import { Geometry } from 'geojson';
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: string;
  float8: any;
  geography: Geometry;
  geometry: Geometry;
  jsonb: any;
  name: any;
  numeric: any;
  smallint: number;
  timestamptz: any;
  uuid: any;
};

/** columns and relationships of "account_pro_view" */
export type AccountProView = {
  __typename?: 'AccountProView';
  authUserId: Scalars['uuid'];
  /** An object relationship */
  proView: ProView;
  proViewId: Scalars['Int'];
};

/** aggregated selection of "account_pro_view" */
export type AccountProViewAggregate = {
  __typename?: 'AccountProViewAggregate';
  aggregate?: Maybe<AccountProViewAggregateFields>;
  nodes: Array<AccountProView>;
};

export type AccountProViewAggregateBoolExp = {
  count?: InputMaybe<AccountProViewAggregateBoolExpCount>;
};

/** aggregate fields of "account_pro_view" */
export type AccountProViewAggregateFields = {
  __typename?: 'AccountProViewAggregateFields';
  avg?: Maybe<AccountProViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AccountProViewMaxFields>;
  min?: Maybe<AccountProViewMinFields>;
  stddev?: Maybe<AccountProViewStddevFields>;
  stddevPop?: Maybe<AccountProViewStddevPopFields>;
  stddevSamp?: Maybe<AccountProViewStddevSampFields>;
  sum?: Maybe<AccountProViewSumFields>;
  varPop?: Maybe<AccountProViewVarPopFields>;
  varSamp?: Maybe<AccountProViewVarSampFields>;
  variance?: Maybe<AccountProViewVarianceFields>;
};


/** aggregate fields of "account_pro_view" */
export type AccountProViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccountProViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_pro_view" */
export type AccountProViewAggregateOrderBy = {
  avg?: InputMaybe<AccountProViewAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AccountProViewMaxOrderBy>;
  min?: InputMaybe<AccountProViewMinOrderBy>;
  stddev?: InputMaybe<AccountProViewStddevOrderBy>;
  stddevPop?: InputMaybe<AccountProViewStddevPopOrderBy>;
  stddevSamp?: InputMaybe<AccountProViewStddevSampOrderBy>;
  sum?: InputMaybe<AccountProViewSumOrderBy>;
  varPop?: InputMaybe<AccountProViewVarPopOrderBy>;
  varSamp?: InputMaybe<AccountProViewVarSampOrderBy>;
  variance?: InputMaybe<AccountProViewVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "account_pro_view" */
export type AccountProViewArrRelInsertInput = {
  data: Array<AccountProViewInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AccountProViewOnConflict>;
};

/** aggregate avg on columns */
export type AccountProViewAvgFields = {
  __typename?: 'AccountProViewAvgFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "account_pro_view" */
export type AccountProViewAvgOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "account_pro_view". All fields are combined with a logical 'AND'. */
export type AccountProViewBoolExp = {
  _and?: InputMaybe<Array<AccountProViewBoolExp>>;
  _not?: InputMaybe<AccountProViewBoolExp>;
  _or?: InputMaybe<Array<AccountProViewBoolExp>>;
  authUserId?: InputMaybe<UuidComparisonExp>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "account_pro_view" */
export enum AccountProViewConstraint {
  /** unique or primary key constraint on columns "auth_user_id", "pro_view_id" */
  AccountProViewPkey = 'account_pro_view_pkey'
}

/** input type for incrementing numeric columns in table "account_pro_view" */
export type AccountProViewIncInput = {
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "account_pro_view" */
export type AccountProViewInsertInput = {
  authUserId?: InputMaybe<Scalars['uuid']>;
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AccountProViewMaxFields = {
  __typename?: 'AccountProViewMaxFields';
  authUserId?: Maybe<Scalars['uuid']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "account_pro_view" */
export type AccountProViewMaxOrderBy = {
  authUserId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AccountProViewMinFields = {
  __typename?: 'AccountProViewMinFields';
  authUserId?: Maybe<Scalars['uuid']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "account_pro_view" */
export type AccountProViewMinOrderBy = {
  authUserId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "account_pro_view" */
export type AccountProViewMutationResponse = {
  __typename?: 'AccountProViewMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountProView>;
};

/** on_conflict condition type for table "account_pro_view" */
export type AccountProViewOnConflict = {
  constraint: AccountProViewConstraint;
  updateColumns?: Array<AccountProViewUpdateColumn>;
  where?: InputMaybe<AccountProViewBoolExp>;
};

/** Ordering options when selecting data from "account_pro_view". */
export type AccountProViewOrderBy = {
  authUserId?: InputMaybe<OrderBy>;
  proView?: InputMaybe<ProViewOrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: account_pro_view */
export type AccountProViewPkColumnsInput = {
  authUserId: Scalars['uuid'];
  proViewId: Scalars['Int'];
};

/** select columns of table "account_pro_view" */
export enum AccountProViewSelectColumn {
  /** column name */
  AuthUserId = 'authUserId',
  /** column name */
  ProViewId = 'proViewId'
}

/** input type for updating data in table "account_pro_view" */
export type AccountProViewSetInput = {
  authUserId?: InputMaybe<Scalars['uuid']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AccountProViewStddevFields = {
  __typename?: 'AccountProViewStddevFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "account_pro_view" */
export type AccountProViewStddevOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type AccountProViewStddevPopFields = {
  __typename?: 'AccountProViewStddevPopFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "account_pro_view" */
export type AccountProViewStddevPopOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type AccountProViewStddevSampFields = {
  __typename?: 'AccountProViewStddevSampFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "account_pro_view" */
export type AccountProViewStddevSampOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "account_pro_view" */
export type AccountProViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccountProViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountProViewStreamCursorValueInput = {
  authUserId?: InputMaybe<Scalars['uuid']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type AccountProViewSumFields = {
  __typename?: 'AccountProViewSumFields';
  proViewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "account_pro_view" */
export type AccountProViewSumOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
};

/** update columns of table "account_pro_view" */
export enum AccountProViewUpdateColumn {
  /** column name */
  AuthUserId = 'authUserId',
  /** column name */
  ProViewId = 'proViewId'
}

export type AccountProViewUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AccountProViewIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountProViewSetInput>;
  /** filter the rows which have to be updated */
  where: AccountProViewBoolExp;
};

/** aggregate varPop on columns */
export type AccountProViewVarPopFields = {
  __typename?: 'AccountProViewVarPopFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "account_pro_view" */
export type AccountProViewVarPopOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type AccountProViewVarSampFields = {
  __typename?: 'AccountProViewVarSampFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "account_pro_view" */
export type AccountProViewVarSampOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AccountProViewVarianceFields = {
  __typename?: 'AccountProViewVarianceFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "account_pro_view" */
export type AccountProViewVarianceOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "action_token" */
export type ActionToken = {
  __typename?: 'ActionToken';
  dateCreated: Scalars['timestamptz'];
  id: Scalars['Int'];
  shortLink: Scalars['String'];
  token: Scalars['String'];
};

/** aggregated selection of "action_token" */
export type ActionTokenAggregate = {
  __typename?: 'ActionTokenAggregate';
  aggregate?: Maybe<ActionTokenAggregateFields>;
  nodes: Array<ActionToken>;
};

/** aggregate fields of "action_token" */
export type ActionTokenAggregateFields = {
  __typename?: 'ActionTokenAggregateFields';
  avg?: Maybe<ActionTokenAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ActionTokenMaxFields>;
  min?: Maybe<ActionTokenMinFields>;
  stddev?: Maybe<ActionTokenStddevFields>;
  stddevPop?: Maybe<ActionTokenStddevPopFields>;
  stddevSamp?: Maybe<ActionTokenStddevSampFields>;
  sum?: Maybe<ActionTokenSumFields>;
  varPop?: Maybe<ActionTokenVarPopFields>;
  varSamp?: Maybe<ActionTokenVarSampFields>;
  variance?: Maybe<ActionTokenVarianceFields>;
};


/** aggregate fields of "action_token" */
export type ActionTokenAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ActionTokenSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ActionTokenAvgFields = {
  __typename?: 'ActionTokenAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "action_token". All fields are combined with a logical 'AND'. */
export type ActionTokenBoolExp = {
  _and?: InputMaybe<Array<ActionTokenBoolExp>>;
  _not?: InputMaybe<ActionTokenBoolExp>;
  _or?: InputMaybe<Array<ActionTokenBoolExp>>;
  dateCreated?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  shortLink?: InputMaybe<StringComparisonExp>;
  token?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "action_token" */
export enum ActionTokenConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22813Primary = 'idx_22813_primary'
}

/** input type for incrementing numeric columns in table "action_token" */
export type ActionTokenIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "action_token" */
export type ActionTokenInsertInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  shortLink?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ActionTokenMaxFields = {
  __typename?: 'ActionTokenMaxFields';
  dateCreated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  shortLink?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ActionTokenMinFields = {
  __typename?: 'ActionTokenMinFields';
  dateCreated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  shortLink?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "action_token" */
export type ActionTokenMutationResponse = {
  __typename?: 'ActionTokenMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ActionToken>;
};

/** on_conflict condition type for table "action_token" */
export type ActionTokenOnConflict = {
  constraint: ActionTokenConstraint;
  updateColumns?: Array<ActionTokenUpdateColumn>;
  where?: InputMaybe<ActionTokenBoolExp>;
};

/** Ordering options when selecting data from "action_token". */
export type ActionTokenOrderBy = {
  dateCreated?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  shortLink?: InputMaybe<OrderBy>;
  token?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: action_token */
export type ActionTokenPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "action_token" */
export enum ActionTokenSelectColumn {
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  Id = 'id',
  /** column name */
  ShortLink = 'shortLink',
  /** column name */
  Token = 'token'
}

/** input type for updating data in table "action_token" */
export type ActionTokenSetInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  shortLink?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ActionTokenStddevFields = {
  __typename?: 'ActionTokenStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type ActionTokenStddevPopFields = {
  __typename?: 'ActionTokenStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type ActionTokenStddevSampFields = {
  __typename?: 'ActionTokenStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "action_token" */
export type ActionTokenStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ActionTokenStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ActionTokenStreamCursorValueInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  shortLink?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ActionTokenSumFields = {
  __typename?: 'ActionTokenSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "action_token" */
export enum ActionTokenUpdateColumn {
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  Id = 'id',
  /** column name */
  ShortLink = 'shortLink',
  /** column name */
  Token = 'token'
}

export type ActionTokenUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ActionTokenIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActionTokenSetInput>;
  /** filter the rows which have to be updated */
  where: ActionTokenBoolExp;
};

/** aggregate varPop on columns */
export type ActionTokenVarPopFields = {
  __typename?: 'ActionTokenVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type ActionTokenVarSampFields = {
  __typename?: 'ActionTokenVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ActionTokenVarianceFields = {
  __typename?: 'ActionTokenVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "announcement" */
export type Announcement = {
  __typename?: 'Announcement';
  body: Scalars['String'];
  endDate: Scalars['timestamptz'];
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

/** aggregated selection of "announcement" */
export type AnnouncementAggregate = {
  __typename?: 'AnnouncementAggregate';
  aggregate?: Maybe<AnnouncementAggregateFields>;
  nodes: Array<Announcement>;
};

/** aggregate fields of "announcement" */
export type AnnouncementAggregateFields = {
  __typename?: 'AnnouncementAggregateFields';
  avg?: Maybe<AnnouncementAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AnnouncementMaxFields>;
  min?: Maybe<AnnouncementMinFields>;
  stddev?: Maybe<AnnouncementStddevFields>;
  stddevPop?: Maybe<AnnouncementStddevPopFields>;
  stddevSamp?: Maybe<AnnouncementStddevSampFields>;
  sum?: Maybe<AnnouncementSumFields>;
  varPop?: Maybe<AnnouncementVarPopFields>;
  varSamp?: Maybe<AnnouncementVarSampFields>;
  variance?: Maybe<AnnouncementVarianceFields>;
};


/** aggregate fields of "announcement" */
export type AnnouncementAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AnnouncementSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AnnouncementAvgFields = {
  __typename?: 'AnnouncementAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "announcement". All fields are combined with a logical 'AND'. */
export type AnnouncementBoolExp = {
  _and?: InputMaybe<Array<AnnouncementBoolExp>>;
  _not?: InputMaybe<AnnouncementBoolExp>;
  _or?: InputMaybe<Array<AnnouncementBoolExp>>;
  body?: InputMaybe<StringComparisonExp>;
  endDate?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "announcement" */
export enum AnnouncementConstraint {
  /** unique or primary key constraint on columns "id" */
  AnnouncementPkey = 'announcement_pkey'
}

/** input type for incrementing numeric columns in table "announcement" */
export type AnnouncementIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "announcement" */
export type AnnouncementInsertInput = {
  body?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AnnouncementMaxFields = {
  __typename?: 'AnnouncementMaxFields';
  body?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AnnouncementMinFields = {
  __typename?: 'AnnouncementMinFields';
  body?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "announcement" */
export type AnnouncementMutationResponse = {
  __typename?: 'AnnouncementMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Announcement>;
};

/** on_conflict condition type for table "announcement" */
export type AnnouncementOnConflict = {
  constraint: AnnouncementConstraint;
  updateColumns?: Array<AnnouncementUpdateColumn>;
  where?: InputMaybe<AnnouncementBoolExp>;
};

/** Ordering options when selecting data from "announcement". */
export type AnnouncementOrderBy = {
  body?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: announcement */
export type AnnouncementPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "announcement" */
export enum AnnouncementSelectColumn {
  /** column name */
  Body = 'body',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "announcement" */
export type AnnouncementSetInput = {
  body?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AnnouncementStddevFields = {
  __typename?: 'AnnouncementStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type AnnouncementStddevPopFields = {
  __typename?: 'AnnouncementStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type AnnouncementStddevSampFields = {
  __typename?: 'AnnouncementStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "announcement" */
export type AnnouncementStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AnnouncementStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnnouncementStreamCursorValueInput = {
  body?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AnnouncementSumFields = {
  __typename?: 'AnnouncementSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "announcement" */
export enum AnnouncementUpdateColumn {
  /** column name */
  Body = 'body',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title'
}

export type AnnouncementUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AnnouncementIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AnnouncementSetInput>;
  /** filter the rows which have to be updated */
  where: AnnouncementBoolExp;
};

/** aggregate varPop on columns */
export type AnnouncementVarPopFields = {
  __typename?: 'AnnouncementVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type AnnouncementVarSampFields = {
  __typename?: 'AnnouncementVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AnnouncementVarianceFields = {
  __typename?: 'AnnouncementVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "autorespond" */
export type Autorespond = {
  __typename?: 'Autorespond';
  emailTemplate: Scalars['String'];
  entityUuid: Scalars['String'];
  id: Scalars['Int'];
  sendDate: Scalars['timestamptz'];
  status?: Maybe<Scalars['String']>;
};

/** aggregated selection of "autorespond" */
export type AutorespondAggregate = {
  __typename?: 'AutorespondAggregate';
  aggregate?: Maybe<AutorespondAggregateFields>;
  nodes: Array<Autorespond>;
};

export type AutorespondAggregateBoolExp = {
  count?: InputMaybe<AutorespondAggregateBoolExpCount>;
};

/** aggregate fields of "autorespond" */
export type AutorespondAggregateFields = {
  __typename?: 'AutorespondAggregateFields';
  avg?: Maybe<AutorespondAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AutorespondMaxFields>;
  min?: Maybe<AutorespondMinFields>;
  stddev?: Maybe<AutorespondStddevFields>;
  stddevPop?: Maybe<AutorespondStddevPopFields>;
  stddevSamp?: Maybe<AutorespondStddevSampFields>;
  sum?: Maybe<AutorespondSumFields>;
  varPop?: Maybe<AutorespondVarPopFields>;
  varSamp?: Maybe<AutorespondVarSampFields>;
  variance?: Maybe<AutorespondVarianceFields>;
};


/** aggregate fields of "autorespond" */
export type AutorespondAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AutorespondSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "autorespond" */
export type AutorespondAggregateOrderBy = {
  avg?: InputMaybe<AutorespondAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AutorespondMaxOrderBy>;
  min?: InputMaybe<AutorespondMinOrderBy>;
  stddev?: InputMaybe<AutorespondStddevOrderBy>;
  stddevPop?: InputMaybe<AutorespondStddevPopOrderBy>;
  stddevSamp?: InputMaybe<AutorespondStddevSampOrderBy>;
  sum?: InputMaybe<AutorespondSumOrderBy>;
  varPop?: InputMaybe<AutorespondVarPopOrderBy>;
  varSamp?: InputMaybe<AutorespondVarSampOrderBy>;
  variance?: InputMaybe<AutorespondVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "autorespond" */
export type AutorespondArrRelInsertInput = {
  data: Array<AutorespondInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AutorespondOnConflict>;
};

/** aggregate avg on columns */
export type AutorespondAvgFields = {
  __typename?: 'AutorespondAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "autorespond" */
export type AutorespondAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "autorespond". All fields are combined with a logical 'AND'. */
export type AutorespondBoolExp = {
  _and?: InputMaybe<Array<AutorespondBoolExp>>;
  _not?: InputMaybe<AutorespondBoolExp>;
  _or?: InputMaybe<Array<AutorespondBoolExp>>;
  emailTemplate?: InputMaybe<StringComparisonExp>;
  entityUuid?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  sendDate?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "autorespond" */
export enum AutorespondConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22822Primary = 'idx_22822_primary'
}

/** input type for incrementing numeric columns in table "autorespond" */
export type AutorespondIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "autorespond" */
export type AutorespondInsertInput = {
  emailTemplate?: InputMaybe<Scalars['String']>;
  entityUuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  sendDate?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AutorespondMaxFields = {
  __typename?: 'AutorespondMaxFields';
  emailTemplate?: Maybe<Scalars['String']>;
  entityUuid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  sendDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "autorespond" */
export type AutorespondMaxOrderBy = {
  emailTemplate?: InputMaybe<OrderBy>;
  entityUuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sendDate?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AutorespondMinFields = {
  __typename?: 'AutorespondMinFields';
  emailTemplate?: Maybe<Scalars['String']>;
  entityUuid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  sendDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "autorespond" */
export type AutorespondMinOrderBy = {
  emailTemplate?: InputMaybe<OrderBy>;
  entityUuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sendDate?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "autorespond" */
export type AutorespondMutationResponse = {
  __typename?: 'AutorespondMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Autorespond>;
};

/** on_conflict condition type for table "autorespond" */
export type AutorespondOnConflict = {
  constraint: AutorespondConstraint;
  updateColumns?: Array<AutorespondUpdateColumn>;
  where?: InputMaybe<AutorespondBoolExp>;
};

/** Ordering options when selecting data from "autorespond". */
export type AutorespondOrderBy = {
  emailTemplate?: InputMaybe<OrderBy>;
  entityUuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sendDate?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: autorespond */
export type AutorespondPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "autorespond" */
export enum AutorespondSelectColumn {
  /** column name */
  EmailTemplate = 'emailTemplate',
  /** column name */
  EntityUuid = 'entityUuid',
  /** column name */
  Id = 'id',
  /** column name */
  SendDate = 'sendDate',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "autorespond" */
export type AutorespondSetInput = {
  emailTemplate?: InputMaybe<Scalars['String']>;
  entityUuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  sendDate?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AutorespondStddevFields = {
  __typename?: 'AutorespondStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "autorespond" */
export type AutorespondStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type AutorespondStddevPopFields = {
  __typename?: 'AutorespondStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "autorespond" */
export type AutorespondStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type AutorespondStddevSampFields = {
  __typename?: 'AutorespondStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "autorespond" */
export type AutorespondStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "autorespond" */
export type AutorespondStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AutorespondStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AutorespondStreamCursorValueInput = {
  emailTemplate?: InputMaybe<Scalars['String']>;
  entityUuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  sendDate?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AutorespondSumFields = {
  __typename?: 'AutorespondSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "autorespond" */
export type AutorespondSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "autorespond" */
export enum AutorespondUpdateColumn {
  /** column name */
  EmailTemplate = 'emailTemplate',
  /** column name */
  EntityUuid = 'entityUuid',
  /** column name */
  Id = 'id',
  /** column name */
  SendDate = 'sendDate',
  /** column name */
  Status = 'status'
}

export type AutorespondUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AutorespondIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AutorespondSetInput>;
  /** filter the rows which have to be updated */
  where: AutorespondBoolExp;
};

/** aggregate varPop on columns */
export type AutorespondVarPopFields = {
  __typename?: 'AutorespondVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "autorespond" */
export type AutorespondVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type AutorespondVarSampFields = {
  __typename?: 'AutorespondVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "autorespond" */
export type AutorespondVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AutorespondVarianceFields = {
  __typename?: 'AutorespondVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "autorespond" */
export type AutorespondVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "bilik_person" */
export type BilikPerson = {
  __typename?: 'BilikPerson';
  authUserId: Scalars['uuid'];
  avatarHash?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  employmentDate: Scalars['timestamptz'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['Int'];
  /** An array relationship */
  managedBilikZones: Array<ManagerBilikPersonBilikZone>;
  /** An aggregate relationship */
  managedBilikZonesAggregate: ManagerBilikPersonBilikZoneAggregate;
  /** An array relationship */
  memberBilikZones: Array<MemberBilikPersonBilikZone>;
  /** An aggregate relationship */
  memberBilikZonesAggregate: MemberBilikPersonBilikZoneAggregate;
  /** An array relationship */
  noteIdentities: Array<NoteIdentity>;
  /** An aggregate relationship */
  noteIdentitiesAggregate: NoteIdentityAggregate;
  /** An array relationship */
  proReviews: Array<ProReview>;
  /** An aggregate relationship */
  proReviewsAggregate: ProReviewAggregate;
  roleName: Scalars['String'];
  status: Scalars['String'];
  telephone: Scalars['String'];
};


/** columns and relationships of "bilik_person" */
export type BilikPersonManagedBilikZonesArgs = {
  distinctOn?: InputMaybe<Array<ManagerBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ManagerBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
};


/** columns and relationships of "bilik_person" */
export type BilikPersonManagedBilikZonesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ManagerBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ManagerBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
};


/** columns and relationships of "bilik_person" */
export type BilikPersonMemberBilikZonesArgs = {
  distinctOn?: InputMaybe<Array<MemberBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MemberBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
};


/** columns and relationships of "bilik_person" */
export type BilikPersonMemberBilikZonesAggregateArgs = {
  distinctOn?: InputMaybe<Array<MemberBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MemberBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
};


/** columns and relationships of "bilik_person" */
export type BilikPersonNoteIdentitiesArgs = {
  distinctOn?: InputMaybe<Array<NoteIdentitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteIdentityOrderBy>>;
  where?: InputMaybe<NoteIdentityBoolExp>;
};


/** columns and relationships of "bilik_person" */
export type BilikPersonNoteIdentitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteIdentitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteIdentityOrderBy>>;
  where?: InputMaybe<NoteIdentityBoolExp>;
};


/** columns and relationships of "bilik_person" */
export type BilikPersonProReviewsArgs = {
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


/** columns and relationships of "bilik_person" */
export type BilikPersonProReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};

/** aggregated selection of "bilik_person" */
export type BilikPersonAggregate = {
  __typename?: 'BilikPersonAggregate';
  aggregate?: Maybe<BilikPersonAggregateFields>;
  nodes: Array<BilikPerson>;
};

/** aggregate fields of "bilik_person" */
export type BilikPersonAggregateFields = {
  __typename?: 'BilikPersonAggregateFields';
  avg?: Maybe<BilikPersonAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BilikPersonMaxFields>;
  min?: Maybe<BilikPersonMinFields>;
  stddev?: Maybe<BilikPersonStddevFields>;
  stddevPop?: Maybe<BilikPersonStddevPopFields>;
  stddevSamp?: Maybe<BilikPersonStddevSampFields>;
  sum?: Maybe<BilikPersonSumFields>;
  varPop?: Maybe<BilikPersonVarPopFields>;
  varSamp?: Maybe<BilikPersonVarSampFields>;
  variance?: Maybe<BilikPersonVarianceFields>;
};


/** aggregate fields of "bilik_person" */
export type BilikPersonAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BilikPersonSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type BilikPersonAvgFields = {
  __typename?: 'BilikPersonAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "bilik_person". All fields are combined with a logical 'AND'. */
export type BilikPersonBoolExp = {
  _and?: InputMaybe<Array<BilikPersonBoolExp>>;
  _not?: InputMaybe<BilikPersonBoolExp>;
  _or?: InputMaybe<Array<BilikPersonBoolExp>>;
  authUserId?: InputMaybe<UuidComparisonExp>;
  avatarHash?: InputMaybe<StringComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  employmentDate?: InputMaybe<TimestamptzComparisonExp>;
  familyName?: InputMaybe<StringComparisonExp>;
  givenName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  managedBilikZones?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
  managedBilikZonesAggregate?: InputMaybe<ManagerBilikPersonBilikZoneAggregateBoolExp>;
  memberBilikZones?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
  memberBilikZonesAggregate?: InputMaybe<MemberBilikPersonBilikZoneAggregateBoolExp>;
  noteIdentities?: InputMaybe<NoteIdentityBoolExp>;
  noteIdentitiesAggregate?: InputMaybe<NoteIdentityAggregateBoolExp>;
  proReviews?: InputMaybe<ProReviewBoolExp>;
  proReviewsAggregate?: InputMaybe<ProReviewAggregateBoolExp>;
  roleName?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  telephone?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "bilik_person" */
export enum BilikPersonConstraint {
  /** unique or primary key constraint on columns "auth_user_id" */
  BilikPersonAuthUserIdKey = 'bilik_person_auth_user_id_key',
  /** unique or primary key constraint on columns "id" */
  Idx_22831Primary = 'idx_22831_primary'
}

/** input type for incrementing numeric columns in table "bilik_person" */
export type BilikPersonIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "bilik_person" */
export type BilikPersonInsertInput = {
  authUserId?: InputMaybe<Scalars['uuid']>;
  avatarHash?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employmentDate?: InputMaybe<Scalars['timestamptz']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  managedBilikZones?: InputMaybe<ManagerBilikPersonBilikZoneArrRelInsertInput>;
  memberBilikZones?: InputMaybe<MemberBilikPersonBilikZoneArrRelInsertInput>;
  noteIdentities?: InputMaybe<NoteIdentityArrRelInsertInput>;
  proReviews?: InputMaybe<ProReviewArrRelInsertInput>;
  roleName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BilikPersonMaxFields = {
  __typename?: 'BilikPersonMaxFields';
  authUserId?: Maybe<Scalars['uuid']>;
  avatarHash?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employmentDate?: Maybe<Scalars['timestamptz']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  roleName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BilikPersonMinFields = {
  __typename?: 'BilikPersonMinFields';
  authUserId?: Maybe<Scalars['uuid']>;
  avatarHash?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employmentDate?: Maybe<Scalars['timestamptz']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  roleName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "bilik_person" */
export type BilikPersonMutationResponse = {
  __typename?: 'BilikPersonMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BilikPerson>;
};

/** input type for inserting object relation for remote table "bilik_person" */
export type BilikPersonObjRelInsertInput = {
  data: BilikPersonInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BilikPersonOnConflict>;
};

/** on_conflict condition type for table "bilik_person" */
export type BilikPersonOnConflict = {
  constraint: BilikPersonConstraint;
  updateColumns?: Array<BilikPersonUpdateColumn>;
  where?: InputMaybe<BilikPersonBoolExp>;
};

/** Ordering options when selecting data from "bilik_person". */
export type BilikPersonOrderBy = {
  authUserId?: InputMaybe<OrderBy>;
  avatarHash?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  employmentDate?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  managedBilikZonesAggregate?: InputMaybe<ManagerBilikPersonBilikZoneAggregateOrderBy>;
  memberBilikZonesAggregate?: InputMaybe<MemberBilikPersonBilikZoneAggregateOrderBy>;
  noteIdentitiesAggregate?: InputMaybe<NoteIdentityAggregateOrderBy>;
  proReviewsAggregate?: InputMaybe<ProReviewAggregateOrderBy>;
  roleName?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: bilik_person */
export type BilikPersonPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "bilik_person" */
export enum BilikPersonSelectColumn {
  /** column name */
  AuthUserId = 'authUserId',
  /** column name */
  AvatarHash = 'avatarHash',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  EmploymentDate = 'employmentDate',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  RoleName = 'roleName',
  /** column name */
  Status = 'status',
  /** column name */
  Telephone = 'telephone'
}

/** input type for updating data in table "bilik_person" */
export type BilikPersonSetInput = {
  authUserId?: InputMaybe<Scalars['uuid']>;
  avatarHash?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employmentDate?: InputMaybe<Scalars['timestamptz']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  roleName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BilikPersonStddevFields = {
  __typename?: 'BilikPersonStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type BilikPersonStddevPopFields = {
  __typename?: 'BilikPersonStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type BilikPersonStddevSampFields = {
  __typename?: 'BilikPersonStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "bilik_person" */
export type BilikPersonStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BilikPersonStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BilikPersonStreamCursorValueInput = {
  authUserId?: InputMaybe<Scalars['uuid']>;
  avatarHash?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employmentDate?: InputMaybe<Scalars['timestamptz']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  roleName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BilikPersonSumFields = {
  __typename?: 'BilikPersonSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "bilik_person" */
export enum BilikPersonUpdateColumn {
  /** column name */
  AuthUserId = 'authUserId',
  /** column name */
  AvatarHash = 'avatarHash',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  EmploymentDate = 'employmentDate',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  RoleName = 'roleName',
  /** column name */
  Status = 'status',
  /** column name */
  Telephone = 'telephone'
}

export type BilikPersonUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BilikPersonIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BilikPersonSetInput>;
  /** filter the rows which have to be updated */
  where: BilikPersonBoolExp;
};

/** aggregate varPop on columns */
export type BilikPersonVarPopFields = {
  __typename?: 'BilikPersonVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type BilikPersonVarSampFields = {
  __typename?: 'BilikPersonVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BilikPersonVarianceFields = {
  __typename?: 'BilikPersonVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "bilik_solicitation" */
export type BilikSolicitation = {
  __typename?: 'BilikSolicitation';
  addressLocality: Scalars['String'];
  bilikZoneId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  bilik_zone?: Maybe<BilikZone>;
  dateCreated: Scalars['timestamptz'];
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['Int'];
  ip?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  telephone: Scalars['String'];
};

/** aggregated selection of "bilik_solicitation" */
export type BilikSolicitationAggregate = {
  __typename?: 'BilikSolicitationAggregate';
  aggregate?: Maybe<BilikSolicitationAggregateFields>;
  nodes: Array<BilikSolicitation>;
};

export type BilikSolicitationAggregateBoolExp = {
  count?: InputMaybe<BilikSolicitationAggregateBoolExpCount>;
};

/** aggregate fields of "bilik_solicitation" */
export type BilikSolicitationAggregateFields = {
  __typename?: 'BilikSolicitationAggregateFields';
  avg?: Maybe<BilikSolicitationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BilikSolicitationMaxFields>;
  min?: Maybe<BilikSolicitationMinFields>;
  stddev?: Maybe<BilikSolicitationStddevFields>;
  stddevPop?: Maybe<BilikSolicitationStddevPopFields>;
  stddevSamp?: Maybe<BilikSolicitationStddevSampFields>;
  sum?: Maybe<BilikSolicitationSumFields>;
  varPop?: Maybe<BilikSolicitationVarPopFields>;
  varSamp?: Maybe<BilikSolicitationVarSampFields>;
  variance?: Maybe<BilikSolicitationVarianceFields>;
};


/** aggregate fields of "bilik_solicitation" */
export type BilikSolicitationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BilikSolicitationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bilik_solicitation" */
export type BilikSolicitationAggregateOrderBy = {
  avg?: InputMaybe<BilikSolicitationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BilikSolicitationMaxOrderBy>;
  min?: InputMaybe<BilikSolicitationMinOrderBy>;
  stddev?: InputMaybe<BilikSolicitationStddevOrderBy>;
  stddevPop?: InputMaybe<BilikSolicitationStddevPopOrderBy>;
  stddevSamp?: InputMaybe<BilikSolicitationStddevSampOrderBy>;
  sum?: InputMaybe<BilikSolicitationSumOrderBy>;
  varPop?: InputMaybe<BilikSolicitationVarPopOrderBy>;
  varSamp?: InputMaybe<BilikSolicitationVarSampOrderBy>;
  variance?: InputMaybe<BilikSolicitationVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "bilik_solicitation" */
export type BilikSolicitationArrRelInsertInput = {
  data: Array<BilikSolicitationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BilikSolicitationOnConflict>;
};

/** aggregate avg on columns */
export type BilikSolicitationAvgFields = {
  __typename?: 'BilikSolicitationAvgFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bilik_solicitation" */
export type BilikSolicitationAvgOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "bilik_solicitation". All fields are combined with a logical 'AND'. */
export type BilikSolicitationBoolExp = {
  _and?: InputMaybe<Array<BilikSolicitationBoolExp>>;
  _not?: InputMaybe<BilikSolicitationBoolExp>;
  _or?: InputMaybe<Array<BilikSolicitationBoolExp>>;
  addressLocality?: InputMaybe<StringComparisonExp>;
  bilikZoneId?: InputMaybe<IntComparisonExp>;
  bilik_zone?: InputMaybe<BilikZoneBoolExp>;
  dateCreated?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  familyName?: InputMaybe<StringComparisonExp>;
  givenName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  ip?: InputMaybe<StringComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  telephone?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "bilik_solicitation" */
export enum BilikSolicitationConstraint {
  /** unique or primary key constraint on columns "id" */
  BilikSolicitationPkey = 'bilik_solicitation_pkey'
}

/** input type for incrementing numeric columns in table "bilik_solicitation" */
export type BilikSolicitationIncInput = {
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "bilik_solicitation" */
export type BilikSolicitationInsertInput = {
  addressLocality?: InputMaybe<Scalars['String']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  bilik_zone?: InputMaybe<BilikZoneObjRelInsertInput>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ip?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BilikSolicitationMaxFields = {
  __typename?: 'BilikSolicitationMaxFields';
  addressLocality?: Maybe<Scalars['String']>;
  bilikZoneId?: Maybe<Scalars['Int']>;
  dateCreated?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ip?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "bilik_solicitation" */
export type BilikSolicitationMaxOrderBy = {
  addressLocality?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BilikSolicitationMinFields = {
  __typename?: 'BilikSolicitationMinFields';
  addressLocality?: Maybe<Scalars['String']>;
  bilikZoneId?: Maybe<Scalars['Int']>;
  dateCreated?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ip?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "bilik_solicitation" */
export type BilikSolicitationMinOrderBy = {
  addressLocality?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "bilik_solicitation" */
export type BilikSolicitationMutationResponse = {
  __typename?: 'BilikSolicitationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BilikSolicitation>;
};

/** on_conflict condition type for table "bilik_solicitation" */
export type BilikSolicitationOnConflict = {
  constraint: BilikSolicitationConstraint;
  updateColumns?: Array<BilikSolicitationUpdateColumn>;
  where?: InputMaybe<BilikSolicitationBoolExp>;
};

/** Ordering options when selecting data from "bilik_solicitation". */
export type BilikSolicitationOrderBy = {
  addressLocality?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  bilik_zone?: InputMaybe<BilikZoneOrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: bilik_solicitation */
export type BilikSolicitationPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "bilik_solicitation" */
export enum BilikSolicitationSelectColumn {
  /** column name */
  AddressLocality = 'addressLocality',
  /** column name */
  BilikZoneId = 'bilikZoneId',
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  Message = 'message',
  /** column name */
  Telephone = 'telephone'
}

/** input type for updating data in table "bilik_solicitation" */
export type BilikSolicitationSetInput = {
  addressLocality?: InputMaybe<Scalars['String']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ip?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BilikSolicitationStddevFields = {
  __typename?: 'BilikSolicitationStddevFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bilik_solicitation" */
export type BilikSolicitationStddevOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type BilikSolicitationStddevPopFields = {
  __typename?: 'BilikSolicitationStddevPopFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "bilik_solicitation" */
export type BilikSolicitationStddevPopOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type BilikSolicitationStddevSampFields = {
  __typename?: 'BilikSolicitationStddevSampFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "bilik_solicitation" */
export type BilikSolicitationStddevSampOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "bilik_solicitation" */
export type BilikSolicitationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BilikSolicitationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BilikSolicitationStreamCursorValueInput = {
  addressLocality?: InputMaybe<Scalars['String']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ip?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BilikSolicitationSumFields = {
  __typename?: 'BilikSolicitationSumFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "bilik_solicitation" */
export type BilikSolicitationSumOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "bilik_solicitation" */
export enum BilikSolicitationUpdateColumn {
  /** column name */
  AddressLocality = 'addressLocality',
  /** column name */
  BilikZoneId = 'bilikZoneId',
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  Message = 'message',
  /** column name */
  Telephone = 'telephone'
}

export type BilikSolicitationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BilikSolicitationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BilikSolicitationSetInput>;
  /** filter the rows which have to be updated */
  where: BilikSolicitationBoolExp;
};

/** aggregate varPop on columns */
export type BilikSolicitationVarPopFields = {
  __typename?: 'BilikSolicitationVarPopFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "bilik_solicitation" */
export type BilikSolicitationVarPopOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type BilikSolicitationVarSampFields = {
  __typename?: 'BilikSolicitationVarSampFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "bilik_solicitation" */
export type BilikSolicitationVarSampOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BilikSolicitationVarianceFields = {
  __typename?: 'BilikSolicitationVarianceFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bilik_solicitation" */
export type BilikSolicitationVarianceOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "bilik_zone" */
export type BilikZone = {
  __typename?: 'BilikZone';
  addressCountry?: Maybe<Scalars['String']>;
  addressLocality: Scalars['String'];
  addressRegion?: Maybe<Scalars['String']>;
  /** A computed field, executes function "bilik_zone_area" */
  area?: Maybe<Scalars['geometry']>;
  areaOld?: Maybe<Scalars['geometry']>;
  /** An aggregate relationship */
  bilikSolicitationsAggregate: BilikSolicitationAggregate;
  /** An array relationship */
  bilik_solicitations: Array<BilikSolicitation>;
  /** (DC2Type:json_array) */
  callTrackingTarget?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  cities: Array<City>;
  /** An aggregate relationship */
  citiesAggregate: CityAggregate;
  /** An array relationship */
  citySitemap: Array<SitemapCity>;
  /** An aggregate relationship */
  citySitemapAggregate: SitemapCityAggregate;
  defaultCallTrackingTarget: Scalars['jsonb'];
  genericEmail: Scalars['String'];
  guideName: Scalars['String'];
  hasDistrict: Scalars['Boolean'];
  hasMultiplePostalCode: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  mainCity: City;
  mainCityCode: Scalars['String'];
  mainCityId: Scalars['Int'];
  /** An array relationship */
  managers: Array<ManagerBilikPersonBilikZone>;
  /** An aggregate relationship */
  managersAggregate: ManagerBilikPersonBilikZoneAggregate;
  /** An array relationship */
  members: Array<MemberBilikPersonBilikZone>;
  /** An aggregate relationship */
  membersAggregate: MemberBilikPersonBilikZoneAggregate;
  name: Scalars['String'];
  postOfficeBoxNumber?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  /** An array relationship */
  proViews: Array<ProView>;
  /** An aggregate relationship */
  proViewsAggregate: ProViewAggregate;
  regionPostalCode: Scalars['String'];
  shouldDisplayContactInPiSms: Scalars['Boolean'];
  /** An array relationship */
  sitemap: Array<SitemapBilikZone>;
  /** An aggregate relationship */
  sitemapAggregate: SitemapBilikZoneAggregate;
  slug: Scalars['String'];
  status: Scalars['String'];
  streetAddress: Scalars['String'];
  telephone: Scalars['String'];
  /** An array relationship */
  tradeMainProCount: Array<BilikZoneTradeMainProCount>;
  /** An aggregate relationship */
  tradeMainProCountAggregate: BilikZoneTradeMainProCountAggregate;
  twilioAddressSid?: Maybe<Scalars['String']>;
  twilioBundleSid?: Maybe<Scalars['String']>;
  /** An object relationship */
  zohoOrganization?: Maybe<ZohoOrganization>;
  zohoOrganizationId?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneBilikSolicitationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikSolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikSolicitationOrderBy>>;
  where?: InputMaybe<BilikSolicitationBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneBilikSolicitationsArgs = {
  distinctOn?: InputMaybe<Array<BilikSolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikSolicitationOrderBy>>;
  where?: InputMaybe<BilikSolicitationBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneCallTrackingTargetArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneCitiesArgs = {
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneCitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneCitySitemapArgs = {
  distinctOn?: InputMaybe<Array<SitemapCitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapCityOrderBy>>;
  where?: InputMaybe<SitemapCityBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneCitySitemapAggregateArgs = {
  distinctOn?: InputMaybe<Array<SitemapCitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapCityOrderBy>>;
  where?: InputMaybe<SitemapCityBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneDefaultCallTrackingTargetArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneManagersArgs = {
  distinctOn?: InputMaybe<Array<ManagerBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ManagerBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneManagersAggregateArgs = {
  distinctOn?: InputMaybe<Array<ManagerBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ManagerBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneMembersArgs = {
  distinctOn?: InputMaybe<Array<MemberBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MemberBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<MemberBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MemberBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneProViewsArgs = {
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneProViewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneSitemapArgs = {
  distinctOn?: InputMaybe<Array<SitemapBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapBilikZoneOrderBy>>;
  where?: InputMaybe<SitemapBilikZoneBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneSitemapAggregateArgs = {
  distinctOn?: InputMaybe<Array<SitemapBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapBilikZoneOrderBy>>;
  where?: InputMaybe<SitemapBilikZoneBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneTradeMainProCountArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneTradeMainProCountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneTradeMainProCountOrderBy>>;
  where?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
};


/** columns and relationships of "bilik_zone" */
export type BilikZoneTradeMainProCountAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneTradeMainProCountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneTradeMainProCountOrderBy>>;
  where?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
};

/** aggregated selection of "bilik_zone" */
export type BilikZoneAggregate = {
  __typename?: 'BilikZoneAggregate';
  aggregate?: Maybe<BilikZoneAggregateFields>;
  nodes: Array<BilikZone>;
};

export type BilikZoneAggregateBoolExp = {
  bool_and?: InputMaybe<BilikZoneAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<BilikZoneAggregateBoolExpBoolOr>;
  count?: InputMaybe<BilikZoneAggregateBoolExpCount>;
};

/** aggregate fields of "bilik_zone" */
export type BilikZoneAggregateFields = {
  __typename?: 'BilikZoneAggregateFields';
  avg?: Maybe<BilikZoneAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BilikZoneMaxFields>;
  min?: Maybe<BilikZoneMinFields>;
  stddev?: Maybe<BilikZoneStddevFields>;
  stddevPop?: Maybe<BilikZoneStddevPopFields>;
  stddevSamp?: Maybe<BilikZoneStddevSampFields>;
  sum?: Maybe<BilikZoneSumFields>;
  varPop?: Maybe<BilikZoneVarPopFields>;
  varSamp?: Maybe<BilikZoneVarSampFields>;
  variance?: Maybe<BilikZoneVarianceFields>;
};


/** aggregate fields of "bilik_zone" */
export type BilikZoneAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BilikZoneSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bilik_zone" */
export type BilikZoneAggregateOrderBy = {
  avg?: InputMaybe<BilikZoneAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BilikZoneMaxOrderBy>;
  min?: InputMaybe<BilikZoneMinOrderBy>;
  stddev?: InputMaybe<BilikZoneStddevOrderBy>;
  stddevPop?: InputMaybe<BilikZoneStddevPopOrderBy>;
  stddevSamp?: InputMaybe<BilikZoneStddevSampOrderBy>;
  sum?: InputMaybe<BilikZoneSumOrderBy>;
  varPop?: InputMaybe<BilikZoneVarPopOrderBy>;
  varSamp?: InputMaybe<BilikZoneVarSampOrderBy>;
  variance?: InputMaybe<BilikZoneVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BilikZoneAppendInput = {
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  defaultCallTrackingTarget?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "bilik_zone" */
export type BilikZoneArrRelInsertInput = {
  data: Array<BilikZoneInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BilikZoneOnConflict>;
};

/** aggregate avg on columns */
export type BilikZoneAvgFields = {
  __typename?: 'BilikZoneAvgFields';
  id?: Maybe<Scalars['Float']>;
  mainCityId?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bilik_zone" */
export type BilikZoneAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  mainCityId?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "bilik_zone". All fields are combined with a logical 'AND'. */
export type BilikZoneBoolExp = {
  _and?: InputMaybe<Array<BilikZoneBoolExp>>;
  _not?: InputMaybe<BilikZoneBoolExp>;
  _or?: InputMaybe<Array<BilikZoneBoolExp>>;
  addressCountry?: InputMaybe<StringComparisonExp>;
  addressLocality?: InputMaybe<StringComparisonExp>;
  addressRegion?: InputMaybe<StringComparisonExp>;
  area?: InputMaybe<GeometryComparisonExp>;
  areaOld?: InputMaybe<GeometryComparisonExp>;
  bilik_solicitations?: InputMaybe<BilikSolicitationBoolExp>;
  bilik_solicitationsAggregate?: InputMaybe<BilikSolicitationAggregateBoolExp>;
  callTrackingTarget?: InputMaybe<JsonbComparisonExp>;
  cities?: InputMaybe<CityBoolExp>;
  citiesAggregate?: InputMaybe<CityAggregateBoolExp>;
  citySitemap?: InputMaybe<SitemapCityBoolExp>;
  citySitemapAggregate?: InputMaybe<SitemapCityAggregateBoolExp>;
  defaultCallTrackingTarget?: InputMaybe<JsonbComparisonExp>;
  genericEmail?: InputMaybe<StringComparisonExp>;
  guideName?: InputMaybe<StringComparisonExp>;
  hasDistrict?: InputMaybe<BooleanComparisonExp>;
  hasMultiplePostalCode?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  mainCity?: InputMaybe<CityBoolExp>;
  mainCityCode?: InputMaybe<StringComparisonExp>;
  mainCityId?: InputMaybe<IntComparisonExp>;
  managers?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
  managersAggregate?: InputMaybe<ManagerBilikPersonBilikZoneAggregateBoolExp>;
  members?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
  membersAggregate?: InputMaybe<MemberBilikPersonBilikZoneAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  postOfficeBoxNumber?: InputMaybe<StringComparisonExp>;
  postalCode?: InputMaybe<StringComparisonExp>;
  proViews?: InputMaybe<ProViewBoolExp>;
  proViewsAggregate?: InputMaybe<ProViewAggregateBoolExp>;
  regionPostalCode?: InputMaybe<StringComparisonExp>;
  shouldDisplayContactInPiSms?: InputMaybe<BooleanComparisonExp>;
  sitemap?: InputMaybe<SitemapBilikZoneBoolExp>;
  sitemapAggregate?: InputMaybe<SitemapBilikZoneAggregateBoolExp>;
  slug?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  streetAddress?: InputMaybe<StringComparisonExp>;
  telephone?: InputMaybe<StringComparisonExp>;
  tradeMainProCount?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
  tradeMainProCountAggregate?: InputMaybe<BilikZoneTradeMainProCountAggregateBoolExp>;
  twilioAddressSid?: InputMaybe<StringComparisonExp>;
  twilioBundleSid?: InputMaybe<StringComparisonExp>;
  zohoOrganization?: InputMaybe<ZohoOrganizationBoolExp>;
  zohoOrganizationId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "bilik_zone" */
export enum BilikZoneConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22843Primary = 'idx_22843_primary',
  /** unique or primary key constraint on columns "slug" */
  Idx_22843Uniq_6ed8f9e989d9b62 = 'idx_22843_uniq_6ed8f9e989d9b62'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BilikZoneDeleteAtPathInput = {
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Array<Scalars['String']>>;
  defaultCallTrackingTarget?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BilikZoneDeleteElemInput = {
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['Int']>;
  defaultCallTrackingTarget?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BilikZoneDeleteKeyInput = {
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['String']>;
  defaultCallTrackingTarget?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "bilik_zone" */
export type BilikZoneIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  mainCityId?: InputMaybe<Scalars['Int']>;
  zohoOrganizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "bilik_zone" */
export type BilikZoneInsertInput = {
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLocality?: InputMaybe<Scalars['String']>;
  addressRegion?: InputMaybe<Scalars['String']>;
  areaOld?: InputMaybe<Scalars['geometry']>;
  bilik_solicitations?: InputMaybe<BilikSolicitationArrRelInsertInput>;
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  cities?: InputMaybe<CityArrRelInsertInput>;
  citySitemap?: InputMaybe<SitemapCityArrRelInsertInput>;
  defaultCallTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  genericEmail?: InputMaybe<Scalars['String']>;
  guideName?: InputMaybe<Scalars['String']>;
  hasDistrict?: InputMaybe<Scalars['Boolean']>;
  hasMultiplePostalCode?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  mainCity?: InputMaybe<CityObjRelInsertInput>;
  mainCityCode?: InputMaybe<Scalars['String']>;
  mainCityId?: InputMaybe<Scalars['Int']>;
  managers?: InputMaybe<ManagerBilikPersonBilikZoneArrRelInsertInput>;
  members?: InputMaybe<MemberBilikPersonBilikZoneArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  postOfficeBoxNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  proViews?: InputMaybe<ProViewArrRelInsertInput>;
  regionPostalCode?: InputMaybe<Scalars['String']>;
  shouldDisplayContactInPiSms?: InputMaybe<Scalars['Boolean']>;
  sitemap?: InputMaybe<SitemapBilikZoneArrRelInsertInput>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  tradeMainProCount?: InputMaybe<BilikZoneTradeMainProCountArrRelInsertInput>;
  twilioAddressSid?: InputMaybe<Scalars['String']>;
  twilioBundleSid?: InputMaybe<Scalars['String']>;
  zohoOrganization?: InputMaybe<ZohoOrganizationObjRelInsertInput>;
  zohoOrganizationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type BilikZoneMaxFields = {
  __typename?: 'BilikZoneMaxFields';
  addressCountry?: Maybe<Scalars['String']>;
  addressLocality?: Maybe<Scalars['String']>;
  addressRegion?: Maybe<Scalars['String']>;
  genericEmail?: Maybe<Scalars['String']>;
  guideName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mainCityCode?: Maybe<Scalars['String']>;
  mainCityId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  postOfficeBoxNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  regionPostalCode?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  twilioAddressSid?: Maybe<Scalars['String']>;
  twilioBundleSid?: Maybe<Scalars['String']>;
  zohoOrganizationId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "bilik_zone" */
export type BilikZoneMaxOrderBy = {
  addressCountry?: InputMaybe<OrderBy>;
  addressLocality?: InputMaybe<OrderBy>;
  addressRegion?: InputMaybe<OrderBy>;
  genericEmail?: InputMaybe<OrderBy>;
  guideName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  mainCityCode?: InputMaybe<OrderBy>;
  mainCityId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  postOfficeBoxNumber?: InputMaybe<OrderBy>;
  postalCode?: InputMaybe<OrderBy>;
  regionPostalCode?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  streetAddress?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
  twilioAddressSid?: InputMaybe<OrderBy>;
  twilioBundleSid?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BilikZoneMinFields = {
  __typename?: 'BilikZoneMinFields';
  addressCountry?: Maybe<Scalars['String']>;
  addressLocality?: Maybe<Scalars['String']>;
  addressRegion?: Maybe<Scalars['String']>;
  genericEmail?: Maybe<Scalars['String']>;
  guideName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mainCityCode?: Maybe<Scalars['String']>;
  mainCityId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  postOfficeBoxNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  regionPostalCode?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  twilioAddressSid?: Maybe<Scalars['String']>;
  twilioBundleSid?: Maybe<Scalars['String']>;
  zohoOrganizationId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "bilik_zone" */
export type BilikZoneMinOrderBy = {
  addressCountry?: InputMaybe<OrderBy>;
  addressLocality?: InputMaybe<OrderBy>;
  addressRegion?: InputMaybe<OrderBy>;
  genericEmail?: InputMaybe<OrderBy>;
  guideName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  mainCityCode?: InputMaybe<OrderBy>;
  mainCityId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  postOfficeBoxNumber?: InputMaybe<OrderBy>;
  postalCode?: InputMaybe<OrderBy>;
  regionPostalCode?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  streetAddress?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
  twilioAddressSid?: InputMaybe<OrderBy>;
  twilioBundleSid?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "bilik_zone" */
export type BilikZoneMutationResponse = {
  __typename?: 'BilikZoneMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BilikZone>;
};

/** input type for inserting object relation for remote table "bilik_zone" */
export type BilikZoneObjRelInsertInput = {
  data: BilikZoneInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BilikZoneOnConflict>;
};

/** on_conflict condition type for table "bilik_zone" */
export type BilikZoneOnConflict = {
  constraint: BilikZoneConstraint;
  updateColumns?: Array<BilikZoneUpdateColumn>;
  where?: InputMaybe<BilikZoneBoolExp>;
};

/** Ordering options when selecting data from "bilik_zone". */
export type BilikZoneOrderBy = {
  addressCountry?: InputMaybe<OrderBy>;
  addressLocality?: InputMaybe<OrderBy>;
  addressRegion?: InputMaybe<OrderBy>;
  area?: InputMaybe<OrderBy>;
  areaOld?: InputMaybe<OrderBy>;
  bilik_solicitationsAggregate?: InputMaybe<BilikSolicitationAggregateOrderBy>;
  callTrackingTarget?: InputMaybe<OrderBy>;
  citiesAggregate?: InputMaybe<CityAggregateOrderBy>;
  citySitemapAggregate?: InputMaybe<SitemapCityAggregateOrderBy>;
  defaultCallTrackingTarget?: InputMaybe<OrderBy>;
  genericEmail?: InputMaybe<OrderBy>;
  guideName?: InputMaybe<OrderBy>;
  hasDistrict?: InputMaybe<OrderBy>;
  hasMultiplePostalCode?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  mainCity?: InputMaybe<CityOrderBy>;
  mainCityCode?: InputMaybe<OrderBy>;
  mainCityId?: InputMaybe<OrderBy>;
  managersAggregate?: InputMaybe<ManagerBilikPersonBilikZoneAggregateOrderBy>;
  membersAggregate?: InputMaybe<MemberBilikPersonBilikZoneAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  postOfficeBoxNumber?: InputMaybe<OrderBy>;
  postalCode?: InputMaybe<OrderBy>;
  proViewsAggregate?: InputMaybe<ProViewAggregateOrderBy>;
  regionPostalCode?: InputMaybe<OrderBy>;
  shouldDisplayContactInPiSms?: InputMaybe<OrderBy>;
  sitemapAggregate?: InputMaybe<SitemapBilikZoneAggregateOrderBy>;
  slug?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  streetAddress?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
  tradeMainProCountAggregate?: InputMaybe<BilikZoneTradeMainProCountAggregateOrderBy>;
  twilioAddressSid?: InputMaybe<OrderBy>;
  twilioBundleSid?: InputMaybe<OrderBy>;
  zohoOrganization?: InputMaybe<ZohoOrganizationOrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "bilik_zone_outline" */
export type BilikZoneOutline = {
  __typename?: 'BilikZoneOutline';
  /** An object relationship */
  bilikZone?: Maybe<BilikZone>;
  bilikZoneId?: Maybe<Scalars['Int']>;
  outline?: Maybe<Scalars['geometry']>;
};

/** aggregated selection of "bilik_zone_outline" */
export type BilikZoneOutlineAggregate = {
  __typename?: 'BilikZoneOutlineAggregate';
  aggregate?: Maybe<BilikZoneOutlineAggregateFields>;
  nodes: Array<BilikZoneOutline>;
};

/** aggregate fields of "bilik_zone_outline" */
export type BilikZoneOutlineAggregateFields = {
  __typename?: 'BilikZoneOutlineAggregateFields';
  avg?: Maybe<BilikZoneOutlineAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BilikZoneOutlineMaxFields>;
  min?: Maybe<BilikZoneOutlineMinFields>;
  stddev?: Maybe<BilikZoneOutlineStddevFields>;
  stddevPop?: Maybe<BilikZoneOutlineStddevPopFields>;
  stddevSamp?: Maybe<BilikZoneOutlineStddevSampFields>;
  sum?: Maybe<BilikZoneOutlineSumFields>;
  varPop?: Maybe<BilikZoneOutlineVarPopFields>;
  varSamp?: Maybe<BilikZoneOutlineVarSampFields>;
  variance?: Maybe<BilikZoneOutlineVarianceFields>;
};


/** aggregate fields of "bilik_zone_outline" */
export type BilikZoneOutlineAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BilikZoneOutlineSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type BilikZoneOutlineAvgFields = {
  __typename?: 'BilikZoneOutlineAvgFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "bilik_zone_outline". All fields are combined with a logical 'AND'. */
export type BilikZoneOutlineBoolExp = {
  _and?: InputMaybe<Array<BilikZoneOutlineBoolExp>>;
  _not?: InputMaybe<BilikZoneOutlineBoolExp>;
  _or?: InputMaybe<Array<BilikZoneOutlineBoolExp>>;
  bilikZone?: InputMaybe<BilikZoneBoolExp>;
  bilikZoneId?: InputMaybe<IntComparisonExp>;
  outline?: InputMaybe<GeometryComparisonExp>;
};

/** aggregate max on columns */
export type BilikZoneOutlineMaxFields = {
  __typename?: 'BilikZoneOutlineMaxFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type BilikZoneOutlineMinFields = {
  __typename?: 'BilikZoneOutlineMinFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "bilik_zone_outline". */
export type BilikZoneOutlineOrderBy = {
  bilikZone?: InputMaybe<BilikZoneOrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  outline?: InputMaybe<OrderBy>;
};

/** select columns of table "bilik_zone_outline" */
export enum BilikZoneOutlineSelectColumn {
  /** column name */
  BilikZoneId = 'bilikZoneId',
  /** column name */
  Outline = 'outline'
}

/** aggregate stddev on columns */
export type BilikZoneOutlineStddevFields = {
  __typename?: 'BilikZoneOutlineStddevFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type BilikZoneOutlineStddevPopFields = {
  __typename?: 'BilikZoneOutlineStddevPopFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type BilikZoneOutlineStddevSampFields = {
  __typename?: 'BilikZoneOutlineStddevSampFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "bilik_zone_outline" */
export type BilikZoneOutlineStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BilikZoneOutlineStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BilikZoneOutlineStreamCursorValueInput = {
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  outline?: InputMaybe<Scalars['geometry']>;
};

/** aggregate sum on columns */
export type BilikZoneOutlineSumFields = {
  __typename?: 'BilikZoneOutlineSumFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
};

/** aggregate varPop on columns */
export type BilikZoneOutlineVarPopFields = {
  __typename?: 'BilikZoneOutlineVarPopFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type BilikZoneOutlineVarSampFields = {
  __typename?: 'BilikZoneOutlineVarSampFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BilikZoneOutlineVarianceFields = {
  __typename?: 'BilikZoneOutlineVarianceFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** primary key columns input for table: bilik_zone */
export type BilikZonePkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BilikZonePrependInput = {
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  defaultCallTrackingTarget?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "bilik_zone" */
export enum BilikZoneSelectColumn {
  /** column name */
  AddressCountry = 'addressCountry',
  /** column name */
  AddressLocality = 'addressLocality',
  /** column name */
  AddressRegion = 'addressRegion',
  /** column name */
  AreaOld = 'areaOld',
  /** column name */
  CallTrackingTarget = 'callTrackingTarget',
  /** column name */
  DefaultCallTrackingTarget = 'defaultCallTrackingTarget',
  /** column name */
  GenericEmail = 'genericEmail',
  /** column name */
  GuideName = 'guideName',
  /** column name */
  HasDistrict = 'hasDistrict',
  /** column name */
  HasMultiplePostalCode = 'hasMultiplePostalCode',
  /** column name */
  Id = 'id',
  /** column name */
  MainCityCode = 'mainCityCode',
  /** column name */
  MainCityId = 'mainCityId',
  /** column name */
  Name = 'name',
  /** column name */
  PostOfficeBoxNumber = 'postOfficeBoxNumber',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  RegionPostalCode = 'regionPostalCode',
  /** column name */
  ShouldDisplayContactInPiSms = 'shouldDisplayContactInPiSms',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  StreetAddress = 'streetAddress',
  /** column name */
  Telephone = 'telephone',
  /** column name */
  TwilioAddressSid = 'twilioAddressSid',
  /** column name */
  TwilioBundleSid = 'twilioBundleSid',
  /** column name */
  ZohoOrganizationId = 'zohoOrganizationId'
}

/** select "bilikZoneAggregateBoolExpBool_andArgumentsColumns" columns of table "bilik_zone" */
export enum BilikZoneSelectColumnBilikZoneAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  HasDistrict = 'hasDistrict',
  /** column name */
  HasMultiplePostalCode = 'hasMultiplePostalCode',
  /** column name */
  ShouldDisplayContactInPiSms = 'shouldDisplayContactInPiSms'
}

/** select "bilikZoneAggregateBoolExpBool_orArgumentsColumns" columns of table "bilik_zone" */
export enum BilikZoneSelectColumnBilikZoneAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  HasDistrict = 'hasDistrict',
  /** column name */
  HasMultiplePostalCode = 'hasMultiplePostalCode',
  /** column name */
  ShouldDisplayContactInPiSms = 'shouldDisplayContactInPiSms'
}

/** input type for updating data in table "bilik_zone" */
export type BilikZoneSetInput = {
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLocality?: InputMaybe<Scalars['String']>;
  addressRegion?: InputMaybe<Scalars['String']>;
  areaOld?: InputMaybe<Scalars['geometry']>;
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  defaultCallTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  genericEmail?: InputMaybe<Scalars['String']>;
  guideName?: InputMaybe<Scalars['String']>;
  hasDistrict?: InputMaybe<Scalars['Boolean']>;
  hasMultiplePostalCode?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  mainCityCode?: InputMaybe<Scalars['String']>;
  mainCityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  postOfficeBoxNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  regionPostalCode?: InputMaybe<Scalars['String']>;
  shouldDisplayContactInPiSms?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  twilioAddressSid?: InputMaybe<Scalars['String']>;
  twilioBundleSid?: InputMaybe<Scalars['String']>;
  zohoOrganizationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type BilikZoneStddevFields = {
  __typename?: 'BilikZoneStddevFields';
  id?: Maybe<Scalars['Float']>;
  mainCityId?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bilik_zone" */
export type BilikZoneStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  mainCityId?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type BilikZoneStddevPopFields = {
  __typename?: 'BilikZoneStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  mainCityId?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "bilik_zone" */
export type BilikZoneStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  mainCityId?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type BilikZoneStddevSampFields = {
  __typename?: 'BilikZoneStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  mainCityId?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "bilik_zone" */
export type BilikZoneStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  mainCityId?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "bilik_zone" */
export type BilikZoneStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BilikZoneStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BilikZoneStreamCursorValueInput = {
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLocality?: InputMaybe<Scalars['String']>;
  addressRegion?: InputMaybe<Scalars['String']>;
  areaOld?: InputMaybe<Scalars['geometry']>;
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  defaultCallTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  genericEmail?: InputMaybe<Scalars['String']>;
  guideName?: InputMaybe<Scalars['String']>;
  hasDistrict?: InputMaybe<Scalars['Boolean']>;
  hasMultiplePostalCode?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  mainCityCode?: InputMaybe<Scalars['String']>;
  mainCityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  postOfficeBoxNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  regionPostalCode?: InputMaybe<Scalars['String']>;
  shouldDisplayContactInPiSms?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  twilioAddressSid?: InputMaybe<Scalars['String']>;
  twilioBundleSid?: InputMaybe<Scalars['String']>;
  zohoOrganizationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type BilikZoneSumFields = {
  __typename?: 'BilikZoneSumFields';
  id?: Maybe<Scalars['Int']>;
  mainCityId?: Maybe<Scalars['Int']>;
  zohoOrganizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "bilik_zone" */
export type BilikZoneSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  mainCityId?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCount = {
  __typename?: 'BilikZoneTradeMainProCount';
  /** An object relationship */
  bilikZone?: Maybe<BilikZone>;
  bilikZoneId?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  trade?: Maybe<Trade>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountAggregate = {
  __typename?: 'BilikZoneTradeMainProCountAggregate';
  aggregate?: Maybe<BilikZoneTradeMainProCountAggregateFields>;
  nodes: Array<BilikZoneTradeMainProCount>;
};

export type BilikZoneTradeMainProCountAggregateBoolExp = {
  count?: InputMaybe<BilikZoneTradeMainProCountAggregateBoolExpCount>;
};

/** aggregate fields of "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountAggregateFields = {
  __typename?: 'BilikZoneTradeMainProCountAggregateFields';
  avg?: Maybe<BilikZoneTradeMainProCountAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BilikZoneTradeMainProCountMaxFields>;
  min?: Maybe<BilikZoneTradeMainProCountMinFields>;
  stddev?: Maybe<BilikZoneTradeMainProCountStddevFields>;
  stddevPop?: Maybe<BilikZoneTradeMainProCountStddevPopFields>;
  stddevSamp?: Maybe<BilikZoneTradeMainProCountStddevSampFields>;
  sum?: Maybe<BilikZoneTradeMainProCountSumFields>;
  varPop?: Maybe<BilikZoneTradeMainProCountVarPopFields>;
  varSamp?: Maybe<BilikZoneTradeMainProCountVarSampFields>;
  variance?: Maybe<BilikZoneTradeMainProCountVarianceFields>;
};


/** aggregate fields of "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BilikZoneTradeMainProCountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountAggregateOrderBy = {
  avg?: InputMaybe<BilikZoneTradeMainProCountAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BilikZoneTradeMainProCountMaxOrderBy>;
  min?: InputMaybe<BilikZoneTradeMainProCountMinOrderBy>;
  stddev?: InputMaybe<BilikZoneTradeMainProCountStddevOrderBy>;
  stddevPop?: InputMaybe<BilikZoneTradeMainProCountStddevPopOrderBy>;
  stddevSamp?: InputMaybe<BilikZoneTradeMainProCountStddevSampOrderBy>;
  sum?: InputMaybe<BilikZoneTradeMainProCountSumOrderBy>;
  varPop?: InputMaybe<BilikZoneTradeMainProCountVarPopOrderBy>;
  varSamp?: InputMaybe<BilikZoneTradeMainProCountVarSampOrderBy>;
  variance?: InputMaybe<BilikZoneTradeMainProCountVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountArrRelInsertInput = {
  data: Array<BilikZoneTradeMainProCountInsertInput>;
};

/** aggregate avg on columns */
export type BilikZoneTradeMainProCountAvgFields = {
  __typename?: 'BilikZoneTradeMainProCountAvgFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountAvgOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "bilik_zone_trade_main_pro_count". All fields are combined with a logical 'AND'. */
export type BilikZoneTradeMainProCountBoolExp = {
  _and?: InputMaybe<Array<BilikZoneTradeMainProCountBoolExp>>;
  _not?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
  _or?: InputMaybe<Array<BilikZoneTradeMainProCountBoolExp>>;
  bilikZone?: InputMaybe<BilikZoneBoolExp>;
  bilikZoneId?: InputMaybe<IntComparisonExp>;
  count?: InputMaybe<BigintComparisonExp>;
  trade?: InputMaybe<TradeBoolExp>;
  tradeId?: InputMaybe<IntComparisonExp>;
};

/** input type for inserting data into table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountInsertInput = {
  bilikZone?: InputMaybe<BilikZoneObjRelInsertInput>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['bigint']>;
  trade?: InputMaybe<TradeObjRelInsertInput>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type BilikZoneTradeMainProCountMaxFields = {
  __typename?: 'BilikZoneTradeMainProCountMaxFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['bigint']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountMaxOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BilikZoneTradeMainProCountMinFields = {
  __typename?: 'BilikZoneTradeMainProCountMinFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['bigint']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountMinOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "bilik_zone_trade_main_pro_count". */
export type BilikZoneTradeMainProCountOrderBy = {
  bilikZone?: InputMaybe<BilikZoneOrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  trade?: InputMaybe<TradeOrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** select columns of table "bilik_zone_trade_main_pro_count" */
export enum BilikZoneTradeMainProCountSelectColumn {
  /** column name */
  BilikZoneId = 'bilikZoneId',
  /** column name */
  Count = 'count',
  /** column name */
  TradeId = 'tradeId'
}

/** aggregate stddev on columns */
export type BilikZoneTradeMainProCountStddevFields = {
  __typename?: 'BilikZoneTradeMainProCountStddevFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountStddevOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type BilikZoneTradeMainProCountStddevPopFields = {
  __typename?: 'BilikZoneTradeMainProCountStddevPopFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountStddevPopOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type BilikZoneTradeMainProCountStddevSampFields = {
  __typename?: 'BilikZoneTradeMainProCountStddevSampFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountStddevSampOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BilikZoneTradeMainProCountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BilikZoneTradeMainProCountStreamCursorValueInput = {
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['bigint']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type BilikZoneTradeMainProCountSumFields = {
  __typename?: 'BilikZoneTradeMainProCountSumFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['bigint']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountSumOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type BilikZoneTradeMainProCountVarPopFields = {
  __typename?: 'BilikZoneTradeMainProCountVarPopFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountVarPopOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type BilikZoneTradeMainProCountVarSampFields = {
  __typename?: 'BilikZoneTradeMainProCountVarSampFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountVarSampOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BilikZoneTradeMainProCountVarianceFields = {
  __typename?: 'BilikZoneTradeMainProCountVarianceFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bilik_zone_trade_main_pro_count" */
export type BilikZoneTradeMainProCountVarianceOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** update columns of table "bilik_zone" */
export enum BilikZoneUpdateColumn {
  /** column name */
  AddressCountry = 'addressCountry',
  /** column name */
  AddressLocality = 'addressLocality',
  /** column name */
  AddressRegion = 'addressRegion',
  /** column name */
  AreaOld = 'areaOld',
  /** column name */
  CallTrackingTarget = 'callTrackingTarget',
  /** column name */
  DefaultCallTrackingTarget = 'defaultCallTrackingTarget',
  /** column name */
  GenericEmail = 'genericEmail',
  /** column name */
  GuideName = 'guideName',
  /** column name */
  HasDistrict = 'hasDistrict',
  /** column name */
  HasMultiplePostalCode = 'hasMultiplePostalCode',
  /** column name */
  Id = 'id',
  /** column name */
  MainCityCode = 'mainCityCode',
  /** column name */
  MainCityId = 'mainCityId',
  /** column name */
  Name = 'name',
  /** column name */
  PostOfficeBoxNumber = 'postOfficeBoxNumber',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  RegionPostalCode = 'regionPostalCode',
  /** column name */
  ShouldDisplayContactInPiSms = 'shouldDisplayContactInPiSms',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  StreetAddress = 'streetAddress',
  /** column name */
  Telephone = 'telephone',
  /** column name */
  TwilioAddressSid = 'twilioAddressSid',
  /** column name */
  TwilioBundleSid = 'twilioBundleSid',
  /** column name */
  ZohoOrganizationId = 'zohoOrganizationId'
}

export type BilikZoneUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BilikZoneAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<BilikZoneDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<BilikZoneDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<BilikZoneDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BilikZoneIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BilikZonePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BilikZoneSetInput>;
  /** filter the rows which have to be updated */
  where: BilikZoneBoolExp;
};

/** aggregate varPop on columns */
export type BilikZoneVarPopFields = {
  __typename?: 'BilikZoneVarPopFields';
  id?: Maybe<Scalars['Float']>;
  mainCityId?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "bilik_zone" */
export type BilikZoneVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  mainCityId?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type BilikZoneVarSampFields = {
  __typename?: 'BilikZoneVarSampFields';
  id?: Maybe<Scalars['Float']>;
  mainCityId?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "bilik_zone" */
export type BilikZoneVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  mainCityId?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BilikZoneVarianceFields = {
  __typename?: 'BilikZoneVarianceFields';
  id?: Maybe<Scalars['Float']>;
  mainCityId?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bilik_zone" */
export type BilikZoneVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  mainCityId?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** columns and relationships of "certification" */
export type Certification = {
  __typename?: 'Certification';
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  proDescription?: Maybe<Scalars['String']>;
  /** An array relationship */
  proPresentations: Array<ProCertification>;
  /** An aggregate relationship */
  proPresentationsAggregate: ProCertificationAggregate;
  slug: Scalars['String'];
};


/** columns and relationships of "certification" */
export type CertificationProPresentationsArgs = {
  distinctOn?: InputMaybe<Array<ProCertificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProCertificationOrderBy>>;
  where?: InputMaybe<ProCertificationBoolExp>;
};


/** columns and relationships of "certification" */
export type CertificationProPresentationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProCertificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProCertificationOrderBy>>;
  where?: InputMaybe<ProCertificationBoolExp>;
};

/** aggregated selection of "certification" */
export type CertificationAggregate = {
  __typename?: 'CertificationAggregate';
  aggregate?: Maybe<CertificationAggregateFields>;
  nodes: Array<Certification>;
};

/** aggregate fields of "certification" */
export type CertificationAggregateFields = {
  __typename?: 'CertificationAggregateFields';
  avg?: Maybe<CertificationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CertificationMaxFields>;
  min?: Maybe<CertificationMinFields>;
  stddev?: Maybe<CertificationStddevFields>;
  stddevPop?: Maybe<CertificationStddevPopFields>;
  stddevSamp?: Maybe<CertificationStddevSampFields>;
  sum?: Maybe<CertificationSumFields>;
  varPop?: Maybe<CertificationVarPopFields>;
  varSamp?: Maybe<CertificationVarSampFields>;
  variance?: Maybe<CertificationVarianceFields>;
};


/** aggregate fields of "certification" */
export type CertificationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CertificationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CertificationAvgFields = {
  __typename?: 'CertificationAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "certification". All fields are combined with a logical 'AND'. */
export type CertificationBoolExp = {
  _and?: InputMaybe<Array<CertificationBoolExp>>;
  _not?: InputMaybe<CertificationBoolExp>;
  _or?: InputMaybe<Array<CertificationBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  proDescription?: InputMaybe<StringComparisonExp>;
  proPresentations?: InputMaybe<ProCertificationBoolExp>;
  proPresentationsAggregate?: InputMaybe<ProCertificationAggregateBoolExp>;
  slug?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "certification" */
export enum CertificationConstraint {
  /** unique or primary key constraint on columns "id" */
  CertificationPkey = 'certification_pkey'
}

/** input type for incrementing numeric columns in table "certification" */
export type CertificationIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "certification" */
export type CertificationInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  proDescription?: InputMaybe<Scalars['String']>;
  proPresentations?: InputMaybe<ProCertificationArrRelInsertInput>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CertificationMaxFields = {
  __typename?: 'CertificationMaxFields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  proDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CertificationMinFields = {
  __typename?: 'CertificationMinFields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  proDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "certification" */
export type CertificationMutationResponse = {
  __typename?: 'CertificationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Certification>;
};

/** input type for inserting object relation for remote table "certification" */
export type CertificationObjRelInsertInput = {
  data: CertificationInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CertificationOnConflict>;
};

/** on_conflict condition type for table "certification" */
export type CertificationOnConflict = {
  constraint: CertificationConstraint;
  updateColumns?: Array<CertificationUpdateColumn>;
  where?: InputMaybe<CertificationBoolExp>;
};

/** Ordering options when selecting data from "certification". */
export type CertificationOrderBy = {
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  proDescription?: InputMaybe<OrderBy>;
  proPresentationsAggregate?: InputMaybe<ProCertificationAggregateOrderBy>;
  slug?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: certification */
export type CertificationPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "certification" */
export enum CertificationSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProDescription = 'proDescription',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "certification" */
export type CertificationSetInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  proDescription?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CertificationStddevFields = {
  __typename?: 'CertificationStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CertificationStddevPopFields = {
  __typename?: 'CertificationStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CertificationStddevSampFields = {
  __typename?: 'CertificationStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "certification" */
export type CertificationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CertificationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CertificationStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  proDescription?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CertificationSumFields = {
  __typename?: 'CertificationSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "certification" */
export enum CertificationUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProDescription = 'proDescription',
  /** column name */
  Slug = 'slug'
}

export type CertificationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CertificationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CertificationSetInput>;
  /** filter the rows which have to be updated */
  where: CertificationBoolExp;
};

/** aggregate varPop on columns */
export type CertificationVarPopFields = {
  __typename?: 'CertificationVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CertificationVarSampFields = {
  __typename?: 'CertificationVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CertificationVarianceFields = {
  __typename?: 'CertificationVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** import OpenDataSoft de toutes les communes de France (2023) */
export type City = {
  __typename?: 'City';
  area: Scalars['geometry'];
  areaReal: Scalars['geometry'];
  /** An object relationship */
  bilikZone?: Maybe<BilikZone>;
  bilikZoneId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  bilikZones: Array<BilikZone>;
  /** An aggregate relationship */
  bilikZonesAggregate: BilikZoneAggregate;
  center: Scalars['geometry'];
  code: Scalars['String'];
  /** An object relationship */
  department: Department;
  departmentId: Scalars['Int'];
  /** An array relationship */
  districts: Array<City>;
  /** An aggregate relationship */
  districtsAggregate: CityAggregate;
  geoNameId: Scalars['Int'];
  id: Scalars['Int'];
  isRestricted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['Int']>;
  population: Scalars['Int'];
  postalCodes?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  proReviews: Array<ProReview>;
  /** An aggregate relationship */
  proReviewsAggregate: ProReviewAggregate;
  /** An array relationship */
  proViews: Array<CityProView>;
  /** An aggregate relationship */
  proViewsAggregate: CityProViewAggregate;
  /** An object relationship */
  region: Region;
  regionId: Scalars['Int'];
  siren?: Maybe<Scalars['String']>;
  /** An array relationship */
  sitemap: Array<SitemapCity>;
  /** An aggregate relationship */
  sitemapAggregate: SitemapCityAggregate;
  slug: Scalars['String'];
  /** An object relationship */
  upperCity?: Maybe<City>;
};


/** import OpenDataSoft de toutes les communes de France (2023) */
export type CityBilikZonesArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneOrderBy>>;
  where?: InputMaybe<BilikZoneBoolExp>;
};


/** import OpenDataSoft de toutes les communes de France (2023) */
export type CityBilikZonesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneOrderBy>>;
  where?: InputMaybe<BilikZoneBoolExp>;
};


/** import OpenDataSoft de toutes les communes de France (2023) */
export type CityDistrictsArgs = {
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


/** import OpenDataSoft de toutes les communes de France (2023) */
export type CityDistrictsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


/** import OpenDataSoft de toutes les communes de France (2023) */
export type CityPostalCodesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** import OpenDataSoft de toutes les communes de France (2023) */
export type CityProReviewsArgs = {
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


/** import OpenDataSoft de toutes les communes de France (2023) */
export type CityProReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


/** import OpenDataSoft de toutes les communes de France (2023) */
export type CityProViewsArgs = {
  distinctOn?: InputMaybe<Array<CityProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityProViewOrderBy>>;
  where?: InputMaybe<CityProViewBoolExp>;
};


/** import OpenDataSoft de toutes les communes de France (2023) */
export type CityProViewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CityProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityProViewOrderBy>>;
  where?: InputMaybe<CityProViewBoolExp>;
};


/** import OpenDataSoft de toutes les communes de France (2023) */
export type CitySitemapArgs = {
  distinctOn?: InputMaybe<Array<SitemapCitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapCityOrderBy>>;
  where?: InputMaybe<SitemapCityBoolExp>;
};


/** import OpenDataSoft de toutes les communes de France (2023) */
export type CitySitemapAggregateArgs = {
  distinctOn?: InputMaybe<Array<SitemapCitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapCityOrderBy>>;
  where?: InputMaybe<SitemapCityBoolExp>;
};

/** aggregated selection of "city" */
export type CityAggregate = {
  __typename?: 'CityAggregate';
  aggregate?: Maybe<CityAggregateFields>;
  nodes: Array<City>;
};

export type CityAggregateBoolExp = {
  bool_and?: InputMaybe<CityAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CityAggregateBoolExpBoolOr>;
  count?: InputMaybe<CityAggregateBoolExpCount>;
};

/** aggregate fields of "city" */
export type CityAggregateFields = {
  __typename?: 'CityAggregateFields';
  avg?: Maybe<CityAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CityMaxFields>;
  min?: Maybe<CityMinFields>;
  stddev?: Maybe<CityStddevFields>;
  stddevPop?: Maybe<CityStddevPopFields>;
  stddevSamp?: Maybe<CityStddevSampFields>;
  sum?: Maybe<CitySumFields>;
  varPop?: Maybe<CityVarPopFields>;
  varSamp?: Maybe<CityVarSampFields>;
  variance?: Maybe<CityVarianceFields>;
};


/** aggregate fields of "city" */
export type CityAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "city" */
export type CityAggregateOrderBy = {
  avg?: InputMaybe<CityAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CityMaxOrderBy>;
  min?: InputMaybe<CityMinOrderBy>;
  stddev?: InputMaybe<CityStddevOrderBy>;
  stddevPop?: InputMaybe<CityStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CityStddevSampOrderBy>;
  sum?: InputMaybe<CitySumOrderBy>;
  varPop?: InputMaybe<CityVarPopOrderBy>;
  varSamp?: InputMaybe<CityVarSampOrderBy>;
  variance?: InputMaybe<CityVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CityAppendInput = {
  postalCodes?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "city" */
export type CityArrRelInsertInput = {
  data: Array<CityInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CityOnConflict>;
};

/** aggregate avg on columns */
export type CityAvgFields = {
  __typename?: 'CityAvgFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  departmentId?: Maybe<Scalars['Float']>;
  geoNameId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['Float']>;
  population?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "city" */
export type CityAvgOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  geoNameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  population?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "city". All fields are combined with a logical 'AND'. */
export type CityBoolExp = {
  _and?: InputMaybe<Array<CityBoolExp>>;
  _not?: InputMaybe<CityBoolExp>;
  _or?: InputMaybe<Array<CityBoolExp>>;
  area?: InputMaybe<GeometryComparisonExp>;
  areaReal?: InputMaybe<GeometryComparisonExp>;
  bilikZone?: InputMaybe<BilikZoneBoolExp>;
  bilikZoneId?: InputMaybe<IntComparisonExp>;
  bilikZones?: InputMaybe<BilikZoneBoolExp>;
  bilikZonesAggregate?: InputMaybe<BilikZoneAggregateBoolExp>;
  center?: InputMaybe<GeometryComparisonExp>;
  code?: InputMaybe<StringComparisonExp>;
  department?: InputMaybe<DepartmentBoolExp>;
  departmentId?: InputMaybe<IntComparisonExp>;
  districts?: InputMaybe<CityBoolExp>;
  districtsAggregate?: InputMaybe<CityAggregateBoolExp>;
  geoNameId?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  isRestricted?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parentId?: InputMaybe<IntComparisonExp>;
  population?: InputMaybe<IntComparisonExp>;
  postalCodes?: InputMaybe<JsonbComparisonExp>;
  proReviews?: InputMaybe<ProReviewBoolExp>;
  proReviewsAggregate?: InputMaybe<ProReviewAggregateBoolExp>;
  proViews?: InputMaybe<CityProViewBoolExp>;
  proViewsAggregate?: InputMaybe<CityProViewAggregateBoolExp>;
  region?: InputMaybe<RegionBoolExp>;
  regionId?: InputMaybe<IntComparisonExp>;
  siren?: InputMaybe<StringComparisonExp>;
  sitemap?: InputMaybe<SitemapCityBoolExp>;
  sitemapAggregate?: InputMaybe<SitemapCityAggregateBoolExp>;
  slug?: InputMaybe<StringComparisonExp>;
  upperCity?: InputMaybe<CityBoolExp>;
};

/** unique or primary key constraints on table "city" */
export enum CityConstraint {
  /** unique or primary key constraint on columns "slug" */
  CitySlugKey = 'city_slug_key',
  /** unique or primary key constraint on columns "id" */
  OpenDataCityPkey = 'open_data_city_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CityDeleteAtPathInput = {
  postalCodes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CityDeleteElemInput = {
  postalCodes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CityDeleteKeyInput = {
  postalCodes?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "city" */
export type CityIncInput = {
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  departmentId?: InputMaybe<Scalars['Int']>;
  geoNameId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['Int']>;
  population?: InputMaybe<Scalars['Int']>;
  regionId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "city" */
export type CityInsertInput = {
  area?: InputMaybe<Scalars['geometry']>;
  areaReal?: InputMaybe<Scalars['geometry']>;
  bilikZone?: InputMaybe<BilikZoneObjRelInsertInput>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  bilikZones?: InputMaybe<BilikZoneArrRelInsertInput>;
  center?: InputMaybe<Scalars['geometry']>;
  code?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<DepartmentObjRelInsertInput>;
  departmentId?: InputMaybe<Scalars['Int']>;
  districts?: InputMaybe<CityArrRelInsertInput>;
  geoNameId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isRestricted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['Int']>;
  population?: InputMaybe<Scalars['Int']>;
  postalCodes?: InputMaybe<Scalars['jsonb']>;
  proReviews?: InputMaybe<ProReviewArrRelInsertInput>;
  proViews?: InputMaybe<CityProViewArrRelInsertInput>;
  region?: InputMaybe<RegionObjRelInsertInput>;
  regionId?: InputMaybe<Scalars['Int']>;
  siren?: InputMaybe<Scalars['String']>;
  sitemap?: InputMaybe<SitemapCityArrRelInsertInput>;
  slug?: InputMaybe<Scalars['String']>;
  upperCity?: InputMaybe<CityObjRelInsertInput>;
};

/** aggregate max on columns */
export type CityMaxFields = {
  __typename?: 'CityMaxFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['Int']>;
  geoNameId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['Int']>;
  population?: Maybe<Scalars['Int']>;
  regionId?: Maybe<Scalars['Int']>;
  siren?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "city" */
export type CityMaxOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  geoNameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  population?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
  siren?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CityMinFields = {
  __typename?: 'CityMinFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['Int']>;
  geoNameId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['Int']>;
  population?: Maybe<Scalars['Int']>;
  regionId?: Maybe<Scalars['Int']>;
  siren?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "city" */
export type CityMinOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  geoNameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  population?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
  siren?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "city" */
export type CityMutationResponse = {
  __typename?: 'CityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<City>;
};

/** input type for inserting object relation for remote table "city" */
export type CityObjRelInsertInput = {
  data: CityInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CityOnConflict>;
};

/** on_conflict condition type for table "city" */
export type CityOnConflict = {
  constraint: CityConstraint;
  updateColumns?: Array<CityUpdateColumn>;
  where?: InputMaybe<CityBoolExp>;
};

/** Ordering options when selecting data from "city". */
export type CityOrderBy = {
  area?: InputMaybe<OrderBy>;
  areaReal?: InputMaybe<OrderBy>;
  bilikZone?: InputMaybe<BilikZoneOrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  bilikZonesAggregate?: InputMaybe<BilikZoneAggregateOrderBy>;
  center?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  department?: InputMaybe<DepartmentOrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  districtsAggregate?: InputMaybe<CityAggregateOrderBy>;
  geoNameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isRestricted?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  population?: InputMaybe<OrderBy>;
  postalCodes?: InputMaybe<OrderBy>;
  proReviewsAggregate?: InputMaybe<ProReviewAggregateOrderBy>;
  proViewsAggregate?: InputMaybe<CityProViewAggregateOrderBy>;
  region?: InputMaybe<RegionOrderBy>;
  regionId?: InputMaybe<OrderBy>;
  siren?: InputMaybe<OrderBy>;
  sitemapAggregate?: InputMaybe<SitemapCityAggregateOrderBy>;
  slug?: InputMaybe<OrderBy>;
  upperCity?: InputMaybe<CityOrderBy>;
};

/** primary key columns input for table: city */
export type CityPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CityPrependInput = {
  postalCodes?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "city_pro_view" */
export type CityProView = {
  __typename?: 'CityProView';
  /** An object relationship */
  city: City;
  cityId: Scalars['Int'];
  /** An object relationship */
  proView: ProView;
  proViewId: Scalars['Int'];
  type: Scalars['String'];
};

/** aggregated selection of "city_pro_view" */
export type CityProViewAggregate = {
  __typename?: 'CityProViewAggregate';
  aggregate?: Maybe<CityProViewAggregateFields>;
  nodes: Array<CityProView>;
};

export type CityProViewAggregateBoolExp = {
  count?: InputMaybe<CityProViewAggregateBoolExpCount>;
};

/** aggregate fields of "city_pro_view" */
export type CityProViewAggregateFields = {
  __typename?: 'CityProViewAggregateFields';
  avg?: Maybe<CityProViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CityProViewMaxFields>;
  min?: Maybe<CityProViewMinFields>;
  stddev?: Maybe<CityProViewStddevFields>;
  stddevPop?: Maybe<CityProViewStddevPopFields>;
  stddevSamp?: Maybe<CityProViewStddevSampFields>;
  sum?: Maybe<CityProViewSumFields>;
  varPop?: Maybe<CityProViewVarPopFields>;
  varSamp?: Maybe<CityProViewVarSampFields>;
  variance?: Maybe<CityProViewVarianceFields>;
};


/** aggregate fields of "city_pro_view" */
export type CityProViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CityProViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "city_pro_view" */
export type CityProViewAggregateOrderBy = {
  avg?: InputMaybe<CityProViewAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CityProViewMaxOrderBy>;
  min?: InputMaybe<CityProViewMinOrderBy>;
  stddev?: InputMaybe<CityProViewStddevOrderBy>;
  stddevPop?: InputMaybe<CityProViewStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CityProViewStddevSampOrderBy>;
  sum?: InputMaybe<CityProViewSumOrderBy>;
  varPop?: InputMaybe<CityProViewVarPopOrderBy>;
  varSamp?: InputMaybe<CityProViewVarSampOrderBy>;
  variance?: InputMaybe<CityProViewVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "city_pro_view" */
export type CityProViewArrRelInsertInput = {
  data: Array<CityProViewInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CityProViewOnConflict>;
};

/** aggregate avg on columns */
export type CityProViewAvgFields = {
  __typename?: 'CityProViewAvgFields';
  cityId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "city_pro_view" */
export type CityProViewAvgOrderBy = {
  cityId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "city_pro_view". All fields are combined with a logical 'AND'. */
export type CityProViewBoolExp = {
  _and?: InputMaybe<Array<CityProViewBoolExp>>;
  _not?: InputMaybe<CityProViewBoolExp>;
  _or?: InputMaybe<Array<CityProViewBoolExp>>;
  city?: InputMaybe<CityBoolExp>;
  cityId?: InputMaybe<IntComparisonExp>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "city_pro_view" */
export enum CityProViewConstraint {
  /** unique or primary key constraint on columns "pro_view_id", "city_id" */
  CityProViewPkey = 'city_pro_view_pkey'
}

/** input type for incrementing numeric columns in table "city_pro_view" */
export type CityProViewIncInput = {
  cityId?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "city_pro_view" */
export type CityProViewInsertInput = {
  city?: InputMaybe<CityObjRelInsertInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CityProViewMaxFields = {
  __typename?: 'CityProViewMaxFields';
  cityId?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "city_pro_view" */
export type CityProViewMaxOrderBy = {
  cityId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CityProViewMinFields = {
  __typename?: 'CityProViewMinFields';
  cityId?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "city_pro_view" */
export type CityProViewMinOrderBy = {
  cityId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "city_pro_view" */
export type CityProViewMutationResponse = {
  __typename?: 'CityProViewMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CityProView>;
};

/** on_conflict condition type for table "city_pro_view" */
export type CityProViewOnConflict = {
  constraint: CityProViewConstraint;
  updateColumns?: Array<CityProViewUpdateColumn>;
  where?: InputMaybe<CityProViewBoolExp>;
};

/** Ordering options when selecting data from "city_pro_view". */
export type CityProViewOrderBy = {
  city?: InputMaybe<CityOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  proView?: InputMaybe<ProViewOrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: city_pro_view */
export type CityProViewPkColumnsInput = {
  cityId: Scalars['Int'];
  proViewId: Scalars['Int'];
};

/** select columns of table "city_pro_view" */
export enum CityProViewSelectColumn {
  /** column name */
  CityId = 'cityId',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "city_pro_view" */
export type CityProViewSetInput = {
  cityId?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CityProViewStddevFields = {
  __typename?: 'CityProViewStddevFields';
  cityId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "city_pro_view" */
export type CityProViewStddevOrderBy = {
  cityId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type CityProViewStddevPopFields = {
  __typename?: 'CityProViewStddevPopFields';
  cityId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "city_pro_view" */
export type CityProViewStddevPopOrderBy = {
  cityId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type CityProViewStddevSampFields = {
  __typename?: 'CityProViewStddevSampFields';
  cityId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "city_pro_view" */
export type CityProViewStddevSampOrderBy = {
  cityId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "city_pro_view" */
export type CityProViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CityProViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CityProViewStreamCursorValueInput = {
  cityId?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CityProViewSumFields = {
  __typename?: 'CityProViewSumFields';
  cityId?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "city_pro_view" */
export type CityProViewSumOrderBy = {
  cityId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** update columns of table "city_pro_view" */
export enum CityProViewUpdateColumn {
  /** column name */
  CityId = 'cityId',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  Type = 'type'
}

export type CityProViewUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CityProViewIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CityProViewSetInput>;
  /** filter the rows which have to be updated */
  where: CityProViewBoolExp;
};

/** aggregate varPop on columns */
export type CityProViewVarPopFields = {
  __typename?: 'CityProViewVarPopFields';
  cityId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "city_pro_view" */
export type CityProViewVarPopOrderBy = {
  cityId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type CityProViewVarSampFields = {
  __typename?: 'CityProViewVarSampFields';
  cityId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "city_pro_view" */
export type CityProViewVarSampOrderBy = {
  cityId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CityProViewVarianceFields = {
  __typename?: 'CityProViewVarianceFields';
  cityId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "city_pro_view" */
export type CityProViewVarianceOrderBy = {
  cityId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** select columns of table "city" */
export enum CitySelectColumn {
  /** column name */
  Area = 'area',
  /** column name */
  AreaReal = 'areaReal',
  /** column name */
  BilikZoneId = 'bilikZoneId',
  /** column name */
  Center = 'center',
  /** column name */
  Code = 'code',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  GeoNameId = 'geoNameId',
  /** column name */
  Id = 'id',
  /** column name */
  IsRestricted = 'isRestricted',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  Population = 'population',
  /** column name */
  PostalCodes = 'postalCodes',
  /** column name */
  RegionId = 'regionId',
  /** column name */
  Siren = 'siren',
  /** column name */
  Slug = 'slug'
}

/** select "cityAggregateBoolExpBool_andArgumentsColumns" columns of table "city" */
export enum CitySelectColumnCityAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsRestricted = 'isRestricted'
}

/** select "cityAggregateBoolExpBool_orArgumentsColumns" columns of table "city" */
export enum CitySelectColumnCityAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsRestricted = 'isRestricted'
}

/** input type for updating data in table "city" */
export type CitySetInput = {
  area?: InputMaybe<Scalars['geometry']>;
  areaReal?: InputMaybe<Scalars['geometry']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  center?: InputMaybe<Scalars['geometry']>;
  code?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['Int']>;
  geoNameId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isRestricted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['Int']>;
  population?: InputMaybe<Scalars['Int']>;
  postalCodes?: InputMaybe<Scalars['jsonb']>;
  regionId?: InputMaybe<Scalars['Int']>;
  siren?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CityStddevFields = {
  __typename?: 'CityStddevFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  departmentId?: Maybe<Scalars['Float']>;
  geoNameId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['Float']>;
  population?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "city" */
export type CityStddevOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  geoNameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  population?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type CityStddevPopFields = {
  __typename?: 'CityStddevPopFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  departmentId?: Maybe<Scalars['Float']>;
  geoNameId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['Float']>;
  population?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "city" */
export type CityStddevPopOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  geoNameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  population?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type CityStddevSampFields = {
  __typename?: 'CityStddevSampFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  departmentId?: Maybe<Scalars['Float']>;
  geoNameId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['Float']>;
  population?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "city" */
export type CityStddevSampOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  geoNameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  population?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "city" */
export type CityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CityStreamCursorValueInput = {
  area?: InputMaybe<Scalars['geometry']>;
  areaReal?: InputMaybe<Scalars['geometry']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  center?: InputMaybe<Scalars['geometry']>;
  code?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['Int']>;
  geoNameId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isRestricted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['Int']>;
  population?: InputMaybe<Scalars['Int']>;
  postalCodes?: InputMaybe<Scalars['jsonb']>;
  regionId?: InputMaybe<Scalars['Int']>;
  siren?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CitySumFields = {
  __typename?: 'CitySumFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  departmentId?: Maybe<Scalars['Int']>;
  geoNameId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['Int']>;
  population?: Maybe<Scalars['Int']>;
  regionId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "city" */
export type CitySumOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  geoNameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  population?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** update columns of table "city" */
export enum CityUpdateColumn {
  /** column name */
  Area = 'area',
  /** column name */
  AreaReal = 'areaReal',
  /** column name */
  BilikZoneId = 'bilikZoneId',
  /** column name */
  Center = 'center',
  /** column name */
  Code = 'code',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  GeoNameId = 'geoNameId',
  /** column name */
  Id = 'id',
  /** column name */
  IsRestricted = 'isRestricted',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  Population = 'population',
  /** column name */
  PostalCodes = 'postalCodes',
  /** column name */
  RegionId = 'regionId',
  /** column name */
  Siren = 'siren',
  /** column name */
  Slug = 'slug'
}

export type CityUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CityAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<CityDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<CityDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<CityDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CityIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CityPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CitySetInput>;
  /** filter the rows which have to be updated */
  where: CityBoolExp;
};

/** aggregate varPop on columns */
export type CityVarPopFields = {
  __typename?: 'CityVarPopFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  departmentId?: Maybe<Scalars['Float']>;
  geoNameId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['Float']>;
  population?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "city" */
export type CityVarPopOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  geoNameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  population?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type CityVarSampFields = {
  __typename?: 'CityVarSampFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  departmentId?: Maybe<Scalars['Float']>;
  geoNameId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['Float']>;
  population?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "city" */
export type CityVarSampOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  geoNameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  population?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CityVarianceFields = {
  __typename?: 'CityVarianceFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  departmentId?: Maybe<Scalars['Float']>;
  geoNameId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['Float']>;
  population?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "city" */
export type CityVarianceOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  geoNameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  population?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "company" */
export type Company = {
  __typename?: 'Company';
  bic?: Maybe<Scalars['String']>;
  billingEmail: Scalars['String'];
  city: Scalars['String'];
  countryCode: Scalars['String'];
  dateOfMandate?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  firstDatePublished?: Maybe<ProOrganizationFirstDatePublished>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  legalForm: Scalars['String'];
  mandateId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  postalCode: Scalars['String'];
  /** An array relationship */
  proMandates: Array<ProMandate>;
  /** An aggregate relationship */
  proMandatesAggregate: ProMandateAggregate;
  /** An array relationship */
  proPresentations: Array<ProPresentation>;
  /** An aggregate relationship */
  proPresentationsAggregate: ProPresentationAggregate;
  registrationNumber: Scalars['String'];
  streetAddress: Scalars['String'];
  vatNumber: Scalars['String'];
  /** An array relationship */
  zohoConsumers: Array<ZohoConsumer>;
  /** An aggregate relationship */
  zohoConsumersAggregate: ZohoConsumerAggregate;
};


/** columns and relationships of "company" */
export type CompanyProMandatesArgs = {
  distinctOn?: InputMaybe<Array<ProMandateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMandateOrderBy>>;
  where?: InputMaybe<ProMandateBoolExp>;
};


/** columns and relationships of "company" */
export type CompanyProMandatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProMandateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMandateOrderBy>>;
  where?: InputMaybe<ProMandateBoolExp>;
};


/** columns and relationships of "company" */
export type CompanyProPresentationsArgs = {
  distinctOn?: InputMaybe<Array<ProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPresentationOrderBy>>;
  where?: InputMaybe<ProPresentationBoolExp>;
};


/** columns and relationships of "company" */
export type CompanyProPresentationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPresentationOrderBy>>;
  where?: InputMaybe<ProPresentationBoolExp>;
};


/** columns and relationships of "company" */
export type CompanyZohoConsumersArgs = {
  distinctOn?: InputMaybe<Array<ZohoConsumerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoConsumerOrderBy>>;
  where?: InputMaybe<ZohoConsumerBoolExp>;
};


/** columns and relationships of "company" */
export type CompanyZohoConsumersAggregateArgs = {
  distinctOn?: InputMaybe<Array<ZohoConsumerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoConsumerOrderBy>>;
  where?: InputMaybe<ZohoConsumerBoolExp>;
};

/** aggregated selection of "company" */
export type CompanyAggregate = {
  __typename?: 'CompanyAggregate';
  aggregate?: Maybe<CompanyAggregateFields>;
  nodes: Array<Company>;
};

/** aggregate fields of "company" */
export type CompanyAggregateFields = {
  __typename?: 'CompanyAggregateFields';
  avg?: Maybe<CompanyAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompanyMaxFields>;
  min?: Maybe<CompanyMinFields>;
  stddev?: Maybe<CompanyStddevFields>;
  stddevPop?: Maybe<CompanyStddevPopFields>;
  stddevSamp?: Maybe<CompanyStddevSampFields>;
  sum?: Maybe<CompanySumFields>;
  varPop?: Maybe<CompanyVarPopFields>;
  varSamp?: Maybe<CompanyVarSampFields>;
  variance?: Maybe<CompanyVarianceFields>;
};


/** aggregate fields of "company" */
export type CompanyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CompanyAvgFields = {
  __typename?: 'CompanyAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "company". All fields are combined with a logical 'AND'. */
export type CompanyBoolExp = {
  _and?: InputMaybe<Array<CompanyBoolExp>>;
  _not?: InputMaybe<CompanyBoolExp>;
  _or?: InputMaybe<Array<CompanyBoolExp>>;
  bic?: InputMaybe<StringComparisonExp>;
  billingEmail?: InputMaybe<StringComparisonExp>;
  city?: InputMaybe<StringComparisonExp>;
  countryCode?: InputMaybe<StringComparisonExp>;
  dateOfMandate?: InputMaybe<TimestamptzComparisonExp>;
  firstDatePublished?: InputMaybe<ProOrganizationFirstDatePublishedBoolExp>;
  iban?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  legalForm?: InputMaybe<StringComparisonExp>;
  mandateId?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  postalCode?: InputMaybe<StringComparisonExp>;
  proMandates?: InputMaybe<ProMandateBoolExp>;
  proMandatesAggregate?: InputMaybe<ProMandateAggregateBoolExp>;
  proPresentations?: InputMaybe<ProPresentationBoolExp>;
  proPresentationsAggregate?: InputMaybe<ProPresentationAggregateBoolExp>;
  registrationNumber?: InputMaybe<StringComparisonExp>;
  streetAddress?: InputMaybe<StringComparisonExp>;
  vatNumber?: InputMaybe<StringComparisonExp>;
  zohoConsumers?: InputMaybe<ZohoConsumerBoolExp>;
  zohoConsumersAggregate?: InputMaybe<ZohoConsumerAggregateBoolExp>;
};

/** unique or primary key constraints on table "company" */
export enum CompanyConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22939Primary = 'idx_22939_primary'
}

/** input type for incrementing numeric columns in table "company" */
export type CompanyIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "company" */
export type CompanyInsertInput = {
  bic?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  dateOfMandate?: InputMaybe<Scalars['timestamptz']>;
  firstDatePublished?: InputMaybe<ProOrganizationFirstDatePublishedObjRelInsertInput>;
  iban?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  legalForm?: InputMaybe<Scalars['String']>;
  mandateId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  proMandates?: InputMaybe<ProMandateArrRelInsertInput>;
  proPresentations?: InputMaybe<ProPresentationArrRelInsertInput>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
  zohoConsumers?: InputMaybe<ZohoConsumerArrRelInsertInput>;
};

/** aggregate max on columns */
export type CompanyMaxFields = {
  __typename?: 'CompanyMaxFields';
  bic?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  dateOfMandate?: Maybe<Scalars['timestamptz']>;
  iban?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  legalForm?: Maybe<Scalars['String']>;
  mandateId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CompanyMinFields = {
  __typename?: 'CompanyMinFields';
  bic?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  dateOfMandate?: Maybe<Scalars['timestamptz']>;
  iban?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  legalForm?: Maybe<Scalars['String']>;
  mandateId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "company" */
export type CompanyMutationResponse = {
  __typename?: 'CompanyMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company>;
};

/** input type for inserting object relation for remote table "company" */
export type CompanyObjRelInsertInput = {
  data: CompanyInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyOnConflict>;
};

/** on_conflict condition type for table "company" */
export type CompanyOnConflict = {
  constraint: CompanyConstraint;
  updateColumns?: Array<CompanyUpdateColumn>;
  where?: InputMaybe<CompanyBoolExp>;
};

/** Ordering options when selecting data from "company". */
export type CompanyOrderBy = {
  bic?: InputMaybe<OrderBy>;
  billingEmail?: InputMaybe<OrderBy>;
  city?: InputMaybe<OrderBy>;
  countryCode?: InputMaybe<OrderBy>;
  dateOfMandate?: InputMaybe<OrderBy>;
  firstDatePublished?: InputMaybe<ProOrganizationFirstDatePublishedOrderBy>;
  iban?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  legalForm?: InputMaybe<OrderBy>;
  mandateId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  postalCode?: InputMaybe<OrderBy>;
  proMandatesAggregate?: InputMaybe<ProMandateAggregateOrderBy>;
  proPresentationsAggregate?: InputMaybe<ProPresentationAggregateOrderBy>;
  registrationNumber?: InputMaybe<OrderBy>;
  streetAddress?: InputMaybe<OrderBy>;
  vatNumber?: InputMaybe<OrderBy>;
  zohoConsumersAggregate?: InputMaybe<ZohoConsumerAggregateOrderBy>;
};

/** primary key columns input for table: company */
export type CompanyPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "company" */
export enum CompanySelectColumn {
  /** column name */
  Bic = 'bic',
  /** column name */
  BillingEmail = 'billingEmail',
  /** column name */
  City = 'city',
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  DateOfMandate = 'dateOfMandate',
  /** column name */
  Iban = 'iban',
  /** column name */
  Id = 'id',
  /** column name */
  LegalForm = 'legalForm',
  /** column name */
  MandateId = 'mandateId',
  /** column name */
  Name = 'name',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  RegistrationNumber = 'registrationNumber',
  /** column name */
  StreetAddress = 'streetAddress',
  /** column name */
  VatNumber = 'vatNumber'
}

/** input type for updating data in table "company" */
export type CompanySetInput = {
  bic?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  dateOfMandate?: InputMaybe<Scalars['timestamptz']>;
  iban?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  legalForm?: InputMaybe<Scalars['String']>;
  mandateId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CompanyStddevFields = {
  __typename?: 'CompanyStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CompanyStddevPopFields = {
  __typename?: 'CompanyStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CompanyStddevSampFields = {
  __typename?: 'CompanyStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "company" */
export type CompanyStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyStreamCursorValueInput = {
  bic?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  dateOfMandate?: InputMaybe<Scalars['timestamptz']>;
  iban?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  legalForm?: InputMaybe<Scalars['String']>;
  mandateId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CompanySumFields = {
  __typename?: 'CompanySumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "company" */
export enum CompanyUpdateColumn {
  /** column name */
  Bic = 'bic',
  /** column name */
  BillingEmail = 'billingEmail',
  /** column name */
  City = 'city',
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  DateOfMandate = 'dateOfMandate',
  /** column name */
  Iban = 'iban',
  /** column name */
  Id = 'id',
  /** column name */
  LegalForm = 'legalForm',
  /** column name */
  MandateId = 'mandateId',
  /** column name */
  Name = 'name',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  RegistrationNumber = 'registrationNumber',
  /** column name */
  StreetAddress = 'streetAddress',
  /** column name */
  VatNumber = 'vatNumber'
}

export type CompanyUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompanyIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanySetInput>;
  /** filter the rows which have to be updated */
  where: CompanyBoolExp;
};

/** aggregate varPop on columns */
export type CompanyVarPopFields = {
  __typename?: 'CompanyVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CompanyVarSampFields = {
  __typename?: 'CompanyVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CompanyVarianceFields = {
  __typename?: 'CompanyVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "count_city_same_slug" */
export type CountCitySameSlug = {
  __typename?: 'CountCitySameSlug';
  occurrence?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
};

/** aggregated selection of "count_city_same_slug" */
export type CountCitySameSlugAggregate = {
  __typename?: 'CountCitySameSlugAggregate';
  aggregate?: Maybe<CountCitySameSlugAggregateFields>;
  nodes: Array<CountCitySameSlug>;
};

/** aggregate fields of "count_city_same_slug" */
export type CountCitySameSlugAggregateFields = {
  __typename?: 'CountCitySameSlugAggregateFields';
  avg?: Maybe<CountCitySameSlugAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CountCitySameSlugMaxFields>;
  min?: Maybe<CountCitySameSlugMinFields>;
  stddev?: Maybe<CountCitySameSlugStddevFields>;
  stddevPop?: Maybe<CountCitySameSlugStddevPopFields>;
  stddevSamp?: Maybe<CountCitySameSlugStddevSampFields>;
  sum?: Maybe<CountCitySameSlugSumFields>;
  varPop?: Maybe<CountCitySameSlugVarPopFields>;
  varSamp?: Maybe<CountCitySameSlugVarSampFields>;
  variance?: Maybe<CountCitySameSlugVarianceFields>;
};


/** aggregate fields of "count_city_same_slug" */
export type CountCitySameSlugAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CountCitySameSlugSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CountCitySameSlugAvgFields = {
  __typename?: 'CountCitySameSlugAvgFields';
  occurrence?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "count_city_same_slug". All fields are combined with a logical 'AND'. */
export type CountCitySameSlugBoolExp = {
  _and?: InputMaybe<Array<CountCitySameSlugBoolExp>>;
  _not?: InputMaybe<CountCitySameSlugBoolExp>;
  _or?: InputMaybe<Array<CountCitySameSlugBoolExp>>;
  occurrence?: InputMaybe<BigintComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type CountCitySameSlugMaxFields = {
  __typename?: 'CountCitySameSlugMaxFields';
  occurrence?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CountCitySameSlugMinFields = {
  __typename?: 'CountCitySameSlugMinFields';
  occurrence?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "count_city_same_slug". */
export type CountCitySameSlugOrderBy = {
  occurrence?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
};

/** select columns of table "count_city_same_slug" */
export enum CountCitySameSlugSelectColumn {
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  Slug = 'slug'
}

/** aggregate stddev on columns */
export type CountCitySameSlugStddevFields = {
  __typename?: 'CountCitySameSlugStddevFields';
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CountCitySameSlugStddevPopFields = {
  __typename?: 'CountCitySameSlugStddevPopFields';
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CountCitySameSlugStddevSampFields = {
  __typename?: 'CountCitySameSlugStddevSampFields';
  occurrence?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "count_city_same_slug" */
export type CountCitySameSlugStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CountCitySameSlugStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CountCitySameSlugStreamCursorValueInput = {
  occurrence?: InputMaybe<Scalars['bigint']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CountCitySameSlugSumFields = {
  __typename?: 'CountCitySameSlugSumFields';
  occurrence?: Maybe<Scalars['bigint']>;
};

/** aggregate varPop on columns */
export type CountCitySameSlugVarPopFields = {
  __typename?: 'CountCitySameSlugVarPopFields';
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CountCitySameSlugVarSampFields = {
  __typename?: 'CountCitySameSlugVarSampFields';
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CountCitySameSlugVarianceFields = {
  __typename?: 'CountCitySameSlugVarianceFields';
  occurrence?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "count_pro_review_by_status" */
export type CountProReviewByStatus = {
  __typename?: 'CountProReviewByStatus';
  count?: Maybe<Scalars['bigint']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregated selection of "count_pro_review_by_status" */
export type CountProReviewByStatusAggregate = {
  __typename?: 'CountProReviewByStatusAggregate';
  aggregate?: Maybe<CountProReviewByStatusAggregateFields>;
  nodes: Array<CountProReviewByStatus>;
};

/** aggregate fields of "count_pro_review_by_status" */
export type CountProReviewByStatusAggregateFields = {
  __typename?: 'CountProReviewByStatusAggregateFields';
  avg?: Maybe<CountProReviewByStatusAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CountProReviewByStatusMaxFields>;
  min?: Maybe<CountProReviewByStatusMinFields>;
  stddev?: Maybe<CountProReviewByStatusStddevFields>;
  stddevPop?: Maybe<CountProReviewByStatusStddevPopFields>;
  stddevSamp?: Maybe<CountProReviewByStatusStddevSampFields>;
  sum?: Maybe<CountProReviewByStatusSumFields>;
  varPop?: Maybe<CountProReviewByStatusVarPopFields>;
  varSamp?: Maybe<CountProReviewByStatusVarSampFields>;
  variance?: Maybe<CountProReviewByStatusVarianceFields>;
};


/** aggregate fields of "count_pro_review_by_status" */
export type CountProReviewByStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CountProReviewByStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CountProReviewByStatusAvgFields = {
  __typename?: 'CountProReviewByStatusAvgFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "count_pro_review_by_status". All fields are combined with a logical 'AND'. */
export type CountProReviewByStatusBoolExp = {
  _and?: InputMaybe<Array<CountProReviewByStatusBoolExp>>;
  _not?: InputMaybe<CountProReviewByStatusBoolExp>;
  _or?: InputMaybe<Array<CountProReviewByStatusBoolExp>>;
  count?: InputMaybe<BigintComparisonExp>;
  proPresentationId?: InputMaybe<IntComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type CountProReviewByStatusMaxFields = {
  __typename?: 'CountProReviewByStatusMaxFields';
  count?: Maybe<Scalars['bigint']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CountProReviewByStatusMinFields = {
  __typename?: 'CountProReviewByStatusMinFields';
  count?: Maybe<Scalars['bigint']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "count_pro_review_by_status". */
export type CountProReviewByStatusOrderBy = {
  count?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** select columns of table "count_pro_review_by_status" */
export enum CountProReviewByStatusSelectColumn {
  /** column name */
  Count = 'count',
  /** column name */
  ProPresentationId = 'proPresentationId',
  /** column name */
  Status = 'status'
}

/** aggregate stddev on columns */
export type CountProReviewByStatusStddevFields = {
  __typename?: 'CountProReviewByStatusStddevFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CountProReviewByStatusStddevPopFields = {
  __typename?: 'CountProReviewByStatusStddevPopFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CountProReviewByStatusStddevSampFields = {
  __typename?: 'CountProReviewByStatusStddevSampFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "count_pro_review_by_status" */
export type CountProReviewByStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CountProReviewByStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CountProReviewByStatusStreamCursorValueInput = {
  count?: InputMaybe<Scalars['bigint']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CountProReviewByStatusSumFields = {
  __typename?: 'CountProReviewByStatusSumFields';
  count?: Maybe<Scalars['bigint']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** aggregate varPop on columns */
export type CountProReviewByStatusVarPopFields = {
  __typename?: 'CountProReviewByStatusVarPopFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CountProReviewByStatusVarSampFields = {
  __typename?: 'CountProReviewByStatusVarSampFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CountProReviewByStatusVarianceFields = {
  __typename?: 'CountProReviewByStatusVarianceFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "count_pro_review_invitations_by_month_by_pro_presentation" */
export type CountProReviewInvitationsByMonthByProPresentation = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentation';
  count?: Maybe<Scalars['bigint']>;
  month?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  proPresentation?: Maybe<ProPresentation>;
  proPresentationId?: Maybe<Scalars['Int']>;
  replyProReviewCount?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "count_pro_review_invitations_by_month_by_pro_presentation" */
export type CountProReviewInvitationsByMonthByProPresentationAggregate = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentationAggregate';
  aggregate?: Maybe<CountProReviewInvitationsByMonthByProPresentationAggregateFields>;
  nodes: Array<CountProReviewInvitationsByMonthByProPresentation>;
};

/** aggregate fields of "count_pro_review_invitations_by_month_by_pro_presentation" */
export type CountProReviewInvitationsByMonthByProPresentationAggregateFields = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentationAggregateFields';
  avg?: Maybe<CountProReviewInvitationsByMonthByProPresentationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CountProReviewInvitationsByMonthByProPresentationMaxFields>;
  min?: Maybe<CountProReviewInvitationsByMonthByProPresentationMinFields>;
  stddev?: Maybe<CountProReviewInvitationsByMonthByProPresentationStddevFields>;
  stddevPop?: Maybe<CountProReviewInvitationsByMonthByProPresentationStddevPopFields>;
  stddevSamp?: Maybe<CountProReviewInvitationsByMonthByProPresentationStddevSampFields>;
  sum?: Maybe<CountProReviewInvitationsByMonthByProPresentationSumFields>;
  varPop?: Maybe<CountProReviewInvitationsByMonthByProPresentationVarPopFields>;
  varSamp?: Maybe<CountProReviewInvitationsByMonthByProPresentationVarSampFields>;
  variance?: Maybe<CountProReviewInvitationsByMonthByProPresentationVarianceFields>;
};


/** aggregate fields of "count_pro_review_invitations_by_month_by_pro_presentation" */
export type CountProReviewInvitationsByMonthByProPresentationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CountProReviewInvitationsByMonthByProPresentationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CountProReviewInvitationsByMonthByProPresentationAvgFields = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentationAvgFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  replyProReviewCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "count_pro_review_invitations_by_month_by_pro_presentation". All fields are combined with a logical 'AND'. */
export type CountProReviewInvitationsByMonthByProPresentationBoolExp = {
  _and?: InputMaybe<Array<CountProReviewInvitationsByMonthByProPresentationBoolExp>>;
  _not?: InputMaybe<CountProReviewInvitationsByMonthByProPresentationBoolExp>;
  _or?: InputMaybe<Array<CountProReviewInvitationsByMonthByProPresentationBoolExp>>;
  count?: InputMaybe<BigintComparisonExp>;
  month?: InputMaybe<TimestamptzComparisonExp>;
  proPresentation?: InputMaybe<ProPresentationBoolExp>;
  proPresentationId?: InputMaybe<IntComparisonExp>;
  replyProReviewCount?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CountProReviewInvitationsByMonthByProPresentationMaxFields = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentationMaxFields';
  count?: Maybe<Scalars['bigint']>;
  month?: Maybe<Scalars['timestamptz']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  replyProReviewCount?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CountProReviewInvitationsByMonthByProPresentationMinFields = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentationMinFields';
  count?: Maybe<Scalars['bigint']>;
  month?: Maybe<Scalars['timestamptz']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  replyProReviewCount?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "count_pro_review_invitations_by_month_by_pro_presentation". */
export type CountProReviewInvitationsByMonthByProPresentationOrderBy = {
  count?: InputMaybe<OrderBy>;
  month?: InputMaybe<OrderBy>;
  proPresentation?: InputMaybe<ProPresentationOrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  replyProReviewCount?: InputMaybe<OrderBy>;
};

/** select columns of table "count_pro_review_invitations_by_month_by_pro_presentation" */
export enum CountProReviewInvitationsByMonthByProPresentationSelectColumn {
  /** column name */
  Count = 'count',
  /** column name */
  Month = 'month',
  /** column name */
  ProPresentationId = 'proPresentationId',
  /** column name */
  ReplyProReviewCount = 'replyProReviewCount'
}

/** aggregate stddev on columns */
export type CountProReviewInvitationsByMonthByProPresentationStddevFields = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentationStddevFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  replyProReviewCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CountProReviewInvitationsByMonthByProPresentationStddevPopFields = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentationStddevPopFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  replyProReviewCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CountProReviewInvitationsByMonthByProPresentationStddevSampFields = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentationStddevSampFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  replyProReviewCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "count_pro_review_invitations_by_month_by_pro_presentation" */
export type CountProReviewInvitationsByMonthByProPresentationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CountProReviewInvitationsByMonthByProPresentationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CountProReviewInvitationsByMonthByProPresentationStreamCursorValueInput = {
  count?: InputMaybe<Scalars['bigint']>;
  month?: InputMaybe<Scalars['timestamptz']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  replyProReviewCount?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CountProReviewInvitationsByMonthByProPresentationSumFields = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentationSumFields';
  count?: Maybe<Scalars['bigint']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  replyProReviewCount?: Maybe<Scalars['bigint']>;
};

/** aggregate varPop on columns */
export type CountProReviewInvitationsByMonthByProPresentationVarPopFields = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentationVarPopFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  replyProReviewCount?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CountProReviewInvitationsByMonthByProPresentationVarSampFields = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentationVarSampFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  replyProReviewCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CountProReviewInvitationsByMonthByProPresentationVarianceFields = {
  __typename?: 'CountProReviewInvitationsByMonthByProPresentationVarianceFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  replyProReviewCount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "count_pro_reviews_with_status_ok_by_month_by_pro_presentation" */
export type CountProReviewsWithStatusOkByMonthByProPresentation = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentation';
  count?: Maybe<Scalars['bigint']>;
  month?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  proPresentation?: Maybe<ProPresentation>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "count_pro_reviews_with_status_ok_by_month_by_pro_presentation" */
export type CountProReviewsWithStatusOkByMonthByProPresentationAggregate = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentationAggregate';
  aggregate?: Maybe<CountProReviewsWithStatusOkByMonthByProPresentationAggregateFields>;
  nodes: Array<CountProReviewsWithStatusOkByMonthByProPresentation>;
};

/** aggregate fields of "count_pro_reviews_with_status_ok_by_month_by_pro_presentation" */
export type CountProReviewsWithStatusOkByMonthByProPresentationAggregateFields = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentationAggregateFields';
  avg?: Maybe<CountProReviewsWithStatusOkByMonthByProPresentationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CountProReviewsWithStatusOkByMonthByProPresentationMaxFields>;
  min?: Maybe<CountProReviewsWithStatusOkByMonthByProPresentationMinFields>;
  stddev?: Maybe<CountProReviewsWithStatusOkByMonthByProPresentationStddevFields>;
  stddevPop?: Maybe<CountProReviewsWithStatusOkByMonthByProPresentationStddevPopFields>;
  stddevSamp?: Maybe<CountProReviewsWithStatusOkByMonthByProPresentationStddevSampFields>;
  sum?: Maybe<CountProReviewsWithStatusOkByMonthByProPresentationSumFields>;
  varPop?: Maybe<CountProReviewsWithStatusOkByMonthByProPresentationVarPopFields>;
  varSamp?: Maybe<CountProReviewsWithStatusOkByMonthByProPresentationVarSampFields>;
  variance?: Maybe<CountProReviewsWithStatusOkByMonthByProPresentationVarianceFields>;
};


/** aggregate fields of "count_pro_reviews_with_status_ok_by_month_by_pro_presentation" */
export type CountProReviewsWithStatusOkByMonthByProPresentationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CountProReviewsWithStatusOkByMonthByProPresentationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CountProReviewsWithStatusOkByMonthByProPresentationAvgFields = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentationAvgFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "count_pro_reviews_with_status_ok_by_month_by_pro_presentation". All fields are combined with a logical 'AND'. */
export type CountProReviewsWithStatusOkByMonthByProPresentationBoolExp = {
  _and?: InputMaybe<Array<CountProReviewsWithStatusOkByMonthByProPresentationBoolExp>>;
  _not?: InputMaybe<CountProReviewsWithStatusOkByMonthByProPresentationBoolExp>;
  _or?: InputMaybe<Array<CountProReviewsWithStatusOkByMonthByProPresentationBoolExp>>;
  count?: InputMaybe<BigintComparisonExp>;
  month?: InputMaybe<TimestamptzComparisonExp>;
  proPresentation?: InputMaybe<ProPresentationBoolExp>;
  proPresentationId?: InputMaybe<IntComparisonExp>;
};

/** aggregate max on columns */
export type CountProReviewsWithStatusOkByMonthByProPresentationMaxFields = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentationMaxFields';
  count?: Maybe<Scalars['bigint']>;
  month?: Maybe<Scalars['timestamptz']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type CountProReviewsWithStatusOkByMonthByProPresentationMinFields = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentationMinFields';
  count?: Maybe<Scalars['bigint']>;
  month?: Maybe<Scalars['timestamptz']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "count_pro_reviews_with_status_ok_by_month_by_pro_presentation". */
export type CountProReviewsWithStatusOkByMonthByProPresentationOrderBy = {
  count?: InputMaybe<OrderBy>;
  month?: InputMaybe<OrderBy>;
  proPresentation?: InputMaybe<ProPresentationOrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** select columns of table "count_pro_reviews_with_status_ok_by_month_by_pro_presentation" */
export enum CountProReviewsWithStatusOkByMonthByProPresentationSelectColumn {
  /** column name */
  Count = 'count',
  /** column name */
  Month = 'month',
  /** column name */
  ProPresentationId = 'proPresentationId'
}

/** aggregate stddev on columns */
export type CountProReviewsWithStatusOkByMonthByProPresentationStddevFields = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentationStddevFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CountProReviewsWithStatusOkByMonthByProPresentationStddevPopFields = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentationStddevPopFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CountProReviewsWithStatusOkByMonthByProPresentationStddevSampFields = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentationStddevSampFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "count_pro_reviews_with_status_ok_by_month_by_pro_presentation" */
export type CountProReviewsWithStatusOkByMonthByProPresentationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CountProReviewsWithStatusOkByMonthByProPresentationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CountProReviewsWithStatusOkByMonthByProPresentationStreamCursorValueInput = {
  count?: InputMaybe<Scalars['bigint']>;
  month?: InputMaybe<Scalars['timestamptz']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CountProReviewsWithStatusOkByMonthByProPresentationSumFields = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentationSumFields';
  count?: Maybe<Scalars['bigint']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** aggregate varPop on columns */
export type CountProReviewsWithStatusOkByMonthByProPresentationVarPopFields = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentationVarPopFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CountProReviewsWithStatusOkByMonthByProPresentationVarSampFields = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentationVarSampFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CountProReviewsWithStatusOkByMonthByProPresentationVarianceFields = {
  __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentationVarianceFields';
  count?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type DateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** import OpenDataSoft de toutes les régions de France (2023) */
export type Department = {
  __typename?: 'Department';
  area: Scalars['geometry'];
  /** An array relationship */
  cities: Array<City>;
  /** An aggregate relationship */
  citiesAggregate: CityAggregate;
  code: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  region: Region;
  regionId: Scalars['Int'];
  siren?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};


/** import OpenDataSoft de toutes les régions de France (2023) */
export type DepartmentCitiesArgs = {
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


/** import OpenDataSoft de toutes les régions de France (2023) */
export type DepartmentCitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};

/** aggregated selection of "department" */
export type DepartmentAggregate = {
  __typename?: 'DepartmentAggregate';
  aggregate?: Maybe<DepartmentAggregateFields>;
  nodes: Array<Department>;
};

export type DepartmentAggregateBoolExp = {
  count?: InputMaybe<DepartmentAggregateBoolExpCount>;
};

/** aggregate fields of "department" */
export type DepartmentAggregateFields = {
  __typename?: 'DepartmentAggregateFields';
  avg?: Maybe<DepartmentAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DepartmentMaxFields>;
  min?: Maybe<DepartmentMinFields>;
  stddev?: Maybe<DepartmentStddevFields>;
  stddevPop?: Maybe<DepartmentStddevPopFields>;
  stddevSamp?: Maybe<DepartmentStddevSampFields>;
  sum?: Maybe<DepartmentSumFields>;
  varPop?: Maybe<DepartmentVarPopFields>;
  varSamp?: Maybe<DepartmentVarSampFields>;
  variance?: Maybe<DepartmentVarianceFields>;
};


/** aggregate fields of "department" */
export type DepartmentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DepartmentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "department" */
export type DepartmentAggregateOrderBy = {
  avg?: InputMaybe<DepartmentAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DepartmentMaxOrderBy>;
  min?: InputMaybe<DepartmentMinOrderBy>;
  stddev?: InputMaybe<DepartmentStddevOrderBy>;
  stddevPop?: InputMaybe<DepartmentStddevPopOrderBy>;
  stddevSamp?: InputMaybe<DepartmentStddevSampOrderBy>;
  sum?: InputMaybe<DepartmentSumOrderBy>;
  varPop?: InputMaybe<DepartmentVarPopOrderBy>;
  varSamp?: InputMaybe<DepartmentVarSampOrderBy>;
  variance?: InputMaybe<DepartmentVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "department" */
export type DepartmentArrRelInsertInput = {
  data: Array<DepartmentInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<DepartmentOnConflict>;
};

/** aggregate avg on columns */
export type DepartmentAvgFields = {
  __typename?: 'DepartmentAvgFields';
  id?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "department" */
export type DepartmentAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "department". All fields are combined with a logical 'AND'. */
export type DepartmentBoolExp = {
  _and?: InputMaybe<Array<DepartmentBoolExp>>;
  _not?: InputMaybe<DepartmentBoolExp>;
  _or?: InputMaybe<Array<DepartmentBoolExp>>;
  area?: InputMaybe<GeometryComparisonExp>;
  cities?: InputMaybe<CityBoolExp>;
  citiesAggregate?: InputMaybe<CityAggregateBoolExp>;
  code?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  region?: InputMaybe<RegionBoolExp>;
  regionId?: InputMaybe<IntComparisonExp>;
  siren?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "department" */
export enum DepartmentConstraint {
  /** unique or primary key constraint on columns "id" */
  OpenDataDepartmentPkey = 'open_data_department_pkey'
}

/** input type for incrementing numeric columns in table "department" */
export type DepartmentIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  regionId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "department" */
export type DepartmentInsertInput = {
  area?: InputMaybe<Scalars['geometry']>;
  cities?: InputMaybe<CityArrRelInsertInput>;
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<RegionObjRelInsertInput>;
  regionId?: InputMaybe<Scalars['Int']>;
  siren?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DepartmentMaxFields = {
  __typename?: 'DepartmentMaxFields';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['Int']>;
  siren?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "department" */
export type DepartmentMaxOrderBy = {
  code?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
  siren?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DepartmentMinFields = {
  __typename?: 'DepartmentMinFields';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['Int']>;
  siren?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "department" */
export type DepartmentMinOrderBy = {
  code?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
  siren?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "department" */
export type DepartmentMutationResponse = {
  __typename?: 'DepartmentMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Department>;
};

/** input type for inserting object relation for remote table "department" */
export type DepartmentObjRelInsertInput = {
  data: DepartmentInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DepartmentOnConflict>;
};

/** on_conflict condition type for table "department" */
export type DepartmentOnConflict = {
  constraint: DepartmentConstraint;
  updateColumns?: Array<DepartmentUpdateColumn>;
  where?: InputMaybe<DepartmentBoolExp>;
};

/** Ordering options when selecting data from "department". */
export type DepartmentOrderBy = {
  area?: InputMaybe<OrderBy>;
  citiesAggregate?: InputMaybe<CityAggregateOrderBy>;
  code?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  region?: InputMaybe<RegionOrderBy>;
  regionId?: InputMaybe<OrderBy>;
  siren?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: department */
export type DepartmentPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "department" */
export enum DepartmentSelectColumn {
  /** column name */
  Area = 'area',
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RegionId = 'regionId',
  /** column name */
  Siren = 'siren',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "department" */
export type DepartmentSetInput = {
  area?: InputMaybe<Scalars['geometry']>;
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['Int']>;
  siren?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DepartmentStddevFields = {
  __typename?: 'DepartmentStddevFields';
  id?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "department" */
export type DepartmentStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type DepartmentStddevPopFields = {
  __typename?: 'DepartmentStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "department" */
export type DepartmentStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type DepartmentStddevSampFields = {
  __typename?: 'DepartmentStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "department" */
export type DepartmentStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "department" */
export type DepartmentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DepartmentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DepartmentStreamCursorValueInput = {
  area?: InputMaybe<Scalars['geometry']>;
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['Int']>;
  siren?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type DepartmentSumFields = {
  __typename?: 'DepartmentSumFields';
  id?: Maybe<Scalars['Int']>;
  regionId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "department" */
export type DepartmentSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** update columns of table "department" */
export enum DepartmentUpdateColumn {
  /** column name */
  Area = 'area',
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RegionId = 'regionId',
  /** column name */
  Siren = 'siren',
  /** column name */
  Slug = 'slug'
}

export type DepartmentUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DepartmentIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DepartmentSetInput>;
  /** filter the rows which have to be updated */
  where: DepartmentBoolExp;
};

/** aggregate varPop on columns */
export type DepartmentVarPopFields = {
  __typename?: 'DepartmentVarPopFields';
  id?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "department" */
export type DepartmentVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type DepartmentVarSampFields = {
  __typename?: 'DepartmentVarSampFields';
  id?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "department" */
export type DepartmentVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type DepartmentVarianceFields = {
  __typename?: 'DepartmentVarianceFields';
  id?: Maybe<Scalars['Float']>;
  regionId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "department" */
export type DepartmentVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  regionId?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8ComparisonExp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

export type GeographyCastExp = {
  geometry?: InputMaybe<GeometryComparisonExp>;
};

/** columns and relationships of "geography_columns" */
export type GeographyColumns = {
  __typename?: 'GeographyColumns';
  coordDimension?: Maybe<Scalars['Int']>;
  fGeographyColumn?: Maybe<Scalars['name']>;
  fTableCatalog?: Maybe<Scalars['name']>;
  fTableName?: Maybe<Scalars['name']>;
  fTableSchema?: Maybe<Scalars['name']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "geography_columns" */
export type GeographyColumnsAggregate = {
  __typename?: 'GeographyColumnsAggregate';
  aggregate?: Maybe<GeographyColumnsAggregateFields>;
  nodes: Array<GeographyColumns>;
};

/** aggregate fields of "geography_columns" */
export type GeographyColumnsAggregateFields = {
  __typename?: 'GeographyColumnsAggregateFields';
  avg?: Maybe<GeographyColumnsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<GeographyColumnsMaxFields>;
  min?: Maybe<GeographyColumnsMinFields>;
  stddev?: Maybe<GeographyColumnsStddevFields>;
  stddevPop?: Maybe<GeographyColumnsStddevPopFields>;
  stddevSamp?: Maybe<GeographyColumnsStddevSampFields>;
  sum?: Maybe<GeographyColumnsSumFields>;
  varPop?: Maybe<GeographyColumnsVarPopFields>;
  varSamp?: Maybe<GeographyColumnsVarSampFields>;
  variance?: Maybe<GeographyColumnsVarianceFields>;
};


/** aggregate fields of "geography_columns" */
export type GeographyColumnsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GeographyColumnsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type GeographyColumnsAvgFields = {
  __typename?: 'GeographyColumnsAvgFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "geography_columns". All fields are combined with a logical 'AND'. */
export type GeographyColumnsBoolExp = {
  _and?: InputMaybe<Array<GeographyColumnsBoolExp>>;
  _not?: InputMaybe<GeographyColumnsBoolExp>;
  _or?: InputMaybe<Array<GeographyColumnsBoolExp>>;
  coordDimension?: InputMaybe<IntComparisonExp>;
  fGeographyColumn?: InputMaybe<NameComparisonExp>;
  fTableCatalog?: InputMaybe<NameComparisonExp>;
  fTableName?: InputMaybe<NameComparisonExp>;
  fTableSchema?: InputMaybe<NameComparisonExp>;
  srid?: InputMaybe<IntComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type GeographyColumnsMaxFields = {
  __typename?: 'GeographyColumnsMaxFields';
  coordDimension?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type GeographyColumnsMinFields = {
  __typename?: 'GeographyColumnsMinFields';
  coordDimension?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "geography_columns". */
export type GeographyColumnsOrderBy = {
  coordDimension?: InputMaybe<OrderBy>;
  fGeographyColumn?: InputMaybe<OrderBy>;
  fTableCatalog?: InputMaybe<OrderBy>;
  fTableName?: InputMaybe<OrderBy>;
  fTableSchema?: InputMaybe<OrderBy>;
  srid?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** select columns of table "geography_columns" */
export enum GeographyColumnsSelectColumn {
  /** column name */
  CoordDimension = 'coordDimension',
  /** column name */
  FGeographyColumn = 'fGeographyColumn',
  /** column name */
  FTableCatalog = 'fTableCatalog',
  /** column name */
  FTableName = 'fTableName',
  /** column name */
  FTableSchema = 'fTableSchema',
  /** column name */
  Srid = 'srid',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type GeographyColumnsStddevFields = {
  __typename?: 'GeographyColumnsStddevFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type GeographyColumnsStddevPopFields = {
  __typename?: 'GeographyColumnsStddevPopFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type GeographyColumnsStddevSampFields = {
  __typename?: 'GeographyColumnsStddevSampFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "geography_columns" */
export type GeographyColumnsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeographyColumnsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeographyColumnsStreamCursorValueInput = {
  coordDimension?: InputMaybe<Scalars['Int']>;
  fGeographyColumn?: InputMaybe<Scalars['name']>;
  fTableCatalog?: InputMaybe<Scalars['name']>;
  fTableName?: InputMaybe<Scalars['name']>;
  fTableSchema?: InputMaybe<Scalars['name']>;
  srid?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type GeographyColumnsSumFields = {
  __typename?: 'GeographyColumnsSumFields';
  coordDimension?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
};

/** aggregate varPop on columns */
export type GeographyColumnsVarPopFields = {
  __typename?: 'GeographyColumnsVarPopFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type GeographyColumnsVarSampFields = {
  __typename?: 'GeographyColumnsVarSampFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type GeographyColumnsVarianceFields = {
  __typename?: 'GeographyColumnsVarianceFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type GeographyComparisonExp = {
  _cast?: InputMaybe<GeographyCastExp>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _stDWithin?: InputMaybe<StDWithinGeographyInput>;
  /** does the column spatially intersect the given geography value */
  _stIntersects?: InputMaybe<Scalars['geography']>;
};

export type GeometryCastExp = {
  geography?: InputMaybe<GeographyComparisonExp>;
};

/** columns and relationships of "geometry_columns" */
export type GeometryColumns = {
  __typename?: 'GeometryColumns';
  coordDimension?: Maybe<Scalars['Int']>;
  fGeometryColumn?: Maybe<Scalars['name']>;
  fTableCatalog?: Maybe<Scalars['String']>;
  fTableName?: Maybe<Scalars['name']>;
  fTableSchema?: Maybe<Scalars['name']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "geometry_columns" */
export type GeometryColumnsAggregate = {
  __typename?: 'GeometryColumnsAggregate';
  aggregate?: Maybe<GeometryColumnsAggregateFields>;
  nodes: Array<GeometryColumns>;
};

/** aggregate fields of "geometry_columns" */
export type GeometryColumnsAggregateFields = {
  __typename?: 'GeometryColumnsAggregateFields';
  avg?: Maybe<GeometryColumnsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<GeometryColumnsMaxFields>;
  min?: Maybe<GeometryColumnsMinFields>;
  stddev?: Maybe<GeometryColumnsStddevFields>;
  stddevPop?: Maybe<GeometryColumnsStddevPopFields>;
  stddevSamp?: Maybe<GeometryColumnsStddevSampFields>;
  sum?: Maybe<GeometryColumnsSumFields>;
  varPop?: Maybe<GeometryColumnsVarPopFields>;
  varSamp?: Maybe<GeometryColumnsVarSampFields>;
  variance?: Maybe<GeometryColumnsVarianceFields>;
};


/** aggregate fields of "geometry_columns" */
export type GeometryColumnsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GeometryColumnsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type GeometryColumnsAvgFields = {
  __typename?: 'GeometryColumnsAvgFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "geometry_columns". All fields are combined with a logical 'AND'. */
export type GeometryColumnsBoolExp = {
  _and?: InputMaybe<Array<GeometryColumnsBoolExp>>;
  _not?: InputMaybe<GeometryColumnsBoolExp>;
  _or?: InputMaybe<Array<GeometryColumnsBoolExp>>;
  coordDimension?: InputMaybe<IntComparisonExp>;
  fGeometryColumn?: InputMaybe<NameComparisonExp>;
  fTableCatalog?: InputMaybe<StringComparisonExp>;
  fTableName?: InputMaybe<NameComparisonExp>;
  fTableSchema?: InputMaybe<NameComparisonExp>;
  srid?: InputMaybe<IntComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** input type for incrementing numeric columns in table "geometry_columns" */
export type GeometryColumnsIncInput = {
  coordDimension?: InputMaybe<Scalars['Int']>;
  srid?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "geometry_columns" */
export type GeometryColumnsInsertInput = {
  coordDimension?: InputMaybe<Scalars['Int']>;
  fGeometryColumn?: InputMaybe<Scalars['name']>;
  fTableCatalog?: InputMaybe<Scalars['String']>;
  fTableName?: InputMaybe<Scalars['name']>;
  fTableSchema?: InputMaybe<Scalars['name']>;
  srid?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GeometryColumnsMaxFields = {
  __typename?: 'GeometryColumnsMaxFields';
  coordDimension?: Maybe<Scalars['Int']>;
  fTableCatalog?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type GeometryColumnsMinFields = {
  __typename?: 'GeometryColumnsMinFields';
  coordDimension?: Maybe<Scalars['Int']>;
  fTableCatalog?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "geometry_columns" */
export type GeometryColumnsMutationResponse = {
  __typename?: 'GeometryColumnsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GeometryColumns>;
};

/** Ordering options when selecting data from "geometry_columns". */
export type GeometryColumnsOrderBy = {
  coordDimension?: InputMaybe<OrderBy>;
  fGeometryColumn?: InputMaybe<OrderBy>;
  fTableCatalog?: InputMaybe<OrderBy>;
  fTableName?: InputMaybe<OrderBy>;
  fTableSchema?: InputMaybe<OrderBy>;
  srid?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** select columns of table "geometry_columns" */
export enum GeometryColumnsSelectColumn {
  /** column name */
  CoordDimension = 'coordDimension',
  /** column name */
  FGeometryColumn = 'fGeometryColumn',
  /** column name */
  FTableCatalog = 'fTableCatalog',
  /** column name */
  FTableName = 'fTableName',
  /** column name */
  FTableSchema = 'fTableSchema',
  /** column name */
  Srid = 'srid',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "geometry_columns" */
export type GeometryColumnsSetInput = {
  coordDimension?: InputMaybe<Scalars['Int']>;
  fGeometryColumn?: InputMaybe<Scalars['name']>;
  fTableCatalog?: InputMaybe<Scalars['String']>;
  fTableName?: InputMaybe<Scalars['name']>;
  fTableSchema?: InputMaybe<Scalars['name']>;
  srid?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GeometryColumnsStddevFields = {
  __typename?: 'GeometryColumnsStddevFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type GeometryColumnsStddevPopFields = {
  __typename?: 'GeometryColumnsStddevPopFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type GeometryColumnsStddevSampFields = {
  __typename?: 'GeometryColumnsStddevSampFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "geometry_columns" */
export type GeometryColumnsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeometryColumnsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeometryColumnsStreamCursorValueInput = {
  coordDimension?: InputMaybe<Scalars['Int']>;
  fGeometryColumn?: InputMaybe<Scalars['name']>;
  fTableCatalog?: InputMaybe<Scalars['String']>;
  fTableName?: InputMaybe<Scalars['name']>;
  fTableSchema?: InputMaybe<Scalars['name']>;
  srid?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type GeometryColumnsSumFields = {
  __typename?: 'GeometryColumnsSumFields';
  coordDimension?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
};

export type GeometryColumnsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GeometryColumnsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeometryColumnsSetInput>;
  /** filter the rows which have to be updated */
  where: GeometryColumnsBoolExp;
};

/** aggregate varPop on columns */
export type GeometryColumnsVarPopFields = {
  __typename?: 'GeometryColumnsVarPopFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type GeometryColumnsVarSampFields = {
  __typename?: 'GeometryColumnsVarSampFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type GeometryColumnsVarianceFields = {
  __typename?: 'GeometryColumnsVarianceFields';
  coordDimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type GeometryComparisonExp = {
  _cast?: InputMaybe<GeometryCastExp>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st3dDWithin?: InputMaybe<StDWithinInput>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st3dIntersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _stContains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _stCrosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _stDWithin?: InputMaybe<StDWithinInput>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _stEquals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _stIntersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _stOverlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _stTouches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _stWithin?: InputMaybe<Scalars['geometry']>;
};

/** columns and relationships of "globally_blocked_identity" */
export type GloballyBlockedIdentity = {
  __typename?: 'GloballyBlockedIdentity';
  dateCreated: Scalars['timestamptz'];
  id: Scalars['Int'];
  identifier: Scalars['String'];
  reason: Scalars['String'];
};

/** aggregated selection of "globally_blocked_identity" */
export type GloballyBlockedIdentityAggregate = {
  __typename?: 'GloballyBlockedIdentityAggregate';
  aggregate?: Maybe<GloballyBlockedIdentityAggregateFields>;
  nodes: Array<GloballyBlockedIdentity>;
};

/** aggregate fields of "globally_blocked_identity" */
export type GloballyBlockedIdentityAggregateFields = {
  __typename?: 'GloballyBlockedIdentityAggregateFields';
  avg?: Maybe<GloballyBlockedIdentityAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<GloballyBlockedIdentityMaxFields>;
  min?: Maybe<GloballyBlockedIdentityMinFields>;
  stddev?: Maybe<GloballyBlockedIdentityStddevFields>;
  stddevPop?: Maybe<GloballyBlockedIdentityStddevPopFields>;
  stddevSamp?: Maybe<GloballyBlockedIdentityStddevSampFields>;
  sum?: Maybe<GloballyBlockedIdentitySumFields>;
  varPop?: Maybe<GloballyBlockedIdentityVarPopFields>;
  varSamp?: Maybe<GloballyBlockedIdentityVarSampFields>;
  variance?: Maybe<GloballyBlockedIdentityVarianceFields>;
};


/** aggregate fields of "globally_blocked_identity" */
export type GloballyBlockedIdentityAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GloballyBlockedIdentitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type GloballyBlockedIdentityAvgFields = {
  __typename?: 'GloballyBlockedIdentityAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "globally_blocked_identity". All fields are combined with a logical 'AND'. */
export type GloballyBlockedIdentityBoolExp = {
  _and?: InputMaybe<Array<GloballyBlockedIdentityBoolExp>>;
  _not?: InputMaybe<GloballyBlockedIdentityBoolExp>;
  _or?: InputMaybe<Array<GloballyBlockedIdentityBoolExp>>;
  dateCreated?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  identifier?: InputMaybe<StringComparisonExp>;
  reason?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "globally_blocked_identity" */
export enum GloballyBlockedIdentityConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22879Primary = 'idx_22879_primary',
  /** unique or primary key constraint on columns "identifier" */
  Idx_22879UniqB600ffbb772e836a = 'idx_22879_uniq_b600ffbb772e836a'
}

/** input type for incrementing numeric columns in table "globally_blocked_identity" */
export type GloballyBlockedIdentityIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "globally_blocked_identity" */
export type GloballyBlockedIdentityInsertInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GloballyBlockedIdentityMaxFields = {
  __typename?: 'GloballyBlockedIdentityMaxFields';
  dateCreated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  identifier?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type GloballyBlockedIdentityMinFields = {
  __typename?: 'GloballyBlockedIdentityMinFields';
  dateCreated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  identifier?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "globally_blocked_identity" */
export type GloballyBlockedIdentityMutationResponse = {
  __typename?: 'GloballyBlockedIdentityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GloballyBlockedIdentity>;
};

/** on_conflict condition type for table "globally_blocked_identity" */
export type GloballyBlockedIdentityOnConflict = {
  constraint: GloballyBlockedIdentityConstraint;
  updateColumns?: Array<GloballyBlockedIdentityUpdateColumn>;
  where?: InputMaybe<GloballyBlockedIdentityBoolExp>;
};

/** Ordering options when selecting data from "globally_blocked_identity". */
export type GloballyBlockedIdentityOrderBy = {
  dateCreated?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  identifier?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: globally_blocked_identity */
export type GloballyBlockedIdentityPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "globally_blocked_identity" */
export enum GloballyBlockedIdentitySelectColumn {
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  Id = 'id',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  Reason = 'reason'
}

/** input type for updating data in table "globally_blocked_identity" */
export type GloballyBlockedIdentitySetInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GloballyBlockedIdentityStddevFields = {
  __typename?: 'GloballyBlockedIdentityStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type GloballyBlockedIdentityStddevPopFields = {
  __typename?: 'GloballyBlockedIdentityStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type GloballyBlockedIdentityStddevSampFields = {
  __typename?: 'GloballyBlockedIdentityStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "globally_blocked_identity" */
export type GloballyBlockedIdentityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GloballyBlockedIdentityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GloballyBlockedIdentityStreamCursorValueInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type GloballyBlockedIdentitySumFields = {
  __typename?: 'GloballyBlockedIdentitySumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "globally_blocked_identity" */
export enum GloballyBlockedIdentityUpdateColumn {
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  Id = 'id',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  Reason = 'reason'
}

export type GloballyBlockedIdentityUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GloballyBlockedIdentityIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GloballyBlockedIdentitySetInput>;
  /** filter the rows which have to be updated */
  where: GloballyBlockedIdentityBoolExp;
};

/** aggregate varPop on columns */
export type GloballyBlockedIdentityVarPopFields = {
  __typename?: 'GloballyBlockedIdentityVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type GloballyBlockedIdentityVarSampFields = {
  __typename?: 'GloballyBlockedIdentityVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type GloballyBlockedIdentityVarianceFields = {
  __typename?: 'GloballyBlockedIdentityVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "google_review_link" */
export type GoogleReviewLink = {
  __typename?: 'GoogleReviewLink';
  id: Scalars['Int'];
  /** An object relationship */
  proPresentation: ProPresentation;
  proPresentationId: Scalars['Int'];
  /** An array relationship */
  proViews: Array<ProView>;
  /** An aggregate relationship */
  proViewsAggregate: ProViewAggregate;
  url: Scalars['String'];
};


/** columns and relationships of "google_review_link" */
export type GoogleReviewLinkProViewsArgs = {
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


/** columns and relationships of "google_review_link" */
export type GoogleReviewLinkProViewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};

/** aggregated selection of "google_review_link" */
export type GoogleReviewLinkAggregate = {
  __typename?: 'GoogleReviewLinkAggregate';
  aggregate?: Maybe<GoogleReviewLinkAggregateFields>;
  nodes: Array<GoogleReviewLink>;
};

export type GoogleReviewLinkAggregateBoolExp = {
  count?: InputMaybe<GoogleReviewLinkAggregateBoolExpCount>;
};

/** aggregate fields of "google_review_link" */
export type GoogleReviewLinkAggregateFields = {
  __typename?: 'GoogleReviewLinkAggregateFields';
  avg?: Maybe<GoogleReviewLinkAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<GoogleReviewLinkMaxFields>;
  min?: Maybe<GoogleReviewLinkMinFields>;
  stddev?: Maybe<GoogleReviewLinkStddevFields>;
  stddevPop?: Maybe<GoogleReviewLinkStddevPopFields>;
  stddevSamp?: Maybe<GoogleReviewLinkStddevSampFields>;
  sum?: Maybe<GoogleReviewLinkSumFields>;
  varPop?: Maybe<GoogleReviewLinkVarPopFields>;
  varSamp?: Maybe<GoogleReviewLinkVarSampFields>;
  variance?: Maybe<GoogleReviewLinkVarianceFields>;
};


/** aggregate fields of "google_review_link" */
export type GoogleReviewLinkAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GoogleReviewLinkSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "google_review_link" */
export type GoogleReviewLinkAggregateOrderBy = {
  avg?: InputMaybe<GoogleReviewLinkAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GoogleReviewLinkMaxOrderBy>;
  min?: InputMaybe<GoogleReviewLinkMinOrderBy>;
  stddev?: InputMaybe<GoogleReviewLinkStddevOrderBy>;
  stddevPop?: InputMaybe<GoogleReviewLinkStddevPopOrderBy>;
  stddevSamp?: InputMaybe<GoogleReviewLinkStddevSampOrderBy>;
  sum?: InputMaybe<GoogleReviewLinkSumOrderBy>;
  varPop?: InputMaybe<GoogleReviewLinkVarPopOrderBy>;
  varSamp?: InputMaybe<GoogleReviewLinkVarSampOrderBy>;
  variance?: InputMaybe<GoogleReviewLinkVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "google_review_link" */
export type GoogleReviewLinkArrRelInsertInput = {
  data: Array<GoogleReviewLinkInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GoogleReviewLinkOnConflict>;
};

/** aggregate avg on columns */
export type GoogleReviewLinkAvgFields = {
  __typename?: 'GoogleReviewLinkAvgFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "google_review_link" */
export type GoogleReviewLinkAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "google_review_link". All fields are combined with a logical 'AND'. */
export type GoogleReviewLinkBoolExp = {
  _and?: InputMaybe<Array<GoogleReviewLinkBoolExp>>;
  _not?: InputMaybe<GoogleReviewLinkBoolExp>;
  _or?: InputMaybe<Array<GoogleReviewLinkBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  proPresentation?: InputMaybe<ProPresentationBoolExp>;
  proPresentationId?: InputMaybe<IntComparisonExp>;
  proViews?: InputMaybe<ProViewBoolExp>;
  proViewsAggregate?: InputMaybe<ProViewAggregateBoolExp>;
  url?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "google_review_link" */
export enum GoogleReviewLinkConstraint {
  /** unique or primary key constraint on columns "id" */
  GoogleReviewLinkPkey = 'google_review_link_pkey'
}

/** input type for incrementing numeric columns in table "google_review_link" */
export type GoogleReviewLinkIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "google_review_link" */
export type GoogleReviewLinkInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  proPresentation?: InputMaybe<ProPresentationObjRelInsertInput>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  proViews?: InputMaybe<ProViewArrRelInsertInput>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GoogleReviewLinkMaxFields = {
  __typename?: 'GoogleReviewLinkMaxFields';
  id?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "google_review_link" */
export type GoogleReviewLinkMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GoogleReviewLinkMinFields = {
  __typename?: 'GoogleReviewLinkMinFields';
  id?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "google_review_link" */
export type GoogleReviewLinkMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "google_review_link" */
export type GoogleReviewLinkMutationResponse = {
  __typename?: 'GoogleReviewLinkMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GoogleReviewLink>;
};

/** input type for inserting object relation for remote table "google_review_link" */
export type GoogleReviewLinkObjRelInsertInput = {
  data: GoogleReviewLinkInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<GoogleReviewLinkOnConflict>;
};

/** on_conflict condition type for table "google_review_link" */
export type GoogleReviewLinkOnConflict = {
  constraint: GoogleReviewLinkConstraint;
  updateColumns?: Array<GoogleReviewLinkUpdateColumn>;
  where?: InputMaybe<GoogleReviewLinkBoolExp>;
};

/** Ordering options when selecting data from "google_review_link". */
export type GoogleReviewLinkOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentation?: InputMaybe<ProPresentationOrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proViewsAggregate?: InputMaybe<ProViewAggregateOrderBy>;
  url?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: google_review_link */
export type GoogleReviewLinkPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "google_review_link" */
export enum GoogleReviewLinkSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ProPresentationId = 'proPresentationId',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "google_review_link" */
export type GoogleReviewLinkSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GoogleReviewLinkStddevFields = {
  __typename?: 'GoogleReviewLinkStddevFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "google_review_link" */
export type GoogleReviewLinkStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type GoogleReviewLinkStddevPopFields = {
  __typename?: 'GoogleReviewLinkStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "google_review_link" */
export type GoogleReviewLinkStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type GoogleReviewLinkStddevSampFields = {
  __typename?: 'GoogleReviewLinkStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "google_review_link" */
export type GoogleReviewLinkStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "google_review_link" */
export type GoogleReviewLinkStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GoogleReviewLinkStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GoogleReviewLinkStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type GoogleReviewLinkSumFields = {
  __typename?: 'GoogleReviewLinkSumFields';
  id?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "google_review_link" */
export type GoogleReviewLinkSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** update columns of table "google_review_link" */
export enum GoogleReviewLinkUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ProPresentationId = 'proPresentationId',
  /** column name */
  Url = 'url'
}

export type GoogleReviewLinkUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GoogleReviewLinkIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GoogleReviewLinkSetInput>;
  /** filter the rows which have to be updated */
  where: GoogleReviewLinkBoolExp;
};

/** aggregate varPop on columns */
export type GoogleReviewLinkVarPopFields = {
  __typename?: 'GoogleReviewLinkVarPopFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "google_review_link" */
export type GoogleReviewLinkVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type GoogleReviewLinkVarSampFields = {
  __typename?: 'GoogleReviewLinkVarSampFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "google_review_link" */
export type GoogleReviewLinkVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type GoogleReviewLinkVarianceFields = {
  __typename?: 'GoogleReviewLinkVarianceFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "google_review_link" */
export type GoogleReviewLinkVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _containedIn?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _hasKey?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZone = {
  __typename?: 'ManagerBilikPersonBilikZone';
  /** An object relationship */
  bilikPerson: BilikPerson;
  bilikPersonId: Scalars['Int'];
  /** An object relationship */
  bilikZone: BilikZone;
  bilikZoneId: Scalars['Int'];
};

/** aggregated selection of "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneAggregate = {
  __typename?: 'ManagerBilikPersonBilikZoneAggregate';
  aggregate?: Maybe<ManagerBilikPersonBilikZoneAggregateFields>;
  nodes: Array<ManagerBilikPersonBilikZone>;
};

export type ManagerBilikPersonBilikZoneAggregateBoolExp = {
  count?: InputMaybe<ManagerBilikPersonBilikZoneAggregateBoolExpCount>;
};

/** aggregate fields of "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneAggregateFields = {
  __typename?: 'ManagerBilikPersonBilikZoneAggregateFields';
  avg?: Maybe<ManagerBilikPersonBilikZoneAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ManagerBilikPersonBilikZoneMaxFields>;
  min?: Maybe<ManagerBilikPersonBilikZoneMinFields>;
  stddev?: Maybe<ManagerBilikPersonBilikZoneStddevFields>;
  stddevPop?: Maybe<ManagerBilikPersonBilikZoneStddevPopFields>;
  stddevSamp?: Maybe<ManagerBilikPersonBilikZoneStddevSampFields>;
  sum?: Maybe<ManagerBilikPersonBilikZoneSumFields>;
  varPop?: Maybe<ManagerBilikPersonBilikZoneVarPopFields>;
  varSamp?: Maybe<ManagerBilikPersonBilikZoneVarSampFields>;
  variance?: Maybe<ManagerBilikPersonBilikZoneVarianceFields>;
};


/** aggregate fields of "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ManagerBilikPersonBilikZoneSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneAggregateOrderBy = {
  avg?: InputMaybe<ManagerBilikPersonBilikZoneAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ManagerBilikPersonBilikZoneMaxOrderBy>;
  min?: InputMaybe<ManagerBilikPersonBilikZoneMinOrderBy>;
  stddev?: InputMaybe<ManagerBilikPersonBilikZoneStddevOrderBy>;
  stddevPop?: InputMaybe<ManagerBilikPersonBilikZoneStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ManagerBilikPersonBilikZoneStddevSampOrderBy>;
  sum?: InputMaybe<ManagerBilikPersonBilikZoneSumOrderBy>;
  varPop?: InputMaybe<ManagerBilikPersonBilikZoneVarPopOrderBy>;
  varSamp?: InputMaybe<ManagerBilikPersonBilikZoneVarSampOrderBy>;
  variance?: InputMaybe<ManagerBilikPersonBilikZoneVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneArrRelInsertInput = {
  data: Array<ManagerBilikPersonBilikZoneInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ManagerBilikPersonBilikZoneOnConflict>;
};

/** aggregate avg on columns */
export type ManagerBilikPersonBilikZoneAvgFields = {
  __typename?: 'ManagerBilikPersonBilikZoneAvgFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneAvgOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "manager_bilik_person_bilik_zone". All fields are combined with a logical 'AND'. */
export type ManagerBilikPersonBilikZoneBoolExp = {
  _and?: InputMaybe<Array<ManagerBilikPersonBilikZoneBoolExp>>;
  _not?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
  _or?: InputMaybe<Array<ManagerBilikPersonBilikZoneBoolExp>>;
  bilikPerson?: InputMaybe<BilikPersonBoolExp>;
  bilikPersonId?: InputMaybe<IntComparisonExp>;
  bilikZone?: InputMaybe<BilikZoneBoolExp>;
  bilikZoneId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "manager_bilik_person_bilik_zone" */
export enum ManagerBilikPersonBilikZoneConstraint {
  /** unique or primary key constraint on columns "bilik_person_id", "bilik_zone_id" */
  ManagerBilikPersonBilikZonePkey = 'manager_bilik_person_bilik_zone_pkey'
}

/** input type for incrementing numeric columns in table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneIncInput = {
  bilikPersonId?: InputMaybe<Scalars['Int']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneInsertInput = {
  bilikPerson?: InputMaybe<BilikPersonObjRelInsertInput>;
  bilikPersonId?: InputMaybe<Scalars['Int']>;
  bilikZone?: InputMaybe<BilikZoneObjRelInsertInput>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ManagerBilikPersonBilikZoneMaxFields = {
  __typename?: 'ManagerBilikPersonBilikZoneMaxFields';
  bilikPersonId?: Maybe<Scalars['Int']>;
  bilikZoneId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneMaxOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ManagerBilikPersonBilikZoneMinFields = {
  __typename?: 'ManagerBilikPersonBilikZoneMinFields';
  bilikPersonId?: Maybe<Scalars['Int']>;
  bilikZoneId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneMinOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneMutationResponse = {
  __typename?: 'ManagerBilikPersonBilikZoneMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ManagerBilikPersonBilikZone>;
};

/** on_conflict condition type for table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneOnConflict = {
  constraint: ManagerBilikPersonBilikZoneConstraint;
  updateColumns?: Array<ManagerBilikPersonBilikZoneUpdateColumn>;
  where?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
};

/** Ordering options when selecting data from "manager_bilik_person_bilik_zone". */
export type ManagerBilikPersonBilikZoneOrderBy = {
  bilikPerson?: InputMaybe<BilikPersonOrderBy>;
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZone?: InputMaybe<BilikZoneOrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: manager_bilik_person_bilik_zone */
export type ManagerBilikPersonBilikZonePkColumnsInput = {
  bilikPersonId: Scalars['Int'];
  bilikZoneId: Scalars['Int'];
};

/** select columns of table "manager_bilik_person_bilik_zone" */
export enum ManagerBilikPersonBilikZoneSelectColumn {
  /** column name */
  BilikPersonId = 'bilikPersonId',
  /** column name */
  BilikZoneId = 'bilikZoneId'
}

/** input type for updating data in table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneSetInput = {
  bilikPersonId?: InputMaybe<Scalars['Int']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ManagerBilikPersonBilikZoneStddevFields = {
  __typename?: 'ManagerBilikPersonBilikZoneStddevFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneStddevOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ManagerBilikPersonBilikZoneStddevPopFields = {
  __typename?: 'ManagerBilikPersonBilikZoneStddevPopFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneStddevPopOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ManagerBilikPersonBilikZoneStddevSampFields = {
  __typename?: 'ManagerBilikPersonBilikZoneStddevSampFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneStddevSampOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ManagerBilikPersonBilikZoneStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ManagerBilikPersonBilikZoneStreamCursorValueInput = {
  bilikPersonId?: InputMaybe<Scalars['Int']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ManagerBilikPersonBilikZoneSumFields = {
  __typename?: 'ManagerBilikPersonBilikZoneSumFields';
  bilikPersonId?: Maybe<Scalars['Int']>;
  bilikZoneId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneSumOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** update columns of table "manager_bilik_person_bilik_zone" */
export enum ManagerBilikPersonBilikZoneUpdateColumn {
  /** column name */
  BilikPersonId = 'bilikPersonId',
  /** column name */
  BilikZoneId = 'bilikZoneId'
}

export type ManagerBilikPersonBilikZoneUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ManagerBilikPersonBilikZoneIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ManagerBilikPersonBilikZoneSetInput>;
  /** filter the rows which have to be updated */
  where: ManagerBilikPersonBilikZoneBoolExp;
};

/** aggregate varPop on columns */
export type ManagerBilikPersonBilikZoneVarPopFields = {
  __typename?: 'ManagerBilikPersonBilikZoneVarPopFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneVarPopOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ManagerBilikPersonBilikZoneVarSampFields = {
  __typename?: 'ManagerBilikPersonBilikZoneVarSampFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneVarSampOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ManagerBilikPersonBilikZoneVarianceFields = {
  __typename?: 'ManagerBilikPersonBilikZoneVarianceFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "manager_bilik_person_bilik_zone" */
export type ManagerBilikPersonBilikZoneVarianceOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZone = {
  __typename?: 'MemberBilikPersonBilikZone';
  /** An object relationship */
  bilikPerson: BilikPerson;
  bilikPersonId: Scalars['Int'];
  /** An object relationship */
  bilikZone: BilikZone;
  bilikZoneId: Scalars['Int'];
};

/** aggregated selection of "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneAggregate = {
  __typename?: 'MemberBilikPersonBilikZoneAggregate';
  aggregate?: Maybe<MemberBilikPersonBilikZoneAggregateFields>;
  nodes: Array<MemberBilikPersonBilikZone>;
};

export type MemberBilikPersonBilikZoneAggregateBoolExp = {
  count?: InputMaybe<MemberBilikPersonBilikZoneAggregateBoolExpCount>;
};

/** aggregate fields of "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneAggregateFields = {
  __typename?: 'MemberBilikPersonBilikZoneAggregateFields';
  avg?: Maybe<MemberBilikPersonBilikZoneAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MemberBilikPersonBilikZoneMaxFields>;
  min?: Maybe<MemberBilikPersonBilikZoneMinFields>;
  stddev?: Maybe<MemberBilikPersonBilikZoneStddevFields>;
  stddevPop?: Maybe<MemberBilikPersonBilikZoneStddevPopFields>;
  stddevSamp?: Maybe<MemberBilikPersonBilikZoneStddevSampFields>;
  sum?: Maybe<MemberBilikPersonBilikZoneSumFields>;
  varPop?: Maybe<MemberBilikPersonBilikZoneVarPopFields>;
  varSamp?: Maybe<MemberBilikPersonBilikZoneVarSampFields>;
  variance?: Maybe<MemberBilikPersonBilikZoneVarianceFields>;
};


/** aggregate fields of "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MemberBilikPersonBilikZoneSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneAggregateOrderBy = {
  avg?: InputMaybe<MemberBilikPersonBilikZoneAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MemberBilikPersonBilikZoneMaxOrderBy>;
  min?: InputMaybe<MemberBilikPersonBilikZoneMinOrderBy>;
  stddev?: InputMaybe<MemberBilikPersonBilikZoneStddevOrderBy>;
  stddevPop?: InputMaybe<MemberBilikPersonBilikZoneStddevPopOrderBy>;
  stddevSamp?: InputMaybe<MemberBilikPersonBilikZoneStddevSampOrderBy>;
  sum?: InputMaybe<MemberBilikPersonBilikZoneSumOrderBy>;
  varPop?: InputMaybe<MemberBilikPersonBilikZoneVarPopOrderBy>;
  varSamp?: InputMaybe<MemberBilikPersonBilikZoneVarSampOrderBy>;
  variance?: InputMaybe<MemberBilikPersonBilikZoneVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneArrRelInsertInput = {
  data: Array<MemberBilikPersonBilikZoneInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MemberBilikPersonBilikZoneOnConflict>;
};

/** aggregate avg on columns */
export type MemberBilikPersonBilikZoneAvgFields = {
  __typename?: 'MemberBilikPersonBilikZoneAvgFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneAvgOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "member_bilik_person_bilik_zone". All fields are combined with a logical 'AND'. */
export type MemberBilikPersonBilikZoneBoolExp = {
  _and?: InputMaybe<Array<MemberBilikPersonBilikZoneBoolExp>>;
  _not?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
  _or?: InputMaybe<Array<MemberBilikPersonBilikZoneBoolExp>>;
  bilikPerson?: InputMaybe<BilikPersonBoolExp>;
  bilikPersonId?: InputMaybe<IntComparisonExp>;
  bilikZone?: InputMaybe<BilikZoneBoolExp>;
  bilikZoneId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "member_bilik_person_bilik_zone" */
export enum MemberBilikPersonBilikZoneConstraint {
  /** unique or primary key constraint on columns "bilik_person_id", "bilik_zone_id" */
  MemberBilikPersonBilikZonePkey = 'member_bilik_person_bilik_zone_pkey'
}

/** input type for incrementing numeric columns in table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneIncInput = {
  bilikPersonId?: InputMaybe<Scalars['Int']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneInsertInput = {
  bilikPerson?: InputMaybe<BilikPersonObjRelInsertInput>;
  bilikPersonId?: InputMaybe<Scalars['Int']>;
  bilikZone?: InputMaybe<BilikZoneObjRelInsertInput>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type MemberBilikPersonBilikZoneMaxFields = {
  __typename?: 'MemberBilikPersonBilikZoneMaxFields';
  bilikPersonId?: Maybe<Scalars['Int']>;
  bilikZoneId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneMaxOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MemberBilikPersonBilikZoneMinFields = {
  __typename?: 'MemberBilikPersonBilikZoneMinFields';
  bilikPersonId?: Maybe<Scalars['Int']>;
  bilikZoneId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneMinOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneMutationResponse = {
  __typename?: 'MemberBilikPersonBilikZoneMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MemberBilikPersonBilikZone>;
};

/** on_conflict condition type for table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneOnConflict = {
  constraint: MemberBilikPersonBilikZoneConstraint;
  updateColumns?: Array<MemberBilikPersonBilikZoneUpdateColumn>;
  where?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
};

/** Ordering options when selecting data from "member_bilik_person_bilik_zone". */
export type MemberBilikPersonBilikZoneOrderBy = {
  bilikPerson?: InputMaybe<BilikPersonOrderBy>;
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZone?: InputMaybe<BilikZoneOrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: member_bilik_person_bilik_zone */
export type MemberBilikPersonBilikZonePkColumnsInput = {
  bilikPersonId: Scalars['Int'];
  bilikZoneId: Scalars['Int'];
};

/** select columns of table "member_bilik_person_bilik_zone" */
export enum MemberBilikPersonBilikZoneSelectColumn {
  /** column name */
  BilikPersonId = 'bilikPersonId',
  /** column name */
  BilikZoneId = 'bilikZoneId'
}

/** input type for updating data in table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneSetInput = {
  bilikPersonId?: InputMaybe<Scalars['Int']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type MemberBilikPersonBilikZoneStddevFields = {
  __typename?: 'MemberBilikPersonBilikZoneStddevFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneStddevOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type MemberBilikPersonBilikZoneStddevPopFields = {
  __typename?: 'MemberBilikPersonBilikZoneStddevPopFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneStddevPopOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type MemberBilikPersonBilikZoneStddevSampFields = {
  __typename?: 'MemberBilikPersonBilikZoneStddevSampFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneStddevSampOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MemberBilikPersonBilikZoneStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MemberBilikPersonBilikZoneStreamCursorValueInput = {
  bilikPersonId?: InputMaybe<Scalars['Int']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type MemberBilikPersonBilikZoneSumFields = {
  __typename?: 'MemberBilikPersonBilikZoneSumFields';
  bilikPersonId?: Maybe<Scalars['Int']>;
  bilikZoneId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneSumOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** update columns of table "member_bilik_person_bilik_zone" */
export enum MemberBilikPersonBilikZoneUpdateColumn {
  /** column name */
  BilikPersonId = 'bilikPersonId',
  /** column name */
  BilikZoneId = 'bilikZoneId'
}

export type MemberBilikPersonBilikZoneUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MemberBilikPersonBilikZoneIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MemberBilikPersonBilikZoneSetInput>;
  /** filter the rows which have to be updated */
  where: MemberBilikPersonBilikZoneBoolExp;
};

/** aggregate varPop on columns */
export type MemberBilikPersonBilikZoneVarPopFields = {
  __typename?: 'MemberBilikPersonBilikZoneVarPopFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneVarPopOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type MemberBilikPersonBilikZoneVarSampFields = {
  __typename?: 'MemberBilikPersonBilikZoneVarSampFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneVarSampOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MemberBilikPersonBilikZoneVarianceFields = {
  __typename?: 'MemberBilikPersonBilikZoneVarianceFields';
  bilikPersonId?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "member_bilik_person_bilik_zone" */
export type MemberBilikPersonBilikZoneVarianceOrderBy = {
  bilikPersonId?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "name". All fields are combined with logical 'AND'. */
export type NameComparisonExp = {
  _eq?: InputMaybe<Scalars['name']>;
  _gt?: InputMaybe<Scalars['name']>;
  _gte?: InputMaybe<Scalars['name']>;
  _in?: InputMaybe<Array<Scalars['name']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['name']>;
  _lte?: InputMaybe<Scalars['name']>;
  _neq?: InputMaybe<Scalars['name']>;
  _nin?: InputMaybe<Array<Scalars['name']>>;
};

/** columns and relationships of "nearest_pro_view" */
export type NearestProView = {
  __typename?: 'NearestProView';
  distance: Scalars['Int'];
  /** An object relationship */
  proView?: Maybe<ProView>;
  proViewId: Scalars['Int'];
};

/** aggregated selection of "nearest_pro_view" */
export type NearestProViewAggregate = {
  __typename?: 'NearestProViewAggregate';
  aggregate?: Maybe<NearestProViewAggregateFields>;
  nodes: Array<NearestProView>;
};

/** aggregate fields of "nearest_pro_view" */
export type NearestProViewAggregateFields = {
  __typename?: 'NearestProViewAggregateFields';
  avg?: Maybe<NearestProViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<NearestProViewMaxFields>;
  min?: Maybe<NearestProViewMinFields>;
  stddev?: Maybe<NearestProViewStddevFields>;
  stddevPop?: Maybe<NearestProViewStddevPopFields>;
  stddevSamp?: Maybe<NearestProViewStddevSampFields>;
  sum?: Maybe<NearestProViewSumFields>;
  varPop?: Maybe<NearestProViewVarPopFields>;
  varSamp?: Maybe<NearestProViewVarSampFields>;
  variance?: Maybe<NearestProViewVarianceFields>;
};


/** aggregate fields of "nearest_pro_view" */
export type NearestProViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NearestProViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type NearestProViewAvgFields = {
  __typename?: 'NearestProViewAvgFields';
  distance?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nearest_pro_view". All fields are combined with a logical 'AND'. */
export type NearestProViewBoolExp = {
  _and?: InputMaybe<Array<NearestProViewBoolExp>>;
  _not?: InputMaybe<NearestProViewBoolExp>;
  _or?: InputMaybe<Array<NearestProViewBoolExp>>;
  distance?: InputMaybe<IntComparisonExp>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
};

/** input type for incrementing numeric columns in table "nearest_pro_view" */
export type NearestProViewIncInput = {
  distance?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "nearest_pro_view" */
export type NearestProViewInsertInput = {
  distance?: InputMaybe<Scalars['Int']>;
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type NearestProViewMaxFields = {
  __typename?: 'NearestProViewMaxFields';
  distance?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type NearestProViewMinFields = {
  __typename?: 'NearestProViewMinFields';
  distance?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "nearest_pro_view" */
export type NearestProViewMutationResponse = {
  __typename?: 'NearestProViewMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NearestProView>;
};

/** Ordering options when selecting data from "nearest_pro_view". */
export type NearestProViewOrderBy = {
  distance?: InputMaybe<OrderBy>;
  proView?: InputMaybe<ProViewOrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** select columns of table "nearest_pro_view" */
export enum NearestProViewSelectColumn {
  /** column name */
  Distance = 'distance',
  /** column name */
  ProViewId = 'proViewId'
}

/** input type for updating data in table "nearest_pro_view" */
export type NearestProViewSetInput = {
  distance?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type NearestProViewStddevFields = {
  __typename?: 'NearestProViewStddevFields';
  distance?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type NearestProViewStddevPopFields = {
  __typename?: 'NearestProViewStddevPopFields';
  distance?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type NearestProViewStddevSampFields = {
  __typename?: 'NearestProViewStddevSampFields';
  distance?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "nearest_pro_view" */
export type NearestProViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NearestProViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NearestProViewStreamCursorValueInput = {
  distance?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type NearestProViewSumFields = {
  __typename?: 'NearestProViewSumFields';
  distance?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

export type NearestProViewUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NearestProViewIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NearestProViewSetInput>;
  /** filter the rows which have to be updated */
  where: NearestProViewBoolExp;
};

/** aggregate varPop on columns */
export type NearestProViewVarPopFields = {
  __typename?: 'NearestProViewVarPopFields';
  distance?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type NearestProViewVarSampFields = {
  __typename?: 'NearestProViewVarSampFields';
  distance?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type NearestProViewVarianceFields = {
  __typename?: 'NearestProViewVarianceFields';
  distance?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "nextval" */
export type Nextval = {
  __typename?: 'Nextval';
  id: Scalars['Int'];
};

/** aggregated selection of "nextval" */
export type NextvalAggregate = {
  __typename?: 'NextvalAggregate';
  aggregate?: Maybe<NextvalAggregateFields>;
  nodes: Array<Nextval>;
};

/** aggregate fields of "nextval" */
export type NextvalAggregateFields = {
  __typename?: 'NextvalAggregateFields';
  avg?: Maybe<NextvalAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<NextvalMaxFields>;
  min?: Maybe<NextvalMinFields>;
  stddev?: Maybe<NextvalStddevFields>;
  stddevPop?: Maybe<NextvalStddevPopFields>;
  stddevSamp?: Maybe<NextvalStddevSampFields>;
  sum?: Maybe<NextvalSumFields>;
  varPop?: Maybe<NextvalVarPopFields>;
  varSamp?: Maybe<NextvalVarSampFields>;
  variance?: Maybe<NextvalVarianceFields>;
};


/** aggregate fields of "nextval" */
export type NextvalAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NextvalSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type NextvalAvgFields = {
  __typename?: 'NextvalAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nextval". All fields are combined with a logical 'AND'. */
export type NextvalBoolExp = {
  _and?: InputMaybe<Array<NextvalBoolExp>>;
  _not?: InputMaybe<NextvalBoolExp>;
  _or?: InputMaybe<Array<NextvalBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
};

/** input type for incrementing numeric columns in table "nextval" */
export type NextvalIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "nextval" */
export type NextvalInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type NextvalMaxFields = {
  __typename?: 'NextvalMaxFields';
  id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type NextvalMinFields = {
  __typename?: 'NextvalMinFields';
  id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "nextval" */
export type NextvalMutationResponse = {
  __typename?: 'NextvalMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nextval>;
};

/** Ordering options when selecting data from "nextval". */
export type NextvalOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** select columns of table "nextval" */
export enum NextvalSelectColumn {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "nextval" */
export type NextvalSetInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type NextvalStddevFields = {
  __typename?: 'NextvalStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type NextvalStddevPopFields = {
  __typename?: 'NextvalStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type NextvalStddevSampFields = {
  __typename?: 'NextvalStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "nextval" */
export type NextvalStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NextvalStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NextvalStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type NextvalSumFields = {
  __typename?: 'NextvalSumFields';
  id?: Maybe<Scalars['Int']>;
};

export type NextvalUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NextvalIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NextvalSetInput>;
  /** filter the rows which have to be updated */
  where: NextvalBoolExp;
};

/** aggregate varPop on columns */
export type NextvalVarPopFields = {
  __typename?: 'NextvalVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type NextvalVarSampFields = {
  __typename?: 'NextvalVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type NextvalVarianceFields = {
  __typename?: 'NextvalVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "note_identity" */
export type NoteIdentity = {
  __typename?: 'NoteIdentity';
  /** An object relationship */
  bilikPerson: BilikPerson;
  id: Scalars['Int'];
  identifier: Scalars['String'];
  lastEditorId: Scalars['Int'];
  lastUpdatedDate: Scalars['timestamptz'];
  message: Scalars['String'];
};

/** aggregated selection of "note_identity" */
export type NoteIdentityAggregate = {
  __typename?: 'NoteIdentityAggregate';
  aggregate?: Maybe<NoteIdentityAggregateFields>;
  nodes: Array<NoteIdentity>;
};

export type NoteIdentityAggregateBoolExp = {
  count?: InputMaybe<NoteIdentityAggregateBoolExpCount>;
};

/** aggregate fields of "note_identity" */
export type NoteIdentityAggregateFields = {
  __typename?: 'NoteIdentityAggregateFields';
  avg?: Maybe<NoteIdentityAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<NoteIdentityMaxFields>;
  min?: Maybe<NoteIdentityMinFields>;
  stddev?: Maybe<NoteIdentityStddevFields>;
  stddevPop?: Maybe<NoteIdentityStddevPopFields>;
  stddevSamp?: Maybe<NoteIdentityStddevSampFields>;
  sum?: Maybe<NoteIdentitySumFields>;
  varPop?: Maybe<NoteIdentityVarPopFields>;
  varSamp?: Maybe<NoteIdentityVarSampFields>;
  variance?: Maybe<NoteIdentityVarianceFields>;
};


/** aggregate fields of "note_identity" */
export type NoteIdentityAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NoteIdentitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "note_identity" */
export type NoteIdentityAggregateOrderBy = {
  avg?: InputMaybe<NoteIdentityAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<NoteIdentityMaxOrderBy>;
  min?: InputMaybe<NoteIdentityMinOrderBy>;
  stddev?: InputMaybe<NoteIdentityStddevOrderBy>;
  stddevPop?: InputMaybe<NoteIdentityStddevPopOrderBy>;
  stddevSamp?: InputMaybe<NoteIdentityStddevSampOrderBy>;
  sum?: InputMaybe<NoteIdentitySumOrderBy>;
  varPop?: InputMaybe<NoteIdentityVarPopOrderBy>;
  varSamp?: InputMaybe<NoteIdentityVarSampOrderBy>;
  variance?: InputMaybe<NoteIdentityVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "note_identity" */
export type NoteIdentityArrRelInsertInput = {
  data: Array<NoteIdentityInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<NoteIdentityOnConflict>;
};

/** aggregate avg on columns */
export type NoteIdentityAvgFields = {
  __typename?: 'NoteIdentityAvgFields';
  id?: Maybe<Scalars['Float']>;
  lastEditorId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "note_identity" */
export type NoteIdentityAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  lastEditorId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "note_identity". All fields are combined with a logical 'AND'. */
export type NoteIdentityBoolExp = {
  _and?: InputMaybe<Array<NoteIdentityBoolExp>>;
  _not?: InputMaybe<NoteIdentityBoolExp>;
  _or?: InputMaybe<Array<NoteIdentityBoolExp>>;
  bilikPerson?: InputMaybe<BilikPersonBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  identifier?: InputMaybe<StringComparisonExp>;
  lastEditorId?: InputMaybe<IntComparisonExp>;
  lastUpdatedDate?: InputMaybe<TimestamptzComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "note_identity" */
export enum NoteIdentityConstraint {
  /** unique or primary key constraint on columns "identifier" */
  NoteIdentityIdentifierKey = 'note_identity_identifier_key',
  /** unique or primary key constraint on columns "id" */
  NoteIdentityPkey = 'note_identity_pkey'
}

/** input type for incrementing numeric columns in table "note_identity" */
export type NoteIdentityIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  lastEditorId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "note_identity" */
export type NoteIdentityInsertInput = {
  bilikPerson?: InputMaybe<BilikPersonObjRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  lastEditorId?: InputMaybe<Scalars['Int']>;
  lastUpdatedDate?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type NoteIdentityMaxFields = {
  __typename?: 'NoteIdentityMaxFields';
  id?: Maybe<Scalars['Int']>;
  identifier?: Maybe<Scalars['String']>;
  lastEditorId?: Maybe<Scalars['Int']>;
  lastUpdatedDate?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "note_identity" */
export type NoteIdentityMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  identifier?: InputMaybe<OrderBy>;
  lastEditorId?: InputMaybe<OrderBy>;
  lastUpdatedDate?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type NoteIdentityMinFields = {
  __typename?: 'NoteIdentityMinFields';
  id?: Maybe<Scalars['Int']>;
  identifier?: Maybe<Scalars['String']>;
  lastEditorId?: Maybe<Scalars['Int']>;
  lastUpdatedDate?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "note_identity" */
export type NoteIdentityMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  identifier?: InputMaybe<OrderBy>;
  lastEditorId?: InputMaybe<OrderBy>;
  lastUpdatedDate?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "note_identity" */
export type NoteIdentityMutationResponse = {
  __typename?: 'NoteIdentityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NoteIdentity>;
};

/** on_conflict condition type for table "note_identity" */
export type NoteIdentityOnConflict = {
  constraint: NoteIdentityConstraint;
  updateColumns?: Array<NoteIdentityUpdateColumn>;
  where?: InputMaybe<NoteIdentityBoolExp>;
};

/** Ordering options when selecting data from "note_identity". */
export type NoteIdentityOrderBy = {
  bilikPerson?: InputMaybe<BilikPersonOrderBy>;
  id?: InputMaybe<OrderBy>;
  identifier?: InputMaybe<OrderBy>;
  lastEditorId?: InputMaybe<OrderBy>;
  lastUpdatedDate?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: note_identity */
export type NoteIdentityPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "note_identity" */
export enum NoteIdentitySelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  LastEditorId = 'lastEditorId',
  /** column name */
  LastUpdatedDate = 'lastUpdatedDate',
  /** column name */
  Message = 'message'
}

/** input type for updating data in table "note_identity" */
export type NoteIdentitySetInput = {
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  lastEditorId?: InputMaybe<Scalars['Int']>;
  lastUpdatedDate?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type NoteIdentityStddevFields = {
  __typename?: 'NoteIdentityStddevFields';
  id?: Maybe<Scalars['Float']>;
  lastEditorId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "note_identity" */
export type NoteIdentityStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  lastEditorId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type NoteIdentityStddevPopFields = {
  __typename?: 'NoteIdentityStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  lastEditorId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "note_identity" */
export type NoteIdentityStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  lastEditorId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type NoteIdentityStddevSampFields = {
  __typename?: 'NoteIdentityStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  lastEditorId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "note_identity" */
export type NoteIdentityStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  lastEditorId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "note_identity" */
export type NoteIdentityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NoteIdentityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NoteIdentityStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  lastEditorId?: InputMaybe<Scalars['Int']>;
  lastUpdatedDate?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type NoteIdentitySumFields = {
  __typename?: 'NoteIdentitySumFields';
  id?: Maybe<Scalars['Int']>;
  lastEditorId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "note_identity" */
export type NoteIdentitySumOrderBy = {
  id?: InputMaybe<OrderBy>;
  lastEditorId?: InputMaybe<OrderBy>;
};

/** update columns of table "note_identity" */
export enum NoteIdentityUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  LastEditorId = 'lastEditorId',
  /** column name */
  LastUpdatedDate = 'lastUpdatedDate',
  /** column name */
  Message = 'message'
}

export type NoteIdentityUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NoteIdentityIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NoteIdentitySetInput>;
  /** filter the rows which have to be updated */
  where: NoteIdentityBoolExp;
};

/** aggregate varPop on columns */
export type NoteIdentityVarPopFields = {
  __typename?: 'NoteIdentityVarPopFields';
  id?: Maybe<Scalars['Float']>;
  lastEditorId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "note_identity" */
export type NoteIdentityVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  lastEditorId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type NoteIdentityVarSampFields = {
  __typename?: 'NoteIdentityVarSampFields';
  id?: Maybe<Scalars['Float']>;
  lastEditorId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "note_identity" */
export type NoteIdentityVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  lastEditorId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type NoteIdentityVarianceFields = {
  __typename?: 'NoteIdentityVarianceFields';
  id?: Maybe<Scalars['Float']>;
  lastEditorId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "note_identity" */
export type NoteIdentityVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  lastEditorId?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  Asc = 'ASC',
  /** in ascending order, nulls first */
  AscNullsFirst = 'ASC_NULLS_FIRST',
  /** in ascending order, nulls last */
  AscNullsLast = 'ASC_NULLS_LAST',
  /** in descending order, nulls first */
  Desc = 'DESC',
  /** in descending order, nulls first */
  DescNullsFirst = 'DESC_NULLS_FIRST',
  /** in descending order, nulls last */
  DescNullsLast = 'DESC_NULLS_LAST'
}

/** columns and relationships of "pennylane_company_mapping" */
export type PennylaneCompanyMapping = {
  __typename?: 'PennylaneCompanyMapping';
  billingIssuerId: Scalars['Int'];
  companyId: Scalars['Int'];
  pennylaneCompanyCustomerId: Scalars['bigint'];
};

/** aggregated selection of "pennylane_company_mapping" */
export type PennylaneCompanyMappingAggregate = {
  __typename?: 'PennylaneCompanyMappingAggregate';
  aggregate?: Maybe<PennylaneCompanyMappingAggregateFields>;
  nodes: Array<PennylaneCompanyMapping>;
};

/** aggregate fields of "pennylane_company_mapping" */
export type PennylaneCompanyMappingAggregateFields = {
  __typename?: 'PennylaneCompanyMappingAggregateFields';
  avg?: Maybe<PennylaneCompanyMappingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PennylaneCompanyMappingMaxFields>;
  min?: Maybe<PennylaneCompanyMappingMinFields>;
  stddev?: Maybe<PennylaneCompanyMappingStddevFields>;
  stddevPop?: Maybe<PennylaneCompanyMappingStddevPopFields>;
  stddevSamp?: Maybe<PennylaneCompanyMappingStddevSampFields>;
  sum?: Maybe<PennylaneCompanyMappingSumFields>;
  varPop?: Maybe<PennylaneCompanyMappingVarPopFields>;
  varSamp?: Maybe<PennylaneCompanyMappingVarSampFields>;
  variance?: Maybe<PennylaneCompanyMappingVarianceFields>;
};


/** aggregate fields of "pennylane_company_mapping" */
export type PennylaneCompanyMappingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PennylaneCompanyMappingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PennylaneCompanyMappingAvgFields = {
  __typename?: 'PennylaneCompanyMappingAvgFields';
  billingIssuerId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  pennylaneCompanyCustomerId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pennylane_company_mapping". All fields are combined with a logical 'AND'. */
export type PennylaneCompanyMappingBoolExp = {
  _and?: InputMaybe<Array<PennylaneCompanyMappingBoolExp>>;
  _not?: InputMaybe<PennylaneCompanyMappingBoolExp>;
  _or?: InputMaybe<Array<PennylaneCompanyMappingBoolExp>>;
  billingIssuerId?: InputMaybe<IntComparisonExp>;
  companyId?: InputMaybe<IntComparisonExp>;
  pennylaneCompanyCustomerId?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "pennylane_company_mapping" */
export enum PennylaneCompanyMappingConstraint {
  /** unique or primary key constraint on columns "billing_issuer_id", "pennylane_company_customer_id" */
  PennylaneCompanyMappingBillingIssuerIdPennylaneCompanyC = 'pennylane_company_mapping_billing_issuer_id_pennylane_company_c',
  /** unique or primary key constraint on columns "billing_issuer_id", "company_id" */
  PennylaneCompanyMappingPkey = 'pennylane_company_mapping_pkey'
}

/** input type for incrementing numeric columns in table "pennylane_company_mapping" */
export type PennylaneCompanyMappingIncInput = {
  billingIssuerId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  pennylaneCompanyCustomerId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pennylane_company_mapping" */
export type PennylaneCompanyMappingInsertInput = {
  billingIssuerId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  pennylaneCompanyCustomerId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type PennylaneCompanyMappingMaxFields = {
  __typename?: 'PennylaneCompanyMappingMaxFields';
  billingIssuerId?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  pennylaneCompanyCustomerId?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type PennylaneCompanyMappingMinFields = {
  __typename?: 'PennylaneCompanyMappingMinFields';
  billingIssuerId?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  pennylaneCompanyCustomerId?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "pennylane_company_mapping" */
export type PennylaneCompanyMappingMutationResponse = {
  __typename?: 'PennylaneCompanyMappingMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PennylaneCompanyMapping>;
};

/** on_conflict condition type for table "pennylane_company_mapping" */
export type PennylaneCompanyMappingOnConflict = {
  constraint: PennylaneCompanyMappingConstraint;
  updateColumns?: Array<PennylaneCompanyMappingUpdateColumn>;
  where?: InputMaybe<PennylaneCompanyMappingBoolExp>;
};

/** Ordering options when selecting data from "pennylane_company_mapping". */
export type PennylaneCompanyMappingOrderBy = {
  billingIssuerId?: InputMaybe<OrderBy>;
  companyId?: InputMaybe<OrderBy>;
  pennylaneCompanyCustomerId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pennylane_company_mapping */
export type PennylaneCompanyMappingPkColumnsInput = {
  billingIssuerId: Scalars['Int'];
  companyId: Scalars['Int'];
};

/** select columns of table "pennylane_company_mapping" */
export enum PennylaneCompanyMappingSelectColumn {
  /** column name */
  BillingIssuerId = 'billingIssuerId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  PennylaneCompanyCustomerId = 'pennylaneCompanyCustomerId'
}

/** input type for updating data in table "pennylane_company_mapping" */
export type PennylaneCompanyMappingSetInput = {
  billingIssuerId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  pennylaneCompanyCustomerId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type PennylaneCompanyMappingStddevFields = {
  __typename?: 'PennylaneCompanyMappingStddevFields';
  billingIssuerId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  pennylaneCompanyCustomerId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PennylaneCompanyMappingStddevPopFields = {
  __typename?: 'PennylaneCompanyMappingStddevPopFields';
  billingIssuerId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  pennylaneCompanyCustomerId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PennylaneCompanyMappingStddevSampFields = {
  __typename?: 'PennylaneCompanyMappingStddevSampFields';
  billingIssuerId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  pennylaneCompanyCustomerId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pennylane_company_mapping" */
export type PennylaneCompanyMappingStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PennylaneCompanyMappingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PennylaneCompanyMappingStreamCursorValueInput = {
  billingIssuerId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  pennylaneCompanyCustomerId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type PennylaneCompanyMappingSumFields = {
  __typename?: 'PennylaneCompanyMappingSumFields';
  billingIssuerId?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  pennylaneCompanyCustomerId?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pennylane_company_mapping" */
export enum PennylaneCompanyMappingUpdateColumn {
  /** column name */
  BillingIssuerId = 'billingIssuerId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  PennylaneCompanyCustomerId = 'pennylaneCompanyCustomerId'
}

export type PennylaneCompanyMappingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PennylaneCompanyMappingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PennylaneCompanyMappingSetInput>;
  /** filter the rows which have to be updated */
  where: PennylaneCompanyMappingBoolExp;
};

/** aggregate varPop on columns */
export type PennylaneCompanyMappingVarPopFields = {
  __typename?: 'PennylaneCompanyMappingVarPopFields';
  billingIssuerId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  pennylaneCompanyCustomerId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PennylaneCompanyMappingVarSampFields = {
  __typename?: 'PennylaneCompanyMappingVarSampFields';
  billingIssuerId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  pennylaneCompanyCustomerId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PennylaneCompanyMappingVarianceFields = {
  __typename?: 'PennylaneCompanyMappingVarianceFields';
  billingIssuerId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  pennylaneCompanyCustomerId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "phone_number" */
export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  dateReleased?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  number: Scalars['String'];
  /** An object relationship */
  proView: ProView;
  proViewId: Scalars['Int'];
  tag: Scalars['String'];
};

/** aggregated selection of "phone_number" */
export type PhoneNumberAggregate = {
  __typename?: 'PhoneNumberAggregate';
  aggregate?: Maybe<PhoneNumberAggregateFields>;
  nodes: Array<PhoneNumber>;
};

export type PhoneNumberAggregateBoolExp = {
  count?: InputMaybe<PhoneNumberAggregateBoolExpCount>;
};

/** aggregate fields of "phone_number" */
export type PhoneNumberAggregateFields = {
  __typename?: 'PhoneNumberAggregateFields';
  avg?: Maybe<PhoneNumberAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PhoneNumberMaxFields>;
  min?: Maybe<PhoneNumberMinFields>;
  stddev?: Maybe<PhoneNumberStddevFields>;
  stddevPop?: Maybe<PhoneNumberStddevPopFields>;
  stddevSamp?: Maybe<PhoneNumberStddevSampFields>;
  sum?: Maybe<PhoneNumberSumFields>;
  varPop?: Maybe<PhoneNumberVarPopFields>;
  varSamp?: Maybe<PhoneNumberVarSampFields>;
  variance?: Maybe<PhoneNumberVarianceFields>;
};


/** aggregate fields of "phone_number" */
export type PhoneNumberAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "phone_number" */
export type PhoneNumberAggregateOrderBy = {
  avg?: InputMaybe<PhoneNumberAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PhoneNumberMaxOrderBy>;
  min?: InputMaybe<PhoneNumberMinOrderBy>;
  stddev?: InputMaybe<PhoneNumberStddevOrderBy>;
  stddevPop?: InputMaybe<PhoneNumberStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PhoneNumberStddevSampOrderBy>;
  sum?: InputMaybe<PhoneNumberSumOrderBy>;
  varPop?: InputMaybe<PhoneNumberVarPopOrderBy>;
  varSamp?: InputMaybe<PhoneNumberVarSampOrderBy>;
  variance?: InputMaybe<PhoneNumberVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "phone_number" */
export type PhoneNumberArrRelInsertInput = {
  data: Array<PhoneNumberInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PhoneNumberOnConflict>;
};

/** aggregate avg on columns */
export type PhoneNumberAvgFields = {
  __typename?: 'PhoneNumberAvgFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "phone_number" */
export type PhoneNumberAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "phone_number". All fields are combined with a logical 'AND'. */
export type PhoneNumberBoolExp = {
  _and?: InputMaybe<Array<PhoneNumberBoolExp>>;
  _not?: InputMaybe<PhoneNumberBoolExp>;
  _or?: InputMaybe<Array<PhoneNumberBoolExp>>;
  dateReleased?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  number?: InputMaybe<StringComparisonExp>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
  tag?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "phone_number" */
export enum PhoneNumberConstraint {
  /** unique or primary key constraint on columns "id" */
  PhoneNumberPkey = 'phone_number_pkey',
  /** unique or primary key constraint on columns "tag", "pro_view_id", "number" */
  PhoneNumberUniquePerPro = 'phone_number_unique_per_pro'
}

/** input type for incrementing numeric columns in table "phone_number" */
export type PhoneNumberIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "phone_number" */
export type PhoneNumberInsertInput = {
  dateReleased?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewId?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PhoneNumberMaxFields = {
  __typename?: 'PhoneNumberMaxFields';
  dateReleased?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  proViewId?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "phone_number" */
export type PhoneNumberMaxOrderBy = {
  dateReleased?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  tag?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PhoneNumberMinFields = {
  __typename?: 'PhoneNumberMinFields';
  dateReleased?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  proViewId?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "phone_number" */
export type PhoneNumberMinOrderBy = {
  dateReleased?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  tag?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "phone_number" */
export type PhoneNumberMutationResponse = {
  __typename?: 'PhoneNumberMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PhoneNumber>;
};

/** on_conflict condition type for table "phone_number" */
export type PhoneNumberOnConflict = {
  constraint: PhoneNumberConstraint;
  updateColumns?: Array<PhoneNumberUpdateColumn>;
  where?: InputMaybe<PhoneNumberBoolExp>;
};

/** Ordering options when selecting data from "phone_number". */
export type PhoneNumberOrderBy = {
  dateReleased?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  proView?: InputMaybe<ProViewOrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  tag?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: phone_number */
export type PhoneNumberPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "phone_number" */
export enum PhoneNumberSelectColumn {
  /** column name */
  DateReleased = 'dateReleased',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  Tag = 'tag'
}

/** input type for updating data in table "phone_number" */
export type PhoneNumberSetInput = {
  dateReleased?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type PhoneNumberStddevFields = {
  __typename?: 'PhoneNumberStddevFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "phone_number" */
export type PhoneNumberStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PhoneNumberStddevPopFields = {
  __typename?: 'PhoneNumberStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "phone_number" */
export type PhoneNumberStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PhoneNumberStddevSampFields = {
  __typename?: 'PhoneNumberStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "phone_number" */
export type PhoneNumberStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "phone_number" */
export type PhoneNumberStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PhoneNumberStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PhoneNumberStreamCursorValueInput = {
  dateReleased?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type PhoneNumberSumFields = {
  __typename?: 'PhoneNumberSumFields';
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "phone_number" */
export type PhoneNumberSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** update columns of table "phone_number" */
export enum PhoneNumberUpdateColumn {
  /** column name */
  DateReleased = 'dateReleased',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  Tag = 'tag'
}

export type PhoneNumberUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PhoneNumberIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PhoneNumberSetInput>;
  /** filter the rows which have to be updated */
  where: PhoneNumberBoolExp;
};

/** aggregate varPop on columns */
export type PhoneNumberVarPopFields = {
  __typename?: 'PhoneNumberVarPopFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "phone_number" */
export type PhoneNumberVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PhoneNumberVarSampFields = {
  __typename?: 'PhoneNumberVarSampFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "phone_number" */
export type PhoneNumberVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PhoneNumberVarianceFields = {
  __typename?: 'PhoneNumberVarianceFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "phone_number" */
export type PhoneNumberVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "private_individual" */
export type PrivateIndividual = {
  __typename?: 'PrivateIndividual';
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
};

/** aggregated selection of "private_individual" */
export type PrivateIndividualAggregate = {
  __typename?: 'PrivateIndividualAggregate';
  aggregate?: Maybe<PrivateIndividualAggregateFields>;
  nodes: Array<PrivateIndividual>;
};

/** aggregate fields of "private_individual" */
export type PrivateIndividualAggregateFields = {
  __typename?: 'PrivateIndividualAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PrivateIndividualMaxFields>;
  min?: Maybe<PrivateIndividualMinFields>;
};


/** aggregate fields of "private_individual" */
export type PrivateIndividualAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PrivateIndividualSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "private_individual". All fields are combined with a logical 'AND'. */
export type PrivateIndividualBoolExp = {
  _and?: InputMaybe<Array<PrivateIndividualBoolExp>>;
  _not?: InputMaybe<PrivateIndividualBoolExp>;
  _or?: InputMaybe<Array<PrivateIndividualBoolExp>>;
  email?: InputMaybe<StringComparisonExp>;
  familyName?: InputMaybe<StringComparisonExp>;
  givenName?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type PrivateIndividualMaxFields = {
  __typename?: 'PrivateIndividualMaxFields';
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PrivateIndividualMinFields = {
  __typename?: 'PrivateIndividualMinFields';
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "private_individual". */
export type PrivateIndividualOrderBy = {
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
};

/** select columns of table "private_individual" */
export enum PrivateIndividualSelectColumn {
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName'
}

/** Streaming cursor of the table "private_individual" */
export type PrivateIndividualStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PrivateIndividualStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PrivateIndividualStreamCursorValueInput = {
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "pro_certification" */
export type ProCertification = {
  __typename?: 'ProCertification';
  /** An object relationship */
  certification: Certification;
  certificationId: Scalars['Int'];
  /** An object relationship */
  proPresentation: ProPresentation;
  proPresentationId: Scalars['Int'];
};

/** aggregated selection of "pro_certification" */
export type ProCertificationAggregate = {
  __typename?: 'ProCertificationAggregate';
  aggregate?: Maybe<ProCertificationAggregateFields>;
  nodes: Array<ProCertification>;
};

export type ProCertificationAggregateBoolExp = {
  count?: InputMaybe<ProCertificationAggregateBoolExpCount>;
};

/** aggregate fields of "pro_certification" */
export type ProCertificationAggregateFields = {
  __typename?: 'ProCertificationAggregateFields';
  avg?: Maybe<ProCertificationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProCertificationMaxFields>;
  min?: Maybe<ProCertificationMinFields>;
  stddev?: Maybe<ProCertificationStddevFields>;
  stddevPop?: Maybe<ProCertificationStddevPopFields>;
  stddevSamp?: Maybe<ProCertificationStddevSampFields>;
  sum?: Maybe<ProCertificationSumFields>;
  varPop?: Maybe<ProCertificationVarPopFields>;
  varSamp?: Maybe<ProCertificationVarSampFields>;
  variance?: Maybe<ProCertificationVarianceFields>;
};


/** aggregate fields of "pro_certification" */
export type ProCertificationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProCertificationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_certification" */
export type ProCertificationAggregateOrderBy = {
  avg?: InputMaybe<ProCertificationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProCertificationMaxOrderBy>;
  min?: InputMaybe<ProCertificationMinOrderBy>;
  stddev?: InputMaybe<ProCertificationStddevOrderBy>;
  stddevPop?: InputMaybe<ProCertificationStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProCertificationStddevSampOrderBy>;
  sum?: InputMaybe<ProCertificationSumOrderBy>;
  varPop?: InputMaybe<ProCertificationVarPopOrderBy>;
  varSamp?: InputMaybe<ProCertificationVarSampOrderBy>;
  variance?: InputMaybe<ProCertificationVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pro_certification" */
export type ProCertificationArrRelInsertInput = {
  data: Array<ProCertificationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProCertificationOnConflict>;
};

/** aggregate avg on columns */
export type ProCertificationAvgFields = {
  __typename?: 'ProCertificationAvgFields';
  certificationId?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pro_certification" */
export type ProCertificationAvgOrderBy = {
  certificationId?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_certification". All fields are combined with a logical 'AND'. */
export type ProCertificationBoolExp = {
  _and?: InputMaybe<Array<ProCertificationBoolExp>>;
  _not?: InputMaybe<ProCertificationBoolExp>;
  _or?: InputMaybe<Array<ProCertificationBoolExp>>;
  certification?: InputMaybe<CertificationBoolExp>;
  certificationId?: InputMaybe<IntComparisonExp>;
  proPresentation?: InputMaybe<ProPresentationBoolExp>;
  proPresentationId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "pro_certification" */
export enum ProCertificationConstraint {
  /** unique or primary key constraint on columns "pro_presentation_id", "certification_id" */
  ProCertificationPkey = 'pro_certification_pkey'
}

/** input type for incrementing numeric columns in table "pro_certification" */
export type ProCertificationIncInput = {
  certificationId?: InputMaybe<Scalars['Int']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_certification" */
export type ProCertificationInsertInput = {
  certification?: InputMaybe<CertificationObjRelInsertInput>;
  certificationId?: InputMaybe<Scalars['Int']>;
  proPresentation?: InputMaybe<ProPresentationObjRelInsertInput>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ProCertificationMaxFields = {
  __typename?: 'ProCertificationMaxFields';
  certificationId?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "pro_certification" */
export type ProCertificationMaxOrderBy = {
  certificationId?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProCertificationMinFields = {
  __typename?: 'ProCertificationMinFields';
  certificationId?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "pro_certification" */
export type ProCertificationMinOrderBy = {
  certificationId?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_certification" */
export type ProCertificationMutationResponse = {
  __typename?: 'ProCertificationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProCertification>;
};

/** on_conflict condition type for table "pro_certification" */
export type ProCertificationOnConflict = {
  constraint: ProCertificationConstraint;
  updateColumns?: Array<ProCertificationUpdateColumn>;
  where?: InputMaybe<ProCertificationBoolExp>;
};

/** Ordering options when selecting data from "pro_certification". */
export type ProCertificationOrderBy = {
  certification?: InputMaybe<CertificationOrderBy>;
  certificationId?: InputMaybe<OrderBy>;
  proPresentation?: InputMaybe<ProPresentationOrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_certification */
export type ProCertificationPkColumnsInput = {
  certificationId: Scalars['Int'];
  proPresentationId: Scalars['Int'];
};

/** select columns of table "pro_certification" */
export enum ProCertificationSelectColumn {
  /** column name */
  CertificationId = 'certificationId',
  /** column name */
  ProPresentationId = 'proPresentationId'
}

/** input type for updating data in table "pro_certification" */
export type ProCertificationSetInput = {
  certificationId?: InputMaybe<Scalars['Int']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ProCertificationStddevFields = {
  __typename?: 'ProCertificationStddevFields';
  certificationId?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pro_certification" */
export type ProCertificationStddevOrderBy = {
  certificationId?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProCertificationStddevPopFields = {
  __typename?: 'ProCertificationStddevPopFields';
  certificationId?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pro_certification" */
export type ProCertificationStddevPopOrderBy = {
  certificationId?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProCertificationStddevSampFields = {
  __typename?: 'ProCertificationStddevSampFields';
  certificationId?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pro_certification" */
export type ProCertificationStddevSampOrderBy = {
  certificationId?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_certification" */
export type ProCertificationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProCertificationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProCertificationStreamCursorValueInput = {
  certificationId?: InputMaybe<Scalars['Int']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ProCertificationSumFields = {
  __typename?: 'ProCertificationSumFields';
  certificationId?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pro_certification" */
export type ProCertificationSumOrderBy = {
  certificationId?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_certification" */
export enum ProCertificationUpdateColumn {
  /** column name */
  CertificationId = 'certificationId',
  /** column name */
  ProPresentationId = 'proPresentationId'
}

export type ProCertificationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProCertificationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProCertificationSetInput>;
  /** filter the rows which have to be updated */
  where: ProCertificationBoolExp;
};

/** aggregate varPop on columns */
export type ProCertificationVarPopFields = {
  __typename?: 'ProCertificationVarPopFields';
  certificationId?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pro_certification" */
export type ProCertificationVarPopOrderBy = {
  certificationId?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProCertificationVarSampFields = {
  __typename?: 'ProCertificationVarSampFields';
  certificationId?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pro_certification" */
export type ProCertificationVarSampOrderBy = {
  certificationId?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProCertificationVarianceFields = {
  __typename?: 'ProCertificationVarianceFields';
  certificationId?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pro_certification" */
export type ProCertificationVarianceOrderBy = {
  certificationId?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "pro_holiday" */
export type ProHoliday = {
  __typename?: 'ProHoliday';
  endDate: Scalars['date'];
  id: Scalars['Int'];
  /** An object relationship */
  proView: ProView;
  proViewId: Scalars['Int'];
  startDate: Scalars['date'];
};

/** aggregated selection of "pro_holiday" */
export type ProHolidayAggregate = {
  __typename?: 'ProHolidayAggregate';
  aggregate?: Maybe<ProHolidayAggregateFields>;
  nodes: Array<ProHoliday>;
};

export type ProHolidayAggregateBoolExp = {
  count?: InputMaybe<ProHolidayAggregateBoolExpCount>;
};

/** aggregate fields of "pro_holiday" */
export type ProHolidayAggregateFields = {
  __typename?: 'ProHolidayAggregateFields';
  avg?: Maybe<ProHolidayAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProHolidayMaxFields>;
  min?: Maybe<ProHolidayMinFields>;
  stddev?: Maybe<ProHolidayStddevFields>;
  stddevPop?: Maybe<ProHolidayStddevPopFields>;
  stddevSamp?: Maybe<ProHolidayStddevSampFields>;
  sum?: Maybe<ProHolidaySumFields>;
  varPop?: Maybe<ProHolidayVarPopFields>;
  varSamp?: Maybe<ProHolidayVarSampFields>;
  variance?: Maybe<ProHolidayVarianceFields>;
};


/** aggregate fields of "pro_holiday" */
export type ProHolidayAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProHolidaySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_holiday" */
export type ProHolidayAggregateOrderBy = {
  avg?: InputMaybe<ProHolidayAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProHolidayMaxOrderBy>;
  min?: InputMaybe<ProHolidayMinOrderBy>;
  stddev?: InputMaybe<ProHolidayStddevOrderBy>;
  stddevPop?: InputMaybe<ProHolidayStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProHolidayStddevSampOrderBy>;
  sum?: InputMaybe<ProHolidaySumOrderBy>;
  varPop?: InputMaybe<ProHolidayVarPopOrderBy>;
  varSamp?: InputMaybe<ProHolidayVarSampOrderBy>;
  variance?: InputMaybe<ProHolidayVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pro_holiday" */
export type ProHolidayArrRelInsertInput = {
  data: Array<ProHolidayInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProHolidayOnConflict>;
};

/** aggregate avg on columns */
export type ProHolidayAvgFields = {
  __typename?: 'ProHolidayAvgFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pro_holiday" */
export type ProHolidayAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_holiday". All fields are combined with a logical 'AND'. */
export type ProHolidayBoolExp = {
  _and?: InputMaybe<Array<ProHolidayBoolExp>>;
  _not?: InputMaybe<ProHolidayBoolExp>;
  _or?: InputMaybe<Array<ProHolidayBoolExp>>;
  endDate?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
  startDate?: InputMaybe<DateComparisonExp>;
};

/** unique or primary key constraints on table "pro_holiday" */
export enum ProHolidayConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22906Primary = 'idx_22906_primary'
}

/** input type for incrementing numeric columns in table "pro_holiday" */
export type ProHolidayIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_holiday" */
export type ProHolidayInsertInput = {
  endDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['date']>;
};

/** aggregate max on columns */
export type ProHolidayMaxFields = {
  __typename?: 'ProHolidayMaxFields';
  endDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "pro_holiday" */
export type ProHolidayMaxOrderBy = {
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProHolidayMinFields = {
  __typename?: 'ProHolidayMinFields';
  endDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "pro_holiday" */
export type ProHolidayMinOrderBy = {
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_holiday" */
export type ProHolidayMutationResponse = {
  __typename?: 'ProHolidayMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProHoliday>;
};

/** on_conflict condition type for table "pro_holiday" */
export type ProHolidayOnConflict = {
  constraint: ProHolidayConstraint;
  updateColumns?: Array<ProHolidayUpdateColumn>;
  where?: InputMaybe<ProHolidayBoolExp>;
};

/** Ordering options when selecting data from "pro_holiday". */
export type ProHolidayOrderBy = {
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proView?: InputMaybe<ProViewOrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_holiday */
export type ProHolidayPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "pro_holiday" */
export enum ProHolidaySelectColumn {
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  StartDate = 'startDate'
}

/** input type for updating data in table "pro_holiday" */
export type ProHolidaySetInput = {
  endDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['date']>;
};

/** aggregate stddev on columns */
export type ProHolidayStddevFields = {
  __typename?: 'ProHolidayStddevFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pro_holiday" */
export type ProHolidayStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProHolidayStddevPopFields = {
  __typename?: 'ProHolidayStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pro_holiday" */
export type ProHolidayStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProHolidayStddevSampFields = {
  __typename?: 'ProHolidayStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pro_holiday" */
export type ProHolidayStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_holiday" */
export type ProHolidayStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProHolidayStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProHolidayStreamCursorValueInput = {
  endDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type ProHolidaySumFields = {
  __typename?: 'ProHolidaySumFields';
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pro_holiday" */
export type ProHolidaySumOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_holiday" */
export enum ProHolidayUpdateColumn {
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  StartDate = 'startDate'
}

export type ProHolidayUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProHolidayIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProHolidaySetInput>;
  /** filter the rows which have to be updated */
  where: ProHolidayBoolExp;
};

/** aggregate varPop on columns */
export type ProHolidayVarPopFields = {
  __typename?: 'ProHolidayVarPopFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pro_holiday" */
export type ProHolidayVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProHolidayVarSampFields = {
  __typename?: 'ProHolidayVarSampFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pro_holiday" */
export type ProHolidayVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProHolidayVarianceFields = {
  __typename?: 'ProHolidayVarianceFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pro_holiday" */
export type ProHolidayVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "pro_label" */
export type ProLabel = {
  __typename?: 'ProLabel';
  certificateName: Scalars['String'];
  dateChecked: Scalars['timestamptz'];
  domain: Scalars['String'];
  id: Scalars['Int'];
  isCheckActive: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  proPresentationId: Scalars['Int'];
  /** An object relationship */
  proPresentations: ProPresentation;
  qualificationUrl: Scalars['String'];
};

/** aggregated selection of "pro_label" */
export type ProLabelAggregate = {
  __typename?: 'ProLabelAggregate';
  aggregate?: Maybe<ProLabelAggregateFields>;
  nodes: Array<ProLabel>;
};

export type ProLabelAggregateBoolExp = {
  bool_and?: InputMaybe<ProLabelAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<ProLabelAggregateBoolExpBoolOr>;
  count?: InputMaybe<ProLabelAggregateBoolExpCount>;
};

/** aggregate fields of "pro_label" */
export type ProLabelAggregateFields = {
  __typename?: 'ProLabelAggregateFields';
  avg?: Maybe<ProLabelAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProLabelMaxFields>;
  min?: Maybe<ProLabelMinFields>;
  stddev?: Maybe<ProLabelStddevFields>;
  stddevPop?: Maybe<ProLabelStddevPopFields>;
  stddevSamp?: Maybe<ProLabelStddevSampFields>;
  sum?: Maybe<ProLabelSumFields>;
  varPop?: Maybe<ProLabelVarPopFields>;
  varSamp?: Maybe<ProLabelVarSampFields>;
  variance?: Maybe<ProLabelVarianceFields>;
};


/** aggregate fields of "pro_label" */
export type ProLabelAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProLabelSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_label" */
export type ProLabelAggregateOrderBy = {
  avg?: InputMaybe<ProLabelAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProLabelMaxOrderBy>;
  min?: InputMaybe<ProLabelMinOrderBy>;
  stddev?: InputMaybe<ProLabelStddevOrderBy>;
  stddevPop?: InputMaybe<ProLabelStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProLabelStddevSampOrderBy>;
  sum?: InputMaybe<ProLabelSumOrderBy>;
  varPop?: InputMaybe<ProLabelVarPopOrderBy>;
  varSamp?: InputMaybe<ProLabelVarSampOrderBy>;
  variance?: InputMaybe<ProLabelVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pro_label" */
export type ProLabelArrRelInsertInput = {
  data: Array<ProLabelInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProLabelOnConflict>;
};

/** aggregate avg on columns */
export type ProLabelAvgFields = {
  __typename?: 'ProLabelAvgFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pro_label" */
export type ProLabelAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_label". All fields are combined with a logical 'AND'. */
export type ProLabelBoolExp = {
  _and?: InputMaybe<Array<ProLabelBoolExp>>;
  _not?: InputMaybe<ProLabelBoolExp>;
  _or?: InputMaybe<Array<ProLabelBoolExp>>;
  certificateName?: InputMaybe<StringComparisonExp>;
  dateChecked?: InputMaybe<TimestamptzComparisonExp>;
  domain?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  isCheckActive?: InputMaybe<BooleanComparisonExp>;
  isVisible?: InputMaybe<BooleanComparisonExp>;
  proPresentationId?: InputMaybe<IntComparisonExp>;
  proPresentations?: InputMaybe<ProPresentationBoolExp>;
  qualificationUrl?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "pro_label" */
export enum ProLabelConstraint {
  /** unique or primary key constraint on columns "id" */
  ProLabelPkey = 'pro_label_pkey'
}

/** input type for incrementing numeric columns in table "pro_label" */
export type ProLabelIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_label" */
export type ProLabelInsertInput = {
  certificateName?: InputMaybe<Scalars['String']>;
  dateChecked?: InputMaybe<Scalars['timestamptz']>;
  domain?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isCheckActive?: InputMaybe<Scalars['Boolean']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  proPresentations?: InputMaybe<ProPresentationObjRelInsertInput>;
  qualificationUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProLabelMaxFields = {
  __typename?: 'ProLabelMaxFields';
  certificateName?: Maybe<Scalars['String']>;
  dateChecked?: Maybe<Scalars['timestamptz']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  qualificationUrl?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "pro_label" */
export type ProLabelMaxOrderBy = {
  certificateName?: InputMaybe<OrderBy>;
  dateChecked?: InputMaybe<OrderBy>;
  domain?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  qualificationUrl?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProLabelMinFields = {
  __typename?: 'ProLabelMinFields';
  certificateName?: Maybe<Scalars['String']>;
  dateChecked?: Maybe<Scalars['timestamptz']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  qualificationUrl?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "pro_label" */
export type ProLabelMinOrderBy = {
  certificateName?: InputMaybe<OrderBy>;
  dateChecked?: InputMaybe<OrderBy>;
  domain?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  qualificationUrl?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_label" */
export type ProLabelMutationResponse = {
  __typename?: 'ProLabelMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProLabel>;
};

/** on_conflict condition type for table "pro_label" */
export type ProLabelOnConflict = {
  constraint: ProLabelConstraint;
  updateColumns?: Array<ProLabelUpdateColumn>;
  where?: InputMaybe<ProLabelBoolExp>;
};

/** Ordering options when selecting data from "pro_label". */
export type ProLabelOrderBy = {
  certificateName?: InputMaybe<OrderBy>;
  dateChecked?: InputMaybe<OrderBy>;
  domain?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isCheckActive?: InputMaybe<OrderBy>;
  isVisible?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proPresentations?: InputMaybe<ProPresentationOrderBy>;
  qualificationUrl?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_label */
export type ProLabelPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "pro_label" */
export enum ProLabelSelectColumn {
  /** column name */
  CertificateName = 'certificateName',
  /** column name */
  DateChecked = 'dateChecked',
  /** column name */
  Domain = 'domain',
  /** column name */
  Id = 'id',
  /** column name */
  IsCheckActive = 'isCheckActive',
  /** column name */
  IsVisible = 'isVisible',
  /** column name */
  ProPresentationId = 'proPresentationId',
  /** column name */
  QualificationUrl = 'qualificationUrl'
}

/** select "proLabelAggregateBoolExpBool_andArgumentsColumns" columns of table "pro_label" */
export enum ProLabelSelectColumnProLabelAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsCheckActive = 'isCheckActive',
  /** column name */
  IsVisible = 'isVisible'
}

/** select "proLabelAggregateBoolExpBool_orArgumentsColumns" columns of table "pro_label" */
export enum ProLabelSelectColumnProLabelAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsCheckActive = 'isCheckActive',
  /** column name */
  IsVisible = 'isVisible'
}

/** input type for updating data in table "pro_label" */
export type ProLabelSetInput = {
  certificateName?: InputMaybe<Scalars['String']>;
  dateChecked?: InputMaybe<Scalars['timestamptz']>;
  domain?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isCheckActive?: InputMaybe<Scalars['Boolean']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  qualificationUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProLabelStddevFields = {
  __typename?: 'ProLabelStddevFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pro_label" */
export type ProLabelStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProLabelStddevPopFields = {
  __typename?: 'ProLabelStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pro_label" */
export type ProLabelStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProLabelStddevSampFields = {
  __typename?: 'ProLabelStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pro_label" */
export type ProLabelStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_label" */
export type ProLabelStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProLabelStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProLabelStreamCursorValueInput = {
  certificateName?: InputMaybe<Scalars['String']>;
  dateChecked?: InputMaybe<Scalars['timestamptz']>;
  domain?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isCheckActive?: InputMaybe<Scalars['Boolean']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  qualificationUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ProLabelSumFields = {
  __typename?: 'ProLabelSumFields';
  id?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pro_label" */
export type ProLabelSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_label" */
export enum ProLabelUpdateColumn {
  /** column name */
  CertificateName = 'certificateName',
  /** column name */
  DateChecked = 'dateChecked',
  /** column name */
  Domain = 'domain',
  /** column name */
  Id = 'id',
  /** column name */
  IsCheckActive = 'isCheckActive',
  /** column name */
  IsVisible = 'isVisible',
  /** column name */
  ProPresentationId = 'proPresentationId',
  /** column name */
  QualificationUrl = 'qualificationUrl'
}

export type ProLabelUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProLabelIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProLabelSetInput>;
  /** filter the rows which have to be updated */
  where: ProLabelBoolExp;
};

/** aggregate varPop on columns */
export type ProLabelVarPopFields = {
  __typename?: 'ProLabelVarPopFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pro_label" */
export type ProLabelVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProLabelVarSampFields = {
  __typename?: 'ProLabelVarSampFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pro_label" */
export type ProLabelVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProLabelVarianceFields = {
  __typename?: 'ProLabelVarianceFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pro_label" */
export type ProLabelVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "pro_mandate" */
export type ProMandate = {
  __typename?: 'ProMandate';
  bic: Scalars['String'];
  /** An object relationship */
  company: Company;
  companyId: Scalars['Int'];
  dateArchived?: Maybe<Scalars['timestamptz']>;
  dateCreated: Scalars['timestamptz'];
  dateSigned?: Maybe<Scalars['timestamptz']>;
  events?: Maybe<Scalars['jsonb']>;
  fileName?: Maybe<Scalars['String']>;
  iban: Scalars['String'];
  id: Scalars['Int'];
  rum: Scalars['String'];
  status: Scalars['String'];
  /** An object relationship */
  zohoOrganization: ZohoOrganization;
  zohoOrganizationId: Scalars['Int'];
};


/** columns and relationships of "pro_mandate" */
export type ProMandateEventsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "pro_mandate" */
export type ProMandateAggregate = {
  __typename?: 'ProMandateAggregate';
  aggregate?: Maybe<ProMandateAggregateFields>;
  nodes: Array<ProMandate>;
};

export type ProMandateAggregateBoolExp = {
  count?: InputMaybe<ProMandateAggregateBoolExpCount>;
};

/** aggregate fields of "pro_mandate" */
export type ProMandateAggregateFields = {
  __typename?: 'ProMandateAggregateFields';
  avg?: Maybe<ProMandateAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProMandateMaxFields>;
  min?: Maybe<ProMandateMinFields>;
  stddev?: Maybe<ProMandateStddevFields>;
  stddevPop?: Maybe<ProMandateStddevPopFields>;
  stddevSamp?: Maybe<ProMandateStddevSampFields>;
  sum?: Maybe<ProMandateSumFields>;
  varPop?: Maybe<ProMandateVarPopFields>;
  varSamp?: Maybe<ProMandateVarSampFields>;
  variance?: Maybe<ProMandateVarianceFields>;
};


/** aggregate fields of "pro_mandate" */
export type ProMandateAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProMandateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_mandate" */
export type ProMandateAggregateOrderBy = {
  avg?: InputMaybe<ProMandateAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProMandateMaxOrderBy>;
  min?: InputMaybe<ProMandateMinOrderBy>;
  stddev?: InputMaybe<ProMandateStddevOrderBy>;
  stddevPop?: InputMaybe<ProMandateStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProMandateStddevSampOrderBy>;
  sum?: InputMaybe<ProMandateSumOrderBy>;
  varPop?: InputMaybe<ProMandateVarPopOrderBy>;
  varSamp?: InputMaybe<ProMandateVarSampOrderBy>;
  variance?: InputMaybe<ProMandateVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ProMandateAppendInput = {
  events?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "pro_mandate" */
export type ProMandateArrRelInsertInput = {
  data: Array<ProMandateInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProMandateOnConflict>;
};

/** aggregate avg on columns */
export type ProMandateAvgFields = {
  __typename?: 'ProMandateAvgFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pro_mandate" */
export type ProMandateAvgOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_mandate". All fields are combined with a logical 'AND'. */
export type ProMandateBoolExp = {
  _and?: InputMaybe<Array<ProMandateBoolExp>>;
  _not?: InputMaybe<ProMandateBoolExp>;
  _or?: InputMaybe<Array<ProMandateBoolExp>>;
  bic?: InputMaybe<StringComparisonExp>;
  company?: InputMaybe<CompanyBoolExp>;
  companyId?: InputMaybe<IntComparisonExp>;
  dateArchived?: InputMaybe<TimestamptzComparisonExp>;
  dateCreated?: InputMaybe<TimestamptzComparisonExp>;
  dateSigned?: InputMaybe<TimestamptzComparisonExp>;
  events?: InputMaybe<JsonbComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  iban?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  rum?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  zohoOrganization?: InputMaybe<ZohoOrganizationBoolExp>;
  zohoOrganizationId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "pro_mandate" */
export enum ProMandateConstraint {
  /** unique or primary key constraint on columns "rum" */
  MandateRumKey = 'mandate_rum_key',
  /** unique or primary key constraint on columns "id" */
  ProMandatePkey = 'pro_mandate_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ProMandateDeleteAtPathInput = {
  events?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ProMandateDeleteElemInput = {
  events?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ProMandateDeleteKeyInput = {
  events?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "pro_mandate" */
export type ProMandateIncInput = {
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  zohoOrganizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_mandate" */
export type ProMandateInsertInput = {
  bic?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['Int']>;
  dateArchived?: InputMaybe<Scalars['timestamptz']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  dateSigned?: InputMaybe<Scalars['timestamptz']>;
  events?: InputMaybe<Scalars['jsonb']>;
  fileName?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  rum?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  zohoOrganization?: InputMaybe<ZohoOrganizationObjRelInsertInput>;
  zohoOrganizationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ProMandateMaxFields = {
  __typename?: 'ProMandateMaxFields';
  bic?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  dateArchived?: Maybe<Scalars['timestamptz']>;
  dateCreated?: Maybe<Scalars['timestamptz']>;
  dateSigned?: Maybe<Scalars['timestamptz']>;
  fileName?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  rum?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  zohoOrganizationId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "pro_mandate" */
export type ProMandateMaxOrderBy = {
  bic?: InputMaybe<OrderBy>;
  companyId?: InputMaybe<OrderBy>;
  dateArchived?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  dateSigned?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  iban?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  rum?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProMandateMinFields = {
  __typename?: 'ProMandateMinFields';
  bic?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  dateArchived?: Maybe<Scalars['timestamptz']>;
  dateCreated?: Maybe<Scalars['timestamptz']>;
  dateSigned?: Maybe<Scalars['timestamptz']>;
  fileName?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  rum?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  zohoOrganizationId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "pro_mandate" */
export type ProMandateMinOrderBy = {
  bic?: InputMaybe<OrderBy>;
  companyId?: InputMaybe<OrderBy>;
  dateArchived?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  dateSigned?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  iban?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  rum?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_mandate" */
export type ProMandateMutationResponse = {
  __typename?: 'ProMandateMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProMandate>;
};

/** on_conflict condition type for table "pro_mandate" */
export type ProMandateOnConflict = {
  constraint: ProMandateConstraint;
  updateColumns?: Array<ProMandateUpdateColumn>;
  where?: InputMaybe<ProMandateBoolExp>;
};

/** Ordering options when selecting data from "pro_mandate". */
export type ProMandateOrderBy = {
  bic?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompanyOrderBy>;
  companyId?: InputMaybe<OrderBy>;
  dateArchived?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  dateSigned?: InputMaybe<OrderBy>;
  events?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  iban?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  rum?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  zohoOrganization?: InputMaybe<ZohoOrganizationOrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_mandate */
export type ProMandatePkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ProMandatePrependInput = {
  events?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "pro_mandate" */
export enum ProMandateSelectColumn {
  /** column name */
  Bic = 'bic',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  DateArchived = 'dateArchived',
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  DateSigned = 'dateSigned',
  /** column name */
  Events = 'events',
  /** column name */
  FileName = 'fileName',
  /** column name */
  Iban = 'iban',
  /** column name */
  Id = 'id',
  /** column name */
  Rum = 'rum',
  /** column name */
  Status = 'status',
  /** column name */
  ZohoOrganizationId = 'zohoOrganizationId'
}

/** input type for updating data in table "pro_mandate" */
export type ProMandateSetInput = {
  bic?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  dateArchived?: InputMaybe<Scalars['timestamptz']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  dateSigned?: InputMaybe<Scalars['timestamptz']>;
  events?: InputMaybe<Scalars['jsonb']>;
  fileName?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  rum?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  zohoOrganizationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ProMandateStddevFields = {
  __typename?: 'ProMandateStddevFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pro_mandate" */
export type ProMandateStddevOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProMandateStddevPopFields = {
  __typename?: 'ProMandateStddevPopFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pro_mandate" */
export type ProMandateStddevPopOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProMandateStddevSampFields = {
  __typename?: 'ProMandateStddevSampFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pro_mandate" */
export type ProMandateStddevSampOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_mandate" */
export type ProMandateStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProMandateStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProMandateStreamCursorValueInput = {
  bic?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  dateArchived?: InputMaybe<Scalars['timestamptz']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  dateSigned?: InputMaybe<Scalars['timestamptz']>;
  events?: InputMaybe<Scalars['jsonb']>;
  fileName?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  rum?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  zohoOrganizationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ProMandateSumFields = {
  __typename?: 'ProMandateSumFields';
  companyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  zohoOrganizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pro_mandate" */
export type ProMandateSumOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_mandate" */
export enum ProMandateUpdateColumn {
  /** column name */
  Bic = 'bic',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  DateArchived = 'dateArchived',
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  DateSigned = 'dateSigned',
  /** column name */
  Events = 'events',
  /** column name */
  FileName = 'fileName',
  /** column name */
  Iban = 'iban',
  /** column name */
  Id = 'id',
  /** column name */
  Rum = 'rum',
  /** column name */
  Status = 'status',
  /** column name */
  ZohoOrganizationId = 'zohoOrganizationId'
}

export type ProMandateUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ProMandateAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<ProMandateDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<ProMandateDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<ProMandateDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProMandateIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ProMandatePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProMandateSetInput>;
  /** filter the rows which have to be updated */
  where: ProMandateBoolExp;
};

/** aggregate varPop on columns */
export type ProMandateVarPopFields = {
  __typename?: 'ProMandateVarPopFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pro_mandate" */
export type ProMandateVarPopOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProMandateVarSampFields = {
  __typename?: 'ProMandateVarSampFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pro_mandate" */
export type ProMandateVarSampOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProMandateVarianceFields = {
  __typename?: 'ProMandateVarianceFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pro_mandate" */
export type ProMandateVarianceOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "pro_media_object" */
export type ProMediaObject = {
  __typename?: 'ProMediaObject';
  hash: Scalars['String'];
  id: Scalars['Int'];
  position: Scalars['Int'];
  /** An object relationship */
  proPresentation: ProPresentation;
  proPresentationId: Scalars['Int'];
};

/** aggregated selection of "pro_media_object" */
export type ProMediaObjectAggregate = {
  __typename?: 'ProMediaObjectAggregate';
  aggregate?: Maybe<ProMediaObjectAggregateFields>;
  nodes: Array<ProMediaObject>;
};

export type ProMediaObjectAggregateBoolExp = {
  count?: InputMaybe<ProMediaObjectAggregateBoolExpCount>;
};

/** aggregate fields of "pro_media_object" */
export type ProMediaObjectAggregateFields = {
  __typename?: 'ProMediaObjectAggregateFields';
  avg?: Maybe<ProMediaObjectAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProMediaObjectMaxFields>;
  min?: Maybe<ProMediaObjectMinFields>;
  stddev?: Maybe<ProMediaObjectStddevFields>;
  stddevPop?: Maybe<ProMediaObjectStddevPopFields>;
  stddevSamp?: Maybe<ProMediaObjectStddevSampFields>;
  sum?: Maybe<ProMediaObjectSumFields>;
  varPop?: Maybe<ProMediaObjectVarPopFields>;
  varSamp?: Maybe<ProMediaObjectVarSampFields>;
  variance?: Maybe<ProMediaObjectVarianceFields>;
};


/** aggregate fields of "pro_media_object" */
export type ProMediaObjectAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProMediaObjectSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_media_object" */
export type ProMediaObjectAggregateOrderBy = {
  avg?: InputMaybe<ProMediaObjectAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProMediaObjectMaxOrderBy>;
  min?: InputMaybe<ProMediaObjectMinOrderBy>;
  stddev?: InputMaybe<ProMediaObjectStddevOrderBy>;
  stddevPop?: InputMaybe<ProMediaObjectStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProMediaObjectStddevSampOrderBy>;
  sum?: InputMaybe<ProMediaObjectSumOrderBy>;
  varPop?: InputMaybe<ProMediaObjectVarPopOrderBy>;
  varSamp?: InputMaybe<ProMediaObjectVarSampOrderBy>;
  variance?: InputMaybe<ProMediaObjectVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pro_media_object" */
export type ProMediaObjectArrRelInsertInput = {
  data: Array<ProMediaObjectInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProMediaObjectOnConflict>;
};

/** aggregate avg on columns */
export type ProMediaObjectAvgFields = {
  __typename?: 'ProMediaObjectAvgFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pro_media_object" */
export type ProMediaObjectAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_media_object". All fields are combined with a logical 'AND'. */
export type ProMediaObjectBoolExp = {
  _and?: InputMaybe<Array<ProMediaObjectBoolExp>>;
  _not?: InputMaybe<ProMediaObjectBoolExp>;
  _or?: InputMaybe<Array<ProMediaObjectBoolExp>>;
  hash?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  position?: InputMaybe<IntComparisonExp>;
  proPresentation?: InputMaybe<ProPresentationBoolExp>;
  proPresentationId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "pro_media_object" */
export enum ProMediaObjectConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22921Primary = 'idx_22921_primary'
}

/** input type for incrementing numeric columns in table "pro_media_object" */
export type ProMediaObjectIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_media_object" */
export type ProMediaObjectInsertInput = {
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  proPresentation?: InputMaybe<ProPresentationObjRelInsertInput>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ProMediaObjectMaxFields = {
  __typename?: 'ProMediaObjectMaxFields';
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "pro_media_object" */
export type ProMediaObjectMaxOrderBy = {
  hash?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProMediaObjectMinFields = {
  __typename?: 'ProMediaObjectMinFields';
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "pro_media_object" */
export type ProMediaObjectMinOrderBy = {
  hash?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_media_object" */
export type ProMediaObjectMutationResponse = {
  __typename?: 'ProMediaObjectMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProMediaObject>;
};

/** on_conflict condition type for table "pro_media_object" */
export type ProMediaObjectOnConflict = {
  constraint: ProMediaObjectConstraint;
  updateColumns?: Array<ProMediaObjectUpdateColumn>;
  where?: InputMaybe<ProMediaObjectBoolExp>;
};

/** Ordering options when selecting data from "pro_media_object". */
export type ProMediaObjectOrderBy = {
  hash?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  proPresentation?: InputMaybe<ProPresentationOrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_media_object */
export type ProMediaObjectPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "pro_media_object" */
export enum ProMediaObjectSelectColumn {
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  ProPresentationId = 'proPresentationId'
}

/** input type for updating data in table "pro_media_object" */
export type ProMediaObjectSetInput = {
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ProMediaObjectStddevFields = {
  __typename?: 'ProMediaObjectStddevFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pro_media_object" */
export type ProMediaObjectStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProMediaObjectStddevPopFields = {
  __typename?: 'ProMediaObjectStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pro_media_object" */
export type ProMediaObjectStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProMediaObjectStddevSampFields = {
  __typename?: 'ProMediaObjectStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pro_media_object" */
export type ProMediaObjectStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_media_object" */
export type ProMediaObjectStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProMediaObjectStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProMediaObjectStreamCursorValueInput = {
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ProMediaObjectSumFields = {
  __typename?: 'ProMediaObjectSumFields';
  id?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pro_media_object" */
export type ProMediaObjectSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_media_object" */
export enum ProMediaObjectUpdateColumn {
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  ProPresentationId = 'proPresentationId'
}

export type ProMediaObjectUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProMediaObjectIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProMediaObjectSetInput>;
  /** filter the rows which have to be updated */
  where: ProMediaObjectBoolExp;
};

/** aggregate varPop on columns */
export type ProMediaObjectVarPopFields = {
  __typename?: 'ProMediaObjectVarPopFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pro_media_object" */
export type ProMediaObjectVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProMediaObjectVarSampFields = {
  __typename?: 'ProMediaObjectVarSampFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pro_media_object" */
export type ProMediaObjectVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProMediaObjectVarianceFields = {
  __typename?: 'ProMediaObjectVarianceFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pro_media_object" */
export type ProMediaObjectVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "pro_message" */
export type ProMessage = {
  __typename?: 'ProMessage';
  body: Scalars['String'];
  endDate?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  isPermanent: Scalars['Boolean'];
  /** An object relationship */
  proView: ProView;
  proViewId: Scalars['Int'];
  startDate?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "pro_message" */
export type ProMessageAggregate = {
  __typename?: 'ProMessageAggregate';
  aggregate?: Maybe<ProMessageAggregateFields>;
  nodes: Array<ProMessage>;
};

export type ProMessageAggregateBoolExp = {
  bool_and?: InputMaybe<ProMessageAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<ProMessageAggregateBoolExpBoolOr>;
  count?: InputMaybe<ProMessageAggregateBoolExpCount>;
};

/** aggregate fields of "pro_message" */
export type ProMessageAggregateFields = {
  __typename?: 'ProMessageAggregateFields';
  avg?: Maybe<ProMessageAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProMessageMaxFields>;
  min?: Maybe<ProMessageMinFields>;
  stddev?: Maybe<ProMessageStddevFields>;
  stddevPop?: Maybe<ProMessageStddevPopFields>;
  stddevSamp?: Maybe<ProMessageStddevSampFields>;
  sum?: Maybe<ProMessageSumFields>;
  varPop?: Maybe<ProMessageVarPopFields>;
  varSamp?: Maybe<ProMessageVarSampFields>;
  variance?: Maybe<ProMessageVarianceFields>;
};


/** aggregate fields of "pro_message" */
export type ProMessageAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProMessageSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_message" */
export type ProMessageAggregateOrderBy = {
  avg?: InputMaybe<ProMessageAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProMessageMaxOrderBy>;
  min?: InputMaybe<ProMessageMinOrderBy>;
  stddev?: InputMaybe<ProMessageStddevOrderBy>;
  stddevPop?: InputMaybe<ProMessageStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProMessageStddevSampOrderBy>;
  sum?: InputMaybe<ProMessageSumOrderBy>;
  varPop?: InputMaybe<ProMessageVarPopOrderBy>;
  varSamp?: InputMaybe<ProMessageVarSampOrderBy>;
  variance?: InputMaybe<ProMessageVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pro_message" */
export type ProMessageArrRelInsertInput = {
  data: Array<ProMessageInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProMessageOnConflict>;
};

/** aggregate avg on columns */
export type ProMessageAvgFields = {
  __typename?: 'ProMessageAvgFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pro_message" */
export type ProMessageAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_message". All fields are combined with a logical 'AND'. */
export type ProMessageBoolExp = {
  _and?: InputMaybe<Array<ProMessageBoolExp>>;
  _not?: InputMaybe<ProMessageBoolExp>;
  _or?: InputMaybe<Array<ProMessageBoolExp>>;
  body?: InputMaybe<StringComparisonExp>;
  endDate?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  isPermanent?: InputMaybe<BooleanComparisonExp>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
  startDate?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "pro_message" */
export enum ProMessageConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22930Primary = 'idx_22930_primary'
}

/** input type for incrementing numeric columns in table "pro_message" */
export type ProMessageIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_message" */
export type ProMessageInsertInput = {
  body?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  isPermanent?: InputMaybe<Scalars['Boolean']>;
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ProMessageMaxFields = {
  __typename?: 'ProMessageMaxFields';
  body?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "pro_message" */
export type ProMessageMaxOrderBy = {
  body?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProMessageMinFields = {
  __typename?: 'ProMessageMinFields';
  body?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "pro_message" */
export type ProMessageMinOrderBy = {
  body?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_message" */
export type ProMessageMutationResponse = {
  __typename?: 'ProMessageMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProMessage>;
};

/** on_conflict condition type for table "pro_message" */
export type ProMessageOnConflict = {
  constraint: ProMessageConstraint;
  updateColumns?: Array<ProMessageUpdateColumn>;
  where?: InputMaybe<ProMessageBoolExp>;
};

/** Ordering options when selecting data from "pro_message". */
export type ProMessageOrderBy = {
  body?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPermanent?: InputMaybe<OrderBy>;
  proView?: InputMaybe<ProViewOrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_message */
export type ProMessagePkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "pro_message" */
export enum ProMessageSelectColumn {
  /** column name */
  Body = 'body',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsPermanent = 'isPermanent',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  StartDate = 'startDate'
}

/** select "proMessageAggregateBoolExpBool_andArgumentsColumns" columns of table "pro_message" */
export enum ProMessageSelectColumnProMessageAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsPermanent = 'isPermanent'
}

/** select "proMessageAggregateBoolExpBool_orArgumentsColumns" columns of table "pro_message" */
export enum ProMessageSelectColumnProMessageAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsPermanent = 'isPermanent'
}

/** input type for updating data in table "pro_message" */
export type ProMessageSetInput = {
  body?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  isPermanent?: InputMaybe<Scalars['Boolean']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ProMessageStddevFields = {
  __typename?: 'ProMessageStddevFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pro_message" */
export type ProMessageStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProMessageStddevPopFields = {
  __typename?: 'ProMessageStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pro_message" */
export type ProMessageStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProMessageStddevSampFields = {
  __typename?: 'ProMessageStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pro_message" */
export type ProMessageStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_message" */
export type ProMessageStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProMessageStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProMessageStreamCursorValueInput = {
  body?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  isPermanent?: InputMaybe<Scalars['Boolean']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ProMessageSumFields = {
  __typename?: 'ProMessageSumFields';
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pro_message" */
export type ProMessageSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_message" */
export enum ProMessageUpdateColumn {
  /** column name */
  Body = 'body',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsPermanent = 'isPermanent',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  StartDate = 'startDate'
}

export type ProMessageUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProMessageIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProMessageSetInput>;
  /** filter the rows which have to be updated */
  where: ProMessageBoolExp;
};

/** aggregate varPop on columns */
export type ProMessageVarPopFields = {
  __typename?: 'ProMessageVarPopFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pro_message" */
export type ProMessageVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProMessageVarSampFields = {
  __typename?: 'ProMessageVarSampFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pro_message" */
export type ProMessageVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProMessageVarianceFields = {
  __typename?: 'ProMessageVarianceFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pro_message" */
export type ProMessageVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "pro_organization_first_date_published" */
export type ProOrganizationFirstDatePublished = {
  __typename?: 'ProOrganizationFirstDatePublished';
  date?: Maybe<Scalars['timestamptz']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "pro_organization_first_date_published" */
export type ProOrganizationFirstDatePublishedAggregate = {
  __typename?: 'ProOrganizationFirstDatePublishedAggregate';
  aggregate?: Maybe<ProOrganizationFirstDatePublishedAggregateFields>;
  nodes: Array<ProOrganizationFirstDatePublished>;
};

/** aggregate fields of "pro_organization_first_date_published" */
export type ProOrganizationFirstDatePublishedAggregateFields = {
  __typename?: 'ProOrganizationFirstDatePublishedAggregateFields';
  avg?: Maybe<ProOrganizationFirstDatePublishedAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProOrganizationFirstDatePublishedMaxFields>;
  min?: Maybe<ProOrganizationFirstDatePublishedMinFields>;
  stddev?: Maybe<ProOrganizationFirstDatePublishedStddevFields>;
  stddevPop?: Maybe<ProOrganizationFirstDatePublishedStddevPopFields>;
  stddevSamp?: Maybe<ProOrganizationFirstDatePublishedStddevSampFields>;
  sum?: Maybe<ProOrganizationFirstDatePublishedSumFields>;
  varPop?: Maybe<ProOrganizationFirstDatePublishedVarPopFields>;
  varSamp?: Maybe<ProOrganizationFirstDatePublishedVarSampFields>;
  variance?: Maybe<ProOrganizationFirstDatePublishedVarianceFields>;
};


/** aggregate fields of "pro_organization_first_date_published" */
export type ProOrganizationFirstDatePublishedAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProOrganizationFirstDatePublishedSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ProOrganizationFirstDatePublishedAvgFields = {
  __typename?: 'ProOrganizationFirstDatePublishedAvgFields';
  organizationId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pro_organization_first_date_published". All fields are combined with a logical 'AND'. */
export type ProOrganizationFirstDatePublishedBoolExp = {
  _and?: InputMaybe<Array<ProOrganizationFirstDatePublishedBoolExp>>;
  _not?: InputMaybe<ProOrganizationFirstDatePublishedBoolExp>;
  _or?: InputMaybe<Array<ProOrganizationFirstDatePublishedBoolExp>>;
  date?: InputMaybe<TimestamptzComparisonExp>;
  organizationId?: InputMaybe<IntComparisonExp>;
};

/** input type for inserting data into table "pro_organization_first_date_published" */
export type ProOrganizationFirstDatePublishedInsertInput = {
  date?: InputMaybe<Scalars['timestamptz']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ProOrganizationFirstDatePublishedMaxFields = {
  __typename?: 'ProOrganizationFirstDatePublishedMaxFields';
  date?: Maybe<Scalars['timestamptz']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ProOrganizationFirstDatePublishedMinFields = {
  __typename?: 'ProOrganizationFirstDatePublishedMinFields';
  date?: Maybe<Scalars['timestamptz']>;
  organizationId?: Maybe<Scalars['Int']>;
};

/** input type for inserting object relation for remote table "pro_organization_first_date_published" */
export type ProOrganizationFirstDatePublishedObjRelInsertInput = {
  data: ProOrganizationFirstDatePublishedInsertInput;
};

/** Ordering options when selecting data from "pro_organization_first_date_published". */
export type ProOrganizationFirstDatePublishedOrderBy = {
  date?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
};

/** select columns of table "pro_organization_first_date_published" */
export enum ProOrganizationFirstDatePublishedSelectColumn {
  /** column name */
  Date = 'date',
  /** column name */
  OrganizationId = 'organizationId'
}

/** aggregate stddev on columns */
export type ProOrganizationFirstDatePublishedStddevFields = {
  __typename?: 'ProOrganizationFirstDatePublishedStddevFields';
  organizationId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type ProOrganizationFirstDatePublishedStddevPopFields = {
  __typename?: 'ProOrganizationFirstDatePublishedStddevPopFields';
  organizationId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type ProOrganizationFirstDatePublishedStddevSampFields = {
  __typename?: 'ProOrganizationFirstDatePublishedStddevSampFields';
  organizationId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pro_organization_first_date_published" */
export type ProOrganizationFirstDatePublishedStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProOrganizationFirstDatePublishedStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProOrganizationFirstDatePublishedStreamCursorValueInput = {
  date?: InputMaybe<Scalars['timestamptz']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ProOrganizationFirstDatePublishedSumFields = {
  __typename?: 'ProOrganizationFirstDatePublishedSumFields';
  organizationId?: Maybe<Scalars['Int']>;
};

/** aggregate varPop on columns */
export type ProOrganizationFirstDatePublishedVarPopFields = {
  __typename?: 'ProOrganizationFirstDatePublishedVarPopFields';
  organizationId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type ProOrganizationFirstDatePublishedVarSampFields = {
  __typename?: 'ProOrganizationFirstDatePublishedVarSampFields';
  organizationId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ProOrganizationFirstDatePublishedVarianceFields = {
  __typename?: 'ProOrganizationFirstDatePublishedVarianceFields';
  organizationId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pro_person" */
export type ProPerson = {
  __typename?: 'ProPerson';
  cloudContactId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['Int'];
  /** An array relationship */
  proViews: Array<ProViewProPerson>;
  /** An aggregate relationship */
  proViewsAggregate: ProViewProPersonAggregate;
  telephone?: Maybe<Scalars['String']>;
};


/** columns and relationships of "pro_person" */
export type ProPersonProViewsArgs = {
  distinctOn?: InputMaybe<Array<ProViewProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProPersonOrderBy>>;
  where?: InputMaybe<ProViewProPersonBoolExp>;
};


/** columns and relationships of "pro_person" */
export type ProPersonProViewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProPersonOrderBy>>;
  where?: InputMaybe<ProViewProPersonBoolExp>;
};

/** aggregated selection of "pro_person" */
export type ProPersonAggregate = {
  __typename?: 'ProPersonAggregate';
  aggregate?: Maybe<ProPersonAggregateFields>;
  nodes: Array<ProPerson>;
};

/** aggregate fields of "pro_person" */
export type ProPersonAggregateFields = {
  __typename?: 'ProPersonAggregateFields';
  avg?: Maybe<ProPersonAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProPersonMaxFields>;
  min?: Maybe<ProPersonMinFields>;
  stddev?: Maybe<ProPersonStddevFields>;
  stddevPop?: Maybe<ProPersonStddevPopFields>;
  stddevSamp?: Maybe<ProPersonStddevSampFields>;
  sum?: Maybe<ProPersonSumFields>;
  varPop?: Maybe<ProPersonVarPopFields>;
  varSamp?: Maybe<ProPersonVarSampFields>;
  variance?: Maybe<ProPersonVarianceFields>;
};


/** aggregate fields of "pro_person" */
export type ProPersonAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProPersonSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ProPersonAvgFields = {
  __typename?: 'ProPersonAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pro_person". All fields are combined with a logical 'AND'. */
export type ProPersonBoolExp = {
  _and?: InputMaybe<Array<ProPersonBoolExp>>;
  _not?: InputMaybe<ProPersonBoolExp>;
  _or?: InputMaybe<Array<ProPersonBoolExp>>;
  cloudContactId?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  familyName?: InputMaybe<StringComparisonExp>;
  givenName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  proViews?: InputMaybe<ProViewProPersonBoolExp>;
  proViewsAggregate?: InputMaybe<ProViewProPersonAggregateBoolExp>;
  telephone?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "pro_person" */
export enum ProPersonConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22948Primary = 'idx_22948_primary'
}

/** input type for incrementing numeric columns in table "pro_person" */
export type ProPersonIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_person" */
export type ProPersonInsertInput = {
  cloudContactId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  proViews?: InputMaybe<ProViewProPersonArrRelInsertInput>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProPersonMaxFields = {
  __typename?: 'ProPersonMaxFields';
  cloudContactId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  telephone?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProPersonMinFields = {
  __typename?: 'ProPersonMinFields';
  cloudContactId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  telephone?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "pro_person" */
export type ProPersonMutationResponse = {
  __typename?: 'ProPersonMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProPerson>;
};

/** input type for inserting object relation for remote table "pro_person" */
export type ProPersonObjRelInsertInput = {
  data: ProPersonInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ProPersonOnConflict>;
};

/** on_conflict condition type for table "pro_person" */
export type ProPersonOnConflict = {
  constraint: ProPersonConstraint;
  updateColumns?: Array<ProPersonUpdateColumn>;
  where?: InputMaybe<ProPersonBoolExp>;
};

/** Ordering options when selecting data from "pro_person". */
export type ProPersonOrderBy = {
  cloudContactId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proViewsAggregate?: InputMaybe<ProViewProPersonAggregateOrderBy>;
  telephone?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_person */
export type ProPersonPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "pro_person" */
export enum ProPersonSelectColumn {
  /** column name */
  CloudContactId = 'cloudContactId',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  Telephone = 'telephone'
}

/** input type for updating data in table "pro_person" */
export type ProPersonSetInput = {
  cloudContactId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProPersonStddevFields = {
  __typename?: 'ProPersonStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type ProPersonStddevPopFields = {
  __typename?: 'ProPersonStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type ProPersonStddevSampFields = {
  __typename?: 'ProPersonStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pro_person" */
export type ProPersonStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProPersonStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProPersonStreamCursorValueInput = {
  cloudContactId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ProPersonSumFields = {
  __typename?: 'ProPersonSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "pro_person" */
export enum ProPersonUpdateColumn {
  /** column name */
  CloudContactId = 'cloudContactId',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  Telephone = 'telephone'
}

export type ProPersonUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProPersonIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProPersonSetInput>;
  /** filter the rows which have to be updated */
  where: ProPersonBoolExp;
};

/** aggregate varPop on columns */
export type ProPersonVarPopFields = {
  __typename?: 'ProPersonVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type ProPersonVarSampFields = {
  __typename?: 'ProPersonVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ProPersonVarianceFields = {
  __typename?: 'ProPersonVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pro_postal_address" */
export type ProPostalAddress = {
  __typename?: 'ProPostalAddress';
  city: Scalars['String'];
  cityGeoCoordinates?: Maybe<Scalars['geometry']>;
  displayOption: Scalars['String'];
  geoCoordinates: Scalars['geometry'];
  postalCode: Scalars['String'];
  /** An object relationship */
  proView: ProView;
  proViewId: Scalars['Int'];
  street: Scalars['String'];
};

/** aggregated selection of "pro_postal_address" */
export type ProPostalAddressAggregate = {
  __typename?: 'ProPostalAddressAggregate';
  aggregate?: Maybe<ProPostalAddressAggregateFields>;
  nodes: Array<ProPostalAddress>;
};

/** aggregate fields of "pro_postal_address" */
export type ProPostalAddressAggregateFields = {
  __typename?: 'ProPostalAddressAggregateFields';
  avg?: Maybe<ProPostalAddressAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProPostalAddressMaxFields>;
  min?: Maybe<ProPostalAddressMinFields>;
  stddev?: Maybe<ProPostalAddressStddevFields>;
  stddevPop?: Maybe<ProPostalAddressStddevPopFields>;
  stddevSamp?: Maybe<ProPostalAddressStddevSampFields>;
  sum?: Maybe<ProPostalAddressSumFields>;
  varPop?: Maybe<ProPostalAddressVarPopFields>;
  varSamp?: Maybe<ProPostalAddressVarSampFields>;
  variance?: Maybe<ProPostalAddressVarianceFields>;
};


/** aggregate fields of "pro_postal_address" */
export type ProPostalAddressAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProPostalAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ProPostalAddressAvgFields = {
  __typename?: 'ProPostalAddressAvgFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pro_postal_address". All fields are combined with a logical 'AND'. */
export type ProPostalAddressBoolExp = {
  _and?: InputMaybe<Array<ProPostalAddressBoolExp>>;
  _not?: InputMaybe<ProPostalAddressBoolExp>;
  _or?: InputMaybe<Array<ProPostalAddressBoolExp>>;
  city?: InputMaybe<StringComparisonExp>;
  cityGeoCoordinates?: InputMaybe<GeometryComparisonExp>;
  displayOption?: InputMaybe<StringComparisonExp>;
  geoCoordinates?: InputMaybe<GeometryComparisonExp>;
  postalCode?: InputMaybe<StringComparisonExp>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
  street?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "pro_postal_address" */
export enum ProPostalAddressConstraint {
  /** unique or primary key constraint on columns "pro_view_id" */
  ProPostalAddressPkey = 'pro_postal_address_pkey',
  /** unique or primary key constraint on columns "pro_view_id" */
  ProPostalAddressUniqProViewId = 'pro_postal_address_uniq_pro_view_id'
}

/** input type for incrementing numeric columns in table "pro_postal_address" */
export type ProPostalAddressIncInput = {
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_postal_address" */
export type ProPostalAddressInsertInput = {
  city?: InputMaybe<Scalars['String']>;
  cityGeoCoordinates?: InputMaybe<Scalars['geometry']>;
  displayOption?: InputMaybe<Scalars['String']>;
  geoCoordinates?: InputMaybe<Scalars['geometry']>;
  postalCode?: InputMaybe<Scalars['String']>;
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewId?: InputMaybe<Scalars['Int']>;
  street?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProPostalAddressMaxFields = {
  __typename?: 'ProPostalAddressMaxFields';
  city?: Maybe<Scalars['String']>;
  displayOption?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  proViewId?: Maybe<Scalars['Int']>;
  street?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProPostalAddressMinFields = {
  __typename?: 'ProPostalAddressMinFields';
  city?: Maybe<Scalars['String']>;
  displayOption?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  proViewId?: Maybe<Scalars['Int']>;
  street?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "pro_postal_address" */
export type ProPostalAddressMutationResponse = {
  __typename?: 'ProPostalAddressMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProPostalAddress>;
};

/** input type for inserting object relation for remote table "pro_postal_address" */
export type ProPostalAddressObjRelInsertInput = {
  data: ProPostalAddressInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ProPostalAddressOnConflict>;
};

/** on_conflict condition type for table "pro_postal_address" */
export type ProPostalAddressOnConflict = {
  constraint: ProPostalAddressConstraint;
  updateColumns?: Array<ProPostalAddressUpdateColumn>;
  where?: InputMaybe<ProPostalAddressBoolExp>;
};

/** Ordering options when selecting data from "pro_postal_address". */
export type ProPostalAddressOrderBy = {
  city?: InputMaybe<OrderBy>;
  cityGeoCoordinates?: InputMaybe<OrderBy>;
  displayOption?: InputMaybe<OrderBy>;
  geoCoordinates?: InputMaybe<OrderBy>;
  postalCode?: InputMaybe<OrderBy>;
  proView?: InputMaybe<ProViewOrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_postal_address */
export type ProPostalAddressPkColumnsInput = {
  proViewId: Scalars['Int'];
};

/** select columns of table "pro_postal_address" */
export enum ProPostalAddressSelectColumn {
  /** column name */
  City = 'city',
  /** column name */
  CityGeoCoordinates = 'cityGeoCoordinates',
  /** column name */
  DisplayOption = 'displayOption',
  /** column name */
  GeoCoordinates = 'geoCoordinates',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  Street = 'street'
}

/** input type for updating data in table "pro_postal_address" */
export type ProPostalAddressSetInput = {
  city?: InputMaybe<Scalars['String']>;
  cityGeoCoordinates?: InputMaybe<Scalars['geometry']>;
  displayOption?: InputMaybe<Scalars['String']>;
  geoCoordinates?: InputMaybe<Scalars['geometry']>;
  postalCode?: InputMaybe<Scalars['String']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  street?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProPostalAddressStddevFields = {
  __typename?: 'ProPostalAddressStddevFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type ProPostalAddressStddevPopFields = {
  __typename?: 'ProPostalAddressStddevPopFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type ProPostalAddressStddevSampFields = {
  __typename?: 'ProPostalAddressStddevSampFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pro_postal_address" */
export type ProPostalAddressStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProPostalAddressStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProPostalAddressStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']>;
  cityGeoCoordinates?: InputMaybe<Scalars['geometry']>;
  displayOption?: InputMaybe<Scalars['String']>;
  geoCoordinates?: InputMaybe<Scalars['geometry']>;
  postalCode?: InputMaybe<Scalars['String']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  street?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ProPostalAddressSumFields = {
  __typename?: 'ProPostalAddressSumFields';
  proViewId?: Maybe<Scalars['Int']>;
};

/** update columns of table "pro_postal_address" */
export enum ProPostalAddressUpdateColumn {
  /** column name */
  City = 'city',
  /** column name */
  CityGeoCoordinates = 'cityGeoCoordinates',
  /** column name */
  DisplayOption = 'displayOption',
  /** column name */
  GeoCoordinates = 'geoCoordinates',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  Street = 'street'
}

export type ProPostalAddressUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProPostalAddressIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProPostalAddressSetInput>;
  /** filter the rows which have to be updated */
  where: ProPostalAddressBoolExp;
};

/** aggregate varPop on columns */
export type ProPostalAddressVarPopFields = {
  __typename?: 'ProPostalAddressVarPopFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type ProPostalAddressVarSampFields = {
  __typename?: 'ProPostalAddressVarSampFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ProPostalAddressVarianceFields = {
  __typename?: 'ProPostalAddressVarianceFields';
  proViewId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pro_presentation" */
export type ProPresentation = {
  __typename?: 'ProPresentation';
  /** Average rating of the published reviews (not spam) visible on the presentation; null without reviews. */
  averageRating?: Maybe<Scalars['float8']>;
  /** Average rating of the published Bilik reviews (not spam) visible on the presentation; null without reviews. */
  bilikAverageRating?: Maybe<Scalars['float8']>;
  /** Number of published Bilik reviews (not spam) visible on the presentation. */
  bilikReviewCount?: Maybe<Scalars['Int']>;
  /** An array relationship */
  certifications: Array<ProCertification>;
  /** An aggregate relationship */
  certificationsAggregate: ProCertificationAggregate;
  /** An object relationship */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  customReviewInvitationDunningEmail?: Maybe<Scalars['String']>;
  customReviewInvitationEmail?: Maybe<Scalars['String']>;
  dateCreated: Scalars['timestamptz'];
  expertise1?: Maybe<Scalars['String']>;
  expertise2?: Maybe<Scalars['String']>;
  expertise3?: Maybe<Scalars['String']>;
  expertise11?: Maybe<Scalars['String']>;
  expertise12?: Maybe<Scalars['String']>;
  expertise13?: Maybe<Scalars['String']>;
  expertise14?: Maybe<Scalars['String']>;
  expertise15?: Maybe<Scalars['String']>;
  expertise16?: Maybe<Scalars['String']>;
  expertise21?: Maybe<Scalars['String']>;
  expertise22?: Maybe<Scalars['String']>;
  expertise23?: Maybe<Scalars['String']>;
  expertise24?: Maybe<Scalars['String']>;
  expertise25?: Maybe<Scalars['String']>;
  expertise26?: Maybe<Scalars['String']>;
  expertise31?: Maybe<Scalars['String']>;
  expertise32?: Maybe<Scalars['String']>;
  expertise33?: Maybe<Scalars['String']>;
  expertise34?: Maybe<Scalars['String']>;
  expertise35?: Maybe<Scalars['String']>;
  expertise36?: Maybe<Scalars['String']>;
  extra1?: Maybe<Scalars['String']>;
  extra2?: Maybe<Scalars['String']>;
  extra3?: Maybe<Scalars['String']>;
  extra4?: Maybe<Scalars['String']>;
  extra5?: Maybe<Scalars['String']>;
  /** An array relationship */
  googleReviewLinks: Array<GoogleReviewLink>;
  /** An aggregate relationship */
  googleReviewLinksAggregate: GoogleReviewLinkAggregate;
  hobbies?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** A computed field, executes function "pro_presentation_is_rge" */
  isRge?: Maybe<Scalars['Boolean']>;
  /** A computed field, executes function "pro_presentation_main_trade_names" */
  mainTradeNames?: Maybe<Scalars['String']>;
  /** An array relationship */
  mainTrades: Array<TradeProPresentation>;
  /** An aggregate relationship */
  mainTradesAggregate: TradeProPresentationAggregate;
  /** A computed field, executes function "pro_presentation_matching_trade_guides" */
  matchingTradeGuides?: Maybe<Array<TradeGuide>>;
  name: Scalars['String'];
  /** Number of reviews awaiting moderation (not spam) visible on the presentation. */
  pendingReviewCount?: Maybe<Scalars['Int']>;
  /** An array relationship */
  proLabels: Array<ProLabel>;
  /** An aggregate relationship */
  proLabelsAggregate: ProLabelAggregate;
  /** An array relationship */
  proMediaObjects: Array<ProMediaObject>;
  /** An aggregate relationship */
  proMediaObjectsAggregate: ProMediaObjectAggregate;
  /** An array relationship */
  proReviewInvitations: Array<ProReviewInvitation>;
  /** An aggregate relationship */
  proReviewInvitationsAggregate: ProReviewInvitationAggregate;
  /** An array relationship */
  proViews: Array<ProView>;
  /** An aggregate relationship */
  proViewsAggregate: ProViewAggregate;
  profile?: Maybe<Scalars['String']>;
  /** Number of published reviews (not spam) visible on the presentation. */
  publishedReviewCount?: Maybe<Scalars['Int']>;
  /** An array relationship */
  reviews: Array<ReviewPresentation>;
  /** An aggregate relationship */
  reviewsAggregate: ReviewPresentationAggregate;
  slug: Scalars['String'];
  webhookToken: Scalars['uuid'];
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationCertificationsArgs = {
  distinctOn?: InputMaybe<Array<ProCertificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProCertificationOrderBy>>;
  where?: InputMaybe<ProCertificationBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationCertificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProCertificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProCertificationOrderBy>>;
  where?: InputMaybe<ProCertificationBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationGoogleReviewLinksArgs = {
  distinctOn?: InputMaybe<Array<GoogleReviewLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GoogleReviewLinkOrderBy>>;
  where?: InputMaybe<GoogleReviewLinkBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationGoogleReviewLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleReviewLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GoogleReviewLinkOrderBy>>;
  where?: InputMaybe<GoogleReviewLinkBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationMainTradesArgs = {
  distinctOn?: InputMaybe<Array<TradeProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProPresentationOrderBy>>;
  where?: InputMaybe<TradeProPresentationBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationMainTradesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProPresentationOrderBy>>;
  where?: InputMaybe<TradeProPresentationBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationMatchingTradeGuidesArgs = {
  distinctOn?: InputMaybe<Array<TradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGuideOrderBy>>;
  where?: InputMaybe<TradeGuideBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationProLabelsArgs = {
  distinctOn?: InputMaybe<Array<ProLabelSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProLabelOrderBy>>;
  where?: InputMaybe<ProLabelBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationProLabelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProLabelSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProLabelOrderBy>>;
  where?: InputMaybe<ProLabelBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationProMediaObjectsArgs = {
  distinctOn?: InputMaybe<Array<ProMediaObjectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMediaObjectOrderBy>>;
  where?: InputMaybe<ProMediaObjectBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationProMediaObjectsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProMediaObjectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMediaObjectOrderBy>>;
  where?: InputMaybe<ProMediaObjectBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationProReviewInvitationsArgs = {
  distinctOn?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationProReviewInvitationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationProViewsArgs = {
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationProViewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationReviewsArgs = {
  distinctOn?: InputMaybe<Array<ReviewPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewPresentationOrderBy>>;
  where?: InputMaybe<ReviewPresentationBoolExp>;
};


/** columns and relationships of "pro_presentation" */
export type ProPresentationReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewPresentationOrderBy>>;
  where?: InputMaybe<ReviewPresentationBoolExp>;
};

/** aggregated selection of "pro_presentation" */
export type ProPresentationAggregate = {
  __typename?: 'ProPresentationAggregate';
  aggregate?: Maybe<ProPresentationAggregateFields>;
  nodes: Array<ProPresentation>;
};

export type ProPresentationAggregateBoolExp = {
  count?: InputMaybe<ProPresentationAggregateBoolExpCount>;
};

/** aggregate fields of "pro_presentation" */
export type ProPresentationAggregateFields = {
  __typename?: 'ProPresentationAggregateFields';
  avg?: Maybe<ProPresentationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProPresentationMaxFields>;
  min?: Maybe<ProPresentationMinFields>;
  stddev?: Maybe<ProPresentationStddevFields>;
  stddevPop?: Maybe<ProPresentationStddevPopFields>;
  stddevSamp?: Maybe<ProPresentationStddevSampFields>;
  sum?: Maybe<ProPresentationSumFields>;
  varPop?: Maybe<ProPresentationVarPopFields>;
  varSamp?: Maybe<ProPresentationVarSampFields>;
  variance?: Maybe<ProPresentationVarianceFields>;
};


/** aggregate fields of "pro_presentation" */
export type ProPresentationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProPresentationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_presentation" */
export type ProPresentationAggregateOrderBy = {
  avg?: InputMaybe<ProPresentationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProPresentationMaxOrderBy>;
  min?: InputMaybe<ProPresentationMinOrderBy>;
  stddev?: InputMaybe<ProPresentationStddevOrderBy>;
  stddevPop?: InputMaybe<ProPresentationStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProPresentationStddevSampOrderBy>;
  sum?: InputMaybe<ProPresentationSumOrderBy>;
  varPop?: InputMaybe<ProPresentationVarPopOrderBy>;
  varSamp?: InputMaybe<ProPresentationVarSampOrderBy>;
  variance?: InputMaybe<ProPresentationVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pro_presentation" */
export type ProPresentationArrRelInsertInput = {
  data: Array<ProPresentationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProPresentationOnConflict>;
};

/** aggregate avg on columns */
export type ProPresentationAvgFields = {
  __typename?: 'ProPresentationAvgFields';
  /** Average rating of the published reviews (not spam) visible on the presentation; null without reviews. */
  averageRating?: Maybe<Scalars['float8']>;
  /** Average rating of the published Bilik reviews (not spam) visible on the presentation; null without reviews. */
  bilikAverageRating?: Maybe<Scalars['float8']>;
  /** Number of published Bilik reviews (not spam) visible on the presentation. */
  bilikReviewCount?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** Number of reviews awaiting moderation (not spam) visible on the presentation. */
  pendingReviewCount?: Maybe<Scalars['Int']>;
  /** Number of published reviews (not spam) visible on the presentation. */
  publishedReviewCount?: Maybe<Scalars['Int']>;
};

/** order by avg() on columns of table "pro_presentation" */
export type ProPresentationAvgOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_presentation". All fields are combined with a logical 'AND'. */
export type ProPresentationBoolExp = {
  _and?: InputMaybe<Array<ProPresentationBoolExp>>;
  _not?: InputMaybe<ProPresentationBoolExp>;
  _or?: InputMaybe<Array<ProPresentationBoolExp>>;
  averageRating?: InputMaybe<Float8ComparisonExp>;
  bilikAverageRating?: InputMaybe<Float8ComparisonExp>;
  bilikReviewCount?: InputMaybe<IntComparisonExp>;
  certifications?: InputMaybe<ProCertificationBoolExp>;
  certificationsAggregate?: InputMaybe<ProCertificationAggregateBoolExp>;
  company?: InputMaybe<CompanyBoolExp>;
  companyId?: InputMaybe<IntComparisonExp>;
  customReviewInvitationDunningEmail?: InputMaybe<StringComparisonExp>;
  customReviewInvitationEmail?: InputMaybe<StringComparisonExp>;
  dateCreated?: InputMaybe<TimestamptzComparisonExp>;
  expertise1?: InputMaybe<StringComparisonExp>;
  expertise2?: InputMaybe<StringComparisonExp>;
  expertise3?: InputMaybe<StringComparisonExp>;
  expertise11?: InputMaybe<StringComparisonExp>;
  expertise12?: InputMaybe<StringComparisonExp>;
  expertise13?: InputMaybe<StringComparisonExp>;
  expertise14?: InputMaybe<StringComparisonExp>;
  expertise15?: InputMaybe<StringComparisonExp>;
  expertise16?: InputMaybe<StringComparisonExp>;
  expertise21?: InputMaybe<StringComparisonExp>;
  expertise22?: InputMaybe<StringComparisonExp>;
  expertise23?: InputMaybe<StringComparisonExp>;
  expertise24?: InputMaybe<StringComparisonExp>;
  expertise25?: InputMaybe<StringComparisonExp>;
  expertise26?: InputMaybe<StringComparisonExp>;
  expertise31?: InputMaybe<StringComparisonExp>;
  expertise32?: InputMaybe<StringComparisonExp>;
  expertise33?: InputMaybe<StringComparisonExp>;
  expertise34?: InputMaybe<StringComparisonExp>;
  expertise35?: InputMaybe<StringComparisonExp>;
  expertise36?: InputMaybe<StringComparisonExp>;
  extra1?: InputMaybe<StringComparisonExp>;
  extra2?: InputMaybe<StringComparisonExp>;
  extra3?: InputMaybe<StringComparisonExp>;
  extra4?: InputMaybe<StringComparisonExp>;
  extra5?: InputMaybe<StringComparisonExp>;
  googleReviewLinks?: InputMaybe<GoogleReviewLinkBoolExp>;
  googleReviewLinksAggregate?: InputMaybe<GoogleReviewLinkAggregateBoolExp>;
  hobbies?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  isRge?: InputMaybe<BooleanComparisonExp>;
  mainTradeNames?: InputMaybe<StringComparisonExp>;
  mainTrades?: InputMaybe<TradeProPresentationBoolExp>;
  mainTradesAggregate?: InputMaybe<TradeProPresentationAggregateBoolExp>;
  matchingTradeGuides?: InputMaybe<TradeGuideBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  pendingReviewCount?: InputMaybe<IntComparisonExp>;
  proLabels?: InputMaybe<ProLabelBoolExp>;
  proLabelsAggregate?: InputMaybe<ProLabelAggregateBoolExp>;
  proMediaObjects?: InputMaybe<ProMediaObjectBoolExp>;
  proMediaObjectsAggregate?: InputMaybe<ProMediaObjectAggregateBoolExp>;
  proReviewInvitations?: InputMaybe<ProReviewInvitationBoolExp>;
  proReviewInvitationsAggregate?: InputMaybe<ProReviewInvitationAggregateBoolExp>;
  proViews?: InputMaybe<ProViewBoolExp>;
  proViewsAggregate?: InputMaybe<ProViewAggregateBoolExp>;
  profile?: InputMaybe<StringComparisonExp>;
  publishedReviewCount?: InputMaybe<IntComparisonExp>;
  reviews?: InputMaybe<ReviewPresentationBoolExp>;
  reviewsAggregate?: InputMaybe<ReviewPresentationAggregateBoolExp>;
  slug?: InputMaybe<StringComparisonExp>;
  webhookToken?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "pro_presentation" */
export enum ProPresentationConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22966Primary = 'idx_22966_primary',
  /** unique or primary key constraint on columns "slug" */
  Idx_22966Uniq_89076416989d9b62 = 'idx_22966_uniq_89076416989d9b62',
  /** unique or primary key constraint on columns "webhook_token" */
  ProPresentationWebhookTokenKey = 'pro_presentation_webhook_token_key'
}

/** input type for incrementing numeric columns in table "pro_presentation" */
export type ProPresentationIncInput = {
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_presentation" */
export type ProPresentationInsertInput = {
  certifications?: InputMaybe<ProCertificationArrRelInsertInput>;
  company?: InputMaybe<CompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['Int']>;
  customReviewInvitationDunningEmail?: InputMaybe<Scalars['String']>;
  customReviewInvitationEmail?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  expertise1?: InputMaybe<Scalars['String']>;
  expertise2?: InputMaybe<Scalars['String']>;
  expertise3?: InputMaybe<Scalars['String']>;
  expertise11?: InputMaybe<Scalars['String']>;
  expertise12?: InputMaybe<Scalars['String']>;
  expertise13?: InputMaybe<Scalars['String']>;
  expertise14?: InputMaybe<Scalars['String']>;
  expertise15?: InputMaybe<Scalars['String']>;
  expertise16?: InputMaybe<Scalars['String']>;
  expertise21?: InputMaybe<Scalars['String']>;
  expertise22?: InputMaybe<Scalars['String']>;
  expertise23?: InputMaybe<Scalars['String']>;
  expertise24?: InputMaybe<Scalars['String']>;
  expertise25?: InputMaybe<Scalars['String']>;
  expertise26?: InputMaybe<Scalars['String']>;
  expertise31?: InputMaybe<Scalars['String']>;
  expertise32?: InputMaybe<Scalars['String']>;
  expertise33?: InputMaybe<Scalars['String']>;
  expertise34?: InputMaybe<Scalars['String']>;
  expertise35?: InputMaybe<Scalars['String']>;
  expertise36?: InputMaybe<Scalars['String']>;
  extra1?: InputMaybe<Scalars['String']>;
  extra2?: InputMaybe<Scalars['String']>;
  extra3?: InputMaybe<Scalars['String']>;
  extra4?: InputMaybe<Scalars['String']>;
  extra5?: InputMaybe<Scalars['String']>;
  googleReviewLinks?: InputMaybe<GoogleReviewLinkArrRelInsertInput>;
  hobbies?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  mainTrades?: InputMaybe<TradeProPresentationArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  proLabels?: InputMaybe<ProLabelArrRelInsertInput>;
  proMediaObjects?: InputMaybe<ProMediaObjectArrRelInsertInput>;
  proReviewInvitations?: InputMaybe<ProReviewInvitationArrRelInsertInput>;
  proViews?: InputMaybe<ProViewArrRelInsertInput>;
  profile?: InputMaybe<Scalars['String']>;
  reviews?: InputMaybe<ReviewPresentationArrRelInsertInput>;
  slug?: InputMaybe<Scalars['String']>;
  webhookToken?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ProPresentationMaxFields = {
  __typename?: 'ProPresentationMaxFields';
  /** Average rating of the published reviews (not spam) visible on the presentation; null without reviews. */
  averageRating?: Maybe<Scalars['float8']>;
  /** Average rating of the published Bilik reviews (not spam) visible on the presentation; null without reviews. */
  bilikAverageRating?: Maybe<Scalars['float8']>;
  /** Number of published Bilik reviews (not spam) visible on the presentation. */
  bilikReviewCount?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  customReviewInvitationDunningEmail?: Maybe<Scalars['String']>;
  customReviewInvitationEmail?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['timestamptz']>;
  expertise1?: Maybe<Scalars['String']>;
  expertise2?: Maybe<Scalars['String']>;
  expertise3?: Maybe<Scalars['String']>;
  expertise11?: Maybe<Scalars['String']>;
  expertise12?: Maybe<Scalars['String']>;
  expertise13?: Maybe<Scalars['String']>;
  expertise14?: Maybe<Scalars['String']>;
  expertise15?: Maybe<Scalars['String']>;
  expertise16?: Maybe<Scalars['String']>;
  expertise21?: Maybe<Scalars['String']>;
  expertise22?: Maybe<Scalars['String']>;
  expertise23?: Maybe<Scalars['String']>;
  expertise24?: Maybe<Scalars['String']>;
  expertise25?: Maybe<Scalars['String']>;
  expertise26?: Maybe<Scalars['String']>;
  expertise31?: Maybe<Scalars['String']>;
  expertise32?: Maybe<Scalars['String']>;
  expertise33?: Maybe<Scalars['String']>;
  expertise34?: Maybe<Scalars['String']>;
  expertise35?: Maybe<Scalars['String']>;
  expertise36?: Maybe<Scalars['String']>;
  extra1?: Maybe<Scalars['String']>;
  extra2?: Maybe<Scalars['String']>;
  extra3?: Maybe<Scalars['String']>;
  extra4?: Maybe<Scalars['String']>;
  extra5?: Maybe<Scalars['String']>;
  hobbies?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "pro_presentation_main_trade_names" */
  mainTradeNames?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Number of reviews awaiting moderation (not spam) visible on the presentation. */
  pendingReviewCount?: Maybe<Scalars['Int']>;
  profile?: Maybe<Scalars['String']>;
  /** Number of published reviews (not spam) visible on the presentation. */
  publishedReviewCount?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  webhookToken?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "pro_presentation" */
export type ProPresentationMaxOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  customReviewInvitationDunningEmail?: InputMaybe<OrderBy>;
  customReviewInvitationEmail?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  expertise1?: InputMaybe<OrderBy>;
  expertise2?: InputMaybe<OrderBy>;
  expertise3?: InputMaybe<OrderBy>;
  expertise11?: InputMaybe<OrderBy>;
  expertise12?: InputMaybe<OrderBy>;
  expertise13?: InputMaybe<OrderBy>;
  expertise14?: InputMaybe<OrderBy>;
  expertise15?: InputMaybe<OrderBy>;
  expertise16?: InputMaybe<OrderBy>;
  expertise21?: InputMaybe<OrderBy>;
  expertise22?: InputMaybe<OrderBy>;
  expertise23?: InputMaybe<OrderBy>;
  expertise24?: InputMaybe<OrderBy>;
  expertise25?: InputMaybe<OrderBy>;
  expertise26?: InputMaybe<OrderBy>;
  expertise31?: InputMaybe<OrderBy>;
  expertise32?: InputMaybe<OrderBy>;
  expertise33?: InputMaybe<OrderBy>;
  expertise34?: InputMaybe<OrderBy>;
  expertise35?: InputMaybe<OrderBy>;
  expertise36?: InputMaybe<OrderBy>;
  extra1?: InputMaybe<OrderBy>;
  extra2?: InputMaybe<OrderBy>;
  extra3?: InputMaybe<OrderBy>;
  extra4?: InputMaybe<OrderBy>;
  extra5?: InputMaybe<OrderBy>;
  hobbies?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  profile?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  webhookToken?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProPresentationMinFields = {
  __typename?: 'ProPresentationMinFields';
  /** Average rating of the published reviews (not spam) visible on the presentation; null without reviews. */
  averageRating?: Maybe<Scalars['float8']>;
  /** Average rating of the published Bilik reviews (not spam) visible on the presentation; null without reviews. */
  bilikAverageRating?: Maybe<Scalars['float8']>;
  /** Number of published Bilik reviews (not spam) visible on the presentation. */
  bilikReviewCount?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  customReviewInvitationDunningEmail?: Maybe<Scalars['String']>;
  customReviewInvitationEmail?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['timestamptz']>;
  expertise1?: Maybe<Scalars['String']>;
  expertise2?: Maybe<Scalars['String']>;
  expertise3?: Maybe<Scalars['String']>;
  expertise11?: Maybe<Scalars['String']>;
  expertise12?: Maybe<Scalars['String']>;
  expertise13?: Maybe<Scalars['String']>;
  expertise14?: Maybe<Scalars['String']>;
  expertise15?: Maybe<Scalars['String']>;
  expertise16?: Maybe<Scalars['String']>;
  expertise21?: Maybe<Scalars['String']>;
  expertise22?: Maybe<Scalars['String']>;
  expertise23?: Maybe<Scalars['String']>;
  expertise24?: Maybe<Scalars['String']>;
  expertise25?: Maybe<Scalars['String']>;
  expertise26?: Maybe<Scalars['String']>;
  expertise31?: Maybe<Scalars['String']>;
  expertise32?: Maybe<Scalars['String']>;
  expertise33?: Maybe<Scalars['String']>;
  expertise34?: Maybe<Scalars['String']>;
  expertise35?: Maybe<Scalars['String']>;
  expertise36?: Maybe<Scalars['String']>;
  extra1?: Maybe<Scalars['String']>;
  extra2?: Maybe<Scalars['String']>;
  extra3?: Maybe<Scalars['String']>;
  extra4?: Maybe<Scalars['String']>;
  extra5?: Maybe<Scalars['String']>;
  hobbies?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "pro_presentation_main_trade_names" */
  mainTradeNames?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Number of reviews awaiting moderation (not spam) visible on the presentation. */
  pendingReviewCount?: Maybe<Scalars['Int']>;
  profile?: Maybe<Scalars['String']>;
  /** Number of published reviews (not spam) visible on the presentation. */
  publishedReviewCount?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  webhookToken?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "pro_presentation" */
export type ProPresentationMinOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  customReviewInvitationDunningEmail?: InputMaybe<OrderBy>;
  customReviewInvitationEmail?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  expertise1?: InputMaybe<OrderBy>;
  expertise2?: InputMaybe<OrderBy>;
  expertise3?: InputMaybe<OrderBy>;
  expertise11?: InputMaybe<OrderBy>;
  expertise12?: InputMaybe<OrderBy>;
  expertise13?: InputMaybe<OrderBy>;
  expertise14?: InputMaybe<OrderBy>;
  expertise15?: InputMaybe<OrderBy>;
  expertise16?: InputMaybe<OrderBy>;
  expertise21?: InputMaybe<OrderBy>;
  expertise22?: InputMaybe<OrderBy>;
  expertise23?: InputMaybe<OrderBy>;
  expertise24?: InputMaybe<OrderBy>;
  expertise25?: InputMaybe<OrderBy>;
  expertise26?: InputMaybe<OrderBy>;
  expertise31?: InputMaybe<OrderBy>;
  expertise32?: InputMaybe<OrderBy>;
  expertise33?: InputMaybe<OrderBy>;
  expertise34?: InputMaybe<OrderBy>;
  expertise35?: InputMaybe<OrderBy>;
  expertise36?: InputMaybe<OrderBy>;
  extra1?: InputMaybe<OrderBy>;
  extra2?: InputMaybe<OrderBy>;
  extra3?: InputMaybe<OrderBy>;
  extra4?: InputMaybe<OrderBy>;
  extra5?: InputMaybe<OrderBy>;
  hobbies?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  profile?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  webhookToken?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_presentation" */
export type ProPresentationMutationResponse = {
  __typename?: 'ProPresentationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProPresentation>;
};

/** input type for inserting object relation for remote table "pro_presentation" */
export type ProPresentationObjRelInsertInput = {
  data: ProPresentationInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ProPresentationOnConflict>;
};

/** on_conflict condition type for table "pro_presentation" */
export type ProPresentationOnConflict = {
  constraint: ProPresentationConstraint;
  updateColumns?: Array<ProPresentationUpdateColumn>;
  where?: InputMaybe<ProPresentationBoolExp>;
};

/** Ordering options when selecting data from "pro_presentation". */
export type ProPresentationOrderBy = {
  averageRating?: InputMaybe<OrderBy>;
  bilikAverageRating?: InputMaybe<OrderBy>;
  bilikReviewCount?: InputMaybe<OrderBy>;
  certificationsAggregate?: InputMaybe<ProCertificationAggregateOrderBy>;
  company?: InputMaybe<CompanyOrderBy>;
  companyId?: InputMaybe<OrderBy>;
  customReviewInvitationDunningEmail?: InputMaybe<OrderBy>;
  customReviewInvitationEmail?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  expertise1?: InputMaybe<OrderBy>;
  expertise2?: InputMaybe<OrderBy>;
  expertise3?: InputMaybe<OrderBy>;
  expertise11?: InputMaybe<OrderBy>;
  expertise12?: InputMaybe<OrderBy>;
  expertise13?: InputMaybe<OrderBy>;
  expertise14?: InputMaybe<OrderBy>;
  expertise15?: InputMaybe<OrderBy>;
  expertise16?: InputMaybe<OrderBy>;
  expertise21?: InputMaybe<OrderBy>;
  expertise22?: InputMaybe<OrderBy>;
  expertise23?: InputMaybe<OrderBy>;
  expertise24?: InputMaybe<OrderBy>;
  expertise25?: InputMaybe<OrderBy>;
  expertise26?: InputMaybe<OrderBy>;
  expertise31?: InputMaybe<OrderBy>;
  expertise32?: InputMaybe<OrderBy>;
  expertise33?: InputMaybe<OrderBy>;
  expertise34?: InputMaybe<OrderBy>;
  expertise35?: InputMaybe<OrderBy>;
  expertise36?: InputMaybe<OrderBy>;
  extra1?: InputMaybe<OrderBy>;
  extra2?: InputMaybe<OrderBy>;
  extra3?: InputMaybe<OrderBy>;
  extra4?: InputMaybe<OrderBy>;
  extra5?: InputMaybe<OrderBy>;
  googleReviewLinksAggregate?: InputMaybe<GoogleReviewLinkAggregateOrderBy>;
  hobbies?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isRge?: InputMaybe<OrderBy>;
  mainTradeNames?: InputMaybe<OrderBy>;
  mainTradesAggregate?: InputMaybe<TradeProPresentationAggregateOrderBy>;
  matchingTradeGuidesAggregate?: InputMaybe<TradeGuideAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  pendingReviewCount?: InputMaybe<OrderBy>;
  proLabelsAggregate?: InputMaybe<ProLabelAggregateOrderBy>;
  proMediaObjectsAggregate?: InputMaybe<ProMediaObjectAggregateOrderBy>;
  proReviewInvitationsAggregate?: InputMaybe<ProReviewInvitationAggregateOrderBy>;
  proViewsAggregate?: InputMaybe<ProViewAggregateOrderBy>;
  profile?: InputMaybe<OrderBy>;
  publishedReviewCount?: InputMaybe<OrderBy>;
  reviewsAggregate?: InputMaybe<ReviewPresentationAggregateOrderBy>;
  slug?: InputMaybe<OrderBy>;
  webhookToken?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_presentation */
export type ProPresentationPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "pro_presentation" */
export enum ProPresentationSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CustomReviewInvitationDunningEmail = 'customReviewInvitationDunningEmail',
  /** column name */
  CustomReviewInvitationEmail = 'customReviewInvitationEmail',
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  Expertise1 = 'expertise1',
  /** column name */
  Expertise2 = 'expertise2',
  /** column name */
  Expertise3 = 'expertise3',
  /** column name */
  Expertise11 = 'expertise11',
  /** column name */
  Expertise12 = 'expertise12',
  /** column name */
  Expertise13 = 'expertise13',
  /** column name */
  Expertise14 = 'expertise14',
  /** column name */
  Expertise15 = 'expertise15',
  /** column name */
  Expertise16 = 'expertise16',
  /** column name */
  Expertise21 = 'expertise21',
  /** column name */
  Expertise22 = 'expertise22',
  /** column name */
  Expertise23 = 'expertise23',
  /** column name */
  Expertise24 = 'expertise24',
  /** column name */
  Expertise25 = 'expertise25',
  /** column name */
  Expertise26 = 'expertise26',
  /** column name */
  Expertise31 = 'expertise31',
  /** column name */
  Expertise32 = 'expertise32',
  /** column name */
  Expertise33 = 'expertise33',
  /** column name */
  Expertise34 = 'expertise34',
  /** column name */
  Expertise35 = 'expertise35',
  /** column name */
  Expertise36 = 'expertise36',
  /** column name */
  Extra1 = 'extra1',
  /** column name */
  Extra2 = 'extra2',
  /** column name */
  Extra3 = 'extra3',
  /** column name */
  Extra4 = 'extra4',
  /** column name */
  Extra5 = 'extra5',
  /** column name */
  Hobbies = 'hobbies',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Profile = 'profile',
  /** column name */
  Slug = 'slug',
  /** column name */
  WebhookToken = 'webhookToken'
}

/** input type for updating data in table "pro_presentation" */
export type ProPresentationSetInput = {
  companyId?: InputMaybe<Scalars['Int']>;
  customReviewInvitationDunningEmail?: InputMaybe<Scalars['String']>;
  customReviewInvitationEmail?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  expertise1?: InputMaybe<Scalars['String']>;
  expertise2?: InputMaybe<Scalars['String']>;
  expertise3?: InputMaybe<Scalars['String']>;
  expertise11?: InputMaybe<Scalars['String']>;
  expertise12?: InputMaybe<Scalars['String']>;
  expertise13?: InputMaybe<Scalars['String']>;
  expertise14?: InputMaybe<Scalars['String']>;
  expertise15?: InputMaybe<Scalars['String']>;
  expertise16?: InputMaybe<Scalars['String']>;
  expertise21?: InputMaybe<Scalars['String']>;
  expertise22?: InputMaybe<Scalars['String']>;
  expertise23?: InputMaybe<Scalars['String']>;
  expertise24?: InputMaybe<Scalars['String']>;
  expertise25?: InputMaybe<Scalars['String']>;
  expertise26?: InputMaybe<Scalars['String']>;
  expertise31?: InputMaybe<Scalars['String']>;
  expertise32?: InputMaybe<Scalars['String']>;
  expertise33?: InputMaybe<Scalars['String']>;
  expertise34?: InputMaybe<Scalars['String']>;
  expertise35?: InputMaybe<Scalars['String']>;
  expertise36?: InputMaybe<Scalars['String']>;
  extra1?: InputMaybe<Scalars['String']>;
  extra2?: InputMaybe<Scalars['String']>;
  extra3?: InputMaybe<Scalars['String']>;
  extra4?: InputMaybe<Scalars['String']>;
  extra5?: InputMaybe<Scalars['String']>;
  hobbies?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  webhookToken?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ProPresentationStddevFields = {
  __typename?: 'ProPresentationStddevFields';
  /** Average rating of the published reviews (not spam) visible on the presentation; null without reviews. */
  averageRating?: Maybe<Scalars['float8']>;
  /** Average rating of the published Bilik reviews (not spam) visible on the presentation; null without reviews. */
  bilikAverageRating?: Maybe<Scalars['float8']>;
  /** Number of published Bilik reviews (not spam) visible on the presentation. */
  bilikReviewCount?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** Number of reviews awaiting moderation (not spam) visible on the presentation. */
  pendingReviewCount?: Maybe<Scalars['Int']>;
  /** Number of published reviews (not spam) visible on the presentation. */
  publishedReviewCount?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "pro_presentation" */
export type ProPresentationStddevOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProPresentationStddevPopFields = {
  __typename?: 'ProPresentationStddevPopFields';
  /** Average rating of the published reviews (not spam) visible on the presentation; null without reviews. */
  averageRating?: Maybe<Scalars['float8']>;
  /** Average rating of the published Bilik reviews (not spam) visible on the presentation; null without reviews. */
  bilikAverageRating?: Maybe<Scalars['float8']>;
  /** Number of published Bilik reviews (not spam) visible on the presentation. */
  bilikReviewCount?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** Number of reviews awaiting moderation (not spam) visible on the presentation. */
  pendingReviewCount?: Maybe<Scalars['Int']>;
  /** Number of published reviews (not spam) visible on the presentation. */
  publishedReviewCount?: Maybe<Scalars['Int']>;
};

/** order by stddevPop() on columns of table "pro_presentation" */
export type ProPresentationStddevPopOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProPresentationStddevSampFields = {
  __typename?: 'ProPresentationStddevSampFields';
  /** Average rating of the published reviews (not spam) visible on the presentation; null without reviews. */
  averageRating?: Maybe<Scalars['float8']>;
  /** Average rating of the published Bilik reviews (not spam) visible on the presentation; null without reviews. */
  bilikAverageRating?: Maybe<Scalars['float8']>;
  /** Number of published Bilik reviews (not spam) visible on the presentation. */
  bilikReviewCount?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** Number of reviews awaiting moderation (not spam) visible on the presentation. */
  pendingReviewCount?: Maybe<Scalars['Int']>;
  /** Number of published reviews (not spam) visible on the presentation. */
  publishedReviewCount?: Maybe<Scalars['Int']>;
};

/** order by stddevSamp() on columns of table "pro_presentation" */
export type ProPresentationStddevSampOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_presentation" */
export type ProPresentationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProPresentationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProPresentationStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['Int']>;
  customReviewInvitationDunningEmail?: InputMaybe<Scalars['String']>;
  customReviewInvitationEmail?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  expertise1?: InputMaybe<Scalars['String']>;
  expertise2?: InputMaybe<Scalars['String']>;
  expertise3?: InputMaybe<Scalars['String']>;
  expertise11?: InputMaybe<Scalars['String']>;
  expertise12?: InputMaybe<Scalars['String']>;
  expertise13?: InputMaybe<Scalars['String']>;
  expertise14?: InputMaybe<Scalars['String']>;
  expertise15?: InputMaybe<Scalars['String']>;
  expertise16?: InputMaybe<Scalars['String']>;
  expertise21?: InputMaybe<Scalars['String']>;
  expertise22?: InputMaybe<Scalars['String']>;
  expertise23?: InputMaybe<Scalars['String']>;
  expertise24?: InputMaybe<Scalars['String']>;
  expertise25?: InputMaybe<Scalars['String']>;
  expertise26?: InputMaybe<Scalars['String']>;
  expertise31?: InputMaybe<Scalars['String']>;
  expertise32?: InputMaybe<Scalars['String']>;
  expertise33?: InputMaybe<Scalars['String']>;
  expertise34?: InputMaybe<Scalars['String']>;
  expertise35?: InputMaybe<Scalars['String']>;
  expertise36?: InputMaybe<Scalars['String']>;
  extra1?: InputMaybe<Scalars['String']>;
  extra2?: InputMaybe<Scalars['String']>;
  extra3?: InputMaybe<Scalars['String']>;
  extra4?: InputMaybe<Scalars['String']>;
  extra5?: InputMaybe<Scalars['String']>;
  hobbies?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  webhookToken?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ProPresentationSumFields = {
  __typename?: 'ProPresentationSumFields';
  /** Average rating of the published reviews (not spam) visible on the presentation; null without reviews. */
  averageRating?: Maybe<Scalars['float8']>;
  /** Average rating of the published Bilik reviews (not spam) visible on the presentation; null without reviews. */
  bilikAverageRating?: Maybe<Scalars['float8']>;
  /** Number of published Bilik reviews (not spam) visible on the presentation. */
  bilikReviewCount?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** Number of reviews awaiting moderation (not spam) visible on the presentation. */
  pendingReviewCount?: Maybe<Scalars['Int']>;
  /** Number of published reviews (not spam) visible on the presentation. */
  publishedReviewCount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pro_presentation" */
export type ProPresentationSumOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_presentation" */
export enum ProPresentationUpdateColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CustomReviewInvitationDunningEmail = 'customReviewInvitationDunningEmail',
  /** column name */
  CustomReviewInvitationEmail = 'customReviewInvitationEmail',
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  Expertise1 = 'expertise1',
  /** column name */
  Expertise2 = 'expertise2',
  /** column name */
  Expertise3 = 'expertise3',
  /** column name */
  Expertise11 = 'expertise11',
  /** column name */
  Expertise12 = 'expertise12',
  /** column name */
  Expertise13 = 'expertise13',
  /** column name */
  Expertise14 = 'expertise14',
  /** column name */
  Expertise15 = 'expertise15',
  /** column name */
  Expertise16 = 'expertise16',
  /** column name */
  Expertise21 = 'expertise21',
  /** column name */
  Expertise22 = 'expertise22',
  /** column name */
  Expertise23 = 'expertise23',
  /** column name */
  Expertise24 = 'expertise24',
  /** column name */
  Expertise25 = 'expertise25',
  /** column name */
  Expertise26 = 'expertise26',
  /** column name */
  Expertise31 = 'expertise31',
  /** column name */
  Expertise32 = 'expertise32',
  /** column name */
  Expertise33 = 'expertise33',
  /** column name */
  Expertise34 = 'expertise34',
  /** column name */
  Expertise35 = 'expertise35',
  /** column name */
  Expertise36 = 'expertise36',
  /** column name */
  Extra1 = 'extra1',
  /** column name */
  Extra2 = 'extra2',
  /** column name */
  Extra3 = 'extra3',
  /** column name */
  Extra4 = 'extra4',
  /** column name */
  Extra5 = 'extra5',
  /** column name */
  Hobbies = 'hobbies',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Profile = 'profile',
  /** column name */
  Slug = 'slug',
  /** column name */
  WebhookToken = 'webhookToken'
}

export type ProPresentationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProPresentationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProPresentationSetInput>;
  /** filter the rows which have to be updated */
  where: ProPresentationBoolExp;
};

/** aggregate varPop on columns */
export type ProPresentationVarPopFields = {
  __typename?: 'ProPresentationVarPopFields';
  /** Average rating of the published reviews (not spam) visible on the presentation; null without reviews. */
  averageRating?: Maybe<Scalars['float8']>;
  /** Average rating of the published Bilik reviews (not spam) visible on the presentation; null without reviews. */
  bilikAverageRating?: Maybe<Scalars['float8']>;
  /** Number of published Bilik reviews (not spam) visible on the presentation. */
  bilikReviewCount?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** Number of reviews awaiting moderation (not spam) visible on the presentation. */
  pendingReviewCount?: Maybe<Scalars['Int']>;
  /** Number of published reviews (not spam) visible on the presentation. */
  publishedReviewCount?: Maybe<Scalars['Int']>;
};

/** order by varPop() on columns of table "pro_presentation" */
export type ProPresentationVarPopOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProPresentationVarSampFields = {
  __typename?: 'ProPresentationVarSampFields';
  /** Average rating of the published reviews (not spam) visible on the presentation; null without reviews. */
  averageRating?: Maybe<Scalars['float8']>;
  /** Average rating of the published Bilik reviews (not spam) visible on the presentation; null without reviews. */
  bilikAverageRating?: Maybe<Scalars['float8']>;
  /** Number of published Bilik reviews (not spam) visible on the presentation. */
  bilikReviewCount?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** Number of reviews awaiting moderation (not spam) visible on the presentation. */
  pendingReviewCount?: Maybe<Scalars['Int']>;
  /** Number of published reviews (not spam) visible on the presentation. */
  publishedReviewCount?: Maybe<Scalars['Int']>;
};

/** order by varSamp() on columns of table "pro_presentation" */
export type ProPresentationVarSampOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProPresentationVarianceFields = {
  __typename?: 'ProPresentationVarianceFields';
  /** Average rating of the published reviews (not spam) visible on the presentation; null without reviews. */
  averageRating?: Maybe<Scalars['float8']>;
  /** Average rating of the published Bilik reviews (not spam) visible on the presentation; null without reviews. */
  bilikAverageRating?: Maybe<Scalars['float8']>;
  /** Number of published Bilik reviews (not spam) visible on the presentation. */
  bilikReviewCount?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** Number of reviews awaiting moderation (not spam) visible on the presentation. */
  pendingReviewCount?: Maybe<Scalars['Int']>;
  /** Number of published reviews (not spam) visible on the presentation. */
  publishedReviewCount?: Maybe<Scalars['Int']>;
};

/** order by variance() on columns of table "pro_presentation" */
export type ProPresentationVarianceOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "pro_price" */
export type ProPrice = {
  __typename?: 'ProPrice';
  content: Scalars['String'];
  id: Scalars['Int'];
  isRepair: Scalars['Boolean'];
  /** An object relationship */
  proView: ProView;
  proViewId: Scalars['Int'];
  title: Scalars['String'];
};

/** aggregated selection of "pro_price" */
export type ProPriceAggregate = {
  __typename?: 'ProPriceAggregate';
  aggregate?: Maybe<ProPriceAggregateFields>;
  nodes: Array<ProPrice>;
};

export type ProPriceAggregateBoolExp = {
  bool_and?: InputMaybe<ProPriceAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<ProPriceAggregateBoolExpBoolOr>;
  count?: InputMaybe<ProPriceAggregateBoolExpCount>;
};

/** aggregate fields of "pro_price" */
export type ProPriceAggregateFields = {
  __typename?: 'ProPriceAggregateFields';
  avg?: Maybe<ProPriceAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProPriceMaxFields>;
  min?: Maybe<ProPriceMinFields>;
  stddev?: Maybe<ProPriceStddevFields>;
  stddevPop?: Maybe<ProPriceStddevPopFields>;
  stddevSamp?: Maybe<ProPriceStddevSampFields>;
  sum?: Maybe<ProPriceSumFields>;
  varPop?: Maybe<ProPriceVarPopFields>;
  varSamp?: Maybe<ProPriceVarSampFields>;
  variance?: Maybe<ProPriceVarianceFields>;
};


/** aggregate fields of "pro_price" */
export type ProPriceAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProPriceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_price" */
export type ProPriceAggregateOrderBy = {
  avg?: InputMaybe<ProPriceAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProPriceMaxOrderBy>;
  min?: InputMaybe<ProPriceMinOrderBy>;
  stddev?: InputMaybe<ProPriceStddevOrderBy>;
  stddevPop?: InputMaybe<ProPriceStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProPriceStddevSampOrderBy>;
  sum?: InputMaybe<ProPriceSumOrderBy>;
  varPop?: InputMaybe<ProPriceVarPopOrderBy>;
  varSamp?: InputMaybe<ProPriceVarSampOrderBy>;
  variance?: InputMaybe<ProPriceVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pro_price" */
export type ProPriceArrRelInsertInput = {
  data: Array<ProPriceInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProPriceOnConflict>;
};

/** aggregate avg on columns */
export type ProPriceAvgFields = {
  __typename?: 'ProPriceAvgFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pro_price" */
export type ProPriceAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_price". All fields are combined with a logical 'AND'. */
export type ProPriceBoolExp = {
  _and?: InputMaybe<Array<ProPriceBoolExp>>;
  _not?: InputMaybe<ProPriceBoolExp>;
  _or?: InputMaybe<Array<ProPriceBoolExp>>;
  content?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  isRepair?: InputMaybe<BooleanComparisonExp>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "pro_price" */
export enum ProPriceConstraint {
  /** unique or primary key constraint on columns "id" */
  ProPricePkey = 'pro_price_pkey'
}

/** input type for incrementing numeric columns in table "pro_price" */
export type ProPriceIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_price" */
export type ProPriceInsertInput = {
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isRepair?: InputMaybe<Scalars['Boolean']>;
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProPriceMaxFields = {
  __typename?: 'ProPriceMaxFields';
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "pro_price" */
export type ProPriceMaxOrderBy = {
  content?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProPriceMinFields = {
  __typename?: 'ProPriceMinFields';
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "pro_price" */
export type ProPriceMinOrderBy = {
  content?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_price" */
export type ProPriceMutationResponse = {
  __typename?: 'ProPriceMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProPrice>;
};

/** on_conflict condition type for table "pro_price" */
export type ProPriceOnConflict = {
  constraint: ProPriceConstraint;
  updateColumns?: Array<ProPriceUpdateColumn>;
  where?: InputMaybe<ProPriceBoolExp>;
};

/** Ordering options when selecting data from "pro_price". */
export type ProPriceOrderBy = {
  content?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isRepair?: InputMaybe<OrderBy>;
  proView?: InputMaybe<ProViewOrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_price */
export type ProPricePkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "pro_price" */
export enum ProPriceSelectColumn {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  IsRepair = 'isRepair',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  Title = 'title'
}

/** select "proPriceAggregateBoolExpBool_andArgumentsColumns" columns of table "pro_price" */
export enum ProPriceSelectColumnProPriceAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsRepair = 'isRepair'
}

/** select "proPriceAggregateBoolExpBool_orArgumentsColumns" columns of table "pro_price" */
export enum ProPriceSelectColumnProPriceAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsRepair = 'isRepair'
}

/** input type for updating data in table "pro_price" */
export type ProPriceSetInput = {
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isRepair?: InputMaybe<Scalars['Boolean']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProPriceStddevFields = {
  __typename?: 'ProPriceStddevFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pro_price" */
export type ProPriceStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProPriceStddevPopFields = {
  __typename?: 'ProPriceStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pro_price" */
export type ProPriceStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProPriceStddevSampFields = {
  __typename?: 'ProPriceStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pro_price" */
export type ProPriceStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_price" */
export type ProPriceStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProPriceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProPriceStreamCursorValueInput = {
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isRepair?: InputMaybe<Scalars['Boolean']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ProPriceSumFields = {
  __typename?: 'ProPriceSumFields';
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pro_price" */
export type ProPriceSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_price" */
export enum ProPriceUpdateColumn {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  IsRepair = 'isRepair',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  Title = 'title'
}

export type ProPriceUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProPriceIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProPriceSetInput>;
  /** filter the rows which have to be updated */
  where: ProPriceBoolExp;
};

/** aggregate varPop on columns */
export type ProPriceVarPopFields = {
  __typename?: 'ProPriceVarPopFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pro_price" */
export type ProPriceVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProPriceVarSampFields = {
  __typename?: 'ProPriceVarSampFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pro_price" */
export type ProPriceVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProPriceVarianceFields = {
  __typename?: 'ProPriceVarianceFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pro_price" */
export type ProPriceVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "pro_review" */
export type ProReview = {
  __typename?: 'ProReview';
  /** A computed field, executes function "pro_review_address_locality" */
  addressLocality?: Maybe<Scalars['String']>;
  checkDate?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  checker?: Maybe<BilikPerson>;
  checkerId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  dateCreated: Scalars['timestamptz'];
  dateOfWork?: Maybe<Scalars['timestamptz']>;
  deprecatedAddressLocality?: Maybe<Scalars['String']>;
  /** An array relationship */
  duplicateProReviews: Array<ProReview>;
  /** An aggregate relationship */
  duplicateProReviewsAggregate: ProReviewAggregate;
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['Int'];
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId: Scalars['Int'];
  ip?: Maybe<Scalars['String']>;
  isSpam: Scalars['Boolean'];
  lastModifiedAt?: Maybe<Scalars['timestamptz']>;
  lockDate?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  locker?: Maybe<BilikPerson>;
  lockerId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  originalProReview?: Maybe<ProReview>;
  originalProReviewId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  otherReviews: Array<ProReview>;
  /** An aggregate relationship */
  otherReviewsAggregate: ProReviewAggregate;
  /** An array relationship */
  presentations: Array<ReviewPresentation>;
  /** An aggregate relationship */
  presentationsAggregate: ReviewPresentationAggregate;
  privateComment?: Maybe<Scalars['String']>;
  /** An array relationship */
  proReviewInvitations: Array<ProReviewInvitation>;
  /** An aggregate relationship */
  proReviewInvitationsAggregate: ProReviewInvitationAggregate;
  proofStatus?: Maybe<Scalars['String']>;
  proofValidationMethod?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['smallint']>;
  ratingType: Scalars['String'];
  /** An object relationship */
  referenceView?: Maybe<ReviewReferenceView>;
  refuseReason?: Maybe<Scalars['String']>;
  reply?: Maybe<Scalars['String']>;
  replyDate?: Maybe<Scalars['timestamptz']>;
  replyStatus?: Maybe<Scalars['String']>;
  reviewAspect: Scalars['String'];
  reviewBody: Scalars['String'];
  /** An array relationship */
  solicitations: Array<Solicitation>;
  /** An aggregate relationship */
  solicitationsAggregate: SolicitationAggregate;
  source: Scalars['String'];
  status: Scalars['String'];
  telephone: Scalars['String'];
  trustLevel?: Maybe<Scalars['String']>;
};


/** columns and relationships of "pro_review" */
export type ProReviewDuplicateProReviewsArgs = {
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


/** columns and relationships of "pro_review" */
export type ProReviewDuplicateProReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


/** columns and relationships of "pro_review" */
export type ProReviewOtherReviewsArgs = {
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


/** columns and relationships of "pro_review" */
export type ProReviewOtherReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


/** columns and relationships of "pro_review" */
export type ProReviewPresentationsArgs = {
  distinctOn?: InputMaybe<Array<ReviewPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewPresentationOrderBy>>;
  where?: InputMaybe<ReviewPresentationBoolExp>;
};


/** columns and relationships of "pro_review" */
export type ProReviewPresentationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewPresentationOrderBy>>;
  where?: InputMaybe<ReviewPresentationBoolExp>;
};


/** columns and relationships of "pro_review" */
export type ProReviewProReviewInvitationsArgs = {
  distinctOn?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


/** columns and relationships of "pro_review" */
export type ProReviewProReviewInvitationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


/** columns and relationships of "pro_review" */
export type ProReviewSolicitationsArgs = {
  distinctOn?: InputMaybe<Array<SolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationOrderBy>>;
  where?: InputMaybe<SolicitationBoolExp>;
};


/** columns and relationships of "pro_review" */
export type ProReviewSolicitationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<SolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationOrderBy>>;
  where?: InputMaybe<SolicitationBoolExp>;
};

/** aggregated selection of "pro_review" */
export type ProReviewAggregate = {
  __typename?: 'ProReviewAggregate';
  aggregate?: Maybe<ProReviewAggregateFields>;
  nodes: Array<ProReview>;
};

export type ProReviewAggregateBoolExp = {
  bool_and?: InputMaybe<ProReviewAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<ProReviewAggregateBoolExpBoolOr>;
  count?: InputMaybe<ProReviewAggregateBoolExpCount>;
};

/** aggregate fields of "pro_review" */
export type ProReviewAggregateFields = {
  __typename?: 'ProReviewAggregateFields';
  avg?: Maybe<ProReviewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProReviewMaxFields>;
  min?: Maybe<ProReviewMinFields>;
  stddev?: Maybe<ProReviewStddevFields>;
  stddevPop?: Maybe<ProReviewStddevPopFields>;
  stddevSamp?: Maybe<ProReviewStddevSampFields>;
  sum?: Maybe<ProReviewSumFields>;
  varPop?: Maybe<ProReviewVarPopFields>;
  varSamp?: Maybe<ProReviewVarSampFields>;
  variance?: Maybe<ProReviewVarianceFields>;
};


/** aggregate fields of "pro_review" */
export type ProReviewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProReviewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_review" */
export type ProReviewAggregateOrderBy = {
  avg?: InputMaybe<ProReviewAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProReviewMaxOrderBy>;
  min?: InputMaybe<ProReviewMinOrderBy>;
  stddev?: InputMaybe<ProReviewStddevOrderBy>;
  stddevPop?: InputMaybe<ProReviewStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProReviewStddevSampOrderBy>;
  sum?: InputMaybe<ProReviewSumOrderBy>;
  varPop?: InputMaybe<ProReviewVarPopOrderBy>;
  varSamp?: InputMaybe<ProReviewVarSampOrderBy>;
  variance?: InputMaybe<ProReviewVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pro_review" */
export type ProReviewArrRelInsertInput = {
  data: Array<ProReviewInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProReviewOnConflict>;
};

/** aggregate avg on columns */
export type ProReviewAvgFields = {
  __typename?: 'ProReviewAvgFields';
  checkerId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: Maybe<Scalars['Float']>;
  lockerId?: Maybe<Scalars['Float']>;
  originalProReviewId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pro_review" */
export type ProReviewAvgOrderBy = {
  checkerId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<OrderBy>;
  lockerId?: InputMaybe<OrderBy>;
  originalProReviewId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_review". All fields are combined with a logical 'AND'. */
export type ProReviewBoolExp = {
  _and?: InputMaybe<Array<ProReviewBoolExp>>;
  _not?: InputMaybe<ProReviewBoolExp>;
  _or?: InputMaybe<Array<ProReviewBoolExp>>;
  addressLocality?: InputMaybe<StringComparisonExp>;
  checkDate?: InputMaybe<TimestamptzComparisonExp>;
  checker?: InputMaybe<BilikPersonBoolExp>;
  checkerId?: InputMaybe<IntComparisonExp>;
  city?: InputMaybe<CityBoolExp>;
  cityId?: InputMaybe<IntComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  dateCreated?: InputMaybe<TimestamptzComparisonExp>;
  dateOfWork?: InputMaybe<TimestamptzComparisonExp>;
  deprecatedAddressLocality?: InputMaybe<StringComparisonExp>;
  duplicateProReviews?: InputMaybe<ProReviewBoolExp>;
  duplicateProReviewsAggregate?: InputMaybe<ProReviewAggregateBoolExp>;
  email?: InputMaybe<StringComparisonExp>;
  familyName?: InputMaybe<StringComparisonExp>;
  givenName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  initialPresentationId?: InputMaybe<IntComparisonExp>;
  ip?: InputMaybe<StringComparisonExp>;
  isSpam?: InputMaybe<BooleanComparisonExp>;
  lastModifiedAt?: InputMaybe<TimestamptzComparisonExp>;
  lockDate?: InputMaybe<TimestamptzComparisonExp>;
  locker?: InputMaybe<BilikPersonBoolExp>;
  lockerId?: InputMaybe<IntComparisonExp>;
  originalProReview?: InputMaybe<ProReviewBoolExp>;
  originalProReviewId?: InputMaybe<IntComparisonExp>;
  otherReviews?: InputMaybe<ProReviewBoolExp>;
  otherReviewsAggregate?: InputMaybe<ProReviewAggregateBoolExp>;
  presentations?: InputMaybe<ReviewPresentationBoolExp>;
  presentationsAggregate?: InputMaybe<ReviewPresentationAggregateBoolExp>;
  privateComment?: InputMaybe<StringComparisonExp>;
  proReviewInvitations?: InputMaybe<ProReviewInvitationBoolExp>;
  proReviewInvitationsAggregate?: InputMaybe<ProReviewInvitationAggregateBoolExp>;
  proofStatus?: InputMaybe<StringComparisonExp>;
  proofValidationMethod?: InputMaybe<StringComparisonExp>;
  rating?: InputMaybe<SmallintComparisonExp>;
  ratingType?: InputMaybe<StringComparisonExp>;
  referenceView?: InputMaybe<ReviewReferenceViewBoolExp>;
  refuseReason?: InputMaybe<StringComparisonExp>;
  reply?: InputMaybe<StringComparisonExp>;
  replyDate?: InputMaybe<TimestamptzComparisonExp>;
  replyStatus?: InputMaybe<StringComparisonExp>;
  reviewAspect?: InputMaybe<StringComparisonExp>;
  reviewBody?: InputMaybe<StringComparisonExp>;
  solicitations?: InputMaybe<SolicitationBoolExp>;
  solicitationsAggregate?: InputMaybe<SolicitationAggregateBoolExp>;
  source?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  telephone?: InputMaybe<StringComparisonExp>;
  trustLevel?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "pro_review" */
export enum ProReviewConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22976Primary = 'idx_22976_primary'
}

/** input type for incrementing numeric columns in table "pro_review" */
export type ProReviewIncInput = {
  checkerId?: InputMaybe<Scalars['Int']>;
  cityId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<Scalars['Int']>;
  lockerId?: InputMaybe<Scalars['Int']>;
  originalProReviewId?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "pro_review" */
export type ProReviewInsertInput = {
  checkDate?: InputMaybe<Scalars['timestamptz']>;
  checker?: InputMaybe<BilikPersonObjRelInsertInput>;
  checkerId?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<CityObjRelInsertInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  dateOfWork?: InputMaybe<Scalars['timestamptz']>;
  deprecatedAddressLocality?: InputMaybe<Scalars['String']>;
  duplicateProReviews?: InputMaybe<ProReviewArrRelInsertInput>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<Scalars['Int']>;
  ip?: InputMaybe<Scalars['String']>;
  isSpam?: InputMaybe<Scalars['Boolean']>;
  lastModifiedAt?: InputMaybe<Scalars['timestamptz']>;
  lockDate?: InputMaybe<Scalars['timestamptz']>;
  locker?: InputMaybe<BilikPersonObjRelInsertInput>;
  lockerId?: InputMaybe<Scalars['Int']>;
  originalProReview?: InputMaybe<ProReviewObjRelInsertInput>;
  originalProReviewId?: InputMaybe<Scalars['Int']>;
  otherReviews?: InputMaybe<ProReviewArrRelInsertInput>;
  presentations?: InputMaybe<ReviewPresentationArrRelInsertInput>;
  privateComment?: InputMaybe<Scalars['String']>;
  proReviewInvitations?: InputMaybe<ProReviewInvitationArrRelInsertInput>;
  proofStatus?: InputMaybe<Scalars['String']>;
  proofValidationMethod?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['smallint']>;
  ratingType?: InputMaybe<Scalars['String']>;
  referenceView?: InputMaybe<ReviewReferenceViewObjRelInsertInput>;
  refuseReason?: InputMaybe<Scalars['String']>;
  reply?: InputMaybe<Scalars['String']>;
  replyDate?: InputMaybe<Scalars['timestamptz']>;
  replyStatus?: InputMaybe<Scalars['String']>;
  reviewAspect?: InputMaybe<Scalars['String']>;
  reviewBody?: InputMaybe<Scalars['String']>;
  solicitations?: InputMaybe<SolicitationArrRelInsertInput>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  trustLevel?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "pro_review_invitation" */
export type ProReviewInvitation = {
  __typename?: 'ProReviewInvitation';
  /** An array relationship */
  autoresponds: Array<Autorespond>;
  /** An aggregate relationship */
  autorespondsAggregate: AutorespondAggregate;
  dateCreated: Scalars['timestamptz'];
  dateOfWork?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['Int'];
  isAutorespondActive: Scalars['Boolean'];
  isBounce: Scalars['Boolean'];
  postmarkMessageId?: Maybe<Scalars['String']>;
  /** An object relationship */
  proPresentation?: Maybe<ProPresentation>;
  proPresentationId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  proReview?: Maybe<ProReview>;
  proReviewId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};


/** columns and relationships of "pro_review_invitation" */
export type ProReviewInvitationAutorespondsArgs = {
  distinctOn?: InputMaybe<Array<AutorespondSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AutorespondOrderBy>>;
  where?: InputMaybe<AutorespondBoolExp>;
};


/** columns and relationships of "pro_review_invitation" */
export type ProReviewInvitationAutorespondsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AutorespondSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AutorespondOrderBy>>;
  where?: InputMaybe<AutorespondBoolExp>;
};

/** aggregated selection of "pro_review_invitation" */
export type ProReviewInvitationAggregate = {
  __typename?: 'ProReviewInvitationAggregate';
  aggregate?: Maybe<ProReviewInvitationAggregateFields>;
  nodes: Array<ProReviewInvitation>;
};

export type ProReviewInvitationAggregateBoolExp = {
  bool_and?: InputMaybe<ProReviewInvitationAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<ProReviewInvitationAggregateBoolExpBoolOr>;
  count?: InputMaybe<ProReviewInvitationAggregateBoolExpCount>;
};

/** aggregate fields of "pro_review_invitation" */
export type ProReviewInvitationAggregateFields = {
  __typename?: 'ProReviewInvitationAggregateFields';
  avg?: Maybe<ProReviewInvitationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProReviewInvitationMaxFields>;
  min?: Maybe<ProReviewInvitationMinFields>;
  stddev?: Maybe<ProReviewInvitationStddevFields>;
  stddevPop?: Maybe<ProReviewInvitationStddevPopFields>;
  stddevSamp?: Maybe<ProReviewInvitationStddevSampFields>;
  sum?: Maybe<ProReviewInvitationSumFields>;
  varPop?: Maybe<ProReviewInvitationVarPopFields>;
  varSamp?: Maybe<ProReviewInvitationVarSampFields>;
  variance?: Maybe<ProReviewInvitationVarianceFields>;
};


/** aggregate fields of "pro_review_invitation" */
export type ProReviewInvitationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_review_invitation" */
export type ProReviewInvitationAggregateOrderBy = {
  avg?: InputMaybe<ProReviewInvitationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProReviewInvitationMaxOrderBy>;
  min?: InputMaybe<ProReviewInvitationMinOrderBy>;
  stddev?: InputMaybe<ProReviewInvitationStddevOrderBy>;
  stddevPop?: InputMaybe<ProReviewInvitationStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProReviewInvitationStddevSampOrderBy>;
  sum?: InputMaybe<ProReviewInvitationSumOrderBy>;
  varPop?: InputMaybe<ProReviewInvitationVarPopOrderBy>;
  varSamp?: InputMaybe<ProReviewInvitationVarSampOrderBy>;
  variance?: InputMaybe<ProReviewInvitationVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pro_review_invitation" */
export type ProReviewInvitationArrRelInsertInput = {
  data: Array<ProReviewInvitationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProReviewInvitationOnConflict>;
};

/** aggregate avg on columns */
export type ProReviewInvitationAvgFields = {
  __typename?: 'ProReviewInvitationAvgFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pro_review_invitation" */
export type ProReviewInvitationAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_review_invitation". All fields are combined with a logical 'AND'. */
export type ProReviewInvitationBoolExp = {
  _and?: InputMaybe<Array<ProReviewInvitationBoolExp>>;
  _not?: InputMaybe<ProReviewInvitationBoolExp>;
  _or?: InputMaybe<Array<ProReviewInvitationBoolExp>>;
  autoresponds?: InputMaybe<AutorespondBoolExp>;
  autorespondsAggregate?: InputMaybe<AutorespondAggregateBoolExp>;
  dateCreated?: InputMaybe<TimestamptzComparisonExp>;
  dateOfWork?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  familyName?: InputMaybe<StringComparisonExp>;
  givenName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  isAutorespondActive?: InputMaybe<BooleanComparisonExp>;
  isBounce?: InputMaybe<BooleanComparisonExp>;
  postmarkMessageId?: InputMaybe<StringComparisonExp>;
  proPresentation?: InputMaybe<ProPresentationBoolExp>;
  proPresentationId?: InputMaybe<IntComparisonExp>;
  proReview?: InputMaybe<ProReviewBoolExp>;
  proReviewId?: InputMaybe<IntComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "pro_review_invitation" */
export enum ProReviewInvitationConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22985Primary = 'idx_22985_primary',
  /** unique or primary key constraint on columns "uuid" */
  Idx_22985Uniq_69e5470ad17f50a6 = 'idx_22985_uniq_69e5470ad17f50a6'
}

/** input type for incrementing numeric columns in table "pro_review_invitation" */
export type ProReviewInvitationIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  proReviewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_review_invitation" */
export type ProReviewInvitationInsertInput = {
  autoresponds?: InputMaybe<AutorespondArrRelInsertInput>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  dateOfWork?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isAutorespondActive?: InputMaybe<Scalars['Boolean']>;
  isBounce?: InputMaybe<Scalars['Boolean']>;
  postmarkMessageId?: InputMaybe<Scalars['String']>;
  proPresentation?: InputMaybe<ProPresentationObjRelInsertInput>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  proReview?: InputMaybe<ProReviewObjRelInsertInput>;
  proReviewId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProReviewInvitationMaxFields = {
  __typename?: 'ProReviewInvitationMaxFields';
  dateCreated?: Maybe<Scalars['timestamptz']>;
  dateOfWork?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  postmarkMessageId?: Maybe<Scalars['String']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  proReviewId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "pro_review_invitation" */
export type ProReviewInvitationMaxOrderBy = {
  dateCreated?: InputMaybe<OrderBy>;
  dateOfWork?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  postmarkMessageId?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProReviewInvitationMinFields = {
  __typename?: 'ProReviewInvitationMinFields';
  dateCreated?: Maybe<Scalars['timestamptz']>;
  dateOfWork?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  postmarkMessageId?: Maybe<Scalars['String']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  proReviewId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "pro_review_invitation" */
export type ProReviewInvitationMinOrderBy = {
  dateCreated?: InputMaybe<OrderBy>;
  dateOfWork?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  postmarkMessageId?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_review_invitation" */
export type ProReviewInvitationMutationResponse = {
  __typename?: 'ProReviewInvitationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProReviewInvitation>;
};

/** on_conflict condition type for table "pro_review_invitation" */
export type ProReviewInvitationOnConflict = {
  constraint: ProReviewInvitationConstraint;
  updateColumns?: Array<ProReviewInvitationUpdateColumn>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};

/** Ordering options when selecting data from "pro_review_invitation". */
export type ProReviewInvitationOrderBy = {
  autorespondsAggregate?: InputMaybe<AutorespondAggregateOrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  dateOfWork?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isAutorespondActive?: InputMaybe<OrderBy>;
  isBounce?: InputMaybe<OrderBy>;
  postmarkMessageId?: InputMaybe<OrderBy>;
  proPresentation?: InputMaybe<ProPresentationOrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proReview?: InputMaybe<ProReviewOrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_review_invitation */
export type ProReviewInvitationPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "pro_review_invitation" */
export enum ProReviewInvitationSelectColumn {
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  DateOfWork = 'dateOfWork',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  IsAutorespondActive = 'isAutorespondActive',
  /** column name */
  IsBounce = 'isBounce',
  /** column name */
  PostmarkMessageId = 'postmarkMessageId',
  /** column name */
  ProPresentationId = 'proPresentationId',
  /** column name */
  ProReviewId = 'proReviewId',
  /** column name */
  Source = 'source',
  /** column name */
  Uuid = 'uuid'
}

/** select "proReviewInvitationAggregateBoolExpBool_andArgumentsColumns" columns of table "pro_review_invitation" */
export enum ProReviewInvitationSelectColumnProReviewInvitationAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsAutorespondActive = 'isAutorespondActive',
  /** column name */
  IsBounce = 'isBounce'
}

/** select "proReviewInvitationAggregateBoolExpBool_orArgumentsColumns" columns of table "pro_review_invitation" */
export enum ProReviewInvitationSelectColumnProReviewInvitationAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsAutorespondActive = 'isAutorespondActive',
  /** column name */
  IsBounce = 'isBounce'
}

/** input type for updating data in table "pro_review_invitation" */
export type ProReviewInvitationSetInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  dateOfWork?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isAutorespondActive?: InputMaybe<Scalars['Boolean']>;
  isBounce?: InputMaybe<Scalars['Boolean']>;
  postmarkMessageId?: InputMaybe<Scalars['String']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  proReviewId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProReviewInvitationStddevFields = {
  __typename?: 'ProReviewInvitationStddevFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pro_review_invitation" */
export type ProReviewInvitationStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProReviewInvitationStddevPopFields = {
  __typename?: 'ProReviewInvitationStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pro_review_invitation" */
export type ProReviewInvitationStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProReviewInvitationStddevSampFields = {
  __typename?: 'ProReviewInvitationStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pro_review_invitation" */
export type ProReviewInvitationStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_review_invitation" */
export type ProReviewInvitationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProReviewInvitationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProReviewInvitationStreamCursorValueInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  dateOfWork?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isAutorespondActive?: InputMaybe<Scalars['Boolean']>;
  isBounce?: InputMaybe<Scalars['Boolean']>;
  postmarkMessageId?: InputMaybe<Scalars['String']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  proReviewId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ProReviewInvitationSumFields = {
  __typename?: 'ProReviewInvitationSumFields';
  id?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  proReviewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pro_review_invitation" */
export type ProReviewInvitationSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_review_invitation" */
export enum ProReviewInvitationUpdateColumn {
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  DateOfWork = 'dateOfWork',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  IsAutorespondActive = 'isAutorespondActive',
  /** column name */
  IsBounce = 'isBounce',
  /** column name */
  PostmarkMessageId = 'postmarkMessageId',
  /** column name */
  ProPresentationId = 'proPresentationId',
  /** column name */
  ProReviewId = 'proReviewId',
  /** column name */
  Source = 'source',
  /** column name */
  Uuid = 'uuid'
}

export type ProReviewInvitationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProReviewInvitationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProReviewInvitationSetInput>;
  /** filter the rows which have to be updated */
  where: ProReviewInvitationBoolExp;
};

/** aggregate varPop on columns */
export type ProReviewInvitationVarPopFields = {
  __typename?: 'ProReviewInvitationVarPopFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pro_review_invitation" */
export type ProReviewInvitationVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProReviewInvitationVarSampFields = {
  __typename?: 'ProReviewInvitationVarSampFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pro_review_invitation" */
export type ProReviewInvitationVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProReviewInvitationVarianceFields = {
  __typename?: 'ProReviewInvitationVarianceFields';
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pro_review_invitation" */
export type ProReviewInvitationVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
};

/** aggregate max on columns */
export type ProReviewMaxFields = {
  __typename?: 'ProReviewMaxFields';
  /** A computed field, executes function "pro_review_address_locality" */
  addressLocality?: Maybe<Scalars['String']>;
  checkDate?: Maybe<Scalars['timestamptz']>;
  checkerId?: Maybe<Scalars['Int']>;
  cityId?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['timestamptz']>;
  dateOfWork?: Maybe<Scalars['timestamptz']>;
  deprecatedAddressLocality?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: Maybe<Scalars['Int']>;
  ip?: Maybe<Scalars['String']>;
  lastModifiedAt?: Maybe<Scalars['timestamptz']>;
  lockDate?: Maybe<Scalars['timestamptz']>;
  lockerId?: Maybe<Scalars['Int']>;
  originalProReviewId?: Maybe<Scalars['Int']>;
  privateComment?: Maybe<Scalars['String']>;
  proofStatus?: Maybe<Scalars['String']>;
  proofValidationMethod?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['smallint']>;
  ratingType?: Maybe<Scalars['String']>;
  refuseReason?: Maybe<Scalars['String']>;
  reply?: Maybe<Scalars['String']>;
  replyDate?: Maybe<Scalars['timestamptz']>;
  replyStatus?: Maybe<Scalars['String']>;
  reviewAspect?: Maybe<Scalars['String']>;
  reviewBody?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  trustLevel?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "pro_review" */
export type ProReviewMaxOrderBy = {
  checkDate?: InputMaybe<OrderBy>;
  checkerId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  dateOfWork?: InputMaybe<OrderBy>;
  deprecatedAddressLocality?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  lastModifiedAt?: InputMaybe<OrderBy>;
  lockDate?: InputMaybe<OrderBy>;
  lockerId?: InputMaybe<OrderBy>;
  originalProReviewId?: InputMaybe<OrderBy>;
  privateComment?: InputMaybe<OrderBy>;
  proofStatus?: InputMaybe<OrderBy>;
  proofValidationMethod?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  ratingType?: InputMaybe<OrderBy>;
  refuseReason?: InputMaybe<OrderBy>;
  reply?: InputMaybe<OrderBy>;
  replyDate?: InputMaybe<OrderBy>;
  replyStatus?: InputMaybe<OrderBy>;
  reviewAspect?: InputMaybe<OrderBy>;
  reviewBody?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
  trustLevel?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProReviewMinFields = {
  __typename?: 'ProReviewMinFields';
  /** A computed field, executes function "pro_review_address_locality" */
  addressLocality?: Maybe<Scalars['String']>;
  checkDate?: Maybe<Scalars['timestamptz']>;
  checkerId?: Maybe<Scalars['Int']>;
  cityId?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['timestamptz']>;
  dateOfWork?: Maybe<Scalars['timestamptz']>;
  deprecatedAddressLocality?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: Maybe<Scalars['Int']>;
  ip?: Maybe<Scalars['String']>;
  lastModifiedAt?: Maybe<Scalars['timestamptz']>;
  lockDate?: Maybe<Scalars['timestamptz']>;
  lockerId?: Maybe<Scalars['Int']>;
  originalProReviewId?: Maybe<Scalars['Int']>;
  privateComment?: Maybe<Scalars['String']>;
  proofStatus?: Maybe<Scalars['String']>;
  proofValidationMethod?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['smallint']>;
  ratingType?: Maybe<Scalars['String']>;
  refuseReason?: Maybe<Scalars['String']>;
  reply?: Maybe<Scalars['String']>;
  replyDate?: Maybe<Scalars['timestamptz']>;
  replyStatus?: Maybe<Scalars['String']>;
  reviewAspect?: Maybe<Scalars['String']>;
  reviewBody?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  trustLevel?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "pro_review" */
export type ProReviewMinOrderBy = {
  checkDate?: InputMaybe<OrderBy>;
  checkerId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  dateOfWork?: InputMaybe<OrderBy>;
  deprecatedAddressLocality?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  lastModifiedAt?: InputMaybe<OrderBy>;
  lockDate?: InputMaybe<OrderBy>;
  lockerId?: InputMaybe<OrderBy>;
  originalProReviewId?: InputMaybe<OrderBy>;
  privateComment?: InputMaybe<OrderBy>;
  proofStatus?: InputMaybe<OrderBy>;
  proofValidationMethod?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  ratingType?: InputMaybe<OrderBy>;
  refuseReason?: InputMaybe<OrderBy>;
  reply?: InputMaybe<OrderBy>;
  replyDate?: InputMaybe<OrderBy>;
  replyStatus?: InputMaybe<OrderBy>;
  reviewAspect?: InputMaybe<OrderBy>;
  reviewBody?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
  trustLevel?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_review" */
export type ProReviewMutationResponse = {
  __typename?: 'ProReviewMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProReview>;
};

/** input type for inserting object relation for remote table "pro_review" */
export type ProReviewObjRelInsertInput = {
  data: ProReviewInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ProReviewOnConflict>;
};

/** on_conflict condition type for table "pro_review" */
export type ProReviewOnConflict = {
  constraint: ProReviewConstraint;
  updateColumns?: Array<ProReviewUpdateColumn>;
  where?: InputMaybe<ProReviewBoolExp>;
};

/** Ordering options when selecting data from "pro_review". */
export type ProReviewOrderBy = {
  addressLocality?: InputMaybe<OrderBy>;
  checkDate?: InputMaybe<OrderBy>;
  checker?: InputMaybe<BilikPersonOrderBy>;
  checkerId?: InputMaybe<OrderBy>;
  city?: InputMaybe<CityOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  dateOfWork?: InputMaybe<OrderBy>;
  deprecatedAddressLocality?: InputMaybe<OrderBy>;
  duplicateProReviewsAggregate?: InputMaybe<ProReviewAggregateOrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  initialPresentationId?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  isSpam?: InputMaybe<OrderBy>;
  lastModifiedAt?: InputMaybe<OrderBy>;
  lockDate?: InputMaybe<OrderBy>;
  locker?: InputMaybe<BilikPersonOrderBy>;
  lockerId?: InputMaybe<OrderBy>;
  originalProReview?: InputMaybe<ProReviewOrderBy>;
  originalProReviewId?: InputMaybe<OrderBy>;
  otherReviewsAggregate?: InputMaybe<ProReviewAggregateOrderBy>;
  presentationsAggregate?: InputMaybe<ReviewPresentationAggregateOrderBy>;
  privateComment?: InputMaybe<OrderBy>;
  proReviewInvitationsAggregate?: InputMaybe<ProReviewInvitationAggregateOrderBy>;
  proofStatus?: InputMaybe<OrderBy>;
  proofValidationMethod?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  ratingType?: InputMaybe<OrderBy>;
  referenceView?: InputMaybe<ReviewReferenceViewOrderBy>;
  refuseReason?: InputMaybe<OrderBy>;
  reply?: InputMaybe<OrderBy>;
  replyDate?: InputMaybe<OrderBy>;
  replyStatus?: InputMaybe<OrderBy>;
  reviewAspect?: InputMaybe<OrderBy>;
  reviewBody?: InputMaybe<OrderBy>;
  solicitationsAggregate?: InputMaybe<SolicitationAggregateOrderBy>;
  source?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
  trustLevel?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_review */
export type ProReviewPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "pro_review" */
export enum ProReviewSelectColumn {
  /** column name */
  CheckDate = 'checkDate',
  /** column name */
  CheckerId = 'checkerId',
  /** column name */
  CityId = 'cityId',
  /** column name */
  Comment = 'comment',
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  DateOfWork = 'dateOfWork',
  /** column name */
  DeprecatedAddressLocality = 'deprecatedAddressLocality',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  InitialPresentationId = 'initialPresentationId',
  /** column name */
  Ip = 'ip',
  /** column name */
  IsSpam = 'isSpam',
  /** column name */
  LastModifiedAt = 'lastModifiedAt',
  /** column name */
  LockDate = 'lockDate',
  /** column name */
  LockerId = 'lockerId',
  /** column name */
  OriginalProReviewId = 'originalProReviewId',
  /** column name */
  PrivateComment = 'privateComment',
  /** column name */
  ProofStatus = 'proofStatus',
  /** column name */
  ProofValidationMethod = 'proofValidationMethod',
  /** column name */
  Rating = 'rating',
  /** column name */
  RatingType = 'ratingType',
  /** column name */
  RefuseReason = 'refuseReason',
  /** column name */
  Reply = 'reply',
  /** column name */
  ReplyDate = 'replyDate',
  /** column name */
  ReplyStatus = 'replyStatus',
  /** column name */
  ReviewAspect = 'reviewAspect',
  /** column name */
  ReviewBody = 'reviewBody',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  Telephone = 'telephone',
  /** column name */
  TrustLevel = 'trustLevel'
}

/** select "proReviewAggregateBoolExpBool_andArgumentsColumns" columns of table "pro_review" */
export enum ProReviewSelectColumnProReviewAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsSpam = 'isSpam'
}

/** select "proReviewAggregateBoolExpBool_orArgumentsColumns" columns of table "pro_review" */
export enum ProReviewSelectColumnProReviewAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsSpam = 'isSpam'
}

/** input type for updating data in table "pro_review" */
export type ProReviewSetInput = {
  checkDate?: InputMaybe<Scalars['timestamptz']>;
  checkerId?: InputMaybe<Scalars['Int']>;
  cityId?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  dateOfWork?: InputMaybe<Scalars['timestamptz']>;
  deprecatedAddressLocality?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<Scalars['Int']>;
  ip?: InputMaybe<Scalars['String']>;
  isSpam?: InputMaybe<Scalars['Boolean']>;
  lastModifiedAt?: InputMaybe<Scalars['timestamptz']>;
  lockDate?: InputMaybe<Scalars['timestamptz']>;
  lockerId?: InputMaybe<Scalars['Int']>;
  originalProReviewId?: InputMaybe<Scalars['Int']>;
  privateComment?: InputMaybe<Scalars['String']>;
  proofStatus?: InputMaybe<Scalars['String']>;
  proofValidationMethod?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['smallint']>;
  ratingType?: InputMaybe<Scalars['String']>;
  refuseReason?: InputMaybe<Scalars['String']>;
  reply?: InputMaybe<Scalars['String']>;
  replyDate?: InputMaybe<Scalars['timestamptz']>;
  replyStatus?: InputMaybe<Scalars['String']>;
  reviewAspect?: InputMaybe<Scalars['String']>;
  reviewBody?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  trustLevel?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProReviewStddevFields = {
  __typename?: 'ProReviewStddevFields';
  checkerId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: Maybe<Scalars['Float']>;
  lockerId?: Maybe<Scalars['Float']>;
  originalProReviewId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pro_review" */
export type ProReviewStddevOrderBy = {
  checkerId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<OrderBy>;
  lockerId?: InputMaybe<OrderBy>;
  originalProReviewId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProReviewStddevPopFields = {
  __typename?: 'ProReviewStddevPopFields';
  checkerId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: Maybe<Scalars['Float']>;
  lockerId?: Maybe<Scalars['Float']>;
  originalProReviewId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pro_review" */
export type ProReviewStddevPopOrderBy = {
  checkerId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<OrderBy>;
  lockerId?: InputMaybe<OrderBy>;
  originalProReviewId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProReviewStddevSampFields = {
  __typename?: 'ProReviewStddevSampFields';
  checkerId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: Maybe<Scalars['Float']>;
  lockerId?: Maybe<Scalars['Float']>;
  originalProReviewId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pro_review" */
export type ProReviewStddevSampOrderBy = {
  checkerId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<OrderBy>;
  lockerId?: InputMaybe<OrderBy>;
  originalProReviewId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_review" */
export type ProReviewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProReviewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProReviewStreamCursorValueInput = {
  checkDate?: InputMaybe<Scalars['timestamptz']>;
  checkerId?: InputMaybe<Scalars['Int']>;
  cityId?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  dateOfWork?: InputMaybe<Scalars['timestamptz']>;
  deprecatedAddressLocality?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<Scalars['Int']>;
  ip?: InputMaybe<Scalars['String']>;
  isSpam?: InputMaybe<Scalars['Boolean']>;
  lastModifiedAt?: InputMaybe<Scalars['timestamptz']>;
  lockDate?: InputMaybe<Scalars['timestamptz']>;
  lockerId?: InputMaybe<Scalars['Int']>;
  originalProReviewId?: InputMaybe<Scalars['Int']>;
  privateComment?: InputMaybe<Scalars['String']>;
  proofStatus?: InputMaybe<Scalars['String']>;
  proofValidationMethod?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['smallint']>;
  ratingType?: InputMaybe<Scalars['String']>;
  refuseReason?: InputMaybe<Scalars['String']>;
  reply?: InputMaybe<Scalars['String']>;
  replyDate?: InputMaybe<Scalars['timestamptz']>;
  replyStatus?: InputMaybe<Scalars['String']>;
  reviewAspect?: InputMaybe<Scalars['String']>;
  reviewBody?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  trustLevel?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ProReviewSumFields = {
  __typename?: 'ProReviewSumFields';
  checkerId?: Maybe<Scalars['Int']>;
  cityId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: Maybe<Scalars['Int']>;
  lockerId?: Maybe<Scalars['Int']>;
  originalProReviewId?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "pro_review" */
export type ProReviewSumOrderBy = {
  checkerId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<OrderBy>;
  lockerId?: InputMaybe<OrderBy>;
  originalProReviewId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_review" */
export enum ProReviewUpdateColumn {
  /** column name */
  CheckDate = 'checkDate',
  /** column name */
  CheckerId = 'checkerId',
  /** column name */
  CityId = 'cityId',
  /** column name */
  Comment = 'comment',
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  DateOfWork = 'dateOfWork',
  /** column name */
  DeprecatedAddressLocality = 'deprecatedAddressLocality',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  InitialPresentationId = 'initialPresentationId',
  /** column name */
  Ip = 'ip',
  /** column name */
  IsSpam = 'isSpam',
  /** column name */
  LastModifiedAt = 'lastModifiedAt',
  /** column name */
  LockDate = 'lockDate',
  /** column name */
  LockerId = 'lockerId',
  /** column name */
  OriginalProReviewId = 'originalProReviewId',
  /** column name */
  PrivateComment = 'privateComment',
  /** column name */
  ProofStatus = 'proofStatus',
  /** column name */
  ProofValidationMethod = 'proofValidationMethod',
  /** column name */
  Rating = 'rating',
  /** column name */
  RatingType = 'ratingType',
  /** column name */
  RefuseReason = 'refuseReason',
  /** column name */
  Reply = 'reply',
  /** column name */
  ReplyDate = 'replyDate',
  /** column name */
  ReplyStatus = 'replyStatus',
  /** column name */
  ReviewAspect = 'reviewAspect',
  /** column name */
  ReviewBody = 'reviewBody',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  Telephone = 'telephone',
  /** column name */
  TrustLevel = 'trustLevel'
}

export type ProReviewUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProReviewIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProReviewSetInput>;
  /** filter the rows which have to be updated */
  where: ProReviewBoolExp;
};

/** aggregate varPop on columns */
export type ProReviewVarPopFields = {
  __typename?: 'ProReviewVarPopFields';
  checkerId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: Maybe<Scalars['Float']>;
  lockerId?: Maybe<Scalars['Float']>;
  originalProReviewId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pro_review" */
export type ProReviewVarPopOrderBy = {
  checkerId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<OrderBy>;
  lockerId?: InputMaybe<OrderBy>;
  originalProReviewId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProReviewVarSampFields = {
  __typename?: 'ProReviewVarSampFields';
  checkerId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: Maybe<Scalars['Float']>;
  lockerId?: Maybe<Scalars['Float']>;
  originalProReviewId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pro_review" */
export type ProReviewVarSampOrderBy = {
  checkerId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<OrderBy>;
  lockerId?: InputMaybe<OrderBy>;
  originalProReviewId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProReviewVarianceFields = {
  __typename?: 'ProReviewVarianceFields';
  checkerId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: Maybe<Scalars['Float']>;
  lockerId?: Maybe<Scalars['Float']>;
  originalProReviewId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pro_review" */
export type ProReviewVarianceOrderBy = {
  checkerId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The presentation the review was left on, never changed afterwards: the presentations it is visible on are in review_presentation. */
  initialPresentationId?: InputMaybe<OrderBy>;
  lockerId?: InputMaybe<OrderBy>;
  originalProReviewId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "pro_view" */
export type ProView = {
  __typename?: 'ProView';
  /** An array relationship */
  accounts: Array<AccountProView>;
  /** An aggregate relationship */
  accountsAggregate: AccountProViewAggregate;
  /** An object relationship */
  activeHoliday?: Maybe<ViewActiveHoliday>;
  archiveReason?: Maybe<Scalars['String']>;
  avatarHash?: Maybe<Scalars['String']>;
  averageProjectDays: Scalars['Int'];
  averageQuotationDays: Scalars['Int'];
  averageResponseDays: Scalars['Int'];
  /** An object relationship */
  bilikZone: BilikZone;
  bilikZoneId: Scalars['Int'];
  /** (DC2Type:json_array) */
  callTrackingForward?: Maybe<Scalars['jsonb']>;
  /** (DC2Type:json_array) */
  callTrackingTarget: Scalars['jsonb'];
  /** An array relationship */
  cities: Array<CityProView>;
  /** An aggregate relationship */
  citiesAggregate: CityProViewAggregate;
  /** An array relationship */
  colleagues: Array<ProViewProView>;
  /** An aggregate relationship */
  colleaguesAggregate: ProViewProViewAggregate;
  contractConfiguration?: Maybe<Scalars['jsonb']>;
  contractEvents?: Maybe<Scalars['jsonb']>;
  dateArchiveScheduled?: Maybe<Scalars['timestamptz']>;
  dateArchived?: Maybe<Scalars['timestamptz']>;
  dateCreated: Scalars['timestamptz'];
  datePublished?: Maybe<Scalars['timestamptz']>;
  emailTarget: Scalars['String'];
  /** An object relationship */
  googleReviewLink?: Maybe<GoogleReviewLink>;
  googleReviewLinkId?: Maybe<Scalars['Int']>;
  hasContact: Scalars['Boolean'];
  hasQuotation: Scalars['Boolean'];
  id: Scalars['Int'];
  interventionExclude?: Maybe<Scalars['geometry']>;
  interventionInclude?: Maybe<Scalars['geometry']>;
  isCallAlertActivated: Scalars['Boolean'];
  isCallRecordable: Scalars['Boolean'];
  isCallsDisabled: Scalars['Boolean'];
  isEnglishSpeaker: Scalars['Boolean'];
  isLocalBusiness: Scalars['Boolean'];
  isMainCityCenterExcluded: Scalars['Boolean'];
  isSmsDisabled: Scalars['Boolean'];
  isSolicitationsDisabled: Scalars['Boolean'];
  /** A computed field, executes function "pro_view_is_trade_call_recordable" */
  isTradeCallRecordable?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Scalars['String']>;
  originalAvatarHash?: Maybe<Scalars['String']>;
  /** An array relationship */
  phoneNumbers: Array<PhoneNumber>;
  /** An aggregate relationship */
  phoneNumbersAggregate: PhoneNumberAggregate;
  priceComment?: Maybe<Scalars['String']>;
  /** An array relationship */
  proHolidays: Array<ProHoliday>;
  /** An aggregate relationship */
  proHolidaysAggregate: ProHolidayAggregate;
  /** An array relationship */
  proMessages: Array<ProMessage>;
  /** An aggregate relationship */
  proMessagesAggregate: ProMessageAggregate;
  /** An array relationship */
  proPeople: Array<ProViewProPerson>;
  /** An aggregate relationship */
  proPeopleAggregate: ProViewProPersonAggregate;
  /** An object relationship */
  proPostalAddress?: Maybe<ProPostalAddress>;
  /** An object relationship */
  proPresentation: ProPresentation;
  proPresentationId: Scalars['Int'];
  /** An array relationship */
  proPrices: Array<ProPrice>;
  /** An aggregate relationship */
  proPricesAggregate: ProPriceAggregate;
  /** An aggregate relationship */
  queuedSmsAggregate: QueuedSmsAggregate;
  /** An array relationship */
  queued_sms: Array<QueuedSms>;
  /** An array relationship */
  relatedProViews: Array<ProViewProView>;
  /** An aggregate relationship */
  relatedProViewsAggregate: ProViewProViewAggregate;
  /** An array relationship */
  solicitations: Array<Solicitation>;
  /** An aggregate relationship */
  solicitationsAggregate: SolicitationAggregate;
  status: Scalars['String'];
  /** An array relationship */
  trades: Array<TradeProView>;
  /** An aggregate relationship */
  tradesAggregate: TradeProViewAggregate;
  /** A computed field, executes function "pro_view_web_phone_number" */
  webPhoneNumber?: Maybe<Scalars['String']>;
};


/** columns and relationships of "pro_view" */
export type ProViewAccountsArgs = {
  distinctOn?: InputMaybe<Array<AccountProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountProViewOrderBy>>;
  where?: InputMaybe<AccountProViewBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountProViewOrderBy>>;
  where?: InputMaybe<AccountProViewBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewCallTrackingForwardArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "pro_view" */
export type ProViewCallTrackingTargetArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "pro_view" */
export type ProViewCitiesArgs = {
  distinctOn?: InputMaybe<Array<CityProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityProViewOrderBy>>;
  where?: InputMaybe<CityProViewBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewCitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CityProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityProViewOrderBy>>;
  where?: InputMaybe<CityProViewBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewColleaguesArgs = {
  distinctOn?: InputMaybe<Array<ProViewProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProViewOrderBy>>;
  where?: InputMaybe<ProViewProViewBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewColleaguesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProViewOrderBy>>;
  where?: InputMaybe<ProViewProViewBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewContractConfigurationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "pro_view" */
export type ProViewContractEventsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "pro_view" */
export type ProViewPhoneNumbersArgs = {
  distinctOn?: InputMaybe<Array<PhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhoneNumberOrderBy>>;
  where?: InputMaybe<PhoneNumberBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewPhoneNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhoneNumberOrderBy>>;
  where?: InputMaybe<PhoneNumberBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewProHolidaysArgs = {
  distinctOn?: InputMaybe<Array<ProHolidaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProHolidayOrderBy>>;
  where?: InputMaybe<ProHolidayBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewProHolidaysAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProHolidaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProHolidayOrderBy>>;
  where?: InputMaybe<ProHolidayBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewProMessagesArgs = {
  distinctOn?: InputMaybe<Array<ProMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMessageOrderBy>>;
  where?: InputMaybe<ProMessageBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewProMessagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMessageOrderBy>>;
  where?: InputMaybe<ProMessageBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewProPeopleArgs = {
  distinctOn?: InputMaybe<Array<ProViewProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProPersonOrderBy>>;
  where?: InputMaybe<ProViewProPersonBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewProPeopleAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProPersonOrderBy>>;
  where?: InputMaybe<ProViewProPersonBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewProPricesArgs = {
  distinctOn?: InputMaybe<Array<ProPriceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPriceOrderBy>>;
  where?: InputMaybe<ProPriceBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewProPricesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProPriceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPriceOrderBy>>;
  where?: InputMaybe<ProPriceBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewQueuedSmsAggregateArgs = {
  distinctOn?: InputMaybe<Array<QueuedSmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QueuedSmsOrderBy>>;
  where?: InputMaybe<QueuedSmsBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewQueuedSmsArgs = {
  distinctOn?: InputMaybe<Array<QueuedSmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QueuedSmsOrderBy>>;
  where?: InputMaybe<QueuedSmsBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewRelatedProViewsArgs = {
  distinctOn?: InputMaybe<Array<ProViewProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProViewOrderBy>>;
  where?: InputMaybe<ProViewProViewBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewRelatedProViewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProViewOrderBy>>;
  where?: InputMaybe<ProViewProViewBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewSolicitationsArgs = {
  distinctOn?: InputMaybe<Array<SolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationOrderBy>>;
  where?: InputMaybe<SolicitationBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewSolicitationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<SolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationOrderBy>>;
  where?: InputMaybe<SolicitationBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewTradesArgs = {
  distinctOn?: InputMaybe<Array<TradeProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProViewOrderBy>>;
  where?: InputMaybe<TradeProViewBoolExp>;
};


/** columns and relationships of "pro_view" */
export type ProViewTradesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProViewOrderBy>>;
  where?: InputMaybe<TradeProViewBoolExp>;
};

/** aggregated selection of "pro_view" */
export type ProViewAggregate = {
  __typename?: 'ProViewAggregate';
  aggregate?: Maybe<ProViewAggregateFields>;
  nodes: Array<ProView>;
};

export type ProViewAggregateBoolExp = {
  bool_and?: InputMaybe<ProViewAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<ProViewAggregateBoolExpBoolOr>;
  count?: InputMaybe<ProViewAggregateBoolExpCount>;
};

/** aggregate fields of "pro_view" */
export type ProViewAggregateFields = {
  __typename?: 'ProViewAggregateFields';
  avg?: Maybe<ProViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProViewMaxFields>;
  min?: Maybe<ProViewMinFields>;
  stddev?: Maybe<ProViewStddevFields>;
  stddevPop?: Maybe<ProViewStddevPopFields>;
  stddevSamp?: Maybe<ProViewStddevSampFields>;
  sum?: Maybe<ProViewSumFields>;
  varPop?: Maybe<ProViewVarPopFields>;
  varSamp?: Maybe<ProViewVarSampFields>;
  variance?: Maybe<ProViewVarianceFields>;
};


/** aggregate fields of "pro_view" */
export type ProViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_view" */
export type ProViewAggregateOrderBy = {
  avg?: InputMaybe<ProViewAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProViewMaxOrderBy>;
  min?: InputMaybe<ProViewMinOrderBy>;
  stddev?: InputMaybe<ProViewStddevOrderBy>;
  stddevPop?: InputMaybe<ProViewStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProViewStddevSampOrderBy>;
  sum?: InputMaybe<ProViewSumOrderBy>;
  varPop?: InputMaybe<ProViewVarPopOrderBy>;
  varSamp?: InputMaybe<ProViewVarSampOrderBy>;
  variance?: InputMaybe<ProViewVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ProViewAppendInput = {
  /** (DC2Type:json_array) */
  callTrackingForward?: InputMaybe<Scalars['jsonb']>;
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  contractConfiguration?: InputMaybe<Scalars['jsonb']>;
  contractEvents?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "pro_view" */
export type ProViewArrRelInsertInput = {
  data: Array<ProViewInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProViewOnConflict>;
};

/** aggregate avg on columns */
export type ProViewAvgFields = {
  __typename?: 'ProViewAvgFields';
  averageProjectDays?: Maybe<Scalars['Float']>;
  averageQuotationDays?: Maybe<Scalars['Float']>;
  averageResponseDays?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
  googleReviewLinkId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pro_view" */
export type ProViewAvgOrderBy = {
  averageProjectDays?: InputMaybe<OrderBy>;
  averageQuotationDays?: InputMaybe<OrderBy>;
  averageResponseDays?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  googleReviewLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_view". All fields are combined with a logical 'AND'. */
export type ProViewBoolExp = {
  _and?: InputMaybe<Array<ProViewBoolExp>>;
  _not?: InputMaybe<ProViewBoolExp>;
  _or?: InputMaybe<Array<ProViewBoolExp>>;
  accounts?: InputMaybe<AccountProViewBoolExp>;
  accountsAggregate?: InputMaybe<AccountProViewAggregateBoolExp>;
  activeHoliday?: InputMaybe<ViewActiveHolidayBoolExp>;
  archiveReason?: InputMaybe<StringComparisonExp>;
  avatarHash?: InputMaybe<StringComparisonExp>;
  averageProjectDays?: InputMaybe<IntComparisonExp>;
  averageQuotationDays?: InputMaybe<IntComparisonExp>;
  averageResponseDays?: InputMaybe<IntComparisonExp>;
  bilikZone?: InputMaybe<BilikZoneBoolExp>;
  bilikZoneId?: InputMaybe<IntComparisonExp>;
  callTrackingForward?: InputMaybe<JsonbComparisonExp>;
  callTrackingTarget?: InputMaybe<JsonbComparisonExp>;
  cities?: InputMaybe<CityProViewBoolExp>;
  citiesAggregate?: InputMaybe<CityProViewAggregateBoolExp>;
  colleagues?: InputMaybe<ProViewProViewBoolExp>;
  colleaguesAggregate?: InputMaybe<ProViewProViewAggregateBoolExp>;
  contractConfiguration?: InputMaybe<JsonbComparisonExp>;
  contractEvents?: InputMaybe<JsonbComparisonExp>;
  dateArchiveScheduled?: InputMaybe<TimestamptzComparisonExp>;
  dateArchived?: InputMaybe<TimestamptzComparisonExp>;
  dateCreated?: InputMaybe<TimestamptzComparisonExp>;
  datePublished?: InputMaybe<TimestamptzComparisonExp>;
  emailTarget?: InputMaybe<StringComparisonExp>;
  googleReviewLink?: InputMaybe<GoogleReviewLinkBoolExp>;
  googleReviewLinkId?: InputMaybe<IntComparisonExp>;
  hasContact?: InputMaybe<BooleanComparisonExp>;
  hasQuotation?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  interventionExclude?: InputMaybe<GeometryComparisonExp>;
  interventionInclude?: InputMaybe<GeometryComparisonExp>;
  isCallAlertActivated?: InputMaybe<BooleanComparisonExp>;
  isCallRecordable?: InputMaybe<BooleanComparisonExp>;
  isCallsDisabled?: InputMaybe<BooleanComparisonExp>;
  isEnglishSpeaker?: InputMaybe<BooleanComparisonExp>;
  isLocalBusiness?: InputMaybe<BooleanComparisonExp>;
  isMainCityCenterExcluded?: InputMaybe<BooleanComparisonExp>;
  isSmsDisabled?: InputMaybe<BooleanComparisonExp>;
  isSolicitationsDisabled?: InputMaybe<BooleanComparisonExp>;
  isTradeCallRecordable?: InputMaybe<BooleanComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  openingHours?: InputMaybe<StringComparisonExp>;
  originalAvatarHash?: InputMaybe<StringComparisonExp>;
  phoneNumbers?: InputMaybe<PhoneNumberBoolExp>;
  phoneNumbersAggregate?: InputMaybe<PhoneNumberAggregateBoolExp>;
  priceComment?: InputMaybe<StringComparisonExp>;
  proHolidays?: InputMaybe<ProHolidayBoolExp>;
  proHolidaysAggregate?: InputMaybe<ProHolidayAggregateBoolExp>;
  proMessages?: InputMaybe<ProMessageBoolExp>;
  proMessagesAggregate?: InputMaybe<ProMessageAggregateBoolExp>;
  proPeople?: InputMaybe<ProViewProPersonBoolExp>;
  proPeopleAggregate?: InputMaybe<ProViewProPersonAggregateBoolExp>;
  proPostalAddress?: InputMaybe<ProPostalAddressBoolExp>;
  proPresentation?: InputMaybe<ProPresentationBoolExp>;
  proPresentationId?: InputMaybe<IntComparisonExp>;
  proPrices?: InputMaybe<ProPriceBoolExp>;
  proPricesAggregate?: InputMaybe<ProPriceAggregateBoolExp>;
  queued_sms?: InputMaybe<QueuedSmsBoolExp>;
  queued_smsAggregate?: InputMaybe<QueuedSmsAggregateBoolExp>;
  relatedProViews?: InputMaybe<ProViewProViewBoolExp>;
  relatedProViewsAggregate?: InputMaybe<ProViewProViewAggregateBoolExp>;
  solicitations?: InputMaybe<SolicitationBoolExp>;
  solicitationsAggregate?: InputMaybe<SolicitationAggregateBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  trades?: InputMaybe<TradeProViewBoolExp>;
  tradesAggregate?: InputMaybe<TradeProViewAggregateBoolExp>;
  webPhoneNumber?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "pro_view" */
export enum ProViewConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_22994Primary = 'idx_22994_primary',
  /** unique or primary key constraint on columns "bilik_zone_id", "pro_presentation_id" */
  Idx_22994ViewUnique = 'idx_22994_view_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ProViewDeleteAtPathInput = {
  /** (DC2Type:json_array) */
  callTrackingForward?: InputMaybe<Array<Scalars['String']>>;
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Array<Scalars['String']>>;
  contractConfiguration?: InputMaybe<Array<Scalars['String']>>;
  contractEvents?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ProViewDeleteElemInput = {
  /** (DC2Type:json_array) */
  callTrackingForward?: InputMaybe<Scalars['Int']>;
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['Int']>;
  contractConfiguration?: InputMaybe<Scalars['Int']>;
  contractEvents?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ProViewDeleteKeyInput = {
  /** (DC2Type:json_array) */
  callTrackingForward?: InputMaybe<Scalars['String']>;
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['String']>;
  contractConfiguration?: InputMaybe<Scalars['String']>;
  contractEvents?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "pro_view" */
export type ProViewIncInput = {
  averageProjectDays?: InputMaybe<Scalars['Int']>;
  averageQuotationDays?: InputMaybe<Scalars['Int']>;
  averageResponseDays?: InputMaybe<Scalars['Int']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  googleReviewLinkId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_view" */
export type ProViewInsertInput = {
  accounts?: InputMaybe<AccountProViewArrRelInsertInput>;
  activeHoliday?: InputMaybe<ViewActiveHolidayObjRelInsertInput>;
  archiveReason?: InputMaybe<Scalars['String']>;
  avatarHash?: InputMaybe<Scalars['String']>;
  averageProjectDays?: InputMaybe<Scalars['Int']>;
  averageQuotationDays?: InputMaybe<Scalars['Int']>;
  averageResponseDays?: InputMaybe<Scalars['Int']>;
  bilikZone?: InputMaybe<BilikZoneObjRelInsertInput>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  /** (DC2Type:json_array) */
  callTrackingForward?: InputMaybe<Scalars['jsonb']>;
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  cities?: InputMaybe<CityProViewArrRelInsertInput>;
  colleagues?: InputMaybe<ProViewProViewArrRelInsertInput>;
  contractConfiguration?: InputMaybe<Scalars['jsonb']>;
  contractEvents?: InputMaybe<Scalars['jsonb']>;
  dateArchiveScheduled?: InputMaybe<Scalars['timestamptz']>;
  dateArchived?: InputMaybe<Scalars['timestamptz']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  datePublished?: InputMaybe<Scalars['timestamptz']>;
  emailTarget?: InputMaybe<Scalars['String']>;
  googleReviewLink?: InputMaybe<GoogleReviewLinkObjRelInsertInput>;
  googleReviewLinkId?: InputMaybe<Scalars['Int']>;
  hasContact?: InputMaybe<Scalars['Boolean']>;
  hasQuotation?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  interventionExclude?: InputMaybe<Scalars['geometry']>;
  interventionInclude?: InputMaybe<Scalars['geometry']>;
  isCallAlertActivated?: InputMaybe<Scalars['Boolean']>;
  isCallRecordable?: InputMaybe<Scalars['Boolean']>;
  isCallsDisabled?: InputMaybe<Scalars['Boolean']>;
  isEnglishSpeaker?: InputMaybe<Scalars['Boolean']>;
  isLocalBusiness?: InputMaybe<Scalars['Boolean']>;
  isMainCityCenterExcluded?: InputMaybe<Scalars['Boolean']>;
  isSmsDisabled?: InputMaybe<Scalars['Boolean']>;
  isSolicitationsDisabled?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  openingHours?: InputMaybe<Scalars['String']>;
  originalAvatarHash?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<PhoneNumberArrRelInsertInput>;
  priceComment?: InputMaybe<Scalars['String']>;
  proHolidays?: InputMaybe<ProHolidayArrRelInsertInput>;
  proMessages?: InputMaybe<ProMessageArrRelInsertInput>;
  proPeople?: InputMaybe<ProViewProPersonArrRelInsertInput>;
  proPostalAddress?: InputMaybe<ProPostalAddressObjRelInsertInput>;
  proPresentation?: InputMaybe<ProPresentationObjRelInsertInput>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  proPrices?: InputMaybe<ProPriceArrRelInsertInput>;
  queued_sms?: InputMaybe<QueuedSmsArrRelInsertInput>;
  relatedProViews?: InputMaybe<ProViewProViewArrRelInsertInput>;
  solicitations?: InputMaybe<SolicitationArrRelInsertInput>;
  status?: InputMaybe<Scalars['String']>;
  trades?: InputMaybe<TradeProViewArrRelInsertInput>;
};

/** aggregate max on columns */
export type ProViewMaxFields = {
  __typename?: 'ProViewMaxFields';
  archiveReason?: Maybe<Scalars['String']>;
  avatarHash?: Maybe<Scalars['String']>;
  averageProjectDays?: Maybe<Scalars['Int']>;
  averageQuotationDays?: Maybe<Scalars['Int']>;
  averageResponseDays?: Maybe<Scalars['Int']>;
  bilikZoneId?: Maybe<Scalars['Int']>;
  dateArchiveScheduled?: Maybe<Scalars['timestamptz']>;
  dateArchived?: Maybe<Scalars['timestamptz']>;
  dateCreated?: Maybe<Scalars['timestamptz']>;
  datePublished?: Maybe<Scalars['timestamptz']>;
  emailTarget?: Maybe<Scalars['String']>;
  googleReviewLinkId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Scalars['String']>;
  originalAvatarHash?: Maybe<Scalars['String']>;
  priceComment?: Maybe<Scalars['String']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  /** A computed field, executes function "pro_view_web_phone_number" */
  webPhoneNumber?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "pro_view" */
export type ProViewMaxOrderBy = {
  archiveReason?: InputMaybe<OrderBy>;
  avatarHash?: InputMaybe<OrderBy>;
  averageProjectDays?: InputMaybe<OrderBy>;
  averageQuotationDays?: InputMaybe<OrderBy>;
  averageResponseDays?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  dateArchiveScheduled?: InputMaybe<OrderBy>;
  dateArchived?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  datePublished?: InputMaybe<OrderBy>;
  emailTarget?: InputMaybe<OrderBy>;
  googleReviewLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  openingHours?: InputMaybe<OrderBy>;
  originalAvatarHash?: InputMaybe<OrderBy>;
  priceComment?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProViewMinFields = {
  __typename?: 'ProViewMinFields';
  archiveReason?: Maybe<Scalars['String']>;
  avatarHash?: Maybe<Scalars['String']>;
  averageProjectDays?: Maybe<Scalars['Int']>;
  averageQuotationDays?: Maybe<Scalars['Int']>;
  averageResponseDays?: Maybe<Scalars['Int']>;
  bilikZoneId?: Maybe<Scalars['Int']>;
  dateArchiveScheduled?: Maybe<Scalars['timestamptz']>;
  dateArchived?: Maybe<Scalars['timestamptz']>;
  dateCreated?: Maybe<Scalars['timestamptz']>;
  datePublished?: Maybe<Scalars['timestamptz']>;
  emailTarget?: Maybe<Scalars['String']>;
  googleReviewLinkId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Scalars['String']>;
  originalAvatarHash?: Maybe<Scalars['String']>;
  priceComment?: Maybe<Scalars['String']>;
  proPresentationId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  /** A computed field, executes function "pro_view_web_phone_number" */
  webPhoneNumber?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "pro_view" */
export type ProViewMinOrderBy = {
  archiveReason?: InputMaybe<OrderBy>;
  avatarHash?: InputMaybe<OrderBy>;
  averageProjectDays?: InputMaybe<OrderBy>;
  averageQuotationDays?: InputMaybe<OrderBy>;
  averageResponseDays?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  dateArchiveScheduled?: InputMaybe<OrderBy>;
  dateArchived?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  datePublished?: InputMaybe<OrderBy>;
  emailTarget?: InputMaybe<OrderBy>;
  googleReviewLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  openingHours?: InputMaybe<OrderBy>;
  originalAvatarHash?: InputMaybe<OrderBy>;
  priceComment?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_view" */
export type ProViewMutationResponse = {
  __typename?: 'ProViewMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProView>;
};

/** input type for inserting object relation for remote table "pro_view" */
export type ProViewObjRelInsertInput = {
  data: ProViewInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ProViewOnConflict>;
};

/** on_conflict condition type for table "pro_view" */
export type ProViewOnConflict = {
  constraint: ProViewConstraint;
  updateColumns?: Array<ProViewUpdateColumn>;
  where?: InputMaybe<ProViewBoolExp>;
};

/** Ordering options when selecting data from "pro_view". */
export type ProViewOrderBy = {
  accountsAggregate?: InputMaybe<AccountProViewAggregateOrderBy>;
  activeHoliday?: InputMaybe<ViewActiveHolidayOrderBy>;
  archiveReason?: InputMaybe<OrderBy>;
  avatarHash?: InputMaybe<OrderBy>;
  averageProjectDays?: InputMaybe<OrderBy>;
  averageQuotationDays?: InputMaybe<OrderBy>;
  averageResponseDays?: InputMaybe<OrderBy>;
  bilikZone?: InputMaybe<BilikZoneOrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  callTrackingForward?: InputMaybe<OrderBy>;
  callTrackingTarget?: InputMaybe<OrderBy>;
  citiesAggregate?: InputMaybe<CityProViewAggregateOrderBy>;
  colleaguesAggregate?: InputMaybe<ProViewProViewAggregateOrderBy>;
  contractConfiguration?: InputMaybe<OrderBy>;
  contractEvents?: InputMaybe<OrderBy>;
  dateArchiveScheduled?: InputMaybe<OrderBy>;
  dateArchived?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  datePublished?: InputMaybe<OrderBy>;
  emailTarget?: InputMaybe<OrderBy>;
  googleReviewLink?: InputMaybe<GoogleReviewLinkOrderBy>;
  googleReviewLinkId?: InputMaybe<OrderBy>;
  hasContact?: InputMaybe<OrderBy>;
  hasQuotation?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interventionExclude?: InputMaybe<OrderBy>;
  interventionInclude?: InputMaybe<OrderBy>;
  isCallAlertActivated?: InputMaybe<OrderBy>;
  isCallRecordable?: InputMaybe<OrderBy>;
  isCallsDisabled?: InputMaybe<OrderBy>;
  isEnglishSpeaker?: InputMaybe<OrderBy>;
  isLocalBusiness?: InputMaybe<OrderBy>;
  isMainCityCenterExcluded?: InputMaybe<OrderBy>;
  isSmsDisabled?: InputMaybe<OrderBy>;
  isSolicitationsDisabled?: InputMaybe<OrderBy>;
  isTradeCallRecordable?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  openingHours?: InputMaybe<OrderBy>;
  originalAvatarHash?: InputMaybe<OrderBy>;
  phoneNumbersAggregate?: InputMaybe<PhoneNumberAggregateOrderBy>;
  priceComment?: InputMaybe<OrderBy>;
  proHolidaysAggregate?: InputMaybe<ProHolidayAggregateOrderBy>;
  proMessagesAggregate?: InputMaybe<ProMessageAggregateOrderBy>;
  proPeopleAggregate?: InputMaybe<ProViewProPersonAggregateOrderBy>;
  proPostalAddress?: InputMaybe<ProPostalAddressOrderBy>;
  proPresentation?: InputMaybe<ProPresentationOrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  proPricesAggregate?: InputMaybe<ProPriceAggregateOrderBy>;
  queued_smsAggregate?: InputMaybe<QueuedSmsAggregateOrderBy>;
  relatedProViewsAggregate?: InputMaybe<ProViewProViewAggregateOrderBy>;
  solicitationsAggregate?: InputMaybe<SolicitationAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  tradesAggregate?: InputMaybe<TradeProViewAggregateOrderBy>;
  webPhoneNumber?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_view */
export type ProViewPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ProViewPrependInput = {
  /** (DC2Type:json_array) */
  callTrackingForward?: InputMaybe<Scalars['jsonb']>;
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  contractConfiguration?: InputMaybe<Scalars['jsonb']>;
  contractEvents?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "pro_view_pro_person" */
export type ProViewProPerson = {
  __typename?: 'ProViewProPerson';
  isVisible: Scalars['Boolean'];
  position: Scalars['Int'];
  /** An object relationship */
  proPerson: ProPerson;
  proPersonId: Scalars['Int'];
  /** An object relationship */
  proView: ProView;
  proViewId: Scalars['Int'];
};

/** aggregated selection of "pro_view_pro_person" */
export type ProViewProPersonAggregate = {
  __typename?: 'ProViewProPersonAggregate';
  aggregate?: Maybe<ProViewProPersonAggregateFields>;
  nodes: Array<ProViewProPerson>;
};

export type ProViewProPersonAggregateBoolExp = {
  bool_and?: InputMaybe<ProViewProPersonAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<ProViewProPersonAggregateBoolExpBoolOr>;
  count?: InputMaybe<ProViewProPersonAggregateBoolExpCount>;
};

/** aggregate fields of "pro_view_pro_person" */
export type ProViewProPersonAggregateFields = {
  __typename?: 'ProViewProPersonAggregateFields';
  avg?: Maybe<ProViewProPersonAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProViewProPersonMaxFields>;
  min?: Maybe<ProViewProPersonMinFields>;
  stddev?: Maybe<ProViewProPersonStddevFields>;
  stddevPop?: Maybe<ProViewProPersonStddevPopFields>;
  stddevSamp?: Maybe<ProViewProPersonStddevSampFields>;
  sum?: Maybe<ProViewProPersonSumFields>;
  varPop?: Maybe<ProViewProPersonVarPopFields>;
  varSamp?: Maybe<ProViewProPersonVarSampFields>;
  variance?: Maybe<ProViewProPersonVarianceFields>;
};


/** aggregate fields of "pro_view_pro_person" */
export type ProViewProPersonAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProViewProPersonSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_view_pro_person" */
export type ProViewProPersonAggregateOrderBy = {
  avg?: InputMaybe<ProViewProPersonAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProViewProPersonMaxOrderBy>;
  min?: InputMaybe<ProViewProPersonMinOrderBy>;
  stddev?: InputMaybe<ProViewProPersonStddevOrderBy>;
  stddevPop?: InputMaybe<ProViewProPersonStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProViewProPersonStddevSampOrderBy>;
  sum?: InputMaybe<ProViewProPersonSumOrderBy>;
  varPop?: InputMaybe<ProViewProPersonVarPopOrderBy>;
  varSamp?: InputMaybe<ProViewProPersonVarSampOrderBy>;
  variance?: InputMaybe<ProViewProPersonVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pro_view_pro_person" */
export type ProViewProPersonArrRelInsertInput = {
  data: Array<ProViewProPersonInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProViewProPersonOnConflict>;
};

/** aggregate avg on columns */
export type ProViewProPersonAvgFields = {
  __typename?: 'ProViewProPersonAvgFields';
  position?: Maybe<Scalars['Float']>;
  proPersonId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pro_view_pro_person" */
export type ProViewProPersonAvgOrderBy = {
  position?: InputMaybe<OrderBy>;
  proPersonId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_view_pro_person". All fields are combined with a logical 'AND'. */
export type ProViewProPersonBoolExp = {
  _and?: InputMaybe<Array<ProViewProPersonBoolExp>>;
  _not?: InputMaybe<ProViewProPersonBoolExp>;
  _or?: InputMaybe<Array<ProViewProPersonBoolExp>>;
  isVisible?: InputMaybe<BooleanComparisonExp>;
  position?: InputMaybe<IntComparisonExp>;
  proPerson?: InputMaybe<ProPersonBoolExp>;
  proPersonId?: InputMaybe<IntComparisonExp>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "pro_view_pro_person" */
export enum ProViewProPersonConstraint {
  /** unique or primary key constraint on columns "pro_view_id", "pro_person_id" */
  ProViewProPersonPkey = 'pro_view_pro_person_pkey'
}

/** input type for incrementing numeric columns in table "pro_view_pro_person" */
export type ProViewProPersonIncInput = {
  position?: InputMaybe<Scalars['Int']>;
  proPersonId?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_view_pro_person" */
export type ProViewProPersonInsertInput = {
  isVisible?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['Int']>;
  proPerson?: InputMaybe<ProPersonObjRelInsertInput>;
  proPersonId?: InputMaybe<Scalars['Int']>;
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ProViewProPersonMaxFields = {
  __typename?: 'ProViewProPersonMaxFields';
  position?: Maybe<Scalars['Int']>;
  proPersonId?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "pro_view_pro_person" */
export type ProViewProPersonMaxOrderBy = {
  position?: InputMaybe<OrderBy>;
  proPersonId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProViewProPersonMinFields = {
  __typename?: 'ProViewProPersonMinFields';
  position?: Maybe<Scalars['Int']>;
  proPersonId?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "pro_view_pro_person" */
export type ProViewProPersonMinOrderBy = {
  position?: InputMaybe<OrderBy>;
  proPersonId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_view_pro_person" */
export type ProViewProPersonMutationResponse = {
  __typename?: 'ProViewProPersonMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProViewProPerson>;
};

/** on_conflict condition type for table "pro_view_pro_person" */
export type ProViewProPersonOnConflict = {
  constraint: ProViewProPersonConstraint;
  updateColumns?: Array<ProViewProPersonUpdateColumn>;
  where?: InputMaybe<ProViewProPersonBoolExp>;
};

/** Ordering options when selecting data from "pro_view_pro_person". */
export type ProViewProPersonOrderBy = {
  isVisible?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  proPerson?: InputMaybe<ProPersonOrderBy>;
  proPersonId?: InputMaybe<OrderBy>;
  proView?: InputMaybe<ProViewOrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_view_pro_person */
export type ProViewProPersonPkColumnsInput = {
  proPersonId: Scalars['Int'];
  proViewId: Scalars['Int'];
};

/** select columns of table "pro_view_pro_person" */
export enum ProViewProPersonSelectColumn {
  /** column name */
  IsVisible = 'isVisible',
  /** column name */
  Position = 'position',
  /** column name */
  ProPersonId = 'proPersonId',
  /** column name */
  ProViewId = 'proViewId'
}

/** select "proViewProPersonAggregateBoolExpBool_andArgumentsColumns" columns of table "pro_view_pro_person" */
export enum ProViewProPersonSelectColumnProViewProPersonAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsVisible = 'isVisible'
}

/** select "proViewProPersonAggregateBoolExpBool_orArgumentsColumns" columns of table "pro_view_pro_person" */
export enum ProViewProPersonSelectColumnProViewProPersonAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsVisible = 'isVisible'
}

/** input type for updating data in table "pro_view_pro_person" */
export type ProViewProPersonSetInput = {
  isVisible?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['Int']>;
  proPersonId?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ProViewProPersonStddevFields = {
  __typename?: 'ProViewProPersonStddevFields';
  position?: Maybe<Scalars['Float']>;
  proPersonId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pro_view_pro_person" */
export type ProViewProPersonStddevOrderBy = {
  position?: InputMaybe<OrderBy>;
  proPersonId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProViewProPersonStddevPopFields = {
  __typename?: 'ProViewProPersonStddevPopFields';
  position?: Maybe<Scalars['Float']>;
  proPersonId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pro_view_pro_person" */
export type ProViewProPersonStddevPopOrderBy = {
  position?: InputMaybe<OrderBy>;
  proPersonId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProViewProPersonStddevSampFields = {
  __typename?: 'ProViewProPersonStddevSampFields';
  position?: Maybe<Scalars['Float']>;
  proPersonId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pro_view_pro_person" */
export type ProViewProPersonStddevSampOrderBy = {
  position?: InputMaybe<OrderBy>;
  proPersonId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_view_pro_person" */
export type ProViewProPersonStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProViewProPersonStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProViewProPersonStreamCursorValueInput = {
  isVisible?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['Int']>;
  proPersonId?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ProViewProPersonSumFields = {
  __typename?: 'ProViewProPersonSumFields';
  position?: Maybe<Scalars['Int']>;
  proPersonId?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pro_view_pro_person" */
export type ProViewProPersonSumOrderBy = {
  position?: InputMaybe<OrderBy>;
  proPersonId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_view_pro_person" */
export enum ProViewProPersonUpdateColumn {
  /** column name */
  IsVisible = 'isVisible',
  /** column name */
  Position = 'position',
  /** column name */
  ProPersonId = 'proPersonId',
  /** column name */
  ProViewId = 'proViewId'
}

export type ProViewProPersonUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProViewProPersonIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProViewProPersonSetInput>;
  /** filter the rows which have to be updated */
  where: ProViewProPersonBoolExp;
};

/** aggregate varPop on columns */
export type ProViewProPersonVarPopFields = {
  __typename?: 'ProViewProPersonVarPopFields';
  position?: Maybe<Scalars['Float']>;
  proPersonId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pro_view_pro_person" */
export type ProViewProPersonVarPopOrderBy = {
  position?: InputMaybe<OrderBy>;
  proPersonId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProViewProPersonVarSampFields = {
  __typename?: 'ProViewProPersonVarSampFields';
  position?: Maybe<Scalars['Float']>;
  proPersonId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pro_view_pro_person" */
export type ProViewProPersonVarSampOrderBy = {
  position?: InputMaybe<OrderBy>;
  proPersonId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProViewProPersonVarianceFields = {
  __typename?: 'ProViewProPersonVarianceFields';
  position?: Maybe<Scalars['Float']>;
  proPersonId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pro_view_pro_person" */
export type ProViewProPersonVarianceOrderBy = {
  position?: InputMaybe<OrderBy>;
  proPersonId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "pro_view_pro_view" */
export type ProViewProView = {
  __typename?: 'ProViewProView';
  /** An object relationship */
  proView: ProView;
  /** An object relationship */
  proViewByProViewSource: ProView;
  proViewSource: Scalars['Int'];
  proViewTarget: Scalars['Int'];
};

/** aggregated selection of "pro_view_pro_view" */
export type ProViewProViewAggregate = {
  __typename?: 'ProViewProViewAggregate';
  aggregate?: Maybe<ProViewProViewAggregateFields>;
  nodes: Array<ProViewProView>;
};

export type ProViewProViewAggregateBoolExp = {
  count?: InputMaybe<ProViewProViewAggregateBoolExpCount>;
};

/** aggregate fields of "pro_view_pro_view" */
export type ProViewProViewAggregateFields = {
  __typename?: 'ProViewProViewAggregateFields';
  avg?: Maybe<ProViewProViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProViewProViewMaxFields>;
  min?: Maybe<ProViewProViewMinFields>;
  stddev?: Maybe<ProViewProViewStddevFields>;
  stddevPop?: Maybe<ProViewProViewStddevPopFields>;
  stddevSamp?: Maybe<ProViewProViewStddevSampFields>;
  sum?: Maybe<ProViewProViewSumFields>;
  varPop?: Maybe<ProViewProViewVarPopFields>;
  varSamp?: Maybe<ProViewProViewVarSampFields>;
  variance?: Maybe<ProViewProViewVarianceFields>;
};


/** aggregate fields of "pro_view_pro_view" */
export type ProViewProViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProViewProViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pro_view_pro_view" */
export type ProViewProViewAggregateOrderBy = {
  avg?: InputMaybe<ProViewProViewAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProViewProViewMaxOrderBy>;
  min?: InputMaybe<ProViewProViewMinOrderBy>;
  stddev?: InputMaybe<ProViewProViewStddevOrderBy>;
  stddevPop?: InputMaybe<ProViewProViewStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ProViewProViewStddevSampOrderBy>;
  sum?: InputMaybe<ProViewProViewSumOrderBy>;
  varPop?: InputMaybe<ProViewProViewVarPopOrderBy>;
  varSamp?: InputMaybe<ProViewProViewVarSampOrderBy>;
  variance?: InputMaybe<ProViewProViewVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pro_view_pro_view" */
export type ProViewProViewArrRelInsertInput = {
  data: Array<ProViewProViewInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProViewProViewOnConflict>;
};

/** aggregate avg on columns */
export type ProViewProViewAvgFields = {
  __typename?: 'ProViewProViewAvgFields';
  proViewSource?: Maybe<Scalars['Float']>;
  proViewTarget?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pro_view_pro_view" */
export type ProViewProViewAvgOrderBy = {
  proViewSource?: InputMaybe<OrderBy>;
  proViewTarget?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pro_view_pro_view". All fields are combined with a logical 'AND'. */
export type ProViewProViewBoolExp = {
  _and?: InputMaybe<Array<ProViewProViewBoolExp>>;
  _not?: InputMaybe<ProViewProViewBoolExp>;
  _or?: InputMaybe<Array<ProViewProViewBoolExp>>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewByProViewSource?: InputMaybe<ProViewBoolExp>;
  proViewSource?: InputMaybe<IntComparisonExp>;
  proViewTarget?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "pro_view_pro_view" */
export enum ProViewProViewConstraint {
  /** unique or primary key constraint on columns "pro_view_target", "pro_view_source" */
  Idx_23009Primary = 'idx_23009_primary'
}

/** input type for incrementing numeric columns in table "pro_view_pro_view" */
export type ProViewProViewIncInput = {
  proViewSource?: InputMaybe<Scalars['Int']>;
  proViewTarget?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pro_view_pro_view" */
export type ProViewProViewInsertInput = {
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewByProViewSource?: InputMaybe<ProViewObjRelInsertInput>;
  proViewSource?: InputMaybe<Scalars['Int']>;
  proViewTarget?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ProViewProViewMaxFields = {
  __typename?: 'ProViewProViewMaxFields';
  proViewSource?: Maybe<Scalars['Int']>;
  proViewTarget?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "pro_view_pro_view" */
export type ProViewProViewMaxOrderBy = {
  proViewSource?: InputMaybe<OrderBy>;
  proViewTarget?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProViewProViewMinFields = {
  __typename?: 'ProViewProViewMinFields';
  proViewSource?: Maybe<Scalars['Int']>;
  proViewTarget?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "pro_view_pro_view" */
export type ProViewProViewMinOrderBy = {
  proViewSource?: InputMaybe<OrderBy>;
  proViewTarget?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pro_view_pro_view" */
export type ProViewProViewMutationResponse = {
  __typename?: 'ProViewProViewMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProViewProView>;
};

/** on_conflict condition type for table "pro_view_pro_view" */
export type ProViewProViewOnConflict = {
  constraint: ProViewProViewConstraint;
  updateColumns?: Array<ProViewProViewUpdateColumn>;
  where?: InputMaybe<ProViewProViewBoolExp>;
};

/** Ordering options when selecting data from "pro_view_pro_view". */
export type ProViewProViewOrderBy = {
  proView?: InputMaybe<ProViewOrderBy>;
  proViewByProViewSource?: InputMaybe<ProViewOrderBy>;
  proViewSource?: InputMaybe<OrderBy>;
  proViewTarget?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pro_view_pro_view */
export type ProViewProViewPkColumnsInput = {
  proViewSource: Scalars['Int'];
  proViewTarget: Scalars['Int'];
};

/** select columns of table "pro_view_pro_view" */
export enum ProViewProViewSelectColumn {
  /** column name */
  ProViewSource = 'proViewSource',
  /** column name */
  ProViewTarget = 'proViewTarget'
}

/** input type for updating data in table "pro_view_pro_view" */
export type ProViewProViewSetInput = {
  proViewSource?: InputMaybe<Scalars['Int']>;
  proViewTarget?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ProViewProViewStddevFields = {
  __typename?: 'ProViewProViewStddevFields';
  proViewSource?: Maybe<Scalars['Float']>;
  proViewTarget?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pro_view_pro_view" */
export type ProViewProViewStddevOrderBy = {
  proViewSource?: InputMaybe<OrderBy>;
  proViewTarget?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProViewProViewStddevPopFields = {
  __typename?: 'ProViewProViewStddevPopFields';
  proViewSource?: Maybe<Scalars['Float']>;
  proViewTarget?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pro_view_pro_view" */
export type ProViewProViewStddevPopOrderBy = {
  proViewSource?: InputMaybe<OrderBy>;
  proViewTarget?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProViewProViewStddevSampFields = {
  __typename?: 'ProViewProViewStddevSampFields';
  proViewSource?: Maybe<Scalars['Float']>;
  proViewTarget?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pro_view_pro_view" */
export type ProViewProViewStddevSampOrderBy = {
  proViewSource?: InputMaybe<OrderBy>;
  proViewTarget?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_view_pro_view" */
export type ProViewProViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProViewProViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProViewProViewStreamCursorValueInput = {
  proViewSource?: InputMaybe<Scalars['Int']>;
  proViewTarget?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ProViewProViewSumFields = {
  __typename?: 'ProViewProViewSumFields';
  proViewSource?: Maybe<Scalars['Int']>;
  proViewTarget?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pro_view_pro_view" */
export type ProViewProViewSumOrderBy = {
  proViewSource?: InputMaybe<OrderBy>;
  proViewTarget?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_view_pro_view" */
export enum ProViewProViewUpdateColumn {
  /** column name */
  ProViewSource = 'proViewSource',
  /** column name */
  ProViewTarget = 'proViewTarget'
}

export type ProViewProViewUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProViewProViewIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProViewProViewSetInput>;
  /** filter the rows which have to be updated */
  where: ProViewProViewBoolExp;
};

/** aggregate varPop on columns */
export type ProViewProViewVarPopFields = {
  __typename?: 'ProViewProViewVarPopFields';
  proViewSource?: Maybe<Scalars['Float']>;
  proViewTarget?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pro_view_pro_view" */
export type ProViewProViewVarPopOrderBy = {
  proViewSource?: InputMaybe<OrderBy>;
  proViewTarget?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProViewProViewVarSampFields = {
  __typename?: 'ProViewProViewVarSampFields';
  proViewSource?: Maybe<Scalars['Float']>;
  proViewTarget?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pro_view_pro_view" */
export type ProViewProViewVarSampOrderBy = {
  proViewSource?: InputMaybe<OrderBy>;
  proViewTarget?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProViewProViewVarianceFields = {
  __typename?: 'ProViewProViewVarianceFields';
  proViewSource?: Maybe<Scalars['Float']>;
  proViewTarget?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pro_view_pro_view" */
export type ProViewProViewVarianceOrderBy = {
  proViewSource?: InputMaybe<OrderBy>;
  proViewTarget?: InputMaybe<OrderBy>;
};

/** select columns of table "pro_view" */
export enum ProViewSelectColumn {
  /** column name */
  ArchiveReason = 'archiveReason',
  /** column name */
  AvatarHash = 'avatarHash',
  /** column name */
  AverageProjectDays = 'averageProjectDays',
  /** column name */
  AverageQuotationDays = 'averageQuotationDays',
  /** column name */
  AverageResponseDays = 'averageResponseDays',
  /** column name */
  BilikZoneId = 'bilikZoneId',
  /** column name */
  CallTrackingForward = 'callTrackingForward',
  /** column name */
  CallTrackingTarget = 'callTrackingTarget',
  /** column name */
  ContractConfiguration = 'contractConfiguration',
  /** column name */
  ContractEvents = 'contractEvents',
  /** column name */
  DateArchiveScheduled = 'dateArchiveScheduled',
  /** column name */
  DateArchived = 'dateArchived',
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  DatePublished = 'datePublished',
  /** column name */
  EmailTarget = 'emailTarget',
  /** column name */
  GoogleReviewLinkId = 'googleReviewLinkId',
  /** column name */
  HasContact = 'hasContact',
  /** column name */
  HasQuotation = 'hasQuotation',
  /** column name */
  Id = 'id',
  /** column name */
  InterventionExclude = 'interventionExclude',
  /** column name */
  InterventionInclude = 'interventionInclude',
  /** column name */
  IsCallAlertActivated = 'isCallAlertActivated',
  /** column name */
  IsCallRecordable = 'isCallRecordable',
  /** column name */
  IsCallsDisabled = 'isCallsDisabled',
  /** column name */
  IsEnglishSpeaker = 'isEnglishSpeaker',
  /** column name */
  IsLocalBusiness = 'isLocalBusiness',
  /** column name */
  IsMainCityCenterExcluded = 'isMainCityCenterExcluded',
  /** column name */
  IsSmsDisabled = 'isSmsDisabled',
  /** column name */
  IsSolicitationsDisabled = 'isSolicitationsDisabled',
  /** column name */
  Note = 'note',
  /** column name */
  OpeningHours = 'openingHours',
  /** column name */
  OriginalAvatarHash = 'originalAvatarHash',
  /** column name */
  PriceComment = 'priceComment',
  /** column name */
  ProPresentationId = 'proPresentationId',
  /** column name */
  Status = 'status'
}

/** select "proViewAggregateBoolExpBool_andArgumentsColumns" columns of table "pro_view" */
export enum ProViewSelectColumnProViewAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  HasContact = 'hasContact',
  /** column name */
  HasQuotation = 'hasQuotation',
  /** column name */
  IsCallAlertActivated = 'isCallAlertActivated',
  /** column name */
  IsCallRecordable = 'isCallRecordable',
  /** column name */
  IsCallsDisabled = 'isCallsDisabled',
  /** column name */
  IsEnglishSpeaker = 'isEnglishSpeaker',
  /** column name */
  IsLocalBusiness = 'isLocalBusiness',
  /** column name */
  IsMainCityCenterExcluded = 'isMainCityCenterExcluded',
  /** column name */
  IsSmsDisabled = 'isSmsDisabled',
  /** column name */
  IsSolicitationsDisabled = 'isSolicitationsDisabled'
}

/** select "proViewAggregateBoolExpBool_orArgumentsColumns" columns of table "pro_view" */
export enum ProViewSelectColumnProViewAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  HasContact = 'hasContact',
  /** column name */
  HasQuotation = 'hasQuotation',
  /** column name */
  IsCallAlertActivated = 'isCallAlertActivated',
  /** column name */
  IsCallRecordable = 'isCallRecordable',
  /** column name */
  IsCallsDisabled = 'isCallsDisabled',
  /** column name */
  IsEnglishSpeaker = 'isEnglishSpeaker',
  /** column name */
  IsLocalBusiness = 'isLocalBusiness',
  /** column name */
  IsMainCityCenterExcluded = 'isMainCityCenterExcluded',
  /** column name */
  IsSmsDisabled = 'isSmsDisabled',
  /** column name */
  IsSolicitationsDisabled = 'isSolicitationsDisabled'
}

/** input type for updating data in table "pro_view" */
export type ProViewSetInput = {
  archiveReason?: InputMaybe<Scalars['String']>;
  avatarHash?: InputMaybe<Scalars['String']>;
  averageProjectDays?: InputMaybe<Scalars['Int']>;
  averageQuotationDays?: InputMaybe<Scalars['Int']>;
  averageResponseDays?: InputMaybe<Scalars['Int']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  /** (DC2Type:json_array) */
  callTrackingForward?: InputMaybe<Scalars['jsonb']>;
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  contractConfiguration?: InputMaybe<Scalars['jsonb']>;
  contractEvents?: InputMaybe<Scalars['jsonb']>;
  dateArchiveScheduled?: InputMaybe<Scalars['timestamptz']>;
  dateArchived?: InputMaybe<Scalars['timestamptz']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  datePublished?: InputMaybe<Scalars['timestamptz']>;
  emailTarget?: InputMaybe<Scalars['String']>;
  googleReviewLinkId?: InputMaybe<Scalars['Int']>;
  hasContact?: InputMaybe<Scalars['Boolean']>;
  hasQuotation?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  interventionExclude?: InputMaybe<Scalars['geometry']>;
  interventionInclude?: InputMaybe<Scalars['geometry']>;
  isCallAlertActivated?: InputMaybe<Scalars['Boolean']>;
  isCallRecordable?: InputMaybe<Scalars['Boolean']>;
  isCallsDisabled?: InputMaybe<Scalars['Boolean']>;
  isEnglishSpeaker?: InputMaybe<Scalars['Boolean']>;
  isLocalBusiness?: InputMaybe<Scalars['Boolean']>;
  isMainCityCenterExcluded?: InputMaybe<Scalars['Boolean']>;
  isSmsDisabled?: InputMaybe<Scalars['Boolean']>;
  isSolicitationsDisabled?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  openingHours?: InputMaybe<Scalars['String']>;
  originalAvatarHash?: InputMaybe<Scalars['String']>;
  priceComment?: InputMaybe<Scalars['String']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProViewStddevFields = {
  __typename?: 'ProViewStddevFields';
  averageProjectDays?: Maybe<Scalars['Float']>;
  averageQuotationDays?: Maybe<Scalars['Float']>;
  averageResponseDays?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
  googleReviewLinkId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pro_view" */
export type ProViewStddevOrderBy = {
  averageProjectDays?: InputMaybe<OrderBy>;
  averageQuotationDays?: InputMaybe<OrderBy>;
  averageResponseDays?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  googleReviewLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ProViewStddevPopFields = {
  __typename?: 'ProViewStddevPopFields';
  averageProjectDays?: Maybe<Scalars['Float']>;
  averageQuotationDays?: Maybe<Scalars['Float']>;
  averageResponseDays?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
  googleReviewLinkId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pro_view" */
export type ProViewStddevPopOrderBy = {
  averageProjectDays?: InputMaybe<OrderBy>;
  averageQuotationDays?: InputMaybe<OrderBy>;
  averageResponseDays?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  googleReviewLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ProViewStddevSampFields = {
  __typename?: 'ProViewStddevSampFields';
  averageProjectDays?: Maybe<Scalars['Float']>;
  averageQuotationDays?: Maybe<Scalars['Float']>;
  averageResponseDays?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
  googleReviewLinkId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pro_view" */
export type ProViewStddevSampOrderBy = {
  averageProjectDays?: InputMaybe<OrderBy>;
  averageQuotationDays?: InputMaybe<OrderBy>;
  averageResponseDays?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  googleReviewLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pro_view" */
export type ProViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProViewStreamCursorValueInput = {
  archiveReason?: InputMaybe<Scalars['String']>;
  avatarHash?: InputMaybe<Scalars['String']>;
  averageProjectDays?: InputMaybe<Scalars['Int']>;
  averageQuotationDays?: InputMaybe<Scalars['Int']>;
  averageResponseDays?: InputMaybe<Scalars['Int']>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  /** (DC2Type:json_array) */
  callTrackingForward?: InputMaybe<Scalars['jsonb']>;
  /** (DC2Type:json_array) */
  callTrackingTarget?: InputMaybe<Scalars['jsonb']>;
  contractConfiguration?: InputMaybe<Scalars['jsonb']>;
  contractEvents?: InputMaybe<Scalars['jsonb']>;
  dateArchiveScheduled?: InputMaybe<Scalars['timestamptz']>;
  dateArchived?: InputMaybe<Scalars['timestamptz']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  datePublished?: InputMaybe<Scalars['timestamptz']>;
  emailTarget?: InputMaybe<Scalars['String']>;
  googleReviewLinkId?: InputMaybe<Scalars['Int']>;
  hasContact?: InputMaybe<Scalars['Boolean']>;
  hasQuotation?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  interventionExclude?: InputMaybe<Scalars['geometry']>;
  interventionInclude?: InputMaybe<Scalars['geometry']>;
  isCallAlertActivated?: InputMaybe<Scalars['Boolean']>;
  isCallRecordable?: InputMaybe<Scalars['Boolean']>;
  isCallsDisabled?: InputMaybe<Scalars['Boolean']>;
  isEnglishSpeaker?: InputMaybe<Scalars['Boolean']>;
  isLocalBusiness?: InputMaybe<Scalars['Boolean']>;
  isMainCityCenterExcluded?: InputMaybe<Scalars['Boolean']>;
  isSmsDisabled?: InputMaybe<Scalars['Boolean']>;
  isSolicitationsDisabled?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  openingHours?: InputMaybe<Scalars['String']>;
  originalAvatarHash?: InputMaybe<Scalars['String']>;
  priceComment?: InputMaybe<Scalars['String']>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ProViewSumFields = {
  __typename?: 'ProViewSumFields';
  averageProjectDays?: Maybe<Scalars['Int']>;
  averageQuotationDays?: Maybe<Scalars['Int']>;
  averageResponseDays?: Maybe<Scalars['Int']>;
  bilikZoneId?: Maybe<Scalars['Int']>;
  googleReviewLinkId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  proPresentationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pro_view" */
export type ProViewSumOrderBy = {
  averageProjectDays?: InputMaybe<OrderBy>;
  averageQuotationDays?: InputMaybe<OrderBy>;
  averageResponseDays?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  googleReviewLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** update columns of table "pro_view" */
export enum ProViewUpdateColumn {
  /** column name */
  ArchiveReason = 'archiveReason',
  /** column name */
  AvatarHash = 'avatarHash',
  /** column name */
  AverageProjectDays = 'averageProjectDays',
  /** column name */
  AverageQuotationDays = 'averageQuotationDays',
  /** column name */
  AverageResponseDays = 'averageResponseDays',
  /** column name */
  BilikZoneId = 'bilikZoneId',
  /** column name */
  CallTrackingForward = 'callTrackingForward',
  /** column name */
  CallTrackingTarget = 'callTrackingTarget',
  /** column name */
  ContractConfiguration = 'contractConfiguration',
  /** column name */
  ContractEvents = 'contractEvents',
  /** column name */
  DateArchiveScheduled = 'dateArchiveScheduled',
  /** column name */
  DateArchived = 'dateArchived',
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  DatePublished = 'datePublished',
  /** column name */
  EmailTarget = 'emailTarget',
  /** column name */
  GoogleReviewLinkId = 'googleReviewLinkId',
  /** column name */
  HasContact = 'hasContact',
  /** column name */
  HasQuotation = 'hasQuotation',
  /** column name */
  Id = 'id',
  /** column name */
  InterventionExclude = 'interventionExclude',
  /** column name */
  InterventionInclude = 'interventionInclude',
  /** column name */
  IsCallAlertActivated = 'isCallAlertActivated',
  /** column name */
  IsCallRecordable = 'isCallRecordable',
  /** column name */
  IsCallsDisabled = 'isCallsDisabled',
  /** column name */
  IsEnglishSpeaker = 'isEnglishSpeaker',
  /** column name */
  IsLocalBusiness = 'isLocalBusiness',
  /** column name */
  IsMainCityCenterExcluded = 'isMainCityCenterExcluded',
  /** column name */
  IsSmsDisabled = 'isSmsDisabled',
  /** column name */
  IsSolicitationsDisabled = 'isSolicitationsDisabled',
  /** column name */
  Note = 'note',
  /** column name */
  OpeningHours = 'openingHours',
  /** column name */
  OriginalAvatarHash = 'originalAvatarHash',
  /** column name */
  PriceComment = 'priceComment',
  /** column name */
  ProPresentationId = 'proPresentationId',
  /** column name */
  Status = 'status'
}

export type ProViewUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ProViewAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<ProViewDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<ProViewDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<ProViewDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProViewIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ProViewPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProViewSetInput>;
  /** filter the rows which have to be updated */
  where: ProViewBoolExp;
};

/** aggregate varPop on columns */
export type ProViewVarPopFields = {
  __typename?: 'ProViewVarPopFields';
  averageProjectDays?: Maybe<Scalars['Float']>;
  averageQuotationDays?: Maybe<Scalars['Float']>;
  averageResponseDays?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
  googleReviewLinkId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pro_view" */
export type ProViewVarPopOrderBy = {
  averageProjectDays?: InputMaybe<OrderBy>;
  averageQuotationDays?: InputMaybe<OrderBy>;
  averageResponseDays?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  googleReviewLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ProViewVarSampFields = {
  __typename?: 'ProViewVarSampFields';
  averageProjectDays?: Maybe<Scalars['Float']>;
  averageQuotationDays?: Maybe<Scalars['Float']>;
  averageResponseDays?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
  googleReviewLinkId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pro_view" */
export type ProViewVarSampOrderBy = {
  averageProjectDays?: InputMaybe<OrderBy>;
  averageQuotationDays?: InputMaybe<OrderBy>;
  averageResponseDays?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  googleReviewLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProViewVarianceFields = {
  __typename?: 'ProViewVarianceFields';
  averageProjectDays?: Maybe<Scalars['Float']>;
  averageQuotationDays?: Maybe<Scalars['Float']>;
  averageResponseDays?: Maybe<Scalars['Float']>;
  bilikZoneId?: Maybe<Scalars['Float']>;
  googleReviewLinkId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  proPresentationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pro_view" */
export type ProViewVarianceOrderBy = {
  averageProjectDays?: InputMaybe<OrderBy>;
  averageQuotationDays?: InputMaybe<OrderBy>;
  averageResponseDays?: InputMaybe<OrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  googleReviewLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "queued_sms" */
export type QueuedSms = {
  __typename?: 'QueuedSms';
  id: Scalars['Int'];
  proViewId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  pro_view?: Maybe<ProView>;
  sendDate: Scalars['timestamptz'];
  smsFrom: Scalars['String'];
  smsTo: Scalars['String'];
  status: Scalars['String'];
  text: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

/** aggregated selection of "queued_sms" */
export type QueuedSmsAggregate = {
  __typename?: 'QueuedSmsAggregate';
  aggregate?: Maybe<QueuedSmsAggregateFields>;
  nodes: Array<QueuedSms>;
};

export type QueuedSmsAggregateBoolExp = {
  count?: InputMaybe<QueuedSmsAggregateBoolExpCount>;
};

/** aggregate fields of "queued_sms" */
export type QueuedSmsAggregateFields = {
  __typename?: 'QueuedSmsAggregateFields';
  avg?: Maybe<QueuedSmsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<QueuedSmsMaxFields>;
  min?: Maybe<QueuedSmsMinFields>;
  stddev?: Maybe<QueuedSmsStddevFields>;
  stddevPop?: Maybe<QueuedSmsStddevPopFields>;
  stddevSamp?: Maybe<QueuedSmsStddevSampFields>;
  sum?: Maybe<QueuedSmsSumFields>;
  varPop?: Maybe<QueuedSmsVarPopFields>;
  varSamp?: Maybe<QueuedSmsVarSampFields>;
  variance?: Maybe<QueuedSmsVarianceFields>;
};


/** aggregate fields of "queued_sms" */
export type QueuedSmsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<QueuedSmsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "queued_sms" */
export type QueuedSmsAggregateOrderBy = {
  avg?: InputMaybe<QueuedSmsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<QueuedSmsMaxOrderBy>;
  min?: InputMaybe<QueuedSmsMinOrderBy>;
  stddev?: InputMaybe<QueuedSmsStddevOrderBy>;
  stddevPop?: InputMaybe<QueuedSmsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<QueuedSmsStddevSampOrderBy>;
  sum?: InputMaybe<QueuedSmsSumOrderBy>;
  varPop?: InputMaybe<QueuedSmsVarPopOrderBy>;
  varSamp?: InputMaybe<QueuedSmsVarSampOrderBy>;
  variance?: InputMaybe<QueuedSmsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "queued_sms" */
export type QueuedSmsArrRelInsertInput = {
  data: Array<QueuedSmsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<QueuedSmsOnConflict>;
};

/** aggregate avg on columns */
export type QueuedSmsAvgFields = {
  __typename?: 'QueuedSmsAvgFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "queued_sms" */
export type QueuedSmsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "queued_sms". All fields are combined with a logical 'AND'. */
export type QueuedSmsBoolExp = {
  _and?: InputMaybe<Array<QueuedSmsBoolExp>>;
  _not?: InputMaybe<QueuedSmsBoolExp>;
  _or?: InputMaybe<Array<QueuedSmsBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
  pro_view?: InputMaybe<ProViewBoolExp>;
  sendDate?: InputMaybe<TimestamptzComparisonExp>;
  smsFrom?: InputMaybe<StringComparisonExp>;
  smsTo?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  text?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "queued_sms" */
export enum QueuedSmsConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_23014Primary = 'idx_23014_primary'
}

/** input type for incrementing numeric columns in table "queued_sms" */
export type QueuedSmsIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "queued_sms" */
export type QueuedSmsInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  pro_view?: InputMaybe<ProViewObjRelInsertInput>;
  sendDate?: InputMaybe<Scalars['timestamptz']>;
  smsFrom?: InputMaybe<Scalars['String']>;
  smsTo?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type QueuedSmsMaxFields = {
  __typename?: 'QueuedSmsMaxFields';
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  sendDate?: Maybe<Scalars['timestamptz']>;
  smsFrom?: Maybe<Scalars['String']>;
  smsTo?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "queued_sms" */
export type QueuedSmsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  sendDate?: InputMaybe<OrderBy>;
  smsFrom?: InputMaybe<OrderBy>;
  smsTo?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  text?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type QueuedSmsMinFields = {
  __typename?: 'QueuedSmsMinFields';
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  sendDate?: Maybe<Scalars['timestamptz']>;
  smsFrom?: Maybe<Scalars['String']>;
  smsTo?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "queued_sms" */
export type QueuedSmsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  sendDate?: InputMaybe<OrderBy>;
  smsFrom?: InputMaybe<OrderBy>;
  smsTo?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  text?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "queued_sms" */
export type QueuedSmsMutationResponse = {
  __typename?: 'QueuedSmsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<QueuedSms>;
};

/** on_conflict condition type for table "queued_sms" */
export type QueuedSmsOnConflict = {
  constraint: QueuedSmsConstraint;
  updateColumns?: Array<QueuedSmsUpdateColumn>;
  where?: InputMaybe<QueuedSmsBoolExp>;
};

/** Ordering options when selecting data from "queued_sms". */
export type QueuedSmsOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  pro_view?: InputMaybe<ProViewOrderBy>;
  sendDate?: InputMaybe<OrderBy>;
  smsFrom?: InputMaybe<OrderBy>;
  smsTo?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  text?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: queued_sms */
export type QueuedSmsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "queued_sms" */
export enum QueuedSmsSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  SendDate = 'sendDate',
  /** column name */
  SmsFrom = 'smsFrom',
  /** column name */
  SmsTo = 'smsTo',
  /** column name */
  Status = 'status',
  /** column name */
  Text = 'text',
  /** column name */
  Type = 'type',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "queued_sms" */
export type QueuedSmsSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  sendDate?: InputMaybe<Scalars['timestamptz']>;
  smsFrom?: InputMaybe<Scalars['String']>;
  smsTo?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type QueuedSmsStddevFields = {
  __typename?: 'QueuedSmsStddevFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "queued_sms" */
export type QueuedSmsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type QueuedSmsStddevPopFields = {
  __typename?: 'QueuedSmsStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "queued_sms" */
export type QueuedSmsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type QueuedSmsStddevSampFields = {
  __typename?: 'QueuedSmsStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "queued_sms" */
export type QueuedSmsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "queued_sms" */
export type QueuedSmsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: QueuedSmsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type QueuedSmsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  sendDate?: InputMaybe<Scalars['timestamptz']>;
  smsFrom?: InputMaybe<Scalars['String']>;
  smsTo?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type QueuedSmsSumFields = {
  __typename?: 'QueuedSmsSumFields';
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "queued_sms" */
export type QueuedSmsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** update columns of table "queued_sms" */
export enum QueuedSmsUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  SendDate = 'sendDate',
  /** column name */
  SmsFrom = 'smsFrom',
  /** column name */
  SmsTo = 'smsTo',
  /** column name */
  Status = 'status',
  /** column name */
  Text = 'text',
  /** column name */
  Type = 'type',
  /** column name */
  Uuid = 'uuid'
}

export type QueuedSmsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<QueuedSmsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QueuedSmsSetInput>;
  /** filter the rows which have to be updated */
  where: QueuedSmsBoolExp;
};

/** aggregate varPop on columns */
export type QueuedSmsVarPopFields = {
  __typename?: 'QueuedSmsVarPopFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "queued_sms" */
export type QueuedSmsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type QueuedSmsVarSampFields = {
  __typename?: 'QueuedSmsVarSampFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "queued_sms" */
export type QueuedSmsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type QueuedSmsVarianceFields = {
  __typename?: 'QueuedSmsVarianceFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "queued_sms" */
export type QueuedSmsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
};

/** import OpenDataSoft de toutes les régions de France (2023) */
export type Region = {
  __typename?: 'Region';
  area: Scalars['geometry'];
  /** An array relationship */
  cities: Array<City>;
  /** An aggregate relationship */
  citiesAggregate: CityAggregate;
  code: Scalars['String'];
  /** An array relationship */
  departments: Array<Department>;
  /** An aggregate relationship */
  departmentsAggregate: DepartmentAggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
  siren?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};


/** import OpenDataSoft de toutes les régions de France (2023) */
export type RegionCitiesArgs = {
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


/** import OpenDataSoft de toutes les régions de France (2023) */
export type RegionCitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


/** import OpenDataSoft de toutes les régions de France (2023) */
export type RegionDepartmentsArgs = {
  distinctOn?: InputMaybe<Array<DepartmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentOrderBy>>;
  where?: InputMaybe<DepartmentBoolExp>;
};


/** import OpenDataSoft de toutes les régions de France (2023) */
export type RegionDepartmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DepartmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentOrderBy>>;
  where?: InputMaybe<DepartmentBoolExp>;
};

/** aggregated selection of "region" */
export type RegionAggregate = {
  __typename?: 'RegionAggregate';
  aggregate?: Maybe<RegionAggregateFields>;
  nodes: Array<Region>;
};

/** aggregate fields of "region" */
export type RegionAggregateFields = {
  __typename?: 'RegionAggregateFields';
  avg?: Maybe<RegionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RegionMaxFields>;
  min?: Maybe<RegionMinFields>;
  stddev?: Maybe<RegionStddevFields>;
  stddevPop?: Maybe<RegionStddevPopFields>;
  stddevSamp?: Maybe<RegionStddevSampFields>;
  sum?: Maybe<RegionSumFields>;
  varPop?: Maybe<RegionVarPopFields>;
  varSamp?: Maybe<RegionVarSampFields>;
  variance?: Maybe<RegionVarianceFields>;
};


/** aggregate fields of "region" */
export type RegionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RegionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type RegionAvgFields = {
  __typename?: 'RegionAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "region". All fields are combined with a logical 'AND'. */
export type RegionBoolExp = {
  _and?: InputMaybe<Array<RegionBoolExp>>;
  _not?: InputMaybe<RegionBoolExp>;
  _or?: InputMaybe<Array<RegionBoolExp>>;
  area?: InputMaybe<GeometryComparisonExp>;
  cities?: InputMaybe<CityBoolExp>;
  citiesAggregate?: InputMaybe<CityAggregateBoolExp>;
  code?: InputMaybe<StringComparisonExp>;
  departments?: InputMaybe<DepartmentBoolExp>;
  departmentsAggregate?: InputMaybe<DepartmentAggregateBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  siren?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "region" */
export enum RegionConstraint {
  /** unique or primary key constraint on columns "id" */
  OpenDataRegionPkey = 'open_data_region_pkey'
}

/** input type for incrementing numeric columns in table "region" */
export type RegionIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "region" */
export type RegionInsertInput = {
  area?: InputMaybe<Scalars['geometry']>;
  cities?: InputMaybe<CityArrRelInsertInput>;
  code?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<DepartmentArrRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  siren?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RegionMaxFields = {
  __typename?: 'RegionMaxFields';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  siren?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RegionMinFields = {
  __typename?: 'RegionMinFields';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  siren?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "region" */
export type RegionMutationResponse = {
  __typename?: 'RegionMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Region>;
};

/** input type for inserting object relation for remote table "region" */
export type RegionObjRelInsertInput = {
  data: RegionInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RegionOnConflict>;
};

/** on_conflict condition type for table "region" */
export type RegionOnConflict = {
  constraint: RegionConstraint;
  updateColumns?: Array<RegionUpdateColumn>;
  where?: InputMaybe<RegionBoolExp>;
};

/** Ordering options when selecting data from "region". */
export type RegionOrderBy = {
  area?: InputMaybe<OrderBy>;
  citiesAggregate?: InputMaybe<CityAggregateOrderBy>;
  code?: InputMaybe<OrderBy>;
  departmentsAggregate?: InputMaybe<DepartmentAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  siren?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: region */
export type RegionPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "region" */
export enum RegionSelectColumn {
  /** column name */
  Area = 'area',
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Siren = 'siren',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "region" */
export type RegionSetInput = {
  area?: InputMaybe<Scalars['geometry']>;
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  siren?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RegionStddevFields = {
  __typename?: 'RegionStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type RegionStddevPopFields = {
  __typename?: 'RegionStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type RegionStddevSampFields = {
  __typename?: 'RegionStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "region" */
export type RegionStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RegionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RegionStreamCursorValueInput = {
  area?: InputMaybe<Scalars['geometry']>;
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  siren?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type RegionSumFields = {
  __typename?: 'RegionSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "region" */
export enum RegionUpdateColumn {
  /** column name */
  Area = 'area',
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Siren = 'siren',
  /** column name */
  Slug = 'slug'
}

export type RegionUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RegionIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RegionSetInput>;
  /** filter the rows which have to be updated */
  where: RegionBoolExp;
};

/** aggregate varPop on columns */
export type RegionVarPopFields = {
  __typename?: 'RegionVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type RegionVarSampFields = {
  __typename?: 'RegionVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RegionVarianceFields = {
  __typename?: 'RegionVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** Presentations a review is visible on. One row per (review, presentation) pair; a review has at least one. */
export type ReviewPresentation = {
  __typename?: 'ReviewPresentation';
  /** An object relationship */
  presentation: ProPresentation;
  presentationId: Scalars['Int'];
  /** An object relationship */
  review: ProReview;
  reviewId: Scalars['Int'];
};

/** aggregated selection of "review_presentation" */
export type ReviewPresentationAggregate = {
  __typename?: 'ReviewPresentationAggregate';
  aggregate?: Maybe<ReviewPresentationAggregateFields>;
  nodes: Array<ReviewPresentation>;
};

export type ReviewPresentationAggregateBoolExp = {
  count?: InputMaybe<ReviewPresentationAggregateBoolExpCount>;
};

/** aggregate fields of "review_presentation" */
export type ReviewPresentationAggregateFields = {
  __typename?: 'ReviewPresentationAggregateFields';
  avg?: Maybe<ReviewPresentationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ReviewPresentationMaxFields>;
  min?: Maybe<ReviewPresentationMinFields>;
  stddev?: Maybe<ReviewPresentationStddevFields>;
  stddevPop?: Maybe<ReviewPresentationStddevPopFields>;
  stddevSamp?: Maybe<ReviewPresentationStddevSampFields>;
  sum?: Maybe<ReviewPresentationSumFields>;
  varPop?: Maybe<ReviewPresentationVarPopFields>;
  varSamp?: Maybe<ReviewPresentationVarSampFields>;
  variance?: Maybe<ReviewPresentationVarianceFields>;
};


/** aggregate fields of "review_presentation" */
export type ReviewPresentationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReviewPresentationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "review_presentation" */
export type ReviewPresentationAggregateOrderBy = {
  avg?: InputMaybe<ReviewPresentationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ReviewPresentationMaxOrderBy>;
  min?: InputMaybe<ReviewPresentationMinOrderBy>;
  stddev?: InputMaybe<ReviewPresentationStddevOrderBy>;
  stddevPop?: InputMaybe<ReviewPresentationStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ReviewPresentationStddevSampOrderBy>;
  sum?: InputMaybe<ReviewPresentationSumOrderBy>;
  varPop?: InputMaybe<ReviewPresentationVarPopOrderBy>;
  varSamp?: InputMaybe<ReviewPresentationVarSampOrderBy>;
  variance?: InputMaybe<ReviewPresentationVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "review_presentation" */
export type ReviewPresentationArrRelInsertInput = {
  data: Array<ReviewPresentationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ReviewPresentationOnConflict>;
};

/** aggregate avg on columns */
export type ReviewPresentationAvgFields = {
  __typename?: 'ReviewPresentationAvgFields';
  presentationId?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "review_presentation" */
export type ReviewPresentationAvgOrderBy = {
  presentationId?: InputMaybe<OrderBy>;
  reviewId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "review_presentation". All fields are combined with a logical 'AND'. */
export type ReviewPresentationBoolExp = {
  _and?: InputMaybe<Array<ReviewPresentationBoolExp>>;
  _not?: InputMaybe<ReviewPresentationBoolExp>;
  _or?: InputMaybe<Array<ReviewPresentationBoolExp>>;
  presentation?: InputMaybe<ProPresentationBoolExp>;
  presentationId?: InputMaybe<IntComparisonExp>;
  review?: InputMaybe<ProReviewBoolExp>;
  reviewId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "review_presentation" */
export enum ReviewPresentationConstraint {
  /** unique or primary key constraint on columns "review_id", "presentation_id" */
  ReviewPresentationPkey = 'review_presentation_pkey'
}

/** input type for incrementing numeric columns in table "review_presentation" */
export type ReviewPresentationIncInput = {
  presentationId?: InputMaybe<Scalars['Int']>;
  reviewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "review_presentation" */
export type ReviewPresentationInsertInput = {
  presentation?: InputMaybe<ProPresentationObjRelInsertInput>;
  presentationId?: InputMaybe<Scalars['Int']>;
  review?: InputMaybe<ProReviewObjRelInsertInput>;
  reviewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ReviewPresentationMaxFields = {
  __typename?: 'ReviewPresentationMaxFields';
  presentationId?: Maybe<Scalars['Int']>;
  reviewId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "review_presentation" */
export type ReviewPresentationMaxOrderBy = {
  presentationId?: InputMaybe<OrderBy>;
  reviewId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ReviewPresentationMinFields = {
  __typename?: 'ReviewPresentationMinFields';
  presentationId?: Maybe<Scalars['Int']>;
  reviewId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "review_presentation" */
export type ReviewPresentationMinOrderBy = {
  presentationId?: InputMaybe<OrderBy>;
  reviewId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "review_presentation" */
export type ReviewPresentationMutationResponse = {
  __typename?: 'ReviewPresentationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ReviewPresentation>;
};

/** on_conflict condition type for table "review_presentation" */
export type ReviewPresentationOnConflict = {
  constraint: ReviewPresentationConstraint;
  updateColumns?: Array<ReviewPresentationUpdateColumn>;
  where?: InputMaybe<ReviewPresentationBoolExp>;
};

/** Ordering options when selecting data from "review_presentation". */
export type ReviewPresentationOrderBy = {
  presentation?: InputMaybe<ProPresentationOrderBy>;
  presentationId?: InputMaybe<OrderBy>;
  review?: InputMaybe<ProReviewOrderBy>;
  reviewId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: review_presentation */
export type ReviewPresentationPkColumnsInput = {
  presentationId: Scalars['Int'];
  reviewId: Scalars['Int'];
};

/** select columns of table "review_presentation" */
export enum ReviewPresentationSelectColumn {
  /** column name */
  PresentationId = 'presentationId',
  /** column name */
  ReviewId = 'reviewId'
}

/** input type for updating data in table "review_presentation" */
export type ReviewPresentationSetInput = {
  presentationId?: InputMaybe<Scalars['Int']>;
  reviewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ReviewPresentationStddevFields = {
  __typename?: 'ReviewPresentationStddevFields';
  presentationId?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "review_presentation" */
export type ReviewPresentationStddevOrderBy = {
  presentationId?: InputMaybe<OrderBy>;
  reviewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ReviewPresentationStddevPopFields = {
  __typename?: 'ReviewPresentationStddevPopFields';
  presentationId?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "review_presentation" */
export type ReviewPresentationStddevPopOrderBy = {
  presentationId?: InputMaybe<OrderBy>;
  reviewId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ReviewPresentationStddevSampFields = {
  __typename?: 'ReviewPresentationStddevSampFields';
  presentationId?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "review_presentation" */
export type ReviewPresentationStddevSampOrderBy = {
  presentationId?: InputMaybe<OrderBy>;
  reviewId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "review_presentation" */
export type ReviewPresentationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReviewPresentationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReviewPresentationStreamCursorValueInput = {
  presentationId?: InputMaybe<Scalars['Int']>;
  reviewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ReviewPresentationSumFields = {
  __typename?: 'ReviewPresentationSumFields';
  presentationId?: Maybe<Scalars['Int']>;
  reviewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "review_presentation" */
export type ReviewPresentationSumOrderBy = {
  presentationId?: InputMaybe<OrderBy>;
  reviewId?: InputMaybe<OrderBy>;
};

/** update columns of table "review_presentation" */
export enum ReviewPresentationUpdateColumn {
  /** column name */
  PresentationId = 'presentationId',
  /** column name */
  ReviewId = 'reviewId'
}

export type ReviewPresentationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReviewPresentationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReviewPresentationSetInput>;
  /** filter the rows which have to be updated */
  where: ReviewPresentationBoolExp;
};

/** aggregate varPop on columns */
export type ReviewPresentationVarPopFields = {
  __typename?: 'ReviewPresentationVarPopFields';
  presentationId?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "review_presentation" */
export type ReviewPresentationVarPopOrderBy = {
  presentationId?: InputMaybe<OrderBy>;
  reviewId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ReviewPresentationVarSampFields = {
  __typename?: 'ReviewPresentationVarSampFields';
  presentationId?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "review_presentation" */
export type ReviewPresentationVarSampOrderBy = {
  presentationId?: InputMaybe<OrderBy>;
  reviewId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ReviewPresentationVarianceFields = {
  __typename?: 'ReviewPresentationVarianceFields';
  presentationId?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "review_presentation" */
export type ReviewPresentationVarianceOrderBy = {
  presentationId?: InputMaybe<OrderBy>;
  reviewId?: InputMaybe<OrderBy>;
};

/** The reference view of each review (view_id), wherever a single one is needed; its zone is the moderation network: among the views of the review's presentations, published first, then in the zone nearest to the city of work. */
export type ReviewReferenceView = {
  __typename?: 'ReviewReferenceView';
  /** An object relationship */
  review?: Maybe<ProReview>;
  reviewId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  view?: Maybe<ProView>;
  viewId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "review_reference_view" */
export type ReviewReferenceViewAggregate = {
  __typename?: 'ReviewReferenceViewAggregate';
  aggregate?: Maybe<ReviewReferenceViewAggregateFields>;
  nodes: Array<ReviewReferenceView>;
};

/** aggregate fields of "review_reference_view" */
export type ReviewReferenceViewAggregateFields = {
  __typename?: 'ReviewReferenceViewAggregateFields';
  avg?: Maybe<ReviewReferenceViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ReviewReferenceViewMaxFields>;
  min?: Maybe<ReviewReferenceViewMinFields>;
  stddev?: Maybe<ReviewReferenceViewStddevFields>;
  stddevPop?: Maybe<ReviewReferenceViewStddevPopFields>;
  stddevSamp?: Maybe<ReviewReferenceViewStddevSampFields>;
  sum?: Maybe<ReviewReferenceViewSumFields>;
  varPop?: Maybe<ReviewReferenceViewVarPopFields>;
  varSamp?: Maybe<ReviewReferenceViewVarSampFields>;
  variance?: Maybe<ReviewReferenceViewVarianceFields>;
};


/** aggregate fields of "review_reference_view" */
export type ReviewReferenceViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReviewReferenceViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ReviewReferenceViewAvgFields = {
  __typename?: 'ReviewReferenceViewAvgFields';
  reviewId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "review_reference_view". All fields are combined with a logical 'AND'. */
export type ReviewReferenceViewBoolExp = {
  _and?: InputMaybe<Array<ReviewReferenceViewBoolExp>>;
  _not?: InputMaybe<ReviewReferenceViewBoolExp>;
  _or?: InputMaybe<Array<ReviewReferenceViewBoolExp>>;
  review?: InputMaybe<ProReviewBoolExp>;
  reviewId?: InputMaybe<IntComparisonExp>;
  view?: InputMaybe<ProViewBoolExp>;
  viewId?: InputMaybe<IntComparisonExp>;
};

/** input type for inserting data into table "review_reference_view" */
export type ReviewReferenceViewInsertInput = {
  review?: InputMaybe<ProReviewObjRelInsertInput>;
  reviewId?: InputMaybe<Scalars['Int']>;
  view?: InputMaybe<ProViewObjRelInsertInput>;
  viewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ReviewReferenceViewMaxFields = {
  __typename?: 'ReviewReferenceViewMaxFields';
  reviewId?: Maybe<Scalars['Int']>;
  viewId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ReviewReferenceViewMinFields = {
  __typename?: 'ReviewReferenceViewMinFields';
  reviewId?: Maybe<Scalars['Int']>;
  viewId?: Maybe<Scalars['Int']>;
};

/** input type for inserting object relation for remote table "review_reference_view" */
export type ReviewReferenceViewObjRelInsertInput = {
  data: ReviewReferenceViewInsertInput;
};

/** Ordering options when selecting data from "review_reference_view". */
export type ReviewReferenceViewOrderBy = {
  review?: InputMaybe<ProReviewOrderBy>;
  reviewId?: InputMaybe<OrderBy>;
  view?: InputMaybe<ProViewOrderBy>;
  viewId?: InputMaybe<OrderBy>;
};

/** select columns of table "review_reference_view" */
export enum ReviewReferenceViewSelectColumn {
  /** column name */
  ReviewId = 'reviewId',
  /** column name */
  ViewId = 'viewId'
}

/** aggregate stddev on columns */
export type ReviewReferenceViewStddevFields = {
  __typename?: 'ReviewReferenceViewStddevFields';
  reviewId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type ReviewReferenceViewStddevPopFields = {
  __typename?: 'ReviewReferenceViewStddevPopFields';
  reviewId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type ReviewReferenceViewStddevSampFields = {
  __typename?: 'ReviewReferenceViewStddevSampFields';
  reviewId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "review_reference_view" */
export type ReviewReferenceViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReviewReferenceViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReviewReferenceViewStreamCursorValueInput = {
  reviewId?: InputMaybe<Scalars['Int']>;
  viewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ReviewReferenceViewSumFields = {
  __typename?: 'ReviewReferenceViewSumFields';
  reviewId?: Maybe<Scalars['Int']>;
  viewId?: Maybe<Scalars['Int']>;
};

/** aggregate varPop on columns */
export type ReviewReferenceViewVarPopFields = {
  __typename?: 'ReviewReferenceViewVarPopFields';
  reviewId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type ReviewReferenceViewVarSampFields = {
  __typename?: 'ReviewReferenceViewVarSampFields';
  reviewId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ReviewReferenceViewVarianceFields = {
  __typename?: 'ReviewReferenceViewVarianceFields';
  reviewId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sitemap_bilik_zone" */
export type SitemapBilikZone = {
  __typename?: 'SitemapBilikZone';
  /** An object relationship */
  bilikZone?: Maybe<BilikZone>;
  bilikZoneId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  trade?: Maybe<Trade>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "sitemap_bilik_zone" */
export type SitemapBilikZoneAggregate = {
  __typename?: 'SitemapBilikZoneAggregate';
  aggregate?: Maybe<SitemapBilikZoneAggregateFields>;
  nodes: Array<SitemapBilikZone>;
};

export type SitemapBilikZoneAggregateBoolExp = {
  count?: InputMaybe<SitemapBilikZoneAggregateBoolExpCount>;
};

/** aggregate fields of "sitemap_bilik_zone" */
export type SitemapBilikZoneAggregateFields = {
  __typename?: 'SitemapBilikZoneAggregateFields';
  avg?: Maybe<SitemapBilikZoneAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SitemapBilikZoneMaxFields>;
  min?: Maybe<SitemapBilikZoneMinFields>;
  stddev?: Maybe<SitemapBilikZoneStddevFields>;
  stddevPop?: Maybe<SitemapBilikZoneStddevPopFields>;
  stddevSamp?: Maybe<SitemapBilikZoneStddevSampFields>;
  sum?: Maybe<SitemapBilikZoneSumFields>;
  varPop?: Maybe<SitemapBilikZoneVarPopFields>;
  varSamp?: Maybe<SitemapBilikZoneVarSampFields>;
  variance?: Maybe<SitemapBilikZoneVarianceFields>;
};


/** aggregate fields of "sitemap_bilik_zone" */
export type SitemapBilikZoneAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SitemapBilikZoneSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sitemap_bilik_zone" */
export type SitemapBilikZoneAggregateOrderBy = {
  avg?: InputMaybe<SitemapBilikZoneAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SitemapBilikZoneMaxOrderBy>;
  min?: InputMaybe<SitemapBilikZoneMinOrderBy>;
  stddev?: InputMaybe<SitemapBilikZoneStddevOrderBy>;
  stddevPop?: InputMaybe<SitemapBilikZoneStddevPopOrderBy>;
  stddevSamp?: InputMaybe<SitemapBilikZoneStddevSampOrderBy>;
  sum?: InputMaybe<SitemapBilikZoneSumOrderBy>;
  varPop?: InputMaybe<SitemapBilikZoneVarPopOrderBy>;
  varSamp?: InputMaybe<SitemapBilikZoneVarSampOrderBy>;
  variance?: InputMaybe<SitemapBilikZoneVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "sitemap_bilik_zone" */
export type SitemapBilikZoneArrRelInsertInput = {
  data: Array<SitemapBilikZoneInsertInput>;
};

/** aggregate avg on columns */
export type SitemapBilikZoneAvgFields = {
  __typename?: 'SitemapBilikZoneAvgFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sitemap_bilik_zone" */
export type SitemapBilikZoneAvgOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sitemap_bilik_zone". All fields are combined with a logical 'AND'. */
export type SitemapBilikZoneBoolExp = {
  _and?: InputMaybe<Array<SitemapBilikZoneBoolExp>>;
  _not?: InputMaybe<SitemapBilikZoneBoolExp>;
  _or?: InputMaybe<Array<SitemapBilikZoneBoolExp>>;
  bilikZone?: InputMaybe<BilikZoneBoolExp>;
  bilikZoneId?: InputMaybe<IntComparisonExp>;
  trade?: InputMaybe<TradeBoolExp>;
  tradeId?: InputMaybe<IntComparisonExp>;
};

/** input type for inserting data into table "sitemap_bilik_zone" */
export type SitemapBilikZoneInsertInput = {
  bilikZone?: InputMaybe<BilikZoneObjRelInsertInput>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  trade?: InputMaybe<TradeObjRelInsertInput>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type SitemapBilikZoneMaxFields = {
  __typename?: 'SitemapBilikZoneMaxFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "sitemap_bilik_zone" */
export type SitemapBilikZoneMaxOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SitemapBilikZoneMinFields = {
  __typename?: 'SitemapBilikZoneMinFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "sitemap_bilik_zone" */
export type SitemapBilikZoneMinOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** input type for inserting object relation for remote table "sitemap_bilik_zone" */
export type SitemapBilikZoneObjRelInsertInput = {
  data: SitemapBilikZoneInsertInput;
};

/** Ordering options when selecting data from "sitemap_bilik_zone". */
export type SitemapBilikZoneOrderBy = {
  bilikZone?: InputMaybe<BilikZoneOrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  trade?: InputMaybe<TradeOrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** select columns of table "sitemap_bilik_zone" */
export enum SitemapBilikZoneSelectColumn {
  /** column name */
  BilikZoneId = 'bilikZoneId',
  /** column name */
  TradeId = 'tradeId'
}

/** aggregate stddev on columns */
export type SitemapBilikZoneStddevFields = {
  __typename?: 'SitemapBilikZoneStddevFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sitemap_bilik_zone" */
export type SitemapBilikZoneStddevOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type SitemapBilikZoneStddevPopFields = {
  __typename?: 'SitemapBilikZoneStddevPopFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "sitemap_bilik_zone" */
export type SitemapBilikZoneStddevPopOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type SitemapBilikZoneStddevSampFields = {
  __typename?: 'SitemapBilikZoneStddevSampFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "sitemap_bilik_zone" */
export type SitemapBilikZoneStddevSampOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sitemap_bilik_zone" */
export type SitemapBilikZoneStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SitemapBilikZoneStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SitemapBilikZoneStreamCursorValueInput = {
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type SitemapBilikZoneSumFields = {
  __typename?: 'SitemapBilikZoneSumFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "sitemap_bilik_zone" */
export type SitemapBilikZoneSumOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type SitemapBilikZoneVarPopFields = {
  __typename?: 'SitemapBilikZoneVarPopFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "sitemap_bilik_zone" */
export type SitemapBilikZoneVarPopOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type SitemapBilikZoneVarSampFields = {
  __typename?: 'SitemapBilikZoneVarSampFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "sitemap_bilik_zone" */
export type SitemapBilikZoneVarSampOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SitemapBilikZoneVarianceFields = {
  __typename?: 'SitemapBilikZoneVarianceFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sitemap_bilik_zone" */
export type SitemapBilikZoneVarianceOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sitemap_city" */
export type SitemapCity = {
  __typename?: 'SitemapCity';
  /** An object relationship */
  bilikZone?: Maybe<BilikZone>;
  bilikZoneId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  trade?: Maybe<Trade>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "sitemap_city" */
export type SitemapCityAggregate = {
  __typename?: 'SitemapCityAggregate';
  aggregate?: Maybe<SitemapCityAggregateFields>;
  nodes: Array<SitemapCity>;
};

export type SitemapCityAggregateBoolExp = {
  count?: InputMaybe<SitemapCityAggregateBoolExpCount>;
};

/** aggregate fields of "sitemap_city" */
export type SitemapCityAggregateFields = {
  __typename?: 'SitemapCityAggregateFields';
  avg?: Maybe<SitemapCityAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SitemapCityMaxFields>;
  min?: Maybe<SitemapCityMinFields>;
  stddev?: Maybe<SitemapCityStddevFields>;
  stddevPop?: Maybe<SitemapCityStddevPopFields>;
  stddevSamp?: Maybe<SitemapCityStddevSampFields>;
  sum?: Maybe<SitemapCitySumFields>;
  varPop?: Maybe<SitemapCityVarPopFields>;
  varSamp?: Maybe<SitemapCityVarSampFields>;
  variance?: Maybe<SitemapCityVarianceFields>;
};


/** aggregate fields of "sitemap_city" */
export type SitemapCityAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SitemapCitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sitemap_city" */
export type SitemapCityAggregateOrderBy = {
  avg?: InputMaybe<SitemapCityAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SitemapCityMaxOrderBy>;
  min?: InputMaybe<SitemapCityMinOrderBy>;
  stddev?: InputMaybe<SitemapCityStddevOrderBy>;
  stddevPop?: InputMaybe<SitemapCityStddevPopOrderBy>;
  stddevSamp?: InputMaybe<SitemapCityStddevSampOrderBy>;
  sum?: InputMaybe<SitemapCitySumOrderBy>;
  varPop?: InputMaybe<SitemapCityVarPopOrderBy>;
  varSamp?: InputMaybe<SitemapCityVarSampOrderBy>;
  variance?: InputMaybe<SitemapCityVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "sitemap_city" */
export type SitemapCityArrRelInsertInput = {
  data: Array<SitemapCityInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<SitemapCityOnConflict>;
};

/** aggregate avg on columns */
export type SitemapCityAvgFields = {
  __typename?: 'SitemapCityAvgFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sitemap_city" */
export type SitemapCityAvgOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sitemap_city". All fields are combined with a logical 'AND'. */
export type SitemapCityBoolExp = {
  _and?: InputMaybe<Array<SitemapCityBoolExp>>;
  _not?: InputMaybe<SitemapCityBoolExp>;
  _or?: InputMaybe<Array<SitemapCityBoolExp>>;
  bilikZone?: InputMaybe<BilikZoneBoolExp>;
  bilikZoneId?: InputMaybe<IntComparisonExp>;
  city?: InputMaybe<CityBoolExp>;
  cityId?: InputMaybe<IntComparisonExp>;
  count?: InputMaybe<BigintComparisonExp>;
  trade?: InputMaybe<TradeBoolExp>;
  tradeId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "sitemap_city" */
export enum SitemapCityConstraint {
  /** unique or primary key constraint on columns "trade_id", "bilik_zone_id", "city_id" */
  SitemapCityCityIdTradeIdBilikZoneIdIdx = 'sitemap_city_city_id_trade_id_bilik_zone_id_idx'
}

/** input type for inserting data into table "sitemap_city" */
export type SitemapCityInsertInput = {
  bilikZone?: InputMaybe<BilikZoneObjRelInsertInput>;
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<CityObjRelInsertInput>;
  cityId?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['bigint']>;
  trade?: InputMaybe<TradeObjRelInsertInput>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type SitemapCityMaxFields = {
  __typename?: 'SitemapCityMaxFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  cityId?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['bigint']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "sitemap_city" */
export type SitemapCityMaxOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SitemapCityMinFields = {
  __typename?: 'SitemapCityMinFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  cityId?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['bigint']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "sitemap_city" */
export type SitemapCityMinOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** on_conflict condition type for table "sitemap_city" */
export type SitemapCityOnConflict = {
  constraint: SitemapCityConstraint;
  updateColumns?: Array<SitemapCityUpdateColumn>;
  where?: InputMaybe<SitemapCityBoolExp>;
};

/** Ordering options when selecting data from "sitemap_city". */
export type SitemapCityOrderBy = {
  bilikZone?: InputMaybe<BilikZoneOrderBy>;
  bilikZoneId?: InputMaybe<OrderBy>;
  city?: InputMaybe<CityOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  trade?: InputMaybe<TradeOrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** select columns of table "sitemap_city" */
export enum SitemapCitySelectColumn {
  /** column name */
  BilikZoneId = 'bilikZoneId',
  /** column name */
  CityId = 'cityId',
  /** column name */
  Count = 'count',
  /** column name */
  TradeId = 'tradeId'
}

/** aggregate stddev on columns */
export type SitemapCityStddevFields = {
  __typename?: 'SitemapCityStddevFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sitemap_city" */
export type SitemapCityStddevOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type SitemapCityStddevPopFields = {
  __typename?: 'SitemapCityStddevPopFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "sitemap_city" */
export type SitemapCityStddevPopOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type SitemapCityStddevSampFields = {
  __typename?: 'SitemapCityStddevSampFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "sitemap_city" */
export type SitemapCityStddevSampOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sitemap_city" */
export type SitemapCityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SitemapCityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SitemapCityStreamCursorValueInput = {
  bilikZoneId?: InputMaybe<Scalars['Int']>;
  cityId?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['bigint']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type SitemapCitySumFields = {
  __typename?: 'SitemapCitySumFields';
  bilikZoneId?: Maybe<Scalars['Int']>;
  cityId?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['bigint']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "sitemap_city" */
export type SitemapCitySumOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** update columns of table "sitemap_city" */
export enum SitemapCityUpdateColumn {
  /** column name */
  BilikZoneId = 'bilikZoneId',
  /** column name */
  CityId = 'cityId',
  /** column name */
  Count = 'count',
  /** column name */
  TradeId = 'tradeId'
}

/** aggregate varPop on columns */
export type SitemapCityVarPopFields = {
  __typename?: 'SitemapCityVarPopFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "sitemap_city" */
export type SitemapCityVarPopOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type SitemapCityVarSampFields = {
  __typename?: 'SitemapCityVarSampFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "sitemap_city" */
export type SitemapCityVarSampOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SitemapCityVarianceFields = {
  __typename?: 'SitemapCityVarianceFields';
  bilikZoneId?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sitemap_city" */
export type SitemapCityVarianceOrderBy = {
  bilikZoneId?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "slug_redirect" */
export type SlugRedirect = {
  __typename?: 'SlugRedirect';
  fromslug: Scalars['String'];
  id: Scalars['Int'];
  slugtype: Scalars['Int'];
  toslug: Scalars['String'];
};

/** aggregated selection of "slug_redirect" */
export type SlugRedirectAggregate = {
  __typename?: 'SlugRedirectAggregate';
  aggregate?: Maybe<SlugRedirectAggregateFields>;
  nodes: Array<SlugRedirect>;
};

/** aggregate fields of "slug_redirect" */
export type SlugRedirectAggregateFields = {
  __typename?: 'SlugRedirectAggregateFields';
  avg?: Maybe<SlugRedirectAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SlugRedirectMaxFields>;
  min?: Maybe<SlugRedirectMinFields>;
  stddev?: Maybe<SlugRedirectStddevFields>;
  stddevPop?: Maybe<SlugRedirectStddevPopFields>;
  stddevSamp?: Maybe<SlugRedirectStddevSampFields>;
  sum?: Maybe<SlugRedirectSumFields>;
  varPop?: Maybe<SlugRedirectVarPopFields>;
  varSamp?: Maybe<SlugRedirectVarSampFields>;
  variance?: Maybe<SlugRedirectVarianceFields>;
};


/** aggregate fields of "slug_redirect" */
export type SlugRedirectAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SlugRedirectSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SlugRedirectAvgFields = {
  __typename?: 'SlugRedirectAvgFields';
  id?: Maybe<Scalars['Float']>;
  slugtype?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "slug_redirect". All fields are combined with a logical 'AND'. */
export type SlugRedirectBoolExp = {
  _and?: InputMaybe<Array<SlugRedirectBoolExp>>;
  _not?: InputMaybe<SlugRedirectBoolExp>;
  _or?: InputMaybe<Array<SlugRedirectBoolExp>>;
  fromslug?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  slugtype?: InputMaybe<IntComparisonExp>;
  toslug?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "slug_redirect" */
export enum SlugRedirectConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_23050Primary = 'idx_23050_primary'
}

/** input type for incrementing numeric columns in table "slug_redirect" */
export type SlugRedirectIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  slugtype?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "slug_redirect" */
export type SlugRedirectInsertInput = {
  fromslug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  slugtype?: InputMaybe<Scalars['Int']>;
  toslug?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SlugRedirectMaxFields = {
  __typename?: 'SlugRedirectMaxFields';
  fromslug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  slugtype?: Maybe<Scalars['Int']>;
  toslug?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SlugRedirectMinFields = {
  __typename?: 'SlugRedirectMinFields';
  fromslug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  slugtype?: Maybe<Scalars['Int']>;
  toslug?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "slug_redirect" */
export type SlugRedirectMutationResponse = {
  __typename?: 'SlugRedirectMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SlugRedirect>;
};

/** on_conflict condition type for table "slug_redirect" */
export type SlugRedirectOnConflict = {
  constraint: SlugRedirectConstraint;
  updateColumns?: Array<SlugRedirectUpdateColumn>;
  where?: InputMaybe<SlugRedirectBoolExp>;
};

/** Ordering options when selecting data from "slug_redirect". */
export type SlugRedirectOrderBy = {
  fromslug?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  slugtype?: InputMaybe<OrderBy>;
  toslug?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: slug_redirect */
export type SlugRedirectPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "slug_redirect" */
export enum SlugRedirectSelectColumn {
  /** column name */
  Fromslug = 'fromslug',
  /** column name */
  Id = 'id',
  /** column name */
  Slugtype = 'slugtype',
  /** column name */
  Toslug = 'toslug'
}

/** input type for updating data in table "slug_redirect" */
export type SlugRedirectSetInput = {
  fromslug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  slugtype?: InputMaybe<Scalars['Int']>;
  toslug?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SlugRedirectStddevFields = {
  __typename?: 'SlugRedirectStddevFields';
  id?: Maybe<Scalars['Float']>;
  slugtype?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type SlugRedirectStddevPopFields = {
  __typename?: 'SlugRedirectStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  slugtype?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type SlugRedirectStddevSampFields = {
  __typename?: 'SlugRedirectStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  slugtype?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "slug_redirect" */
export type SlugRedirectStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SlugRedirectStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SlugRedirectStreamCursorValueInput = {
  fromslug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  slugtype?: InputMaybe<Scalars['Int']>;
  toslug?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SlugRedirectSumFields = {
  __typename?: 'SlugRedirectSumFields';
  id?: Maybe<Scalars['Int']>;
  slugtype?: Maybe<Scalars['Int']>;
};

/** update columns of table "slug_redirect" */
export enum SlugRedirectUpdateColumn {
  /** column name */
  Fromslug = 'fromslug',
  /** column name */
  Id = 'id',
  /** column name */
  Slugtype = 'slugtype',
  /** column name */
  Toslug = 'toslug'
}

export type SlugRedirectUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SlugRedirectIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SlugRedirectSetInput>;
  /** filter the rows which have to be updated */
  where: SlugRedirectBoolExp;
};

/** aggregate varPop on columns */
export type SlugRedirectVarPopFields = {
  __typename?: 'SlugRedirectVarPopFields';
  id?: Maybe<Scalars['Float']>;
  slugtype?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type SlugRedirectVarSampFields = {
  __typename?: 'SlugRedirectVarSampFields';
  id?: Maybe<Scalars['Float']>;
  slugtype?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SlugRedirectVarianceFields = {
  __typename?: 'SlugRedirectVarianceFields';
  id?: Maybe<Scalars['Float']>;
  slugtype?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type SmallintComparisonExp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** columns and relationships of "solicitation" */
export type Solicitation = {
  __typename?: 'Solicitation';
  addressLocality: Scalars['String'];
  bounceEntity?: Maybe<Scalars['String']>;
  /** (DC2Type:json_array) */
  configuration?: Maybe<Scalars['jsonb']>;
  dateCreated: Scalars['timestamptz'];
  declineReason?: Maybe<Scalars['String']>;
  declineType?: Maybe<Scalars['String']>;
  declinedBy?: Maybe<Scalars['String']>;
  delay?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['Int'];
  ip?: Maybe<Scalars['String']>;
  isAutorespondActive: Scalars['Boolean'];
  isSpam: Scalars['Boolean'];
  lastResponseDate?: Maybe<Scalars['timestamptz']>;
  message: Scalars['String'];
  /** An object relationship */
  proReview?: Maybe<ProReview>;
  proReviewId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  proView: ProView;
  proViewId: Scalars['Int'];
  source: Scalars['String'];
  /** An object relationship */
  sourceTrade?: Maybe<Trade>;
  sourceTradeId?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
  telephone: Scalars['String'];
  /** An object relationship */
  utmRecord?: Maybe<UtmRecord>;
  utmRecordId?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};


/** columns and relationships of "solicitation" */
export type SolicitationConfigurationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "solicitation" */
export type SolicitationAggregate = {
  __typename?: 'SolicitationAggregate';
  aggregate?: Maybe<SolicitationAggregateFields>;
  nodes: Array<Solicitation>;
};

export type SolicitationAggregateBoolExp = {
  bool_and?: InputMaybe<SolicitationAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<SolicitationAggregateBoolExpBoolOr>;
  count?: InputMaybe<SolicitationAggregateBoolExpCount>;
};

/** aggregate fields of "solicitation" */
export type SolicitationAggregateFields = {
  __typename?: 'SolicitationAggregateFields';
  avg?: Maybe<SolicitationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SolicitationMaxFields>;
  min?: Maybe<SolicitationMinFields>;
  stddev?: Maybe<SolicitationStddevFields>;
  stddevPop?: Maybe<SolicitationStddevPopFields>;
  stddevSamp?: Maybe<SolicitationStddevSampFields>;
  sum?: Maybe<SolicitationSumFields>;
  varPop?: Maybe<SolicitationVarPopFields>;
  varSamp?: Maybe<SolicitationVarSampFields>;
  variance?: Maybe<SolicitationVarianceFields>;
};


/** aggregate fields of "solicitation" */
export type SolicitationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SolicitationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "solicitation" */
export type SolicitationAggregateOrderBy = {
  avg?: InputMaybe<SolicitationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SolicitationMaxOrderBy>;
  min?: InputMaybe<SolicitationMinOrderBy>;
  stddev?: InputMaybe<SolicitationStddevOrderBy>;
  stddevPop?: InputMaybe<SolicitationStddevPopOrderBy>;
  stddevSamp?: InputMaybe<SolicitationStddevSampOrderBy>;
  sum?: InputMaybe<SolicitationSumOrderBy>;
  varPop?: InputMaybe<SolicitationVarPopOrderBy>;
  varSamp?: InputMaybe<SolicitationVarSampOrderBy>;
  variance?: InputMaybe<SolicitationVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SolicitationAppendInput = {
  /** (DC2Type:json_array) */
  configuration?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "solicitation" */
export type SolicitationArrRelInsertInput = {
  data: Array<SolicitationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<SolicitationOnConflict>;
};

/** aggregate avg on columns */
export type SolicitationAvgFields = {
  __typename?: 'SolicitationAvgFields';
  id?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
  sourceTradeId?: Maybe<Scalars['Float']>;
  utmRecordId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "solicitation" */
export type SolicitationAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  sourceTradeId?: InputMaybe<OrderBy>;
  utmRecordId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "solicitation". All fields are combined with a logical 'AND'. */
export type SolicitationBoolExp = {
  _and?: InputMaybe<Array<SolicitationBoolExp>>;
  _not?: InputMaybe<SolicitationBoolExp>;
  _or?: InputMaybe<Array<SolicitationBoolExp>>;
  addressLocality?: InputMaybe<StringComparisonExp>;
  bounceEntity?: InputMaybe<StringComparisonExp>;
  configuration?: InputMaybe<JsonbComparisonExp>;
  dateCreated?: InputMaybe<TimestamptzComparisonExp>;
  declineReason?: InputMaybe<StringComparisonExp>;
  declineType?: InputMaybe<StringComparisonExp>;
  declinedBy?: InputMaybe<StringComparisonExp>;
  delay?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  familyName?: InputMaybe<StringComparisonExp>;
  givenName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  ip?: InputMaybe<StringComparisonExp>;
  isAutorespondActive?: InputMaybe<BooleanComparisonExp>;
  isSpam?: InputMaybe<BooleanComparisonExp>;
  lastResponseDate?: InputMaybe<TimestamptzComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  proReview?: InputMaybe<ProReviewBoolExp>;
  proReviewId?: InputMaybe<IntComparisonExp>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  sourceTrade?: InputMaybe<TradeBoolExp>;
  sourceTradeId?: InputMaybe<IntComparisonExp>;
  subject?: InputMaybe<StringComparisonExp>;
  telephone?: InputMaybe<StringComparisonExp>;
  utmRecord?: InputMaybe<UtmRecordBoolExp>;
  utmRecordId?: InputMaybe<IntComparisonExp>;
  uuid?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "solicitation" */
export enum SolicitationConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_23059Primary = 'idx_23059_primary',
  /** unique or primary key constraint on columns "uuid" */
  Idx_23059Uniq_4fa96783d17f50a6 = 'idx_23059_uniq_4fa96783d17f50a6'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SolicitationDeleteAtPathInput = {
  /** (DC2Type:json_array) */
  configuration?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SolicitationDeleteElemInput = {
  /** (DC2Type:json_array) */
  configuration?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SolicitationDeleteKeyInput = {
  /** (DC2Type:json_array) */
  configuration?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "solicitation" */
export type SolicitationIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  proReviewId?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  sourceTradeId?: InputMaybe<Scalars['Int']>;
  utmRecordId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "solicitation" */
export type SolicitationInsertInput = {
  addressLocality?: InputMaybe<Scalars['String']>;
  bounceEntity?: InputMaybe<Scalars['String']>;
  /** (DC2Type:json_array) */
  configuration?: InputMaybe<Scalars['jsonb']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  declineReason?: InputMaybe<Scalars['String']>;
  declineType?: InputMaybe<Scalars['String']>;
  declinedBy?: InputMaybe<Scalars['String']>;
  delay?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ip?: InputMaybe<Scalars['String']>;
  isAutorespondActive?: InputMaybe<Scalars['Boolean']>;
  isSpam?: InputMaybe<Scalars['Boolean']>;
  lastResponseDate?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
  proReview?: InputMaybe<ProReviewObjRelInsertInput>;
  proReviewId?: InputMaybe<Scalars['Int']>;
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  sourceTrade?: InputMaybe<TradeObjRelInsertInput>;
  sourceTradeId?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  utmRecord?: InputMaybe<UtmRecordObjRelInsertInput>;
  utmRecordId?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SolicitationMaxFields = {
  __typename?: 'SolicitationMaxFields';
  addressLocality?: Maybe<Scalars['String']>;
  bounceEntity?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['timestamptz']>;
  declineReason?: Maybe<Scalars['String']>;
  declineType?: Maybe<Scalars['String']>;
  declinedBy?: Maybe<Scalars['String']>;
  delay?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ip?: Maybe<Scalars['String']>;
  lastResponseDate?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
  proReviewId?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  sourceTradeId?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  utmRecordId?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "solicitation" */
export type SolicitationMaxOrderBy = {
  addressLocality?: InputMaybe<OrderBy>;
  bounceEntity?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  declineReason?: InputMaybe<OrderBy>;
  declineType?: InputMaybe<OrderBy>;
  declinedBy?: InputMaybe<OrderBy>;
  delay?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  lastResponseDate?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceTradeId?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
  utmRecordId?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SolicitationMinFields = {
  __typename?: 'SolicitationMinFields';
  addressLocality?: Maybe<Scalars['String']>;
  bounceEntity?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['timestamptz']>;
  declineReason?: Maybe<Scalars['String']>;
  declineType?: Maybe<Scalars['String']>;
  declinedBy?: Maybe<Scalars['String']>;
  delay?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ip?: Maybe<Scalars['String']>;
  lastResponseDate?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
  proReviewId?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  sourceTradeId?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  utmRecordId?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "solicitation" */
export type SolicitationMinOrderBy = {
  addressLocality?: InputMaybe<OrderBy>;
  bounceEntity?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  declineReason?: InputMaybe<OrderBy>;
  declineType?: InputMaybe<OrderBy>;
  declinedBy?: InputMaybe<OrderBy>;
  delay?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  lastResponseDate?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceTradeId?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
  utmRecordId?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "solicitation" */
export type SolicitationMutationResponse = {
  __typename?: 'SolicitationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Solicitation>;
};

/** on_conflict condition type for table "solicitation" */
export type SolicitationOnConflict = {
  constraint: SolicitationConstraint;
  updateColumns?: Array<SolicitationUpdateColumn>;
  where?: InputMaybe<SolicitationBoolExp>;
};

/** Ordering options when selecting data from "solicitation". */
export type SolicitationOrderBy = {
  addressLocality?: InputMaybe<OrderBy>;
  bounceEntity?: InputMaybe<OrderBy>;
  configuration?: InputMaybe<OrderBy>;
  dateCreated?: InputMaybe<OrderBy>;
  declineReason?: InputMaybe<OrderBy>;
  declineType?: InputMaybe<OrderBy>;
  declinedBy?: InputMaybe<OrderBy>;
  delay?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  isAutorespondActive?: InputMaybe<OrderBy>;
  isSpam?: InputMaybe<OrderBy>;
  lastResponseDate?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  proReview?: InputMaybe<ProReviewOrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  proView?: InputMaybe<ProViewOrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceTrade?: InputMaybe<TradeOrderBy>;
  sourceTradeId?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
  utmRecord?: InputMaybe<UtmRecordOrderBy>;
  utmRecordId?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: solicitation */
export type SolicitationPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SolicitationPrependInput = {
  /** (DC2Type:json_array) */
  configuration?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "solicitation" */
export enum SolicitationSelectColumn {
  /** column name */
  AddressLocality = 'addressLocality',
  /** column name */
  BounceEntity = 'bounceEntity',
  /** column name */
  Configuration = 'configuration',
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  DeclineReason = 'declineReason',
  /** column name */
  DeclineType = 'declineType',
  /** column name */
  DeclinedBy = 'declinedBy',
  /** column name */
  Delay = 'delay',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  IsAutorespondActive = 'isAutorespondActive',
  /** column name */
  IsSpam = 'isSpam',
  /** column name */
  LastResponseDate = 'lastResponseDate',
  /** column name */
  Message = 'message',
  /** column name */
  ProReviewId = 'proReviewId',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  Source = 'source',
  /** column name */
  SourceTradeId = 'sourceTradeId',
  /** column name */
  Subject = 'subject',
  /** column name */
  Telephone = 'telephone',
  /** column name */
  UtmRecordId = 'utmRecordId',
  /** column name */
  Uuid = 'uuid'
}

/** select "solicitationAggregateBoolExpBool_andArgumentsColumns" columns of table "solicitation" */
export enum SolicitationSelectColumnSolicitationAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsAutorespondActive = 'isAutorespondActive',
  /** column name */
  IsSpam = 'isSpam'
}

/** select "solicitationAggregateBoolExpBool_orArgumentsColumns" columns of table "solicitation" */
export enum SolicitationSelectColumnSolicitationAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsAutorespondActive = 'isAutorespondActive',
  /** column name */
  IsSpam = 'isSpam'
}

/** input type for updating data in table "solicitation" */
export type SolicitationSetInput = {
  addressLocality?: InputMaybe<Scalars['String']>;
  bounceEntity?: InputMaybe<Scalars['String']>;
  /** (DC2Type:json_array) */
  configuration?: InputMaybe<Scalars['jsonb']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  declineReason?: InputMaybe<Scalars['String']>;
  declineType?: InputMaybe<Scalars['String']>;
  declinedBy?: InputMaybe<Scalars['String']>;
  delay?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ip?: InputMaybe<Scalars['String']>;
  isAutorespondActive?: InputMaybe<Scalars['Boolean']>;
  isSpam?: InputMaybe<Scalars['Boolean']>;
  lastResponseDate?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
  proReviewId?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  sourceTradeId?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  utmRecordId?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "solicitation_stat" */
export type SolicitationStat = {
  __typename?: 'SolicitationStat';
  dateCreated?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  proView?: Maybe<ProView>;
  proViewId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
};

/** aggregated selection of "solicitation_stat" */
export type SolicitationStatAggregate = {
  __typename?: 'SolicitationStatAggregate';
  aggregate?: Maybe<SolicitationStatAggregateFields>;
  nodes: Array<SolicitationStat>;
};

/** aggregate fields of "solicitation_stat" */
export type SolicitationStatAggregateFields = {
  __typename?: 'SolicitationStatAggregateFields';
  avg?: Maybe<SolicitationStatAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SolicitationStatMaxFields>;
  min?: Maybe<SolicitationStatMinFields>;
  stddev?: Maybe<SolicitationStatStddevFields>;
  stddevPop?: Maybe<SolicitationStatStddevPopFields>;
  stddevSamp?: Maybe<SolicitationStatStddevSampFields>;
  sum?: Maybe<SolicitationStatSumFields>;
  varPop?: Maybe<SolicitationStatVarPopFields>;
  varSamp?: Maybe<SolicitationStatVarSampFields>;
  variance?: Maybe<SolicitationStatVarianceFields>;
};


/** aggregate fields of "solicitation_stat" */
export type SolicitationStatAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SolicitationStatSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SolicitationStatAvgFields = {
  __typename?: 'SolicitationStatAvgFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "solicitation_stat". All fields are combined with a logical 'AND'. */
export type SolicitationStatBoolExp = {
  _and?: InputMaybe<Array<SolicitationStatBoolExp>>;
  _not?: InputMaybe<SolicitationStatBoolExp>;
  _or?: InputMaybe<Array<SolicitationStatBoolExp>>;
  dateCreated?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  telephone?: InputMaybe<StringComparisonExp>;
};

/** input type for incrementing numeric columns in table "solicitation_stat" */
export type SolicitationStatIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "solicitation_stat" */
export type SolicitationStatInsertInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SolicitationStatMaxFields = {
  __typename?: 'SolicitationStatMaxFields';
  dateCreated?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SolicitationStatMinFields = {
  __typename?: 'SolicitationStatMinFields';
  dateCreated?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "solicitation_stat" */
export type SolicitationStatMutationResponse = {
  __typename?: 'SolicitationStatMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SolicitationStat>;
};

/** Ordering options when selecting data from "solicitation_stat". */
export type SolicitationStatOrderBy = {
  dateCreated?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  proView?: InputMaybe<ProViewOrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
};

/** select columns of table "solicitation_stat" */
export enum SolicitationStatSelectColumn {
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  Source = 'source',
  /** column name */
  Telephone = 'telephone'
}

/** input type for updating data in table "solicitation_stat" */
export type SolicitationStatSetInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SolicitationStatStddevFields = {
  __typename?: 'SolicitationStatStddevFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type SolicitationStatStddevPopFields = {
  __typename?: 'SolicitationStatStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type SolicitationStatStddevSampFields = {
  __typename?: 'SolicitationStatStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "solicitation_stat" */
export type SolicitationStatStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SolicitationStatStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SolicitationStatStreamCursorValueInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SolicitationStatSumFields = {
  __typename?: 'SolicitationStatSumFields';
  id?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
};

export type SolicitationStatUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SolicitationStatIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SolicitationStatSetInput>;
  /** filter the rows which have to be updated */
  where: SolicitationStatBoolExp;
};

/** aggregate varPop on columns */
export type SolicitationStatVarPopFields = {
  __typename?: 'SolicitationStatVarPopFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type SolicitationStatVarSampFields = {
  __typename?: 'SolicitationStatVarSampFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SolicitationStatVarianceFields = {
  __typename?: 'SolicitationStatVarianceFields';
  id?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type SolicitationStddevFields = {
  __typename?: 'SolicitationStddevFields';
  id?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
  sourceTradeId?: Maybe<Scalars['Float']>;
  utmRecordId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "solicitation" */
export type SolicitationStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  sourceTradeId?: InputMaybe<OrderBy>;
  utmRecordId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type SolicitationStddevPopFields = {
  __typename?: 'SolicitationStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
  sourceTradeId?: Maybe<Scalars['Float']>;
  utmRecordId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "solicitation" */
export type SolicitationStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  sourceTradeId?: InputMaybe<OrderBy>;
  utmRecordId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type SolicitationStddevSampFields = {
  __typename?: 'SolicitationStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
  sourceTradeId?: Maybe<Scalars['Float']>;
  utmRecordId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "solicitation" */
export type SolicitationStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  sourceTradeId?: InputMaybe<OrderBy>;
  utmRecordId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "solicitation" */
export type SolicitationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SolicitationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SolicitationStreamCursorValueInput = {
  addressLocality?: InputMaybe<Scalars['String']>;
  bounceEntity?: InputMaybe<Scalars['String']>;
  /** (DC2Type:json_array) */
  configuration?: InputMaybe<Scalars['jsonb']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  declineReason?: InputMaybe<Scalars['String']>;
  declineType?: InputMaybe<Scalars['String']>;
  declinedBy?: InputMaybe<Scalars['String']>;
  delay?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ip?: InputMaybe<Scalars['String']>;
  isAutorespondActive?: InputMaybe<Scalars['Boolean']>;
  isSpam?: InputMaybe<Scalars['Boolean']>;
  lastResponseDate?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
  proReviewId?: InputMaybe<Scalars['Int']>;
  proViewId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  sourceTradeId?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  utmRecordId?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SolicitationSumFields = {
  __typename?: 'SolicitationSumFields';
  id?: Maybe<Scalars['Int']>;
  proReviewId?: Maybe<Scalars['Int']>;
  proViewId?: Maybe<Scalars['Int']>;
  sourceTradeId?: Maybe<Scalars['Int']>;
  utmRecordId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "solicitation" */
export type SolicitationSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  sourceTradeId?: InputMaybe<OrderBy>;
  utmRecordId?: InputMaybe<OrderBy>;
};

/** update columns of table "solicitation" */
export enum SolicitationUpdateColumn {
  /** column name */
  AddressLocality = 'addressLocality',
  /** column name */
  BounceEntity = 'bounceEntity',
  /** column name */
  Configuration = 'configuration',
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  DeclineReason = 'declineReason',
  /** column name */
  DeclineType = 'declineType',
  /** column name */
  DeclinedBy = 'declinedBy',
  /** column name */
  Delay = 'delay',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  IsAutorespondActive = 'isAutorespondActive',
  /** column name */
  IsSpam = 'isSpam',
  /** column name */
  LastResponseDate = 'lastResponseDate',
  /** column name */
  Message = 'message',
  /** column name */
  ProReviewId = 'proReviewId',
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  Source = 'source',
  /** column name */
  SourceTradeId = 'sourceTradeId',
  /** column name */
  Subject = 'subject',
  /** column name */
  Telephone = 'telephone',
  /** column name */
  UtmRecordId = 'utmRecordId',
  /** column name */
  Uuid = 'uuid'
}

export type SolicitationUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SolicitationAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<SolicitationDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<SolicitationDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<SolicitationDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SolicitationIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SolicitationPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SolicitationSetInput>;
  /** filter the rows which have to be updated */
  where: SolicitationBoolExp;
};

/** aggregate varPop on columns */
export type SolicitationVarPopFields = {
  __typename?: 'SolicitationVarPopFields';
  id?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
  sourceTradeId?: Maybe<Scalars['Float']>;
  utmRecordId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "solicitation" */
export type SolicitationVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  sourceTradeId?: InputMaybe<OrderBy>;
  utmRecordId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type SolicitationVarSampFields = {
  __typename?: 'SolicitationVarSampFields';
  id?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
  sourceTradeId?: Maybe<Scalars['Float']>;
  utmRecordId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "solicitation" */
export type SolicitationVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  sourceTradeId?: InputMaybe<OrderBy>;
  utmRecordId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SolicitationVarianceFields = {
  __typename?: 'SolicitationVarianceFields';
  id?: Maybe<Scalars['Float']>;
  proReviewId?: Maybe<Scalars['Float']>;
  proViewId?: Maybe<Scalars['Float']>;
  sourceTradeId?: Maybe<Scalars['Float']>;
  utmRecordId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "solicitation" */
export type SolicitationVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  proReviewId?: InputMaybe<OrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  sourceTradeId?: InputMaybe<OrderBy>;
  utmRecordId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "spatial_ref_sys" */
export type SpatialRefSys = {
  __typename?: 'SpatialRefSys';
  authName?: Maybe<Scalars['String']>;
  authSrid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid: Scalars['Int'];
  srtext?: Maybe<Scalars['String']>;
};

/** aggregated selection of "spatial_ref_sys" */
export type SpatialRefSysAggregate = {
  __typename?: 'SpatialRefSysAggregate';
  aggregate?: Maybe<SpatialRefSysAggregateFields>;
  nodes: Array<SpatialRefSys>;
};

/** aggregate fields of "spatial_ref_sys" */
export type SpatialRefSysAggregateFields = {
  __typename?: 'SpatialRefSysAggregateFields';
  avg?: Maybe<SpatialRefSysAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SpatialRefSysMaxFields>;
  min?: Maybe<SpatialRefSysMinFields>;
  stddev?: Maybe<SpatialRefSysStddevFields>;
  stddevPop?: Maybe<SpatialRefSysStddevPopFields>;
  stddevSamp?: Maybe<SpatialRefSysStddevSampFields>;
  sum?: Maybe<SpatialRefSysSumFields>;
  varPop?: Maybe<SpatialRefSysVarPopFields>;
  varSamp?: Maybe<SpatialRefSysVarSampFields>;
  variance?: Maybe<SpatialRefSysVarianceFields>;
};


/** aggregate fields of "spatial_ref_sys" */
export type SpatialRefSysAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SpatialRefSysSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SpatialRefSysAvgFields = {
  __typename?: 'SpatialRefSysAvgFields';
  authSrid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "spatial_ref_sys". All fields are combined with a logical 'AND'. */
export type SpatialRefSysBoolExp = {
  _and?: InputMaybe<Array<SpatialRefSysBoolExp>>;
  _not?: InputMaybe<SpatialRefSysBoolExp>;
  _or?: InputMaybe<Array<SpatialRefSysBoolExp>>;
  authName?: InputMaybe<StringComparisonExp>;
  authSrid?: InputMaybe<IntComparisonExp>;
  proj4text?: InputMaybe<StringComparisonExp>;
  srid?: InputMaybe<IntComparisonExp>;
  srtext?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "spatial_ref_sys" */
export enum SpatialRefSysConstraint {
  /** unique or primary key constraint on columns "srid" */
  SpatialRefSysPkey = 'spatial_ref_sys_pkey'
}

/** input type for incrementing numeric columns in table "spatial_ref_sys" */
export type SpatialRefSysIncInput = {
  authSrid?: InputMaybe<Scalars['Int']>;
  srid?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "spatial_ref_sys" */
export type SpatialRefSysInsertInput = {
  authName?: InputMaybe<Scalars['String']>;
  authSrid?: InputMaybe<Scalars['Int']>;
  proj4text?: InputMaybe<Scalars['String']>;
  srid?: InputMaybe<Scalars['Int']>;
  srtext?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SpatialRefSysMaxFields = {
  __typename?: 'SpatialRefSysMaxFields';
  authName?: Maybe<Scalars['String']>;
  authSrid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  srtext?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SpatialRefSysMinFields = {
  __typename?: 'SpatialRefSysMinFields';
  authName?: Maybe<Scalars['String']>;
  authSrid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  srtext?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "spatial_ref_sys" */
export type SpatialRefSysMutationResponse = {
  __typename?: 'SpatialRefSysMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SpatialRefSys>;
};

/** on_conflict condition type for table "spatial_ref_sys" */
export type SpatialRefSysOnConflict = {
  constraint: SpatialRefSysConstraint;
  updateColumns?: Array<SpatialRefSysUpdateColumn>;
  where?: InputMaybe<SpatialRefSysBoolExp>;
};

/** Ordering options when selecting data from "spatial_ref_sys". */
export type SpatialRefSysOrderBy = {
  authName?: InputMaybe<OrderBy>;
  authSrid?: InputMaybe<OrderBy>;
  proj4text?: InputMaybe<OrderBy>;
  srid?: InputMaybe<OrderBy>;
  srtext?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: spatial_ref_sys */
export type SpatialRefSysPkColumnsInput = {
  srid: Scalars['Int'];
};

/** select columns of table "spatial_ref_sys" */
export enum SpatialRefSysSelectColumn {
  /** column name */
  AuthName = 'authName',
  /** column name */
  AuthSrid = 'authSrid',
  /** column name */
  Proj4text = 'proj4text',
  /** column name */
  Srid = 'srid',
  /** column name */
  Srtext = 'srtext'
}

/** input type for updating data in table "spatial_ref_sys" */
export type SpatialRefSysSetInput = {
  authName?: InputMaybe<Scalars['String']>;
  authSrid?: InputMaybe<Scalars['Int']>;
  proj4text?: InputMaybe<Scalars['String']>;
  srid?: InputMaybe<Scalars['Int']>;
  srtext?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SpatialRefSysStddevFields = {
  __typename?: 'SpatialRefSysStddevFields';
  authSrid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type SpatialRefSysStddevPopFields = {
  __typename?: 'SpatialRefSysStddevPopFields';
  authSrid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type SpatialRefSysStddevSampFields = {
  __typename?: 'SpatialRefSysStddevSampFields';
  authSrid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "spatial_ref_sys" */
export type SpatialRefSysStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SpatialRefSysStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SpatialRefSysStreamCursorValueInput = {
  authName?: InputMaybe<Scalars['String']>;
  authSrid?: InputMaybe<Scalars['Int']>;
  proj4text?: InputMaybe<Scalars['String']>;
  srid?: InputMaybe<Scalars['Int']>;
  srtext?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SpatialRefSysSumFields = {
  __typename?: 'SpatialRefSysSumFields';
  authSrid?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
};

/** update columns of table "spatial_ref_sys" */
export enum SpatialRefSysUpdateColumn {
  /** column name */
  AuthName = 'authName',
  /** column name */
  AuthSrid = 'authSrid',
  /** column name */
  Proj4text = 'proj4text',
  /** column name */
  Srid = 'srid',
  /** column name */
  Srtext = 'srtext'
}

export type SpatialRefSysUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SpatialRefSysIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SpatialRefSysSetInput>;
  /** filter the rows which have to be updated */
  where: SpatialRefSysBoolExp;
};

/** aggregate varPop on columns */
export type SpatialRefSysVarPopFields = {
  __typename?: 'SpatialRefSysVarPopFields';
  authSrid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type SpatialRefSysVarSampFields = {
  __typename?: 'SpatialRefSysVarSampFields';
  authSrid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SpatialRefSysVarianceFields = {
  __typename?: 'SpatialRefSysVarianceFields';
  authSrid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "stop_sms" */
export type StopSms = {
  __typename?: 'StopSms';
  dateCreated: Scalars['timestamptz'];
  id: Scalars['Int'];
  telephone: Scalars['String'];
};

/** aggregated selection of "stop_sms" */
export type StopSmsAggregate = {
  __typename?: 'StopSmsAggregate';
  aggregate?: Maybe<StopSmsAggregateFields>;
  nodes: Array<StopSms>;
};

/** aggregate fields of "stop_sms" */
export type StopSmsAggregateFields = {
  __typename?: 'StopSmsAggregateFields';
  avg?: Maybe<StopSmsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<StopSmsMaxFields>;
  min?: Maybe<StopSmsMinFields>;
  stddev?: Maybe<StopSmsStddevFields>;
  stddevPop?: Maybe<StopSmsStddevPopFields>;
  stddevSamp?: Maybe<StopSmsStddevSampFields>;
  sum?: Maybe<StopSmsSumFields>;
  varPop?: Maybe<StopSmsVarPopFields>;
  varSamp?: Maybe<StopSmsVarSampFields>;
  variance?: Maybe<StopSmsVarianceFields>;
};


/** aggregate fields of "stop_sms" */
export type StopSmsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<StopSmsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type StopSmsAvgFields = {
  __typename?: 'StopSmsAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "stop_sms". All fields are combined with a logical 'AND'. */
export type StopSmsBoolExp = {
  _and?: InputMaybe<Array<StopSmsBoolExp>>;
  _not?: InputMaybe<StopSmsBoolExp>;
  _or?: InputMaybe<Array<StopSmsBoolExp>>;
  dateCreated?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  telephone?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "stop_sms" */
export enum StopSmsConstraint {
  /** unique or primary key constraint on columns "id" */
  StopSmsPkey = 'stop_sms_pkey',
  /** unique or primary key constraint on columns "telephone" */
  StopSmsPkeyUniq = 'stop_sms_pkey_uniq'
}

/** input type for incrementing numeric columns in table "stop_sms" */
export type StopSmsIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stop_sms" */
export type StopSmsInsertInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type StopSmsMaxFields = {
  __typename?: 'StopSmsMaxFields';
  dateCreated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  telephone?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type StopSmsMinFields = {
  __typename?: 'StopSmsMinFields';
  dateCreated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  telephone?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "stop_sms" */
export type StopSmsMutationResponse = {
  __typename?: 'StopSmsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<StopSms>;
};

/** on_conflict condition type for table "stop_sms" */
export type StopSmsOnConflict = {
  constraint: StopSmsConstraint;
  updateColumns?: Array<StopSmsUpdateColumn>;
  where?: InputMaybe<StopSmsBoolExp>;
};

/** Ordering options when selecting data from "stop_sms". */
export type StopSmsOrderBy = {
  dateCreated?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: stop_sms */
export type StopSmsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "stop_sms" */
export enum StopSmsSelectColumn {
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  Id = 'id',
  /** column name */
  Telephone = 'telephone'
}

/** input type for updating data in table "stop_sms" */
export type StopSmsSetInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type StopSmsStddevFields = {
  __typename?: 'StopSmsStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type StopSmsStddevPopFields = {
  __typename?: 'StopSmsStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type StopSmsStddevSampFields = {
  __typename?: 'StopSmsStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stop_sms" */
export type StopSmsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: StopSmsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type StopSmsStreamCursorValueInput = {
  dateCreated?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type StopSmsSumFields = {
  __typename?: 'StopSmsSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "stop_sms" */
export enum StopSmsUpdateColumn {
  /** column name */
  DateCreated = 'dateCreated',
  /** column name */
  Id = 'id',
  /** column name */
  Telephone = 'telephone'
}

export type StopSmsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StopSmsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StopSmsSetInput>;
  /** filter the rows which have to be updated */
  where: StopSmsBoolExp;
};

/** aggregate varPop on columns */
export type StopSmsVarPopFields = {
  __typename?: 'StopSmsVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type StopSmsVarSampFields = {
  __typename?: 'StopSmsVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type StopSmsVarianceFields = {
  __typename?: 'StopSmsVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "subscription" */
export type Subscription = {
  __typename?: 'Subscription';
  baseAmount: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  discounts: Scalars['jsonb'];
  managerIds: Scalars['jsonb'];
  paymentMethod: Scalars['String'];
  /** An object relationship */
  proView: ProView;
  recurrence: Scalars['String'];
  setupFee?: Maybe<Scalars['jsonb']>;
  startDate: Scalars['date'];
  viewId: Scalars['Int'];
};


/** columns and relationships of "subscription" */
export type SubscriptionDiscountsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "subscription" */
export type SubscriptionManagerIdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "subscription" */
export type SubscriptionSetupFeeArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "subscription" */
export type SubscriptionAggregate = {
  __typename?: 'SubscriptionAggregate';
  aggregate?: Maybe<SubscriptionAggregateFields>;
  nodes: Array<Subscription>;
};

/** aggregate fields of "subscription" */
export type SubscriptionAggregateFields = {
  __typename?: 'SubscriptionAggregateFields';
  avg?: Maybe<SubscriptionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SubscriptionMaxFields>;
  min?: Maybe<SubscriptionMinFields>;
  stddev?: Maybe<SubscriptionStddevFields>;
  stddevPop?: Maybe<SubscriptionStddevPopFields>;
  stddevSamp?: Maybe<SubscriptionStddevSampFields>;
  sum?: Maybe<SubscriptionSumFields>;
  varPop?: Maybe<SubscriptionVarPopFields>;
  varSamp?: Maybe<SubscriptionVarSampFields>;
  variance?: Maybe<SubscriptionVarianceFields>;
};


/** aggregate fields of "subscription" */
export type SubscriptionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SubscriptionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SubscriptionAppendInput = {
  discounts?: InputMaybe<Scalars['jsonb']>;
  managerIds?: InputMaybe<Scalars['jsonb']>;
  setupFee?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type SubscriptionAvgFields = {
  __typename?: 'SubscriptionAvgFields';
  baseAmount?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "subscription". All fields are combined with a logical 'AND'. */
export type SubscriptionBoolExp = {
  _and?: InputMaybe<Array<SubscriptionBoolExp>>;
  _not?: InputMaybe<SubscriptionBoolExp>;
  _or?: InputMaybe<Array<SubscriptionBoolExp>>;
  baseAmount?: InputMaybe<NumericComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  discounts?: InputMaybe<JsonbComparisonExp>;
  managerIds?: InputMaybe<JsonbComparisonExp>;
  paymentMethod?: InputMaybe<StringComparisonExp>;
  proView?: InputMaybe<ProViewBoolExp>;
  recurrence?: InputMaybe<StringComparisonExp>;
  setupFee?: InputMaybe<JsonbComparisonExp>;
  startDate?: InputMaybe<DateComparisonExp>;
  viewId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "subscription" */
export enum SubscriptionConstraint {
  /** unique or primary key constraint on columns "view_id" */
  SubscriptionPkey = 'subscription_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SubscriptionDeleteAtPathInput = {
  discounts?: InputMaybe<Array<Scalars['String']>>;
  managerIds?: InputMaybe<Array<Scalars['String']>>;
  setupFee?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SubscriptionDeleteElemInput = {
  discounts?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Scalars['Int']>;
  setupFee?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SubscriptionDeleteKeyInput = {
  discounts?: InputMaybe<Scalars['String']>;
  managerIds?: InputMaybe<Scalars['String']>;
  setupFee?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "subscription" */
export type SubscriptionIncInput = {
  baseAmount?: InputMaybe<Scalars['numeric']>;
  viewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription" */
export type SubscriptionInsertInput = {
  baseAmount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discounts?: InputMaybe<Scalars['jsonb']>;
  managerIds?: InputMaybe<Scalars['jsonb']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  recurrence?: InputMaybe<Scalars['String']>;
  setupFee?: InputMaybe<Scalars['jsonb']>;
  startDate?: InputMaybe<Scalars['date']>;
  viewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type SubscriptionMaxFields = {
  __typename?: 'SubscriptionMaxFields';
  baseAmount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  paymentMethod?: Maybe<Scalars['String']>;
  recurrence?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['date']>;
  viewId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type SubscriptionMinFields = {
  __typename?: 'SubscriptionMinFields';
  baseAmount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  paymentMethod?: Maybe<Scalars['String']>;
  recurrence?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['date']>;
  viewId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "subscription" */
export type SubscriptionMutationResponse = {
  __typename?: 'SubscriptionMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription>;
};

/** on_conflict condition type for table "subscription" */
export type SubscriptionOnConflict = {
  constraint: SubscriptionConstraint;
  updateColumns?: Array<SubscriptionUpdateColumn>;
  where?: InputMaybe<SubscriptionBoolExp>;
};

/** Ordering options when selecting data from "subscription". */
export type SubscriptionOrderBy = {
  baseAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  discounts?: InputMaybe<OrderBy>;
  managerIds?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<OrderBy>;
  proView?: InputMaybe<ProViewOrderBy>;
  recurrence?: InputMaybe<OrderBy>;
  setupFee?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  viewId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: subscription */
export type SubscriptionPkColumnsInput = {
  viewId: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SubscriptionPrependInput = {
  discounts?: InputMaybe<Scalars['jsonb']>;
  managerIds?: InputMaybe<Scalars['jsonb']>;
  setupFee?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "subscription" */
export enum SubscriptionSelectColumn {
  /** column name */
  BaseAmount = 'baseAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Discounts = 'discounts',
  /** column name */
  ManagerIds = 'managerIds',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  Recurrence = 'recurrence',
  /** column name */
  SetupFee = 'setupFee',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  ViewId = 'viewId'
}

/** input type for updating data in table "subscription" */
export type SubscriptionSetInput = {
  baseAmount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discounts?: InputMaybe<Scalars['jsonb']>;
  managerIds?: InputMaybe<Scalars['jsonb']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  recurrence?: InputMaybe<Scalars['String']>;
  setupFee?: InputMaybe<Scalars['jsonb']>;
  startDate?: InputMaybe<Scalars['date']>;
  viewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type SubscriptionStddevFields = {
  __typename?: 'SubscriptionStddevFields';
  baseAmount?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type SubscriptionStddevPopFields = {
  __typename?: 'SubscriptionStddevPopFields';
  baseAmount?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type SubscriptionStddevSampFields = {
  __typename?: 'SubscriptionStddevSampFields';
  baseAmount?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "subscription" */
export type SubscriptionStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SubscriptionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SubscriptionStreamCursorValueInput = {
  baseAmount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discounts?: InputMaybe<Scalars['jsonb']>;
  managerIds?: InputMaybe<Scalars['jsonb']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  recurrence?: InputMaybe<Scalars['String']>;
  setupFee?: InputMaybe<Scalars['jsonb']>;
  startDate?: InputMaybe<Scalars['date']>;
  viewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type SubscriptionSumFields = {
  __typename?: 'SubscriptionSumFields';
  baseAmount?: Maybe<Scalars['numeric']>;
  viewId?: Maybe<Scalars['Int']>;
};

/** update columns of table "subscription" */
export enum SubscriptionUpdateColumn {
  /** column name */
  BaseAmount = 'baseAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Discounts = 'discounts',
  /** column name */
  ManagerIds = 'managerIds',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  Recurrence = 'recurrence',
  /** column name */
  SetupFee = 'setupFee',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  ViewId = 'viewId'
}

export type SubscriptionUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SubscriptionAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<SubscriptionDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<SubscriptionDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<SubscriptionDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SubscriptionIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SubscriptionPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SubscriptionSetInput>;
  /** filter the rows which have to be updated */
  where: SubscriptionBoolExp;
};

/** aggregate varPop on columns */
export type SubscriptionVarPopFields = {
  __typename?: 'SubscriptionVarPopFields';
  baseAmount?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type SubscriptionVarSampFields = {
  __typename?: 'SubscriptionVarSampFields';
  baseAmount?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SubscriptionVarianceFields = {
  __typename?: 'SubscriptionVarianceFields';
  baseAmount?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "timeline_private_individual" */
export type TimelinePrivateIndividual = {
  __typename?: 'TimelinePrivateIndividual';
  addressLocality?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
};

/** aggregated selection of "timeline_private_individual" */
export type TimelinePrivateIndividualAggregate = {
  __typename?: 'TimelinePrivateIndividualAggregate';
  aggregate?: Maybe<TimelinePrivateIndividualAggregateFields>;
  nodes: Array<TimelinePrivateIndividual>;
};

/** aggregate fields of "timeline_private_individual" */
export type TimelinePrivateIndividualAggregateFields = {
  __typename?: 'TimelinePrivateIndividualAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<TimelinePrivateIndividualMaxFields>;
  min?: Maybe<TimelinePrivateIndividualMinFields>;
};


/** aggregate fields of "timeline_private_individual" */
export type TimelinePrivateIndividualAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TimelinePrivateIndividualSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "timeline_private_individual". All fields are combined with a logical 'AND'. */
export type TimelinePrivateIndividualBoolExp = {
  _and?: InputMaybe<Array<TimelinePrivateIndividualBoolExp>>;
  _not?: InputMaybe<TimelinePrivateIndividualBoolExp>;
  _or?: InputMaybe<Array<TimelinePrivateIndividualBoolExp>>;
  addressLocality?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  familyName?: InputMaybe<StringComparisonExp>;
  givenName?: InputMaybe<StringComparisonExp>;
  telephone?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type TimelinePrivateIndividualMaxFields = {
  __typename?: 'TimelinePrivateIndividualMaxFields';
  addressLocality?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TimelinePrivateIndividualMinFields = {
  __typename?: 'TimelinePrivateIndividualMinFields';
  addressLocality?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "timeline_private_individual". */
export type TimelinePrivateIndividualOrderBy = {
  addressLocality?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  familyName?: InputMaybe<OrderBy>;
  givenName?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
};

/** select columns of table "timeline_private_individual" */
export enum TimelinePrivateIndividualSelectColumn {
  /** column name */
  AddressLocality = 'addressLocality',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Telephone = 'telephone'
}

/** Streaming cursor of the table "timeline_private_individual" */
export type TimelinePrivateIndividualStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TimelinePrivateIndividualStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TimelinePrivateIndividualStreamCursorValueInput = {
  addressLocality?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "topology.layer" */
export type TopologyLayer = {
  __typename?: 'TopologyLayer';
  childId?: Maybe<Scalars['Int']>;
  featureColumn: Scalars['String'];
  featureType: Scalars['Int'];
  layerId: Scalars['Int'];
  level: Scalars['Int'];
  schemaName: Scalars['String'];
  tableName: Scalars['String'];
  topologyId: Scalars['Int'];
};

/** aggregated selection of "topology.layer" */
export type TopologyLayerAggregate = {
  __typename?: 'TopologyLayerAggregate';
  aggregate?: Maybe<TopologyLayerAggregateFields>;
  nodes: Array<TopologyLayer>;
};

/** aggregate fields of "topology.layer" */
export type TopologyLayerAggregateFields = {
  __typename?: 'TopologyLayerAggregateFields';
  avg?: Maybe<TopologyLayerAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TopologyLayerMaxFields>;
  min?: Maybe<TopologyLayerMinFields>;
  stddev?: Maybe<TopologyLayerStddevFields>;
  stddevPop?: Maybe<TopologyLayerStddevPopFields>;
  stddevSamp?: Maybe<TopologyLayerStddevSampFields>;
  sum?: Maybe<TopologyLayerSumFields>;
  varPop?: Maybe<TopologyLayerVarPopFields>;
  varSamp?: Maybe<TopologyLayerVarSampFields>;
  variance?: Maybe<TopologyLayerVarianceFields>;
};


/** aggregate fields of "topology.layer" */
export type TopologyLayerAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TopologyLayerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TopologyLayerAvgFields = {
  __typename?: 'TopologyLayerAvgFields';
  childId?: Maybe<Scalars['Float']>;
  featureType?: Maybe<Scalars['Float']>;
  layerId?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  topologyId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "topology.layer". All fields are combined with a logical 'AND'. */
export type TopologyLayerBoolExp = {
  _and?: InputMaybe<Array<TopologyLayerBoolExp>>;
  _not?: InputMaybe<TopologyLayerBoolExp>;
  _or?: InputMaybe<Array<TopologyLayerBoolExp>>;
  childId?: InputMaybe<IntComparisonExp>;
  featureColumn?: InputMaybe<StringComparisonExp>;
  featureType?: InputMaybe<IntComparisonExp>;
  layerId?: InputMaybe<IntComparisonExp>;
  level?: InputMaybe<IntComparisonExp>;
  schemaName?: InputMaybe<StringComparisonExp>;
  tableName?: InputMaybe<StringComparisonExp>;
  topologyId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "topology.layer" */
export enum TopologyLayerConstraint {
  /** unique or primary key constraint on columns "topology_id", "layer_id" */
  LayerPkey = 'layer_pkey',
  /** unique or primary key constraint on columns "feature_column", "table_name", "schema_name" */
  LayerSchemaNameTableNameFeatureColumnKey = 'layer_schema_name_table_name_feature_column_key'
}

/** input type for incrementing numeric columns in table "topology.layer" */
export type TopologyLayerIncInput = {
  childId?: InputMaybe<Scalars['Int']>;
  featureType?: InputMaybe<Scalars['Int']>;
  layerId?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  topologyId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "topology.layer" */
export type TopologyLayerInsertInput = {
  childId?: InputMaybe<Scalars['Int']>;
  featureColumn?: InputMaybe<Scalars['String']>;
  featureType?: InputMaybe<Scalars['Int']>;
  layerId?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  schemaName?: InputMaybe<Scalars['String']>;
  tableName?: InputMaybe<Scalars['String']>;
  topologyId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TopologyLayerMaxFields = {
  __typename?: 'TopologyLayerMaxFields';
  childId?: Maybe<Scalars['Int']>;
  featureColumn?: Maybe<Scalars['String']>;
  featureType?: Maybe<Scalars['Int']>;
  layerId?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  schemaName?: Maybe<Scalars['String']>;
  tableName?: Maybe<Scalars['String']>;
  topologyId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type TopologyLayerMinFields = {
  __typename?: 'TopologyLayerMinFields';
  childId?: Maybe<Scalars['Int']>;
  featureColumn?: Maybe<Scalars['String']>;
  featureType?: Maybe<Scalars['Int']>;
  layerId?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  schemaName?: Maybe<Scalars['String']>;
  tableName?: Maybe<Scalars['String']>;
  topologyId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "topology.layer" */
export type TopologyLayerMutationResponse = {
  __typename?: 'TopologyLayerMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TopologyLayer>;
};

/** on_conflict condition type for table "topology.layer" */
export type TopologyLayerOnConflict = {
  constraint: TopologyLayerConstraint;
  updateColumns?: Array<TopologyLayerUpdateColumn>;
  where?: InputMaybe<TopologyLayerBoolExp>;
};

/** Ordering options when selecting data from "topology.layer". */
export type TopologyLayerOrderBy = {
  childId?: InputMaybe<OrderBy>;
  featureColumn?: InputMaybe<OrderBy>;
  featureType?: InputMaybe<OrderBy>;
  layerId?: InputMaybe<OrderBy>;
  level?: InputMaybe<OrderBy>;
  schemaName?: InputMaybe<OrderBy>;
  tableName?: InputMaybe<OrderBy>;
  topologyId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: topology.layer */
export type TopologyLayerPkColumnsInput = {
  layerId: Scalars['Int'];
  topologyId: Scalars['Int'];
};

/** select columns of table "topology.layer" */
export enum TopologyLayerSelectColumn {
  /** column name */
  ChildId = 'childId',
  /** column name */
  FeatureColumn = 'featureColumn',
  /** column name */
  FeatureType = 'featureType',
  /** column name */
  LayerId = 'layerId',
  /** column name */
  Level = 'level',
  /** column name */
  SchemaName = 'schemaName',
  /** column name */
  TableName = 'tableName',
  /** column name */
  TopologyId = 'topologyId'
}

/** input type for updating data in table "topology.layer" */
export type TopologyLayerSetInput = {
  childId?: InputMaybe<Scalars['Int']>;
  featureColumn?: InputMaybe<Scalars['String']>;
  featureType?: InputMaybe<Scalars['Int']>;
  layerId?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  schemaName?: InputMaybe<Scalars['String']>;
  tableName?: InputMaybe<Scalars['String']>;
  topologyId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type TopologyLayerStddevFields = {
  __typename?: 'TopologyLayerStddevFields';
  childId?: Maybe<Scalars['Float']>;
  featureType?: Maybe<Scalars['Float']>;
  layerId?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  topologyId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type TopologyLayerStddevPopFields = {
  __typename?: 'TopologyLayerStddevPopFields';
  childId?: Maybe<Scalars['Float']>;
  featureType?: Maybe<Scalars['Float']>;
  layerId?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  topologyId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type TopologyLayerStddevSampFields = {
  __typename?: 'TopologyLayerStddevSampFields';
  childId?: Maybe<Scalars['Float']>;
  featureType?: Maybe<Scalars['Float']>;
  layerId?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  topologyId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "topology_layer" */
export type TopologyLayerStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TopologyLayerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TopologyLayerStreamCursorValueInput = {
  childId?: InputMaybe<Scalars['Int']>;
  featureColumn?: InputMaybe<Scalars['String']>;
  featureType?: InputMaybe<Scalars['Int']>;
  layerId?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  schemaName?: InputMaybe<Scalars['String']>;
  tableName?: InputMaybe<Scalars['String']>;
  topologyId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TopologyLayerSumFields = {
  __typename?: 'TopologyLayerSumFields';
  childId?: Maybe<Scalars['Int']>;
  featureType?: Maybe<Scalars['Int']>;
  layerId?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  topologyId?: Maybe<Scalars['Int']>;
};

/** update columns of table "topology.layer" */
export enum TopologyLayerUpdateColumn {
  /** column name */
  ChildId = 'childId',
  /** column name */
  FeatureColumn = 'featureColumn',
  /** column name */
  FeatureType = 'featureType',
  /** column name */
  LayerId = 'layerId',
  /** column name */
  Level = 'level',
  /** column name */
  SchemaName = 'schemaName',
  /** column name */
  TableName = 'tableName',
  /** column name */
  TopologyId = 'topologyId'
}

export type TopologyLayerUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TopologyLayerIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TopologyLayerSetInput>;
  /** filter the rows which have to be updated */
  where: TopologyLayerBoolExp;
};

/** aggregate varPop on columns */
export type TopologyLayerVarPopFields = {
  __typename?: 'TopologyLayerVarPopFields';
  childId?: Maybe<Scalars['Float']>;
  featureType?: Maybe<Scalars['Float']>;
  layerId?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  topologyId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type TopologyLayerVarSampFields = {
  __typename?: 'TopologyLayerVarSampFields';
  childId?: Maybe<Scalars['Float']>;
  featureType?: Maybe<Scalars['Float']>;
  layerId?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  topologyId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TopologyLayerVarianceFields = {
  __typename?: 'TopologyLayerVarianceFields';
  childId?: Maybe<Scalars['Float']>;
  featureType?: Maybe<Scalars['Float']>;
  layerId?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  topologyId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "topology.topology" */
export type TopologyTopology = {
  __typename?: 'TopologyTopology';
  hasz: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  precision: Scalars['float8'];
  srid: Scalars['Int'];
};

/** aggregated selection of "topology.topology" */
export type TopologyTopologyAggregate = {
  __typename?: 'TopologyTopologyAggregate';
  aggregate?: Maybe<TopologyTopologyAggregateFields>;
  nodes: Array<TopologyTopology>;
};

/** aggregate fields of "topology.topology" */
export type TopologyTopologyAggregateFields = {
  __typename?: 'TopologyTopologyAggregateFields';
  avg?: Maybe<TopologyTopologyAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TopologyTopologyMaxFields>;
  min?: Maybe<TopologyTopologyMinFields>;
  stddev?: Maybe<TopologyTopologyStddevFields>;
  stddevPop?: Maybe<TopologyTopologyStddevPopFields>;
  stddevSamp?: Maybe<TopologyTopologyStddevSampFields>;
  sum?: Maybe<TopologyTopologySumFields>;
  varPop?: Maybe<TopologyTopologyVarPopFields>;
  varSamp?: Maybe<TopologyTopologyVarSampFields>;
  variance?: Maybe<TopologyTopologyVarianceFields>;
};


/** aggregate fields of "topology.topology" */
export type TopologyTopologyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TopologyTopologySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TopologyTopologyAvgFields = {
  __typename?: 'TopologyTopologyAvgFields';
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "topology.topology". All fields are combined with a logical 'AND'. */
export type TopologyTopologyBoolExp = {
  _and?: InputMaybe<Array<TopologyTopologyBoolExp>>;
  _not?: InputMaybe<TopologyTopologyBoolExp>;
  _or?: InputMaybe<Array<TopologyTopologyBoolExp>>;
  hasz?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  precision?: InputMaybe<Float8ComparisonExp>;
  srid?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "topology.topology" */
export enum TopologyTopologyConstraint {
  /** unique or primary key constraint on columns "name" */
  TopologyNameKey = 'topology_name_key',
  /** unique or primary key constraint on columns "id" */
  TopologyPkey = 'topology_pkey'
}

/** input type for incrementing numeric columns in table "topology.topology" */
export type TopologyTopologyIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  precision?: InputMaybe<Scalars['float8']>;
  srid?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "topology.topology" */
export type TopologyTopologyInsertInput = {
  hasz?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  precision?: InputMaybe<Scalars['float8']>;
  srid?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TopologyTopologyMaxFields = {
  __typename?: 'TopologyTopologyMaxFields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  precision?: Maybe<Scalars['float8']>;
  srid?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type TopologyTopologyMinFields = {
  __typename?: 'TopologyTopologyMinFields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  precision?: Maybe<Scalars['float8']>;
  srid?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "topology.topology" */
export type TopologyTopologyMutationResponse = {
  __typename?: 'TopologyTopologyMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TopologyTopology>;
};

/** on_conflict condition type for table "topology.topology" */
export type TopologyTopologyOnConflict = {
  constraint: TopologyTopologyConstraint;
  updateColumns?: Array<TopologyTopologyUpdateColumn>;
  where?: InputMaybe<TopologyTopologyBoolExp>;
};

/** Ordering options when selecting data from "topology.topology". */
export type TopologyTopologyOrderBy = {
  hasz?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  precision?: InputMaybe<OrderBy>;
  srid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: topology.topology */
export type TopologyTopologyPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "topology.topology" */
export enum TopologyTopologySelectColumn {
  /** column name */
  Hasz = 'hasz',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Precision = 'precision',
  /** column name */
  Srid = 'srid'
}

/** input type for updating data in table "topology.topology" */
export type TopologyTopologySetInput = {
  hasz?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  precision?: InputMaybe<Scalars['float8']>;
  srid?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type TopologyTopologyStddevFields = {
  __typename?: 'TopologyTopologyStddevFields';
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type TopologyTopologyStddevPopFields = {
  __typename?: 'TopologyTopologyStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type TopologyTopologyStddevSampFields = {
  __typename?: 'TopologyTopologyStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "topology_topology" */
export type TopologyTopologyStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TopologyTopologyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TopologyTopologyStreamCursorValueInput = {
  hasz?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  precision?: InputMaybe<Scalars['float8']>;
  srid?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TopologyTopologySumFields = {
  __typename?: 'TopologyTopologySumFields';
  id?: Maybe<Scalars['Int']>;
  precision?: Maybe<Scalars['float8']>;
  srid?: Maybe<Scalars['Int']>;
};

/** update columns of table "topology.topology" */
export enum TopologyTopologyUpdateColumn {
  /** column name */
  Hasz = 'hasz',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Precision = 'precision',
  /** column name */
  Srid = 'srid'
}

export type TopologyTopologyUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TopologyTopologyIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TopologyTopologySetInput>;
  /** filter the rows which have to be updated */
  where: TopologyTopologyBoolExp;
};

/** aggregate varPop on columns */
export type TopologyTopologyVarPopFields = {
  __typename?: 'TopologyTopologyVarPopFields';
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type TopologyTopologyVarSampFields = {
  __typename?: 'TopologyTopologyVarSampFields';
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TopologyTopologyVarianceFields = {
  __typename?: 'TopologyTopologyVarianceFields';
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "trade" */
export type Trade = {
  __typename?: 'Trade';
  anchor: Scalars['String'];
  /** An array relationship */
  bilikZoneMainProCount: Array<BilikZoneTradeMainProCount>;
  /** An aggregate relationship */
  bilikZoneMainProCountAggregate: BilikZoneTradeMainProCountAggregate;
  /** An object relationship */
  bilikZoneSitemap?: Maybe<SitemapBilikZone>;
  /** An array relationship */
  citySitemap: Array<SitemapCity>;
  /** An aggregate relationship */
  citySitemapAggregate: SitemapCityAggregate;
  id: Scalars['Int'];
  isAnonymised: Scalars['Boolean'];
  isCallRecordable: Scalars['Boolean'];
  isRgeFilterable: Scalars['Boolean'];
  label: Scalars['String'];
  /** An array relationship */
  mainTradeProPresentations: Array<TradeProPresentation>;
  /** An aggregate relationship */
  mainTradeProPresentationsAggregate: TradeProPresentationAggregate;
  metaDescription: Scalars['String'];
  metaTitle: Scalars['String'];
  name: Scalars['String'];
  pageSubtitle: Scalars['String'];
  pageTitle: Scalars['String'];
  pageTitleDirectory: Scalars['String'];
  pageTitleVariant: Scalars['String'];
  schemaAdditionalType?: Maybe<Scalars['String']>;
  schemaType: Scalars['String'];
  slug: Scalars['String'];
  /** An array relationship */
  tradeGroups: Array<TradeTradeGroup>;
  /** An aggregate relationship */
  tradeGroupsAggregate: TradeTradeGroupAggregate;
  /** An array relationship */
  tradeGuides: Array<TradeTradeGuide>;
  /** An aggregate relationship */
  tradeGuidesAggregate: TradeTradeGuideAggregate;
  /** An array relationship */
  tradeKeywords: Array<TradeKeyword>;
  /** An aggregate relationship */
  tradeKeywordsAggregate: TradeKeywordAggregate;
  /** An array relationship */
  tradeProViews: Array<TradeProView>;
  /** An aggregate relationship */
  tradeProViewsAggregate: TradeProViewAggregate;
  /** An array relationship */
  tradeQuestions: Array<TradeQuestion>;
  /** An aggregate relationship */
  tradeQuestionsAggregate: TradeQuestionAggregate;
};


/** columns and relationships of "trade" */
export type TradeBilikZoneMainProCountArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneTradeMainProCountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneTradeMainProCountOrderBy>>;
  where?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeBilikZoneMainProCountAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneTradeMainProCountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneTradeMainProCountOrderBy>>;
  where?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeCitySitemapArgs = {
  distinctOn?: InputMaybe<Array<SitemapCitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapCityOrderBy>>;
  where?: InputMaybe<SitemapCityBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeCitySitemapAggregateArgs = {
  distinctOn?: InputMaybe<Array<SitemapCitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapCityOrderBy>>;
  where?: InputMaybe<SitemapCityBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeMainTradeProPresentationsArgs = {
  distinctOn?: InputMaybe<Array<TradeProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProPresentationOrderBy>>;
  where?: InputMaybe<TradeProPresentationBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeMainTradeProPresentationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProPresentationOrderBy>>;
  where?: InputMaybe<TradeProPresentationBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeTradeGroupsArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGroupOrderBy>>;
  where?: InputMaybe<TradeTradeGroupBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeTradeGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGroupOrderBy>>;
  where?: InputMaybe<TradeTradeGroupBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeTradeGuidesArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGuideOrderBy>>;
  where?: InputMaybe<TradeTradeGuideBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeTradeGuidesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGuideOrderBy>>;
  where?: InputMaybe<TradeTradeGuideBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeTradeKeywordsArgs = {
  distinctOn?: InputMaybe<Array<TradeKeywordSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeKeywordOrderBy>>;
  where?: InputMaybe<TradeKeywordBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeTradeKeywordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeKeywordSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeKeywordOrderBy>>;
  where?: InputMaybe<TradeKeywordBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeTradeProViewsArgs = {
  distinctOn?: InputMaybe<Array<TradeProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProViewOrderBy>>;
  where?: InputMaybe<TradeProViewBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeTradeProViewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProViewOrderBy>>;
  where?: InputMaybe<TradeProViewBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeTradeQuestionsArgs = {
  distinctOn?: InputMaybe<Array<TradeQuestionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeQuestionOrderBy>>;
  where?: InputMaybe<TradeQuestionBoolExp>;
};


/** columns and relationships of "trade" */
export type TradeTradeQuestionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeQuestionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeQuestionOrderBy>>;
  where?: InputMaybe<TradeQuestionBoolExp>;
};

export type TradeAggregate = {
  __typename?: 'TradeAggregate';
  aggregate?: Maybe<TradeAggregateFields>;
  nodes: Array<Trade>;
};

/** aggregate fields of "trade" */
export type TradeAggregateFields = {
  __typename?: 'TradeAggregateFields';
  avg?: Maybe<TradeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TradeMaxFields>;
  min?: Maybe<TradeMinFields>;
  stddev?: Maybe<TradeStddevFields>;
  stddevPop?: Maybe<TradeStddevPopFields>;
  stddevSamp?: Maybe<TradeStddevSampFields>;
  sum?: Maybe<TradeSumFields>;
  varPop?: Maybe<TradeVarPopFields>;
  varSamp?: Maybe<TradeVarSampFields>;
  variance?: Maybe<TradeVarianceFields>;
};


/** aggregate fields of "trade" */
export type TradeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TradeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TradeAvgFields = {
  __typename?: 'TradeAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "trade". All fields are combined with a logical 'AND'. */
export type TradeBoolExp = {
  _and?: InputMaybe<Array<TradeBoolExp>>;
  _not?: InputMaybe<TradeBoolExp>;
  _or?: InputMaybe<Array<TradeBoolExp>>;
  anchor?: InputMaybe<StringComparisonExp>;
  bilikZoneMainProCount?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
  bilikZoneMainProCountAggregate?: InputMaybe<BilikZoneTradeMainProCountAggregateBoolExp>;
  bilikZoneSitemap?: InputMaybe<SitemapBilikZoneBoolExp>;
  citySitemap?: InputMaybe<SitemapCityBoolExp>;
  citySitemapAggregate?: InputMaybe<SitemapCityAggregateBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  isAnonymised?: InputMaybe<BooleanComparisonExp>;
  isCallRecordable?: InputMaybe<BooleanComparisonExp>;
  isRgeFilterable?: InputMaybe<BooleanComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  mainTradeProPresentations?: InputMaybe<TradeProPresentationBoolExp>;
  mainTradeProPresentationsAggregate?: InputMaybe<TradeProPresentationAggregateBoolExp>;
  metaDescription?: InputMaybe<StringComparisonExp>;
  metaTitle?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  pageSubtitle?: InputMaybe<StringComparisonExp>;
  pageTitle?: InputMaybe<StringComparisonExp>;
  pageTitleDirectory?: InputMaybe<StringComparisonExp>;
  pageTitleVariant?: InputMaybe<StringComparisonExp>;
  schemaAdditionalType?: InputMaybe<StringComparisonExp>;
  schemaType?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  tradeGroups?: InputMaybe<TradeTradeGroupBoolExp>;
  tradeGroupsAggregate?: InputMaybe<TradeTradeGroupAggregateBoolExp>;
  tradeGuides?: InputMaybe<TradeTradeGuideBoolExp>;
  tradeGuidesAggregate?: InputMaybe<TradeTradeGuideAggregateBoolExp>;
  tradeKeywords?: InputMaybe<TradeKeywordBoolExp>;
  tradeKeywordsAggregate?: InputMaybe<TradeKeywordAggregateBoolExp>;
  tradeProViews?: InputMaybe<TradeProViewBoolExp>;
  tradeProViewsAggregate?: InputMaybe<TradeProViewAggregateBoolExp>;
  tradeQuestions?: InputMaybe<TradeQuestionBoolExp>;
  tradeQuestionsAggregate?: InputMaybe<TradeQuestionAggregateBoolExp>;
};

/** unique or primary key constraints on table "trade" */
export enum TradeConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_23077Primary = 'idx_23077_primary',
  /** unique or primary key constraint on columns "slug" */
  Idx_23077Uniq_7e1a4366989d9b62 = 'idx_23077_uniq_7e1a4366989d9b62'
}

/** columns and relationships of "trade_group" */
export type TradeGroup = {
  __typename?: 'TradeGroup';
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  position: Scalars['Int'];
  /** An array relationship */
  tradeTradeGroups: Array<TradeTradeGroup>;
  /** An aggregate relationship */
  tradeTradeGroupsAggregate: TradeTradeGroupAggregate;
};


/** columns and relationships of "trade_group" */
export type TradeGroupTradeTradeGroupsArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGroupOrderBy>>;
  where?: InputMaybe<TradeTradeGroupBoolExp>;
};


/** columns and relationships of "trade_group" */
export type TradeGroupTradeTradeGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGroupOrderBy>>;
  where?: InputMaybe<TradeTradeGroupBoolExp>;
};

export type TradeGroupAggregate = {
  __typename?: 'TradeGroupAggregate';
  aggregate?: Maybe<TradeGroupAggregateFields>;
  nodes: Array<TradeGroup>;
};

/** aggregate fields of "trade_group" */
export type TradeGroupAggregateFields = {
  __typename?: 'TradeGroupAggregateFields';
  avg?: Maybe<TradeGroupAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TradeGroupMaxFields>;
  min?: Maybe<TradeGroupMinFields>;
  stddev?: Maybe<TradeGroupStddevFields>;
  stddevPop?: Maybe<TradeGroupStddevPopFields>;
  stddevSamp?: Maybe<TradeGroupStddevSampFields>;
  sum?: Maybe<TradeGroupSumFields>;
  varPop?: Maybe<TradeGroupVarPopFields>;
  varSamp?: Maybe<TradeGroupVarSampFields>;
  variance?: Maybe<TradeGroupVarianceFields>;
};


/** aggregate fields of "trade_group" */
export type TradeGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TradeGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TradeGroupAvgFields = {
  __typename?: 'TradeGroupAvgFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "trade_group". All fields are combined with a logical 'AND'. */
export type TradeGroupBoolExp = {
  _and?: InputMaybe<Array<TradeGroupBoolExp>>;
  _not?: InputMaybe<TradeGroupBoolExp>;
  _or?: InputMaybe<Array<TradeGroupBoolExp>>;
  iconName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  position?: InputMaybe<IntComparisonExp>;
  tradeTradeGroups?: InputMaybe<TradeTradeGroupBoolExp>;
  tradeTradeGroupsAggregate?: InputMaybe<TradeTradeGroupAggregateBoolExp>;
};

/** unique or primary key constraints on table "trade_group" */
export enum TradeGroupConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_23086Primary = 'idx_23086_primary'
}

/** input type for incrementing numeric columns in table "trade_group" */
export type TradeGroupIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trade_group" */
export type TradeGroupInsertInput = {
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  tradeTradeGroups?: InputMaybe<TradeTradeGroupArrRelInsertInput>;
};

/** aggregate max on columns */
export type TradeGroupMaxFields = {
  __typename?: 'TradeGroupMaxFields';
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type TradeGroupMinFields = {
  __typename?: 'TradeGroupMinFields';
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "trade_group" */
export type TradeGroupMutationResponse = {
  __typename?: 'TradeGroupMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TradeGroup>;
};

/** input type for inserting object relation for remote table "trade_group" */
export type TradeGroupObjRelInsertInput = {
  data: TradeGroupInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TradeGroupOnConflict>;
};

/** on_conflict condition type for table "trade_group" */
export type TradeGroupOnConflict = {
  constraint: TradeGroupConstraint;
  updateColumns?: Array<TradeGroupUpdateColumn>;
  where?: InputMaybe<TradeGroupBoolExp>;
};

/** Ordering options when selecting data from "trade_group". */
export type TradeGroupOrderBy = {
  iconName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  tradeTradeGroupsAggregate?: InputMaybe<TradeTradeGroupAggregateOrderBy>;
};

/** primary key columns input for table: trade_group */
export type TradeGroupPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "trade_group" */
export enum TradeGroupSelectColumn {
  /** column name */
  IconName = 'iconName',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Position = 'position'
}

/** input type for updating data in table "trade_group" */
export type TradeGroupSetInput = {
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type TradeGroupStddevFields = {
  __typename?: 'TradeGroupStddevFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type TradeGroupStddevPopFields = {
  __typename?: 'TradeGroupStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type TradeGroupStddevSampFields = {
  __typename?: 'TradeGroupStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "trade_group" */
export type TradeGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TradeGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TradeGroupStreamCursorValueInput = {
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TradeGroupSumFields = {
  __typename?: 'TradeGroupSumFields';
  id?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
};

/** update columns of table "trade_group" */
export enum TradeGroupUpdateColumn {
  /** column name */
  IconName = 'iconName',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Position = 'position'
}

export type TradeGroupUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TradeGroupIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TradeGroupSetInput>;
  /** filter the rows which have to be updated */
  where: TradeGroupBoolExp;
};

/** aggregate varPop on columns */
export type TradeGroupVarPopFields = {
  __typename?: 'TradeGroupVarPopFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type TradeGroupVarSampFields = {
  __typename?: 'TradeGroupVarSampFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TradeGroupVarianceFields = {
  __typename?: 'TradeGroupVarianceFields';
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "trade_guide" */
export type TradeGuide = {
  __typename?: 'TradeGuide';
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  trades: Array<TradeTradeGuide>;
  /** An aggregate relationship */
  tradesAggregate: TradeTradeGuideAggregate;
};


/** columns and relationships of "trade_guide" */
export type TradeGuideTradesArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGuideOrderBy>>;
  where?: InputMaybe<TradeTradeGuideBoolExp>;
};


/** columns and relationships of "trade_guide" */
export type TradeGuideTradesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGuideOrderBy>>;
  where?: InputMaybe<TradeTradeGuideBoolExp>;
};

/** aggregated selection of "trade_guide" */
export type TradeGuideAggregate = {
  __typename?: 'TradeGuideAggregate';
  aggregate?: Maybe<TradeGuideAggregateFields>;
  nodes: Array<TradeGuide>;
};

/** aggregate fields of "trade_guide" */
export type TradeGuideAggregateFields = {
  __typename?: 'TradeGuideAggregateFields';
  avg?: Maybe<TradeGuideAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TradeGuideMaxFields>;
  min?: Maybe<TradeGuideMinFields>;
  stddev?: Maybe<TradeGuideStddevFields>;
  stddevPop?: Maybe<TradeGuideStddevPopFields>;
  stddevSamp?: Maybe<TradeGuideStddevSampFields>;
  sum?: Maybe<TradeGuideSumFields>;
  varPop?: Maybe<TradeGuideVarPopFields>;
  varSamp?: Maybe<TradeGuideVarSampFields>;
  variance?: Maybe<TradeGuideVarianceFields>;
};


/** aggregate fields of "trade_guide" */
export type TradeGuideAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TradeGuideSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_guide" */
export type TradeGuideAggregateOrderBy = {
  avg?: InputMaybe<TradeGuideAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TradeGuideMaxOrderBy>;
  min?: InputMaybe<TradeGuideMinOrderBy>;
  stddev?: InputMaybe<TradeGuideStddevOrderBy>;
  stddevPop?: InputMaybe<TradeGuideStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TradeGuideStddevSampOrderBy>;
  sum?: InputMaybe<TradeGuideSumOrderBy>;
  varPop?: InputMaybe<TradeGuideVarPopOrderBy>;
  varSamp?: InputMaybe<TradeGuideVarSampOrderBy>;
  variance?: InputMaybe<TradeGuideVarianceOrderBy>;
};

/** aggregate avg on columns */
export type TradeGuideAvgFields = {
  __typename?: 'TradeGuideAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_guide" */
export type TradeGuideAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "trade_guide". All fields are combined with a logical 'AND'. */
export type TradeGuideBoolExp = {
  _and?: InputMaybe<Array<TradeGuideBoolExp>>;
  _not?: InputMaybe<TradeGuideBoolExp>;
  _or?: InputMaybe<Array<TradeGuideBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  trades?: InputMaybe<TradeTradeGuideBoolExp>;
  tradesAggregate?: InputMaybe<TradeTradeGuideAggregateBoolExp>;
};

/** unique or primary key constraints on table "trade_guide" */
export enum TradeGuideConstraint {
  /** unique or primary key constraint on columns "id" */
  TradeGuidePkey = 'trade_guide_pkey'
}

/** input type for incrementing numeric columns in table "trade_guide" */
export type TradeGuideIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trade_guide" */
export type TradeGuideInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  trades?: InputMaybe<TradeTradeGuideArrRelInsertInput>;
};

/** aggregate max on columns */
export type TradeGuideMaxFields = {
  __typename?: 'TradeGuideMaxFields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "trade_guide" */
export type TradeGuideMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TradeGuideMinFields = {
  __typename?: 'TradeGuideMinFields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "trade_guide" */
export type TradeGuideMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "trade_guide" */
export type TradeGuideMutationResponse = {
  __typename?: 'TradeGuideMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TradeGuide>;
};

/** input type for inserting object relation for remote table "trade_guide" */
export type TradeGuideObjRelInsertInput = {
  data: TradeGuideInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TradeGuideOnConflict>;
};

/** on_conflict condition type for table "trade_guide" */
export type TradeGuideOnConflict = {
  constraint: TradeGuideConstraint;
  updateColumns?: Array<TradeGuideUpdateColumn>;
  where?: InputMaybe<TradeGuideBoolExp>;
};

/** Ordering options when selecting data from "trade_guide". */
export type TradeGuideOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  tradesAggregate?: InputMaybe<TradeTradeGuideAggregateOrderBy>;
};

/** primary key columns input for table: trade_guide */
export type TradeGuidePkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "trade_guide" */
export enum TradeGuideSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "trade_guide" */
export type TradeGuideSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type TradeGuideStddevFields = {
  __typename?: 'TradeGuideStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_guide" */
export type TradeGuideStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type TradeGuideStddevPopFields = {
  __typename?: 'TradeGuideStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "trade_guide" */
export type TradeGuideStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type TradeGuideStddevSampFields = {
  __typename?: 'TradeGuideStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "trade_guide" */
export type TradeGuideStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "trade_guide" */
export type TradeGuideStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TradeGuideStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TradeGuideStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TradeGuideSumFields = {
  __typename?: 'TradeGuideSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trade_guide" */
export type TradeGuideSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "trade_guide" */
export enum TradeGuideUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type TradeGuideUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TradeGuideIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TradeGuideSetInput>;
  /** filter the rows which have to be updated */
  where: TradeGuideBoolExp;
};

/** aggregate varPop on columns */
export type TradeGuideVarPopFields = {
  __typename?: 'TradeGuideVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "trade_guide" */
export type TradeGuideVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type TradeGuideVarSampFields = {
  __typename?: 'TradeGuideVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "trade_guide" */
export type TradeGuideVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TradeGuideVarianceFields = {
  __typename?: 'TradeGuideVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_guide" */
export type TradeGuideVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** input type for incrementing numeric columns in table "trade" */
export type TradeIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trade" */
export type TradeInsertInput = {
  anchor?: InputMaybe<Scalars['String']>;
  bilikZoneMainProCount?: InputMaybe<BilikZoneTradeMainProCountArrRelInsertInput>;
  bilikZoneSitemap?: InputMaybe<SitemapBilikZoneObjRelInsertInput>;
  citySitemap?: InputMaybe<SitemapCityArrRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  isAnonymised?: InputMaybe<Scalars['Boolean']>;
  isCallRecordable?: InputMaybe<Scalars['Boolean']>;
  isRgeFilterable?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  mainTradeProPresentations?: InputMaybe<TradeProPresentationArrRelInsertInput>;
  metaDescription?: InputMaybe<Scalars['String']>;
  metaTitle?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageSubtitle?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  pageTitleDirectory?: InputMaybe<Scalars['String']>;
  pageTitleVariant?: InputMaybe<Scalars['String']>;
  schemaAdditionalType?: InputMaybe<Scalars['String']>;
  schemaType?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  tradeGroups?: InputMaybe<TradeTradeGroupArrRelInsertInput>;
  tradeGuides?: InputMaybe<TradeTradeGuideArrRelInsertInput>;
  tradeKeywords?: InputMaybe<TradeKeywordArrRelInsertInput>;
  tradeProViews?: InputMaybe<TradeProViewArrRelInsertInput>;
  tradeQuestions?: InputMaybe<TradeQuestionArrRelInsertInput>;
};

/** columns and relationships of "trade_keyword" */
export type TradeKeyword = {
  __typename?: 'TradeKeyword';
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  trade: Trade;
  tradeId: Scalars['Int'];
};

/** aggregated selection of "trade_keyword" */
export type TradeKeywordAggregate = {
  __typename?: 'TradeKeywordAggregate';
  aggregate?: Maybe<TradeKeywordAggregateFields>;
  nodes: Array<TradeKeyword>;
};

export type TradeKeywordAggregateBoolExp = {
  count?: InputMaybe<TradeKeywordAggregateBoolExpCount>;
};

/** aggregate fields of "trade_keyword" */
export type TradeKeywordAggregateFields = {
  __typename?: 'TradeKeywordAggregateFields';
  avg?: Maybe<TradeKeywordAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TradeKeywordMaxFields>;
  min?: Maybe<TradeKeywordMinFields>;
  stddev?: Maybe<TradeKeywordStddevFields>;
  stddevPop?: Maybe<TradeKeywordStddevPopFields>;
  stddevSamp?: Maybe<TradeKeywordStddevSampFields>;
  sum?: Maybe<TradeKeywordSumFields>;
  varPop?: Maybe<TradeKeywordVarPopFields>;
  varSamp?: Maybe<TradeKeywordVarSampFields>;
  variance?: Maybe<TradeKeywordVarianceFields>;
};


/** aggregate fields of "trade_keyword" */
export type TradeKeywordAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TradeKeywordSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_keyword" */
export type TradeKeywordAggregateOrderBy = {
  avg?: InputMaybe<TradeKeywordAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TradeKeywordMaxOrderBy>;
  min?: InputMaybe<TradeKeywordMinOrderBy>;
  stddev?: InputMaybe<TradeKeywordStddevOrderBy>;
  stddevPop?: InputMaybe<TradeKeywordStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TradeKeywordStddevSampOrderBy>;
  sum?: InputMaybe<TradeKeywordSumOrderBy>;
  varPop?: InputMaybe<TradeKeywordVarPopOrderBy>;
  varSamp?: InputMaybe<TradeKeywordVarSampOrderBy>;
  variance?: InputMaybe<TradeKeywordVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "trade_keyword" */
export type TradeKeywordArrRelInsertInput = {
  data: Array<TradeKeywordInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TradeKeywordOnConflict>;
};

/** aggregate avg on columns */
export type TradeKeywordAvgFields = {
  __typename?: 'TradeKeywordAvgFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_keyword" */
export type TradeKeywordAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "trade_keyword". All fields are combined with a logical 'AND'. */
export type TradeKeywordBoolExp = {
  _and?: InputMaybe<Array<TradeKeywordBoolExp>>;
  _not?: InputMaybe<TradeKeywordBoolExp>;
  _or?: InputMaybe<Array<TradeKeywordBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  trade?: InputMaybe<TradeBoolExp>;
  tradeId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "trade_keyword" */
export enum TradeKeywordConstraint {
  /** unique or primary key constraint on columns "id" */
  KeywordPkey = 'keyword_pkey'
}

/** input type for incrementing numeric columns in table "trade_keyword" */
export type TradeKeywordIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trade_keyword" */
export type TradeKeywordInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  trade?: InputMaybe<TradeObjRelInsertInput>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TradeKeywordMaxFields = {
  __typename?: 'TradeKeywordMaxFields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "trade_keyword" */
export type TradeKeywordMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TradeKeywordMinFields = {
  __typename?: 'TradeKeywordMinFields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "trade_keyword" */
export type TradeKeywordMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "trade_keyword" */
export type TradeKeywordMutationResponse = {
  __typename?: 'TradeKeywordMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TradeKeyword>;
};

/** on_conflict condition type for table "trade_keyword" */
export type TradeKeywordOnConflict = {
  constraint: TradeKeywordConstraint;
  updateColumns?: Array<TradeKeywordUpdateColumn>;
  where?: InputMaybe<TradeKeywordBoolExp>;
};

/** Ordering options when selecting data from "trade_keyword". */
export type TradeKeywordOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  trade?: InputMaybe<TradeOrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: trade_keyword */
export type TradeKeywordPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "trade_keyword" */
export enum TradeKeywordSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TradeId = 'tradeId'
}

/** input type for updating data in table "trade_keyword" */
export type TradeKeywordSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type TradeKeywordStddevFields = {
  __typename?: 'TradeKeywordStddevFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_keyword" */
export type TradeKeywordStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type TradeKeywordStddevPopFields = {
  __typename?: 'TradeKeywordStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "trade_keyword" */
export type TradeKeywordStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type TradeKeywordStddevSampFields = {
  __typename?: 'TradeKeywordStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "trade_keyword" */
export type TradeKeywordStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "trade_keyword" */
export type TradeKeywordStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TradeKeywordStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TradeKeywordStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TradeKeywordSumFields = {
  __typename?: 'TradeKeywordSumFields';
  id?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trade_keyword" */
export type TradeKeywordSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** update columns of table "trade_keyword" */
export enum TradeKeywordUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TradeId = 'tradeId'
}

export type TradeKeywordUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TradeKeywordIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TradeKeywordSetInput>;
  /** filter the rows which have to be updated */
  where: TradeKeywordBoolExp;
};

/** aggregate varPop on columns */
export type TradeKeywordVarPopFields = {
  __typename?: 'TradeKeywordVarPopFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "trade_keyword" */
export type TradeKeywordVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type TradeKeywordVarSampFields = {
  __typename?: 'TradeKeywordVarSampFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "trade_keyword" */
export type TradeKeywordVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TradeKeywordVarianceFields = {
  __typename?: 'TradeKeywordVarianceFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_keyword" */
export type TradeKeywordVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "trade_main_pro_count" */
export type TradeMainProCount = {
  __typename?: 'TradeMainProCount';
  count?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  trade?: Maybe<Trade>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "trade_main_pro_count" */
export type TradeMainProCountAggregate = {
  __typename?: 'TradeMainProCountAggregate';
  aggregate?: Maybe<TradeMainProCountAggregateFields>;
  nodes: Array<TradeMainProCount>;
};

/** aggregate fields of "trade_main_pro_count" */
export type TradeMainProCountAggregateFields = {
  __typename?: 'TradeMainProCountAggregateFields';
  avg?: Maybe<TradeMainProCountAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TradeMainProCountMaxFields>;
  min?: Maybe<TradeMainProCountMinFields>;
  stddev?: Maybe<TradeMainProCountStddevFields>;
  stddevPop?: Maybe<TradeMainProCountStddevPopFields>;
  stddevSamp?: Maybe<TradeMainProCountStddevSampFields>;
  sum?: Maybe<TradeMainProCountSumFields>;
  varPop?: Maybe<TradeMainProCountVarPopFields>;
  varSamp?: Maybe<TradeMainProCountVarSampFields>;
  variance?: Maybe<TradeMainProCountVarianceFields>;
};


/** aggregate fields of "trade_main_pro_count" */
export type TradeMainProCountAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TradeMainProCountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TradeMainProCountAvgFields = {
  __typename?: 'TradeMainProCountAvgFields';
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "trade_main_pro_count". All fields are combined with a logical 'AND'. */
export type TradeMainProCountBoolExp = {
  _and?: InputMaybe<Array<TradeMainProCountBoolExp>>;
  _not?: InputMaybe<TradeMainProCountBoolExp>;
  _or?: InputMaybe<Array<TradeMainProCountBoolExp>>;
  count?: InputMaybe<BigintComparisonExp>;
  trade?: InputMaybe<TradeBoolExp>;
  tradeId?: InputMaybe<IntComparisonExp>;
};

/** aggregate max on columns */
export type TradeMainProCountMaxFields = {
  __typename?: 'TradeMainProCountMaxFields';
  count?: Maybe<Scalars['bigint']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type TradeMainProCountMinFields = {
  __typename?: 'TradeMainProCountMinFields';
  count?: Maybe<Scalars['bigint']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "trade_main_pro_count". */
export type TradeMainProCountOrderBy = {
  count?: InputMaybe<OrderBy>;
  trade?: InputMaybe<TradeOrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** select columns of table "trade_main_pro_count" */
export enum TradeMainProCountSelectColumn {
  /** column name */
  Count = 'count',
  /** column name */
  TradeId = 'tradeId'
}

/** aggregate stddev on columns */
export type TradeMainProCountStddevFields = {
  __typename?: 'TradeMainProCountStddevFields';
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type TradeMainProCountStddevPopFields = {
  __typename?: 'TradeMainProCountStddevPopFields';
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type TradeMainProCountStddevSampFields = {
  __typename?: 'TradeMainProCountStddevSampFields';
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "trade_main_pro_count" */
export type TradeMainProCountStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TradeMainProCountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TradeMainProCountStreamCursorValueInput = {
  count?: InputMaybe<Scalars['bigint']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TradeMainProCountSumFields = {
  __typename?: 'TradeMainProCountSumFields';
  count?: Maybe<Scalars['bigint']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** aggregate varPop on columns */
export type TradeMainProCountVarPopFields = {
  __typename?: 'TradeMainProCountVarPopFields';
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type TradeMainProCountVarSampFields = {
  __typename?: 'TradeMainProCountVarSampFields';
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TradeMainProCountVarianceFields = {
  __typename?: 'TradeMainProCountVarianceFields';
  count?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type TradeMaxFields = {
  __typename?: 'TradeMaxFields';
  anchor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pageSubtitle?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  pageTitleDirectory?: Maybe<Scalars['String']>;
  pageTitleVariant?: Maybe<Scalars['String']>;
  schemaAdditionalType?: Maybe<Scalars['String']>;
  schemaType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TradeMinFields = {
  __typename?: 'TradeMinFields';
  anchor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pageSubtitle?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  pageTitleDirectory?: Maybe<Scalars['String']>;
  pageTitleVariant?: Maybe<Scalars['String']>;
  schemaAdditionalType?: Maybe<Scalars['String']>;
  schemaType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "trade" */
export type TradeMutationResponse = {
  __typename?: 'TradeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade>;
};

/** input type for inserting object relation for remote table "trade" */
export type TradeObjRelInsertInput = {
  data: TradeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TradeOnConflict>;
};

/** on_conflict condition type for table "trade" */
export type TradeOnConflict = {
  constraint: TradeConstraint;
  updateColumns?: Array<TradeUpdateColumn>;
  where?: InputMaybe<TradeBoolExp>;
};

/** Ordering options when selecting data from "trade". */
export type TradeOrderBy = {
  anchor?: InputMaybe<OrderBy>;
  bilikZoneMainProCountAggregate?: InputMaybe<BilikZoneTradeMainProCountAggregateOrderBy>;
  bilikZoneSitemap?: InputMaybe<SitemapBilikZoneOrderBy>;
  citySitemapAggregate?: InputMaybe<SitemapCityAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  isAnonymised?: InputMaybe<OrderBy>;
  isCallRecordable?: InputMaybe<OrderBy>;
  isRgeFilterable?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  mainTradeProPresentationsAggregate?: InputMaybe<TradeProPresentationAggregateOrderBy>;
  metaDescription?: InputMaybe<OrderBy>;
  metaTitle?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pageSubtitle?: InputMaybe<OrderBy>;
  pageTitle?: InputMaybe<OrderBy>;
  pageTitleDirectory?: InputMaybe<OrderBy>;
  pageTitleVariant?: InputMaybe<OrderBy>;
  schemaAdditionalType?: InputMaybe<OrderBy>;
  schemaType?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tradeGroupsAggregate?: InputMaybe<TradeTradeGroupAggregateOrderBy>;
  tradeGuidesAggregate?: InputMaybe<TradeTradeGuideAggregateOrderBy>;
  tradeKeywordsAggregate?: InputMaybe<TradeKeywordAggregateOrderBy>;
  tradeProViewsAggregate?: InputMaybe<TradeProViewAggregateOrderBy>;
  tradeQuestionsAggregate?: InputMaybe<TradeQuestionAggregateOrderBy>;
};

/** primary key columns input for table: trade */
export type TradePkColumnsInput = {
  id: Scalars['Int'];
};

/** columns and relationships of "trade_pro_presentation" */
export type TradeProPresentation = {
  __typename?: 'TradeProPresentation';
  /** An object relationship */
  proPresentation: ProPresentation;
  proPresentationId: Scalars['Int'];
  /** An object relationship */
  trade: Trade;
  tradeId: Scalars['Int'];
};

/** aggregated selection of "trade_pro_presentation" */
export type TradeProPresentationAggregate = {
  __typename?: 'TradeProPresentationAggregate';
  aggregate?: Maybe<TradeProPresentationAggregateFields>;
  nodes: Array<TradeProPresentation>;
};

export type TradeProPresentationAggregateBoolExp = {
  count?: InputMaybe<TradeProPresentationAggregateBoolExpCount>;
};

/** aggregate fields of "trade_pro_presentation" */
export type TradeProPresentationAggregateFields = {
  __typename?: 'TradeProPresentationAggregateFields';
  avg?: Maybe<TradeProPresentationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TradeProPresentationMaxFields>;
  min?: Maybe<TradeProPresentationMinFields>;
  stddev?: Maybe<TradeProPresentationStddevFields>;
  stddevPop?: Maybe<TradeProPresentationStddevPopFields>;
  stddevSamp?: Maybe<TradeProPresentationStddevSampFields>;
  sum?: Maybe<TradeProPresentationSumFields>;
  varPop?: Maybe<TradeProPresentationVarPopFields>;
  varSamp?: Maybe<TradeProPresentationVarSampFields>;
  variance?: Maybe<TradeProPresentationVarianceFields>;
};


/** aggregate fields of "trade_pro_presentation" */
export type TradeProPresentationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TradeProPresentationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_pro_presentation" */
export type TradeProPresentationAggregateOrderBy = {
  avg?: InputMaybe<TradeProPresentationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TradeProPresentationMaxOrderBy>;
  min?: InputMaybe<TradeProPresentationMinOrderBy>;
  stddev?: InputMaybe<TradeProPresentationStddevOrderBy>;
  stddevPop?: InputMaybe<TradeProPresentationStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TradeProPresentationStddevSampOrderBy>;
  sum?: InputMaybe<TradeProPresentationSumOrderBy>;
  varPop?: InputMaybe<TradeProPresentationVarPopOrderBy>;
  varSamp?: InputMaybe<TradeProPresentationVarSampOrderBy>;
  variance?: InputMaybe<TradeProPresentationVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "trade_pro_presentation" */
export type TradeProPresentationArrRelInsertInput = {
  data: Array<TradeProPresentationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TradeProPresentationOnConflict>;
};

/** aggregate avg on columns */
export type TradeProPresentationAvgFields = {
  __typename?: 'TradeProPresentationAvgFields';
  proPresentationId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_pro_presentation" */
export type TradeProPresentationAvgOrderBy = {
  proPresentationId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "trade_pro_presentation". All fields are combined with a logical 'AND'. */
export type TradeProPresentationBoolExp = {
  _and?: InputMaybe<Array<TradeProPresentationBoolExp>>;
  _not?: InputMaybe<TradeProPresentationBoolExp>;
  _or?: InputMaybe<Array<TradeProPresentationBoolExp>>;
  proPresentation?: InputMaybe<ProPresentationBoolExp>;
  proPresentationId?: InputMaybe<IntComparisonExp>;
  trade?: InputMaybe<TradeBoolExp>;
  tradeId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "trade_pro_presentation" */
export enum TradeProPresentationConstraint {
  /** unique or primary key constraint on columns "trade_id", "pro_presentation_id" */
  TradeProPresentationPkey = 'trade_pro_presentation_pkey'
}

/** input type for incrementing numeric columns in table "trade_pro_presentation" */
export type TradeProPresentationIncInput = {
  proPresentationId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trade_pro_presentation" */
export type TradeProPresentationInsertInput = {
  proPresentation?: InputMaybe<ProPresentationObjRelInsertInput>;
  proPresentationId?: InputMaybe<Scalars['Int']>;
  trade?: InputMaybe<TradeObjRelInsertInput>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TradeProPresentationMaxFields = {
  __typename?: 'TradeProPresentationMaxFields';
  proPresentationId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "trade_pro_presentation" */
export type TradeProPresentationMaxOrderBy = {
  proPresentationId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TradeProPresentationMinFields = {
  __typename?: 'TradeProPresentationMinFields';
  proPresentationId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "trade_pro_presentation" */
export type TradeProPresentationMinOrderBy = {
  proPresentationId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "trade_pro_presentation" */
export type TradeProPresentationMutationResponse = {
  __typename?: 'TradeProPresentationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TradeProPresentation>;
};

/** on_conflict condition type for table "trade_pro_presentation" */
export type TradeProPresentationOnConflict = {
  constraint: TradeProPresentationConstraint;
  updateColumns?: Array<TradeProPresentationUpdateColumn>;
  where?: InputMaybe<TradeProPresentationBoolExp>;
};

/** Ordering options when selecting data from "trade_pro_presentation". */
export type TradeProPresentationOrderBy = {
  proPresentation?: InputMaybe<ProPresentationOrderBy>;
  proPresentationId?: InputMaybe<OrderBy>;
  trade?: InputMaybe<TradeOrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: trade_pro_presentation */
export type TradeProPresentationPkColumnsInput = {
  proPresentationId: Scalars['Int'];
  tradeId: Scalars['Int'];
};

/** select columns of table "trade_pro_presentation" */
export enum TradeProPresentationSelectColumn {
  /** column name */
  ProPresentationId = 'proPresentationId',
  /** column name */
  TradeId = 'tradeId'
}

/** input type for updating data in table "trade_pro_presentation" */
export type TradeProPresentationSetInput = {
  proPresentationId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type TradeProPresentationStddevFields = {
  __typename?: 'TradeProPresentationStddevFields';
  proPresentationId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_pro_presentation" */
export type TradeProPresentationStddevOrderBy = {
  proPresentationId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type TradeProPresentationStddevPopFields = {
  __typename?: 'TradeProPresentationStddevPopFields';
  proPresentationId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "trade_pro_presentation" */
export type TradeProPresentationStddevPopOrderBy = {
  proPresentationId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type TradeProPresentationStddevSampFields = {
  __typename?: 'TradeProPresentationStddevSampFields';
  proPresentationId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "trade_pro_presentation" */
export type TradeProPresentationStddevSampOrderBy = {
  proPresentationId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "trade_pro_presentation" */
export type TradeProPresentationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TradeProPresentationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TradeProPresentationStreamCursorValueInput = {
  proPresentationId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TradeProPresentationSumFields = {
  __typename?: 'TradeProPresentationSumFields';
  proPresentationId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trade_pro_presentation" */
export type TradeProPresentationSumOrderBy = {
  proPresentationId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** update columns of table "trade_pro_presentation" */
export enum TradeProPresentationUpdateColumn {
  /** column name */
  ProPresentationId = 'proPresentationId',
  /** column name */
  TradeId = 'tradeId'
}

export type TradeProPresentationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TradeProPresentationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TradeProPresentationSetInput>;
  /** filter the rows which have to be updated */
  where: TradeProPresentationBoolExp;
};

/** aggregate varPop on columns */
export type TradeProPresentationVarPopFields = {
  __typename?: 'TradeProPresentationVarPopFields';
  proPresentationId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "trade_pro_presentation" */
export type TradeProPresentationVarPopOrderBy = {
  proPresentationId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type TradeProPresentationVarSampFields = {
  __typename?: 'TradeProPresentationVarSampFields';
  proPresentationId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "trade_pro_presentation" */
export type TradeProPresentationVarSampOrderBy = {
  proPresentationId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TradeProPresentationVarianceFields = {
  __typename?: 'TradeProPresentationVarianceFields';
  proPresentationId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_pro_presentation" */
export type TradeProPresentationVarianceOrderBy = {
  proPresentationId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "trade_pro_view" */
export type TradeProView = {
  __typename?: 'TradeProView';
  /** An object relationship */
  proView: ProView;
  proViewId: Scalars['Int'];
  /** An object relationship */
  trade: Trade;
  tradeId: Scalars['Int'];
};

/** aggregated selection of "trade_pro_view" */
export type TradeProViewAggregate = {
  __typename?: 'TradeProViewAggregate';
  aggregate?: Maybe<TradeProViewAggregateFields>;
  nodes: Array<TradeProView>;
};

export type TradeProViewAggregateBoolExp = {
  count?: InputMaybe<TradeProViewAggregateBoolExpCount>;
};

/** aggregate fields of "trade_pro_view" */
export type TradeProViewAggregateFields = {
  __typename?: 'TradeProViewAggregateFields';
  avg?: Maybe<TradeProViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TradeProViewMaxFields>;
  min?: Maybe<TradeProViewMinFields>;
  stddev?: Maybe<TradeProViewStddevFields>;
  stddevPop?: Maybe<TradeProViewStddevPopFields>;
  stddevSamp?: Maybe<TradeProViewStddevSampFields>;
  sum?: Maybe<TradeProViewSumFields>;
  varPop?: Maybe<TradeProViewVarPopFields>;
  varSamp?: Maybe<TradeProViewVarSampFields>;
  variance?: Maybe<TradeProViewVarianceFields>;
};


/** aggregate fields of "trade_pro_view" */
export type TradeProViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TradeProViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_pro_view" */
export type TradeProViewAggregateOrderBy = {
  avg?: InputMaybe<TradeProViewAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TradeProViewMaxOrderBy>;
  min?: InputMaybe<TradeProViewMinOrderBy>;
  stddev?: InputMaybe<TradeProViewStddevOrderBy>;
  stddevPop?: InputMaybe<TradeProViewStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TradeProViewStddevSampOrderBy>;
  sum?: InputMaybe<TradeProViewSumOrderBy>;
  varPop?: InputMaybe<TradeProViewVarPopOrderBy>;
  varSamp?: InputMaybe<TradeProViewVarSampOrderBy>;
  variance?: InputMaybe<TradeProViewVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "trade_pro_view" */
export type TradeProViewArrRelInsertInput = {
  data: Array<TradeProViewInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TradeProViewOnConflict>;
};

/** aggregate avg on columns */
export type TradeProViewAvgFields = {
  __typename?: 'TradeProViewAvgFields';
  proViewId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_pro_view" */
export type TradeProViewAvgOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "trade_pro_view". All fields are combined with a logical 'AND'. */
export type TradeProViewBoolExp = {
  _and?: InputMaybe<Array<TradeProViewBoolExp>>;
  _not?: InputMaybe<TradeProViewBoolExp>;
  _or?: InputMaybe<Array<TradeProViewBoolExp>>;
  proView?: InputMaybe<ProViewBoolExp>;
  proViewId?: InputMaybe<IntComparisonExp>;
  trade?: InputMaybe<TradeBoolExp>;
  tradeId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "trade_pro_view" */
export enum TradeProViewConstraint {
  /** unique or primary key constraint on columns "trade_id", "pro_view_id" */
  Idx_23093Primary = 'idx_23093_primary'
}

/** input type for incrementing numeric columns in table "trade_pro_view" */
export type TradeProViewIncInput = {
  proViewId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trade_pro_view" */
export type TradeProViewInsertInput = {
  proView?: InputMaybe<ProViewObjRelInsertInput>;
  proViewId?: InputMaybe<Scalars['Int']>;
  trade?: InputMaybe<TradeObjRelInsertInput>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TradeProViewMaxFields = {
  __typename?: 'TradeProViewMaxFields';
  proViewId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "trade_pro_view" */
export type TradeProViewMaxOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TradeProViewMinFields = {
  __typename?: 'TradeProViewMinFields';
  proViewId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "trade_pro_view" */
export type TradeProViewMinOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "trade_pro_view" */
export type TradeProViewMutationResponse = {
  __typename?: 'TradeProViewMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TradeProView>;
};

/** on_conflict condition type for table "trade_pro_view" */
export type TradeProViewOnConflict = {
  constraint: TradeProViewConstraint;
  updateColumns?: Array<TradeProViewUpdateColumn>;
  where?: InputMaybe<TradeProViewBoolExp>;
};

/** Ordering options when selecting data from "trade_pro_view". */
export type TradeProViewOrderBy = {
  proView?: InputMaybe<ProViewOrderBy>;
  proViewId?: InputMaybe<OrderBy>;
  trade?: InputMaybe<TradeOrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: trade_pro_view */
export type TradeProViewPkColumnsInput = {
  proViewId: Scalars['Int'];
  tradeId: Scalars['Int'];
};

/** select columns of table "trade_pro_view" */
export enum TradeProViewSelectColumn {
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  TradeId = 'tradeId'
}

/** input type for updating data in table "trade_pro_view" */
export type TradeProViewSetInput = {
  proViewId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type TradeProViewStddevFields = {
  __typename?: 'TradeProViewStddevFields';
  proViewId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_pro_view" */
export type TradeProViewStddevOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type TradeProViewStddevPopFields = {
  __typename?: 'TradeProViewStddevPopFields';
  proViewId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "trade_pro_view" */
export type TradeProViewStddevPopOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type TradeProViewStddevSampFields = {
  __typename?: 'TradeProViewStddevSampFields';
  proViewId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "trade_pro_view" */
export type TradeProViewStddevSampOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "trade_pro_view" */
export type TradeProViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TradeProViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TradeProViewStreamCursorValueInput = {
  proViewId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TradeProViewSumFields = {
  __typename?: 'TradeProViewSumFields';
  proViewId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trade_pro_view" */
export type TradeProViewSumOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** update columns of table "trade_pro_view" */
export enum TradeProViewUpdateColumn {
  /** column name */
  ProViewId = 'proViewId',
  /** column name */
  TradeId = 'tradeId'
}

export type TradeProViewUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TradeProViewIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TradeProViewSetInput>;
  /** filter the rows which have to be updated */
  where: TradeProViewBoolExp;
};

/** aggregate varPop on columns */
export type TradeProViewVarPopFields = {
  __typename?: 'TradeProViewVarPopFields';
  proViewId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "trade_pro_view" */
export type TradeProViewVarPopOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type TradeProViewVarSampFields = {
  __typename?: 'TradeProViewVarSampFields';
  proViewId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "trade_pro_view" */
export type TradeProViewVarSampOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TradeProViewVarianceFields = {
  __typename?: 'TradeProViewVarianceFields';
  proViewId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_pro_view" */
export type TradeProViewVarianceOrderBy = {
  proViewId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "trade_question" */
export type TradeQuestion = {
  __typename?: 'TradeQuestion';
  answer: Scalars['String'];
  id: Scalars['Int'];
  question: Scalars['String'];
  /** An object relationship */
  trade: Trade;
  tradeId: Scalars['Int'];
};

/** aggregated selection of "trade_question" */
export type TradeQuestionAggregate = {
  __typename?: 'TradeQuestionAggregate';
  aggregate?: Maybe<TradeQuestionAggregateFields>;
  nodes: Array<TradeQuestion>;
};

export type TradeQuestionAggregateBoolExp = {
  count?: InputMaybe<TradeQuestionAggregateBoolExpCount>;
};

/** aggregate fields of "trade_question" */
export type TradeQuestionAggregateFields = {
  __typename?: 'TradeQuestionAggregateFields';
  avg?: Maybe<TradeQuestionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TradeQuestionMaxFields>;
  min?: Maybe<TradeQuestionMinFields>;
  stddev?: Maybe<TradeQuestionStddevFields>;
  stddevPop?: Maybe<TradeQuestionStddevPopFields>;
  stddevSamp?: Maybe<TradeQuestionStddevSampFields>;
  sum?: Maybe<TradeQuestionSumFields>;
  varPop?: Maybe<TradeQuestionVarPopFields>;
  varSamp?: Maybe<TradeQuestionVarSampFields>;
  variance?: Maybe<TradeQuestionVarianceFields>;
};


/** aggregate fields of "trade_question" */
export type TradeQuestionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TradeQuestionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_question" */
export type TradeQuestionAggregateOrderBy = {
  avg?: InputMaybe<TradeQuestionAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TradeQuestionMaxOrderBy>;
  min?: InputMaybe<TradeQuestionMinOrderBy>;
  stddev?: InputMaybe<TradeQuestionStddevOrderBy>;
  stddevPop?: InputMaybe<TradeQuestionStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TradeQuestionStddevSampOrderBy>;
  sum?: InputMaybe<TradeQuestionSumOrderBy>;
  varPop?: InputMaybe<TradeQuestionVarPopOrderBy>;
  varSamp?: InputMaybe<TradeQuestionVarSampOrderBy>;
  variance?: InputMaybe<TradeQuestionVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "trade_question" */
export type TradeQuestionArrRelInsertInput = {
  data: Array<TradeQuestionInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TradeQuestionOnConflict>;
};

/** aggregate avg on columns */
export type TradeQuestionAvgFields = {
  __typename?: 'TradeQuestionAvgFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_question" */
export type TradeQuestionAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "trade_question". All fields are combined with a logical 'AND'. */
export type TradeQuestionBoolExp = {
  _and?: InputMaybe<Array<TradeQuestionBoolExp>>;
  _not?: InputMaybe<TradeQuestionBoolExp>;
  _or?: InputMaybe<Array<TradeQuestionBoolExp>>;
  answer?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  question?: InputMaybe<StringComparisonExp>;
  trade?: InputMaybe<TradeBoolExp>;
  tradeId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "trade_question" */
export enum TradeQuestionConstraint {
  /** unique or primary key constraint on columns "id" */
  TradeQuestionPkey = 'trade_question_pkey'
}

/** input type for incrementing numeric columns in table "trade_question" */
export type TradeQuestionIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trade_question" */
export type TradeQuestionInsertInput = {
  answer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  trade?: InputMaybe<TradeObjRelInsertInput>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TradeQuestionMaxFields = {
  __typename?: 'TradeQuestionMaxFields';
  answer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "trade_question" */
export type TradeQuestionMaxOrderBy = {
  answer?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TradeQuestionMinFields = {
  __typename?: 'TradeQuestionMinFields';
  answer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "trade_question" */
export type TradeQuestionMinOrderBy = {
  answer?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "trade_question" */
export type TradeQuestionMutationResponse = {
  __typename?: 'TradeQuestionMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TradeQuestion>;
};

/** on_conflict condition type for table "trade_question" */
export type TradeQuestionOnConflict = {
  constraint: TradeQuestionConstraint;
  updateColumns?: Array<TradeQuestionUpdateColumn>;
  where?: InputMaybe<TradeQuestionBoolExp>;
};

/** Ordering options when selecting data from "trade_question". */
export type TradeQuestionOrderBy = {
  answer?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  trade?: InputMaybe<TradeOrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: trade_question */
export type TradeQuestionPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "trade_question" */
export enum TradeQuestionSelectColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  TradeId = 'tradeId'
}

/** input type for updating data in table "trade_question" */
export type TradeQuestionSetInput = {
  answer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type TradeQuestionStddevFields = {
  __typename?: 'TradeQuestionStddevFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_question" */
export type TradeQuestionStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type TradeQuestionStddevPopFields = {
  __typename?: 'TradeQuestionStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "trade_question" */
export type TradeQuestionStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type TradeQuestionStddevSampFields = {
  __typename?: 'TradeQuestionStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "trade_question" */
export type TradeQuestionStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "trade_question" */
export type TradeQuestionStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TradeQuestionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TradeQuestionStreamCursorValueInput = {
  answer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TradeQuestionSumFields = {
  __typename?: 'TradeQuestionSumFields';
  id?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trade_question" */
export type TradeQuestionSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** update columns of table "trade_question" */
export enum TradeQuestionUpdateColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  TradeId = 'tradeId'
}

export type TradeQuestionUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TradeQuestionIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TradeQuestionSetInput>;
  /** filter the rows which have to be updated */
  where: TradeQuestionBoolExp;
};

/** aggregate varPop on columns */
export type TradeQuestionVarPopFields = {
  __typename?: 'TradeQuestionVarPopFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "trade_question" */
export type TradeQuestionVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type TradeQuestionVarSampFields = {
  __typename?: 'TradeQuestionVarSampFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "trade_question" */
export type TradeQuestionVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TradeQuestionVarianceFields = {
  __typename?: 'TradeQuestionVarianceFields';
  id?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_question" */
export type TradeQuestionVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** select columns of table "trade" */
export enum TradeSelectColumn {
  /** column name */
  Anchor = 'anchor',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymised = 'isAnonymised',
  /** column name */
  IsCallRecordable = 'isCallRecordable',
  /** column name */
  IsRgeFilterable = 'isRgeFilterable',
  /** column name */
  Label = 'label',
  /** column name */
  MetaDescription = 'metaDescription',
  /** column name */
  MetaTitle = 'metaTitle',
  /** column name */
  Name = 'name',
  /** column name */
  PageSubtitle = 'pageSubtitle',
  /** column name */
  PageTitle = 'pageTitle',
  /** column name */
  PageTitleDirectory = 'pageTitleDirectory',
  /** column name */
  PageTitleVariant = 'pageTitleVariant',
  /** column name */
  SchemaAdditionalType = 'schemaAdditionalType',
  /** column name */
  SchemaType = 'schemaType',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "trade" */
export type TradeSetInput = {
  anchor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isAnonymised?: InputMaybe<Scalars['Boolean']>;
  isCallRecordable?: InputMaybe<Scalars['Boolean']>;
  isRgeFilterable?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  metaTitle?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageSubtitle?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  pageTitleDirectory?: InputMaybe<Scalars['String']>;
  pageTitleVariant?: InputMaybe<Scalars['String']>;
  schemaAdditionalType?: InputMaybe<Scalars['String']>;
  schemaType?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type TradeStddevFields = {
  __typename?: 'TradeStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type TradeStddevPopFields = {
  __typename?: 'TradeStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type TradeStddevSampFields = {
  __typename?: 'TradeStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "trade" */
export type TradeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TradeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TradeStreamCursorValueInput = {
  anchor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isAnonymised?: InputMaybe<Scalars['Boolean']>;
  isCallRecordable?: InputMaybe<Scalars['Boolean']>;
  isRgeFilterable?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  metaTitle?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageSubtitle?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  pageTitleDirectory?: InputMaybe<Scalars['String']>;
  pageTitleVariant?: InputMaybe<Scalars['String']>;
  schemaAdditionalType?: InputMaybe<Scalars['String']>;
  schemaType?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TradeSumFields = {
  __typename?: 'TradeSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "trade_trade_group" */
export type TradeTradeGroup = {
  __typename?: 'TradeTradeGroup';
  /** An object relationship */
  trade: Trade;
  /** An object relationship */
  tradeGroup: TradeGroup;
  tradeGroupId: Scalars['Int'];
  tradeId: Scalars['Int'];
};

/** aggregated selection of "trade_trade_group" */
export type TradeTradeGroupAggregate = {
  __typename?: 'TradeTradeGroupAggregate';
  aggregate?: Maybe<TradeTradeGroupAggregateFields>;
  nodes: Array<TradeTradeGroup>;
};

export type TradeTradeGroupAggregateBoolExp = {
  count?: InputMaybe<TradeTradeGroupAggregateBoolExpCount>;
};

/** aggregate fields of "trade_trade_group" */
export type TradeTradeGroupAggregateFields = {
  __typename?: 'TradeTradeGroupAggregateFields';
  avg?: Maybe<TradeTradeGroupAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TradeTradeGroupMaxFields>;
  min?: Maybe<TradeTradeGroupMinFields>;
  stddev?: Maybe<TradeTradeGroupStddevFields>;
  stddevPop?: Maybe<TradeTradeGroupStddevPopFields>;
  stddevSamp?: Maybe<TradeTradeGroupStddevSampFields>;
  sum?: Maybe<TradeTradeGroupSumFields>;
  varPop?: Maybe<TradeTradeGroupVarPopFields>;
  varSamp?: Maybe<TradeTradeGroupVarSampFields>;
  variance?: Maybe<TradeTradeGroupVarianceFields>;
};


/** aggregate fields of "trade_trade_group" */
export type TradeTradeGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TradeTradeGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_trade_group" */
export type TradeTradeGroupAggregateOrderBy = {
  avg?: InputMaybe<TradeTradeGroupAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TradeTradeGroupMaxOrderBy>;
  min?: InputMaybe<TradeTradeGroupMinOrderBy>;
  stddev?: InputMaybe<TradeTradeGroupStddevOrderBy>;
  stddevPop?: InputMaybe<TradeTradeGroupStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TradeTradeGroupStddevSampOrderBy>;
  sum?: InputMaybe<TradeTradeGroupSumOrderBy>;
  varPop?: InputMaybe<TradeTradeGroupVarPopOrderBy>;
  varSamp?: InputMaybe<TradeTradeGroupVarSampOrderBy>;
  variance?: InputMaybe<TradeTradeGroupVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "trade_trade_group" */
export type TradeTradeGroupArrRelInsertInput = {
  data: Array<TradeTradeGroupInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TradeTradeGroupOnConflict>;
};

/** aggregate avg on columns */
export type TradeTradeGroupAvgFields = {
  __typename?: 'TradeTradeGroupAvgFields';
  tradeGroupId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_trade_group" */
export type TradeTradeGroupAvgOrderBy = {
  tradeGroupId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "trade_trade_group". All fields are combined with a logical 'AND'. */
export type TradeTradeGroupBoolExp = {
  _and?: InputMaybe<Array<TradeTradeGroupBoolExp>>;
  _not?: InputMaybe<TradeTradeGroupBoolExp>;
  _or?: InputMaybe<Array<TradeTradeGroupBoolExp>>;
  trade?: InputMaybe<TradeBoolExp>;
  tradeGroup?: InputMaybe<TradeGroupBoolExp>;
  tradeGroupId?: InputMaybe<IntComparisonExp>;
  tradeId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "trade_trade_group" */
export enum TradeTradeGroupConstraint {
  /** unique or primary key constraint on columns "trade_id", "trade_group_id" */
  Idx_23096Primary = 'idx_23096_primary'
}

/** input type for incrementing numeric columns in table "trade_trade_group" */
export type TradeTradeGroupIncInput = {
  tradeGroupId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trade_trade_group" */
export type TradeTradeGroupInsertInput = {
  trade?: InputMaybe<TradeObjRelInsertInput>;
  tradeGroup?: InputMaybe<TradeGroupObjRelInsertInput>;
  tradeGroupId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TradeTradeGroupMaxFields = {
  __typename?: 'TradeTradeGroupMaxFields';
  tradeGroupId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "trade_trade_group" */
export type TradeTradeGroupMaxOrderBy = {
  tradeGroupId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TradeTradeGroupMinFields = {
  __typename?: 'TradeTradeGroupMinFields';
  tradeGroupId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "trade_trade_group" */
export type TradeTradeGroupMinOrderBy = {
  tradeGroupId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "trade_trade_group" */
export type TradeTradeGroupMutationResponse = {
  __typename?: 'TradeTradeGroupMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TradeTradeGroup>;
};

/** on_conflict condition type for table "trade_trade_group" */
export type TradeTradeGroupOnConflict = {
  constraint: TradeTradeGroupConstraint;
  updateColumns?: Array<TradeTradeGroupUpdateColumn>;
  where?: InputMaybe<TradeTradeGroupBoolExp>;
};

/** Ordering options when selecting data from "trade_trade_group". */
export type TradeTradeGroupOrderBy = {
  trade?: InputMaybe<TradeOrderBy>;
  tradeGroup?: InputMaybe<TradeGroupOrderBy>;
  tradeGroupId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: trade_trade_group */
export type TradeTradeGroupPkColumnsInput = {
  tradeGroupId: Scalars['Int'];
  tradeId: Scalars['Int'];
};

/** select columns of table "trade_trade_group" */
export enum TradeTradeGroupSelectColumn {
  /** column name */
  TradeGroupId = 'tradeGroupId',
  /** column name */
  TradeId = 'tradeId'
}

/** input type for updating data in table "trade_trade_group" */
export type TradeTradeGroupSetInput = {
  tradeGroupId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type TradeTradeGroupStddevFields = {
  __typename?: 'TradeTradeGroupStddevFields';
  tradeGroupId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_trade_group" */
export type TradeTradeGroupStddevOrderBy = {
  tradeGroupId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type TradeTradeGroupStddevPopFields = {
  __typename?: 'TradeTradeGroupStddevPopFields';
  tradeGroupId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "trade_trade_group" */
export type TradeTradeGroupStddevPopOrderBy = {
  tradeGroupId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type TradeTradeGroupStddevSampFields = {
  __typename?: 'TradeTradeGroupStddevSampFields';
  tradeGroupId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "trade_trade_group" */
export type TradeTradeGroupStddevSampOrderBy = {
  tradeGroupId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "trade_trade_group" */
export type TradeTradeGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TradeTradeGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TradeTradeGroupStreamCursorValueInput = {
  tradeGroupId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TradeTradeGroupSumFields = {
  __typename?: 'TradeTradeGroupSumFields';
  tradeGroupId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trade_trade_group" */
export type TradeTradeGroupSumOrderBy = {
  tradeGroupId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** update columns of table "trade_trade_group" */
export enum TradeTradeGroupUpdateColumn {
  /** column name */
  TradeGroupId = 'tradeGroupId',
  /** column name */
  TradeId = 'tradeId'
}

export type TradeTradeGroupUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TradeTradeGroupIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TradeTradeGroupSetInput>;
  /** filter the rows which have to be updated */
  where: TradeTradeGroupBoolExp;
};

/** aggregate varPop on columns */
export type TradeTradeGroupVarPopFields = {
  __typename?: 'TradeTradeGroupVarPopFields';
  tradeGroupId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "trade_trade_group" */
export type TradeTradeGroupVarPopOrderBy = {
  tradeGroupId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type TradeTradeGroupVarSampFields = {
  __typename?: 'TradeTradeGroupVarSampFields';
  tradeGroupId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "trade_trade_group" */
export type TradeTradeGroupVarSampOrderBy = {
  tradeGroupId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TradeTradeGroupVarianceFields = {
  __typename?: 'TradeTradeGroupVarianceFields';
  tradeGroupId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_trade_group" */
export type TradeTradeGroupVarianceOrderBy = {
  tradeGroupId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "trade_trade_guide" */
export type TradeTradeGuide = {
  __typename?: 'TradeTradeGuide';
  /** An object relationship */
  trade: Trade;
  /** An object relationship */
  tradeGuide: TradeGuide;
  tradeGuideId: Scalars['Int'];
  tradeId: Scalars['Int'];
};

/** aggregated selection of "trade_trade_guide" */
export type TradeTradeGuideAggregate = {
  __typename?: 'TradeTradeGuideAggregate';
  aggregate?: Maybe<TradeTradeGuideAggregateFields>;
  nodes: Array<TradeTradeGuide>;
};

export type TradeTradeGuideAggregateBoolExp = {
  count?: InputMaybe<TradeTradeGuideAggregateBoolExpCount>;
};

/** aggregate fields of "trade_trade_guide" */
export type TradeTradeGuideAggregateFields = {
  __typename?: 'TradeTradeGuideAggregateFields';
  avg?: Maybe<TradeTradeGuideAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TradeTradeGuideMaxFields>;
  min?: Maybe<TradeTradeGuideMinFields>;
  stddev?: Maybe<TradeTradeGuideStddevFields>;
  stddevPop?: Maybe<TradeTradeGuideStddevPopFields>;
  stddevSamp?: Maybe<TradeTradeGuideStddevSampFields>;
  sum?: Maybe<TradeTradeGuideSumFields>;
  varPop?: Maybe<TradeTradeGuideVarPopFields>;
  varSamp?: Maybe<TradeTradeGuideVarSampFields>;
  variance?: Maybe<TradeTradeGuideVarianceFields>;
};


/** aggregate fields of "trade_trade_guide" */
export type TradeTradeGuideAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TradeTradeGuideSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_trade_guide" */
export type TradeTradeGuideAggregateOrderBy = {
  avg?: InputMaybe<TradeTradeGuideAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TradeTradeGuideMaxOrderBy>;
  min?: InputMaybe<TradeTradeGuideMinOrderBy>;
  stddev?: InputMaybe<TradeTradeGuideStddevOrderBy>;
  stddevPop?: InputMaybe<TradeTradeGuideStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TradeTradeGuideStddevSampOrderBy>;
  sum?: InputMaybe<TradeTradeGuideSumOrderBy>;
  varPop?: InputMaybe<TradeTradeGuideVarPopOrderBy>;
  varSamp?: InputMaybe<TradeTradeGuideVarSampOrderBy>;
  variance?: InputMaybe<TradeTradeGuideVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "trade_trade_guide" */
export type TradeTradeGuideArrRelInsertInput = {
  data: Array<TradeTradeGuideInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TradeTradeGuideOnConflict>;
};

/** aggregate avg on columns */
export type TradeTradeGuideAvgFields = {
  __typename?: 'TradeTradeGuideAvgFields';
  tradeGuideId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_trade_guide" */
export type TradeTradeGuideAvgOrderBy = {
  tradeGuideId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "trade_trade_guide". All fields are combined with a logical 'AND'. */
export type TradeTradeGuideBoolExp = {
  _and?: InputMaybe<Array<TradeTradeGuideBoolExp>>;
  _not?: InputMaybe<TradeTradeGuideBoolExp>;
  _or?: InputMaybe<Array<TradeTradeGuideBoolExp>>;
  trade?: InputMaybe<TradeBoolExp>;
  tradeGuide?: InputMaybe<TradeGuideBoolExp>;
  tradeGuideId?: InputMaybe<IntComparisonExp>;
  tradeId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "trade_trade_guide" */
export enum TradeTradeGuideConstraint {
  /** unique or primary key constraint on columns "trade_id", "trade_guide_id" */
  TradeTradeGuidePkey = 'trade_trade_guide_pkey'
}

/** input type for incrementing numeric columns in table "trade_trade_guide" */
export type TradeTradeGuideIncInput = {
  tradeGuideId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trade_trade_guide" */
export type TradeTradeGuideInsertInput = {
  trade?: InputMaybe<TradeObjRelInsertInput>;
  tradeGuide?: InputMaybe<TradeGuideObjRelInsertInput>;
  tradeGuideId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TradeTradeGuideMaxFields = {
  __typename?: 'TradeTradeGuideMaxFields';
  tradeGuideId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "trade_trade_guide" */
export type TradeTradeGuideMaxOrderBy = {
  tradeGuideId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TradeTradeGuideMinFields = {
  __typename?: 'TradeTradeGuideMinFields';
  tradeGuideId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "trade_trade_guide" */
export type TradeTradeGuideMinOrderBy = {
  tradeGuideId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "trade_trade_guide" */
export type TradeTradeGuideMutationResponse = {
  __typename?: 'TradeTradeGuideMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TradeTradeGuide>;
};

/** on_conflict condition type for table "trade_trade_guide" */
export type TradeTradeGuideOnConflict = {
  constraint: TradeTradeGuideConstraint;
  updateColumns?: Array<TradeTradeGuideUpdateColumn>;
  where?: InputMaybe<TradeTradeGuideBoolExp>;
};

/** Ordering options when selecting data from "trade_trade_guide". */
export type TradeTradeGuideOrderBy = {
  trade?: InputMaybe<TradeOrderBy>;
  tradeGuide?: InputMaybe<TradeGuideOrderBy>;
  tradeGuideId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: trade_trade_guide */
export type TradeTradeGuidePkColumnsInput = {
  tradeGuideId: Scalars['Int'];
  tradeId: Scalars['Int'];
};

/** select columns of table "trade_trade_guide" */
export enum TradeTradeGuideSelectColumn {
  /** column name */
  TradeGuideId = 'tradeGuideId',
  /** column name */
  TradeId = 'tradeId'
}

/** input type for updating data in table "trade_trade_guide" */
export type TradeTradeGuideSetInput = {
  tradeGuideId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type TradeTradeGuideStddevFields = {
  __typename?: 'TradeTradeGuideStddevFields';
  tradeGuideId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_trade_guide" */
export type TradeTradeGuideStddevOrderBy = {
  tradeGuideId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type TradeTradeGuideStddevPopFields = {
  __typename?: 'TradeTradeGuideStddevPopFields';
  tradeGuideId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "trade_trade_guide" */
export type TradeTradeGuideStddevPopOrderBy = {
  tradeGuideId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type TradeTradeGuideStddevSampFields = {
  __typename?: 'TradeTradeGuideStddevSampFields';
  tradeGuideId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "trade_trade_guide" */
export type TradeTradeGuideStddevSampOrderBy = {
  tradeGuideId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "trade_trade_guide" */
export type TradeTradeGuideStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TradeTradeGuideStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TradeTradeGuideStreamCursorValueInput = {
  tradeGuideId?: InputMaybe<Scalars['Int']>;
  tradeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TradeTradeGuideSumFields = {
  __typename?: 'TradeTradeGuideSumFields';
  tradeGuideId?: Maybe<Scalars['Int']>;
  tradeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trade_trade_guide" */
export type TradeTradeGuideSumOrderBy = {
  tradeGuideId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** update columns of table "trade_trade_guide" */
export enum TradeTradeGuideUpdateColumn {
  /** column name */
  TradeGuideId = 'tradeGuideId',
  /** column name */
  TradeId = 'tradeId'
}

export type TradeTradeGuideUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TradeTradeGuideIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TradeTradeGuideSetInput>;
  /** filter the rows which have to be updated */
  where: TradeTradeGuideBoolExp;
};

/** aggregate varPop on columns */
export type TradeTradeGuideVarPopFields = {
  __typename?: 'TradeTradeGuideVarPopFields';
  tradeGuideId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "trade_trade_guide" */
export type TradeTradeGuideVarPopOrderBy = {
  tradeGuideId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type TradeTradeGuideVarSampFields = {
  __typename?: 'TradeTradeGuideVarSampFields';
  tradeGuideId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "trade_trade_guide" */
export type TradeTradeGuideVarSampOrderBy = {
  tradeGuideId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TradeTradeGuideVarianceFields = {
  __typename?: 'TradeTradeGuideVarianceFields';
  tradeGuideId?: Maybe<Scalars['Float']>;
  tradeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_trade_guide" */
export type TradeTradeGuideVarianceOrderBy = {
  tradeGuideId?: InputMaybe<OrderBy>;
  tradeId?: InputMaybe<OrderBy>;
};

/** update columns of table "trade" */
export enum TradeUpdateColumn {
  /** column name */
  Anchor = 'anchor',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymised = 'isAnonymised',
  /** column name */
  IsCallRecordable = 'isCallRecordable',
  /** column name */
  IsRgeFilterable = 'isRgeFilterable',
  /** column name */
  Label = 'label',
  /** column name */
  MetaDescription = 'metaDescription',
  /** column name */
  MetaTitle = 'metaTitle',
  /** column name */
  Name = 'name',
  /** column name */
  PageSubtitle = 'pageSubtitle',
  /** column name */
  PageTitle = 'pageTitle',
  /** column name */
  PageTitleDirectory = 'pageTitleDirectory',
  /** column name */
  PageTitleVariant = 'pageTitleVariant',
  /** column name */
  SchemaAdditionalType = 'schemaAdditionalType',
  /** column name */
  SchemaType = 'schemaType',
  /** column name */
  Slug = 'slug'
}

export type TradeUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TradeIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TradeSetInput>;
  /** filter the rows which have to be updated */
  where: TradeBoolExp;
};

/** aggregate varPop on columns */
export type TradeVarPopFields = {
  __typename?: 'TradeVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type TradeVarSampFields = {
  __typename?: 'TradeVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TradeVarianceFields = {
  __typename?: 'TradeVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "utm_record" */
export type UtmRecord = {
  __typename?: 'UtmRecord';
  campaign: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  medium: Scalars['String'];
  source: Scalars['String'];
  term?: Maybe<Scalars['String']>;
};

/** aggregated selection of "utm_record" */
export type UtmRecordAggregate = {
  __typename?: 'UtmRecordAggregate';
  aggregate?: Maybe<UtmRecordAggregateFields>;
  nodes: Array<UtmRecord>;
};

/** aggregate fields of "utm_record" */
export type UtmRecordAggregateFields = {
  __typename?: 'UtmRecordAggregateFields';
  avg?: Maybe<UtmRecordAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UtmRecordMaxFields>;
  min?: Maybe<UtmRecordMinFields>;
  stddev?: Maybe<UtmRecordStddevFields>;
  stddevPop?: Maybe<UtmRecordStddevPopFields>;
  stddevSamp?: Maybe<UtmRecordStddevSampFields>;
  sum?: Maybe<UtmRecordSumFields>;
  varPop?: Maybe<UtmRecordVarPopFields>;
  varSamp?: Maybe<UtmRecordVarSampFields>;
  variance?: Maybe<UtmRecordVarianceFields>;
};


/** aggregate fields of "utm_record" */
export type UtmRecordAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UtmRecordSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UtmRecordAvgFields = {
  __typename?: 'UtmRecordAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "utm_record". All fields are combined with a logical 'AND'. */
export type UtmRecordBoolExp = {
  _and?: InputMaybe<Array<UtmRecordBoolExp>>;
  _not?: InputMaybe<UtmRecordBoolExp>;
  _or?: InputMaybe<Array<UtmRecordBoolExp>>;
  campaign?: InputMaybe<StringComparisonExp>;
  content?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  medium?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  term?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "utm_record" */
export enum UtmRecordConstraint {
  /** unique or primary key constraint on columns "id" */
  UtmRecordPkey = 'utm_record_pkey',
  /** unique or primary key constraint on columns "term", "content", "medium", "campaign", "source" */
  UtmRecordUniqueConstraint = 'utm_record_unique_constraint'
}

/** input type for incrementing numeric columns in table "utm_record" */
export type UtmRecordIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "utm_record" */
export type UtmRecordInsertInput = {
  campaign?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  medium?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UtmRecordMaxFields = {
  __typename?: 'UtmRecordMaxFields';
  campaign?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  medium?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UtmRecordMinFields = {
  __typename?: 'UtmRecordMinFields';
  campaign?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  medium?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "utm_record" */
export type UtmRecordMutationResponse = {
  __typename?: 'UtmRecordMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UtmRecord>;
};

/** input type for inserting object relation for remote table "utm_record" */
export type UtmRecordObjRelInsertInput = {
  data: UtmRecordInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UtmRecordOnConflict>;
};

/** on_conflict condition type for table "utm_record" */
export type UtmRecordOnConflict = {
  constraint: UtmRecordConstraint;
  updateColumns?: Array<UtmRecordUpdateColumn>;
  where?: InputMaybe<UtmRecordBoolExp>;
};

/** Ordering options when selecting data from "utm_record". */
export type UtmRecordOrderBy = {
  campaign?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  medium?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  term?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: utm_record */
export type UtmRecordPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "utm_record" */
export enum UtmRecordSelectColumn {
  /** column name */
  Campaign = 'campaign',
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  Medium = 'medium',
  /** column name */
  Source = 'source',
  /** column name */
  Term = 'term'
}

/** input type for updating data in table "utm_record" */
export type UtmRecordSetInput = {
  campaign?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  medium?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UtmRecordStddevFields = {
  __typename?: 'UtmRecordStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type UtmRecordStddevPopFields = {
  __typename?: 'UtmRecordStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type UtmRecordStddevSampFields = {
  __typename?: 'UtmRecordStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "utm_record" */
export type UtmRecordStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UtmRecordStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UtmRecordStreamCursorValueInput = {
  campaign?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  medium?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UtmRecordSumFields = {
  __typename?: 'UtmRecordSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "utm_record" */
export enum UtmRecordUpdateColumn {
  /** column name */
  Campaign = 'campaign',
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  Medium = 'medium',
  /** column name */
  Source = 'source',
  /** column name */
  Term = 'term'
}

export type UtmRecordUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UtmRecordIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UtmRecordSetInput>;
  /** filter the rows which have to be updated */
  where: UtmRecordBoolExp;
};

/** aggregate varPop on columns */
export type UtmRecordVarPopFields = {
  __typename?: 'UtmRecordVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type UtmRecordVarSampFields = {
  __typename?: 'UtmRecordVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UtmRecordVarianceFields = {
  __typename?: 'UtmRecordVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "view_active_holiday" */
export type ViewActiveHoliday = {
  __typename?: 'ViewActiveHoliday';
  endDate?: Maybe<Scalars['date']>;
  holidayId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['date']>;
  /** An object relationship */
  view?: Maybe<ProView>;
  viewId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "view_active_holiday" */
export type ViewActiveHolidayAggregate = {
  __typename?: 'ViewActiveHolidayAggregate';
  aggregate?: Maybe<ViewActiveHolidayAggregateFields>;
  nodes: Array<ViewActiveHoliday>;
};

/** aggregate fields of "view_active_holiday" */
export type ViewActiveHolidayAggregateFields = {
  __typename?: 'ViewActiveHolidayAggregateFields';
  avg?: Maybe<ViewActiveHolidayAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ViewActiveHolidayMaxFields>;
  min?: Maybe<ViewActiveHolidayMinFields>;
  stddev?: Maybe<ViewActiveHolidayStddevFields>;
  stddevPop?: Maybe<ViewActiveHolidayStddevPopFields>;
  stddevSamp?: Maybe<ViewActiveHolidayStddevSampFields>;
  sum?: Maybe<ViewActiveHolidaySumFields>;
  varPop?: Maybe<ViewActiveHolidayVarPopFields>;
  varSamp?: Maybe<ViewActiveHolidayVarSampFields>;
  variance?: Maybe<ViewActiveHolidayVarianceFields>;
};


/** aggregate fields of "view_active_holiday" */
export type ViewActiveHolidayAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ViewActiveHolidaySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ViewActiveHolidayAvgFields = {
  __typename?: 'ViewActiveHolidayAvgFields';
  holidayId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "view_active_holiday". All fields are combined with a logical 'AND'. */
export type ViewActiveHolidayBoolExp = {
  _and?: InputMaybe<Array<ViewActiveHolidayBoolExp>>;
  _not?: InputMaybe<ViewActiveHolidayBoolExp>;
  _or?: InputMaybe<Array<ViewActiveHolidayBoolExp>>;
  endDate?: InputMaybe<DateComparisonExp>;
  holidayId?: InputMaybe<IntComparisonExp>;
  startDate?: InputMaybe<DateComparisonExp>;
  view?: InputMaybe<ProViewBoolExp>;
  viewId?: InputMaybe<IntComparisonExp>;
};

/** input type for inserting data into table "view_active_holiday" */
export type ViewActiveHolidayInsertInput = {
  endDate?: InputMaybe<Scalars['date']>;
  holidayId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['date']>;
  view?: InputMaybe<ProViewObjRelInsertInput>;
  viewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ViewActiveHolidayMaxFields = {
  __typename?: 'ViewActiveHolidayMaxFields';
  endDate?: Maybe<Scalars['date']>;
  holidayId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['date']>;
  viewId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ViewActiveHolidayMinFields = {
  __typename?: 'ViewActiveHolidayMinFields';
  endDate?: Maybe<Scalars['date']>;
  holidayId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['date']>;
  viewId?: Maybe<Scalars['Int']>;
};

/** input type for inserting object relation for remote table "view_active_holiday" */
export type ViewActiveHolidayObjRelInsertInput = {
  data: ViewActiveHolidayInsertInput;
};

/** Ordering options when selecting data from "view_active_holiday". */
export type ViewActiveHolidayOrderBy = {
  endDate?: InputMaybe<OrderBy>;
  holidayId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  view?: InputMaybe<ProViewOrderBy>;
  viewId?: InputMaybe<OrderBy>;
};

/** select columns of table "view_active_holiday" */
export enum ViewActiveHolidaySelectColumn {
  /** column name */
  EndDate = 'endDate',
  /** column name */
  HolidayId = 'holidayId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  ViewId = 'viewId'
}

/** aggregate stddev on columns */
export type ViewActiveHolidayStddevFields = {
  __typename?: 'ViewActiveHolidayStddevFields';
  holidayId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type ViewActiveHolidayStddevPopFields = {
  __typename?: 'ViewActiveHolidayStddevPopFields';
  holidayId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type ViewActiveHolidayStddevSampFields = {
  __typename?: 'ViewActiveHolidayStddevSampFields';
  holidayId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "view_active_holiday" */
export type ViewActiveHolidayStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ViewActiveHolidayStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ViewActiveHolidayStreamCursorValueInput = {
  endDate?: InputMaybe<Scalars['date']>;
  holidayId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['date']>;
  viewId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ViewActiveHolidaySumFields = {
  __typename?: 'ViewActiveHolidaySumFields';
  holidayId?: Maybe<Scalars['Int']>;
  viewId?: Maybe<Scalars['Int']>;
};

/** aggregate varPop on columns */
export type ViewActiveHolidayVarPopFields = {
  __typename?: 'ViewActiveHolidayVarPopFields';
  holidayId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type ViewActiveHolidayVarSampFields = {
  __typename?: 'ViewActiveHolidayVarSampFields';
  holidayId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ViewActiveHolidayVarianceFields = {
  __typename?: 'ViewActiveHolidayVarianceFields';
  holidayId?: Maybe<Scalars['Float']>;
  viewId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "zoho_consumer" */
export type ZohoConsumer = {
  __typename?: 'ZohoConsumer';
  /** An object relationship */
  company: Company;
  companyId: Scalars['Int'];
  consumerId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object relationship */
  zohoOrganization: ZohoOrganization;
  zohoOrganizationId: Scalars['Int'];
};

/** aggregated selection of "zoho_consumer" */
export type ZohoConsumerAggregate = {
  __typename?: 'ZohoConsumerAggregate';
  aggregate?: Maybe<ZohoConsumerAggregateFields>;
  nodes: Array<ZohoConsumer>;
};

export type ZohoConsumerAggregateBoolExp = {
  count?: InputMaybe<ZohoConsumerAggregateBoolExpCount>;
};

/** aggregate fields of "zoho_consumer" */
export type ZohoConsumerAggregateFields = {
  __typename?: 'ZohoConsumerAggregateFields';
  avg?: Maybe<ZohoConsumerAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ZohoConsumerMaxFields>;
  min?: Maybe<ZohoConsumerMinFields>;
  stddev?: Maybe<ZohoConsumerStddevFields>;
  stddevPop?: Maybe<ZohoConsumerStddevPopFields>;
  stddevSamp?: Maybe<ZohoConsumerStddevSampFields>;
  sum?: Maybe<ZohoConsumerSumFields>;
  varPop?: Maybe<ZohoConsumerVarPopFields>;
  varSamp?: Maybe<ZohoConsumerVarSampFields>;
  variance?: Maybe<ZohoConsumerVarianceFields>;
};


/** aggregate fields of "zoho_consumer" */
export type ZohoConsumerAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ZohoConsumerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "zoho_consumer" */
export type ZohoConsumerAggregateOrderBy = {
  avg?: InputMaybe<ZohoConsumerAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ZohoConsumerMaxOrderBy>;
  min?: InputMaybe<ZohoConsumerMinOrderBy>;
  stddev?: InputMaybe<ZohoConsumerStddevOrderBy>;
  stddevPop?: InputMaybe<ZohoConsumerStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ZohoConsumerStddevSampOrderBy>;
  sum?: InputMaybe<ZohoConsumerSumOrderBy>;
  varPop?: InputMaybe<ZohoConsumerVarPopOrderBy>;
  varSamp?: InputMaybe<ZohoConsumerVarSampOrderBy>;
  variance?: InputMaybe<ZohoConsumerVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "zoho_consumer" */
export type ZohoConsumerArrRelInsertInput = {
  data: Array<ZohoConsumerInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ZohoConsumerOnConflict>;
};

/** aggregate avg on columns */
export type ZohoConsumerAvgFields = {
  __typename?: 'ZohoConsumerAvgFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "zoho_consumer" */
export type ZohoConsumerAvgOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "zoho_consumer". All fields are combined with a logical 'AND'. */
export type ZohoConsumerBoolExp = {
  _and?: InputMaybe<Array<ZohoConsumerBoolExp>>;
  _not?: InputMaybe<ZohoConsumerBoolExp>;
  _or?: InputMaybe<Array<ZohoConsumerBoolExp>>;
  company?: InputMaybe<CompanyBoolExp>;
  companyId?: InputMaybe<IntComparisonExp>;
  consumerId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  zohoOrganization?: InputMaybe<ZohoOrganizationBoolExp>;
  zohoOrganizationId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "zoho_consumer" */
export enum ZohoConsumerConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_23101Primary = 'idx_23101_primary'
}

/** input type for incrementing numeric columns in table "zoho_consumer" */
export type ZohoConsumerIncInput = {
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  zohoOrganizationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "zoho_consumer" */
export type ZohoConsumerInsertInput = {
  company?: InputMaybe<CompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['Int']>;
  consumerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  zohoOrganization?: InputMaybe<ZohoOrganizationObjRelInsertInput>;
  zohoOrganizationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ZohoConsumerMaxFields = {
  __typename?: 'ZohoConsumerMaxFields';
  companyId?: Maybe<Scalars['Int']>;
  consumerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  zohoOrganizationId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "zoho_consumer" */
export type ZohoConsumerMaxOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  consumerId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ZohoConsumerMinFields = {
  __typename?: 'ZohoConsumerMinFields';
  companyId?: Maybe<Scalars['Int']>;
  consumerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  zohoOrganizationId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "zoho_consumer" */
export type ZohoConsumerMinOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  consumerId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "zoho_consumer" */
export type ZohoConsumerMutationResponse = {
  __typename?: 'ZohoConsumerMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ZohoConsumer>;
};

/** on_conflict condition type for table "zoho_consumer" */
export type ZohoConsumerOnConflict = {
  constraint: ZohoConsumerConstraint;
  updateColumns?: Array<ZohoConsumerUpdateColumn>;
  where?: InputMaybe<ZohoConsumerBoolExp>;
};

/** Ordering options when selecting data from "zoho_consumer". */
export type ZohoConsumerOrderBy = {
  company?: InputMaybe<CompanyOrderBy>;
  companyId?: InputMaybe<OrderBy>;
  consumerId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganization?: InputMaybe<ZohoOrganizationOrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: zoho_consumer */
export type ZohoConsumerPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "zoho_consumer" */
export enum ZohoConsumerSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  ConsumerId = 'consumerId',
  /** column name */
  Id = 'id',
  /** column name */
  ZohoOrganizationId = 'zohoOrganizationId'
}

/** input type for updating data in table "zoho_consumer" */
export type ZohoConsumerSetInput = {
  companyId?: InputMaybe<Scalars['Int']>;
  consumerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  zohoOrganizationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ZohoConsumerStddevFields = {
  __typename?: 'ZohoConsumerStddevFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "zoho_consumer" */
export type ZohoConsumerStddevOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ZohoConsumerStddevPopFields = {
  __typename?: 'ZohoConsumerStddevPopFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "zoho_consumer" */
export type ZohoConsumerStddevPopOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ZohoConsumerStddevSampFields = {
  __typename?: 'ZohoConsumerStddevSampFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "zoho_consumer" */
export type ZohoConsumerStddevSampOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "zoho_consumer" */
export type ZohoConsumerStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ZohoConsumerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ZohoConsumerStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['Int']>;
  consumerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  zohoOrganizationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ZohoConsumerSumFields = {
  __typename?: 'ZohoConsumerSumFields';
  companyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  zohoOrganizationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "zoho_consumer" */
export type ZohoConsumerSumOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** update columns of table "zoho_consumer" */
export enum ZohoConsumerUpdateColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  ConsumerId = 'consumerId',
  /** column name */
  Id = 'id',
  /** column name */
  ZohoOrganizationId = 'zohoOrganizationId'
}

export type ZohoConsumerUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ZohoConsumerIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ZohoConsumerSetInput>;
  /** filter the rows which have to be updated */
  where: ZohoConsumerBoolExp;
};

/** aggregate varPop on columns */
export type ZohoConsumerVarPopFields = {
  __typename?: 'ZohoConsumerVarPopFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "zoho_consumer" */
export type ZohoConsumerVarPopOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ZohoConsumerVarSampFields = {
  __typename?: 'ZohoConsumerVarSampFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "zoho_consumer" */
export type ZohoConsumerVarSampOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ZohoConsumerVarianceFields = {
  __typename?: 'ZohoConsumerVarianceFields';
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  zohoOrganizationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "zoho_consumer" */
export type ZohoConsumerVarianceOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  zohoOrganizationId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "zoho_organization" */
export type ZohoOrganization = {
  __typename?: 'ZohoOrganization';
  address?: Maybe<Scalars['String']>;
  bankId: Scalars['String'];
  bic?: Maybe<Scalars['String']>;
  /** An array relationship */
  bilikZones: Array<BilikZone>;
  /** An aggregate relationship */
  bilikZonesAggregate: BilikZoneAggregate;
  businessStatus: Scalars['String'];
  iban?: Maybe<Scalars['String']>;
  ics?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  legalRepresentative?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  rcs: Scalars['String'];
  shareCapital?: Maybe<Scalars['String']>;
  tvaTaxId: Scalars['String'];
  /** An array relationship */
  zohoConsumers: Array<ZohoConsumer>;
  /** An aggregate relationship */
  zohoConsumersAggregate: ZohoConsumerAggregate;
};


/** columns and relationships of "zoho_organization" */
export type ZohoOrganizationBilikZonesArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneOrderBy>>;
  where?: InputMaybe<BilikZoneBoolExp>;
};


/** columns and relationships of "zoho_organization" */
export type ZohoOrganizationBilikZonesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneOrderBy>>;
  where?: InputMaybe<BilikZoneBoolExp>;
};


/** columns and relationships of "zoho_organization" */
export type ZohoOrganizationZohoConsumersArgs = {
  distinctOn?: InputMaybe<Array<ZohoConsumerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoConsumerOrderBy>>;
  where?: InputMaybe<ZohoConsumerBoolExp>;
};


/** columns and relationships of "zoho_organization" */
export type ZohoOrganizationZohoConsumersAggregateArgs = {
  distinctOn?: InputMaybe<Array<ZohoConsumerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoConsumerOrderBy>>;
  where?: InputMaybe<ZohoConsumerBoolExp>;
};

/** aggregated selection of "zoho_organization" */
export type ZohoOrganizationAggregate = {
  __typename?: 'ZohoOrganizationAggregate';
  aggregate?: Maybe<ZohoOrganizationAggregateFields>;
  nodes: Array<ZohoOrganization>;
};

/** aggregate fields of "zoho_organization" */
export type ZohoOrganizationAggregateFields = {
  __typename?: 'ZohoOrganizationAggregateFields';
  avg?: Maybe<ZohoOrganizationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ZohoOrganizationMaxFields>;
  min?: Maybe<ZohoOrganizationMinFields>;
  stddev?: Maybe<ZohoOrganizationStddevFields>;
  stddevPop?: Maybe<ZohoOrganizationStddevPopFields>;
  stddevSamp?: Maybe<ZohoOrganizationStddevSampFields>;
  sum?: Maybe<ZohoOrganizationSumFields>;
  varPop?: Maybe<ZohoOrganizationVarPopFields>;
  varSamp?: Maybe<ZohoOrganizationVarSampFields>;
  variance?: Maybe<ZohoOrganizationVarianceFields>;
};


/** aggregate fields of "zoho_organization" */
export type ZohoOrganizationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ZohoOrganizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ZohoOrganizationAvgFields = {
  __typename?: 'ZohoOrganizationAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "zoho_organization". All fields are combined with a logical 'AND'. */
export type ZohoOrganizationBoolExp = {
  _and?: InputMaybe<Array<ZohoOrganizationBoolExp>>;
  _not?: InputMaybe<ZohoOrganizationBoolExp>;
  _or?: InputMaybe<Array<ZohoOrganizationBoolExp>>;
  address?: InputMaybe<StringComparisonExp>;
  bankId?: InputMaybe<StringComparisonExp>;
  bic?: InputMaybe<StringComparisonExp>;
  bilikZones?: InputMaybe<BilikZoneBoolExp>;
  bilikZonesAggregate?: InputMaybe<BilikZoneAggregateBoolExp>;
  businessStatus?: InputMaybe<StringComparisonExp>;
  iban?: InputMaybe<StringComparisonExp>;
  ics?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  legalRepresentative?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organizationId?: InputMaybe<StringComparisonExp>;
  rcs?: InputMaybe<StringComparisonExp>;
  shareCapital?: InputMaybe<StringComparisonExp>;
  tvaTaxId?: InputMaybe<StringComparisonExp>;
  zohoConsumers?: InputMaybe<ZohoConsumerBoolExp>;
  zohoConsumersAggregate?: InputMaybe<ZohoConsumerAggregateBoolExp>;
};

/** unique or primary key constraints on table "zoho_organization" */
export enum ZohoOrganizationConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_23107Primary = 'idx_23107_primary'
}

/** input type for incrementing numeric columns in table "zoho_organization" */
export type ZohoOrganizationIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "zoho_organization" */
export type ZohoOrganizationInsertInput = {
  address?: InputMaybe<Scalars['String']>;
  bankId?: InputMaybe<Scalars['String']>;
  bic?: InputMaybe<Scalars['String']>;
  bilikZones?: InputMaybe<BilikZoneArrRelInsertInput>;
  businessStatus?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  ics?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  legalRepresentative?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  rcs?: InputMaybe<Scalars['String']>;
  shareCapital?: InputMaybe<Scalars['String']>;
  tvaTaxId?: InputMaybe<Scalars['String']>;
  zohoConsumers?: InputMaybe<ZohoConsumerArrRelInsertInput>;
};

/** aggregate max on columns */
export type ZohoOrganizationMaxFields = {
  __typename?: 'ZohoOrganizationMaxFields';
  address?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  businessStatus?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  ics?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  legalRepresentative?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  rcs?: Maybe<Scalars['String']>;
  shareCapital?: Maybe<Scalars['String']>;
  tvaTaxId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ZohoOrganizationMinFields = {
  __typename?: 'ZohoOrganizationMinFields';
  address?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  businessStatus?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  ics?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  legalRepresentative?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  rcs?: Maybe<Scalars['String']>;
  shareCapital?: Maybe<Scalars['String']>;
  tvaTaxId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "zoho_organization" */
export type ZohoOrganizationMutationResponse = {
  __typename?: 'ZohoOrganizationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ZohoOrganization>;
};

/** input type for inserting object relation for remote table "zoho_organization" */
export type ZohoOrganizationObjRelInsertInput = {
  data: ZohoOrganizationInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ZohoOrganizationOnConflict>;
};

/** on_conflict condition type for table "zoho_organization" */
export type ZohoOrganizationOnConflict = {
  constraint: ZohoOrganizationConstraint;
  updateColumns?: Array<ZohoOrganizationUpdateColumn>;
  where?: InputMaybe<ZohoOrganizationBoolExp>;
};

/** Ordering options when selecting data from "zoho_organization". */
export type ZohoOrganizationOrderBy = {
  address?: InputMaybe<OrderBy>;
  bankId?: InputMaybe<OrderBy>;
  bic?: InputMaybe<OrderBy>;
  bilikZonesAggregate?: InputMaybe<BilikZoneAggregateOrderBy>;
  businessStatus?: InputMaybe<OrderBy>;
  iban?: InputMaybe<OrderBy>;
  ics?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  legalRepresentative?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  rcs?: InputMaybe<OrderBy>;
  shareCapital?: InputMaybe<OrderBy>;
  tvaTaxId?: InputMaybe<OrderBy>;
  zohoConsumersAggregate?: InputMaybe<ZohoConsumerAggregateOrderBy>;
};

/** primary key columns input for table: zoho_organization */
export type ZohoOrganizationPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "zoho_organization" */
export enum ZohoOrganizationSelectColumn {
  /** column name */
  Address = 'address',
  /** column name */
  BankId = 'bankId',
  /** column name */
  Bic = 'bic',
  /** column name */
  BusinessStatus = 'businessStatus',
  /** column name */
  Iban = 'iban',
  /** column name */
  Ics = 'ics',
  /** column name */
  Id = 'id',
  /** column name */
  LegalRepresentative = 'legalRepresentative',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Rcs = 'rcs',
  /** column name */
  ShareCapital = 'shareCapital',
  /** column name */
  TvaTaxId = 'tvaTaxId'
}

/** input type for updating data in table "zoho_organization" */
export type ZohoOrganizationSetInput = {
  address?: InputMaybe<Scalars['String']>;
  bankId?: InputMaybe<Scalars['String']>;
  bic?: InputMaybe<Scalars['String']>;
  businessStatus?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  ics?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  legalRepresentative?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  rcs?: InputMaybe<Scalars['String']>;
  shareCapital?: InputMaybe<Scalars['String']>;
  tvaTaxId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ZohoOrganizationStddevFields = {
  __typename?: 'ZohoOrganizationStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type ZohoOrganizationStddevPopFields = {
  __typename?: 'ZohoOrganizationStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type ZohoOrganizationStddevSampFields = {
  __typename?: 'ZohoOrganizationStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "zoho_organization" */
export type ZohoOrganizationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ZohoOrganizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ZohoOrganizationStreamCursorValueInput = {
  address?: InputMaybe<Scalars['String']>;
  bankId?: InputMaybe<Scalars['String']>;
  bic?: InputMaybe<Scalars['String']>;
  businessStatus?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  ics?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  legalRepresentative?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  rcs?: InputMaybe<Scalars['String']>;
  shareCapital?: InputMaybe<Scalars['String']>;
  tvaTaxId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ZohoOrganizationSumFields = {
  __typename?: 'ZohoOrganizationSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "zoho_organization" */
export enum ZohoOrganizationUpdateColumn {
  /** column name */
  Address = 'address',
  /** column name */
  BankId = 'bankId',
  /** column name */
  Bic = 'bic',
  /** column name */
  BusinessStatus = 'businessStatus',
  /** column name */
  Iban = 'iban',
  /** column name */
  Ics = 'ics',
  /** column name */
  Id = 'id',
  /** column name */
  LegalRepresentative = 'legalRepresentative',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Rcs = 'rcs',
  /** column name */
  ShareCapital = 'shareCapital',
  /** column name */
  TvaTaxId = 'tvaTaxId'
}

export type ZohoOrganizationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ZohoOrganizationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ZohoOrganizationSetInput>;
  /** filter the rows which have to be updated */
  where: ZohoOrganizationBoolExp;
};

/** aggregate varPop on columns */
export type ZohoOrganizationVarPopFields = {
  __typename?: 'ZohoOrganizationVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type ZohoOrganizationVarSampFields = {
  __typename?: 'ZohoOrganizationVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ZohoOrganizationVarianceFields = {
  __typename?: 'ZohoOrganizationVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "zoho_token" */
export type ZohoToken = {
  __typename?: 'ZohoToken';
  accessToken?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  refreshToken?: Maybe<Scalars['String']>;
};

/** aggregated selection of "zoho_token" */
export type ZohoTokenAggregate = {
  __typename?: 'ZohoTokenAggregate';
  aggregate?: Maybe<ZohoTokenAggregateFields>;
  nodes: Array<ZohoToken>;
};

/** aggregate fields of "zoho_token" */
export type ZohoTokenAggregateFields = {
  __typename?: 'ZohoTokenAggregateFields';
  avg?: Maybe<ZohoTokenAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ZohoTokenMaxFields>;
  min?: Maybe<ZohoTokenMinFields>;
  stddev?: Maybe<ZohoTokenStddevFields>;
  stddevPop?: Maybe<ZohoTokenStddevPopFields>;
  stddevSamp?: Maybe<ZohoTokenStddevSampFields>;
  sum?: Maybe<ZohoTokenSumFields>;
  varPop?: Maybe<ZohoTokenVarPopFields>;
  varSamp?: Maybe<ZohoTokenVarSampFields>;
  variance?: Maybe<ZohoTokenVarianceFields>;
};


/** aggregate fields of "zoho_token" */
export type ZohoTokenAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ZohoTokenSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ZohoTokenAvgFields = {
  __typename?: 'ZohoTokenAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "zoho_token". All fields are combined with a logical 'AND'. */
export type ZohoTokenBoolExp = {
  _and?: InputMaybe<Array<ZohoTokenBoolExp>>;
  _not?: InputMaybe<ZohoTokenBoolExp>;
  _or?: InputMaybe<Array<ZohoTokenBoolExp>>;
  accessToken?: InputMaybe<StringComparisonExp>;
  clientId?: InputMaybe<StringComparisonExp>;
  clientSecret?: InputMaybe<StringComparisonExp>;
  expirationDate?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  refreshToken?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "zoho_token" */
export enum ZohoTokenConstraint {
  /** unique or primary key constraint on columns "id" */
  Idx_23116Primary = 'idx_23116_primary'
}

/** input type for incrementing numeric columns in table "zoho_token" */
export type ZohoTokenIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "zoho_token" */
export type ZohoTokenInsertInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  refreshToken?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ZohoTokenMaxFields = {
  __typename?: 'ZohoTokenMaxFields';
  accessToken?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  refreshToken?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ZohoTokenMinFields = {
  __typename?: 'ZohoTokenMinFields';
  accessToken?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  refreshToken?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "zoho_token" */
export type ZohoTokenMutationResponse = {
  __typename?: 'ZohoTokenMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ZohoToken>;
};

/** on_conflict condition type for table "zoho_token" */
export type ZohoTokenOnConflict = {
  constraint: ZohoTokenConstraint;
  updateColumns?: Array<ZohoTokenUpdateColumn>;
  where?: InputMaybe<ZohoTokenBoolExp>;
};

/** Ordering options when selecting data from "zoho_token". */
export type ZohoTokenOrderBy = {
  accessToken?: InputMaybe<OrderBy>;
  clientId?: InputMaybe<OrderBy>;
  clientSecret?: InputMaybe<OrderBy>;
  expirationDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  refreshToken?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: zoho_token */
export type ZohoTokenPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "zoho_token" */
export enum ZohoTokenSelectColumn {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  ClientSecret = 'clientSecret',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  RefreshToken = 'refreshToken'
}

/** input type for updating data in table "zoho_token" */
export type ZohoTokenSetInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  refreshToken?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ZohoTokenStddevFields = {
  __typename?: 'ZohoTokenStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type ZohoTokenStddevPopFields = {
  __typename?: 'ZohoTokenStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type ZohoTokenStddevSampFields = {
  __typename?: 'ZohoTokenStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "zoho_token" */
export type ZohoTokenStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ZohoTokenStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ZohoTokenStreamCursorValueInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  refreshToken?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ZohoTokenSumFields = {
  __typename?: 'ZohoTokenSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "zoho_token" */
export enum ZohoTokenUpdateColumn {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  ClientSecret = 'clientSecret',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  RefreshToken = 'refreshToken'
}

export type ZohoTokenUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ZohoTokenIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ZohoTokenSetInput>;
  /** filter the rows which have to be updated */
  where: ZohoTokenBoolExp;
};

/** aggregate varPop on columns */
export type ZohoTokenVarPopFields = {
  __typename?: 'ZohoTokenVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type ZohoTokenVarSampFields = {
  __typename?: 'ZohoTokenVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ZohoTokenVarianceFields = {
  __typename?: 'ZohoTokenVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

export type AccountProViewAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AccountProViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountProViewBoolExp>;
  predicate: IntComparisonExp;
};

export type AutorespondAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AutorespondSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AutorespondBoolExp>;
  predicate: IntComparisonExp;
};

export type BilikSolicitationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BilikSolicitationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BilikSolicitationBoolExp>;
  predicate: IntComparisonExp;
};

export type BilikZoneAggregateBoolExpBoolAnd = {
  arguments: BilikZoneSelectColumnBilikZoneAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BilikZoneBoolExp>;
  predicate: BooleanComparisonExp;
};

export type BilikZoneAggregateBoolExpBoolOr = {
  arguments: BilikZoneSelectColumnBilikZoneAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BilikZoneBoolExp>;
  predicate: BooleanComparisonExp;
};

export type BilikZoneAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BilikZoneSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BilikZoneBoolExp>;
  predicate: IntComparisonExp;
};

export type BilikZoneTradeMainProCountAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BilikZoneTradeMainProCountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
  predicate: IntComparisonExp;
};

export type CityAggregateBoolExpBoolAnd = {
  arguments: CitySelectColumnCityAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CityBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CityAggregateBoolExpBoolOr = {
  arguments: CitySelectColumnCityAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CityBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CityAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CityBoolExp>;
  predicate: IntComparisonExp;
};

export type CityProViewAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CityProViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CityProViewBoolExp>;
  predicate: IntComparisonExp;
};

export type DepartmentAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DepartmentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DepartmentBoolExp>;
  predicate: IntComparisonExp;
};

export type GoogleReviewLinkAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GoogleReviewLinkSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GoogleReviewLinkBoolExp>;
  predicate: IntComparisonExp;
};

export type ManagerBilikPersonBilikZoneAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ManagerBilikPersonBilikZoneSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
  predicate: IntComparisonExp;
};

export type MemberBilikPersonBilikZoneAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MemberBilikPersonBilikZoneSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
  predicate: IntComparisonExp;
};

/** mutation root */
export type MutationRoot = {
  __typename?: 'mutation_root';
  /** delete data from the table: "account_pro_view" */
  deleteAccountProView?: Maybe<AccountProViewMutationResponse>;
  /** delete single row from the table: "account_pro_view" */
  deleteAccountProViewByPk?: Maybe<AccountProView>;
  /** delete data from the table: "action_token" */
  deleteActionToken?: Maybe<ActionTokenMutationResponse>;
  /** delete single row from the table: "action_token" */
  deleteActionTokenByPk?: Maybe<ActionToken>;
  /** delete data from the table: "announcement" */
  deleteAnnouncement?: Maybe<AnnouncementMutationResponse>;
  /** delete single row from the table: "announcement" */
  deleteAnnouncementByPk?: Maybe<Announcement>;
  /** delete data from the table: "autorespond" */
  deleteAutorespond?: Maybe<AutorespondMutationResponse>;
  /** delete single row from the table: "autorespond" */
  deleteAutorespondByPk?: Maybe<Autorespond>;
  /** delete data from the table: "bilik_person" */
  deleteBilikPerson?: Maybe<BilikPersonMutationResponse>;
  /** delete single row from the table: "bilik_person" */
  deleteBilikPersonByPk?: Maybe<BilikPerson>;
  /** delete data from the table: "bilik_solicitation" */
  deleteBilikSolicitation?: Maybe<BilikSolicitationMutationResponse>;
  /** delete single row from the table: "bilik_solicitation" */
  deleteBilikSolicitationByPk?: Maybe<BilikSolicitation>;
  /** delete data from the table: "bilik_zone" */
  deleteBilikZone?: Maybe<BilikZoneMutationResponse>;
  /** delete single row from the table: "bilik_zone" */
  deleteBilikZoneByPk?: Maybe<BilikZone>;
  /** delete data from the table: "certification" */
  deleteCertification?: Maybe<CertificationMutationResponse>;
  /** delete single row from the table: "certification" */
  deleteCertificationByPk?: Maybe<Certification>;
  /** delete data from the table: "city" */
  deleteCity?: Maybe<CityMutationResponse>;
  /** delete single row from the table: "city" */
  deleteCityByPk?: Maybe<City>;
  /** delete data from the table: "city_pro_view" */
  deleteCityProView?: Maybe<CityProViewMutationResponse>;
  /** delete single row from the table: "city_pro_view" */
  deleteCityProViewByPk?: Maybe<CityProView>;
  /** delete data from the table: "company" */
  deleteCompany?: Maybe<CompanyMutationResponse>;
  /** delete single row from the table: "company" */
  deleteCompanyByPk?: Maybe<Company>;
  /** delete data from the table: "department" */
  deleteDepartment?: Maybe<DepartmentMutationResponse>;
  /** delete single row from the table: "department" */
  deleteDepartmentByPk?: Maybe<Department>;
  /** delete data from the table: "geometry_columns" */
  deleteGeometryColumns?: Maybe<GeometryColumnsMutationResponse>;
  /** delete data from the table: "globally_blocked_identity" */
  deleteGloballyBlockedIdentity?: Maybe<GloballyBlockedIdentityMutationResponse>;
  /** delete single row from the table: "globally_blocked_identity" */
  deleteGloballyBlockedIdentityByPk?: Maybe<GloballyBlockedIdentity>;
  /** delete data from the table: "google_review_link" */
  deleteGoogleReviewLink?: Maybe<GoogleReviewLinkMutationResponse>;
  /** delete single row from the table: "google_review_link" */
  deleteGoogleReviewLinkByPk?: Maybe<GoogleReviewLink>;
  /** delete data from the table: "manager_bilik_person_bilik_zone" */
  deleteManagerBilikPersonBilikZone?: Maybe<ManagerBilikPersonBilikZoneMutationResponse>;
  /** delete single row from the table: "manager_bilik_person_bilik_zone" */
  deleteManagerBilikPersonBilikZoneByPk?: Maybe<ManagerBilikPersonBilikZone>;
  /** delete data from the table: "member_bilik_person_bilik_zone" */
  deleteMemberBilikPersonBilikZone?: Maybe<MemberBilikPersonBilikZoneMutationResponse>;
  /** delete single row from the table: "member_bilik_person_bilik_zone" */
  deleteMemberBilikPersonBilikZoneByPk?: Maybe<MemberBilikPersonBilikZone>;
  /** delete data from the table: "nearest_pro_view" */
  deleteNearestProView?: Maybe<NearestProViewMutationResponse>;
  /** delete data from the table: "nextval" */
  deleteNextval?: Maybe<NextvalMutationResponse>;
  /** delete data from the table: "note_identity" */
  deleteNoteIdentity?: Maybe<NoteIdentityMutationResponse>;
  /** delete single row from the table: "note_identity" */
  deleteNoteIdentityByPk?: Maybe<NoteIdentity>;
  /** delete data from the table: "pennylane_company_mapping" */
  deletePennylaneCompanyMapping?: Maybe<PennylaneCompanyMappingMutationResponse>;
  /** delete single row from the table: "pennylane_company_mapping" */
  deletePennylaneCompanyMappingByPk?: Maybe<PennylaneCompanyMapping>;
  /** delete data from the table: "phone_number" */
  deletePhoneNumber?: Maybe<PhoneNumberMutationResponse>;
  /** delete single row from the table: "phone_number" */
  deletePhoneNumberByPk?: Maybe<PhoneNumber>;
  /** delete data from the table: "pro_certification" */
  deleteProCertification?: Maybe<ProCertificationMutationResponse>;
  /** delete single row from the table: "pro_certification" */
  deleteProCertificationByPk?: Maybe<ProCertification>;
  /** delete data from the table: "pro_holiday" */
  deleteProHoliday?: Maybe<ProHolidayMutationResponse>;
  /** delete single row from the table: "pro_holiday" */
  deleteProHolidayByPk?: Maybe<ProHoliday>;
  /** delete data from the table: "pro_label" */
  deleteProLabel?: Maybe<ProLabelMutationResponse>;
  /** delete single row from the table: "pro_label" */
  deleteProLabelByPk?: Maybe<ProLabel>;
  /** delete data from the table: "pro_mandate" */
  deleteProMandate?: Maybe<ProMandateMutationResponse>;
  /** delete single row from the table: "pro_mandate" */
  deleteProMandateByPk?: Maybe<ProMandate>;
  /** delete data from the table: "pro_media_object" */
  deleteProMediaObject?: Maybe<ProMediaObjectMutationResponse>;
  /** delete single row from the table: "pro_media_object" */
  deleteProMediaObjectByPk?: Maybe<ProMediaObject>;
  /** delete data from the table: "pro_message" */
  deleteProMessage?: Maybe<ProMessageMutationResponse>;
  /** delete single row from the table: "pro_message" */
  deleteProMessageByPk?: Maybe<ProMessage>;
  /** delete data from the table: "pro_person" */
  deleteProPerson?: Maybe<ProPersonMutationResponse>;
  /** delete single row from the table: "pro_person" */
  deleteProPersonByPk?: Maybe<ProPerson>;
  /** delete data from the table: "pro_postal_address" */
  deleteProPostalAddress?: Maybe<ProPostalAddressMutationResponse>;
  /** delete single row from the table: "pro_postal_address" */
  deleteProPostalAddressByPk?: Maybe<ProPostalAddress>;
  /** delete data from the table: "pro_presentation" */
  deleteProPresentation?: Maybe<ProPresentationMutationResponse>;
  /** delete single row from the table: "pro_presentation" */
  deleteProPresentationByPk?: Maybe<ProPresentation>;
  /** delete data from the table: "pro_price" */
  deleteProPrice?: Maybe<ProPriceMutationResponse>;
  /** delete single row from the table: "pro_price" */
  deleteProPriceByPk?: Maybe<ProPrice>;
  /** delete data from the table: "pro_review" */
  deleteProReview?: Maybe<ProReviewMutationResponse>;
  /** delete single row from the table: "pro_review" */
  deleteProReviewByPk?: Maybe<ProReview>;
  /** delete data from the table: "pro_review_invitation" */
  deleteProReviewInvitation?: Maybe<ProReviewInvitationMutationResponse>;
  /** delete single row from the table: "pro_review_invitation" */
  deleteProReviewInvitationByPk?: Maybe<ProReviewInvitation>;
  /** delete data from the table: "pro_view" */
  deleteProView?: Maybe<ProViewMutationResponse>;
  /** delete single row from the table: "pro_view" */
  deleteProViewByPk?: Maybe<ProView>;
  /** delete data from the table: "pro_view_pro_person" */
  deleteProViewProPerson?: Maybe<ProViewProPersonMutationResponse>;
  /** delete single row from the table: "pro_view_pro_person" */
  deleteProViewProPersonByPk?: Maybe<ProViewProPerson>;
  /** delete data from the table: "pro_view_pro_view" */
  deleteProViewProView?: Maybe<ProViewProViewMutationResponse>;
  /** delete single row from the table: "pro_view_pro_view" */
  deleteProViewProViewByPk?: Maybe<ProViewProView>;
  /** delete data from the table: "queued_sms" */
  deleteQueuedSms?: Maybe<QueuedSmsMutationResponse>;
  /** delete single row from the table: "queued_sms" */
  deleteQueuedSmsByPk?: Maybe<QueuedSms>;
  /** delete data from the table: "region" */
  deleteRegion?: Maybe<RegionMutationResponse>;
  /** delete single row from the table: "region" */
  deleteRegionByPk?: Maybe<Region>;
  /** delete data from the table: "review_presentation" */
  deleteReviewPresentation?: Maybe<ReviewPresentationMutationResponse>;
  /** delete single row from the table: "review_presentation" */
  deleteReviewPresentationByPk?: Maybe<ReviewPresentation>;
  /** delete data from the table: "slug_redirect" */
  deleteSlugRedirect?: Maybe<SlugRedirectMutationResponse>;
  /** delete single row from the table: "slug_redirect" */
  deleteSlugRedirectByPk?: Maybe<SlugRedirect>;
  /** delete data from the table: "solicitation" */
  deleteSolicitation?: Maybe<SolicitationMutationResponse>;
  /** delete single row from the table: "solicitation" */
  deleteSolicitationByPk?: Maybe<Solicitation>;
  /** delete data from the table: "solicitation_stat" */
  deleteSolicitationStat?: Maybe<SolicitationStatMutationResponse>;
  /** delete data from the table: "spatial_ref_sys" */
  deleteSpatialRefSys?: Maybe<SpatialRefSysMutationResponse>;
  /** delete single row from the table: "spatial_ref_sys" */
  deleteSpatialRefSysByPk?: Maybe<SpatialRefSys>;
  /** delete data from the table: "stop_sms" */
  deleteStopSms?: Maybe<StopSmsMutationResponse>;
  /** delete single row from the table: "stop_sms" */
  deleteStopSmsByPk?: Maybe<StopSms>;
  /** delete data from the table: "subscription" */
  deleteSubscription?: Maybe<SubscriptionMutationResponse>;
  /** delete single row from the table: "subscription" */
  deleteSubscriptionByPk?: Maybe<Subscription>;
  /** delete data from the table: "topology.layer" */
  deleteTopologyLayer?: Maybe<TopologyLayerMutationResponse>;
  /** delete single row from the table: "topology.layer" */
  deleteTopologyLayerByPk?: Maybe<TopologyLayer>;
  /** delete data from the table: "topology.topology" */
  deleteTopologyTopology?: Maybe<TopologyTopologyMutationResponse>;
  /** delete single row from the table: "topology.topology" */
  deleteTopologyTopologyByPk?: Maybe<TopologyTopology>;
  /** delete data from the table: "trade" */
  deleteTrade?: Maybe<TradeMutationResponse>;
  /** delete single row from the table: "trade" */
  deleteTradeByPk?: Maybe<Trade>;
  /** delete data from the table: "trade_group" */
  deleteTradeGroup?: Maybe<TradeGroupMutationResponse>;
  /** delete single row from the table: "trade_group" */
  deleteTradeGroupByPk?: Maybe<TradeGroup>;
  /** delete data from the table: "trade_guide" */
  deleteTradeGuide?: Maybe<TradeGuideMutationResponse>;
  /** delete single row from the table: "trade_guide" */
  deleteTradeGuideByPk?: Maybe<TradeGuide>;
  /** delete data from the table: "trade_keyword" */
  deleteTradeKeyword?: Maybe<TradeKeywordMutationResponse>;
  /** delete single row from the table: "trade_keyword" */
  deleteTradeKeywordByPk?: Maybe<TradeKeyword>;
  /** delete data from the table: "trade_pro_presentation" */
  deleteTradeProPresentation?: Maybe<TradeProPresentationMutationResponse>;
  /** delete single row from the table: "trade_pro_presentation" */
  deleteTradeProPresentationByPk?: Maybe<TradeProPresentation>;
  /** delete data from the table: "trade_pro_view" */
  deleteTradeProView?: Maybe<TradeProViewMutationResponse>;
  /** delete single row from the table: "trade_pro_view" */
  deleteTradeProViewByPk?: Maybe<TradeProView>;
  /** delete data from the table: "trade_question" */
  deleteTradeQuestion?: Maybe<TradeQuestionMutationResponse>;
  /** delete single row from the table: "trade_question" */
  deleteTradeQuestionByPk?: Maybe<TradeQuestion>;
  /** delete data from the table: "trade_trade_group" */
  deleteTradeTradeGroup?: Maybe<TradeTradeGroupMutationResponse>;
  /** delete single row from the table: "trade_trade_group" */
  deleteTradeTradeGroupByPk?: Maybe<TradeTradeGroup>;
  /** delete data from the table: "trade_trade_guide" */
  deleteTradeTradeGuide?: Maybe<TradeTradeGuideMutationResponse>;
  /** delete single row from the table: "trade_trade_guide" */
  deleteTradeTradeGuideByPk?: Maybe<TradeTradeGuide>;
  /** delete data from the table: "utm_record" */
  deleteUtmRecord?: Maybe<UtmRecordMutationResponse>;
  /** delete single row from the table: "utm_record" */
  deleteUtmRecordByPk?: Maybe<UtmRecord>;
  /** delete data from the table: "zoho_consumer" */
  deleteZohoConsumer?: Maybe<ZohoConsumerMutationResponse>;
  /** delete single row from the table: "zoho_consumer" */
  deleteZohoConsumerByPk?: Maybe<ZohoConsumer>;
  /** delete data from the table: "zoho_organization" */
  deleteZohoOrganization?: Maybe<ZohoOrganizationMutationResponse>;
  /** delete single row from the table: "zoho_organization" */
  deleteZohoOrganizationByPk?: Maybe<ZohoOrganization>;
  /** delete data from the table: "zoho_token" */
  deleteZohoToken?: Maybe<ZohoTokenMutationResponse>;
  /** delete single row from the table: "zoho_token" */
  deleteZohoTokenByPk?: Maybe<ZohoToken>;
  /** insert data into the table: "account_pro_view" */
  insertAccountProView?: Maybe<AccountProViewMutationResponse>;
  /** insert a single row into the table: "account_pro_view" */
  insertAccountProViewOne?: Maybe<AccountProView>;
  /** insert data into the table: "action_token" */
  insertActionToken?: Maybe<ActionTokenMutationResponse>;
  /** insert a single row into the table: "action_token" */
  insertActionTokenOne?: Maybe<ActionToken>;
  /** insert data into the table: "announcement" */
  insertAnnouncement?: Maybe<AnnouncementMutationResponse>;
  /** insert a single row into the table: "announcement" */
  insertAnnouncementOne?: Maybe<Announcement>;
  /** insert data into the table: "autorespond" */
  insertAutorespond?: Maybe<AutorespondMutationResponse>;
  /** insert a single row into the table: "autorespond" */
  insertAutorespondOne?: Maybe<Autorespond>;
  /** insert data into the table: "bilik_person" */
  insertBilikPerson?: Maybe<BilikPersonMutationResponse>;
  /** insert a single row into the table: "bilik_person" */
  insertBilikPersonOne?: Maybe<BilikPerson>;
  /** insert data into the table: "bilik_solicitation" */
  insertBilikSolicitation?: Maybe<BilikSolicitationMutationResponse>;
  /** insert a single row into the table: "bilik_solicitation" */
  insertBilikSolicitationOne?: Maybe<BilikSolicitation>;
  /** insert data into the table: "bilik_zone" */
  insertBilikZone?: Maybe<BilikZoneMutationResponse>;
  /** insert a single row into the table: "bilik_zone" */
  insertBilikZoneOne?: Maybe<BilikZone>;
  /** insert data into the table: "certification" */
  insertCertification?: Maybe<CertificationMutationResponse>;
  /** insert a single row into the table: "certification" */
  insertCertificationOne?: Maybe<Certification>;
  /** insert data into the table: "city" */
  insertCity?: Maybe<CityMutationResponse>;
  /** insert a single row into the table: "city" */
  insertCityOne?: Maybe<City>;
  /** insert data into the table: "city_pro_view" */
  insertCityProView?: Maybe<CityProViewMutationResponse>;
  /** insert a single row into the table: "city_pro_view" */
  insertCityProViewOne?: Maybe<CityProView>;
  /** insert data into the table: "company" */
  insertCompany?: Maybe<CompanyMutationResponse>;
  /** insert a single row into the table: "company" */
  insertCompanyOne?: Maybe<Company>;
  /** insert data into the table: "department" */
  insertDepartment?: Maybe<DepartmentMutationResponse>;
  /** insert a single row into the table: "department" */
  insertDepartmentOne?: Maybe<Department>;
  /** insert data into the table: "geometry_columns" */
  insertGeometryColumns?: Maybe<GeometryColumnsMutationResponse>;
  /** insert a single row into the table: "geometry_columns" */
  insertGeometryColumnsOne?: Maybe<GeometryColumns>;
  /** insert data into the table: "globally_blocked_identity" */
  insertGloballyBlockedIdentity?: Maybe<GloballyBlockedIdentityMutationResponse>;
  /** insert a single row into the table: "globally_blocked_identity" */
  insertGloballyBlockedIdentityOne?: Maybe<GloballyBlockedIdentity>;
  /** insert data into the table: "google_review_link" */
  insertGoogleReviewLink?: Maybe<GoogleReviewLinkMutationResponse>;
  /** insert a single row into the table: "google_review_link" */
  insertGoogleReviewLinkOne?: Maybe<GoogleReviewLink>;
  /** insert data into the table: "manager_bilik_person_bilik_zone" */
  insertManagerBilikPersonBilikZone?: Maybe<ManagerBilikPersonBilikZoneMutationResponse>;
  /** insert a single row into the table: "manager_bilik_person_bilik_zone" */
  insertManagerBilikPersonBilikZoneOne?: Maybe<ManagerBilikPersonBilikZone>;
  /** insert data into the table: "member_bilik_person_bilik_zone" */
  insertMemberBilikPersonBilikZone?: Maybe<MemberBilikPersonBilikZoneMutationResponse>;
  /** insert a single row into the table: "member_bilik_person_bilik_zone" */
  insertMemberBilikPersonBilikZoneOne?: Maybe<MemberBilikPersonBilikZone>;
  /** insert data into the table: "nearest_pro_view" */
  insertNearestProView?: Maybe<NearestProViewMutationResponse>;
  /** insert a single row into the table: "nearest_pro_view" */
  insertNearestProViewOne?: Maybe<NearestProView>;
  /** insert data into the table: "nextval" */
  insertNextval?: Maybe<NextvalMutationResponse>;
  /** insert a single row into the table: "nextval" */
  insertNextvalOne?: Maybe<Nextval>;
  /** insert data into the table: "note_identity" */
  insertNoteIdentity?: Maybe<NoteIdentityMutationResponse>;
  /** insert a single row into the table: "note_identity" */
  insertNoteIdentityOne?: Maybe<NoteIdentity>;
  /** insert data into the table: "pennylane_company_mapping" */
  insertPennylaneCompanyMapping?: Maybe<PennylaneCompanyMappingMutationResponse>;
  /** insert a single row into the table: "pennylane_company_mapping" */
  insertPennylaneCompanyMappingOne?: Maybe<PennylaneCompanyMapping>;
  /** insert data into the table: "phone_number" */
  insertPhoneNumber?: Maybe<PhoneNumberMutationResponse>;
  /** insert a single row into the table: "phone_number" */
  insertPhoneNumberOne?: Maybe<PhoneNumber>;
  /** insert data into the table: "pro_certification" */
  insertProCertification?: Maybe<ProCertificationMutationResponse>;
  /** insert a single row into the table: "pro_certification" */
  insertProCertificationOne?: Maybe<ProCertification>;
  /** insert data into the table: "pro_holiday" */
  insertProHoliday?: Maybe<ProHolidayMutationResponse>;
  /** insert a single row into the table: "pro_holiday" */
  insertProHolidayOne?: Maybe<ProHoliday>;
  /** insert data into the table: "pro_label" */
  insertProLabel?: Maybe<ProLabelMutationResponse>;
  /** insert a single row into the table: "pro_label" */
  insertProLabelOne?: Maybe<ProLabel>;
  /** insert data into the table: "pro_mandate" */
  insertProMandate?: Maybe<ProMandateMutationResponse>;
  /** insert a single row into the table: "pro_mandate" */
  insertProMandateOne?: Maybe<ProMandate>;
  /** insert data into the table: "pro_media_object" */
  insertProMediaObject?: Maybe<ProMediaObjectMutationResponse>;
  /** insert a single row into the table: "pro_media_object" */
  insertProMediaObjectOne?: Maybe<ProMediaObject>;
  /** insert data into the table: "pro_message" */
  insertProMessage?: Maybe<ProMessageMutationResponse>;
  /** insert a single row into the table: "pro_message" */
  insertProMessageOne?: Maybe<ProMessage>;
  /** insert data into the table: "pro_person" */
  insertProPerson?: Maybe<ProPersonMutationResponse>;
  /** insert a single row into the table: "pro_person" */
  insertProPersonOne?: Maybe<ProPerson>;
  /** insert data into the table: "pro_postal_address" */
  insertProPostalAddress?: Maybe<ProPostalAddressMutationResponse>;
  /** insert a single row into the table: "pro_postal_address" */
  insertProPostalAddressOne?: Maybe<ProPostalAddress>;
  /** insert data into the table: "pro_presentation" */
  insertProPresentation?: Maybe<ProPresentationMutationResponse>;
  /** insert a single row into the table: "pro_presentation" */
  insertProPresentationOne?: Maybe<ProPresentation>;
  /** insert data into the table: "pro_price" */
  insertProPrice?: Maybe<ProPriceMutationResponse>;
  /** insert a single row into the table: "pro_price" */
  insertProPriceOne?: Maybe<ProPrice>;
  /** insert data into the table: "pro_review" */
  insertProReview?: Maybe<ProReviewMutationResponse>;
  /** insert data into the table: "pro_review_invitation" */
  insertProReviewInvitation?: Maybe<ProReviewInvitationMutationResponse>;
  /** insert a single row into the table: "pro_review_invitation" */
  insertProReviewInvitationOne?: Maybe<ProReviewInvitation>;
  /** insert a single row into the table: "pro_review" */
  insertProReviewOne?: Maybe<ProReview>;
  /** insert data into the table: "pro_view" */
  insertProView?: Maybe<ProViewMutationResponse>;
  /** insert a single row into the table: "pro_view" */
  insertProViewOne?: Maybe<ProView>;
  /** insert data into the table: "pro_view_pro_person" */
  insertProViewProPerson?: Maybe<ProViewProPersonMutationResponse>;
  /** insert a single row into the table: "pro_view_pro_person" */
  insertProViewProPersonOne?: Maybe<ProViewProPerson>;
  /** insert data into the table: "pro_view_pro_view" */
  insertProViewProView?: Maybe<ProViewProViewMutationResponse>;
  /** insert a single row into the table: "pro_view_pro_view" */
  insertProViewProViewOne?: Maybe<ProViewProView>;
  /** insert data into the table: "queued_sms" */
  insertQueuedSms?: Maybe<QueuedSmsMutationResponse>;
  /** insert a single row into the table: "queued_sms" */
  insertQueuedSmsOne?: Maybe<QueuedSms>;
  /** insert data into the table: "region" */
  insertRegion?: Maybe<RegionMutationResponse>;
  /** insert a single row into the table: "region" */
  insertRegionOne?: Maybe<Region>;
  /** insert data into the table: "review_presentation" */
  insertReviewPresentation?: Maybe<ReviewPresentationMutationResponse>;
  /** insert a single row into the table: "review_presentation" */
  insertReviewPresentationOne?: Maybe<ReviewPresentation>;
  /** insert data into the table: "slug_redirect" */
  insertSlugRedirect?: Maybe<SlugRedirectMutationResponse>;
  /** insert a single row into the table: "slug_redirect" */
  insertSlugRedirectOne?: Maybe<SlugRedirect>;
  /** insert data into the table: "solicitation" */
  insertSolicitation?: Maybe<SolicitationMutationResponse>;
  /** insert a single row into the table: "solicitation" */
  insertSolicitationOne?: Maybe<Solicitation>;
  /** insert data into the table: "solicitation_stat" */
  insertSolicitationStat?: Maybe<SolicitationStatMutationResponse>;
  /** insert a single row into the table: "solicitation_stat" */
  insertSolicitationStatOne?: Maybe<SolicitationStat>;
  /** insert data into the table: "spatial_ref_sys" */
  insertSpatialRefSys?: Maybe<SpatialRefSysMutationResponse>;
  /** insert a single row into the table: "spatial_ref_sys" */
  insertSpatialRefSysOne?: Maybe<SpatialRefSys>;
  /** insert data into the table: "stop_sms" */
  insertStopSms?: Maybe<StopSmsMutationResponse>;
  /** insert a single row into the table: "stop_sms" */
  insertStopSmsOne?: Maybe<StopSms>;
  /** insert data into the table: "subscription" */
  insertSubscription?: Maybe<SubscriptionMutationResponse>;
  /** insert a single row into the table: "subscription" */
  insertSubscriptionOne?: Maybe<Subscription>;
  /** insert data into the table: "topology.layer" */
  insertTopologyLayer?: Maybe<TopologyLayerMutationResponse>;
  /** insert a single row into the table: "topology.layer" */
  insertTopologyLayerOne?: Maybe<TopologyLayer>;
  /** insert data into the table: "topology.topology" */
  insertTopologyTopology?: Maybe<TopologyTopologyMutationResponse>;
  /** insert a single row into the table: "topology.topology" */
  insertTopologyTopologyOne?: Maybe<TopologyTopology>;
  /** insert data into the table: "trade" */
  insertTrade?: Maybe<TradeMutationResponse>;
  /** insert data into the table: "trade_group" */
  insertTradeGroup?: Maybe<TradeGroupMutationResponse>;
  /** insert a single row into the table: "trade_group" */
  insertTradeGroupOne?: Maybe<TradeGroup>;
  /** insert data into the table: "trade_guide" */
  insertTradeGuide?: Maybe<TradeGuideMutationResponse>;
  /** insert a single row into the table: "trade_guide" */
  insertTradeGuideOne?: Maybe<TradeGuide>;
  /** insert data into the table: "trade_keyword" */
  insertTradeKeyword?: Maybe<TradeKeywordMutationResponse>;
  /** insert a single row into the table: "trade_keyword" */
  insertTradeKeywordOne?: Maybe<TradeKeyword>;
  /** insert a single row into the table: "trade" */
  insertTradeOne?: Maybe<Trade>;
  /** insert data into the table: "trade_pro_presentation" */
  insertTradeProPresentation?: Maybe<TradeProPresentationMutationResponse>;
  /** insert a single row into the table: "trade_pro_presentation" */
  insertTradeProPresentationOne?: Maybe<TradeProPresentation>;
  /** insert data into the table: "trade_pro_view" */
  insertTradeProView?: Maybe<TradeProViewMutationResponse>;
  /** insert a single row into the table: "trade_pro_view" */
  insertTradeProViewOne?: Maybe<TradeProView>;
  /** insert data into the table: "trade_question" */
  insertTradeQuestion?: Maybe<TradeQuestionMutationResponse>;
  /** insert a single row into the table: "trade_question" */
  insertTradeQuestionOne?: Maybe<TradeQuestion>;
  /** insert data into the table: "trade_trade_group" */
  insertTradeTradeGroup?: Maybe<TradeTradeGroupMutationResponse>;
  /** insert a single row into the table: "trade_trade_group" */
  insertTradeTradeGroupOne?: Maybe<TradeTradeGroup>;
  /** insert data into the table: "trade_trade_guide" */
  insertTradeTradeGuide?: Maybe<TradeTradeGuideMutationResponse>;
  /** insert a single row into the table: "trade_trade_guide" */
  insertTradeTradeGuideOne?: Maybe<TradeTradeGuide>;
  /** insert data into the table: "utm_record" */
  insertUtmRecord?: Maybe<UtmRecordMutationResponse>;
  /** insert a single row into the table: "utm_record" */
  insertUtmRecordOne?: Maybe<UtmRecord>;
  /** insert data into the table: "zoho_consumer" */
  insertZohoConsumer?: Maybe<ZohoConsumerMutationResponse>;
  /** insert a single row into the table: "zoho_consumer" */
  insertZohoConsumerOne?: Maybe<ZohoConsumer>;
  /** insert data into the table: "zoho_organization" */
  insertZohoOrganization?: Maybe<ZohoOrganizationMutationResponse>;
  /** insert a single row into the table: "zoho_organization" */
  insertZohoOrganizationOne?: Maybe<ZohoOrganization>;
  /** insert data into the table: "zoho_token" */
  insertZohoToken?: Maybe<ZohoTokenMutationResponse>;
  /** insert a single row into the table: "zoho_token" */
  insertZohoTokenOne?: Maybe<ZohoToken>;
  /** execute VOLATILE function "sequence_nextval" which returns "nextval" */
  sequenceNextval: Array<Nextval>;
  /** update data of the table: "account_pro_view" */
  updateAccountProView?: Maybe<AccountProViewMutationResponse>;
  /** update single row of the table: "account_pro_view" */
  updateAccountProViewByPk?: Maybe<AccountProView>;
  /** update multiples rows of table: "account_pro_view" */
  updateAccountProViewMany?: Maybe<Array<Maybe<AccountProViewMutationResponse>>>;
  /** update data of the table: "action_token" */
  updateActionToken?: Maybe<ActionTokenMutationResponse>;
  /** update single row of the table: "action_token" */
  updateActionTokenByPk?: Maybe<ActionToken>;
  /** update multiples rows of table: "action_token" */
  updateActionTokenMany?: Maybe<Array<Maybe<ActionTokenMutationResponse>>>;
  /** update data of the table: "announcement" */
  updateAnnouncement?: Maybe<AnnouncementMutationResponse>;
  /** update single row of the table: "announcement" */
  updateAnnouncementByPk?: Maybe<Announcement>;
  /** update multiples rows of table: "announcement" */
  updateAnnouncementMany?: Maybe<Array<Maybe<AnnouncementMutationResponse>>>;
  /** update data of the table: "autorespond" */
  updateAutorespond?: Maybe<AutorespondMutationResponse>;
  /** update single row of the table: "autorespond" */
  updateAutorespondByPk?: Maybe<Autorespond>;
  /** update multiples rows of table: "autorespond" */
  updateAutorespondMany?: Maybe<Array<Maybe<AutorespondMutationResponse>>>;
  /** update data of the table: "bilik_person" */
  updateBilikPerson?: Maybe<BilikPersonMutationResponse>;
  /** update single row of the table: "bilik_person" */
  updateBilikPersonByPk?: Maybe<BilikPerson>;
  /** update multiples rows of table: "bilik_person" */
  updateBilikPersonMany?: Maybe<Array<Maybe<BilikPersonMutationResponse>>>;
  /** update data of the table: "bilik_solicitation" */
  updateBilikSolicitation?: Maybe<BilikSolicitationMutationResponse>;
  /** update single row of the table: "bilik_solicitation" */
  updateBilikSolicitationByPk?: Maybe<BilikSolicitation>;
  /** update multiples rows of table: "bilik_solicitation" */
  updateBilikSolicitationMany?: Maybe<Array<Maybe<BilikSolicitationMutationResponse>>>;
  /** update data of the table: "bilik_zone" */
  updateBilikZone?: Maybe<BilikZoneMutationResponse>;
  /** update single row of the table: "bilik_zone" */
  updateBilikZoneByPk?: Maybe<BilikZone>;
  /** update multiples rows of table: "bilik_zone" */
  updateBilikZoneMany?: Maybe<Array<Maybe<BilikZoneMutationResponse>>>;
  /** update data of the table: "certification" */
  updateCertification?: Maybe<CertificationMutationResponse>;
  /** update single row of the table: "certification" */
  updateCertificationByPk?: Maybe<Certification>;
  /** update multiples rows of table: "certification" */
  updateCertificationMany?: Maybe<Array<Maybe<CertificationMutationResponse>>>;
  /** update data of the table: "city" */
  updateCity?: Maybe<CityMutationResponse>;
  /** update single row of the table: "city" */
  updateCityByPk?: Maybe<City>;
  /** update multiples rows of table: "city" */
  updateCityMany?: Maybe<Array<Maybe<CityMutationResponse>>>;
  /** update data of the table: "city_pro_view" */
  updateCityProView?: Maybe<CityProViewMutationResponse>;
  /** update single row of the table: "city_pro_view" */
  updateCityProViewByPk?: Maybe<CityProView>;
  /** update multiples rows of table: "city_pro_view" */
  updateCityProViewMany?: Maybe<Array<Maybe<CityProViewMutationResponse>>>;
  /** update data of the table: "company" */
  updateCompany?: Maybe<CompanyMutationResponse>;
  /** update single row of the table: "company" */
  updateCompanyByPk?: Maybe<Company>;
  /** update multiples rows of table: "company" */
  updateCompanyMany?: Maybe<Array<Maybe<CompanyMutationResponse>>>;
  /** update data of the table: "department" */
  updateDepartment?: Maybe<DepartmentMutationResponse>;
  /** update single row of the table: "department" */
  updateDepartmentByPk?: Maybe<Department>;
  /** update multiples rows of table: "department" */
  updateDepartmentMany?: Maybe<Array<Maybe<DepartmentMutationResponse>>>;
  /** update data of the table: "geometry_columns" */
  updateGeometryColumns?: Maybe<GeometryColumnsMutationResponse>;
  /** update multiples rows of table: "geometry_columns" */
  updateGeometryColumnsMany?: Maybe<Array<Maybe<GeometryColumnsMutationResponse>>>;
  /** update data of the table: "globally_blocked_identity" */
  updateGloballyBlockedIdentity?: Maybe<GloballyBlockedIdentityMutationResponse>;
  /** update single row of the table: "globally_blocked_identity" */
  updateGloballyBlockedIdentityByPk?: Maybe<GloballyBlockedIdentity>;
  /** update multiples rows of table: "globally_blocked_identity" */
  updateGloballyBlockedIdentityMany?: Maybe<Array<Maybe<GloballyBlockedIdentityMutationResponse>>>;
  /** update data of the table: "google_review_link" */
  updateGoogleReviewLink?: Maybe<GoogleReviewLinkMutationResponse>;
  /** update single row of the table: "google_review_link" */
  updateGoogleReviewLinkByPk?: Maybe<GoogleReviewLink>;
  /** update multiples rows of table: "google_review_link" */
  updateGoogleReviewLinkMany?: Maybe<Array<Maybe<GoogleReviewLinkMutationResponse>>>;
  /** update data of the table: "manager_bilik_person_bilik_zone" */
  updateManagerBilikPersonBilikZone?: Maybe<ManagerBilikPersonBilikZoneMutationResponse>;
  /** update single row of the table: "manager_bilik_person_bilik_zone" */
  updateManagerBilikPersonBilikZoneByPk?: Maybe<ManagerBilikPersonBilikZone>;
  /** update multiples rows of table: "manager_bilik_person_bilik_zone" */
  updateManagerBilikPersonBilikZoneMany?: Maybe<Array<Maybe<ManagerBilikPersonBilikZoneMutationResponse>>>;
  /** update data of the table: "member_bilik_person_bilik_zone" */
  updateMemberBilikPersonBilikZone?: Maybe<MemberBilikPersonBilikZoneMutationResponse>;
  /** update single row of the table: "member_bilik_person_bilik_zone" */
  updateMemberBilikPersonBilikZoneByPk?: Maybe<MemberBilikPersonBilikZone>;
  /** update multiples rows of table: "member_bilik_person_bilik_zone" */
  updateMemberBilikPersonBilikZoneMany?: Maybe<Array<Maybe<MemberBilikPersonBilikZoneMutationResponse>>>;
  /** update data of the table: "nearest_pro_view" */
  updateNearestProView?: Maybe<NearestProViewMutationResponse>;
  /** update multiples rows of table: "nearest_pro_view" */
  updateNearestProViewMany?: Maybe<Array<Maybe<NearestProViewMutationResponse>>>;
  /** update data of the table: "nextval" */
  updateNextval?: Maybe<NextvalMutationResponse>;
  /** update multiples rows of table: "nextval" */
  updateNextvalMany?: Maybe<Array<Maybe<NextvalMutationResponse>>>;
  /** update data of the table: "note_identity" */
  updateNoteIdentity?: Maybe<NoteIdentityMutationResponse>;
  /** update single row of the table: "note_identity" */
  updateNoteIdentityByPk?: Maybe<NoteIdentity>;
  /** update multiples rows of table: "note_identity" */
  updateNoteIdentityMany?: Maybe<Array<Maybe<NoteIdentityMutationResponse>>>;
  /** update data of the table: "pennylane_company_mapping" */
  updatePennylaneCompanyMapping?: Maybe<PennylaneCompanyMappingMutationResponse>;
  /** update single row of the table: "pennylane_company_mapping" */
  updatePennylaneCompanyMappingByPk?: Maybe<PennylaneCompanyMapping>;
  /** update multiples rows of table: "pennylane_company_mapping" */
  updatePennylaneCompanyMappingMany?: Maybe<Array<Maybe<PennylaneCompanyMappingMutationResponse>>>;
  /** update data of the table: "phone_number" */
  updatePhoneNumber?: Maybe<PhoneNumberMutationResponse>;
  /** update single row of the table: "phone_number" */
  updatePhoneNumberByPk?: Maybe<PhoneNumber>;
  /** update multiples rows of table: "phone_number" */
  updatePhoneNumberMany?: Maybe<Array<Maybe<PhoneNumberMutationResponse>>>;
  /** update data of the table: "pro_certification" */
  updateProCertification?: Maybe<ProCertificationMutationResponse>;
  /** update single row of the table: "pro_certification" */
  updateProCertificationByPk?: Maybe<ProCertification>;
  /** update multiples rows of table: "pro_certification" */
  updateProCertificationMany?: Maybe<Array<Maybe<ProCertificationMutationResponse>>>;
  /** update data of the table: "pro_holiday" */
  updateProHoliday?: Maybe<ProHolidayMutationResponse>;
  /** update single row of the table: "pro_holiday" */
  updateProHolidayByPk?: Maybe<ProHoliday>;
  /** update multiples rows of table: "pro_holiday" */
  updateProHolidayMany?: Maybe<Array<Maybe<ProHolidayMutationResponse>>>;
  /** update data of the table: "pro_label" */
  updateProLabel?: Maybe<ProLabelMutationResponse>;
  /** update single row of the table: "pro_label" */
  updateProLabelByPk?: Maybe<ProLabel>;
  /** update multiples rows of table: "pro_label" */
  updateProLabelMany?: Maybe<Array<Maybe<ProLabelMutationResponse>>>;
  /** update data of the table: "pro_mandate" */
  updateProMandate?: Maybe<ProMandateMutationResponse>;
  /** update single row of the table: "pro_mandate" */
  updateProMandateByPk?: Maybe<ProMandate>;
  /** update multiples rows of table: "pro_mandate" */
  updateProMandateMany?: Maybe<Array<Maybe<ProMandateMutationResponse>>>;
  /** update data of the table: "pro_media_object" */
  updateProMediaObject?: Maybe<ProMediaObjectMutationResponse>;
  /** update single row of the table: "pro_media_object" */
  updateProMediaObjectByPk?: Maybe<ProMediaObject>;
  /** update multiples rows of table: "pro_media_object" */
  updateProMediaObjectMany?: Maybe<Array<Maybe<ProMediaObjectMutationResponse>>>;
  /** update data of the table: "pro_message" */
  updateProMessage?: Maybe<ProMessageMutationResponse>;
  /** update single row of the table: "pro_message" */
  updateProMessageByPk?: Maybe<ProMessage>;
  /** update multiples rows of table: "pro_message" */
  updateProMessageMany?: Maybe<Array<Maybe<ProMessageMutationResponse>>>;
  /** update data of the table: "pro_person" */
  updateProPerson?: Maybe<ProPersonMutationResponse>;
  /** update single row of the table: "pro_person" */
  updateProPersonByPk?: Maybe<ProPerson>;
  /** update multiples rows of table: "pro_person" */
  updateProPersonMany?: Maybe<Array<Maybe<ProPersonMutationResponse>>>;
  /** update data of the table: "pro_postal_address" */
  updateProPostalAddress?: Maybe<ProPostalAddressMutationResponse>;
  /** update single row of the table: "pro_postal_address" */
  updateProPostalAddressByPk?: Maybe<ProPostalAddress>;
  /** update multiples rows of table: "pro_postal_address" */
  updateProPostalAddressMany?: Maybe<Array<Maybe<ProPostalAddressMutationResponse>>>;
  /** update data of the table: "pro_presentation" */
  updateProPresentation?: Maybe<ProPresentationMutationResponse>;
  /** update single row of the table: "pro_presentation" */
  updateProPresentationByPk?: Maybe<ProPresentation>;
  /** update multiples rows of table: "pro_presentation" */
  updateProPresentationMany?: Maybe<Array<Maybe<ProPresentationMutationResponse>>>;
  /** update data of the table: "pro_price" */
  updateProPrice?: Maybe<ProPriceMutationResponse>;
  /** update single row of the table: "pro_price" */
  updateProPriceByPk?: Maybe<ProPrice>;
  /** update multiples rows of table: "pro_price" */
  updateProPriceMany?: Maybe<Array<Maybe<ProPriceMutationResponse>>>;
  /** update data of the table: "pro_review" */
  updateProReview?: Maybe<ProReviewMutationResponse>;
  /** update single row of the table: "pro_review" */
  updateProReviewByPk?: Maybe<ProReview>;
  /** update data of the table: "pro_review_invitation" */
  updateProReviewInvitation?: Maybe<ProReviewInvitationMutationResponse>;
  /** update single row of the table: "pro_review_invitation" */
  updateProReviewInvitationByPk?: Maybe<ProReviewInvitation>;
  /** update multiples rows of table: "pro_review_invitation" */
  updateProReviewInvitationMany?: Maybe<Array<Maybe<ProReviewInvitationMutationResponse>>>;
  /** update multiples rows of table: "pro_review" */
  updateProReviewMany?: Maybe<Array<Maybe<ProReviewMutationResponse>>>;
  /** update data of the table: "pro_view" */
  updateProView?: Maybe<ProViewMutationResponse>;
  /** update single row of the table: "pro_view" */
  updateProViewByPk?: Maybe<ProView>;
  /** update multiples rows of table: "pro_view" */
  updateProViewMany?: Maybe<Array<Maybe<ProViewMutationResponse>>>;
  /** update data of the table: "pro_view_pro_person" */
  updateProViewProPerson?: Maybe<ProViewProPersonMutationResponse>;
  /** update single row of the table: "pro_view_pro_person" */
  updateProViewProPersonByPk?: Maybe<ProViewProPerson>;
  /** update multiples rows of table: "pro_view_pro_person" */
  updateProViewProPersonMany?: Maybe<Array<Maybe<ProViewProPersonMutationResponse>>>;
  /** update data of the table: "pro_view_pro_view" */
  updateProViewProView?: Maybe<ProViewProViewMutationResponse>;
  /** update single row of the table: "pro_view_pro_view" */
  updateProViewProViewByPk?: Maybe<ProViewProView>;
  /** update multiples rows of table: "pro_view_pro_view" */
  updateProViewProViewMany?: Maybe<Array<Maybe<ProViewProViewMutationResponse>>>;
  /** update data of the table: "queued_sms" */
  updateQueuedSms?: Maybe<QueuedSmsMutationResponse>;
  /** update single row of the table: "queued_sms" */
  updateQueuedSmsByPk?: Maybe<QueuedSms>;
  /** update multiples rows of table: "queued_sms" */
  updateQueuedSmsMany?: Maybe<Array<Maybe<QueuedSmsMutationResponse>>>;
  /** update data of the table: "region" */
  updateRegion?: Maybe<RegionMutationResponse>;
  /** update single row of the table: "region" */
  updateRegionByPk?: Maybe<Region>;
  /** update multiples rows of table: "region" */
  updateRegionMany?: Maybe<Array<Maybe<RegionMutationResponse>>>;
  /** update data of the table: "review_presentation" */
  updateReviewPresentation?: Maybe<ReviewPresentationMutationResponse>;
  /** update single row of the table: "review_presentation" */
  updateReviewPresentationByPk?: Maybe<ReviewPresentation>;
  /** update multiples rows of table: "review_presentation" */
  updateReviewPresentationMany?: Maybe<Array<Maybe<ReviewPresentationMutationResponse>>>;
  /** update data of the table: "slug_redirect" */
  updateSlugRedirect?: Maybe<SlugRedirectMutationResponse>;
  /** update single row of the table: "slug_redirect" */
  updateSlugRedirectByPk?: Maybe<SlugRedirect>;
  /** update multiples rows of table: "slug_redirect" */
  updateSlugRedirectMany?: Maybe<Array<Maybe<SlugRedirectMutationResponse>>>;
  /** update data of the table: "solicitation" */
  updateSolicitation?: Maybe<SolicitationMutationResponse>;
  /** update single row of the table: "solicitation" */
  updateSolicitationByPk?: Maybe<Solicitation>;
  /** update multiples rows of table: "solicitation" */
  updateSolicitationMany?: Maybe<Array<Maybe<SolicitationMutationResponse>>>;
  /** update data of the table: "solicitation_stat" */
  updateSolicitationStat?: Maybe<SolicitationStatMutationResponse>;
  /** update multiples rows of table: "solicitation_stat" */
  updateSolicitationStatMany?: Maybe<Array<Maybe<SolicitationStatMutationResponse>>>;
  /** update data of the table: "spatial_ref_sys" */
  updateSpatialRefSys?: Maybe<SpatialRefSysMutationResponse>;
  /** update single row of the table: "spatial_ref_sys" */
  updateSpatialRefSysByPk?: Maybe<SpatialRefSys>;
  /** update multiples rows of table: "spatial_ref_sys" */
  updateSpatialRefSysMany?: Maybe<Array<Maybe<SpatialRefSysMutationResponse>>>;
  /** update data of the table: "stop_sms" */
  updateStopSms?: Maybe<StopSmsMutationResponse>;
  /** update single row of the table: "stop_sms" */
  updateStopSmsByPk?: Maybe<StopSms>;
  /** update multiples rows of table: "stop_sms" */
  updateStopSmsMany?: Maybe<Array<Maybe<StopSmsMutationResponse>>>;
  /** update data of the table: "subscription" */
  updateSubscription?: Maybe<SubscriptionMutationResponse>;
  /** update single row of the table: "subscription" */
  updateSubscriptionByPk?: Maybe<Subscription>;
  /** update multiples rows of table: "subscription" */
  updateSubscriptionMany?: Maybe<Array<Maybe<SubscriptionMutationResponse>>>;
  /** update data of the table: "topology.layer" */
  updateTopologyLayer?: Maybe<TopologyLayerMutationResponse>;
  /** update single row of the table: "topology.layer" */
  updateTopologyLayerByPk?: Maybe<TopologyLayer>;
  /** update multiples rows of table: "topology.layer" */
  updateTopologyLayerMany?: Maybe<Array<Maybe<TopologyLayerMutationResponse>>>;
  /** update data of the table: "topology.topology" */
  updateTopologyTopology?: Maybe<TopologyTopologyMutationResponse>;
  /** update single row of the table: "topology.topology" */
  updateTopologyTopologyByPk?: Maybe<TopologyTopology>;
  /** update multiples rows of table: "topology.topology" */
  updateTopologyTopologyMany?: Maybe<Array<Maybe<TopologyTopologyMutationResponse>>>;
  /** update data of the table: "trade" */
  updateTrade?: Maybe<TradeMutationResponse>;
  /** update single row of the table: "trade" */
  updateTradeByPk?: Maybe<Trade>;
  /** update data of the table: "trade_group" */
  updateTradeGroup?: Maybe<TradeGroupMutationResponse>;
  /** update single row of the table: "trade_group" */
  updateTradeGroupByPk?: Maybe<TradeGroup>;
  /** update multiples rows of table: "trade_group" */
  updateTradeGroupMany?: Maybe<Array<Maybe<TradeGroupMutationResponse>>>;
  /** update data of the table: "trade_guide" */
  updateTradeGuide?: Maybe<TradeGuideMutationResponse>;
  /** update single row of the table: "trade_guide" */
  updateTradeGuideByPk?: Maybe<TradeGuide>;
  /** update multiples rows of table: "trade_guide" */
  updateTradeGuideMany?: Maybe<Array<Maybe<TradeGuideMutationResponse>>>;
  /** update data of the table: "trade_keyword" */
  updateTradeKeyword?: Maybe<TradeKeywordMutationResponse>;
  /** update single row of the table: "trade_keyword" */
  updateTradeKeywordByPk?: Maybe<TradeKeyword>;
  /** update multiples rows of table: "trade_keyword" */
  updateTradeKeywordMany?: Maybe<Array<Maybe<TradeKeywordMutationResponse>>>;
  /** update multiples rows of table: "trade" */
  updateTradeMany?: Maybe<Array<Maybe<TradeMutationResponse>>>;
  /** update data of the table: "trade_pro_presentation" */
  updateTradeProPresentation?: Maybe<TradeProPresentationMutationResponse>;
  /** update single row of the table: "trade_pro_presentation" */
  updateTradeProPresentationByPk?: Maybe<TradeProPresentation>;
  /** update multiples rows of table: "trade_pro_presentation" */
  updateTradeProPresentationMany?: Maybe<Array<Maybe<TradeProPresentationMutationResponse>>>;
  /** update data of the table: "trade_pro_view" */
  updateTradeProView?: Maybe<TradeProViewMutationResponse>;
  /** update single row of the table: "trade_pro_view" */
  updateTradeProViewByPk?: Maybe<TradeProView>;
  /** update multiples rows of table: "trade_pro_view" */
  updateTradeProViewMany?: Maybe<Array<Maybe<TradeProViewMutationResponse>>>;
  /** update data of the table: "trade_question" */
  updateTradeQuestion?: Maybe<TradeQuestionMutationResponse>;
  /** update single row of the table: "trade_question" */
  updateTradeQuestionByPk?: Maybe<TradeQuestion>;
  /** update multiples rows of table: "trade_question" */
  updateTradeQuestionMany?: Maybe<Array<Maybe<TradeQuestionMutationResponse>>>;
  /** update data of the table: "trade_trade_group" */
  updateTradeTradeGroup?: Maybe<TradeTradeGroupMutationResponse>;
  /** update single row of the table: "trade_trade_group" */
  updateTradeTradeGroupByPk?: Maybe<TradeTradeGroup>;
  /** update multiples rows of table: "trade_trade_group" */
  updateTradeTradeGroupMany?: Maybe<Array<Maybe<TradeTradeGroupMutationResponse>>>;
  /** update data of the table: "trade_trade_guide" */
  updateTradeTradeGuide?: Maybe<TradeTradeGuideMutationResponse>;
  /** update single row of the table: "trade_trade_guide" */
  updateTradeTradeGuideByPk?: Maybe<TradeTradeGuide>;
  /** update multiples rows of table: "trade_trade_guide" */
  updateTradeTradeGuideMany?: Maybe<Array<Maybe<TradeTradeGuideMutationResponse>>>;
  /** update data of the table: "utm_record" */
  updateUtmRecord?: Maybe<UtmRecordMutationResponse>;
  /** update single row of the table: "utm_record" */
  updateUtmRecordByPk?: Maybe<UtmRecord>;
  /** update multiples rows of table: "utm_record" */
  updateUtmRecordMany?: Maybe<Array<Maybe<UtmRecordMutationResponse>>>;
  /** update data of the table: "zoho_consumer" */
  updateZohoConsumer?: Maybe<ZohoConsumerMutationResponse>;
  /** update single row of the table: "zoho_consumer" */
  updateZohoConsumerByPk?: Maybe<ZohoConsumer>;
  /** update multiples rows of table: "zoho_consumer" */
  updateZohoConsumerMany?: Maybe<Array<Maybe<ZohoConsumerMutationResponse>>>;
  /** update data of the table: "zoho_organization" */
  updateZohoOrganization?: Maybe<ZohoOrganizationMutationResponse>;
  /** update single row of the table: "zoho_organization" */
  updateZohoOrganizationByPk?: Maybe<ZohoOrganization>;
  /** update multiples rows of table: "zoho_organization" */
  updateZohoOrganizationMany?: Maybe<Array<Maybe<ZohoOrganizationMutationResponse>>>;
  /** update data of the table: "zoho_token" */
  updateZohoToken?: Maybe<ZohoTokenMutationResponse>;
  /** update single row of the table: "zoho_token" */
  updateZohoTokenByPk?: Maybe<ZohoToken>;
  /** update multiples rows of table: "zoho_token" */
  updateZohoTokenMany?: Maybe<Array<Maybe<ZohoTokenMutationResponse>>>;
};


/** mutation root */
export type MutationRootDeleteAccountProViewArgs = {
  where: AccountProViewBoolExp;
};


/** mutation root */
export type MutationRootDeleteAccountProViewByPkArgs = {
  authUserId: Scalars['uuid'];
  proViewId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteActionTokenArgs = {
  where: ActionTokenBoolExp;
};


/** mutation root */
export type MutationRootDeleteActionTokenByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAnnouncementArgs = {
  where: AnnouncementBoolExp;
};


/** mutation root */
export type MutationRootDeleteAnnouncementByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAutorespondArgs = {
  where: AutorespondBoolExp;
};


/** mutation root */
export type MutationRootDeleteAutorespondByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteBilikPersonArgs = {
  where: BilikPersonBoolExp;
};


/** mutation root */
export type MutationRootDeleteBilikPersonByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteBilikSolicitationArgs = {
  where: BilikSolicitationBoolExp;
};


/** mutation root */
export type MutationRootDeleteBilikSolicitationByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteBilikZoneArgs = {
  where: BilikZoneBoolExp;
};


/** mutation root */
export type MutationRootDeleteBilikZoneByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCertificationArgs = {
  where: CertificationBoolExp;
};


/** mutation root */
export type MutationRootDeleteCertificationByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCityArgs = {
  where: CityBoolExp;
};


/** mutation root */
export type MutationRootDeleteCityByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCityProViewArgs = {
  where: CityProViewBoolExp;
};


/** mutation root */
export type MutationRootDeleteCityProViewByPkArgs = {
  cityId: Scalars['Int'];
  proViewId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCompanyArgs = {
  where: CompanyBoolExp;
};


/** mutation root */
export type MutationRootDeleteCompanyByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDepartmentArgs = {
  where: DepartmentBoolExp;
};


/** mutation root */
export type MutationRootDeleteDepartmentByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteGeometryColumnsArgs = {
  where: GeometryColumnsBoolExp;
};


/** mutation root */
export type MutationRootDeleteGloballyBlockedIdentityArgs = {
  where: GloballyBlockedIdentityBoolExp;
};


/** mutation root */
export type MutationRootDeleteGloballyBlockedIdentityByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteGoogleReviewLinkArgs = {
  where: GoogleReviewLinkBoolExp;
};


/** mutation root */
export type MutationRootDeleteGoogleReviewLinkByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteManagerBilikPersonBilikZoneArgs = {
  where: ManagerBilikPersonBilikZoneBoolExp;
};


/** mutation root */
export type MutationRootDeleteManagerBilikPersonBilikZoneByPkArgs = {
  bilikPersonId: Scalars['Int'];
  bilikZoneId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteMemberBilikPersonBilikZoneArgs = {
  where: MemberBilikPersonBilikZoneBoolExp;
};


/** mutation root */
export type MutationRootDeleteMemberBilikPersonBilikZoneByPkArgs = {
  bilikPersonId: Scalars['Int'];
  bilikZoneId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteNearestProViewArgs = {
  where: NearestProViewBoolExp;
};


/** mutation root */
export type MutationRootDeleteNextvalArgs = {
  where: NextvalBoolExp;
};


/** mutation root */
export type MutationRootDeleteNoteIdentityArgs = {
  where: NoteIdentityBoolExp;
};


/** mutation root */
export type MutationRootDeleteNoteIdentityByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeletePennylaneCompanyMappingArgs = {
  where: PennylaneCompanyMappingBoolExp;
};


/** mutation root */
export type MutationRootDeletePennylaneCompanyMappingByPkArgs = {
  billingIssuerId: Scalars['Int'];
  companyId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeletePhoneNumberArgs = {
  where: PhoneNumberBoolExp;
};


/** mutation root */
export type MutationRootDeletePhoneNumberByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProCertificationArgs = {
  where: ProCertificationBoolExp;
};


/** mutation root */
export type MutationRootDeleteProCertificationByPkArgs = {
  certificationId: Scalars['Int'];
  proPresentationId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProHolidayArgs = {
  where: ProHolidayBoolExp;
};


/** mutation root */
export type MutationRootDeleteProHolidayByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProLabelArgs = {
  where: ProLabelBoolExp;
};


/** mutation root */
export type MutationRootDeleteProLabelByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProMandateArgs = {
  where: ProMandateBoolExp;
};


/** mutation root */
export type MutationRootDeleteProMandateByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProMediaObjectArgs = {
  where: ProMediaObjectBoolExp;
};


/** mutation root */
export type MutationRootDeleteProMediaObjectByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProMessageArgs = {
  where: ProMessageBoolExp;
};


/** mutation root */
export type MutationRootDeleteProMessageByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProPersonArgs = {
  where: ProPersonBoolExp;
};


/** mutation root */
export type MutationRootDeleteProPersonByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProPostalAddressArgs = {
  where: ProPostalAddressBoolExp;
};


/** mutation root */
export type MutationRootDeleteProPostalAddressByPkArgs = {
  proViewId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProPresentationArgs = {
  where: ProPresentationBoolExp;
};


/** mutation root */
export type MutationRootDeleteProPresentationByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProPriceArgs = {
  where: ProPriceBoolExp;
};


/** mutation root */
export type MutationRootDeleteProPriceByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProReviewArgs = {
  where: ProReviewBoolExp;
};


/** mutation root */
export type MutationRootDeleteProReviewByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProReviewInvitationArgs = {
  where: ProReviewInvitationBoolExp;
};


/** mutation root */
export type MutationRootDeleteProReviewInvitationByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProViewArgs = {
  where: ProViewBoolExp;
};


/** mutation root */
export type MutationRootDeleteProViewByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProViewProPersonArgs = {
  where: ProViewProPersonBoolExp;
};


/** mutation root */
export type MutationRootDeleteProViewProPersonByPkArgs = {
  proPersonId: Scalars['Int'];
  proViewId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProViewProViewArgs = {
  where: ProViewProViewBoolExp;
};


/** mutation root */
export type MutationRootDeleteProViewProViewByPkArgs = {
  proViewSource: Scalars['Int'];
  proViewTarget: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteQueuedSmsArgs = {
  where: QueuedSmsBoolExp;
};


/** mutation root */
export type MutationRootDeleteQueuedSmsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteRegionArgs = {
  where: RegionBoolExp;
};


/** mutation root */
export type MutationRootDeleteRegionByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteReviewPresentationArgs = {
  where: ReviewPresentationBoolExp;
};


/** mutation root */
export type MutationRootDeleteReviewPresentationByPkArgs = {
  presentationId: Scalars['Int'];
  reviewId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteSlugRedirectArgs = {
  where: SlugRedirectBoolExp;
};


/** mutation root */
export type MutationRootDeleteSlugRedirectByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteSolicitationArgs = {
  where: SolicitationBoolExp;
};


/** mutation root */
export type MutationRootDeleteSolicitationByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteSolicitationStatArgs = {
  where: SolicitationStatBoolExp;
};


/** mutation root */
export type MutationRootDeleteSpatialRefSysArgs = {
  where: SpatialRefSysBoolExp;
};


/** mutation root */
export type MutationRootDeleteSpatialRefSysByPkArgs = {
  srid: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteStopSmsArgs = {
  where: StopSmsBoolExp;
};


/** mutation root */
export type MutationRootDeleteStopSmsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteSubscriptionArgs = {
  where: SubscriptionBoolExp;
};


/** mutation root */
export type MutationRootDeleteSubscriptionByPkArgs = {
  viewId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTopologyLayerArgs = {
  where: TopologyLayerBoolExp;
};


/** mutation root */
export type MutationRootDeleteTopologyLayerByPkArgs = {
  layerId: Scalars['Int'];
  topologyId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTopologyTopologyArgs = {
  where: TopologyTopologyBoolExp;
};


/** mutation root */
export type MutationRootDeleteTopologyTopologyByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTradeArgs = {
  where: TradeBoolExp;
};


/** mutation root */
export type MutationRootDeleteTradeByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTradeGroupArgs = {
  where: TradeGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteTradeGroupByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTradeGuideArgs = {
  where: TradeGuideBoolExp;
};


/** mutation root */
export type MutationRootDeleteTradeGuideByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTradeKeywordArgs = {
  where: TradeKeywordBoolExp;
};


/** mutation root */
export type MutationRootDeleteTradeKeywordByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTradeProPresentationArgs = {
  where: TradeProPresentationBoolExp;
};


/** mutation root */
export type MutationRootDeleteTradeProPresentationByPkArgs = {
  proPresentationId: Scalars['Int'];
  tradeId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTradeProViewArgs = {
  where: TradeProViewBoolExp;
};


/** mutation root */
export type MutationRootDeleteTradeProViewByPkArgs = {
  proViewId: Scalars['Int'];
  tradeId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTradeQuestionArgs = {
  where: TradeQuestionBoolExp;
};


/** mutation root */
export type MutationRootDeleteTradeQuestionByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTradeTradeGroupArgs = {
  where: TradeTradeGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteTradeTradeGroupByPkArgs = {
  tradeGroupId: Scalars['Int'];
  tradeId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTradeTradeGuideArgs = {
  where: TradeTradeGuideBoolExp;
};


/** mutation root */
export type MutationRootDeleteTradeTradeGuideByPkArgs = {
  tradeGuideId: Scalars['Int'];
  tradeId: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteUtmRecordArgs = {
  where: UtmRecordBoolExp;
};


/** mutation root */
export type MutationRootDeleteUtmRecordByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteZohoConsumerArgs = {
  where: ZohoConsumerBoolExp;
};


/** mutation root */
export type MutationRootDeleteZohoConsumerByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteZohoOrganizationArgs = {
  where: ZohoOrganizationBoolExp;
};


/** mutation root */
export type MutationRootDeleteZohoOrganizationByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteZohoTokenArgs = {
  where: ZohoTokenBoolExp;
};


/** mutation root */
export type MutationRootDeleteZohoTokenByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootInsertAccountProViewArgs = {
  objects: Array<AccountProViewInsertInput>;
  onConflict?: InputMaybe<AccountProViewOnConflict>;
};


/** mutation root */
export type MutationRootInsertAccountProViewOneArgs = {
  object: AccountProViewInsertInput;
  onConflict?: InputMaybe<AccountProViewOnConflict>;
};


/** mutation root */
export type MutationRootInsertActionTokenArgs = {
  objects: Array<ActionTokenInsertInput>;
  onConflict?: InputMaybe<ActionTokenOnConflict>;
};


/** mutation root */
export type MutationRootInsertActionTokenOneArgs = {
  object: ActionTokenInsertInput;
  onConflict?: InputMaybe<ActionTokenOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnnouncementArgs = {
  objects: Array<AnnouncementInsertInput>;
  onConflict?: InputMaybe<AnnouncementOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnnouncementOneArgs = {
  object: AnnouncementInsertInput;
  onConflict?: InputMaybe<AnnouncementOnConflict>;
};


/** mutation root */
export type MutationRootInsertAutorespondArgs = {
  objects: Array<AutorespondInsertInput>;
  onConflict?: InputMaybe<AutorespondOnConflict>;
};


/** mutation root */
export type MutationRootInsertAutorespondOneArgs = {
  object: AutorespondInsertInput;
  onConflict?: InputMaybe<AutorespondOnConflict>;
};


/** mutation root */
export type MutationRootInsertBilikPersonArgs = {
  objects: Array<BilikPersonInsertInput>;
  onConflict?: InputMaybe<BilikPersonOnConflict>;
};


/** mutation root */
export type MutationRootInsertBilikPersonOneArgs = {
  object: BilikPersonInsertInput;
  onConflict?: InputMaybe<BilikPersonOnConflict>;
};


/** mutation root */
export type MutationRootInsertBilikSolicitationArgs = {
  objects: Array<BilikSolicitationInsertInput>;
  onConflict?: InputMaybe<BilikSolicitationOnConflict>;
};


/** mutation root */
export type MutationRootInsertBilikSolicitationOneArgs = {
  object: BilikSolicitationInsertInput;
  onConflict?: InputMaybe<BilikSolicitationOnConflict>;
};


/** mutation root */
export type MutationRootInsertBilikZoneArgs = {
  objects: Array<BilikZoneInsertInput>;
  onConflict?: InputMaybe<BilikZoneOnConflict>;
};


/** mutation root */
export type MutationRootInsertBilikZoneOneArgs = {
  object: BilikZoneInsertInput;
  onConflict?: InputMaybe<BilikZoneOnConflict>;
};


/** mutation root */
export type MutationRootInsertCertificationArgs = {
  objects: Array<CertificationInsertInput>;
  onConflict?: InputMaybe<CertificationOnConflict>;
};


/** mutation root */
export type MutationRootInsertCertificationOneArgs = {
  object: CertificationInsertInput;
  onConflict?: InputMaybe<CertificationOnConflict>;
};


/** mutation root */
export type MutationRootInsertCityArgs = {
  objects: Array<CityInsertInput>;
  onConflict?: InputMaybe<CityOnConflict>;
};


/** mutation root */
export type MutationRootInsertCityOneArgs = {
  object: CityInsertInput;
  onConflict?: InputMaybe<CityOnConflict>;
};


/** mutation root */
export type MutationRootInsertCityProViewArgs = {
  objects: Array<CityProViewInsertInput>;
  onConflict?: InputMaybe<CityProViewOnConflict>;
};


/** mutation root */
export type MutationRootInsertCityProViewOneArgs = {
  object: CityProViewInsertInput;
  onConflict?: InputMaybe<CityProViewOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyArgs = {
  objects: Array<CompanyInsertInput>;
  onConflict?: InputMaybe<CompanyOnConflict>;
};


/** mutation root */
export type MutationRootInsertCompanyOneArgs = {
  object: CompanyInsertInput;
  onConflict?: InputMaybe<CompanyOnConflict>;
};


/** mutation root */
export type MutationRootInsertDepartmentArgs = {
  objects: Array<DepartmentInsertInput>;
  onConflict?: InputMaybe<DepartmentOnConflict>;
};


/** mutation root */
export type MutationRootInsertDepartmentOneArgs = {
  object: DepartmentInsertInput;
  onConflict?: InputMaybe<DepartmentOnConflict>;
};


/** mutation root */
export type MutationRootInsertGeometryColumnsArgs = {
  objects: Array<GeometryColumnsInsertInput>;
};


/** mutation root */
export type MutationRootInsertGeometryColumnsOneArgs = {
  object: GeometryColumnsInsertInput;
};


/** mutation root */
export type MutationRootInsertGloballyBlockedIdentityArgs = {
  objects: Array<GloballyBlockedIdentityInsertInput>;
  onConflict?: InputMaybe<GloballyBlockedIdentityOnConflict>;
};


/** mutation root */
export type MutationRootInsertGloballyBlockedIdentityOneArgs = {
  object: GloballyBlockedIdentityInsertInput;
  onConflict?: InputMaybe<GloballyBlockedIdentityOnConflict>;
};


/** mutation root */
export type MutationRootInsertGoogleReviewLinkArgs = {
  objects: Array<GoogleReviewLinkInsertInput>;
  onConflict?: InputMaybe<GoogleReviewLinkOnConflict>;
};


/** mutation root */
export type MutationRootInsertGoogleReviewLinkOneArgs = {
  object: GoogleReviewLinkInsertInput;
  onConflict?: InputMaybe<GoogleReviewLinkOnConflict>;
};


/** mutation root */
export type MutationRootInsertManagerBilikPersonBilikZoneArgs = {
  objects: Array<ManagerBilikPersonBilikZoneInsertInput>;
  onConflict?: InputMaybe<ManagerBilikPersonBilikZoneOnConflict>;
};


/** mutation root */
export type MutationRootInsertManagerBilikPersonBilikZoneOneArgs = {
  object: ManagerBilikPersonBilikZoneInsertInput;
  onConflict?: InputMaybe<ManagerBilikPersonBilikZoneOnConflict>;
};


/** mutation root */
export type MutationRootInsertMemberBilikPersonBilikZoneArgs = {
  objects: Array<MemberBilikPersonBilikZoneInsertInput>;
  onConflict?: InputMaybe<MemberBilikPersonBilikZoneOnConflict>;
};


/** mutation root */
export type MutationRootInsertMemberBilikPersonBilikZoneOneArgs = {
  object: MemberBilikPersonBilikZoneInsertInput;
  onConflict?: InputMaybe<MemberBilikPersonBilikZoneOnConflict>;
};


/** mutation root */
export type MutationRootInsertNearestProViewArgs = {
  objects: Array<NearestProViewInsertInput>;
};


/** mutation root */
export type MutationRootInsertNearestProViewOneArgs = {
  object: NearestProViewInsertInput;
};


/** mutation root */
export type MutationRootInsertNextvalArgs = {
  objects: Array<NextvalInsertInput>;
};


/** mutation root */
export type MutationRootInsertNextvalOneArgs = {
  object: NextvalInsertInput;
};


/** mutation root */
export type MutationRootInsertNoteIdentityArgs = {
  objects: Array<NoteIdentityInsertInput>;
  onConflict?: InputMaybe<NoteIdentityOnConflict>;
};


/** mutation root */
export type MutationRootInsertNoteIdentityOneArgs = {
  object: NoteIdentityInsertInput;
  onConflict?: InputMaybe<NoteIdentityOnConflict>;
};


/** mutation root */
export type MutationRootInsertPennylaneCompanyMappingArgs = {
  objects: Array<PennylaneCompanyMappingInsertInput>;
  onConflict?: InputMaybe<PennylaneCompanyMappingOnConflict>;
};


/** mutation root */
export type MutationRootInsertPennylaneCompanyMappingOneArgs = {
  object: PennylaneCompanyMappingInsertInput;
  onConflict?: InputMaybe<PennylaneCompanyMappingOnConflict>;
};


/** mutation root */
export type MutationRootInsertPhoneNumberArgs = {
  objects: Array<PhoneNumberInsertInput>;
  onConflict?: InputMaybe<PhoneNumberOnConflict>;
};


/** mutation root */
export type MutationRootInsertPhoneNumberOneArgs = {
  object: PhoneNumberInsertInput;
  onConflict?: InputMaybe<PhoneNumberOnConflict>;
};


/** mutation root */
export type MutationRootInsertProCertificationArgs = {
  objects: Array<ProCertificationInsertInput>;
  onConflict?: InputMaybe<ProCertificationOnConflict>;
};


/** mutation root */
export type MutationRootInsertProCertificationOneArgs = {
  object: ProCertificationInsertInput;
  onConflict?: InputMaybe<ProCertificationOnConflict>;
};


/** mutation root */
export type MutationRootInsertProHolidayArgs = {
  objects: Array<ProHolidayInsertInput>;
  onConflict?: InputMaybe<ProHolidayOnConflict>;
};


/** mutation root */
export type MutationRootInsertProHolidayOneArgs = {
  object: ProHolidayInsertInput;
  onConflict?: InputMaybe<ProHolidayOnConflict>;
};


/** mutation root */
export type MutationRootInsertProLabelArgs = {
  objects: Array<ProLabelInsertInput>;
  onConflict?: InputMaybe<ProLabelOnConflict>;
};


/** mutation root */
export type MutationRootInsertProLabelOneArgs = {
  object: ProLabelInsertInput;
  onConflict?: InputMaybe<ProLabelOnConflict>;
};


/** mutation root */
export type MutationRootInsertProMandateArgs = {
  objects: Array<ProMandateInsertInput>;
  onConflict?: InputMaybe<ProMandateOnConflict>;
};


/** mutation root */
export type MutationRootInsertProMandateOneArgs = {
  object: ProMandateInsertInput;
  onConflict?: InputMaybe<ProMandateOnConflict>;
};


/** mutation root */
export type MutationRootInsertProMediaObjectArgs = {
  objects: Array<ProMediaObjectInsertInput>;
  onConflict?: InputMaybe<ProMediaObjectOnConflict>;
};


/** mutation root */
export type MutationRootInsertProMediaObjectOneArgs = {
  object: ProMediaObjectInsertInput;
  onConflict?: InputMaybe<ProMediaObjectOnConflict>;
};


/** mutation root */
export type MutationRootInsertProMessageArgs = {
  objects: Array<ProMessageInsertInput>;
  onConflict?: InputMaybe<ProMessageOnConflict>;
};


/** mutation root */
export type MutationRootInsertProMessageOneArgs = {
  object: ProMessageInsertInput;
  onConflict?: InputMaybe<ProMessageOnConflict>;
};


/** mutation root */
export type MutationRootInsertProPersonArgs = {
  objects: Array<ProPersonInsertInput>;
  onConflict?: InputMaybe<ProPersonOnConflict>;
};


/** mutation root */
export type MutationRootInsertProPersonOneArgs = {
  object: ProPersonInsertInput;
  onConflict?: InputMaybe<ProPersonOnConflict>;
};


/** mutation root */
export type MutationRootInsertProPostalAddressArgs = {
  objects: Array<ProPostalAddressInsertInput>;
  onConflict?: InputMaybe<ProPostalAddressOnConflict>;
};


/** mutation root */
export type MutationRootInsertProPostalAddressOneArgs = {
  object: ProPostalAddressInsertInput;
  onConflict?: InputMaybe<ProPostalAddressOnConflict>;
};


/** mutation root */
export type MutationRootInsertProPresentationArgs = {
  objects: Array<ProPresentationInsertInput>;
  onConflict?: InputMaybe<ProPresentationOnConflict>;
};


/** mutation root */
export type MutationRootInsertProPresentationOneArgs = {
  object: ProPresentationInsertInput;
  onConflict?: InputMaybe<ProPresentationOnConflict>;
};


/** mutation root */
export type MutationRootInsertProPriceArgs = {
  objects: Array<ProPriceInsertInput>;
  onConflict?: InputMaybe<ProPriceOnConflict>;
};


/** mutation root */
export type MutationRootInsertProPriceOneArgs = {
  object: ProPriceInsertInput;
  onConflict?: InputMaybe<ProPriceOnConflict>;
};


/** mutation root */
export type MutationRootInsertProReviewArgs = {
  objects: Array<ProReviewInsertInput>;
  onConflict?: InputMaybe<ProReviewOnConflict>;
};


/** mutation root */
export type MutationRootInsertProReviewInvitationArgs = {
  objects: Array<ProReviewInvitationInsertInput>;
  onConflict?: InputMaybe<ProReviewInvitationOnConflict>;
};


/** mutation root */
export type MutationRootInsertProReviewInvitationOneArgs = {
  object: ProReviewInvitationInsertInput;
  onConflict?: InputMaybe<ProReviewInvitationOnConflict>;
};


/** mutation root */
export type MutationRootInsertProReviewOneArgs = {
  object: ProReviewInsertInput;
  onConflict?: InputMaybe<ProReviewOnConflict>;
};


/** mutation root */
export type MutationRootInsertProViewArgs = {
  objects: Array<ProViewInsertInput>;
  onConflict?: InputMaybe<ProViewOnConflict>;
};


/** mutation root */
export type MutationRootInsertProViewOneArgs = {
  object: ProViewInsertInput;
  onConflict?: InputMaybe<ProViewOnConflict>;
};


/** mutation root */
export type MutationRootInsertProViewProPersonArgs = {
  objects: Array<ProViewProPersonInsertInput>;
  onConflict?: InputMaybe<ProViewProPersonOnConflict>;
};


/** mutation root */
export type MutationRootInsertProViewProPersonOneArgs = {
  object: ProViewProPersonInsertInput;
  onConflict?: InputMaybe<ProViewProPersonOnConflict>;
};


/** mutation root */
export type MutationRootInsertProViewProViewArgs = {
  objects: Array<ProViewProViewInsertInput>;
  onConflict?: InputMaybe<ProViewProViewOnConflict>;
};


/** mutation root */
export type MutationRootInsertProViewProViewOneArgs = {
  object: ProViewProViewInsertInput;
  onConflict?: InputMaybe<ProViewProViewOnConflict>;
};


/** mutation root */
export type MutationRootInsertQueuedSmsArgs = {
  objects: Array<QueuedSmsInsertInput>;
  onConflict?: InputMaybe<QueuedSmsOnConflict>;
};


/** mutation root */
export type MutationRootInsertQueuedSmsOneArgs = {
  object: QueuedSmsInsertInput;
  onConflict?: InputMaybe<QueuedSmsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRegionArgs = {
  objects: Array<RegionInsertInput>;
  onConflict?: InputMaybe<RegionOnConflict>;
};


/** mutation root */
export type MutationRootInsertRegionOneArgs = {
  object: RegionInsertInput;
  onConflict?: InputMaybe<RegionOnConflict>;
};


/** mutation root */
export type MutationRootInsertReviewPresentationArgs = {
  objects: Array<ReviewPresentationInsertInput>;
  onConflict?: InputMaybe<ReviewPresentationOnConflict>;
};


/** mutation root */
export type MutationRootInsertReviewPresentationOneArgs = {
  object: ReviewPresentationInsertInput;
  onConflict?: InputMaybe<ReviewPresentationOnConflict>;
};


/** mutation root */
export type MutationRootInsertSlugRedirectArgs = {
  objects: Array<SlugRedirectInsertInput>;
  onConflict?: InputMaybe<SlugRedirectOnConflict>;
};


/** mutation root */
export type MutationRootInsertSlugRedirectOneArgs = {
  object: SlugRedirectInsertInput;
  onConflict?: InputMaybe<SlugRedirectOnConflict>;
};


/** mutation root */
export type MutationRootInsertSolicitationArgs = {
  objects: Array<SolicitationInsertInput>;
  onConflict?: InputMaybe<SolicitationOnConflict>;
};


/** mutation root */
export type MutationRootInsertSolicitationOneArgs = {
  object: SolicitationInsertInput;
  onConflict?: InputMaybe<SolicitationOnConflict>;
};


/** mutation root */
export type MutationRootInsertSolicitationStatArgs = {
  objects: Array<SolicitationStatInsertInput>;
};


/** mutation root */
export type MutationRootInsertSolicitationStatOneArgs = {
  object: SolicitationStatInsertInput;
};


/** mutation root */
export type MutationRootInsertSpatialRefSysArgs = {
  objects: Array<SpatialRefSysInsertInput>;
  onConflict?: InputMaybe<SpatialRefSysOnConflict>;
};


/** mutation root */
export type MutationRootInsertSpatialRefSysOneArgs = {
  object: SpatialRefSysInsertInput;
  onConflict?: InputMaybe<SpatialRefSysOnConflict>;
};


/** mutation root */
export type MutationRootInsertStopSmsArgs = {
  objects: Array<StopSmsInsertInput>;
  onConflict?: InputMaybe<StopSmsOnConflict>;
};


/** mutation root */
export type MutationRootInsertStopSmsOneArgs = {
  object: StopSmsInsertInput;
  onConflict?: InputMaybe<StopSmsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSubscriptionArgs = {
  objects: Array<SubscriptionInsertInput>;
  onConflict?: InputMaybe<SubscriptionOnConflict>;
};


/** mutation root */
export type MutationRootInsertSubscriptionOneArgs = {
  object: SubscriptionInsertInput;
  onConflict?: InputMaybe<SubscriptionOnConflict>;
};


/** mutation root */
export type MutationRootInsertTopologyLayerArgs = {
  objects: Array<TopologyLayerInsertInput>;
  onConflict?: InputMaybe<TopologyLayerOnConflict>;
};


/** mutation root */
export type MutationRootInsertTopologyLayerOneArgs = {
  object: TopologyLayerInsertInput;
  onConflict?: InputMaybe<TopologyLayerOnConflict>;
};


/** mutation root */
export type MutationRootInsertTopologyTopologyArgs = {
  objects: Array<TopologyTopologyInsertInput>;
  onConflict?: InputMaybe<TopologyTopologyOnConflict>;
};


/** mutation root */
export type MutationRootInsertTopologyTopologyOneArgs = {
  object: TopologyTopologyInsertInput;
  onConflict?: InputMaybe<TopologyTopologyOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeArgs = {
  objects: Array<TradeInsertInput>;
  onConflict?: InputMaybe<TradeOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeGroupArgs = {
  objects: Array<TradeGroupInsertInput>;
  onConflict?: InputMaybe<TradeGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeGroupOneArgs = {
  object: TradeGroupInsertInput;
  onConflict?: InputMaybe<TradeGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeGuideArgs = {
  objects: Array<TradeGuideInsertInput>;
  onConflict?: InputMaybe<TradeGuideOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeGuideOneArgs = {
  object: TradeGuideInsertInput;
  onConflict?: InputMaybe<TradeGuideOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeKeywordArgs = {
  objects: Array<TradeKeywordInsertInput>;
  onConflict?: InputMaybe<TradeKeywordOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeKeywordOneArgs = {
  object: TradeKeywordInsertInput;
  onConflict?: InputMaybe<TradeKeywordOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeOneArgs = {
  object: TradeInsertInput;
  onConflict?: InputMaybe<TradeOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeProPresentationArgs = {
  objects: Array<TradeProPresentationInsertInput>;
  onConflict?: InputMaybe<TradeProPresentationOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeProPresentationOneArgs = {
  object: TradeProPresentationInsertInput;
  onConflict?: InputMaybe<TradeProPresentationOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeProViewArgs = {
  objects: Array<TradeProViewInsertInput>;
  onConflict?: InputMaybe<TradeProViewOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeProViewOneArgs = {
  object: TradeProViewInsertInput;
  onConflict?: InputMaybe<TradeProViewOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeQuestionArgs = {
  objects: Array<TradeQuestionInsertInput>;
  onConflict?: InputMaybe<TradeQuestionOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeQuestionOneArgs = {
  object: TradeQuestionInsertInput;
  onConflict?: InputMaybe<TradeQuestionOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeTradeGroupArgs = {
  objects: Array<TradeTradeGroupInsertInput>;
  onConflict?: InputMaybe<TradeTradeGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeTradeGroupOneArgs = {
  object: TradeTradeGroupInsertInput;
  onConflict?: InputMaybe<TradeTradeGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeTradeGuideArgs = {
  objects: Array<TradeTradeGuideInsertInput>;
  onConflict?: InputMaybe<TradeTradeGuideOnConflict>;
};


/** mutation root */
export type MutationRootInsertTradeTradeGuideOneArgs = {
  object: TradeTradeGuideInsertInput;
  onConflict?: InputMaybe<TradeTradeGuideOnConflict>;
};


/** mutation root */
export type MutationRootInsertUtmRecordArgs = {
  objects: Array<UtmRecordInsertInput>;
  onConflict?: InputMaybe<UtmRecordOnConflict>;
};


/** mutation root */
export type MutationRootInsertUtmRecordOneArgs = {
  object: UtmRecordInsertInput;
  onConflict?: InputMaybe<UtmRecordOnConflict>;
};


/** mutation root */
export type MutationRootInsertZohoConsumerArgs = {
  objects: Array<ZohoConsumerInsertInput>;
  onConflict?: InputMaybe<ZohoConsumerOnConflict>;
};


/** mutation root */
export type MutationRootInsertZohoConsumerOneArgs = {
  object: ZohoConsumerInsertInput;
  onConflict?: InputMaybe<ZohoConsumerOnConflict>;
};


/** mutation root */
export type MutationRootInsertZohoOrganizationArgs = {
  objects: Array<ZohoOrganizationInsertInput>;
  onConflict?: InputMaybe<ZohoOrganizationOnConflict>;
};


/** mutation root */
export type MutationRootInsertZohoOrganizationOneArgs = {
  object: ZohoOrganizationInsertInput;
  onConflict?: InputMaybe<ZohoOrganizationOnConflict>;
};


/** mutation root */
export type MutationRootInsertZohoTokenArgs = {
  objects: Array<ZohoTokenInsertInput>;
  onConflict?: InputMaybe<ZohoTokenOnConflict>;
};


/** mutation root */
export type MutationRootInsertZohoTokenOneArgs = {
  object: ZohoTokenInsertInput;
  onConflict?: InputMaybe<ZohoTokenOnConflict>;
};


/** mutation root */
export type MutationRootSequenceNextvalArgs = {
  args: SequenceNextvalArgs;
  distinctOn?: InputMaybe<Array<NextvalSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NextvalOrderBy>>;
  where?: InputMaybe<NextvalBoolExp>;
};


/** mutation root */
export type MutationRootUpdateAccountProViewArgs = {
  _inc?: InputMaybe<AccountProViewIncInput>;
  _set?: InputMaybe<AccountProViewSetInput>;
  where: AccountProViewBoolExp;
};


/** mutation root */
export type MutationRootUpdateAccountProViewByPkArgs = {
  _inc?: InputMaybe<AccountProViewIncInput>;
  _set?: InputMaybe<AccountProViewSetInput>;
  pkColumns: AccountProViewPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAccountProViewManyArgs = {
  updates: Array<AccountProViewUpdates>;
};


/** mutation root */
export type MutationRootUpdateActionTokenArgs = {
  _inc?: InputMaybe<ActionTokenIncInput>;
  _set?: InputMaybe<ActionTokenSetInput>;
  where: ActionTokenBoolExp;
};


/** mutation root */
export type MutationRootUpdateActionTokenByPkArgs = {
  _inc?: InputMaybe<ActionTokenIncInput>;
  _set?: InputMaybe<ActionTokenSetInput>;
  pkColumns: ActionTokenPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateActionTokenManyArgs = {
  updates: Array<ActionTokenUpdates>;
};


/** mutation root */
export type MutationRootUpdateAnnouncementArgs = {
  _inc?: InputMaybe<AnnouncementIncInput>;
  _set?: InputMaybe<AnnouncementSetInput>;
  where: AnnouncementBoolExp;
};


/** mutation root */
export type MutationRootUpdateAnnouncementByPkArgs = {
  _inc?: InputMaybe<AnnouncementIncInput>;
  _set?: InputMaybe<AnnouncementSetInput>;
  pkColumns: AnnouncementPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAnnouncementManyArgs = {
  updates: Array<AnnouncementUpdates>;
};


/** mutation root */
export type MutationRootUpdateAutorespondArgs = {
  _inc?: InputMaybe<AutorespondIncInput>;
  _set?: InputMaybe<AutorespondSetInput>;
  where: AutorespondBoolExp;
};


/** mutation root */
export type MutationRootUpdateAutorespondByPkArgs = {
  _inc?: InputMaybe<AutorespondIncInput>;
  _set?: InputMaybe<AutorespondSetInput>;
  pkColumns: AutorespondPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAutorespondManyArgs = {
  updates: Array<AutorespondUpdates>;
};


/** mutation root */
export type MutationRootUpdateBilikPersonArgs = {
  _inc?: InputMaybe<BilikPersonIncInput>;
  _set?: InputMaybe<BilikPersonSetInput>;
  where: BilikPersonBoolExp;
};


/** mutation root */
export type MutationRootUpdateBilikPersonByPkArgs = {
  _inc?: InputMaybe<BilikPersonIncInput>;
  _set?: InputMaybe<BilikPersonSetInput>;
  pkColumns: BilikPersonPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBilikPersonManyArgs = {
  updates: Array<BilikPersonUpdates>;
};


/** mutation root */
export type MutationRootUpdateBilikSolicitationArgs = {
  _inc?: InputMaybe<BilikSolicitationIncInput>;
  _set?: InputMaybe<BilikSolicitationSetInput>;
  where: BilikSolicitationBoolExp;
};


/** mutation root */
export type MutationRootUpdateBilikSolicitationByPkArgs = {
  _inc?: InputMaybe<BilikSolicitationIncInput>;
  _set?: InputMaybe<BilikSolicitationSetInput>;
  pkColumns: BilikSolicitationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBilikSolicitationManyArgs = {
  updates: Array<BilikSolicitationUpdates>;
};


/** mutation root */
export type MutationRootUpdateBilikZoneArgs = {
  _append?: InputMaybe<BilikZoneAppendInput>;
  _deleteAtPath?: InputMaybe<BilikZoneDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BilikZoneDeleteElemInput>;
  _deleteKey?: InputMaybe<BilikZoneDeleteKeyInput>;
  _inc?: InputMaybe<BilikZoneIncInput>;
  _prepend?: InputMaybe<BilikZonePrependInput>;
  _set?: InputMaybe<BilikZoneSetInput>;
  where: BilikZoneBoolExp;
};


/** mutation root */
export type MutationRootUpdateBilikZoneByPkArgs = {
  _append?: InputMaybe<BilikZoneAppendInput>;
  _deleteAtPath?: InputMaybe<BilikZoneDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BilikZoneDeleteElemInput>;
  _deleteKey?: InputMaybe<BilikZoneDeleteKeyInput>;
  _inc?: InputMaybe<BilikZoneIncInput>;
  _prepend?: InputMaybe<BilikZonePrependInput>;
  _set?: InputMaybe<BilikZoneSetInput>;
  pkColumns: BilikZonePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBilikZoneManyArgs = {
  updates: Array<BilikZoneUpdates>;
};


/** mutation root */
export type MutationRootUpdateCertificationArgs = {
  _inc?: InputMaybe<CertificationIncInput>;
  _set?: InputMaybe<CertificationSetInput>;
  where: CertificationBoolExp;
};


/** mutation root */
export type MutationRootUpdateCertificationByPkArgs = {
  _inc?: InputMaybe<CertificationIncInput>;
  _set?: InputMaybe<CertificationSetInput>;
  pkColumns: CertificationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCertificationManyArgs = {
  updates: Array<CertificationUpdates>;
};


/** mutation root */
export type MutationRootUpdateCityArgs = {
  _append?: InputMaybe<CityAppendInput>;
  _deleteAtPath?: InputMaybe<CityDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CityDeleteElemInput>;
  _deleteKey?: InputMaybe<CityDeleteKeyInput>;
  _inc?: InputMaybe<CityIncInput>;
  _prepend?: InputMaybe<CityPrependInput>;
  _set?: InputMaybe<CitySetInput>;
  where: CityBoolExp;
};


/** mutation root */
export type MutationRootUpdateCityByPkArgs = {
  _append?: InputMaybe<CityAppendInput>;
  _deleteAtPath?: InputMaybe<CityDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CityDeleteElemInput>;
  _deleteKey?: InputMaybe<CityDeleteKeyInput>;
  _inc?: InputMaybe<CityIncInput>;
  _prepend?: InputMaybe<CityPrependInput>;
  _set?: InputMaybe<CitySetInput>;
  pkColumns: CityPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCityManyArgs = {
  updates: Array<CityUpdates>;
};


/** mutation root */
export type MutationRootUpdateCityProViewArgs = {
  _inc?: InputMaybe<CityProViewIncInput>;
  _set?: InputMaybe<CityProViewSetInput>;
  where: CityProViewBoolExp;
};


/** mutation root */
export type MutationRootUpdateCityProViewByPkArgs = {
  _inc?: InputMaybe<CityProViewIncInput>;
  _set?: InputMaybe<CityProViewSetInput>;
  pkColumns: CityProViewPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCityProViewManyArgs = {
  updates: Array<CityProViewUpdates>;
};


/** mutation root */
export type MutationRootUpdateCompanyArgs = {
  _inc?: InputMaybe<CompanyIncInput>;
  _set?: InputMaybe<CompanySetInput>;
  where: CompanyBoolExp;
};


/** mutation root */
export type MutationRootUpdateCompanyByPkArgs = {
  _inc?: InputMaybe<CompanyIncInput>;
  _set?: InputMaybe<CompanySetInput>;
  pkColumns: CompanyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCompanyManyArgs = {
  updates: Array<CompanyUpdates>;
};


/** mutation root */
export type MutationRootUpdateDepartmentArgs = {
  _inc?: InputMaybe<DepartmentIncInput>;
  _set?: InputMaybe<DepartmentSetInput>;
  where: DepartmentBoolExp;
};


/** mutation root */
export type MutationRootUpdateDepartmentByPkArgs = {
  _inc?: InputMaybe<DepartmentIncInput>;
  _set?: InputMaybe<DepartmentSetInput>;
  pkColumns: DepartmentPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDepartmentManyArgs = {
  updates: Array<DepartmentUpdates>;
};


/** mutation root */
export type MutationRootUpdateGeometryColumnsArgs = {
  _inc?: InputMaybe<GeometryColumnsIncInput>;
  _set?: InputMaybe<GeometryColumnsSetInput>;
  where: GeometryColumnsBoolExp;
};


/** mutation root */
export type MutationRootUpdateGeometryColumnsManyArgs = {
  updates: Array<GeometryColumnsUpdates>;
};


/** mutation root */
export type MutationRootUpdateGloballyBlockedIdentityArgs = {
  _inc?: InputMaybe<GloballyBlockedIdentityIncInput>;
  _set?: InputMaybe<GloballyBlockedIdentitySetInput>;
  where: GloballyBlockedIdentityBoolExp;
};


/** mutation root */
export type MutationRootUpdateGloballyBlockedIdentityByPkArgs = {
  _inc?: InputMaybe<GloballyBlockedIdentityIncInput>;
  _set?: InputMaybe<GloballyBlockedIdentitySetInput>;
  pkColumns: GloballyBlockedIdentityPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGloballyBlockedIdentityManyArgs = {
  updates: Array<GloballyBlockedIdentityUpdates>;
};


/** mutation root */
export type MutationRootUpdateGoogleReviewLinkArgs = {
  _inc?: InputMaybe<GoogleReviewLinkIncInput>;
  _set?: InputMaybe<GoogleReviewLinkSetInput>;
  where: GoogleReviewLinkBoolExp;
};


/** mutation root */
export type MutationRootUpdateGoogleReviewLinkByPkArgs = {
  _inc?: InputMaybe<GoogleReviewLinkIncInput>;
  _set?: InputMaybe<GoogleReviewLinkSetInput>;
  pkColumns: GoogleReviewLinkPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGoogleReviewLinkManyArgs = {
  updates: Array<GoogleReviewLinkUpdates>;
};


/** mutation root */
export type MutationRootUpdateManagerBilikPersonBilikZoneArgs = {
  _inc?: InputMaybe<ManagerBilikPersonBilikZoneIncInput>;
  _set?: InputMaybe<ManagerBilikPersonBilikZoneSetInput>;
  where: ManagerBilikPersonBilikZoneBoolExp;
};


/** mutation root */
export type MutationRootUpdateManagerBilikPersonBilikZoneByPkArgs = {
  _inc?: InputMaybe<ManagerBilikPersonBilikZoneIncInput>;
  _set?: InputMaybe<ManagerBilikPersonBilikZoneSetInput>;
  pkColumns: ManagerBilikPersonBilikZonePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateManagerBilikPersonBilikZoneManyArgs = {
  updates: Array<ManagerBilikPersonBilikZoneUpdates>;
};


/** mutation root */
export type MutationRootUpdateMemberBilikPersonBilikZoneArgs = {
  _inc?: InputMaybe<MemberBilikPersonBilikZoneIncInput>;
  _set?: InputMaybe<MemberBilikPersonBilikZoneSetInput>;
  where: MemberBilikPersonBilikZoneBoolExp;
};


/** mutation root */
export type MutationRootUpdateMemberBilikPersonBilikZoneByPkArgs = {
  _inc?: InputMaybe<MemberBilikPersonBilikZoneIncInput>;
  _set?: InputMaybe<MemberBilikPersonBilikZoneSetInput>;
  pkColumns: MemberBilikPersonBilikZonePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMemberBilikPersonBilikZoneManyArgs = {
  updates: Array<MemberBilikPersonBilikZoneUpdates>;
};


/** mutation root */
export type MutationRootUpdateNearestProViewArgs = {
  _inc?: InputMaybe<NearestProViewIncInput>;
  _set?: InputMaybe<NearestProViewSetInput>;
  where: NearestProViewBoolExp;
};


/** mutation root */
export type MutationRootUpdateNearestProViewManyArgs = {
  updates: Array<NearestProViewUpdates>;
};


/** mutation root */
export type MutationRootUpdateNextvalArgs = {
  _inc?: InputMaybe<NextvalIncInput>;
  _set?: InputMaybe<NextvalSetInput>;
  where: NextvalBoolExp;
};


/** mutation root */
export type MutationRootUpdateNextvalManyArgs = {
  updates: Array<NextvalUpdates>;
};


/** mutation root */
export type MutationRootUpdateNoteIdentityArgs = {
  _inc?: InputMaybe<NoteIdentityIncInput>;
  _set?: InputMaybe<NoteIdentitySetInput>;
  where: NoteIdentityBoolExp;
};


/** mutation root */
export type MutationRootUpdateNoteIdentityByPkArgs = {
  _inc?: InputMaybe<NoteIdentityIncInput>;
  _set?: InputMaybe<NoteIdentitySetInput>;
  pkColumns: NoteIdentityPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateNoteIdentityManyArgs = {
  updates: Array<NoteIdentityUpdates>;
};


/** mutation root */
export type MutationRootUpdatePennylaneCompanyMappingArgs = {
  _inc?: InputMaybe<PennylaneCompanyMappingIncInput>;
  _set?: InputMaybe<PennylaneCompanyMappingSetInput>;
  where: PennylaneCompanyMappingBoolExp;
};


/** mutation root */
export type MutationRootUpdatePennylaneCompanyMappingByPkArgs = {
  _inc?: InputMaybe<PennylaneCompanyMappingIncInput>;
  _set?: InputMaybe<PennylaneCompanyMappingSetInput>;
  pkColumns: PennylaneCompanyMappingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdatePennylaneCompanyMappingManyArgs = {
  updates: Array<PennylaneCompanyMappingUpdates>;
};


/** mutation root */
export type MutationRootUpdatePhoneNumberArgs = {
  _inc?: InputMaybe<PhoneNumberIncInput>;
  _set?: InputMaybe<PhoneNumberSetInput>;
  where: PhoneNumberBoolExp;
};


/** mutation root */
export type MutationRootUpdatePhoneNumberByPkArgs = {
  _inc?: InputMaybe<PhoneNumberIncInput>;
  _set?: InputMaybe<PhoneNumberSetInput>;
  pkColumns: PhoneNumberPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdatePhoneNumberManyArgs = {
  updates: Array<PhoneNumberUpdates>;
};


/** mutation root */
export type MutationRootUpdateProCertificationArgs = {
  _inc?: InputMaybe<ProCertificationIncInput>;
  _set?: InputMaybe<ProCertificationSetInput>;
  where: ProCertificationBoolExp;
};


/** mutation root */
export type MutationRootUpdateProCertificationByPkArgs = {
  _inc?: InputMaybe<ProCertificationIncInput>;
  _set?: InputMaybe<ProCertificationSetInput>;
  pkColumns: ProCertificationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProCertificationManyArgs = {
  updates: Array<ProCertificationUpdates>;
};


/** mutation root */
export type MutationRootUpdateProHolidayArgs = {
  _inc?: InputMaybe<ProHolidayIncInput>;
  _set?: InputMaybe<ProHolidaySetInput>;
  where: ProHolidayBoolExp;
};


/** mutation root */
export type MutationRootUpdateProHolidayByPkArgs = {
  _inc?: InputMaybe<ProHolidayIncInput>;
  _set?: InputMaybe<ProHolidaySetInput>;
  pkColumns: ProHolidayPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProHolidayManyArgs = {
  updates: Array<ProHolidayUpdates>;
};


/** mutation root */
export type MutationRootUpdateProLabelArgs = {
  _inc?: InputMaybe<ProLabelIncInput>;
  _set?: InputMaybe<ProLabelSetInput>;
  where: ProLabelBoolExp;
};


/** mutation root */
export type MutationRootUpdateProLabelByPkArgs = {
  _inc?: InputMaybe<ProLabelIncInput>;
  _set?: InputMaybe<ProLabelSetInput>;
  pkColumns: ProLabelPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProLabelManyArgs = {
  updates: Array<ProLabelUpdates>;
};


/** mutation root */
export type MutationRootUpdateProMandateArgs = {
  _append?: InputMaybe<ProMandateAppendInput>;
  _deleteAtPath?: InputMaybe<ProMandateDeleteAtPathInput>;
  _deleteElem?: InputMaybe<ProMandateDeleteElemInput>;
  _deleteKey?: InputMaybe<ProMandateDeleteKeyInput>;
  _inc?: InputMaybe<ProMandateIncInput>;
  _prepend?: InputMaybe<ProMandatePrependInput>;
  _set?: InputMaybe<ProMandateSetInput>;
  where: ProMandateBoolExp;
};


/** mutation root */
export type MutationRootUpdateProMandateByPkArgs = {
  _append?: InputMaybe<ProMandateAppendInput>;
  _deleteAtPath?: InputMaybe<ProMandateDeleteAtPathInput>;
  _deleteElem?: InputMaybe<ProMandateDeleteElemInput>;
  _deleteKey?: InputMaybe<ProMandateDeleteKeyInput>;
  _inc?: InputMaybe<ProMandateIncInput>;
  _prepend?: InputMaybe<ProMandatePrependInput>;
  _set?: InputMaybe<ProMandateSetInput>;
  pkColumns: ProMandatePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProMandateManyArgs = {
  updates: Array<ProMandateUpdates>;
};


/** mutation root */
export type MutationRootUpdateProMediaObjectArgs = {
  _inc?: InputMaybe<ProMediaObjectIncInput>;
  _set?: InputMaybe<ProMediaObjectSetInput>;
  where: ProMediaObjectBoolExp;
};


/** mutation root */
export type MutationRootUpdateProMediaObjectByPkArgs = {
  _inc?: InputMaybe<ProMediaObjectIncInput>;
  _set?: InputMaybe<ProMediaObjectSetInput>;
  pkColumns: ProMediaObjectPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProMediaObjectManyArgs = {
  updates: Array<ProMediaObjectUpdates>;
};


/** mutation root */
export type MutationRootUpdateProMessageArgs = {
  _inc?: InputMaybe<ProMessageIncInput>;
  _set?: InputMaybe<ProMessageSetInput>;
  where: ProMessageBoolExp;
};


/** mutation root */
export type MutationRootUpdateProMessageByPkArgs = {
  _inc?: InputMaybe<ProMessageIncInput>;
  _set?: InputMaybe<ProMessageSetInput>;
  pkColumns: ProMessagePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProMessageManyArgs = {
  updates: Array<ProMessageUpdates>;
};


/** mutation root */
export type MutationRootUpdateProPersonArgs = {
  _inc?: InputMaybe<ProPersonIncInput>;
  _set?: InputMaybe<ProPersonSetInput>;
  where: ProPersonBoolExp;
};


/** mutation root */
export type MutationRootUpdateProPersonByPkArgs = {
  _inc?: InputMaybe<ProPersonIncInput>;
  _set?: InputMaybe<ProPersonSetInput>;
  pkColumns: ProPersonPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProPersonManyArgs = {
  updates: Array<ProPersonUpdates>;
};


/** mutation root */
export type MutationRootUpdateProPostalAddressArgs = {
  _inc?: InputMaybe<ProPostalAddressIncInput>;
  _set?: InputMaybe<ProPostalAddressSetInput>;
  where: ProPostalAddressBoolExp;
};


/** mutation root */
export type MutationRootUpdateProPostalAddressByPkArgs = {
  _inc?: InputMaybe<ProPostalAddressIncInput>;
  _set?: InputMaybe<ProPostalAddressSetInput>;
  pkColumns: ProPostalAddressPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProPostalAddressManyArgs = {
  updates: Array<ProPostalAddressUpdates>;
};


/** mutation root */
export type MutationRootUpdateProPresentationArgs = {
  _inc?: InputMaybe<ProPresentationIncInput>;
  _set?: InputMaybe<ProPresentationSetInput>;
  where: ProPresentationBoolExp;
};


/** mutation root */
export type MutationRootUpdateProPresentationByPkArgs = {
  _inc?: InputMaybe<ProPresentationIncInput>;
  _set?: InputMaybe<ProPresentationSetInput>;
  pkColumns: ProPresentationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProPresentationManyArgs = {
  updates: Array<ProPresentationUpdates>;
};


/** mutation root */
export type MutationRootUpdateProPriceArgs = {
  _inc?: InputMaybe<ProPriceIncInput>;
  _set?: InputMaybe<ProPriceSetInput>;
  where: ProPriceBoolExp;
};


/** mutation root */
export type MutationRootUpdateProPriceByPkArgs = {
  _inc?: InputMaybe<ProPriceIncInput>;
  _set?: InputMaybe<ProPriceSetInput>;
  pkColumns: ProPricePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProPriceManyArgs = {
  updates: Array<ProPriceUpdates>;
};


/** mutation root */
export type MutationRootUpdateProReviewArgs = {
  _inc?: InputMaybe<ProReviewIncInput>;
  _set?: InputMaybe<ProReviewSetInput>;
  where: ProReviewBoolExp;
};


/** mutation root */
export type MutationRootUpdateProReviewByPkArgs = {
  _inc?: InputMaybe<ProReviewIncInput>;
  _set?: InputMaybe<ProReviewSetInput>;
  pkColumns: ProReviewPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProReviewInvitationArgs = {
  _inc?: InputMaybe<ProReviewInvitationIncInput>;
  _set?: InputMaybe<ProReviewInvitationSetInput>;
  where: ProReviewInvitationBoolExp;
};


/** mutation root */
export type MutationRootUpdateProReviewInvitationByPkArgs = {
  _inc?: InputMaybe<ProReviewInvitationIncInput>;
  _set?: InputMaybe<ProReviewInvitationSetInput>;
  pkColumns: ProReviewInvitationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProReviewInvitationManyArgs = {
  updates: Array<ProReviewInvitationUpdates>;
};


/** mutation root */
export type MutationRootUpdateProReviewManyArgs = {
  updates: Array<ProReviewUpdates>;
};


/** mutation root */
export type MutationRootUpdateProViewArgs = {
  _append?: InputMaybe<ProViewAppendInput>;
  _deleteAtPath?: InputMaybe<ProViewDeleteAtPathInput>;
  _deleteElem?: InputMaybe<ProViewDeleteElemInput>;
  _deleteKey?: InputMaybe<ProViewDeleteKeyInput>;
  _inc?: InputMaybe<ProViewIncInput>;
  _prepend?: InputMaybe<ProViewPrependInput>;
  _set?: InputMaybe<ProViewSetInput>;
  where: ProViewBoolExp;
};


/** mutation root */
export type MutationRootUpdateProViewByPkArgs = {
  _append?: InputMaybe<ProViewAppendInput>;
  _deleteAtPath?: InputMaybe<ProViewDeleteAtPathInput>;
  _deleteElem?: InputMaybe<ProViewDeleteElemInput>;
  _deleteKey?: InputMaybe<ProViewDeleteKeyInput>;
  _inc?: InputMaybe<ProViewIncInput>;
  _prepend?: InputMaybe<ProViewPrependInput>;
  _set?: InputMaybe<ProViewSetInput>;
  pkColumns: ProViewPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProViewManyArgs = {
  updates: Array<ProViewUpdates>;
};


/** mutation root */
export type MutationRootUpdateProViewProPersonArgs = {
  _inc?: InputMaybe<ProViewProPersonIncInput>;
  _set?: InputMaybe<ProViewProPersonSetInput>;
  where: ProViewProPersonBoolExp;
};


/** mutation root */
export type MutationRootUpdateProViewProPersonByPkArgs = {
  _inc?: InputMaybe<ProViewProPersonIncInput>;
  _set?: InputMaybe<ProViewProPersonSetInput>;
  pkColumns: ProViewProPersonPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProViewProPersonManyArgs = {
  updates: Array<ProViewProPersonUpdates>;
};


/** mutation root */
export type MutationRootUpdateProViewProViewArgs = {
  _inc?: InputMaybe<ProViewProViewIncInput>;
  _set?: InputMaybe<ProViewProViewSetInput>;
  where: ProViewProViewBoolExp;
};


/** mutation root */
export type MutationRootUpdateProViewProViewByPkArgs = {
  _inc?: InputMaybe<ProViewProViewIncInput>;
  _set?: InputMaybe<ProViewProViewSetInput>;
  pkColumns: ProViewProViewPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProViewProViewManyArgs = {
  updates: Array<ProViewProViewUpdates>;
};


/** mutation root */
export type MutationRootUpdateQueuedSmsArgs = {
  _inc?: InputMaybe<QueuedSmsIncInput>;
  _set?: InputMaybe<QueuedSmsSetInput>;
  where: QueuedSmsBoolExp;
};


/** mutation root */
export type MutationRootUpdateQueuedSmsByPkArgs = {
  _inc?: InputMaybe<QueuedSmsIncInput>;
  _set?: InputMaybe<QueuedSmsSetInput>;
  pkColumns: QueuedSmsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateQueuedSmsManyArgs = {
  updates: Array<QueuedSmsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRegionArgs = {
  _inc?: InputMaybe<RegionIncInput>;
  _set?: InputMaybe<RegionSetInput>;
  where: RegionBoolExp;
};


/** mutation root */
export type MutationRootUpdateRegionByPkArgs = {
  _inc?: InputMaybe<RegionIncInput>;
  _set?: InputMaybe<RegionSetInput>;
  pkColumns: RegionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRegionManyArgs = {
  updates: Array<RegionUpdates>;
};


/** mutation root */
export type MutationRootUpdateReviewPresentationArgs = {
  _inc?: InputMaybe<ReviewPresentationIncInput>;
  _set?: InputMaybe<ReviewPresentationSetInput>;
  where: ReviewPresentationBoolExp;
};


/** mutation root */
export type MutationRootUpdateReviewPresentationByPkArgs = {
  _inc?: InputMaybe<ReviewPresentationIncInput>;
  _set?: InputMaybe<ReviewPresentationSetInput>;
  pkColumns: ReviewPresentationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateReviewPresentationManyArgs = {
  updates: Array<ReviewPresentationUpdates>;
};


/** mutation root */
export type MutationRootUpdateSlugRedirectArgs = {
  _inc?: InputMaybe<SlugRedirectIncInput>;
  _set?: InputMaybe<SlugRedirectSetInput>;
  where: SlugRedirectBoolExp;
};


/** mutation root */
export type MutationRootUpdateSlugRedirectByPkArgs = {
  _inc?: InputMaybe<SlugRedirectIncInput>;
  _set?: InputMaybe<SlugRedirectSetInput>;
  pkColumns: SlugRedirectPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSlugRedirectManyArgs = {
  updates: Array<SlugRedirectUpdates>;
};


/** mutation root */
export type MutationRootUpdateSolicitationArgs = {
  _append?: InputMaybe<SolicitationAppendInput>;
  _deleteAtPath?: InputMaybe<SolicitationDeleteAtPathInput>;
  _deleteElem?: InputMaybe<SolicitationDeleteElemInput>;
  _deleteKey?: InputMaybe<SolicitationDeleteKeyInput>;
  _inc?: InputMaybe<SolicitationIncInput>;
  _prepend?: InputMaybe<SolicitationPrependInput>;
  _set?: InputMaybe<SolicitationSetInput>;
  where: SolicitationBoolExp;
};


/** mutation root */
export type MutationRootUpdateSolicitationByPkArgs = {
  _append?: InputMaybe<SolicitationAppendInput>;
  _deleteAtPath?: InputMaybe<SolicitationDeleteAtPathInput>;
  _deleteElem?: InputMaybe<SolicitationDeleteElemInput>;
  _deleteKey?: InputMaybe<SolicitationDeleteKeyInput>;
  _inc?: InputMaybe<SolicitationIncInput>;
  _prepend?: InputMaybe<SolicitationPrependInput>;
  _set?: InputMaybe<SolicitationSetInput>;
  pkColumns: SolicitationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSolicitationManyArgs = {
  updates: Array<SolicitationUpdates>;
};


/** mutation root */
export type MutationRootUpdateSolicitationStatArgs = {
  _inc?: InputMaybe<SolicitationStatIncInput>;
  _set?: InputMaybe<SolicitationStatSetInput>;
  where: SolicitationStatBoolExp;
};


/** mutation root */
export type MutationRootUpdateSolicitationStatManyArgs = {
  updates: Array<SolicitationStatUpdates>;
};


/** mutation root */
export type MutationRootUpdateSpatialRefSysArgs = {
  _inc?: InputMaybe<SpatialRefSysIncInput>;
  _set?: InputMaybe<SpatialRefSysSetInput>;
  where: SpatialRefSysBoolExp;
};


/** mutation root */
export type MutationRootUpdateSpatialRefSysByPkArgs = {
  _inc?: InputMaybe<SpatialRefSysIncInput>;
  _set?: InputMaybe<SpatialRefSysSetInput>;
  pkColumns: SpatialRefSysPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSpatialRefSysManyArgs = {
  updates: Array<SpatialRefSysUpdates>;
};


/** mutation root */
export type MutationRootUpdateStopSmsArgs = {
  _inc?: InputMaybe<StopSmsIncInput>;
  _set?: InputMaybe<StopSmsSetInput>;
  where: StopSmsBoolExp;
};


/** mutation root */
export type MutationRootUpdateStopSmsByPkArgs = {
  _inc?: InputMaybe<StopSmsIncInput>;
  _set?: InputMaybe<StopSmsSetInput>;
  pkColumns: StopSmsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateStopSmsManyArgs = {
  updates: Array<StopSmsUpdates>;
};


/** mutation root */
export type MutationRootUpdateSubscriptionArgs = {
  _append?: InputMaybe<SubscriptionAppendInput>;
  _deleteAtPath?: InputMaybe<SubscriptionDeleteAtPathInput>;
  _deleteElem?: InputMaybe<SubscriptionDeleteElemInput>;
  _deleteKey?: InputMaybe<SubscriptionDeleteKeyInput>;
  _inc?: InputMaybe<SubscriptionIncInput>;
  _prepend?: InputMaybe<SubscriptionPrependInput>;
  _set?: InputMaybe<SubscriptionSetInput>;
  where: SubscriptionBoolExp;
};


/** mutation root */
export type MutationRootUpdateSubscriptionByPkArgs = {
  _append?: InputMaybe<SubscriptionAppendInput>;
  _deleteAtPath?: InputMaybe<SubscriptionDeleteAtPathInput>;
  _deleteElem?: InputMaybe<SubscriptionDeleteElemInput>;
  _deleteKey?: InputMaybe<SubscriptionDeleteKeyInput>;
  _inc?: InputMaybe<SubscriptionIncInput>;
  _prepend?: InputMaybe<SubscriptionPrependInput>;
  _set?: InputMaybe<SubscriptionSetInput>;
  pkColumns: SubscriptionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSubscriptionManyArgs = {
  updates: Array<SubscriptionUpdates>;
};


/** mutation root */
export type MutationRootUpdateTopologyLayerArgs = {
  _inc?: InputMaybe<TopologyLayerIncInput>;
  _set?: InputMaybe<TopologyLayerSetInput>;
  where: TopologyLayerBoolExp;
};


/** mutation root */
export type MutationRootUpdateTopologyLayerByPkArgs = {
  _inc?: InputMaybe<TopologyLayerIncInput>;
  _set?: InputMaybe<TopologyLayerSetInput>;
  pkColumns: TopologyLayerPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTopologyLayerManyArgs = {
  updates: Array<TopologyLayerUpdates>;
};


/** mutation root */
export type MutationRootUpdateTopologyTopologyArgs = {
  _inc?: InputMaybe<TopologyTopologyIncInput>;
  _set?: InputMaybe<TopologyTopologySetInput>;
  where: TopologyTopologyBoolExp;
};


/** mutation root */
export type MutationRootUpdateTopologyTopologyByPkArgs = {
  _inc?: InputMaybe<TopologyTopologyIncInput>;
  _set?: InputMaybe<TopologyTopologySetInput>;
  pkColumns: TopologyTopologyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTopologyTopologyManyArgs = {
  updates: Array<TopologyTopologyUpdates>;
};


/** mutation root */
export type MutationRootUpdateTradeArgs = {
  _inc?: InputMaybe<TradeIncInput>;
  _set?: InputMaybe<TradeSetInput>;
  where: TradeBoolExp;
};


/** mutation root */
export type MutationRootUpdateTradeByPkArgs = {
  _inc?: InputMaybe<TradeIncInput>;
  _set?: InputMaybe<TradeSetInput>;
  pkColumns: TradePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTradeGroupArgs = {
  _inc?: InputMaybe<TradeGroupIncInput>;
  _set?: InputMaybe<TradeGroupSetInput>;
  where: TradeGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateTradeGroupByPkArgs = {
  _inc?: InputMaybe<TradeGroupIncInput>;
  _set?: InputMaybe<TradeGroupSetInput>;
  pkColumns: TradeGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTradeGroupManyArgs = {
  updates: Array<TradeGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateTradeGuideArgs = {
  _inc?: InputMaybe<TradeGuideIncInput>;
  _set?: InputMaybe<TradeGuideSetInput>;
  where: TradeGuideBoolExp;
};


/** mutation root */
export type MutationRootUpdateTradeGuideByPkArgs = {
  _inc?: InputMaybe<TradeGuideIncInput>;
  _set?: InputMaybe<TradeGuideSetInput>;
  pkColumns: TradeGuidePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTradeGuideManyArgs = {
  updates: Array<TradeGuideUpdates>;
};


/** mutation root */
export type MutationRootUpdateTradeKeywordArgs = {
  _inc?: InputMaybe<TradeKeywordIncInput>;
  _set?: InputMaybe<TradeKeywordSetInput>;
  where: TradeKeywordBoolExp;
};


/** mutation root */
export type MutationRootUpdateTradeKeywordByPkArgs = {
  _inc?: InputMaybe<TradeKeywordIncInput>;
  _set?: InputMaybe<TradeKeywordSetInput>;
  pkColumns: TradeKeywordPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTradeKeywordManyArgs = {
  updates: Array<TradeKeywordUpdates>;
};


/** mutation root */
export type MutationRootUpdateTradeManyArgs = {
  updates: Array<TradeUpdates>;
};


/** mutation root */
export type MutationRootUpdateTradeProPresentationArgs = {
  _inc?: InputMaybe<TradeProPresentationIncInput>;
  _set?: InputMaybe<TradeProPresentationSetInput>;
  where: TradeProPresentationBoolExp;
};


/** mutation root */
export type MutationRootUpdateTradeProPresentationByPkArgs = {
  _inc?: InputMaybe<TradeProPresentationIncInput>;
  _set?: InputMaybe<TradeProPresentationSetInput>;
  pkColumns: TradeProPresentationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTradeProPresentationManyArgs = {
  updates: Array<TradeProPresentationUpdates>;
};


/** mutation root */
export type MutationRootUpdateTradeProViewArgs = {
  _inc?: InputMaybe<TradeProViewIncInput>;
  _set?: InputMaybe<TradeProViewSetInput>;
  where: TradeProViewBoolExp;
};


/** mutation root */
export type MutationRootUpdateTradeProViewByPkArgs = {
  _inc?: InputMaybe<TradeProViewIncInput>;
  _set?: InputMaybe<TradeProViewSetInput>;
  pkColumns: TradeProViewPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTradeProViewManyArgs = {
  updates: Array<TradeProViewUpdates>;
};


/** mutation root */
export type MutationRootUpdateTradeQuestionArgs = {
  _inc?: InputMaybe<TradeQuestionIncInput>;
  _set?: InputMaybe<TradeQuestionSetInput>;
  where: TradeQuestionBoolExp;
};


/** mutation root */
export type MutationRootUpdateTradeQuestionByPkArgs = {
  _inc?: InputMaybe<TradeQuestionIncInput>;
  _set?: InputMaybe<TradeQuestionSetInput>;
  pkColumns: TradeQuestionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTradeQuestionManyArgs = {
  updates: Array<TradeQuestionUpdates>;
};


/** mutation root */
export type MutationRootUpdateTradeTradeGroupArgs = {
  _inc?: InputMaybe<TradeTradeGroupIncInput>;
  _set?: InputMaybe<TradeTradeGroupSetInput>;
  where: TradeTradeGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateTradeTradeGroupByPkArgs = {
  _inc?: InputMaybe<TradeTradeGroupIncInput>;
  _set?: InputMaybe<TradeTradeGroupSetInput>;
  pkColumns: TradeTradeGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTradeTradeGroupManyArgs = {
  updates: Array<TradeTradeGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateTradeTradeGuideArgs = {
  _inc?: InputMaybe<TradeTradeGuideIncInput>;
  _set?: InputMaybe<TradeTradeGuideSetInput>;
  where: TradeTradeGuideBoolExp;
};


/** mutation root */
export type MutationRootUpdateTradeTradeGuideByPkArgs = {
  _inc?: InputMaybe<TradeTradeGuideIncInput>;
  _set?: InputMaybe<TradeTradeGuideSetInput>;
  pkColumns: TradeTradeGuidePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTradeTradeGuideManyArgs = {
  updates: Array<TradeTradeGuideUpdates>;
};


/** mutation root */
export type MutationRootUpdateUtmRecordArgs = {
  _inc?: InputMaybe<UtmRecordIncInput>;
  _set?: InputMaybe<UtmRecordSetInput>;
  where: UtmRecordBoolExp;
};


/** mutation root */
export type MutationRootUpdateUtmRecordByPkArgs = {
  _inc?: InputMaybe<UtmRecordIncInput>;
  _set?: InputMaybe<UtmRecordSetInput>;
  pkColumns: UtmRecordPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUtmRecordManyArgs = {
  updates: Array<UtmRecordUpdates>;
};


/** mutation root */
export type MutationRootUpdateZohoConsumerArgs = {
  _inc?: InputMaybe<ZohoConsumerIncInput>;
  _set?: InputMaybe<ZohoConsumerSetInput>;
  where: ZohoConsumerBoolExp;
};


/** mutation root */
export type MutationRootUpdateZohoConsumerByPkArgs = {
  _inc?: InputMaybe<ZohoConsumerIncInput>;
  _set?: InputMaybe<ZohoConsumerSetInput>;
  pkColumns: ZohoConsumerPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateZohoConsumerManyArgs = {
  updates: Array<ZohoConsumerUpdates>;
};


/** mutation root */
export type MutationRootUpdateZohoOrganizationArgs = {
  _inc?: InputMaybe<ZohoOrganizationIncInput>;
  _set?: InputMaybe<ZohoOrganizationSetInput>;
  where: ZohoOrganizationBoolExp;
};


/** mutation root */
export type MutationRootUpdateZohoOrganizationByPkArgs = {
  _inc?: InputMaybe<ZohoOrganizationIncInput>;
  _set?: InputMaybe<ZohoOrganizationSetInput>;
  pkColumns: ZohoOrganizationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateZohoOrganizationManyArgs = {
  updates: Array<ZohoOrganizationUpdates>;
};


/** mutation root */
export type MutationRootUpdateZohoTokenArgs = {
  _inc?: InputMaybe<ZohoTokenIncInput>;
  _set?: InputMaybe<ZohoTokenSetInput>;
  where: ZohoTokenBoolExp;
};


/** mutation root */
export type MutationRootUpdateZohoTokenByPkArgs = {
  _inc?: InputMaybe<ZohoTokenIncInput>;
  _set?: InputMaybe<ZohoTokenSetInput>;
  pkColumns: ZohoTokenPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateZohoTokenManyArgs = {
  updates: Array<ZohoTokenUpdates>;
};

export type NoteIdentityAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<NoteIdentitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NoteIdentityBoolExp>;
  predicate: IntComparisonExp;
};

export type PhoneNumberAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PhoneNumberBoolExp>;
  predicate: IntComparisonExp;
};

export type ProCertificationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProCertificationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProCertificationBoolExp>;
  predicate: IntComparisonExp;
};

export type ProHolidayAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProHolidaySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProHolidayBoolExp>;
  predicate: IntComparisonExp;
};

export type ProLabelAggregateBoolExpBoolAnd = {
  arguments: ProLabelSelectColumnProLabelAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProLabelBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProLabelAggregateBoolExpBoolOr = {
  arguments: ProLabelSelectColumnProLabelAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProLabelBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProLabelAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProLabelSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProLabelBoolExp>;
  predicate: IntComparisonExp;
};

export type ProMandateAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProMandateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProMandateBoolExp>;
  predicate: IntComparisonExp;
};

export type ProMediaObjectAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProMediaObjectSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProMediaObjectBoolExp>;
  predicate: IntComparisonExp;
};

export type ProMessageAggregateBoolExpBoolAnd = {
  arguments: ProMessageSelectColumnProMessageAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProMessageBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProMessageAggregateBoolExpBoolOr = {
  arguments: ProMessageSelectColumnProMessageAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProMessageBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProMessageAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProMessageSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProMessageBoolExp>;
  predicate: IntComparisonExp;
};

export type ProPresentationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProPresentationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProPresentationBoolExp>;
  predicate: IntComparisonExp;
};

export type ProPriceAggregateBoolExpBoolAnd = {
  arguments: ProPriceSelectColumnProPriceAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProPriceBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProPriceAggregateBoolExpBoolOr = {
  arguments: ProPriceSelectColumnProPriceAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProPriceBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProPriceAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProPriceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProPriceBoolExp>;
  predicate: IntComparisonExp;
};

export type ProReviewAggregateBoolExpBoolAnd = {
  arguments: ProReviewSelectColumnProReviewAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProReviewBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProReviewAggregateBoolExpBoolOr = {
  arguments: ProReviewSelectColumnProReviewAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProReviewBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProReviewAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProReviewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProReviewBoolExp>;
  predicate: IntComparisonExp;
};

export type ProReviewInvitationAggregateBoolExpBoolAnd = {
  arguments: ProReviewInvitationSelectColumnProReviewInvitationAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProReviewInvitationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProReviewInvitationAggregateBoolExpBoolOr = {
  arguments: ProReviewInvitationSelectColumnProReviewInvitationAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProReviewInvitationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProReviewInvitationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProReviewInvitationBoolExp>;
  predicate: IntComparisonExp;
};

export type ProViewAggregateBoolExpBoolAnd = {
  arguments: ProViewSelectColumnProViewAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProViewBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProViewAggregateBoolExpBoolOr = {
  arguments: ProViewSelectColumnProViewAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProViewBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProViewAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProViewBoolExp>;
  predicate: IntComparisonExp;
};

export type ProViewProPersonAggregateBoolExpBoolAnd = {
  arguments: ProViewProPersonSelectColumnProViewProPersonAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProViewProPersonBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProViewProPersonAggregateBoolExpBoolOr = {
  arguments: ProViewProPersonSelectColumnProViewProPersonAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProViewProPersonBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProViewProPersonAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProViewProPersonSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProViewProPersonBoolExp>;
  predicate: IntComparisonExp;
};

export type ProViewProViewAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProViewProViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProViewProViewBoolExp>;
  predicate: IntComparisonExp;
};

export type QueryRoot = {
  __typename?: 'query_root';
  /** fetch data from the table: "account_pro_view" */
  accountProView: Array<AccountProView>;
  /** fetch aggregated fields from the table: "account_pro_view" */
  accountProViewAggregate: AccountProViewAggregate;
  /** fetch data from the table: "account_pro_view" using primary key columns */
  accountProViewByPk?: Maybe<AccountProView>;
  /** fetch data from the table: "action_token" */
  actionToken: Array<ActionToken>;
  /** fetch aggregated fields from the table: "action_token" */
  actionTokenAggregate: ActionTokenAggregate;
  /** fetch data from the table: "action_token" using primary key columns */
  actionTokenByPk?: Maybe<ActionToken>;
  /** fetch data from the table: "announcement" */
  announcement: Array<Announcement>;
  /** fetch aggregated fields from the table: "announcement" */
  announcementAggregate: AnnouncementAggregate;
  /** fetch data from the table: "announcement" using primary key columns */
  announcementByPk?: Maybe<Announcement>;
  /** fetch data from the table: "autorespond" */
  autorespond: Array<Autorespond>;
  /** fetch aggregated fields from the table: "autorespond" */
  autorespondAggregate: AutorespondAggregate;
  /** fetch data from the table: "autorespond" using primary key columns */
  autorespondByPk?: Maybe<Autorespond>;
  /** fetch data from the table: "bilik_person" */
  bilikPerson: Array<BilikPerson>;
  /** fetch aggregated fields from the table: "bilik_person" */
  bilikPersonAggregate: BilikPersonAggregate;
  /** fetch data from the table: "bilik_person" using primary key columns */
  bilikPersonByPk?: Maybe<BilikPerson>;
  /** fetch data from the table: "bilik_solicitation" */
  bilikSolicitation: Array<BilikSolicitation>;
  /** fetch aggregated fields from the table: "bilik_solicitation" */
  bilikSolicitationAggregate: BilikSolicitationAggregate;
  /** fetch data from the table: "bilik_solicitation" using primary key columns */
  bilikSolicitationByPk?: Maybe<BilikSolicitation>;
  /** fetch data from the table: "bilik_zone" */
  bilikZone: Array<BilikZone>;
  /** fetch aggregated fields from the table: "bilik_zone" */
  bilikZoneAggregate: BilikZoneAggregate;
  /** fetch data from the table: "bilik_zone" using primary key columns */
  bilikZoneByPk?: Maybe<BilikZone>;
  /** fetch data from the table: "bilik_zone_outline" */
  bilikZoneOutline: Array<BilikZoneOutline>;
  /** fetch aggregated fields from the table: "bilik_zone_outline" */
  bilikZoneOutlineAggregate: BilikZoneOutlineAggregate;
  /** fetch data from the table: "bilik_zone_trade_main_pro_count" */
  bilikZoneTradeMainProCount: Array<BilikZoneTradeMainProCount>;
  /** fetch aggregated fields from the table: "bilik_zone_trade_main_pro_count" */
  bilikZoneTradeMainProCountAggregate: BilikZoneTradeMainProCountAggregate;
  /** fetch data from the table: "certification" */
  certification: Array<Certification>;
  /** fetch aggregated fields from the table: "certification" */
  certificationAggregate: CertificationAggregate;
  /** fetch data from the table: "certification" using primary key columns */
  certificationByPk?: Maybe<Certification>;
  /** fetch data from the table: "city" */
  city: Array<City>;
  /** fetch aggregated fields from the table: "city" */
  cityAggregate: CityAggregate;
  /** fetch data from the table: "city" using primary key columns */
  cityByPk?: Maybe<City>;
  /** fetch data from the table: "city_pro_view" */
  cityProView: Array<CityProView>;
  /** fetch aggregated fields from the table: "city_pro_view" */
  cityProViewAggregate: CityProViewAggregate;
  /** fetch data from the table: "city_pro_view" using primary key columns */
  cityProViewByPk?: Maybe<CityProView>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  companyAggregate: CompanyAggregate;
  /** fetch data from the table: "company" using primary key columns */
  companyByPk?: Maybe<Company>;
  /** fetch data from the table: "count_city_same_slug" */
  countCitySameSlug: Array<CountCitySameSlug>;
  /** fetch aggregated fields from the table: "count_city_same_slug" */
  countCitySameSlugAggregate: CountCitySameSlugAggregate;
  /** fetch data from the table: "count_pro_review_by_status" */
  countProReviewByStatus: Array<CountProReviewByStatus>;
  /** fetch aggregated fields from the table: "count_pro_review_by_status" */
  countProReviewByStatusAggregate: CountProReviewByStatusAggregate;
  /** fetch data from the table: "count_pro_review_invitations_by_month_by_pro_presentation" */
  countProReviewInvitationsByMonthByProPresentation: Array<CountProReviewInvitationsByMonthByProPresentation>;
  /** fetch aggregated fields from the table: "count_pro_review_invitations_by_month_by_pro_presentation" */
  countProReviewInvitationsByMonthByProPresentationAggregate: CountProReviewInvitationsByMonthByProPresentationAggregate;
  /** fetch data from the table: "count_pro_reviews_with_status_ok_by_month_by_pro_presentation" */
  countProReviewsWithStatusOkByMonthByProPresentation: Array<CountProReviewsWithStatusOkByMonthByProPresentation>;
  /** fetch aggregated fields from the table: "count_pro_reviews_with_status_ok_by_month_by_pro_presentation" */
  countProReviewsWithStatusOkByMonthByProPresentationAggregate: CountProReviewsWithStatusOkByMonthByProPresentationAggregate;
  /** fetch data from the table: "department" */
  department: Array<Department>;
  /** fetch aggregated fields from the table: "department" */
  departmentAggregate: DepartmentAggregate;
  /** fetch data from the table: "department" using primary key columns */
  departmentByPk?: Maybe<Department>;
  /** fetch data from the table: "geography_columns" */
  geographyColumns: Array<GeographyColumns>;
  /** fetch aggregated fields from the table: "geography_columns" */
  geographyColumnsAggregate: GeographyColumnsAggregate;
  /** fetch data from the table: "geometry_columns" */
  geometryColumns: Array<GeometryColumns>;
  /** fetch aggregated fields from the table: "geometry_columns" */
  geometryColumnsAggregate: GeometryColumnsAggregate;
  /** fetch data from the table: "globally_blocked_identity" */
  globallyBlockedIdentity: Array<GloballyBlockedIdentity>;
  /** fetch aggregated fields from the table: "globally_blocked_identity" */
  globallyBlockedIdentityAggregate: GloballyBlockedIdentityAggregate;
  /** fetch data from the table: "globally_blocked_identity" using primary key columns */
  globallyBlockedIdentityByPk?: Maybe<GloballyBlockedIdentity>;
  /** fetch data from the table: "google_review_link" */
  googleReviewLink: Array<GoogleReviewLink>;
  /** fetch aggregated fields from the table: "google_review_link" */
  googleReviewLinkAggregate: GoogleReviewLinkAggregate;
  /** fetch data from the table: "google_review_link" using primary key columns */
  googleReviewLinkByPk?: Maybe<GoogleReviewLink>;
  /** fetch data from the table: "manager_bilik_person_bilik_zone" */
  managerBilikPersonBilikZone: Array<ManagerBilikPersonBilikZone>;
  /** fetch aggregated fields from the table: "manager_bilik_person_bilik_zone" */
  managerBilikPersonBilikZoneAggregate: ManagerBilikPersonBilikZoneAggregate;
  /** fetch data from the table: "manager_bilik_person_bilik_zone" using primary key columns */
  managerBilikPersonBilikZoneByPk?: Maybe<ManagerBilikPersonBilikZone>;
  /** fetch data from the table: "member_bilik_person_bilik_zone" */
  memberBilikPersonBilikZone: Array<MemberBilikPersonBilikZone>;
  /** fetch aggregated fields from the table: "member_bilik_person_bilik_zone" */
  memberBilikPersonBilikZoneAggregate: MemberBilikPersonBilikZoneAggregate;
  /** fetch data from the table: "member_bilik_person_bilik_zone" using primary key columns */
  memberBilikPersonBilikZoneByPk?: Maybe<MemberBilikPersonBilikZone>;
  /** fetch data from the table: "nearest_pro_view" */
  nearestProView: Array<NearestProView>;
  /** fetch aggregated fields from the table: "nearest_pro_view" */
  nearestProViewAggregate: NearestProViewAggregate;
  /** fetch data from the table: "nextval" */
  nextval: Array<Nextval>;
  /** fetch aggregated fields from the table: "nextval" */
  nextvalAggregate: NextvalAggregate;
  /** fetch data from the table: "note_identity" */
  noteIdentity: Array<NoteIdentity>;
  /** fetch aggregated fields from the table: "note_identity" */
  noteIdentityAggregate: NoteIdentityAggregate;
  /** fetch data from the table: "note_identity" using primary key columns */
  noteIdentityByPk?: Maybe<NoteIdentity>;
  /** fetch data from the table: "pennylane_company_mapping" */
  pennylaneCompanyMapping: Array<PennylaneCompanyMapping>;
  /** fetch aggregated fields from the table: "pennylane_company_mapping" */
  pennylaneCompanyMappingAggregate: PennylaneCompanyMappingAggregate;
  /** fetch data from the table: "pennylane_company_mapping" using primary key columns */
  pennylaneCompanyMappingByPk?: Maybe<PennylaneCompanyMapping>;
  /** fetch data from the table: "phone_number" */
  phoneNumber: Array<PhoneNumber>;
  /** fetch aggregated fields from the table: "phone_number" */
  phoneNumberAggregate: PhoneNumberAggregate;
  /** fetch data from the table: "phone_number" using primary key columns */
  phoneNumberByPk?: Maybe<PhoneNumber>;
  /** fetch data from the table: "private_individual" */
  privateIndividual: Array<PrivateIndividual>;
  /** fetch aggregated fields from the table: "private_individual" */
  privateIndividualAggregate: PrivateIndividualAggregate;
  /** fetch data from the table: "pro_certification" */
  proCertification: Array<ProCertification>;
  /** fetch aggregated fields from the table: "pro_certification" */
  proCertificationAggregate: ProCertificationAggregate;
  /** fetch data from the table: "pro_certification" using primary key columns */
  proCertificationByPk?: Maybe<ProCertification>;
  /** fetch data from the table: "pro_holiday" */
  proHoliday: Array<ProHoliday>;
  /** fetch aggregated fields from the table: "pro_holiday" */
  proHolidayAggregate: ProHolidayAggregate;
  /** fetch data from the table: "pro_holiday" using primary key columns */
  proHolidayByPk?: Maybe<ProHoliday>;
  /** fetch data from the table: "pro_label" */
  proLabel: Array<ProLabel>;
  /** fetch aggregated fields from the table: "pro_label" */
  proLabelAggregate: ProLabelAggregate;
  /** fetch data from the table: "pro_label" using primary key columns */
  proLabelByPk?: Maybe<ProLabel>;
  /** fetch data from the table: "pro_mandate" */
  proMandate: Array<ProMandate>;
  /** fetch aggregated fields from the table: "pro_mandate" */
  proMandateAggregate: ProMandateAggregate;
  /** fetch data from the table: "pro_mandate" using primary key columns */
  proMandateByPk?: Maybe<ProMandate>;
  /** fetch data from the table: "pro_media_object" */
  proMediaObject: Array<ProMediaObject>;
  /** fetch aggregated fields from the table: "pro_media_object" */
  proMediaObjectAggregate: ProMediaObjectAggregate;
  /** fetch data from the table: "pro_media_object" using primary key columns */
  proMediaObjectByPk?: Maybe<ProMediaObject>;
  /** fetch data from the table: "pro_message" */
  proMessage: Array<ProMessage>;
  /** fetch aggregated fields from the table: "pro_message" */
  proMessageAggregate: ProMessageAggregate;
  /** fetch data from the table: "pro_message" using primary key columns */
  proMessageByPk?: Maybe<ProMessage>;
  /** fetch data from the table: "pro_organization_first_date_published" */
  proOrganizationFirstDatePublished: Array<ProOrganizationFirstDatePublished>;
  /** fetch aggregated fields from the table: "pro_organization_first_date_published" */
  proOrganizationFirstDatePublishedAggregate: ProOrganizationFirstDatePublishedAggregate;
  /** fetch data from the table: "pro_person" */
  proPerson: Array<ProPerson>;
  /** fetch aggregated fields from the table: "pro_person" */
  proPersonAggregate: ProPersonAggregate;
  /** fetch data from the table: "pro_person" using primary key columns */
  proPersonByPk?: Maybe<ProPerson>;
  /** fetch data from the table: "pro_postal_address" */
  proPostalAddress: Array<ProPostalAddress>;
  /** fetch aggregated fields from the table: "pro_postal_address" */
  proPostalAddressAggregate: ProPostalAddressAggregate;
  /** fetch data from the table: "pro_postal_address" using primary key columns */
  proPostalAddressByPk?: Maybe<ProPostalAddress>;
  /** fetch data from the table: "pro_presentation" */
  proPresentation: Array<ProPresentation>;
  /** fetch aggregated fields from the table: "pro_presentation" */
  proPresentationAggregate: ProPresentationAggregate;
  /** fetch data from the table: "pro_presentation" using primary key columns */
  proPresentationByPk?: Maybe<ProPresentation>;
  /** fetch data from the table: "pro_price" */
  proPrice: Array<ProPrice>;
  /** fetch aggregated fields from the table: "pro_price" */
  proPriceAggregate: ProPriceAggregate;
  /** fetch data from the table: "pro_price" using primary key columns */
  proPriceByPk?: Maybe<ProPrice>;
  /** fetch data from the table: "pro_review" */
  proReview: Array<ProReview>;
  /** fetch aggregated fields from the table: "pro_review" */
  proReviewAggregate: ProReviewAggregate;
  /** fetch data from the table: "pro_review" using primary key columns */
  proReviewByPk?: Maybe<ProReview>;
  /** fetch data from the table: "pro_review_invitation" */
  proReviewInvitation: Array<ProReviewInvitation>;
  /** fetch aggregated fields from the table: "pro_review_invitation" */
  proReviewInvitationAggregate: ProReviewInvitationAggregate;
  /** fetch data from the table: "pro_review_invitation" using primary key columns */
  proReviewInvitationByPk?: Maybe<ProReviewInvitation>;
  /** fetch data from the table: "pro_view" */
  proView: Array<ProView>;
  /** fetch aggregated fields from the table: "pro_view" */
  proViewAggregate: ProViewAggregate;
  /** fetch data from the table: "pro_view" using primary key columns */
  proViewByPk?: Maybe<ProView>;
  /** fetch data from the table: "pro_view_pro_person" */
  proViewProPerson: Array<ProViewProPerson>;
  /** fetch aggregated fields from the table: "pro_view_pro_person" */
  proViewProPersonAggregate: ProViewProPersonAggregate;
  /** fetch data from the table: "pro_view_pro_person" using primary key columns */
  proViewProPersonByPk?: Maybe<ProViewProPerson>;
  /** fetch data from the table: "pro_view_pro_view" */
  proViewProView: Array<ProViewProView>;
  /** fetch aggregated fields from the table: "pro_view_pro_view" */
  proViewProViewAggregate: ProViewProViewAggregate;
  /** fetch data from the table: "pro_view_pro_view" using primary key columns */
  proViewProViewByPk?: Maybe<ProViewProView>;
  /** fetch data from the table: "queued_sms" */
  queuedSms: Array<QueuedSms>;
  /** An aggregate relationship */
  queuedSmsAggregate: QueuedSmsAggregate;
  /** fetch data from the table: "queued_sms" using primary key columns */
  queuedSmsByPk?: Maybe<QueuedSms>;
  /** execute function "random_pro_views" which returns "pro_view" */
  randomProViews: Array<ProView>;
  /** execute function "random_pro_views" and query aggregates on result of table type "pro_view" */
  randomProViewsAggregate: ProViewAggregate;
  /** fetch data from the table: "region" */
  region: Array<Region>;
  /** fetch aggregated fields from the table: "region" */
  regionAggregate: RegionAggregate;
  /** fetch data from the table: "region" using primary key columns */
  regionByPk?: Maybe<Region>;
  /** fetch data from the table: "review_presentation" */
  reviewPresentation: Array<ReviewPresentation>;
  /** fetch aggregated fields from the table: "review_presentation" */
  reviewPresentationAggregate: ReviewPresentationAggregate;
  /** fetch data from the table: "review_presentation" using primary key columns */
  reviewPresentationByPk?: Maybe<ReviewPresentation>;
  /** fetch data from the table: "review_reference_view" */
  reviewReferenceView: Array<ReviewReferenceView>;
  /** fetch aggregated fields from the table: "review_reference_view" */
  reviewReferenceViewAggregate: ReviewReferenceViewAggregate;
  /** execute function "search_city" which returns "city" */
  searchCity: Array<City>;
  /** execute function "search_city" and query aggregates on result of table type "city" */
  searchCityAggregate: CityAggregate;
  /** execute function "search_nearest_city" which returns "city" */
  searchNearestCity: Array<City>;
  /** execute function "search_nearest_city" and query aggregates on result of table type "city" */
  searchNearestCityAggregate: CityAggregate;
  /** execute function "search_nearest_pro_review" which returns "pro_review" */
  searchNearestProReview: Array<ProReview>;
  /** execute function "search_nearest_pro_review" and query aggregates on result of table type "pro_review" */
  searchNearestProReviewAggregate: ProReviewAggregate;
  /** execute function "search_nearest_pro_view" which returns "nearest_pro_view" */
  searchNearestProView: Array<NearestProView>;
  /** execute function "search_nearest_pro_view" and query aggregates on result of table type "nearest_pro_view" */
  searchNearestProViewAggregate: NearestProViewAggregate;
  /** execute function "search_pro_person" which returns "pro_person" */
  searchProPerson: Array<ProPerson>;
  /** execute function "search_pro_person" and query aggregates on result of table type "pro_person" */
  searchProPersonAggregate: ProPersonAggregate;
  /** execute function "search_pro_presentation" which returns "pro_presentation" */
  searchProPresentation: Array<ProPresentation>;
  /** execute function "search_pro_presentation" and query aggregates on result of table type "pro_presentation" */
  searchProPresentationAggregate: ProPresentationAggregate;
  /** execute function "search_pro_review" which returns "pro_review" */
  searchProReview: Array<ProReview>;
  /** execute function "search_pro_review" and query aggregates on result of table type "pro_review" */
  searchProReviewAggregate: ProReviewAggregate;
  /** execute function "search_pro_review_invitation" which returns "pro_review_invitation" */
  searchProReviewInvitation: Array<ProReviewInvitation>;
  /** execute function "search_pro_review_invitation" and query aggregates on result of table type "pro_review_invitation" */
  searchProReviewInvitationAggregate: ProReviewInvitationAggregate;
  /** execute function "search_pro_view" which returns "pro_view" */
  searchProView: Array<ProView>;
  /** execute function "search_pro_view" and query aggregates on result of table type "pro_view" */
  searchProViewAggregate: ProViewAggregate;
  /** execute function "search_solicitation" which returns "solicitation" */
  searchSolicitation: Array<Solicitation>;
  /** execute function "search_solicitation" and query aggregates on result of table type "solicitation" */
  searchSolicitationAggregate: SolicitationAggregate;
  /** execute function "search_trade" which returns "trade" */
  searchTrade: Array<Trade>;
  /** execute function "search_trade" and query aggregates on result of table type "trade" */
  searchTradeAggregate: TradeAggregate;
  /** execute function "search_trade_group" which returns "trade_group" */
  searchTradeGroup: Array<TradeGroup>;
  /** execute function "search_trade_group" and query aggregates on result of table type "trade_group" */
  searchTradeGroupAggregate: TradeGroupAggregate;
  /** fetch data from the table: "sitemap_bilik_zone" */
  sitemapBilikZone: Array<SitemapBilikZone>;
  /** fetch aggregated fields from the table: "sitemap_bilik_zone" */
  sitemapBilikZoneAggregate: SitemapBilikZoneAggregate;
  /** fetch data from the table: "sitemap_city" */
  sitemapCity: Array<SitemapCity>;
  /** fetch aggregated fields from the table: "sitemap_city" */
  sitemapCityAggregate: SitemapCityAggregate;
  /** fetch data from the table: "slug_redirect" */
  slugRedirect: Array<SlugRedirect>;
  /** fetch aggregated fields from the table: "slug_redirect" */
  slugRedirectAggregate: SlugRedirectAggregate;
  /** fetch data from the table: "slug_redirect" using primary key columns */
  slugRedirectByPk?: Maybe<SlugRedirect>;
  /** fetch data from the table: "solicitation" */
  solicitation: Array<Solicitation>;
  /** fetch aggregated fields from the table: "solicitation" */
  solicitationAggregate: SolicitationAggregate;
  /** fetch data from the table: "solicitation" using primary key columns */
  solicitationByPk?: Maybe<Solicitation>;
  /** fetch data from the table: "solicitation_stat" */
  solicitationStat: Array<SolicitationStat>;
  /** fetch aggregated fields from the table: "solicitation_stat" */
  solicitationStatAggregate: SolicitationStatAggregate;
  /** fetch data from the table: "spatial_ref_sys" */
  spatialRefSys: Array<SpatialRefSys>;
  /** fetch aggregated fields from the table: "spatial_ref_sys" */
  spatialRefSysAggregate: SpatialRefSysAggregate;
  /** fetch data from the table: "spatial_ref_sys" using primary key columns */
  spatialRefSysByPk?: Maybe<SpatialRefSys>;
  /** fetch data from the table: "stop_sms" */
  stopSms: Array<StopSms>;
  /** fetch aggregated fields from the table: "stop_sms" */
  stopSmsAggregate: StopSmsAggregate;
  /** fetch data from the table: "stop_sms" using primary key columns */
  stopSmsByPk?: Maybe<StopSms>;
  /** fetch data from the table: "subscription" */
  subscription: Array<Subscription>;
  /** fetch aggregated fields from the table: "subscription" */
  subscriptionAggregate: SubscriptionAggregate;
  /** fetch data from the table: "subscription" using primary key columns */
  subscriptionByPk?: Maybe<Subscription>;
  /** fetch data from the table: "timeline_private_individual" */
  timelinePrivateIndividual: Array<TimelinePrivateIndividual>;
  /** fetch aggregated fields from the table: "timeline_private_individual" */
  timelinePrivateIndividualAggregate: TimelinePrivateIndividualAggregate;
  /** fetch data from the table: "topology.layer" */
  topologyLayer: Array<TopologyLayer>;
  /** fetch aggregated fields from the table: "topology.layer" */
  topologyLayerAggregate: TopologyLayerAggregate;
  /** fetch data from the table: "topology.layer" using primary key columns */
  topologyLayerByPk?: Maybe<TopologyLayer>;
  /** fetch data from the table: "topology.topology" */
  topologyTopology: Array<TopologyTopology>;
  /** fetch aggregated fields from the table: "topology.topology" */
  topologyTopologyAggregate: TopologyTopologyAggregate;
  /** fetch data from the table: "topology.topology" using primary key columns */
  topologyTopologyByPk?: Maybe<TopologyTopology>;
  /** fetch data from the table: "trade" */
  trade: Array<Trade>;
  /** fetch aggregated fields from the table: "trade" */
  tradeAggregate: TradeAggregate;
  /** fetch data from the table: "trade" using primary key columns */
  tradeByPk?: Maybe<Trade>;
  /** fetch data from the table: "trade_group" */
  tradeGroup: Array<TradeGroup>;
  /** fetch aggregated fields from the table: "trade_group" */
  tradeGroupAggregate: TradeGroupAggregate;
  /** fetch data from the table: "trade_group" using primary key columns */
  tradeGroupByPk?: Maybe<TradeGroup>;
  /** fetch data from the table: "trade_guide" */
  tradeGuide: Array<TradeGuide>;
  /** fetch aggregated fields from the table: "trade_guide" */
  tradeGuideAggregate: TradeGuideAggregate;
  /** fetch data from the table: "trade_guide" using primary key columns */
  tradeGuideByPk?: Maybe<TradeGuide>;
  /** fetch data from the table: "trade_keyword" */
  tradeKeyword: Array<TradeKeyword>;
  /** fetch aggregated fields from the table: "trade_keyword" */
  tradeKeywordAggregate: TradeKeywordAggregate;
  /** fetch data from the table: "trade_keyword" using primary key columns */
  tradeKeywordByPk?: Maybe<TradeKeyword>;
  /** fetch data from the table: "trade_main_pro_count" */
  tradeMainProCount: Array<TradeMainProCount>;
  /** fetch aggregated fields from the table: "trade_main_pro_count" */
  tradeMainProCountAggregate: TradeMainProCountAggregate;
  /** fetch data from the table: "trade_pro_presentation" */
  tradeProPresentation: Array<TradeProPresentation>;
  /** fetch aggregated fields from the table: "trade_pro_presentation" */
  tradeProPresentationAggregate: TradeProPresentationAggregate;
  /** fetch data from the table: "trade_pro_presentation" using primary key columns */
  tradeProPresentationByPk?: Maybe<TradeProPresentation>;
  /** fetch data from the table: "trade_pro_view" */
  tradeProView: Array<TradeProView>;
  /** fetch aggregated fields from the table: "trade_pro_view" */
  tradeProViewAggregate: TradeProViewAggregate;
  /** fetch data from the table: "trade_pro_view" using primary key columns */
  tradeProViewByPk?: Maybe<TradeProView>;
  /** fetch data from the table: "trade_question" */
  tradeQuestion: Array<TradeQuestion>;
  /** fetch aggregated fields from the table: "trade_question" */
  tradeQuestionAggregate: TradeQuestionAggregate;
  /** fetch data from the table: "trade_question" using primary key columns */
  tradeQuestionByPk?: Maybe<TradeQuestion>;
  /** fetch data from the table: "trade_trade_group" */
  tradeTradeGroup: Array<TradeTradeGroup>;
  /** fetch aggregated fields from the table: "trade_trade_group" */
  tradeTradeGroupAggregate: TradeTradeGroupAggregate;
  /** fetch data from the table: "trade_trade_group" using primary key columns */
  tradeTradeGroupByPk?: Maybe<TradeTradeGroup>;
  /** fetch data from the table: "trade_trade_guide" */
  tradeTradeGuide: Array<TradeTradeGuide>;
  /** fetch aggregated fields from the table: "trade_trade_guide" */
  tradeTradeGuideAggregate: TradeTradeGuideAggregate;
  /** fetch data from the table: "trade_trade_guide" using primary key columns */
  tradeTradeGuideByPk?: Maybe<TradeTradeGuide>;
  /** fetch data from the table: "utm_record" */
  utmRecord: Array<UtmRecord>;
  /** fetch aggregated fields from the table: "utm_record" */
  utmRecordAggregate: UtmRecordAggregate;
  /** fetch data from the table: "utm_record" using primary key columns */
  utmRecordByPk?: Maybe<UtmRecord>;
  /** fetch data from the table: "view_active_holiday" */
  viewActiveHoliday: Array<ViewActiveHoliday>;
  /** fetch aggregated fields from the table: "view_active_holiday" */
  viewActiveHolidayAggregate: ViewActiveHolidayAggregate;
  /** fetch data from the table: "zoho_consumer" */
  zohoConsumer: Array<ZohoConsumer>;
  /** fetch aggregated fields from the table: "zoho_consumer" */
  zohoConsumerAggregate: ZohoConsumerAggregate;
  /** fetch data from the table: "zoho_consumer" using primary key columns */
  zohoConsumerByPk?: Maybe<ZohoConsumer>;
  /** fetch data from the table: "zoho_organization" */
  zohoOrganization: Array<ZohoOrganization>;
  /** fetch aggregated fields from the table: "zoho_organization" */
  zohoOrganizationAggregate: ZohoOrganizationAggregate;
  /** fetch data from the table: "zoho_organization" using primary key columns */
  zohoOrganizationByPk?: Maybe<ZohoOrganization>;
  /** fetch data from the table: "zoho_token" */
  zohoToken: Array<ZohoToken>;
  /** fetch aggregated fields from the table: "zoho_token" */
  zohoTokenAggregate: ZohoTokenAggregate;
  /** fetch data from the table: "zoho_token" using primary key columns */
  zohoTokenByPk?: Maybe<ZohoToken>;
};


export type QueryRootAccountProViewArgs = {
  distinctOn?: InputMaybe<Array<AccountProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountProViewOrderBy>>;
  where?: InputMaybe<AccountProViewBoolExp>;
};


export type QueryRootAccountProViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountProViewOrderBy>>;
  where?: InputMaybe<AccountProViewBoolExp>;
};


export type QueryRootAccountProViewByPkArgs = {
  authUserId: Scalars['uuid'];
  proViewId: Scalars['Int'];
};


export type QueryRootActionTokenArgs = {
  distinctOn?: InputMaybe<Array<ActionTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActionTokenOrderBy>>;
  where?: InputMaybe<ActionTokenBoolExp>;
};


export type QueryRootActionTokenAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActionTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActionTokenOrderBy>>;
  where?: InputMaybe<ActionTokenBoolExp>;
};


export type QueryRootActionTokenByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAnnouncementArgs = {
  distinctOn?: InputMaybe<Array<AnnouncementSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AnnouncementOrderBy>>;
  where?: InputMaybe<AnnouncementBoolExp>;
};


export type QueryRootAnnouncementAggregateArgs = {
  distinctOn?: InputMaybe<Array<AnnouncementSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AnnouncementOrderBy>>;
  where?: InputMaybe<AnnouncementBoolExp>;
};


export type QueryRootAnnouncementByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAutorespondArgs = {
  distinctOn?: InputMaybe<Array<AutorespondSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AutorespondOrderBy>>;
  where?: InputMaybe<AutorespondBoolExp>;
};


export type QueryRootAutorespondAggregateArgs = {
  distinctOn?: InputMaybe<Array<AutorespondSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AutorespondOrderBy>>;
  where?: InputMaybe<AutorespondBoolExp>;
};


export type QueryRootAutorespondByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootBilikPersonArgs = {
  distinctOn?: InputMaybe<Array<BilikPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikPersonOrderBy>>;
  where?: InputMaybe<BilikPersonBoolExp>;
};


export type QueryRootBilikPersonAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikPersonOrderBy>>;
  where?: InputMaybe<BilikPersonBoolExp>;
};


export type QueryRootBilikPersonByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootBilikSolicitationArgs = {
  distinctOn?: InputMaybe<Array<BilikSolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikSolicitationOrderBy>>;
  where?: InputMaybe<BilikSolicitationBoolExp>;
};


export type QueryRootBilikSolicitationAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikSolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikSolicitationOrderBy>>;
  where?: InputMaybe<BilikSolicitationBoolExp>;
};


export type QueryRootBilikSolicitationByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootBilikZoneArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneOrderBy>>;
  where?: InputMaybe<BilikZoneBoolExp>;
};


export type QueryRootBilikZoneAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneOrderBy>>;
  where?: InputMaybe<BilikZoneBoolExp>;
};


export type QueryRootBilikZoneByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootBilikZoneOutlineArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneOutlineSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneOutlineOrderBy>>;
  where?: InputMaybe<BilikZoneOutlineBoolExp>;
};


export type QueryRootBilikZoneOutlineAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneOutlineSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneOutlineOrderBy>>;
  where?: InputMaybe<BilikZoneOutlineBoolExp>;
};


export type QueryRootBilikZoneTradeMainProCountArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneTradeMainProCountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneTradeMainProCountOrderBy>>;
  where?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
};


export type QueryRootBilikZoneTradeMainProCountAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneTradeMainProCountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneTradeMainProCountOrderBy>>;
  where?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
};


export type QueryRootCertificationArgs = {
  distinctOn?: InputMaybe<Array<CertificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CertificationOrderBy>>;
  where?: InputMaybe<CertificationBoolExp>;
};


export type QueryRootCertificationAggregateArgs = {
  distinctOn?: InputMaybe<Array<CertificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CertificationOrderBy>>;
  where?: InputMaybe<CertificationBoolExp>;
};


export type QueryRootCertificationByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCityArgs = {
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


export type QueryRootCityAggregateArgs = {
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


export type QueryRootCityByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCityProViewArgs = {
  distinctOn?: InputMaybe<Array<CityProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityProViewOrderBy>>;
  where?: InputMaybe<CityProViewBoolExp>;
};


export type QueryRootCityProViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<CityProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityProViewOrderBy>>;
  where?: InputMaybe<CityProViewBoolExp>;
};


export type QueryRootCityProViewByPkArgs = {
  cityId: Scalars['Int'];
  proViewId: Scalars['Int'];
};


export type QueryRootCompanyArgs = {
  distinctOn?: InputMaybe<Array<CompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyOrderBy>>;
  where?: InputMaybe<CompanyBoolExp>;
};


export type QueryRootCompanyAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyOrderBy>>;
  where?: InputMaybe<CompanyBoolExp>;
};


export type QueryRootCompanyByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCountCitySameSlugArgs = {
  distinctOn?: InputMaybe<Array<CountCitySameSlugSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountCitySameSlugOrderBy>>;
  where?: InputMaybe<CountCitySameSlugBoolExp>;
};


export type QueryRootCountCitySameSlugAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountCitySameSlugSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountCitySameSlugOrderBy>>;
  where?: InputMaybe<CountCitySameSlugBoolExp>;
};


export type QueryRootCountProReviewByStatusArgs = {
  distinctOn?: InputMaybe<Array<CountProReviewByStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountProReviewByStatusOrderBy>>;
  where?: InputMaybe<CountProReviewByStatusBoolExp>;
};


export type QueryRootCountProReviewByStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountProReviewByStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountProReviewByStatusOrderBy>>;
  where?: InputMaybe<CountProReviewByStatusBoolExp>;
};


export type QueryRootCountProReviewInvitationsByMonthByProPresentationArgs = {
  distinctOn?: InputMaybe<Array<CountProReviewInvitationsByMonthByProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountProReviewInvitationsByMonthByProPresentationOrderBy>>;
  where?: InputMaybe<CountProReviewInvitationsByMonthByProPresentationBoolExp>;
};


export type QueryRootCountProReviewInvitationsByMonthByProPresentationAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountProReviewInvitationsByMonthByProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountProReviewInvitationsByMonthByProPresentationOrderBy>>;
  where?: InputMaybe<CountProReviewInvitationsByMonthByProPresentationBoolExp>;
};


export type QueryRootCountProReviewsWithStatusOkByMonthByProPresentationArgs = {
  distinctOn?: InputMaybe<Array<CountProReviewsWithStatusOkByMonthByProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountProReviewsWithStatusOkByMonthByProPresentationOrderBy>>;
  where?: InputMaybe<CountProReviewsWithStatusOkByMonthByProPresentationBoolExp>;
};


export type QueryRootCountProReviewsWithStatusOkByMonthByProPresentationAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountProReviewsWithStatusOkByMonthByProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountProReviewsWithStatusOkByMonthByProPresentationOrderBy>>;
  where?: InputMaybe<CountProReviewsWithStatusOkByMonthByProPresentationBoolExp>;
};


export type QueryRootDepartmentArgs = {
  distinctOn?: InputMaybe<Array<DepartmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentOrderBy>>;
  where?: InputMaybe<DepartmentBoolExp>;
};


export type QueryRootDepartmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<DepartmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentOrderBy>>;
  where?: InputMaybe<DepartmentBoolExp>;
};


export type QueryRootDepartmentByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootGeographyColumnsArgs = {
  distinctOn?: InputMaybe<Array<GeographyColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeographyColumnsOrderBy>>;
  where?: InputMaybe<GeographyColumnsBoolExp>;
};


export type QueryRootGeographyColumnsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeographyColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeographyColumnsOrderBy>>;
  where?: InputMaybe<GeographyColumnsBoolExp>;
};


export type QueryRootGeometryColumnsArgs = {
  distinctOn?: InputMaybe<Array<GeometryColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeometryColumnsOrderBy>>;
  where?: InputMaybe<GeometryColumnsBoolExp>;
};


export type QueryRootGeometryColumnsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeometryColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeometryColumnsOrderBy>>;
  where?: InputMaybe<GeometryColumnsBoolExp>;
};


export type QueryRootGloballyBlockedIdentityArgs = {
  distinctOn?: InputMaybe<Array<GloballyBlockedIdentitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GloballyBlockedIdentityOrderBy>>;
  where?: InputMaybe<GloballyBlockedIdentityBoolExp>;
};


export type QueryRootGloballyBlockedIdentityAggregateArgs = {
  distinctOn?: InputMaybe<Array<GloballyBlockedIdentitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GloballyBlockedIdentityOrderBy>>;
  where?: InputMaybe<GloballyBlockedIdentityBoolExp>;
};


export type QueryRootGloballyBlockedIdentityByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootGoogleReviewLinkArgs = {
  distinctOn?: InputMaybe<Array<GoogleReviewLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GoogleReviewLinkOrderBy>>;
  where?: InputMaybe<GoogleReviewLinkBoolExp>;
};


export type QueryRootGoogleReviewLinkAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleReviewLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GoogleReviewLinkOrderBy>>;
  where?: InputMaybe<GoogleReviewLinkBoolExp>;
};


export type QueryRootGoogleReviewLinkByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootManagerBilikPersonBilikZoneArgs = {
  distinctOn?: InputMaybe<Array<ManagerBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ManagerBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
};


export type QueryRootManagerBilikPersonBilikZoneAggregateArgs = {
  distinctOn?: InputMaybe<Array<ManagerBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ManagerBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
};


export type QueryRootManagerBilikPersonBilikZoneByPkArgs = {
  bilikPersonId: Scalars['Int'];
  bilikZoneId: Scalars['Int'];
};


export type QueryRootMemberBilikPersonBilikZoneArgs = {
  distinctOn?: InputMaybe<Array<MemberBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MemberBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
};


export type QueryRootMemberBilikPersonBilikZoneAggregateArgs = {
  distinctOn?: InputMaybe<Array<MemberBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MemberBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
};


export type QueryRootMemberBilikPersonBilikZoneByPkArgs = {
  bilikPersonId: Scalars['Int'];
  bilikZoneId: Scalars['Int'];
};


export type QueryRootNearestProViewArgs = {
  distinctOn?: InputMaybe<Array<NearestProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NearestProViewOrderBy>>;
  where?: InputMaybe<NearestProViewBoolExp>;
};


export type QueryRootNearestProViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<NearestProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NearestProViewOrderBy>>;
  where?: InputMaybe<NearestProViewBoolExp>;
};


export type QueryRootNextvalArgs = {
  distinctOn?: InputMaybe<Array<NextvalSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NextvalOrderBy>>;
  where?: InputMaybe<NextvalBoolExp>;
};


export type QueryRootNextvalAggregateArgs = {
  distinctOn?: InputMaybe<Array<NextvalSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NextvalOrderBy>>;
  where?: InputMaybe<NextvalBoolExp>;
};


export type QueryRootNoteIdentityArgs = {
  distinctOn?: InputMaybe<Array<NoteIdentitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteIdentityOrderBy>>;
  where?: InputMaybe<NoteIdentityBoolExp>;
};


export type QueryRootNoteIdentityAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteIdentitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteIdentityOrderBy>>;
  where?: InputMaybe<NoteIdentityBoolExp>;
};


export type QueryRootNoteIdentityByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootPennylaneCompanyMappingArgs = {
  distinctOn?: InputMaybe<Array<PennylaneCompanyMappingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PennylaneCompanyMappingOrderBy>>;
  where?: InputMaybe<PennylaneCompanyMappingBoolExp>;
};


export type QueryRootPennylaneCompanyMappingAggregateArgs = {
  distinctOn?: InputMaybe<Array<PennylaneCompanyMappingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PennylaneCompanyMappingOrderBy>>;
  where?: InputMaybe<PennylaneCompanyMappingBoolExp>;
};


export type QueryRootPennylaneCompanyMappingByPkArgs = {
  billingIssuerId: Scalars['Int'];
  companyId: Scalars['Int'];
};


export type QueryRootPhoneNumberArgs = {
  distinctOn?: InputMaybe<Array<PhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhoneNumberOrderBy>>;
  where?: InputMaybe<PhoneNumberBoolExp>;
};


export type QueryRootPhoneNumberAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhoneNumberOrderBy>>;
  where?: InputMaybe<PhoneNumberBoolExp>;
};


export type QueryRootPhoneNumberByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootPrivateIndividualArgs = {
  distinctOn?: InputMaybe<Array<PrivateIndividualSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PrivateIndividualOrderBy>>;
  where?: InputMaybe<PrivateIndividualBoolExp>;
};


export type QueryRootPrivateIndividualAggregateArgs = {
  distinctOn?: InputMaybe<Array<PrivateIndividualSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PrivateIndividualOrderBy>>;
  where?: InputMaybe<PrivateIndividualBoolExp>;
};


export type QueryRootProCertificationArgs = {
  distinctOn?: InputMaybe<Array<ProCertificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProCertificationOrderBy>>;
  where?: InputMaybe<ProCertificationBoolExp>;
};


export type QueryRootProCertificationAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProCertificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProCertificationOrderBy>>;
  where?: InputMaybe<ProCertificationBoolExp>;
};


export type QueryRootProCertificationByPkArgs = {
  certificationId: Scalars['Int'];
  proPresentationId: Scalars['Int'];
};


export type QueryRootProHolidayArgs = {
  distinctOn?: InputMaybe<Array<ProHolidaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProHolidayOrderBy>>;
  where?: InputMaybe<ProHolidayBoolExp>;
};


export type QueryRootProHolidayAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProHolidaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProHolidayOrderBy>>;
  where?: InputMaybe<ProHolidayBoolExp>;
};


export type QueryRootProHolidayByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProLabelArgs = {
  distinctOn?: InputMaybe<Array<ProLabelSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProLabelOrderBy>>;
  where?: InputMaybe<ProLabelBoolExp>;
};


export type QueryRootProLabelAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProLabelSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProLabelOrderBy>>;
  where?: InputMaybe<ProLabelBoolExp>;
};


export type QueryRootProLabelByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProMandateArgs = {
  distinctOn?: InputMaybe<Array<ProMandateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMandateOrderBy>>;
  where?: InputMaybe<ProMandateBoolExp>;
};


export type QueryRootProMandateAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProMandateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMandateOrderBy>>;
  where?: InputMaybe<ProMandateBoolExp>;
};


export type QueryRootProMandateByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProMediaObjectArgs = {
  distinctOn?: InputMaybe<Array<ProMediaObjectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMediaObjectOrderBy>>;
  where?: InputMaybe<ProMediaObjectBoolExp>;
};


export type QueryRootProMediaObjectAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProMediaObjectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMediaObjectOrderBy>>;
  where?: InputMaybe<ProMediaObjectBoolExp>;
};


export type QueryRootProMediaObjectByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProMessageArgs = {
  distinctOn?: InputMaybe<Array<ProMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMessageOrderBy>>;
  where?: InputMaybe<ProMessageBoolExp>;
};


export type QueryRootProMessageAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMessageOrderBy>>;
  where?: InputMaybe<ProMessageBoolExp>;
};


export type QueryRootProMessageByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProOrganizationFirstDatePublishedArgs = {
  distinctOn?: InputMaybe<Array<ProOrganizationFirstDatePublishedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProOrganizationFirstDatePublishedOrderBy>>;
  where?: InputMaybe<ProOrganizationFirstDatePublishedBoolExp>;
};


export type QueryRootProOrganizationFirstDatePublishedAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProOrganizationFirstDatePublishedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProOrganizationFirstDatePublishedOrderBy>>;
  where?: InputMaybe<ProOrganizationFirstDatePublishedBoolExp>;
};


export type QueryRootProPersonArgs = {
  distinctOn?: InputMaybe<Array<ProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPersonOrderBy>>;
  where?: InputMaybe<ProPersonBoolExp>;
};


export type QueryRootProPersonAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPersonOrderBy>>;
  where?: InputMaybe<ProPersonBoolExp>;
};


export type QueryRootProPersonByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProPostalAddressArgs = {
  distinctOn?: InputMaybe<Array<ProPostalAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPostalAddressOrderBy>>;
  where?: InputMaybe<ProPostalAddressBoolExp>;
};


export type QueryRootProPostalAddressAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProPostalAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPostalAddressOrderBy>>;
  where?: InputMaybe<ProPostalAddressBoolExp>;
};


export type QueryRootProPostalAddressByPkArgs = {
  proViewId: Scalars['Int'];
};


export type QueryRootProPresentationArgs = {
  distinctOn?: InputMaybe<Array<ProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPresentationOrderBy>>;
  where?: InputMaybe<ProPresentationBoolExp>;
};


export type QueryRootProPresentationAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPresentationOrderBy>>;
  where?: InputMaybe<ProPresentationBoolExp>;
};


export type QueryRootProPresentationByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProPriceArgs = {
  distinctOn?: InputMaybe<Array<ProPriceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPriceOrderBy>>;
  where?: InputMaybe<ProPriceBoolExp>;
};


export type QueryRootProPriceAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProPriceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPriceOrderBy>>;
  where?: InputMaybe<ProPriceBoolExp>;
};


export type QueryRootProPriceByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProReviewArgs = {
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type QueryRootProReviewAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type QueryRootProReviewByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProReviewInvitationArgs = {
  distinctOn?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


export type QueryRootProReviewInvitationAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


export type QueryRootProReviewInvitationByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProViewArgs = {
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type QueryRootProViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type QueryRootProViewByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProViewProPersonArgs = {
  distinctOn?: InputMaybe<Array<ProViewProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProPersonOrderBy>>;
  where?: InputMaybe<ProViewProPersonBoolExp>;
};


export type QueryRootProViewProPersonAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProPersonOrderBy>>;
  where?: InputMaybe<ProViewProPersonBoolExp>;
};


export type QueryRootProViewProPersonByPkArgs = {
  proPersonId: Scalars['Int'];
  proViewId: Scalars['Int'];
};


export type QueryRootProViewProViewArgs = {
  distinctOn?: InputMaybe<Array<ProViewProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProViewOrderBy>>;
  where?: InputMaybe<ProViewProViewBoolExp>;
};


export type QueryRootProViewProViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProViewOrderBy>>;
  where?: InputMaybe<ProViewProViewBoolExp>;
};


export type QueryRootProViewProViewByPkArgs = {
  proViewSource: Scalars['Int'];
  proViewTarget: Scalars['Int'];
};


export type QueryRootQueuedSmsArgs = {
  distinctOn?: InputMaybe<Array<QueuedSmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QueuedSmsOrderBy>>;
  where?: InputMaybe<QueuedSmsBoolExp>;
};


export type QueryRootQueuedSmsAggregateArgs = {
  distinctOn?: InputMaybe<Array<QueuedSmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QueuedSmsOrderBy>>;
  where?: InputMaybe<QueuedSmsBoolExp>;
};


export type QueryRootQueuedSmsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootRandomProViewsArgs = {
  args?: InputMaybe<RandomProViewsArgs>;
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type QueryRootRandomProViewsAggregateArgs = {
  args?: InputMaybe<RandomProViewsArgs>;
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type QueryRootRegionArgs = {
  distinctOn?: InputMaybe<Array<RegionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RegionOrderBy>>;
  where?: InputMaybe<RegionBoolExp>;
};


export type QueryRootRegionAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RegionOrderBy>>;
  where?: InputMaybe<RegionBoolExp>;
};


export type QueryRootRegionByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootReviewPresentationArgs = {
  distinctOn?: InputMaybe<Array<ReviewPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewPresentationOrderBy>>;
  where?: InputMaybe<ReviewPresentationBoolExp>;
};


export type QueryRootReviewPresentationAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewPresentationOrderBy>>;
  where?: InputMaybe<ReviewPresentationBoolExp>;
};


export type QueryRootReviewPresentationByPkArgs = {
  presentationId: Scalars['Int'];
  reviewId: Scalars['Int'];
};


export type QueryRootReviewReferenceViewArgs = {
  distinctOn?: InputMaybe<Array<ReviewReferenceViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewReferenceViewOrderBy>>;
  where?: InputMaybe<ReviewReferenceViewBoolExp>;
};


export type QueryRootReviewReferenceViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewReferenceViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewReferenceViewOrderBy>>;
  where?: InputMaybe<ReviewReferenceViewBoolExp>;
};


export type QueryRootSearchCityArgs = {
  args: SearchCityArgs;
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


export type QueryRootSearchCityAggregateArgs = {
  args: SearchCityArgs;
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


export type QueryRootSearchNearestCityArgs = {
  args: SearchNearestCityArgs;
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


export type QueryRootSearchNearestCityAggregateArgs = {
  args: SearchNearestCityArgs;
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


export type QueryRootSearchNearestProReviewArgs = {
  args: SearchNearestProReviewArgs;
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type QueryRootSearchNearestProReviewAggregateArgs = {
  args: SearchNearestProReviewArgs;
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type QueryRootSearchNearestProViewArgs = {
  args: SearchNearestProViewArgs;
  distinctOn?: InputMaybe<Array<NearestProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NearestProViewOrderBy>>;
  where?: InputMaybe<NearestProViewBoolExp>;
};


export type QueryRootSearchNearestProViewAggregateArgs = {
  args: SearchNearestProViewArgs;
  distinctOn?: InputMaybe<Array<NearestProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NearestProViewOrderBy>>;
  where?: InputMaybe<NearestProViewBoolExp>;
};


export type QueryRootSearchProPersonArgs = {
  args: SearchProPersonArgs;
  distinctOn?: InputMaybe<Array<ProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPersonOrderBy>>;
  where?: InputMaybe<ProPersonBoolExp>;
};


export type QueryRootSearchProPersonAggregateArgs = {
  args: SearchProPersonArgs;
  distinctOn?: InputMaybe<Array<ProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPersonOrderBy>>;
  where?: InputMaybe<ProPersonBoolExp>;
};


export type QueryRootSearchProPresentationArgs = {
  args: SearchProPresentationArgs;
  distinctOn?: InputMaybe<Array<ProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPresentationOrderBy>>;
  where?: InputMaybe<ProPresentationBoolExp>;
};


export type QueryRootSearchProPresentationAggregateArgs = {
  args: SearchProPresentationArgs;
  distinctOn?: InputMaybe<Array<ProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPresentationOrderBy>>;
  where?: InputMaybe<ProPresentationBoolExp>;
};


export type QueryRootSearchProReviewArgs = {
  args: SearchProReviewArgs;
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type QueryRootSearchProReviewAggregateArgs = {
  args: SearchProReviewArgs;
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type QueryRootSearchProReviewInvitationArgs = {
  args: SearchProReviewInvitationArgs;
  distinctOn?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


export type QueryRootSearchProReviewInvitationAggregateArgs = {
  args: SearchProReviewInvitationArgs;
  distinctOn?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


export type QueryRootSearchProViewArgs = {
  args: SearchProViewArgs;
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type QueryRootSearchProViewAggregateArgs = {
  args: SearchProViewArgs;
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type QueryRootSearchSolicitationArgs = {
  args: SearchSolicitationArgs;
  distinctOn?: InputMaybe<Array<SolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationOrderBy>>;
  where?: InputMaybe<SolicitationBoolExp>;
};


export type QueryRootSearchSolicitationAggregateArgs = {
  args: SearchSolicitationArgs;
  distinctOn?: InputMaybe<Array<SolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationOrderBy>>;
  where?: InputMaybe<SolicitationBoolExp>;
};


export type QueryRootSearchTradeArgs = {
  args: SearchTradeArgs;
  distinctOn?: InputMaybe<Array<TradeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeOrderBy>>;
  where?: InputMaybe<TradeBoolExp>;
};


export type QueryRootSearchTradeAggregateArgs = {
  args: SearchTradeArgs;
  distinctOn?: InputMaybe<Array<TradeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeOrderBy>>;
  where?: InputMaybe<TradeBoolExp>;
};


export type QueryRootSearchTradeGroupArgs = {
  args: SearchTradeGroupArgs;
  distinctOn?: InputMaybe<Array<TradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGroupOrderBy>>;
  where?: InputMaybe<TradeGroupBoolExp>;
};


export type QueryRootSearchTradeGroupAggregateArgs = {
  args: SearchTradeGroupArgs;
  distinctOn?: InputMaybe<Array<TradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGroupOrderBy>>;
  where?: InputMaybe<TradeGroupBoolExp>;
};


export type QueryRootSitemapBilikZoneArgs = {
  distinctOn?: InputMaybe<Array<SitemapBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapBilikZoneOrderBy>>;
  where?: InputMaybe<SitemapBilikZoneBoolExp>;
};


export type QueryRootSitemapBilikZoneAggregateArgs = {
  distinctOn?: InputMaybe<Array<SitemapBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapBilikZoneOrderBy>>;
  where?: InputMaybe<SitemapBilikZoneBoolExp>;
};


export type QueryRootSitemapCityArgs = {
  distinctOn?: InputMaybe<Array<SitemapCitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapCityOrderBy>>;
  where?: InputMaybe<SitemapCityBoolExp>;
};


export type QueryRootSitemapCityAggregateArgs = {
  distinctOn?: InputMaybe<Array<SitemapCitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapCityOrderBy>>;
  where?: InputMaybe<SitemapCityBoolExp>;
};


export type QueryRootSlugRedirectArgs = {
  distinctOn?: InputMaybe<Array<SlugRedirectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SlugRedirectOrderBy>>;
  where?: InputMaybe<SlugRedirectBoolExp>;
};


export type QueryRootSlugRedirectAggregateArgs = {
  distinctOn?: InputMaybe<Array<SlugRedirectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SlugRedirectOrderBy>>;
  where?: InputMaybe<SlugRedirectBoolExp>;
};


export type QueryRootSlugRedirectByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootSolicitationArgs = {
  distinctOn?: InputMaybe<Array<SolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationOrderBy>>;
  where?: InputMaybe<SolicitationBoolExp>;
};


export type QueryRootSolicitationAggregateArgs = {
  distinctOn?: InputMaybe<Array<SolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationOrderBy>>;
  where?: InputMaybe<SolicitationBoolExp>;
};


export type QueryRootSolicitationByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootSolicitationStatArgs = {
  distinctOn?: InputMaybe<Array<SolicitationStatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationStatOrderBy>>;
  where?: InputMaybe<SolicitationStatBoolExp>;
};


export type QueryRootSolicitationStatAggregateArgs = {
  distinctOn?: InputMaybe<Array<SolicitationStatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationStatOrderBy>>;
  where?: InputMaybe<SolicitationStatBoolExp>;
};


export type QueryRootSpatialRefSysArgs = {
  distinctOn?: InputMaybe<Array<SpatialRefSysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SpatialRefSysOrderBy>>;
  where?: InputMaybe<SpatialRefSysBoolExp>;
};


export type QueryRootSpatialRefSysAggregateArgs = {
  distinctOn?: InputMaybe<Array<SpatialRefSysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SpatialRefSysOrderBy>>;
  where?: InputMaybe<SpatialRefSysBoolExp>;
};


export type QueryRootSpatialRefSysByPkArgs = {
  srid: Scalars['Int'];
};


export type QueryRootStopSmsArgs = {
  distinctOn?: InputMaybe<Array<StopSmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StopSmsOrderBy>>;
  where?: InputMaybe<StopSmsBoolExp>;
};


export type QueryRootStopSmsAggregateArgs = {
  distinctOn?: InputMaybe<Array<StopSmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StopSmsOrderBy>>;
  where?: InputMaybe<StopSmsBoolExp>;
};


export type QueryRootStopSmsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootSubscriptionArgs = {
  distinctOn?: InputMaybe<Array<SubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubscriptionOrderBy>>;
  where?: InputMaybe<SubscriptionBoolExp>;
};


export type QueryRootSubscriptionAggregateArgs = {
  distinctOn?: InputMaybe<Array<SubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubscriptionOrderBy>>;
  where?: InputMaybe<SubscriptionBoolExp>;
};


export type QueryRootSubscriptionByPkArgs = {
  viewId: Scalars['Int'];
};


export type QueryRootTimelinePrivateIndividualArgs = {
  distinctOn?: InputMaybe<Array<TimelinePrivateIndividualSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimelinePrivateIndividualOrderBy>>;
  where?: InputMaybe<TimelinePrivateIndividualBoolExp>;
};


export type QueryRootTimelinePrivateIndividualAggregateArgs = {
  distinctOn?: InputMaybe<Array<TimelinePrivateIndividualSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimelinePrivateIndividualOrderBy>>;
  where?: InputMaybe<TimelinePrivateIndividualBoolExp>;
};


export type QueryRootTopologyLayerArgs = {
  distinctOn?: InputMaybe<Array<TopologyLayerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TopologyLayerOrderBy>>;
  where?: InputMaybe<TopologyLayerBoolExp>;
};


export type QueryRootTopologyLayerAggregateArgs = {
  distinctOn?: InputMaybe<Array<TopologyLayerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TopologyLayerOrderBy>>;
  where?: InputMaybe<TopologyLayerBoolExp>;
};


export type QueryRootTopologyLayerByPkArgs = {
  layerId: Scalars['Int'];
  topologyId: Scalars['Int'];
};


export type QueryRootTopologyTopologyArgs = {
  distinctOn?: InputMaybe<Array<TopologyTopologySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TopologyTopologyOrderBy>>;
  where?: InputMaybe<TopologyTopologyBoolExp>;
};


export type QueryRootTopologyTopologyAggregateArgs = {
  distinctOn?: InputMaybe<Array<TopologyTopologySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TopologyTopologyOrderBy>>;
  where?: InputMaybe<TopologyTopologyBoolExp>;
};


export type QueryRootTopologyTopologyByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootTradeArgs = {
  distinctOn?: InputMaybe<Array<TradeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeOrderBy>>;
  where?: InputMaybe<TradeBoolExp>;
};


export type QueryRootTradeAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeOrderBy>>;
  where?: InputMaybe<TradeBoolExp>;
};


export type QueryRootTradeByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootTradeGroupArgs = {
  distinctOn?: InputMaybe<Array<TradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGroupOrderBy>>;
  where?: InputMaybe<TradeGroupBoolExp>;
};


export type QueryRootTradeGroupAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGroupOrderBy>>;
  where?: InputMaybe<TradeGroupBoolExp>;
};


export type QueryRootTradeGroupByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootTradeGuideArgs = {
  distinctOn?: InputMaybe<Array<TradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGuideOrderBy>>;
  where?: InputMaybe<TradeGuideBoolExp>;
};


export type QueryRootTradeGuideAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGuideOrderBy>>;
  where?: InputMaybe<TradeGuideBoolExp>;
};


export type QueryRootTradeGuideByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootTradeKeywordArgs = {
  distinctOn?: InputMaybe<Array<TradeKeywordSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeKeywordOrderBy>>;
  where?: InputMaybe<TradeKeywordBoolExp>;
};


export type QueryRootTradeKeywordAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeKeywordSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeKeywordOrderBy>>;
  where?: InputMaybe<TradeKeywordBoolExp>;
};


export type QueryRootTradeKeywordByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootTradeMainProCountArgs = {
  distinctOn?: InputMaybe<Array<TradeMainProCountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeMainProCountOrderBy>>;
  where?: InputMaybe<TradeMainProCountBoolExp>;
};


export type QueryRootTradeMainProCountAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeMainProCountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeMainProCountOrderBy>>;
  where?: InputMaybe<TradeMainProCountBoolExp>;
};


export type QueryRootTradeProPresentationArgs = {
  distinctOn?: InputMaybe<Array<TradeProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProPresentationOrderBy>>;
  where?: InputMaybe<TradeProPresentationBoolExp>;
};


export type QueryRootTradeProPresentationAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProPresentationOrderBy>>;
  where?: InputMaybe<TradeProPresentationBoolExp>;
};


export type QueryRootTradeProPresentationByPkArgs = {
  proPresentationId: Scalars['Int'];
  tradeId: Scalars['Int'];
};


export type QueryRootTradeProViewArgs = {
  distinctOn?: InputMaybe<Array<TradeProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProViewOrderBy>>;
  where?: InputMaybe<TradeProViewBoolExp>;
};


export type QueryRootTradeProViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProViewOrderBy>>;
  where?: InputMaybe<TradeProViewBoolExp>;
};


export type QueryRootTradeProViewByPkArgs = {
  proViewId: Scalars['Int'];
  tradeId: Scalars['Int'];
};


export type QueryRootTradeQuestionArgs = {
  distinctOn?: InputMaybe<Array<TradeQuestionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeQuestionOrderBy>>;
  where?: InputMaybe<TradeQuestionBoolExp>;
};


export type QueryRootTradeQuestionAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeQuestionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeQuestionOrderBy>>;
  where?: InputMaybe<TradeQuestionBoolExp>;
};


export type QueryRootTradeQuestionByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootTradeTradeGroupArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGroupOrderBy>>;
  where?: InputMaybe<TradeTradeGroupBoolExp>;
};


export type QueryRootTradeTradeGroupAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGroupOrderBy>>;
  where?: InputMaybe<TradeTradeGroupBoolExp>;
};


export type QueryRootTradeTradeGroupByPkArgs = {
  tradeGroupId: Scalars['Int'];
  tradeId: Scalars['Int'];
};


export type QueryRootTradeTradeGuideArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGuideOrderBy>>;
  where?: InputMaybe<TradeTradeGuideBoolExp>;
};


export type QueryRootTradeTradeGuideAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGuideOrderBy>>;
  where?: InputMaybe<TradeTradeGuideBoolExp>;
};


export type QueryRootTradeTradeGuideByPkArgs = {
  tradeGuideId: Scalars['Int'];
  tradeId: Scalars['Int'];
};


export type QueryRootUtmRecordArgs = {
  distinctOn?: InputMaybe<Array<UtmRecordSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtmRecordOrderBy>>;
  where?: InputMaybe<UtmRecordBoolExp>;
};


export type QueryRootUtmRecordAggregateArgs = {
  distinctOn?: InputMaybe<Array<UtmRecordSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtmRecordOrderBy>>;
  where?: InputMaybe<UtmRecordBoolExp>;
};


export type QueryRootUtmRecordByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootViewActiveHolidayArgs = {
  distinctOn?: InputMaybe<Array<ViewActiveHolidaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewActiveHolidayOrderBy>>;
  where?: InputMaybe<ViewActiveHolidayBoolExp>;
};


export type QueryRootViewActiveHolidayAggregateArgs = {
  distinctOn?: InputMaybe<Array<ViewActiveHolidaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewActiveHolidayOrderBy>>;
  where?: InputMaybe<ViewActiveHolidayBoolExp>;
};


export type QueryRootZohoConsumerArgs = {
  distinctOn?: InputMaybe<Array<ZohoConsumerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoConsumerOrderBy>>;
  where?: InputMaybe<ZohoConsumerBoolExp>;
};


export type QueryRootZohoConsumerAggregateArgs = {
  distinctOn?: InputMaybe<Array<ZohoConsumerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoConsumerOrderBy>>;
  where?: InputMaybe<ZohoConsumerBoolExp>;
};


export type QueryRootZohoConsumerByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootZohoOrganizationArgs = {
  distinctOn?: InputMaybe<Array<ZohoOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoOrganizationOrderBy>>;
  where?: InputMaybe<ZohoOrganizationBoolExp>;
};


export type QueryRootZohoOrganizationAggregateArgs = {
  distinctOn?: InputMaybe<Array<ZohoOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoOrganizationOrderBy>>;
  where?: InputMaybe<ZohoOrganizationBoolExp>;
};


export type QueryRootZohoOrganizationByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootZohoTokenArgs = {
  distinctOn?: InputMaybe<Array<ZohoTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoTokenOrderBy>>;
  where?: InputMaybe<ZohoTokenBoolExp>;
};


export type QueryRootZohoTokenAggregateArgs = {
  distinctOn?: InputMaybe<Array<ZohoTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoTokenOrderBy>>;
  where?: InputMaybe<ZohoTokenBoolExp>;
};


export type QueryRootZohoTokenByPkArgs = {
  id: Scalars['Int'];
};

export type QueuedSmsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<QueuedSmsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<QueuedSmsBoolExp>;
  predicate: IntComparisonExp;
};

export type RandomProViewsArgs = {
  seed?: InputMaybe<Scalars['float8']>;
};

export type ReviewPresentationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ReviewPresentationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReviewPresentationBoolExp>;
  predicate: IntComparisonExp;
};

export type SearchCityArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type SearchNearestCityArgs = {
  location?: InputMaybe<Scalars['geometry']>;
  max_distance_km?: InputMaybe<Scalars['Int']>;
};

export type SearchNearestProReviewArgs = {
  location?: InputMaybe<Scalars['geometry']>;
};

export type SearchNearestProViewArgs = {
  location?: InputMaybe<Scalars['geometry']>;
};

export type SearchProPersonArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type SearchProPresentationArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type SearchProReviewArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type SearchProReviewInvitationArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type SearchProViewArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type SearchSolicitationArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type SearchTradeArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type SearchTradeGroupArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type SequenceNextvalArgs = {
  sequence_name?: InputMaybe<Scalars['String']>;
};

export type SitemapBilikZoneAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SitemapBilikZoneSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SitemapBilikZoneBoolExp>;
  predicate: IntComparisonExp;
};

export type SitemapCityAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SitemapCitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SitemapCityBoolExp>;
  predicate: IntComparisonExp;
};

export type SolicitationAggregateBoolExpBoolAnd = {
  arguments: SolicitationSelectColumnSolicitationAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SolicitationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type SolicitationAggregateBoolExpBoolOr = {
  arguments: SolicitationSelectColumnSolicitationAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SolicitationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type SolicitationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SolicitationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SolicitationBoolExp>;
  predicate: IntComparisonExp;
};

export type StDWithinGeographyInput = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type StDWithinInput = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

export type SubscriptionRoot = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "account_pro_view" */
  accountProView: Array<AccountProView>;
  /** fetch aggregated fields from the table: "account_pro_view" */
  accountProViewAggregate: AccountProViewAggregate;
  /** fetch data from the table: "account_pro_view" using primary key columns */
  accountProViewByPk?: Maybe<AccountProView>;
  /** fetch data from the table in a streaming manner: "account_pro_view" */
  accountProViewStream: Array<AccountProView>;
  /** fetch data from the table: "action_token" */
  actionToken: Array<ActionToken>;
  /** fetch aggregated fields from the table: "action_token" */
  actionTokenAggregate: ActionTokenAggregate;
  /** fetch data from the table: "action_token" using primary key columns */
  actionTokenByPk?: Maybe<ActionToken>;
  /** fetch data from the table in a streaming manner: "action_token" */
  actionTokenStream: Array<ActionToken>;
  /** fetch data from the table: "announcement" */
  announcement: Array<Announcement>;
  /** fetch aggregated fields from the table: "announcement" */
  announcementAggregate: AnnouncementAggregate;
  /** fetch data from the table: "announcement" using primary key columns */
  announcementByPk?: Maybe<Announcement>;
  /** fetch data from the table in a streaming manner: "announcement" */
  announcementStream: Array<Announcement>;
  /** fetch data from the table: "autorespond" */
  autorespond: Array<Autorespond>;
  /** fetch aggregated fields from the table: "autorespond" */
  autorespondAggregate: AutorespondAggregate;
  /** fetch data from the table: "autorespond" using primary key columns */
  autorespondByPk?: Maybe<Autorespond>;
  /** fetch data from the table in a streaming manner: "autorespond" */
  autorespondStream: Array<Autorespond>;
  /** fetch data from the table: "bilik_person" */
  bilikPerson: Array<BilikPerson>;
  /** fetch aggregated fields from the table: "bilik_person" */
  bilikPersonAggregate: BilikPersonAggregate;
  /** fetch data from the table: "bilik_person" using primary key columns */
  bilikPersonByPk?: Maybe<BilikPerson>;
  /** fetch data from the table in a streaming manner: "bilik_person" */
  bilikPersonStream: Array<BilikPerson>;
  /** fetch data from the table: "bilik_solicitation" */
  bilikSolicitation: Array<BilikSolicitation>;
  /** fetch aggregated fields from the table: "bilik_solicitation" */
  bilikSolicitationAggregate: BilikSolicitationAggregate;
  /** fetch data from the table: "bilik_solicitation" using primary key columns */
  bilikSolicitationByPk?: Maybe<BilikSolicitation>;
  /** fetch data from the table in a streaming manner: "bilik_solicitation" */
  bilikSolicitationStream: Array<BilikSolicitation>;
  /** fetch data from the table: "bilik_zone" */
  bilikZone: Array<BilikZone>;
  /** fetch aggregated fields from the table: "bilik_zone" */
  bilikZoneAggregate: BilikZoneAggregate;
  /** fetch data from the table: "bilik_zone" using primary key columns */
  bilikZoneByPk?: Maybe<BilikZone>;
  /** fetch data from the table: "bilik_zone_outline" */
  bilikZoneOutline: Array<BilikZoneOutline>;
  /** fetch aggregated fields from the table: "bilik_zone_outline" */
  bilikZoneOutlineAggregate: BilikZoneOutlineAggregate;
  /** fetch data from the table in a streaming manner: "bilik_zone_outline" */
  bilikZoneOutlineStream: Array<BilikZoneOutline>;
  /** fetch data from the table in a streaming manner: "bilik_zone" */
  bilikZoneStream: Array<BilikZone>;
  /** fetch data from the table: "bilik_zone_trade_main_pro_count" */
  bilikZoneTradeMainProCount: Array<BilikZoneTradeMainProCount>;
  /** fetch aggregated fields from the table: "bilik_zone_trade_main_pro_count" */
  bilikZoneTradeMainProCountAggregate: BilikZoneTradeMainProCountAggregate;
  /** fetch data from the table in a streaming manner: "bilik_zone_trade_main_pro_count" */
  bilikZoneTradeMainProCountStream: Array<BilikZoneTradeMainProCount>;
  /** fetch data from the table: "certification" */
  certification: Array<Certification>;
  /** fetch aggregated fields from the table: "certification" */
  certificationAggregate: CertificationAggregate;
  /** fetch data from the table: "certification" using primary key columns */
  certificationByPk?: Maybe<Certification>;
  /** fetch data from the table in a streaming manner: "certification" */
  certificationStream: Array<Certification>;
  /** fetch data from the table: "city" */
  city: Array<City>;
  /** fetch aggregated fields from the table: "city" */
  cityAggregate: CityAggregate;
  /** fetch data from the table: "city" using primary key columns */
  cityByPk?: Maybe<City>;
  /** fetch data from the table: "city_pro_view" */
  cityProView: Array<CityProView>;
  /** fetch aggregated fields from the table: "city_pro_view" */
  cityProViewAggregate: CityProViewAggregate;
  /** fetch data from the table: "city_pro_view" using primary key columns */
  cityProViewByPk?: Maybe<CityProView>;
  /** fetch data from the table in a streaming manner: "city_pro_view" */
  cityProViewStream: Array<CityProView>;
  /** fetch data from the table in a streaming manner: "city" */
  cityStream: Array<City>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  companyAggregate: CompanyAggregate;
  /** fetch data from the table: "company" using primary key columns */
  companyByPk?: Maybe<Company>;
  /** fetch data from the table in a streaming manner: "company" */
  companyStream: Array<Company>;
  /** fetch data from the table: "count_city_same_slug" */
  countCitySameSlug: Array<CountCitySameSlug>;
  /** fetch aggregated fields from the table: "count_city_same_slug" */
  countCitySameSlugAggregate: CountCitySameSlugAggregate;
  /** fetch data from the table in a streaming manner: "count_city_same_slug" */
  countCitySameSlugStream: Array<CountCitySameSlug>;
  /** fetch data from the table: "count_pro_review_by_status" */
  countProReviewByStatus: Array<CountProReviewByStatus>;
  /** fetch aggregated fields from the table: "count_pro_review_by_status" */
  countProReviewByStatusAggregate: CountProReviewByStatusAggregate;
  /** fetch data from the table in a streaming manner: "count_pro_review_by_status" */
  countProReviewByStatusStream: Array<CountProReviewByStatus>;
  /** fetch data from the table: "count_pro_review_invitations_by_month_by_pro_presentation" */
  countProReviewInvitationsByMonthByProPresentation: Array<CountProReviewInvitationsByMonthByProPresentation>;
  /** fetch aggregated fields from the table: "count_pro_review_invitations_by_month_by_pro_presentation" */
  countProReviewInvitationsByMonthByProPresentationAggregate: CountProReviewInvitationsByMonthByProPresentationAggregate;
  /** fetch data from the table in a streaming manner: "count_pro_review_invitations_by_month_by_pro_presentation" */
  countProReviewInvitationsByMonthByProPresentationStream: Array<CountProReviewInvitationsByMonthByProPresentation>;
  /** fetch data from the table: "count_pro_reviews_with_status_ok_by_month_by_pro_presentation" */
  countProReviewsWithStatusOkByMonthByProPresentation: Array<CountProReviewsWithStatusOkByMonthByProPresentation>;
  /** fetch aggregated fields from the table: "count_pro_reviews_with_status_ok_by_month_by_pro_presentation" */
  countProReviewsWithStatusOkByMonthByProPresentationAggregate: CountProReviewsWithStatusOkByMonthByProPresentationAggregate;
  /** fetch data from the table in a streaming manner: "count_pro_reviews_with_status_ok_by_month_by_pro_presentation" */
  countProReviewsWithStatusOkByMonthByProPresentationStream: Array<CountProReviewsWithStatusOkByMonthByProPresentation>;
  /** fetch data from the table: "department" */
  department: Array<Department>;
  /** fetch aggregated fields from the table: "department" */
  departmentAggregate: DepartmentAggregate;
  /** fetch data from the table: "department" using primary key columns */
  departmentByPk?: Maybe<Department>;
  /** fetch data from the table in a streaming manner: "department" */
  departmentStream: Array<Department>;
  /** fetch data from the table: "geography_columns" */
  geographyColumns: Array<GeographyColumns>;
  /** fetch aggregated fields from the table: "geography_columns" */
  geographyColumnsAggregate: GeographyColumnsAggregate;
  /** fetch data from the table in a streaming manner: "geography_columns" */
  geographyColumnsStream: Array<GeographyColumns>;
  /** fetch data from the table: "geometry_columns" */
  geometryColumns: Array<GeometryColumns>;
  /** fetch aggregated fields from the table: "geometry_columns" */
  geometryColumnsAggregate: GeometryColumnsAggregate;
  /** fetch data from the table in a streaming manner: "geometry_columns" */
  geometryColumnsStream: Array<GeometryColumns>;
  /** fetch data from the table: "globally_blocked_identity" */
  globallyBlockedIdentity: Array<GloballyBlockedIdentity>;
  /** fetch aggregated fields from the table: "globally_blocked_identity" */
  globallyBlockedIdentityAggregate: GloballyBlockedIdentityAggregate;
  /** fetch data from the table: "globally_blocked_identity" using primary key columns */
  globallyBlockedIdentityByPk?: Maybe<GloballyBlockedIdentity>;
  /** fetch data from the table in a streaming manner: "globally_blocked_identity" */
  globallyBlockedIdentityStream: Array<GloballyBlockedIdentity>;
  /** fetch data from the table: "google_review_link" */
  googleReviewLink: Array<GoogleReviewLink>;
  /** fetch aggregated fields from the table: "google_review_link" */
  googleReviewLinkAggregate: GoogleReviewLinkAggregate;
  /** fetch data from the table: "google_review_link" using primary key columns */
  googleReviewLinkByPk?: Maybe<GoogleReviewLink>;
  /** fetch data from the table in a streaming manner: "google_review_link" */
  googleReviewLinkStream: Array<GoogleReviewLink>;
  /** fetch data from the table: "manager_bilik_person_bilik_zone" */
  managerBilikPersonBilikZone: Array<ManagerBilikPersonBilikZone>;
  /** fetch aggregated fields from the table: "manager_bilik_person_bilik_zone" */
  managerBilikPersonBilikZoneAggregate: ManagerBilikPersonBilikZoneAggregate;
  /** fetch data from the table: "manager_bilik_person_bilik_zone" using primary key columns */
  managerBilikPersonBilikZoneByPk?: Maybe<ManagerBilikPersonBilikZone>;
  /** fetch data from the table in a streaming manner: "manager_bilik_person_bilik_zone" */
  managerBilikPersonBilikZoneStream: Array<ManagerBilikPersonBilikZone>;
  /** fetch data from the table: "member_bilik_person_bilik_zone" */
  memberBilikPersonBilikZone: Array<MemberBilikPersonBilikZone>;
  /** fetch aggregated fields from the table: "member_bilik_person_bilik_zone" */
  memberBilikPersonBilikZoneAggregate: MemberBilikPersonBilikZoneAggregate;
  /** fetch data from the table: "member_bilik_person_bilik_zone" using primary key columns */
  memberBilikPersonBilikZoneByPk?: Maybe<MemberBilikPersonBilikZone>;
  /** fetch data from the table in a streaming manner: "member_bilik_person_bilik_zone" */
  memberBilikPersonBilikZoneStream: Array<MemberBilikPersonBilikZone>;
  /** fetch data from the table: "nearest_pro_view" */
  nearestProView: Array<NearestProView>;
  /** fetch aggregated fields from the table: "nearest_pro_view" */
  nearestProViewAggregate: NearestProViewAggregate;
  /** fetch data from the table in a streaming manner: "nearest_pro_view" */
  nearestProViewStream: Array<NearestProView>;
  /** fetch data from the table: "nextval" */
  nextval: Array<Nextval>;
  /** fetch aggregated fields from the table: "nextval" */
  nextvalAggregate: NextvalAggregate;
  /** fetch data from the table in a streaming manner: "nextval" */
  nextvalStream: Array<Nextval>;
  /** fetch data from the table: "note_identity" */
  noteIdentity: Array<NoteIdentity>;
  /** fetch aggregated fields from the table: "note_identity" */
  noteIdentityAggregate: NoteIdentityAggregate;
  /** fetch data from the table: "note_identity" using primary key columns */
  noteIdentityByPk?: Maybe<NoteIdentity>;
  /** fetch data from the table in a streaming manner: "note_identity" */
  noteIdentityStream: Array<NoteIdentity>;
  /** fetch data from the table: "pennylane_company_mapping" */
  pennylaneCompanyMapping: Array<PennylaneCompanyMapping>;
  /** fetch aggregated fields from the table: "pennylane_company_mapping" */
  pennylaneCompanyMappingAggregate: PennylaneCompanyMappingAggregate;
  /** fetch data from the table: "pennylane_company_mapping" using primary key columns */
  pennylaneCompanyMappingByPk?: Maybe<PennylaneCompanyMapping>;
  /** fetch data from the table in a streaming manner: "pennylane_company_mapping" */
  pennylaneCompanyMappingStream: Array<PennylaneCompanyMapping>;
  /** fetch data from the table: "phone_number" */
  phoneNumber: Array<PhoneNumber>;
  /** fetch aggregated fields from the table: "phone_number" */
  phoneNumberAggregate: PhoneNumberAggregate;
  /** fetch data from the table: "phone_number" using primary key columns */
  phoneNumberByPk?: Maybe<PhoneNumber>;
  /** fetch data from the table in a streaming manner: "phone_number" */
  phoneNumberStream: Array<PhoneNumber>;
  /** fetch data from the table: "private_individual" */
  privateIndividual: Array<PrivateIndividual>;
  /** fetch aggregated fields from the table: "private_individual" */
  privateIndividualAggregate: PrivateIndividualAggregate;
  /** fetch data from the table in a streaming manner: "private_individual" */
  privateIndividualStream: Array<PrivateIndividual>;
  /** fetch data from the table: "pro_certification" */
  proCertification: Array<ProCertification>;
  /** fetch aggregated fields from the table: "pro_certification" */
  proCertificationAggregate: ProCertificationAggregate;
  /** fetch data from the table: "pro_certification" using primary key columns */
  proCertificationByPk?: Maybe<ProCertification>;
  /** fetch data from the table in a streaming manner: "pro_certification" */
  proCertificationStream: Array<ProCertification>;
  /** fetch data from the table: "pro_holiday" */
  proHoliday: Array<ProHoliday>;
  /** fetch aggregated fields from the table: "pro_holiday" */
  proHolidayAggregate: ProHolidayAggregate;
  /** fetch data from the table: "pro_holiday" using primary key columns */
  proHolidayByPk?: Maybe<ProHoliday>;
  /** fetch data from the table in a streaming manner: "pro_holiday" */
  proHolidayStream: Array<ProHoliday>;
  /** fetch data from the table: "pro_label" */
  proLabel: Array<ProLabel>;
  /** fetch aggregated fields from the table: "pro_label" */
  proLabelAggregate: ProLabelAggregate;
  /** fetch data from the table: "pro_label" using primary key columns */
  proLabelByPk?: Maybe<ProLabel>;
  /** fetch data from the table in a streaming manner: "pro_label" */
  proLabelStream: Array<ProLabel>;
  /** fetch data from the table: "pro_mandate" */
  proMandate: Array<ProMandate>;
  /** fetch aggregated fields from the table: "pro_mandate" */
  proMandateAggregate: ProMandateAggregate;
  /** fetch data from the table: "pro_mandate" using primary key columns */
  proMandateByPk?: Maybe<ProMandate>;
  /** fetch data from the table in a streaming manner: "pro_mandate" */
  proMandateStream: Array<ProMandate>;
  /** fetch data from the table: "pro_media_object" */
  proMediaObject: Array<ProMediaObject>;
  /** fetch aggregated fields from the table: "pro_media_object" */
  proMediaObjectAggregate: ProMediaObjectAggregate;
  /** fetch data from the table: "pro_media_object" using primary key columns */
  proMediaObjectByPk?: Maybe<ProMediaObject>;
  /** fetch data from the table in a streaming manner: "pro_media_object" */
  proMediaObjectStream: Array<ProMediaObject>;
  /** fetch data from the table: "pro_message" */
  proMessage: Array<ProMessage>;
  /** fetch aggregated fields from the table: "pro_message" */
  proMessageAggregate: ProMessageAggregate;
  /** fetch data from the table: "pro_message" using primary key columns */
  proMessageByPk?: Maybe<ProMessage>;
  /** fetch data from the table in a streaming manner: "pro_message" */
  proMessageStream: Array<ProMessage>;
  /** fetch data from the table: "pro_organization_first_date_published" */
  proOrganizationFirstDatePublished: Array<ProOrganizationFirstDatePublished>;
  /** fetch aggregated fields from the table: "pro_organization_first_date_published" */
  proOrganizationFirstDatePublishedAggregate: ProOrganizationFirstDatePublishedAggregate;
  /** fetch data from the table in a streaming manner: "pro_organization_first_date_published" */
  proOrganizationFirstDatePublishedStream: Array<ProOrganizationFirstDatePublished>;
  /** fetch data from the table: "pro_person" */
  proPerson: Array<ProPerson>;
  /** fetch aggregated fields from the table: "pro_person" */
  proPersonAggregate: ProPersonAggregate;
  /** fetch data from the table: "pro_person" using primary key columns */
  proPersonByPk?: Maybe<ProPerson>;
  /** fetch data from the table in a streaming manner: "pro_person" */
  proPersonStream: Array<ProPerson>;
  /** fetch data from the table: "pro_postal_address" */
  proPostalAddress: Array<ProPostalAddress>;
  /** fetch aggregated fields from the table: "pro_postal_address" */
  proPostalAddressAggregate: ProPostalAddressAggregate;
  /** fetch data from the table: "pro_postal_address" using primary key columns */
  proPostalAddressByPk?: Maybe<ProPostalAddress>;
  /** fetch data from the table in a streaming manner: "pro_postal_address" */
  proPostalAddressStream: Array<ProPostalAddress>;
  /** fetch data from the table: "pro_presentation" */
  proPresentation: Array<ProPresentation>;
  /** fetch aggregated fields from the table: "pro_presentation" */
  proPresentationAggregate: ProPresentationAggregate;
  /** fetch data from the table: "pro_presentation" using primary key columns */
  proPresentationByPk?: Maybe<ProPresentation>;
  /** fetch data from the table in a streaming manner: "pro_presentation" */
  proPresentationStream: Array<ProPresentation>;
  /** fetch data from the table: "pro_price" */
  proPrice: Array<ProPrice>;
  /** fetch aggregated fields from the table: "pro_price" */
  proPriceAggregate: ProPriceAggregate;
  /** fetch data from the table: "pro_price" using primary key columns */
  proPriceByPk?: Maybe<ProPrice>;
  /** fetch data from the table in a streaming manner: "pro_price" */
  proPriceStream: Array<ProPrice>;
  /** fetch data from the table: "pro_review" */
  proReview: Array<ProReview>;
  /** fetch aggregated fields from the table: "pro_review" */
  proReviewAggregate: ProReviewAggregate;
  /** fetch data from the table: "pro_review" using primary key columns */
  proReviewByPk?: Maybe<ProReview>;
  /** fetch data from the table: "pro_review_invitation" */
  proReviewInvitation: Array<ProReviewInvitation>;
  /** fetch aggregated fields from the table: "pro_review_invitation" */
  proReviewInvitationAggregate: ProReviewInvitationAggregate;
  /** fetch data from the table: "pro_review_invitation" using primary key columns */
  proReviewInvitationByPk?: Maybe<ProReviewInvitation>;
  /** fetch data from the table in a streaming manner: "pro_review_invitation" */
  proReviewInvitationStream: Array<ProReviewInvitation>;
  /** fetch data from the table in a streaming manner: "pro_review" */
  proReviewStream: Array<ProReview>;
  /** fetch data from the table: "pro_view" */
  proView: Array<ProView>;
  /** fetch aggregated fields from the table: "pro_view" */
  proViewAggregate: ProViewAggregate;
  /** fetch data from the table: "pro_view" using primary key columns */
  proViewByPk?: Maybe<ProView>;
  /** fetch data from the table: "pro_view_pro_person" */
  proViewProPerson: Array<ProViewProPerson>;
  /** fetch aggregated fields from the table: "pro_view_pro_person" */
  proViewProPersonAggregate: ProViewProPersonAggregate;
  /** fetch data from the table: "pro_view_pro_person" using primary key columns */
  proViewProPersonByPk?: Maybe<ProViewProPerson>;
  /** fetch data from the table in a streaming manner: "pro_view_pro_person" */
  proViewProPersonStream: Array<ProViewProPerson>;
  /** fetch data from the table: "pro_view_pro_view" */
  proViewProView: Array<ProViewProView>;
  /** fetch aggregated fields from the table: "pro_view_pro_view" */
  proViewProViewAggregate: ProViewProViewAggregate;
  /** fetch data from the table: "pro_view_pro_view" using primary key columns */
  proViewProViewByPk?: Maybe<ProViewProView>;
  /** fetch data from the table in a streaming manner: "pro_view_pro_view" */
  proViewProViewStream: Array<ProViewProView>;
  /** fetch data from the table in a streaming manner: "pro_view" */
  proViewStream: Array<ProView>;
  /** fetch data from the table: "queued_sms" */
  queuedSms: Array<QueuedSms>;
  /** An aggregate relationship */
  queuedSmsAggregate: QueuedSmsAggregate;
  /** fetch data from the table: "queued_sms" using primary key columns */
  queuedSmsByPk?: Maybe<QueuedSms>;
  /** fetch data from the table in a streaming manner: "queued_sms" */
  queuedSmsStream: Array<QueuedSms>;
  /** execute function "random_pro_views" which returns "pro_view" */
  randomProViews: Array<ProView>;
  /** execute function "random_pro_views" and query aggregates on result of table type "pro_view" */
  randomProViewsAggregate: ProViewAggregate;
  /** fetch data from the table: "region" */
  region: Array<Region>;
  /** fetch aggregated fields from the table: "region" */
  regionAggregate: RegionAggregate;
  /** fetch data from the table: "region" using primary key columns */
  regionByPk?: Maybe<Region>;
  /** fetch data from the table in a streaming manner: "region" */
  regionStream: Array<Region>;
  /** fetch data from the table: "review_presentation" */
  reviewPresentation: Array<ReviewPresentation>;
  /** fetch aggregated fields from the table: "review_presentation" */
  reviewPresentationAggregate: ReviewPresentationAggregate;
  /** fetch data from the table: "review_presentation" using primary key columns */
  reviewPresentationByPk?: Maybe<ReviewPresentation>;
  /** fetch data from the table in a streaming manner: "review_presentation" */
  reviewPresentationStream: Array<ReviewPresentation>;
  /** fetch data from the table: "review_reference_view" */
  reviewReferenceView: Array<ReviewReferenceView>;
  /** fetch aggregated fields from the table: "review_reference_view" */
  reviewReferenceViewAggregate: ReviewReferenceViewAggregate;
  /** fetch data from the table in a streaming manner: "review_reference_view" */
  reviewReferenceViewStream: Array<ReviewReferenceView>;
  /** execute function "search_city" which returns "city" */
  searchCity: Array<City>;
  /** execute function "search_city" and query aggregates on result of table type "city" */
  searchCityAggregate: CityAggregate;
  /** execute function "search_nearest_city" which returns "city" */
  searchNearestCity: Array<City>;
  /** execute function "search_nearest_city" and query aggregates on result of table type "city" */
  searchNearestCityAggregate: CityAggregate;
  /** execute function "search_nearest_pro_review" which returns "pro_review" */
  searchNearestProReview: Array<ProReview>;
  /** execute function "search_nearest_pro_review" and query aggregates on result of table type "pro_review" */
  searchNearestProReviewAggregate: ProReviewAggregate;
  /** execute function "search_nearest_pro_view" which returns "nearest_pro_view" */
  searchNearestProView: Array<NearestProView>;
  /** execute function "search_nearest_pro_view" and query aggregates on result of table type "nearest_pro_view" */
  searchNearestProViewAggregate: NearestProViewAggregate;
  /** execute function "search_pro_person" which returns "pro_person" */
  searchProPerson: Array<ProPerson>;
  /** execute function "search_pro_person" and query aggregates on result of table type "pro_person" */
  searchProPersonAggregate: ProPersonAggregate;
  /** execute function "search_pro_presentation" which returns "pro_presentation" */
  searchProPresentation: Array<ProPresentation>;
  /** execute function "search_pro_presentation" and query aggregates on result of table type "pro_presentation" */
  searchProPresentationAggregate: ProPresentationAggregate;
  /** execute function "search_pro_review" which returns "pro_review" */
  searchProReview: Array<ProReview>;
  /** execute function "search_pro_review" and query aggregates on result of table type "pro_review" */
  searchProReviewAggregate: ProReviewAggregate;
  /** execute function "search_pro_review_invitation" which returns "pro_review_invitation" */
  searchProReviewInvitation: Array<ProReviewInvitation>;
  /** execute function "search_pro_review_invitation" and query aggregates on result of table type "pro_review_invitation" */
  searchProReviewInvitationAggregate: ProReviewInvitationAggregate;
  /** execute function "search_pro_view" which returns "pro_view" */
  searchProView: Array<ProView>;
  /** execute function "search_pro_view" and query aggregates on result of table type "pro_view" */
  searchProViewAggregate: ProViewAggregate;
  /** execute function "search_solicitation" which returns "solicitation" */
  searchSolicitation: Array<Solicitation>;
  /** execute function "search_solicitation" and query aggregates on result of table type "solicitation" */
  searchSolicitationAggregate: SolicitationAggregate;
  /** execute function "search_trade" which returns "trade" */
  searchTrade: Array<Trade>;
  /** execute function "search_trade" and query aggregates on result of table type "trade" */
  searchTradeAggregate: TradeAggregate;
  /** execute function "search_trade_group" which returns "trade_group" */
  searchTradeGroup: Array<TradeGroup>;
  /** execute function "search_trade_group" and query aggregates on result of table type "trade_group" */
  searchTradeGroupAggregate: TradeGroupAggregate;
  /** fetch data from the table: "sitemap_bilik_zone" */
  sitemapBilikZone: Array<SitemapBilikZone>;
  /** fetch aggregated fields from the table: "sitemap_bilik_zone" */
  sitemapBilikZoneAggregate: SitemapBilikZoneAggregate;
  /** fetch data from the table in a streaming manner: "sitemap_bilik_zone" */
  sitemapBilikZoneStream: Array<SitemapBilikZone>;
  /** fetch data from the table: "sitemap_city" */
  sitemapCity: Array<SitemapCity>;
  /** fetch aggregated fields from the table: "sitemap_city" */
  sitemapCityAggregate: SitemapCityAggregate;
  /** fetch data from the table in a streaming manner: "sitemap_city" */
  sitemapCityStream: Array<SitemapCity>;
  /** fetch data from the table: "slug_redirect" */
  slugRedirect: Array<SlugRedirect>;
  /** fetch aggregated fields from the table: "slug_redirect" */
  slugRedirectAggregate: SlugRedirectAggregate;
  /** fetch data from the table: "slug_redirect" using primary key columns */
  slugRedirectByPk?: Maybe<SlugRedirect>;
  /** fetch data from the table in a streaming manner: "slug_redirect" */
  slugRedirectStream: Array<SlugRedirect>;
  /** fetch data from the table: "solicitation" */
  solicitation: Array<Solicitation>;
  /** fetch aggregated fields from the table: "solicitation" */
  solicitationAggregate: SolicitationAggregate;
  /** fetch data from the table: "solicitation" using primary key columns */
  solicitationByPk?: Maybe<Solicitation>;
  /** fetch data from the table: "solicitation_stat" */
  solicitationStat: Array<SolicitationStat>;
  /** fetch aggregated fields from the table: "solicitation_stat" */
  solicitationStatAggregate: SolicitationStatAggregate;
  /** fetch data from the table in a streaming manner: "solicitation_stat" */
  solicitationStatStream: Array<SolicitationStat>;
  /** fetch data from the table in a streaming manner: "solicitation" */
  solicitationStream: Array<Solicitation>;
  /** fetch data from the table: "spatial_ref_sys" */
  spatialRefSys: Array<SpatialRefSys>;
  /** fetch aggregated fields from the table: "spatial_ref_sys" */
  spatialRefSysAggregate: SpatialRefSysAggregate;
  /** fetch data from the table: "spatial_ref_sys" using primary key columns */
  spatialRefSysByPk?: Maybe<SpatialRefSys>;
  /** fetch data from the table in a streaming manner: "spatial_ref_sys" */
  spatialRefSysStream: Array<SpatialRefSys>;
  /** fetch data from the table: "stop_sms" */
  stopSms: Array<StopSms>;
  /** fetch aggregated fields from the table: "stop_sms" */
  stopSmsAggregate: StopSmsAggregate;
  /** fetch data from the table: "stop_sms" using primary key columns */
  stopSmsByPk?: Maybe<StopSms>;
  /** fetch data from the table in a streaming manner: "stop_sms" */
  stopSmsStream: Array<StopSms>;
  /** fetch data from the table: "subscription" */
  subscription: Array<Subscription>;
  /** fetch aggregated fields from the table: "subscription" */
  subscriptionAggregate: SubscriptionAggregate;
  /** fetch data from the table: "subscription" using primary key columns */
  subscriptionByPk?: Maybe<Subscription>;
  /** fetch data from the table in a streaming manner: "subscription" */
  subscriptionStream: Array<Subscription>;
  /** fetch data from the table: "timeline_private_individual" */
  timelinePrivateIndividual: Array<TimelinePrivateIndividual>;
  /** fetch aggregated fields from the table: "timeline_private_individual" */
  timelinePrivateIndividualAggregate: TimelinePrivateIndividualAggregate;
  /** fetch data from the table in a streaming manner: "timeline_private_individual" */
  timelinePrivateIndividualStream: Array<TimelinePrivateIndividual>;
  /** fetch data from the table: "topology.layer" */
  topologyLayer: Array<TopologyLayer>;
  /** fetch aggregated fields from the table: "topology.layer" */
  topologyLayerAggregate: TopologyLayerAggregate;
  /** fetch data from the table: "topology.layer" using primary key columns */
  topologyLayerByPk?: Maybe<TopologyLayer>;
  /** fetch data from the table in a streaming manner: "topology.layer" */
  topologyLayerStream: Array<TopologyLayer>;
  /** fetch data from the table: "topology.topology" */
  topologyTopology: Array<TopologyTopology>;
  /** fetch aggregated fields from the table: "topology.topology" */
  topologyTopologyAggregate: TopologyTopologyAggregate;
  /** fetch data from the table: "topology.topology" using primary key columns */
  topologyTopologyByPk?: Maybe<TopologyTopology>;
  /** fetch data from the table in a streaming manner: "topology.topology" */
  topologyTopologyStream: Array<TopologyTopology>;
  /** fetch data from the table: "trade" */
  trade: Array<Trade>;
  /** fetch aggregated fields from the table: "trade" */
  tradeAggregate: TradeAggregate;
  /** fetch data from the table: "trade" using primary key columns */
  tradeByPk?: Maybe<Trade>;
  /** fetch data from the table: "trade_group" */
  tradeGroup: Array<TradeGroup>;
  /** fetch aggregated fields from the table: "trade_group" */
  tradeGroupAggregate: TradeGroupAggregate;
  /** fetch data from the table: "trade_group" using primary key columns */
  tradeGroupByPk?: Maybe<TradeGroup>;
  /** fetch data from the table in a streaming manner: "trade_group" */
  tradeGroupStream: Array<TradeGroup>;
  /** fetch data from the table: "trade_guide" */
  tradeGuide: Array<TradeGuide>;
  /** fetch aggregated fields from the table: "trade_guide" */
  tradeGuideAggregate: TradeGuideAggregate;
  /** fetch data from the table: "trade_guide" using primary key columns */
  tradeGuideByPk?: Maybe<TradeGuide>;
  /** fetch data from the table in a streaming manner: "trade_guide" */
  tradeGuideStream: Array<TradeGuide>;
  /** fetch data from the table: "trade_keyword" */
  tradeKeyword: Array<TradeKeyword>;
  /** fetch aggregated fields from the table: "trade_keyword" */
  tradeKeywordAggregate: TradeKeywordAggregate;
  /** fetch data from the table: "trade_keyword" using primary key columns */
  tradeKeywordByPk?: Maybe<TradeKeyword>;
  /** fetch data from the table in a streaming manner: "trade_keyword" */
  tradeKeywordStream: Array<TradeKeyword>;
  /** fetch data from the table: "trade_main_pro_count" */
  tradeMainProCount: Array<TradeMainProCount>;
  /** fetch aggregated fields from the table: "trade_main_pro_count" */
  tradeMainProCountAggregate: TradeMainProCountAggregate;
  /** fetch data from the table in a streaming manner: "trade_main_pro_count" */
  tradeMainProCountStream: Array<TradeMainProCount>;
  /** fetch data from the table: "trade_pro_presentation" */
  tradeProPresentation: Array<TradeProPresentation>;
  /** fetch aggregated fields from the table: "trade_pro_presentation" */
  tradeProPresentationAggregate: TradeProPresentationAggregate;
  /** fetch data from the table: "trade_pro_presentation" using primary key columns */
  tradeProPresentationByPk?: Maybe<TradeProPresentation>;
  /** fetch data from the table in a streaming manner: "trade_pro_presentation" */
  tradeProPresentationStream: Array<TradeProPresentation>;
  /** fetch data from the table: "trade_pro_view" */
  tradeProView: Array<TradeProView>;
  /** fetch aggregated fields from the table: "trade_pro_view" */
  tradeProViewAggregate: TradeProViewAggregate;
  /** fetch data from the table: "trade_pro_view" using primary key columns */
  tradeProViewByPk?: Maybe<TradeProView>;
  /** fetch data from the table in a streaming manner: "trade_pro_view" */
  tradeProViewStream: Array<TradeProView>;
  /** fetch data from the table: "trade_question" */
  tradeQuestion: Array<TradeQuestion>;
  /** fetch aggregated fields from the table: "trade_question" */
  tradeQuestionAggregate: TradeQuestionAggregate;
  /** fetch data from the table: "trade_question" using primary key columns */
  tradeQuestionByPk?: Maybe<TradeQuestion>;
  /** fetch data from the table in a streaming manner: "trade_question" */
  tradeQuestionStream: Array<TradeQuestion>;
  /** fetch data from the table in a streaming manner: "trade" */
  tradeStream: Array<Trade>;
  /** fetch data from the table: "trade_trade_group" */
  tradeTradeGroup: Array<TradeTradeGroup>;
  /** fetch aggregated fields from the table: "trade_trade_group" */
  tradeTradeGroupAggregate: TradeTradeGroupAggregate;
  /** fetch data from the table: "trade_trade_group" using primary key columns */
  tradeTradeGroupByPk?: Maybe<TradeTradeGroup>;
  /** fetch data from the table in a streaming manner: "trade_trade_group" */
  tradeTradeGroupStream: Array<TradeTradeGroup>;
  /** fetch data from the table: "trade_trade_guide" */
  tradeTradeGuide: Array<TradeTradeGuide>;
  /** fetch aggregated fields from the table: "trade_trade_guide" */
  tradeTradeGuideAggregate: TradeTradeGuideAggregate;
  /** fetch data from the table: "trade_trade_guide" using primary key columns */
  tradeTradeGuideByPk?: Maybe<TradeTradeGuide>;
  /** fetch data from the table in a streaming manner: "trade_trade_guide" */
  tradeTradeGuideStream: Array<TradeTradeGuide>;
  /** fetch data from the table: "utm_record" */
  utmRecord: Array<UtmRecord>;
  /** fetch aggregated fields from the table: "utm_record" */
  utmRecordAggregate: UtmRecordAggregate;
  /** fetch data from the table: "utm_record" using primary key columns */
  utmRecordByPk?: Maybe<UtmRecord>;
  /** fetch data from the table in a streaming manner: "utm_record" */
  utmRecordStream: Array<UtmRecord>;
  /** fetch data from the table: "view_active_holiday" */
  viewActiveHoliday: Array<ViewActiveHoliday>;
  /** fetch aggregated fields from the table: "view_active_holiday" */
  viewActiveHolidayAggregate: ViewActiveHolidayAggregate;
  /** fetch data from the table in a streaming manner: "view_active_holiday" */
  viewActiveHolidayStream: Array<ViewActiveHoliday>;
  /** fetch data from the table: "zoho_consumer" */
  zohoConsumer: Array<ZohoConsumer>;
  /** fetch aggregated fields from the table: "zoho_consumer" */
  zohoConsumerAggregate: ZohoConsumerAggregate;
  /** fetch data from the table: "zoho_consumer" using primary key columns */
  zohoConsumerByPk?: Maybe<ZohoConsumer>;
  /** fetch data from the table in a streaming manner: "zoho_consumer" */
  zohoConsumerStream: Array<ZohoConsumer>;
  /** fetch data from the table: "zoho_organization" */
  zohoOrganization: Array<ZohoOrganization>;
  /** fetch aggregated fields from the table: "zoho_organization" */
  zohoOrganizationAggregate: ZohoOrganizationAggregate;
  /** fetch data from the table: "zoho_organization" using primary key columns */
  zohoOrganizationByPk?: Maybe<ZohoOrganization>;
  /** fetch data from the table in a streaming manner: "zoho_organization" */
  zohoOrganizationStream: Array<ZohoOrganization>;
  /** fetch data from the table: "zoho_token" */
  zohoToken: Array<ZohoToken>;
  /** fetch aggregated fields from the table: "zoho_token" */
  zohoTokenAggregate: ZohoTokenAggregate;
  /** fetch data from the table: "zoho_token" using primary key columns */
  zohoTokenByPk?: Maybe<ZohoToken>;
  /** fetch data from the table in a streaming manner: "zoho_token" */
  zohoTokenStream: Array<ZohoToken>;
};


export type SubscriptionRootAccountProViewArgs = {
  distinctOn?: InputMaybe<Array<AccountProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountProViewOrderBy>>;
  where?: InputMaybe<AccountProViewBoolExp>;
};


export type SubscriptionRootAccountProViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountProViewOrderBy>>;
  where?: InputMaybe<AccountProViewBoolExp>;
};


export type SubscriptionRootAccountProViewByPkArgs = {
  authUserId: Scalars['uuid'];
  proViewId: Scalars['Int'];
};


export type SubscriptionRootAccountProViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccountProViewStreamCursorInput>>;
  where?: InputMaybe<AccountProViewBoolExp>;
};


export type SubscriptionRootActionTokenArgs = {
  distinctOn?: InputMaybe<Array<ActionTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActionTokenOrderBy>>;
  where?: InputMaybe<ActionTokenBoolExp>;
};


export type SubscriptionRootActionTokenAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActionTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActionTokenOrderBy>>;
  where?: InputMaybe<ActionTokenBoolExp>;
};


export type SubscriptionRootActionTokenByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootActionTokenStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ActionTokenStreamCursorInput>>;
  where?: InputMaybe<ActionTokenBoolExp>;
};


export type SubscriptionRootAnnouncementArgs = {
  distinctOn?: InputMaybe<Array<AnnouncementSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AnnouncementOrderBy>>;
  where?: InputMaybe<AnnouncementBoolExp>;
};


export type SubscriptionRootAnnouncementAggregateArgs = {
  distinctOn?: InputMaybe<Array<AnnouncementSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AnnouncementOrderBy>>;
  where?: InputMaybe<AnnouncementBoolExp>;
};


export type SubscriptionRootAnnouncementByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAnnouncementStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AnnouncementStreamCursorInput>>;
  where?: InputMaybe<AnnouncementBoolExp>;
};


export type SubscriptionRootAutorespondArgs = {
  distinctOn?: InputMaybe<Array<AutorespondSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AutorespondOrderBy>>;
  where?: InputMaybe<AutorespondBoolExp>;
};


export type SubscriptionRootAutorespondAggregateArgs = {
  distinctOn?: InputMaybe<Array<AutorespondSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AutorespondOrderBy>>;
  where?: InputMaybe<AutorespondBoolExp>;
};


export type SubscriptionRootAutorespondByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAutorespondStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AutorespondStreamCursorInput>>;
  where?: InputMaybe<AutorespondBoolExp>;
};


export type SubscriptionRootBilikPersonArgs = {
  distinctOn?: InputMaybe<Array<BilikPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikPersonOrderBy>>;
  where?: InputMaybe<BilikPersonBoolExp>;
};


export type SubscriptionRootBilikPersonAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikPersonOrderBy>>;
  where?: InputMaybe<BilikPersonBoolExp>;
};


export type SubscriptionRootBilikPersonByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootBilikPersonStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BilikPersonStreamCursorInput>>;
  where?: InputMaybe<BilikPersonBoolExp>;
};


export type SubscriptionRootBilikSolicitationArgs = {
  distinctOn?: InputMaybe<Array<BilikSolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikSolicitationOrderBy>>;
  where?: InputMaybe<BilikSolicitationBoolExp>;
};


export type SubscriptionRootBilikSolicitationAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikSolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikSolicitationOrderBy>>;
  where?: InputMaybe<BilikSolicitationBoolExp>;
};


export type SubscriptionRootBilikSolicitationByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootBilikSolicitationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BilikSolicitationStreamCursorInput>>;
  where?: InputMaybe<BilikSolicitationBoolExp>;
};


export type SubscriptionRootBilikZoneArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneOrderBy>>;
  where?: InputMaybe<BilikZoneBoolExp>;
};


export type SubscriptionRootBilikZoneAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneOrderBy>>;
  where?: InputMaybe<BilikZoneBoolExp>;
};


export type SubscriptionRootBilikZoneByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootBilikZoneOutlineArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneOutlineSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneOutlineOrderBy>>;
  where?: InputMaybe<BilikZoneOutlineBoolExp>;
};


export type SubscriptionRootBilikZoneOutlineAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneOutlineSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneOutlineOrderBy>>;
  where?: InputMaybe<BilikZoneOutlineBoolExp>;
};


export type SubscriptionRootBilikZoneOutlineStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BilikZoneOutlineStreamCursorInput>>;
  where?: InputMaybe<BilikZoneOutlineBoolExp>;
};


export type SubscriptionRootBilikZoneStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BilikZoneStreamCursorInput>>;
  where?: InputMaybe<BilikZoneBoolExp>;
};


export type SubscriptionRootBilikZoneTradeMainProCountArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneTradeMainProCountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneTradeMainProCountOrderBy>>;
  where?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
};


export type SubscriptionRootBilikZoneTradeMainProCountAggregateArgs = {
  distinctOn?: InputMaybe<Array<BilikZoneTradeMainProCountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BilikZoneTradeMainProCountOrderBy>>;
  where?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
};


export type SubscriptionRootBilikZoneTradeMainProCountStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BilikZoneTradeMainProCountStreamCursorInput>>;
  where?: InputMaybe<BilikZoneTradeMainProCountBoolExp>;
};


export type SubscriptionRootCertificationArgs = {
  distinctOn?: InputMaybe<Array<CertificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CertificationOrderBy>>;
  where?: InputMaybe<CertificationBoolExp>;
};


export type SubscriptionRootCertificationAggregateArgs = {
  distinctOn?: InputMaybe<Array<CertificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CertificationOrderBy>>;
  where?: InputMaybe<CertificationBoolExp>;
};


export type SubscriptionRootCertificationByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCertificationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CertificationStreamCursorInput>>;
  where?: InputMaybe<CertificationBoolExp>;
};


export type SubscriptionRootCityArgs = {
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


export type SubscriptionRootCityAggregateArgs = {
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


export type SubscriptionRootCityByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCityProViewArgs = {
  distinctOn?: InputMaybe<Array<CityProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityProViewOrderBy>>;
  where?: InputMaybe<CityProViewBoolExp>;
};


export type SubscriptionRootCityProViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<CityProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityProViewOrderBy>>;
  where?: InputMaybe<CityProViewBoolExp>;
};


export type SubscriptionRootCityProViewByPkArgs = {
  cityId: Scalars['Int'];
  proViewId: Scalars['Int'];
};


export type SubscriptionRootCityProViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CityProViewStreamCursorInput>>;
  where?: InputMaybe<CityProViewBoolExp>;
};


export type SubscriptionRootCityStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CityStreamCursorInput>>;
  where?: InputMaybe<CityBoolExp>;
};


export type SubscriptionRootCompanyArgs = {
  distinctOn?: InputMaybe<Array<CompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyOrderBy>>;
  where?: InputMaybe<CompanyBoolExp>;
};


export type SubscriptionRootCompanyAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyOrderBy>>;
  where?: InputMaybe<CompanyBoolExp>;
};


export type SubscriptionRootCompanyByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCompanyStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyStreamCursorInput>>;
  where?: InputMaybe<CompanyBoolExp>;
};


export type SubscriptionRootCountCitySameSlugArgs = {
  distinctOn?: InputMaybe<Array<CountCitySameSlugSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountCitySameSlugOrderBy>>;
  where?: InputMaybe<CountCitySameSlugBoolExp>;
};


export type SubscriptionRootCountCitySameSlugAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountCitySameSlugSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountCitySameSlugOrderBy>>;
  where?: InputMaybe<CountCitySameSlugBoolExp>;
};


export type SubscriptionRootCountCitySameSlugStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CountCitySameSlugStreamCursorInput>>;
  where?: InputMaybe<CountCitySameSlugBoolExp>;
};


export type SubscriptionRootCountProReviewByStatusArgs = {
  distinctOn?: InputMaybe<Array<CountProReviewByStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountProReviewByStatusOrderBy>>;
  where?: InputMaybe<CountProReviewByStatusBoolExp>;
};


export type SubscriptionRootCountProReviewByStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountProReviewByStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountProReviewByStatusOrderBy>>;
  where?: InputMaybe<CountProReviewByStatusBoolExp>;
};


export type SubscriptionRootCountProReviewByStatusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CountProReviewByStatusStreamCursorInput>>;
  where?: InputMaybe<CountProReviewByStatusBoolExp>;
};


export type SubscriptionRootCountProReviewInvitationsByMonthByProPresentationArgs = {
  distinctOn?: InputMaybe<Array<CountProReviewInvitationsByMonthByProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountProReviewInvitationsByMonthByProPresentationOrderBy>>;
  where?: InputMaybe<CountProReviewInvitationsByMonthByProPresentationBoolExp>;
};


export type SubscriptionRootCountProReviewInvitationsByMonthByProPresentationAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountProReviewInvitationsByMonthByProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountProReviewInvitationsByMonthByProPresentationOrderBy>>;
  where?: InputMaybe<CountProReviewInvitationsByMonthByProPresentationBoolExp>;
};


export type SubscriptionRootCountProReviewInvitationsByMonthByProPresentationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CountProReviewInvitationsByMonthByProPresentationStreamCursorInput>>;
  where?: InputMaybe<CountProReviewInvitationsByMonthByProPresentationBoolExp>;
};


export type SubscriptionRootCountProReviewsWithStatusOkByMonthByProPresentationArgs = {
  distinctOn?: InputMaybe<Array<CountProReviewsWithStatusOkByMonthByProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountProReviewsWithStatusOkByMonthByProPresentationOrderBy>>;
  where?: InputMaybe<CountProReviewsWithStatusOkByMonthByProPresentationBoolExp>;
};


export type SubscriptionRootCountProReviewsWithStatusOkByMonthByProPresentationAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountProReviewsWithStatusOkByMonthByProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountProReviewsWithStatusOkByMonthByProPresentationOrderBy>>;
  where?: InputMaybe<CountProReviewsWithStatusOkByMonthByProPresentationBoolExp>;
};


export type SubscriptionRootCountProReviewsWithStatusOkByMonthByProPresentationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CountProReviewsWithStatusOkByMonthByProPresentationStreamCursorInput>>;
  where?: InputMaybe<CountProReviewsWithStatusOkByMonthByProPresentationBoolExp>;
};


export type SubscriptionRootDepartmentArgs = {
  distinctOn?: InputMaybe<Array<DepartmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentOrderBy>>;
  where?: InputMaybe<DepartmentBoolExp>;
};


export type SubscriptionRootDepartmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<DepartmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentOrderBy>>;
  where?: InputMaybe<DepartmentBoolExp>;
};


export type SubscriptionRootDepartmentByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDepartmentStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<DepartmentStreamCursorInput>>;
  where?: InputMaybe<DepartmentBoolExp>;
};


export type SubscriptionRootGeographyColumnsArgs = {
  distinctOn?: InputMaybe<Array<GeographyColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeographyColumnsOrderBy>>;
  where?: InputMaybe<GeographyColumnsBoolExp>;
};


export type SubscriptionRootGeographyColumnsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeographyColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeographyColumnsOrderBy>>;
  where?: InputMaybe<GeographyColumnsBoolExp>;
};


export type SubscriptionRootGeographyColumnsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GeographyColumnsStreamCursorInput>>;
  where?: InputMaybe<GeographyColumnsBoolExp>;
};


export type SubscriptionRootGeometryColumnsArgs = {
  distinctOn?: InputMaybe<Array<GeometryColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeometryColumnsOrderBy>>;
  where?: InputMaybe<GeometryColumnsBoolExp>;
};


export type SubscriptionRootGeometryColumnsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeometryColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeometryColumnsOrderBy>>;
  where?: InputMaybe<GeometryColumnsBoolExp>;
};


export type SubscriptionRootGeometryColumnsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GeometryColumnsStreamCursorInput>>;
  where?: InputMaybe<GeometryColumnsBoolExp>;
};


export type SubscriptionRootGloballyBlockedIdentityArgs = {
  distinctOn?: InputMaybe<Array<GloballyBlockedIdentitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GloballyBlockedIdentityOrderBy>>;
  where?: InputMaybe<GloballyBlockedIdentityBoolExp>;
};


export type SubscriptionRootGloballyBlockedIdentityAggregateArgs = {
  distinctOn?: InputMaybe<Array<GloballyBlockedIdentitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GloballyBlockedIdentityOrderBy>>;
  where?: InputMaybe<GloballyBlockedIdentityBoolExp>;
};


export type SubscriptionRootGloballyBlockedIdentityByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootGloballyBlockedIdentityStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GloballyBlockedIdentityStreamCursorInput>>;
  where?: InputMaybe<GloballyBlockedIdentityBoolExp>;
};


export type SubscriptionRootGoogleReviewLinkArgs = {
  distinctOn?: InputMaybe<Array<GoogleReviewLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GoogleReviewLinkOrderBy>>;
  where?: InputMaybe<GoogleReviewLinkBoolExp>;
};


export type SubscriptionRootGoogleReviewLinkAggregateArgs = {
  distinctOn?: InputMaybe<Array<GoogleReviewLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GoogleReviewLinkOrderBy>>;
  where?: InputMaybe<GoogleReviewLinkBoolExp>;
};


export type SubscriptionRootGoogleReviewLinkByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootGoogleReviewLinkStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GoogleReviewLinkStreamCursorInput>>;
  where?: InputMaybe<GoogleReviewLinkBoolExp>;
};


export type SubscriptionRootManagerBilikPersonBilikZoneArgs = {
  distinctOn?: InputMaybe<Array<ManagerBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ManagerBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
};


export type SubscriptionRootManagerBilikPersonBilikZoneAggregateArgs = {
  distinctOn?: InputMaybe<Array<ManagerBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ManagerBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
};


export type SubscriptionRootManagerBilikPersonBilikZoneByPkArgs = {
  bilikPersonId: Scalars['Int'];
  bilikZoneId: Scalars['Int'];
};


export type SubscriptionRootManagerBilikPersonBilikZoneStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ManagerBilikPersonBilikZoneStreamCursorInput>>;
  where?: InputMaybe<ManagerBilikPersonBilikZoneBoolExp>;
};


export type SubscriptionRootMemberBilikPersonBilikZoneArgs = {
  distinctOn?: InputMaybe<Array<MemberBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MemberBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
};


export type SubscriptionRootMemberBilikPersonBilikZoneAggregateArgs = {
  distinctOn?: InputMaybe<Array<MemberBilikPersonBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MemberBilikPersonBilikZoneOrderBy>>;
  where?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
};


export type SubscriptionRootMemberBilikPersonBilikZoneByPkArgs = {
  bilikPersonId: Scalars['Int'];
  bilikZoneId: Scalars['Int'];
};


export type SubscriptionRootMemberBilikPersonBilikZoneStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MemberBilikPersonBilikZoneStreamCursorInput>>;
  where?: InputMaybe<MemberBilikPersonBilikZoneBoolExp>;
};


export type SubscriptionRootNearestProViewArgs = {
  distinctOn?: InputMaybe<Array<NearestProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NearestProViewOrderBy>>;
  where?: InputMaybe<NearestProViewBoolExp>;
};


export type SubscriptionRootNearestProViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<NearestProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NearestProViewOrderBy>>;
  where?: InputMaybe<NearestProViewBoolExp>;
};


export type SubscriptionRootNearestProViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<NearestProViewStreamCursorInput>>;
  where?: InputMaybe<NearestProViewBoolExp>;
};


export type SubscriptionRootNextvalArgs = {
  distinctOn?: InputMaybe<Array<NextvalSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NextvalOrderBy>>;
  where?: InputMaybe<NextvalBoolExp>;
};


export type SubscriptionRootNextvalAggregateArgs = {
  distinctOn?: InputMaybe<Array<NextvalSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NextvalOrderBy>>;
  where?: InputMaybe<NextvalBoolExp>;
};


export type SubscriptionRootNextvalStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<NextvalStreamCursorInput>>;
  where?: InputMaybe<NextvalBoolExp>;
};


export type SubscriptionRootNoteIdentityArgs = {
  distinctOn?: InputMaybe<Array<NoteIdentitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteIdentityOrderBy>>;
  where?: InputMaybe<NoteIdentityBoolExp>;
};


export type SubscriptionRootNoteIdentityAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteIdentitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteIdentityOrderBy>>;
  where?: InputMaybe<NoteIdentityBoolExp>;
};


export type SubscriptionRootNoteIdentityByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootNoteIdentityStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<NoteIdentityStreamCursorInput>>;
  where?: InputMaybe<NoteIdentityBoolExp>;
};


export type SubscriptionRootPennylaneCompanyMappingArgs = {
  distinctOn?: InputMaybe<Array<PennylaneCompanyMappingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PennylaneCompanyMappingOrderBy>>;
  where?: InputMaybe<PennylaneCompanyMappingBoolExp>;
};


export type SubscriptionRootPennylaneCompanyMappingAggregateArgs = {
  distinctOn?: InputMaybe<Array<PennylaneCompanyMappingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PennylaneCompanyMappingOrderBy>>;
  where?: InputMaybe<PennylaneCompanyMappingBoolExp>;
};


export type SubscriptionRootPennylaneCompanyMappingByPkArgs = {
  billingIssuerId: Scalars['Int'];
  companyId: Scalars['Int'];
};


export type SubscriptionRootPennylaneCompanyMappingStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PennylaneCompanyMappingStreamCursorInput>>;
  where?: InputMaybe<PennylaneCompanyMappingBoolExp>;
};


export type SubscriptionRootPhoneNumberArgs = {
  distinctOn?: InputMaybe<Array<PhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhoneNumberOrderBy>>;
  where?: InputMaybe<PhoneNumberBoolExp>;
};


export type SubscriptionRootPhoneNumberAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhoneNumberOrderBy>>;
  where?: InputMaybe<PhoneNumberBoolExp>;
};


export type SubscriptionRootPhoneNumberByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootPhoneNumberStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PhoneNumberStreamCursorInput>>;
  where?: InputMaybe<PhoneNumberBoolExp>;
};


export type SubscriptionRootPrivateIndividualArgs = {
  distinctOn?: InputMaybe<Array<PrivateIndividualSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PrivateIndividualOrderBy>>;
  where?: InputMaybe<PrivateIndividualBoolExp>;
};


export type SubscriptionRootPrivateIndividualAggregateArgs = {
  distinctOn?: InputMaybe<Array<PrivateIndividualSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PrivateIndividualOrderBy>>;
  where?: InputMaybe<PrivateIndividualBoolExp>;
};


export type SubscriptionRootPrivateIndividualStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PrivateIndividualStreamCursorInput>>;
  where?: InputMaybe<PrivateIndividualBoolExp>;
};


export type SubscriptionRootProCertificationArgs = {
  distinctOn?: InputMaybe<Array<ProCertificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProCertificationOrderBy>>;
  where?: InputMaybe<ProCertificationBoolExp>;
};


export type SubscriptionRootProCertificationAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProCertificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProCertificationOrderBy>>;
  where?: InputMaybe<ProCertificationBoolExp>;
};


export type SubscriptionRootProCertificationByPkArgs = {
  certificationId: Scalars['Int'];
  proPresentationId: Scalars['Int'];
};


export type SubscriptionRootProCertificationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProCertificationStreamCursorInput>>;
  where?: InputMaybe<ProCertificationBoolExp>;
};


export type SubscriptionRootProHolidayArgs = {
  distinctOn?: InputMaybe<Array<ProHolidaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProHolidayOrderBy>>;
  where?: InputMaybe<ProHolidayBoolExp>;
};


export type SubscriptionRootProHolidayAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProHolidaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProHolidayOrderBy>>;
  where?: InputMaybe<ProHolidayBoolExp>;
};


export type SubscriptionRootProHolidayByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProHolidayStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProHolidayStreamCursorInput>>;
  where?: InputMaybe<ProHolidayBoolExp>;
};


export type SubscriptionRootProLabelArgs = {
  distinctOn?: InputMaybe<Array<ProLabelSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProLabelOrderBy>>;
  where?: InputMaybe<ProLabelBoolExp>;
};


export type SubscriptionRootProLabelAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProLabelSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProLabelOrderBy>>;
  where?: InputMaybe<ProLabelBoolExp>;
};


export type SubscriptionRootProLabelByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProLabelStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProLabelStreamCursorInput>>;
  where?: InputMaybe<ProLabelBoolExp>;
};


export type SubscriptionRootProMandateArgs = {
  distinctOn?: InputMaybe<Array<ProMandateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMandateOrderBy>>;
  where?: InputMaybe<ProMandateBoolExp>;
};


export type SubscriptionRootProMandateAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProMandateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMandateOrderBy>>;
  where?: InputMaybe<ProMandateBoolExp>;
};


export type SubscriptionRootProMandateByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProMandateStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProMandateStreamCursorInput>>;
  where?: InputMaybe<ProMandateBoolExp>;
};


export type SubscriptionRootProMediaObjectArgs = {
  distinctOn?: InputMaybe<Array<ProMediaObjectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMediaObjectOrderBy>>;
  where?: InputMaybe<ProMediaObjectBoolExp>;
};


export type SubscriptionRootProMediaObjectAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProMediaObjectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMediaObjectOrderBy>>;
  where?: InputMaybe<ProMediaObjectBoolExp>;
};


export type SubscriptionRootProMediaObjectByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProMediaObjectStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProMediaObjectStreamCursorInput>>;
  where?: InputMaybe<ProMediaObjectBoolExp>;
};


export type SubscriptionRootProMessageArgs = {
  distinctOn?: InputMaybe<Array<ProMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMessageOrderBy>>;
  where?: InputMaybe<ProMessageBoolExp>;
};


export type SubscriptionRootProMessageAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProMessageOrderBy>>;
  where?: InputMaybe<ProMessageBoolExp>;
};


export type SubscriptionRootProMessageByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProMessageStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProMessageStreamCursorInput>>;
  where?: InputMaybe<ProMessageBoolExp>;
};


export type SubscriptionRootProOrganizationFirstDatePublishedArgs = {
  distinctOn?: InputMaybe<Array<ProOrganizationFirstDatePublishedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProOrganizationFirstDatePublishedOrderBy>>;
  where?: InputMaybe<ProOrganizationFirstDatePublishedBoolExp>;
};


export type SubscriptionRootProOrganizationFirstDatePublishedAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProOrganizationFirstDatePublishedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProOrganizationFirstDatePublishedOrderBy>>;
  where?: InputMaybe<ProOrganizationFirstDatePublishedBoolExp>;
};


export type SubscriptionRootProOrganizationFirstDatePublishedStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProOrganizationFirstDatePublishedStreamCursorInput>>;
  where?: InputMaybe<ProOrganizationFirstDatePublishedBoolExp>;
};


export type SubscriptionRootProPersonArgs = {
  distinctOn?: InputMaybe<Array<ProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPersonOrderBy>>;
  where?: InputMaybe<ProPersonBoolExp>;
};


export type SubscriptionRootProPersonAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPersonOrderBy>>;
  where?: InputMaybe<ProPersonBoolExp>;
};


export type SubscriptionRootProPersonByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProPersonStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProPersonStreamCursorInput>>;
  where?: InputMaybe<ProPersonBoolExp>;
};


export type SubscriptionRootProPostalAddressArgs = {
  distinctOn?: InputMaybe<Array<ProPostalAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPostalAddressOrderBy>>;
  where?: InputMaybe<ProPostalAddressBoolExp>;
};


export type SubscriptionRootProPostalAddressAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProPostalAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPostalAddressOrderBy>>;
  where?: InputMaybe<ProPostalAddressBoolExp>;
};


export type SubscriptionRootProPostalAddressByPkArgs = {
  proViewId: Scalars['Int'];
};


export type SubscriptionRootProPostalAddressStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProPostalAddressStreamCursorInput>>;
  where?: InputMaybe<ProPostalAddressBoolExp>;
};


export type SubscriptionRootProPresentationArgs = {
  distinctOn?: InputMaybe<Array<ProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPresentationOrderBy>>;
  where?: InputMaybe<ProPresentationBoolExp>;
};


export type SubscriptionRootProPresentationAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPresentationOrderBy>>;
  where?: InputMaybe<ProPresentationBoolExp>;
};


export type SubscriptionRootProPresentationByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProPresentationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProPresentationStreamCursorInput>>;
  where?: InputMaybe<ProPresentationBoolExp>;
};


export type SubscriptionRootProPriceArgs = {
  distinctOn?: InputMaybe<Array<ProPriceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPriceOrderBy>>;
  where?: InputMaybe<ProPriceBoolExp>;
};


export type SubscriptionRootProPriceAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProPriceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPriceOrderBy>>;
  where?: InputMaybe<ProPriceBoolExp>;
};


export type SubscriptionRootProPriceByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProPriceStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProPriceStreamCursorInput>>;
  where?: InputMaybe<ProPriceBoolExp>;
};


export type SubscriptionRootProReviewArgs = {
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type SubscriptionRootProReviewAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type SubscriptionRootProReviewByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProReviewInvitationArgs = {
  distinctOn?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


export type SubscriptionRootProReviewInvitationAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


export type SubscriptionRootProReviewInvitationByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProReviewInvitationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProReviewInvitationStreamCursorInput>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


export type SubscriptionRootProReviewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProReviewStreamCursorInput>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type SubscriptionRootProViewArgs = {
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type SubscriptionRootProViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type SubscriptionRootProViewByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProViewProPersonArgs = {
  distinctOn?: InputMaybe<Array<ProViewProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProPersonOrderBy>>;
  where?: InputMaybe<ProViewProPersonBoolExp>;
};


export type SubscriptionRootProViewProPersonAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProPersonOrderBy>>;
  where?: InputMaybe<ProViewProPersonBoolExp>;
};


export type SubscriptionRootProViewProPersonByPkArgs = {
  proPersonId: Scalars['Int'];
  proViewId: Scalars['Int'];
};


export type SubscriptionRootProViewProPersonStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProViewProPersonStreamCursorInput>>;
  where?: InputMaybe<ProViewProPersonBoolExp>;
};


export type SubscriptionRootProViewProViewArgs = {
  distinctOn?: InputMaybe<Array<ProViewProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProViewOrderBy>>;
  where?: InputMaybe<ProViewProViewBoolExp>;
};


export type SubscriptionRootProViewProViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProViewProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewProViewOrderBy>>;
  where?: InputMaybe<ProViewProViewBoolExp>;
};


export type SubscriptionRootProViewProViewByPkArgs = {
  proViewSource: Scalars['Int'];
  proViewTarget: Scalars['Int'];
};


export type SubscriptionRootProViewProViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProViewProViewStreamCursorInput>>;
  where?: InputMaybe<ProViewProViewBoolExp>;
};


export type SubscriptionRootProViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProViewStreamCursorInput>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type SubscriptionRootQueuedSmsArgs = {
  distinctOn?: InputMaybe<Array<QueuedSmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QueuedSmsOrderBy>>;
  where?: InputMaybe<QueuedSmsBoolExp>;
};


export type SubscriptionRootQueuedSmsAggregateArgs = {
  distinctOn?: InputMaybe<Array<QueuedSmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QueuedSmsOrderBy>>;
  where?: InputMaybe<QueuedSmsBoolExp>;
};


export type SubscriptionRootQueuedSmsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootQueuedSmsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<QueuedSmsStreamCursorInput>>;
  where?: InputMaybe<QueuedSmsBoolExp>;
};


export type SubscriptionRootRandomProViewsArgs = {
  args?: InputMaybe<RandomProViewsArgs>;
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type SubscriptionRootRandomProViewsAggregateArgs = {
  args?: InputMaybe<RandomProViewsArgs>;
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type SubscriptionRootRegionArgs = {
  distinctOn?: InputMaybe<Array<RegionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RegionOrderBy>>;
  where?: InputMaybe<RegionBoolExp>;
};


export type SubscriptionRootRegionAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RegionOrderBy>>;
  where?: InputMaybe<RegionBoolExp>;
};


export type SubscriptionRootRegionByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootRegionStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RegionStreamCursorInput>>;
  where?: InputMaybe<RegionBoolExp>;
};


export type SubscriptionRootReviewPresentationArgs = {
  distinctOn?: InputMaybe<Array<ReviewPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewPresentationOrderBy>>;
  where?: InputMaybe<ReviewPresentationBoolExp>;
};


export type SubscriptionRootReviewPresentationAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewPresentationOrderBy>>;
  where?: InputMaybe<ReviewPresentationBoolExp>;
};


export type SubscriptionRootReviewPresentationByPkArgs = {
  presentationId: Scalars['Int'];
  reviewId: Scalars['Int'];
};


export type SubscriptionRootReviewPresentationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ReviewPresentationStreamCursorInput>>;
  where?: InputMaybe<ReviewPresentationBoolExp>;
};


export type SubscriptionRootReviewReferenceViewArgs = {
  distinctOn?: InputMaybe<Array<ReviewReferenceViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewReferenceViewOrderBy>>;
  where?: InputMaybe<ReviewReferenceViewBoolExp>;
};


export type SubscriptionRootReviewReferenceViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewReferenceViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewReferenceViewOrderBy>>;
  where?: InputMaybe<ReviewReferenceViewBoolExp>;
};


export type SubscriptionRootReviewReferenceViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ReviewReferenceViewStreamCursorInput>>;
  where?: InputMaybe<ReviewReferenceViewBoolExp>;
};


export type SubscriptionRootSearchCityArgs = {
  args: SearchCityArgs;
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


export type SubscriptionRootSearchCityAggregateArgs = {
  args: SearchCityArgs;
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


export type SubscriptionRootSearchNearestCityArgs = {
  args: SearchNearestCityArgs;
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


export type SubscriptionRootSearchNearestCityAggregateArgs = {
  args: SearchNearestCityArgs;
  distinctOn?: InputMaybe<Array<CitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CityOrderBy>>;
  where?: InputMaybe<CityBoolExp>;
};


export type SubscriptionRootSearchNearestProReviewArgs = {
  args: SearchNearestProReviewArgs;
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type SubscriptionRootSearchNearestProReviewAggregateArgs = {
  args: SearchNearestProReviewArgs;
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type SubscriptionRootSearchNearestProViewArgs = {
  args: SearchNearestProViewArgs;
  distinctOn?: InputMaybe<Array<NearestProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NearestProViewOrderBy>>;
  where?: InputMaybe<NearestProViewBoolExp>;
};


export type SubscriptionRootSearchNearestProViewAggregateArgs = {
  args: SearchNearestProViewArgs;
  distinctOn?: InputMaybe<Array<NearestProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NearestProViewOrderBy>>;
  where?: InputMaybe<NearestProViewBoolExp>;
};


export type SubscriptionRootSearchProPersonArgs = {
  args: SearchProPersonArgs;
  distinctOn?: InputMaybe<Array<ProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPersonOrderBy>>;
  where?: InputMaybe<ProPersonBoolExp>;
};


export type SubscriptionRootSearchProPersonAggregateArgs = {
  args: SearchProPersonArgs;
  distinctOn?: InputMaybe<Array<ProPersonSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPersonOrderBy>>;
  where?: InputMaybe<ProPersonBoolExp>;
};


export type SubscriptionRootSearchProPresentationArgs = {
  args: SearchProPresentationArgs;
  distinctOn?: InputMaybe<Array<ProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPresentationOrderBy>>;
  where?: InputMaybe<ProPresentationBoolExp>;
};


export type SubscriptionRootSearchProPresentationAggregateArgs = {
  args: SearchProPresentationArgs;
  distinctOn?: InputMaybe<Array<ProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProPresentationOrderBy>>;
  where?: InputMaybe<ProPresentationBoolExp>;
};


export type SubscriptionRootSearchProReviewArgs = {
  args: SearchProReviewArgs;
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type SubscriptionRootSearchProReviewAggregateArgs = {
  args: SearchProReviewArgs;
  distinctOn?: InputMaybe<Array<ProReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewOrderBy>>;
  where?: InputMaybe<ProReviewBoolExp>;
};


export type SubscriptionRootSearchProReviewInvitationArgs = {
  args: SearchProReviewInvitationArgs;
  distinctOn?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


export type SubscriptionRootSearchProReviewInvitationAggregateArgs = {
  args: SearchProReviewInvitationArgs;
  distinctOn?: InputMaybe<Array<ProReviewInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy>>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
};


export type SubscriptionRootSearchProViewArgs = {
  args: SearchProViewArgs;
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type SubscriptionRootSearchProViewAggregateArgs = {
  args: SearchProViewArgs;
  distinctOn?: InputMaybe<Array<ProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProViewOrderBy>>;
  where?: InputMaybe<ProViewBoolExp>;
};


export type SubscriptionRootSearchSolicitationArgs = {
  args: SearchSolicitationArgs;
  distinctOn?: InputMaybe<Array<SolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationOrderBy>>;
  where?: InputMaybe<SolicitationBoolExp>;
};


export type SubscriptionRootSearchSolicitationAggregateArgs = {
  args: SearchSolicitationArgs;
  distinctOn?: InputMaybe<Array<SolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationOrderBy>>;
  where?: InputMaybe<SolicitationBoolExp>;
};


export type SubscriptionRootSearchTradeArgs = {
  args: SearchTradeArgs;
  distinctOn?: InputMaybe<Array<TradeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeOrderBy>>;
  where?: InputMaybe<TradeBoolExp>;
};


export type SubscriptionRootSearchTradeAggregateArgs = {
  args: SearchTradeArgs;
  distinctOn?: InputMaybe<Array<TradeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeOrderBy>>;
  where?: InputMaybe<TradeBoolExp>;
};


export type SubscriptionRootSearchTradeGroupArgs = {
  args: SearchTradeGroupArgs;
  distinctOn?: InputMaybe<Array<TradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGroupOrderBy>>;
  where?: InputMaybe<TradeGroupBoolExp>;
};


export type SubscriptionRootSearchTradeGroupAggregateArgs = {
  args: SearchTradeGroupArgs;
  distinctOn?: InputMaybe<Array<TradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGroupOrderBy>>;
  where?: InputMaybe<TradeGroupBoolExp>;
};


export type SubscriptionRootSitemapBilikZoneArgs = {
  distinctOn?: InputMaybe<Array<SitemapBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapBilikZoneOrderBy>>;
  where?: InputMaybe<SitemapBilikZoneBoolExp>;
};


export type SubscriptionRootSitemapBilikZoneAggregateArgs = {
  distinctOn?: InputMaybe<Array<SitemapBilikZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapBilikZoneOrderBy>>;
  where?: InputMaybe<SitemapBilikZoneBoolExp>;
};


export type SubscriptionRootSitemapBilikZoneStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SitemapBilikZoneStreamCursorInput>>;
  where?: InputMaybe<SitemapBilikZoneBoolExp>;
};


export type SubscriptionRootSitemapCityArgs = {
  distinctOn?: InputMaybe<Array<SitemapCitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapCityOrderBy>>;
  where?: InputMaybe<SitemapCityBoolExp>;
};


export type SubscriptionRootSitemapCityAggregateArgs = {
  distinctOn?: InputMaybe<Array<SitemapCitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitemapCityOrderBy>>;
  where?: InputMaybe<SitemapCityBoolExp>;
};


export type SubscriptionRootSitemapCityStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SitemapCityStreamCursorInput>>;
  where?: InputMaybe<SitemapCityBoolExp>;
};


export type SubscriptionRootSlugRedirectArgs = {
  distinctOn?: InputMaybe<Array<SlugRedirectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SlugRedirectOrderBy>>;
  where?: InputMaybe<SlugRedirectBoolExp>;
};


export type SubscriptionRootSlugRedirectAggregateArgs = {
  distinctOn?: InputMaybe<Array<SlugRedirectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SlugRedirectOrderBy>>;
  where?: InputMaybe<SlugRedirectBoolExp>;
};


export type SubscriptionRootSlugRedirectByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootSlugRedirectStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SlugRedirectStreamCursorInput>>;
  where?: InputMaybe<SlugRedirectBoolExp>;
};


export type SubscriptionRootSolicitationArgs = {
  distinctOn?: InputMaybe<Array<SolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationOrderBy>>;
  where?: InputMaybe<SolicitationBoolExp>;
};


export type SubscriptionRootSolicitationAggregateArgs = {
  distinctOn?: InputMaybe<Array<SolicitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationOrderBy>>;
  where?: InputMaybe<SolicitationBoolExp>;
};


export type SubscriptionRootSolicitationByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootSolicitationStatArgs = {
  distinctOn?: InputMaybe<Array<SolicitationStatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationStatOrderBy>>;
  where?: InputMaybe<SolicitationStatBoolExp>;
};


export type SubscriptionRootSolicitationStatAggregateArgs = {
  distinctOn?: InputMaybe<Array<SolicitationStatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SolicitationStatOrderBy>>;
  where?: InputMaybe<SolicitationStatBoolExp>;
};


export type SubscriptionRootSolicitationStatStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SolicitationStatStreamCursorInput>>;
  where?: InputMaybe<SolicitationStatBoolExp>;
};


export type SubscriptionRootSolicitationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SolicitationStreamCursorInput>>;
  where?: InputMaybe<SolicitationBoolExp>;
};


export type SubscriptionRootSpatialRefSysArgs = {
  distinctOn?: InputMaybe<Array<SpatialRefSysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SpatialRefSysOrderBy>>;
  where?: InputMaybe<SpatialRefSysBoolExp>;
};


export type SubscriptionRootSpatialRefSysAggregateArgs = {
  distinctOn?: InputMaybe<Array<SpatialRefSysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SpatialRefSysOrderBy>>;
  where?: InputMaybe<SpatialRefSysBoolExp>;
};


export type SubscriptionRootSpatialRefSysByPkArgs = {
  srid: Scalars['Int'];
};


export type SubscriptionRootSpatialRefSysStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SpatialRefSysStreamCursorInput>>;
  where?: InputMaybe<SpatialRefSysBoolExp>;
};


export type SubscriptionRootStopSmsArgs = {
  distinctOn?: InputMaybe<Array<StopSmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StopSmsOrderBy>>;
  where?: InputMaybe<StopSmsBoolExp>;
};


export type SubscriptionRootStopSmsAggregateArgs = {
  distinctOn?: InputMaybe<Array<StopSmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StopSmsOrderBy>>;
  where?: InputMaybe<StopSmsBoolExp>;
};


export type SubscriptionRootStopSmsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootStopSmsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<StopSmsStreamCursorInput>>;
  where?: InputMaybe<StopSmsBoolExp>;
};


export type SubscriptionRootSubscriptionArgs = {
  distinctOn?: InputMaybe<Array<SubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubscriptionOrderBy>>;
  where?: InputMaybe<SubscriptionBoolExp>;
};


export type SubscriptionRootSubscriptionAggregateArgs = {
  distinctOn?: InputMaybe<Array<SubscriptionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubscriptionOrderBy>>;
  where?: InputMaybe<SubscriptionBoolExp>;
};


export type SubscriptionRootSubscriptionByPkArgs = {
  viewId: Scalars['Int'];
};


export type SubscriptionRootSubscriptionStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SubscriptionStreamCursorInput>>;
  where?: InputMaybe<SubscriptionBoolExp>;
};


export type SubscriptionRootTimelinePrivateIndividualArgs = {
  distinctOn?: InputMaybe<Array<TimelinePrivateIndividualSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimelinePrivateIndividualOrderBy>>;
  where?: InputMaybe<TimelinePrivateIndividualBoolExp>;
};


export type SubscriptionRootTimelinePrivateIndividualAggregateArgs = {
  distinctOn?: InputMaybe<Array<TimelinePrivateIndividualSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimelinePrivateIndividualOrderBy>>;
  where?: InputMaybe<TimelinePrivateIndividualBoolExp>;
};


export type SubscriptionRootTimelinePrivateIndividualStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TimelinePrivateIndividualStreamCursorInput>>;
  where?: InputMaybe<TimelinePrivateIndividualBoolExp>;
};


export type SubscriptionRootTopologyLayerArgs = {
  distinctOn?: InputMaybe<Array<TopologyLayerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TopologyLayerOrderBy>>;
  where?: InputMaybe<TopologyLayerBoolExp>;
};


export type SubscriptionRootTopologyLayerAggregateArgs = {
  distinctOn?: InputMaybe<Array<TopologyLayerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TopologyLayerOrderBy>>;
  where?: InputMaybe<TopologyLayerBoolExp>;
};


export type SubscriptionRootTopologyLayerByPkArgs = {
  layerId: Scalars['Int'];
  topologyId: Scalars['Int'];
};


export type SubscriptionRootTopologyLayerStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TopologyLayerStreamCursorInput>>;
  where?: InputMaybe<TopologyLayerBoolExp>;
};


export type SubscriptionRootTopologyTopologyArgs = {
  distinctOn?: InputMaybe<Array<TopologyTopologySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TopologyTopologyOrderBy>>;
  where?: InputMaybe<TopologyTopologyBoolExp>;
};


export type SubscriptionRootTopologyTopologyAggregateArgs = {
  distinctOn?: InputMaybe<Array<TopologyTopologySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TopologyTopologyOrderBy>>;
  where?: InputMaybe<TopologyTopologyBoolExp>;
};


export type SubscriptionRootTopologyTopologyByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootTopologyTopologyStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TopologyTopologyStreamCursorInput>>;
  where?: InputMaybe<TopologyTopologyBoolExp>;
};


export type SubscriptionRootTradeArgs = {
  distinctOn?: InputMaybe<Array<TradeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeOrderBy>>;
  where?: InputMaybe<TradeBoolExp>;
};


export type SubscriptionRootTradeAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeOrderBy>>;
  where?: InputMaybe<TradeBoolExp>;
};


export type SubscriptionRootTradeByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootTradeGroupArgs = {
  distinctOn?: InputMaybe<Array<TradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGroupOrderBy>>;
  where?: InputMaybe<TradeGroupBoolExp>;
};


export type SubscriptionRootTradeGroupAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGroupOrderBy>>;
  where?: InputMaybe<TradeGroupBoolExp>;
};


export type SubscriptionRootTradeGroupByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootTradeGroupStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TradeGroupStreamCursorInput>>;
  where?: InputMaybe<TradeGroupBoolExp>;
};


export type SubscriptionRootTradeGuideArgs = {
  distinctOn?: InputMaybe<Array<TradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGuideOrderBy>>;
  where?: InputMaybe<TradeGuideBoolExp>;
};


export type SubscriptionRootTradeGuideAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeGuideOrderBy>>;
  where?: InputMaybe<TradeGuideBoolExp>;
};


export type SubscriptionRootTradeGuideByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootTradeGuideStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TradeGuideStreamCursorInput>>;
  where?: InputMaybe<TradeGuideBoolExp>;
};


export type SubscriptionRootTradeKeywordArgs = {
  distinctOn?: InputMaybe<Array<TradeKeywordSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeKeywordOrderBy>>;
  where?: InputMaybe<TradeKeywordBoolExp>;
};


export type SubscriptionRootTradeKeywordAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeKeywordSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeKeywordOrderBy>>;
  where?: InputMaybe<TradeKeywordBoolExp>;
};


export type SubscriptionRootTradeKeywordByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootTradeKeywordStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TradeKeywordStreamCursorInput>>;
  where?: InputMaybe<TradeKeywordBoolExp>;
};


export type SubscriptionRootTradeMainProCountArgs = {
  distinctOn?: InputMaybe<Array<TradeMainProCountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeMainProCountOrderBy>>;
  where?: InputMaybe<TradeMainProCountBoolExp>;
};


export type SubscriptionRootTradeMainProCountAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeMainProCountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeMainProCountOrderBy>>;
  where?: InputMaybe<TradeMainProCountBoolExp>;
};


export type SubscriptionRootTradeMainProCountStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TradeMainProCountStreamCursorInput>>;
  where?: InputMaybe<TradeMainProCountBoolExp>;
};


export type SubscriptionRootTradeProPresentationArgs = {
  distinctOn?: InputMaybe<Array<TradeProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProPresentationOrderBy>>;
  where?: InputMaybe<TradeProPresentationBoolExp>;
};


export type SubscriptionRootTradeProPresentationAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeProPresentationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProPresentationOrderBy>>;
  where?: InputMaybe<TradeProPresentationBoolExp>;
};


export type SubscriptionRootTradeProPresentationByPkArgs = {
  proPresentationId: Scalars['Int'];
  tradeId: Scalars['Int'];
};


export type SubscriptionRootTradeProPresentationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TradeProPresentationStreamCursorInput>>;
  where?: InputMaybe<TradeProPresentationBoolExp>;
};


export type SubscriptionRootTradeProViewArgs = {
  distinctOn?: InputMaybe<Array<TradeProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProViewOrderBy>>;
  where?: InputMaybe<TradeProViewBoolExp>;
};


export type SubscriptionRootTradeProViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeProViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeProViewOrderBy>>;
  where?: InputMaybe<TradeProViewBoolExp>;
};


export type SubscriptionRootTradeProViewByPkArgs = {
  proViewId: Scalars['Int'];
  tradeId: Scalars['Int'];
};


export type SubscriptionRootTradeProViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TradeProViewStreamCursorInput>>;
  where?: InputMaybe<TradeProViewBoolExp>;
};


export type SubscriptionRootTradeQuestionArgs = {
  distinctOn?: InputMaybe<Array<TradeQuestionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeQuestionOrderBy>>;
  where?: InputMaybe<TradeQuestionBoolExp>;
};


export type SubscriptionRootTradeQuestionAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeQuestionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeQuestionOrderBy>>;
  where?: InputMaybe<TradeQuestionBoolExp>;
};


export type SubscriptionRootTradeQuestionByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootTradeQuestionStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TradeQuestionStreamCursorInput>>;
  where?: InputMaybe<TradeQuestionBoolExp>;
};


export type SubscriptionRootTradeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TradeStreamCursorInput>>;
  where?: InputMaybe<TradeBoolExp>;
};


export type SubscriptionRootTradeTradeGroupArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGroupOrderBy>>;
  where?: InputMaybe<TradeTradeGroupBoolExp>;
};


export type SubscriptionRootTradeTradeGroupAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGroupOrderBy>>;
  where?: InputMaybe<TradeTradeGroupBoolExp>;
};


export type SubscriptionRootTradeTradeGroupByPkArgs = {
  tradeGroupId: Scalars['Int'];
  tradeId: Scalars['Int'];
};


export type SubscriptionRootTradeTradeGroupStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TradeTradeGroupStreamCursorInput>>;
  where?: InputMaybe<TradeTradeGroupBoolExp>;
};


export type SubscriptionRootTradeTradeGuideArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGuideOrderBy>>;
  where?: InputMaybe<TradeTradeGuideBoolExp>;
};


export type SubscriptionRootTradeTradeGuideAggregateArgs = {
  distinctOn?: InputMaybe<Array<TradeTradeGuideSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TradeTradeGuideOrderBy>>;
  where?: InputMaybe<TradeTradeGuideBoolExp>;
};


export type SubscriptionRootTradeTradeGuideByPkArgs = {
  tradeGuideId: Scalars['Int'];
  tradeId: Scalars['Int'];
};


export type SubscriptionRootTradeTradeGuideStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TradeTradeGuideStreamCursorInput>>;
  where?: InputMaybe<TradeTradeGuideBoolExp>;
};


export type SubscriptionRootUtmRecordArgs = {
  distinctOn?: InputMaybe<Array<UtmRecordSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtmRecordOrderBy>>;
  where?: InputMaybe<UtmRecordBoolExp>;
};


export type SubscriptionRootUtmRecordAggregateArgs = {
  distinctOn?: InputMaybe<Array<UtmRecordSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UtmRecordOrderBy>>;
  where?: InputMaybe<UtmRecordBoolExp>;
};


export type SubscriptionRootUtmRecordByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootUtmRecordStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UtmRecordStreamCursorInput>>;
  where?: InputMaybe<UtmRecordBoolExp>;
};


export type SubscriptionRootViewActiveHolidayArgs = {
  distinctOn?: InputMaybe<Array<ViewActiveHolidaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewActiveHolidayOrderBy>>;
  where?: InputMaybe<ViewActiveHolidayBoolExp>;
};


export type SubscriptionRootViewActiveHolidayAggregateArgs = {
  distinctOn?: InputMaybe<Array<ViewActiveHolidaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewActiveHolidayOrderBy>>;
  where?: InputMaybe<ViewActiveHolidayBoolExp>;
};


export type SubscriptionRootViewActiveHolidayStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ViewActiveHolidayStreamCursorInput>>;
  where?: InputMaybe<ViewActiveHolidayBoolExp>;
};


export type SubscriptionRootZohoConsumerArgs = {
  distinctOn?: InputMaybe<Array<ZohoConsumerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoConsumerOrderBy>>;
  where?: InputMaybe<ZohoConsumerBoolExp>;
};


export type SubscriptionRootZohoConsumerAggregateArgs = {
  distinctOn?: InputMaybe<Array<ZohoConsumerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoConsumerOrderBy>>;
  where?: InputMaybe<ZohoConsumerBoolExp>;
};


export type SubscriptionRootZohoConsumerByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootZohoConsumerStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ZohoConsumerStreamCursorInput>>;
  where?: InputMaybe<ZohoConsumerBoolExp>;
};


export type SubscriptionRootZohoOrganizationArgs = {
  distinctOn?: InputMaybe<Array<ZohoOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoOrganizationOrderBy>>;
  where?: InputMaybe<ZohoOrganizationBoolExp>;
};


export type SubscriptionRootZohoOrganizationAggregateArgs = {
  distinctOn?: InputMaybe<Array<ZohoOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoOrganizationOrderBy>>;
  where?: InputMaybe<ZohoOrganizationBoolExp>;
};


export type SubscriptionRootZohoOrganizationByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootZohoOrganizationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ZohoOrganizationStreamCursorInput>>;
  where?: InputMaybe<ZohoOrganizationBoolExp>;
};


export type SubscriptionRootZohoTokenArgs = {
  distinctOn?: InputMaybe<Array<ZohoTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoTokenOrderBy>>;
  where?: InputMaybe<ZohoTokenBoolExp>;
};


export type SubscriptionRootZohoTokenAggregateArgs = {
  distinctOn?: InputMaybe<Array<ZohoTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZohoTokenOrderBy>>;
  where?: InputMaybe<ZohoTokenBoolExp>;
};


export type SubscriptionRootZohoTokenByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootZohoTokenStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ZohoTokenStreamCursorInput>>;
  where?: InputMaybe<ZohoTokenBoolExp>;
};

export type TradeKeywordAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TradeKeywordSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TradeKeywordBoolExp>;
  predicate: IntComparisonExp;
};

export type TradeProPresentationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TradeProPresentationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TradeProPresentationBoolExp>;
  predicate: IntComparisonExp;
};

export type TradeProViewAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TradeProViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TradeProViewBoolExp>;
  predicate: IntComparisonExp;
};

export type TradeQuestionAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TradeQuestionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TradeQuestionBoolExp>;
  predicate: IntComparisonExp;
};

export type TradeTradeGroupAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TradeTradeGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TradeTradeGroupBoolExp>;
  predicate: IntComparisonExp;
};

export type TradeTradeGuideAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TradeTradeGuideSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TradeTradeGuideBoolExp>;
  predicate: IntComparisonExp;
};

export type ZohoConsumerAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ZohoConsumerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ZohoConsumerBoolExp>;
  predicate: IntComparisonExp;
};

export type AccountProViewDeleteConfirmModalQueryVariables = Exact<{
  authUserId: Scalars['uuid'];
}>;


export type AccountProViewDeleteConfirmModalQuery = { __typename?: 'query_root', proView: Array<{ __typename?: 'ProView', id: number, bilikZone: { __typename?: 'BilikZone', mainCityCode: string }, proPresentation: { __typename?: 'ProPresentation', name: string, mainTradeNames?: string } }> };

export type AccountsFieldUnlinkAllAccountMutationVariables = Exact<{
  authUserId: Scalars['uuid'];
}>;


export type AccountsFieldUnlinkAllAccountMutation = { __typename?: 'mutation_root', deleteAccountProView?: { __typename?: 'AccountProViewMutationResponse', affectedRows: number } };

export type AccountsFieldLinkAccountMutationVariables = Exact<{
  objects: Array<AccountProViewInsertInput> | AccountProViewInsertInput;
}>;


export type AccountsFieldLinkAccountMutation = { __typename?: 'mutation_root', insertAccountProView?: { __typename?: 'AccountProViewMutationResponse', affectedRows: number } };

export type AccountsFieldGetLinkedAccountQueryVariables = Exact<{
  authUserId: Scalars['uuid'];
}>;


export type AccountsFieldGetLinkedAccountQuery = { __typename?: 'query_root', accountProView: Array<{ __typename?: 'AccountProView', proViewId: number }> };

export type CallsTableGloballyBlockedQueryVariables = Exact<{ [key: string]: never; }>;


export type CallsTableGloballyBlockedQuery = { __typename?: 'query_root', globallyBlockedIdentity: Array<{ __typename?: 'GloballyBlockedIdentity', identifier: string }> };

export type CountPresentationReviewByStatusQueryVariables = Exact<{
  where?: InputMaybe<CountProReviewByStatusBoolExp>;
}>;


export type CountPresentationReviewByStatusQuery = { __typename?: 'query_root', countProReviewByStatus: Array<{ __typename?: 'CountProReviewByStatus', count?: any, status?: string }> };

export type GloballyBlockedQueryVariables = Exact<{
  identifiers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GloballyBlockedQuery = { __typename?: 'query_root', globallyBlockedIdentity: Array<{ __typename?: 'GloballyBlockedIdentity', id: number, identifier: string, reason: string, dateCreated: any }> };

export type GoogleReviewLinkFieldQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GoogleReviewLinkFieldQuery = { __typename?: 'query_root', proPresentationByPk?: { __typename?: 'ProPresentation', proViewsAggregate: { __typename?: 'ProViewAggregate', aggregate?: { __typename?: 'ProViewAggregateFields', count: number } } } };

export type GetCitiesQueryVariables = Exact<{
  where: CityBoolExp;
}>;


export type GetCitiesQuery = { __typename?: 'query_root', city: Array<{ __typename?: 'City', id: number, name: string, area: Geometry, parentId?: number, departmentId: number }> };

export type GetInterventionsFieldDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInterventionsFieldDepartmentsQuery = { __typename?: 'query_root', department: Array<{ __typename?: 'Department', id: number, name: string, code: string, area: Geometry, citiesAggregate: { __typename?: 'CityAggregate', aggregate?: { __typename?: 'CityAggregateFields', count: number } } }> };

export type LastCheckedProReviewQueryVariables = Exact<{
  proPresentationId: Scalars['Int'];
}>;


export type LastCheckedProReviewQuery = { __typename?: 'query_root', proReview: Array<{ __typename?: 'ProReview', checkDate?: any }> };

export type BilikZonesLayerQueryVariables = Exact<{ [key: string]: never; }>;


export type BilikZonesLayerQuery = { __typename?: 'query_root', bilikZoneOutline: Array<{ __typename?: 'BilikZoneOutline', bilikZoneId?: number, outline?: Geometry, bilikZone?: { __typename?: 'BilikZone', name: string } }> };

export type NoteIdentityDeleteMutationVariables = Exact<{
  noteIdentityId: Scalars['Int'];
}>;


export type NoteIdentityDeleteMutation = { __typename?: 'mutation_root', deleteNoteIdentityByPk?: { __typename?: 'NoteIdentity', id: number } };

export type NoteIdentityInsertMutationVariables = Exact<{
  noteIdentityInput: NoteIdentityInsertInput;
}>;


export type NoteIdentityInsertMutation = { __typename?: 'mutation_root', insertNoteIdentityOne?: { __typename?: 'NoteIdentity', id: number } };

export type NotesIdentityByIdentifiersQueryVariables = Exact<{
  identifiers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type NotesIdentityByIdentifiersQuery = { __typename?: 'query_root', noteIdentity: Array<{ __typename?: 'NoteIdentity', id: number, identifier: string, lastEditorId: number, lastUpdatedDate: any, message: string, bilikPerson: { __typename?: 'BilikPerson', id: number, givenName: string } }> };

export type PrivateIndividualSearchSolicitationQueryVariables = Exact<{
  criteria?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<SolicitationBoolExp>;
}>;


export type PrivateIndividualSearchSolicitationQuery = { __typename?: 'query_root', searchSolicitation: Array<{ __typename?: 'Solicitation', email: string, givenName: string, familyName: string }> };

export type PrivateIndividualSearchProReviewQueryVariables = Exact<{
  criteria?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<ProReviewBoolExp>;
}>;


export type PrivateIndividualSearchProReviewQuery = { __typename?: 'query_root', searchProReview: Array<{ __typename?: 'ProReview', email: string, givenName: string, familyName: string }> };

export type PrivateIndividualSearchProReviewInvitationQueryVariables = Exact<{
  criteria?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
}>;


export type PrivateIndividualSearchProReviewInvitationQuery = { __typename?: 'query_root', searchProReviewInvitation: Array<{ __typename?: 'ProReviewInvitation', email: string, givenName: string, familyName: string }> };

export type ProPersonSearchFilterQueryVariables = Exact<{
  criteria?: InputMaybe<Scalars['String']>;
}>;


export type ProPersonSearchFilterQuery = { __typename?: 'query_root', searchProPerson: Array<{ __typename?: 'ProPerson', id: number, givenName: string, familyName: string, email?: string, telephone?: string }> };

export type ProContactDeleteConfirmModalQueryVariables = Exact<{
  proPersonId: Scalars['Int'];
  authUserId: Scalars['uuid'];
  skipRelatedProViewAccounts: Scalars['Boolean'];
}>;


export type ProContactDeleteConfirmModalQuery = { __typename?: 'query_root', relatedProViewProPeople: Array<{ __typename?: 'ProView', id: number, bilikZone: { __typename?: 'BilikZone', mainCityCode: string }, proPresentation: { __typename?: 'ProPresentation', name: string, mainTradeNames?: string } }>, relatedProViewAccounts: Array<{ __typename?: 'ProView', id: number, bilikZone: { __typename?: 'BilikZone', mainCityCode: string }, proPresentation: { __typename?: 'ProPresentation', name: string, mainTradeNames?: string } }> };

export type ProContactsFieldQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type ProContactsFieldQuery = { __typename?: 'query_root', proPerson: Array<{ __typename?: 'ProPerson', id: number, givenName: string, familyName: string, email?: string, telephone?: string }> };

export type ProFormArchiveModalUpdateMutationVariables = Exact<{
  proViewIds: Array<Scalars['Int']> | Scalars['Int'];
  set: ProViewSetInput;
}>;


export type ProFormArchiveModalUpdateMutation = { __typename?: 'mutation_root', updateProView?: { __typename?: 'ProViewMutationResponse', returning: Array<{ __typename?: 'ProView', id: number }> } };

export type ProFormArchiveModalQueryVariables = Exact<{
  companyId: Scalars['Int'];
  proViewId: Scalars['Int'];
}>;


export type ProFormArchiveModalQuery = { __typename?: 'query_root', proView?: { __typename?: 'ProView', id: number, dateArchiveScheduled?: any, archiveReason?: string }, company?: { __typename?: 'Company', proPresentations: Array<{ __typename?: 'ProPresentation', name: string, proViews: Array<{ __typename?: 'ProView', id: number, dateArchiveScheduled?: any, archiveReason?: string, bilikZone: { __typename?: 'BilikZone', name: string }, proPresentation: { __typename?: 'ProPresentation', mainTradeNames?: string } }> }> } };

export type ProFormCreateProViewMutationVariables = Exact<{
  input: ProViewInsertInput;
}>;


export type ProFormCreateProViewMutation = { __typename?: 'mutation_root', insertProViewOne?: { __typename?: 'ProView', id: number } };

export type ProFormUpdateProPresentationMutationVariables = Exact<{
  id: Scalars['Int'];
  input: ProPresentationSetInput;
}>;


export type ProFormUpdateProPresentationMutation = { __typename?: 'mutation_root', updateProPresentationByPk?: { __typename?: 'ProPresentation', id: number, slug: string, mainTrades: Array<{ __typename?: 'TradeProPresentation', tradeId: number }> } };

export type ProFormCreateModalQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProFormCreateModalQuery = { __typename?: 'query_root', proPresentationByPk?: { __typename?: 'ProPresentation', id: number, name: string, slug: string, mainTrades: Array<{ __typename?: 'TradeProPresentation', tradeId: number }>, proViews: Array<{ __typename?: 'ProView', bilikZoneId: number, trades: Array<{ __typename?: 'TradeProView', trade: { __typename?: 'Trade', id: number } }> }> } };

export type ProMandateFormCreateMutationVariables = Exact<{
  proMandate: ProMandateInsertInput;
}>;


export type ProMandateFormCreateMutation = { __typename?: 'mutation_root', insertProMandateOne?: { __typename?: 'ProMandate', id: number, dateCreated: any, rum: string, zohoOrganizationId: number, companyId: number, iban: string, bic: string, status: string } };

export type ProPresentationSearchFilterProPresentationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProPresentationSearchFilterProPresentationQuery = { __typename?: 'query_root', proPresentationByPk?: { __typename?: 'ProPresentation', name: string } };

export type ProPresentationSearchFilterQueryVariables = Exact<{
  criteria?: InputMaybe<Scalars['String']>;
  filters: ProPresentationBoolExp;
}>;


export type ProPresentationSearchFilterQuery = { __typename?: 'query_root', searchProPresentation: Array<{ __typename?: 'ProPresentation', id: number, name: string, mainTradeNames?: string, proViews: Array<{ __typename?: 'ProView', id: number, status: string, proPeople: Array<{ __typename?: 'ProViewProPerson', proPerson: { __typename?: 'ProPerson', id: number, givenName: string, familyName: string } }>, bilikZone: { __typename?: 'BilikZone', mainCityCode: string } }> }> };

export type ProReviewInvitationToggleMutationVariables = Exact<{
  isAutorespondActive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;


export type ProReviewInvitationToggleMutation = { __typename?: 'mutation_root', updateProReviewInvitationByPk?: { __typename?: 'ProReviewInvitation', id: number, email: string, isAutorespondActive: boolean, proPresentation?: { __typename?: 'ProPresentation', name: string, mainTradeNames?: string } } };

export type ProReviewInvitationToggleQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProReviewInvitationToggleQuery = { __typename?: 'query_root', proReviewInvitationByPk?: { __typename?: 'ProReviewInvitation', id: number, isAutorespondActive: boolean, proReviewId?: number, isBounce: boolean, proPresentation?: { __typename?: 'ProPresentation', proViews: Array<{ __typename?: 'ProView', status: string }> } } };

export type ProReviewInvitationMailsMutationVariables = Exact<{
  id: Scalars['Int'];
  proPresentation: ProPresentationSetInput;
}>;


export type ProReviewInvitationMailsMutation = { __typename?: 'mutation_root', updateProPresentationByPk?: { __typename?: 'ProPresentation', id: number } };

export type ProReviewInvitationsTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProReviewInvitationOrderBy> | ProReviewInvitationOrderBy>;
  where?: InputMaybe<ProReviewInvitationBoolExp>;
}>;


export type ProReviewInvitationsTableQuery = { __typename?: 'query_root', proReviewInvitation: Array<{ __typename?: 'ProReviewInvitation', id: number, givenName: string, familyName: string, email: string, isBounce: boolean, dateCreated: any, dateOfWork?: any, uuid?: string, isAutorespondActive: boolean, proReviewId?: number }> };

export type IpCheckerIndicatorQueryVariables = Exact<{
  where?: InputMaybe<ProReviewBoolExp>;
}>;


export type IpCheckerIndicatorQuery = { __typename?: 'query_root', proReviewAggregate: { __typename?: 'ProReviewAggregate', aggregate?: { __typename?: 'ProReviewAggregateFields', count: number } } };

export type ProReviewInvitationCheckerIndicatorQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type ProReviewInvitationCheckerIndicatorQuery = { __typename?: 'query_root', proReviewInvitation: Array<{ __typename?: 'ProReviewInvitation', id: number, proPresentation?: { __typename?: 'ProPresentation', id: number } }> };

export type SolicitationCheckerIndicatorQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type SolicitationCheckerIndicatorQuery = { __typename?: 'query_root', solicitation: Array<{ __typename?: 'Solicitation', id: number, givenName: string, familyName: string, email: string, isAutorespondActive: boolean, proView: { __typename?: 'ProView', id: number, proPresentation: { __typename?: 'ProPresentation', id: number } }, proReview?: { __typename?: 'ProReview', id: number } }> };

export type SearchCityFieldQueryVariables = Exact<{
  criteria?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CityBoolExp>;
}>;


export type SearchCityFieldQuery = { __typename?: 'query_root', searchCity: Array<{ __typename?: 'City', id: number, name: string, slug: string, department: { __typename?: 'Department', code: string } }> };

export type SearchCityFieldDefaultQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SearchCityFieldDefaultQuery = { __typename?: 'query_root', cityByPk?: { __typename?: 'City', id: number, name: string, slug: string, department: { __typename?: 'Department', code: string } } };

export type SelectBilikPersonFieldQueryVariables = Exact<{
  where?: InputMaybe<BilikPersonBoolExp>;
}>;


export type SelectBilikPersonFieldQuery = { __typename?: 'query_root', bilikPerson: Array<{ __typename?: 'BilikPerson', id: number, givenName: string, familyName: string, email: string, telephone: string }> };

export type SelectBilikZoneFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectBilikZoneFieldQuery = { __typename?: 'query_root', bilikZone: Array<{ __typename?: 'BilikZone', id: number, name: string }> };

export type SelectBilikZoneQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<BilikZoneOrderBy> | BilikZoneOrderBy>;
}>;


export type SelectBilikZoneQuery = { __typename?: 'query_root', bilikZone: Array<{ __typename?: 'BilikZone', id: number, name: string }> };

export type SelectCityFieldQueryVariables = Exact<{
  where?: InputMaybe<CityBoolExp>;
}>;


export type SelectCityFieldQuery = { __typename?: 'query_root', cities: Array<{ __typename?: 'City', id: number, name: string, slug: string }> };

export type SelectCompanyFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectCompanyFieldQuery = { __typename?: 'query_root', company: Array<{ __typename?: 'Company', id: number, name: string }> };

export type SelectCurrentBilikZoneQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<BilikZoneOrderBy> | BilikZoneOrderBy>;
}>;


export type SelectCurrentBilikZoneQuery = { __typename?: 'query_root', bilikZone: Array<{ __typename?: 'BilikZone', id: number, name: string, mainCityCode: string }> };

export type SelectProPresentationFieldQueryVariables = Exact<{
  where?: InputMaybe<ProPresentationBoolExp>;
}>;


export type SelectProPresentationFieldQuery = { __typename?: 'query_root', proPresentation: Array<{ __typename?: 'ProPresentation', id: number, name: string, mainTradeNames?: string }> };

export type SelectProViewFieldQueryVariables = Exact<{
  where?: InputMaybe<ProViewBoolExp>;
}>;


export type SelectProViewFieldQuery = { __typename?: 'query_root', proView: Array<{ __typename?: 'ProView', id: number, proPresentation: { __typename?: 'ProPresentation', id: number, name: string, mainTradeNames?: string }, bilikZone: { __typename?: 'BilikZone', id: number, mainCityCode: string } }> };

export type SelectTradeFieldQueryVariables = Exact<{
  bilikZoneId: Scalars['Int'];
}>;


export type SelectTradeFieldQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'Trade', id: number, name: string, tradeProViewsAggregate: { __typename?: 'TradeProViewAggregate', aggregate?: { __typename?: 'TradeProViewAggregateFields', count: number } }, mainTradeProPresentationsAggregate: { __typename?: 'TradeProPresentationAggregate', aggregate?: { __typename?: 'TradeProPresentationAggregateFields', count: number } } }> };

export type SelectTradeGroupFieldQueryVariables = Exact<{
  order_by?: InputMaybe<Array<TradeGroupOrderBy> | TradeGroupOrderBy>;
  where?: InputMaybe<TradeGroupBoolExp>;
}>;


export type SelectTradeGroupFieldQuery = { __typename?: 'query_root', tradeGroup: Array<{ __typename?: 'TradeGroup', id: number, name: string }> };

export type SelectZohoOrganizationFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectZohoOrganizationFieldQuery = { __typename?: 'query_root', zohoOrganization: Array<{ __typename?: 'ZohoOrganization', id: number, organizationId: string, name: string }> };

export type DeleteSlugRedirectbyIdsMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type DeleteSlugRedirectbyIdsMutation = { __typename?: 'mutation_root', deleteSlugRedirect?: { __typename?: 'SlugRedirectMutationResponse', affectedRows: number } };

export type PiBouncedSolicitationUpdateMutationVariables = Exact<{
  solicitationId: Scalars['Int'];
  solicitation: SolicitationSetInput;
}>;


export type PiBouncedSolicitationUpdateMutation = { __typename?: 'mutation_root', updateSolicitationByPk?: { __typename?: 'Solicitation', email: string } };

export type SolicitationAutorespondToggleMutationVariables = Exact<{
  isAutorespondActive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;


export type SolicitationAutorespondToggleMutation = { __typename?: 'mutation_root', updateSolicitationByPk?: { __typename?: 'Solicitation', id: number, email: string, telephone: string, isAutorespondActive: boolean, proView: { __typename?: 'ProView', proPresentation: { __typename?: 'ProPresentation', name: string, mainTradeNames?: string }, bilikZone: { __typename?: 'BilikZone', mainCityCode: string } } } };

export type SolicitationAutorespondToggleQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SolicitationAutorespondToggleQuery = { __typename?: 'query_root', solicitationByPk?: { __typename?: 'Solicitation', id: number, isAutorespondActive: boolean, proReviewId?: number, declinedBy?: string, proView: { __typename?: 'ProView', status: string } } };

export type SolicitationsTableGloballyBlockedByIdentifierQueryVariables = Exact<{
  identifier?: InputMaybe<Scalars['String']>;
}>;


export type SolicitationsTableGloballyBlockedByIdentifierQuery = { __typename?: 'query_root', globallyBlockedIdentity: Array<{ __typename?: 'GloballyBlockedIdentity', identifier: string }> };

export type SolicitationsTableGloballyBlockedQueryVariables = Exact<{ [key: string]: never; }>;


export type SolicitationsTableGloballyBlockedQuery = { __typename?: 'query_root', globallyBlockedIdentity: Array<{ __typename?: 'GloballyBlockedIdentity', identifier: string }> };

export type SolicitationsTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SolicitationOrderBy> | SolicitationOrderBy>;
  where?: InputMaybe<SolicitationBoolExp>;
}>;


export type SolicitationsTableQuery = { __typename?: 'query_root', solicitation: Array<{ __typename?: 'Solicitation', id: number, uuid?: string, ip?: string, givenName: string, familyName: string, telephone: string, email: string, subject?: string, message: string, addressLocality: string, isSpam: boolean, dateCreated: any, declinedBy?: string, declineReason?: string, bounceEntity?: string, delay?: string, configuration?: any, lastResponseDate?: any, source: string, proReview?: { __typename?: 'ProReview', id: number }, proView: { __typename?: 'ProView', id: number, status: string, emailTarget: string, bilikZone: { __typename?: 'BilikZone', id: number, mainCityCode: string }, proPeople: Array<{ __typename?: 'ProViewProPerson', proPerson: { __typename?: 'ProPerson', id: number, givenName: string, familyName: string } }>, proPresentation: { __typename?: 'ProPresentation', id: number, name: string, slug: string, mainTradeNames?: string } } }> };

export type StopSmsCreateMutationVariables = Exact<{
  object: StopSmsInsertInput;
}>;


export type StopSmsCreateMutation = { __typename?: 'mutation_root', insertStopSmsOne?: { __typename?: 'StopSms', id: number, telephone: string, dateCreated: any } };

export type StopSmsDeleteMutationVariables = Exact<{
  telephone: Scalars['String'];
}>;


export type StopSmsDeleteMutation = { __typename?: 'mutation_root', deleteStopSms?: { __typename?: 'StopSmsMutationResponse', returning: Array<{ __typename?: 'StopSms', id: number, telephone: string, dateCreated: any }> } };

export type StopSmsQueryVariables = Exact<{
  telephones?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type StopSmsQuery = { __typename?: 'query_root', stopSms: Array<{ __typename?: 'StopSms', id: number, telephone: string, dateCreated: any }> };

export type TimelinePrivateIndividualQueryVariables = Exact<{
  value: Scalars['String'];
}>;


export type TimelinePrivateIndividualQuery = { __typename?: 'query_root', timelinePrivateIndividual: Array<{ __typename?: 'TimelinePrivateIndividual', email?: string, telephone?: string, givenName?: string, familyName?: string, addressLocality?: string }> };

export type GetBilikPersonByContactInfoQueryVariables = Exact<{
  value: Scalars['String'];
}>;


export type GetBilikPersonByContactInfoQuery = { __typename?: 'query_root', bilikPerson: Array<{ __typename?: 'BilikPerson', telephone: string }> };

export type GloballyBlockedIdentityQueryVariables = Exact<{
  identifier: Scalars['String'];
}>;


export type GloballyBlockedIdentityQuery = { __typename?: 'query_root', globallyBlockedIdentity: Array<{ __typename?: 'GloballyBlockedIdentity', identifier: string }> };

export type TradeFieldsSuggestionsQueryVariables = Exact<{
  tradeIds: Array<Scalars['Int']> | Scalars['Int'];
  mainTradeIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type TradeFieldsSuggestionsQuery = { __typename?: 'query_root', mainTrades: Array<{ __typename?: 'Trade', name: string }>, possibleTradeGuides: Array<{ __typename?: 'TradeGuide', name: string, trades: Array<{ __typename?: 'TradeTradeGuide', trade: { __typename?: 'Trade', name: string, id: number } }> }> };

export type TradeGroupSearchFilterDefaultQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type TradeGroupSearchFilterDefaultQuery = { __typename?: 'query_root', tradeGroupByPk?: { __typename?: 'TradeGroup', name: string } };

export type TradeGroupSearchFilterQueryVariables = Exact<{
  criteria?: InputMaybe<Scalars['String']>;
}>;


export type TradeGroupSearchFilterQuery = { __typename?: 'query_root', searchTradeGroup: Array<{ __typename?: 'TradeGroup', id: number, name: string }> };

export type TradeSearchFilterDefaultQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type TradeSearchFilterDefaultQuery = { __typename?: 'query_root', tradeByPk?: { __typename?: 'Trade', name: string } };

export type TradeSearchFilterQueryVariables = Exact<{
  criteria?: InputMaybe<Scalars['String']>;
}>;


export type TradeSearchFilterQuery = { __typename?: 'query_root', searchTrade: Array<{ __typename?: 'Trade', id: number, name: string }> };

export type CurrentBilikZonesQueryVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type CurrentBilikZonesQuery = { __typename?: 'query_root', bilikZone: Array<{ __typename?: 'BilikZone', id: number, mainCityCode: string, name: string, slug: string, telephone: string, managers: Array<{ __typename?: 'ManagerBilikPersonBilikZone', bilikPerson: { __typename?: 'BilikPerson', id: number, givenName: string, familyName: string } }> }> };

export type CurrentBilikPersonQueryVariables = Exact<{
  authUserId: Scalars['uuid'];
}>;


export type CurrentBilikPersonQuery = { __typename?: 'query_root', bilikPerson: Array<{ __typename?: 'BilikPerson', id: number, familyName: string, givenName: string, avatarHash?: string, roleName: string, telephone: string, email: string }> };

export type ProReviewInvitationsCountQueryVariables = Exact<{
  where?: InputMaybe<ProReviewInvitationBoolExp>;
}>;


export type ProReviewInvitationsCountQuery = { __typename?: 'query_root', proReviewInvitationAggregate: { __typename?: 'ProReviewInvitationAggregate', aggregate?: { __typename?: 'ProReviewInvitationAggregateFields', count: number } } };

export type ProReviewsCountQueryVariables = Exact<{
  where?: InputMaybe<ProReviewBoolExp>;
}>;


export type ProReviewsCountQuery = { __typename?: 'query_root', proReviewAggregate: { __typename?: 'ProReviewAggregate', aggregate?: { __typename?: 'ProReviewAggregateFields', count: number } } };

export type ProViewPublishedCountByMonthQueryVariables = Exact<{
  where?: InputMaybe<ProViewBoolExp>;
}>;


export type ProViewPublishedCountByMonthQuery = { __typename?: 'query_root', proView: Array<{ __typename?: 'ProView', datePublished?: any, dateArchived?: any }> };

export type ProViewsCountQueryVariables = Exact<{
  criteria?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<ProViewBoolExp>;
}>;


export type ProViewsCountQuery = { __typename?: 'query_root', searchProViewAggregate: { __typename?: 'ProViewAggregate', aggregate?: { __typename?: 'ProViewAggregateFields', count: number } } };

export type SlugRedirectQueryVariables = Exact<{
  fromslug: Scalars['String'];
}>;


export type SlugRedirectQuery = { __typename?: 'query_root', slugRedirect: Array<{ __typename?: 'SlugRedirect', id: number, fromslug: string, toslug: string }> };

export type SolicitationStatsCountQueryVariables = Exact<{
  where?: InputMaybe<SolicitationStatBoolExp>;
  distinct?: InputMaybe<Array<SolicitationStatSelectColumn> | SolicitationStatSelectColumn>;
}>;


export type SolicitationStatsCountQuery = { __typename?: 'query_root', solicitationStatAggregate: { __typename?: 'SolicitationStatAggregate', aggregate?: { __typename?: 'SolicitationStatAggregateFields', count: number } } };

export type SolicitationsCountQueryVariables = Exact<{
  where?: InputMaybe<SolicitationBoolExp>;
}>;


export type SolicitationsCountQuery = { __typename?: 'query_root', solicitationAggregate: { __typename?: 'SolicitationAggregate', aggregate?: { __typename?: 'SolicitationAggregateFields', count: number } } };

export type ReviewCompanyPresentationsQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type ReviewCompanyPresentationsQuery = { __typename?: 'query_root', proPresentation: Array<{ __typename?: 'ProPresentation', id: number, name: string, mainTradeNames?: string, proViews: Array<{ __typename?: 'ProView', id: number, status: string, bilikZone: { __typename?: 'BilikZone', id: number, mainCityCode: string } }> }> };

export type QueryProReviewIsSpamByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type QueryProReviewIsSpamByIdQuery = { __typename?: 'query_root', proReviewByPk?: { __typename?: 'ProReview', id: number, email: string, telephone: string, referenceView?: { __typename?: 'ReviewReferenceView', view?: { __typename?: 'ProView', proPresentation: { __typename?: 'ProPresentation', id: number, name: string, mainTradeNames?: string } } } } };

export type ProReviewUpdateByPkMutationVariables = Exact<{
  lockerId?: InputMaybe<Scalars['Int']>;
  lockerDate?: InputMaybe<Scalars['timestamptz']>;
  proReviewId: Scalars['Int'];
}>;


export type ProReviewUpdateByPkMutation = { __typename?: 'mutation_root', updateProReviewByPk?: { __typename?: 'ProReview', id: number } };

export type ReviewLockerQueryVariables = Exact<{
  proReviewId: Scalars['Int'];
}>;


export type ReviewLockerQuery = { __typename?: 'query_root', proReviewByPk?: { __typename?: 'ProReview', id: number, lockerId?: number, lockDate?: any, locker?: { __typename?: 'BilikPerson', id: number, givenName: string, familyName: string } } };

export type PresentationReviewStatsQueryVariables = Exact<{
  presentationId: Scalars['Int'];
}>;


export type PresentationReviewStatsQuery = { __typename?: 'query_root', averageRating: { __typename?: 'ProReviewAggregate', aggregate?: { __typename?: 'ProReviewAggregateFields', avg?: { __typename?: 'ProReviewAvgFields', rating?: number } } }, latestReview: { __typename?: 'ProReviewAggregate', aggregate?: { __typename?: 'ProReviewAggregateFields', max?: { __typename?: 'ProReviewMaxFields', dateCreated?: any } } } };

export type ReviewsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProReviewOrderBy> | ProReviewOrderBy>;
  where?: InputMaybe<ProReviewBoolExp>;
}>;


export type ReviewsQuery = { __typename?: 'query_root', proReview: Array<{ __typename?: 'ProReview', id: number, status: string, trustLevel?: string, reviewAspect: string, reviewBody: string, source: string, refuseReason?: string, rating?: number, ratingType: string, privateComment?: string, comment?: string, reply?: string, givenName: string, familyName: string, telephone: string, email: string, dateCreated: any, addressLocality?: string, isSpam: boolean, lastModifiedAt?: any, dateOfWork?: any, checkDate?: any, lockDate?: any, proofStatus?: string, replyStatus?: string, replyDate?: any, originalProReviewId?: number, ip?: string, cityId?: number, checker?: { __typename?: 'BilikPerson', id: number, givenName: string, familyName: string }, locker?: { __typename?: 'BilikPerson', id: number, givenName: string, familyName: string, email: string }, referenceView?: { __typename?: 'ReviewReferenceView', view?: { __typename?: 'ProView', id: number, status: string, bilikZone: { __typename?: 'BilikZone', id: number, slug: string, mainCityCode: string }, proPresentation: { __typename?: 'ProPresentation', id: number, name: string, slug: string, mainTradeNames?: string, proViews: Array<{ __typename?: 'ProView', id: number, status: string, bilikZone: { __typename?: 'BilikZone', id: number, slug: string, mainCityCode: string } }> } } }, presentations: Array<{ __typename?: 'ReviewPresentation', presentationId: number, presentation: { __typename?: 'ProPresentation', id: number, name: string, mainTradeNames?: string, companyId?: number, company?: { __typename?: 'Company', name: string, proPresentationsAggregate: { __typename?: 'ProPresentationAggregate', aggregate?: { __typename?: 'ProPresentationAggregateFields', count: number } } }, proViews: Array<{ __typename?: 'ProView', id: number, status: string, bilikZone: { __typename?: 'BilikZone', id: number, mainCityCode: string } }> } }>, city?: { __typename?: 'City', id: number, name: string, postalCodes?: any, bilikZoneId?: number } }> };

export type BilikPeopleTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BilikPersonOrderBy> | BilikPersonOrderBy>;
}>;


export type BilikPeopleTableQuery = { __typename?: 'query_root', bilikPerson: Array<{ __typename?: 'BilikPerson', id: number, givenName: string, familyName: string, telephone: string, roleName: string, employmentDate: any, status: string, email: string }> };

export type BilikPersonFormCreateMutationVariables = Exact<{
  object: BilikPersonInsertInput;
}>;


export type BilikPersonFormCreateMutation = { __typename?: 'mutation_root', insertBilikPersonOne?: { __typename?: 'BilikPerson', id: number } };

export type UseBilikPersonFormUpdateMutationVariables = Exact<{
  bilikPersonId: Scalars['Int'];
  bilikPerson?: InputMaybe<BilikPersonSetInput>;
}>;


export type UseBilikPersonFormUpdateMutation = { __typename?: 'mutation_root', updateBilikPersonByPk?: { __typename?: 'BilikPerson', id: number } };

export type BilikPersonFormUpdateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type BilikPersonFormUpdateQuery = { __typename?: 'query_root', bilikPersonByPk?: { __typename?: 'BilikPerson', id: number, roleName: string, telephone: string, givenName: string, familyName: string, avatarHash?: string, employmentDate: any, status: string, description?: string, email: string, authUserId: any } };

export type BilikPersonUpdatePageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type BilikPersonUpdatePageQuery = { __typename?: 'query_root', bilikPersonByPk?: { __typename?: 'BilikPerson', givenName: string, familyName: string } };

export type BilikZoneFormCreateMutationVariables = Exact<{
  object: BilikZoneInsertInput;
}>;


export type BilikZoneFormCreateMutation = { __typename?: 'mutation_root', insertBilikZoneOne?: { __typename: 'BilikZone', id: number } };

export type UpdateCityMutationVariables = Exact<{
  updateCities: Array<CityUpdates> | CityUpdates;
}>;


export type UpdateCityMutation = { __typename?: 'mutation_root', updateCityMany?: Array<{ __typename?: 'CityMutationResponse', returning: Array<{ __typename?: 'City', id: number }> }> };

export type BilikZoneFormGetInterventionsFieldDataQueryVariables = Exact<{
  currentBilikZoneId: Scalars['Int'];
}>;


export type BilikZoneFormGetInterventionsFieldDataQuery = { __typename?: 'query_root', otherBilikZones: Array<{ __typename?: 'BilikZone', name: string, area?: Geometry }>, currentBilikZones?: { __typename?: 'BilikZone', area?: Geometry } };

export type BilikZoneFormUpdateMutationVariables = Exact<{
  bilikZoneId: Scalars['Int'];
  bilikZone?: InputMaybe<BilikZoneSetInput>;
  removeManagerIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  addManagers: Array<ManagerBilikPersonBilikZoneInsertInput> | ManagerBilikPersonBilikZoneInsertInput;
  removeMemberIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  addMembers: Array<MemberBilikPersonBilikZoneInsertInput> | MemberBilikPersonBilikZoneInsertInput;
  updateCities: Array<CityUpdates> | CityUpdates;
}>;


export type BilikZoneFormUpdateMutation = { __typename?: 'mutation_root', updateBilikZoneByPk?: { __typename: 'BilikZone', id: number }, updateCityMany?: Array<{ __typename?: 'CityMutationResponse', returning: Array<{ __typename: 'City', id: number }> }>, deleteManagerBilikPersonBilikZone?: { __typename?: 'ManagerBilikPersonBilikZoneMutationResponse', returning: Array<{ __typename: 'ManagerBilikPersonBilikZone', bilikPerson: { __typename: 'BilikPerson', id: number } }> }, insertManagerBilikPersonBilikZone?: { __typename?: 'ManagerBilikPersonBilikZoneMutationResponse', returning: Array<{ __typename: 'ManagerBilikPersonBilikZone', bilikPerson: { __typename: 'BilikPerson', id: number } }> }, deleteMemberBilikPersonBilikZone?: { __typename?: 'MemberBilikPersonBilikZoneMutationResponse', returning: Array<{ __typename: 'MemberBilikPersonBilikZone', bilikPerson: { __typename: 'BilikPerson', id: number } }> }, insertMemberBilikPersonBilikZone?: { __typename?: 'MemberBilikPersonBilikZoneMutationResponse', returning: Array<{ __typename: 'MemberBilikPersonBilikZone', bilikPerson: { __typename: 'BilikPerson', id: number } }> } };

export type BilikZoneFormUpdateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type BilikZoneFormUpdateQuery = { __typename?: 'query_root', bilikZoneByPk?: { __typename?: 'BilikZone', id: number, status: string, callTrackingTarget?: any, genericEmail: string, defaultCallTrackingTarget: any, telephone: string, shouldDisplayContactInPiSms: boolean, addressLocality: string, postOfficeBoxNumber?: string, regionPostalCode: string, postalCode: string, streetAddress: string, name: string, mainCityId: number, guideName: string, mainCityCode: string, area?: Geometry, slug: string, hasMultiplePostalCode: boolean, hasDistrict: boolean, cities: Array<{ __typename?: 'City', id: number, parentId?: number }>, zohoOrganization?: { __typename?: 'ZohoOrganization', id: number, organizationId: string }, managers: Array<{ __typename?: 'ManagerBilikPersonBilikZone', bilikPerson: { __typename?: 'BilikPerson', id: number } }>, members: Array<{ __typename?: 'MemberBilikPersonBilikZone', bilikPerson: { __typename?: 'BilikPerson', id: number } }>, proViews: Array<{ __typename?: 'ProView', id: number }> } };

export type BilikZonesTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BilikZoneOrderBy> | BilikZoneOrderBy>;
  where?: InputMaybe<BilikZoneBoolExp>;
}>;


export type BilikZonesTableQuery = { __typename?: 'query_root', bilikZone: Array<{ __typename?: 'BilikZone', id: number, name: string, status: string, managers: Array<{ __typename?: 'ManagerBilikPersonBilikZone', bilikPerson: { __typename?: 'BilikPerson', id: number, givenName: string, familyName: string } }>, citiesAggregate: { __typename?: 'CityAggregate', aggregate?: { __typename?: 'CityAggregateFields', count: number, sum?: { __typename?: 'CitySumFields', population?: number } } } }> };

export type DashboardPageProViewQueryVariables = Exact<{
  where: ProViewBoolExp;
}>;


export type DashboardPageProViewQuery = { __typename?: 'query_root', proView: Array<{ __typename?: 'ProView', id: number, status: string }> };

export type FinancialStatsQueryVariables = Exact<{
  bilikPersonIds: Array<Scalars['Int']> | Scalars['Int'];
  bilikZoneIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type FinancialStatsQuery = { __typename?: 'query_root', bilikPeople: Array<{ __typename?: 'BilikPerson', id: number, givenName: string, familyName: string }>, bilikZones: Array<{ __typename?: 'BilikZone', id: number, name: string }> };

export type ProReviewInvitationGraphQueryVariables = Exact<{
  where?: InputMaybe<ProReviewInvitationBoolExp>;
}>;


export type ProReviewInvitationGraphQuery = { __typename?: 'query_root', proReviewInvitation: Array<{ __typename?: 'ProReviewInvitation', dateCreated: any }> };

export type SolicitationGraphQueryVariables = Exact<{
  where?: InputMaybe<SolicitationStatBoolExp>;
}>;


export type SolicitationGraphQuery = { __typename?: 'query_root', solicitationStat: Array<{ __typename?: 'SolicitationStat', dateCreated?: any }> };

export type ExportGuideProViewsTableQueryVariables = Exact<{
  where?: InputMaybe<ProViewBoolExp>;
}>;


export type ExportGuideProViewsTableQuery = { __typename?: 'query_root', proView: Array<{ __typename?: 'ProView', id: number, phoneNumbers: Array<{ __typename?: 'PhoneNumber', id: number, tag: string }>, proPresentation: { __typename?: 'ProPresentation', id: number, name: string, profile?: string, mainTrades: Array<{ __typename?: 'TradeProPresentation', trade: { __typename?: 'Trade', name: string } }>, matchingTradeGuides?: Array<{ __typename?: 'TradeGuide', name: string }> }, proPeople: Array<{ __typename?: 'ProViewProPerson', proPerson: { __typename?: 'ProPerson', id: number, givenName: string, familyName: string } }> }> };

export type ManageNetworkMapHeatmapQueryVariables = Exact<{
  where: CityProViewBoolExp;
}>;


export type ManageNetworkMapHeatmapQuery = { __typename?: 'query_root', city: Array<{ __typename?: 'City', id: number, name: string, slug: string, area: Geometry, proViewsAggregate: { __typename?: 'CityProViewAggregate', aggregate?: { __typename?: 'CityProViewAggregateFields', count: number } } }> };

export type ManageNetworkMapViewsQueryVariables = Exact<{
  where: ProViewBoolExp;
}>;


export type ManageNetworkMapViewsQuery = { __typename?: 'query_root', proView: Array<{ __typename?: 'ProView', id: number, avatarHash?: string, proPostalAddress?: { __typename?: 'ProPostalAddress', geoCoordinates: Geometry }, proPresentation: { __typename?: 'ProPresentation', name: string, mainTradeNames?: string }, bilikZone: { __typename?: 'BilikZone', name: string } }> };

export type ProReviewInvitationsCreatePageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProReviewInvitationsCreatePageQuery = { __typename?: 'query_root', proPresentationByPk?: { __typename?: 'ProPresentation', id: number, name: string, mainTradeNames?: string } };

export type ProReviewInvitationsFormCreateMutationVariables = Exact<{
  proReviewInvitations: Array<ProReviewInvitationInsertInput> | ProReviewInvitationInsertInput;
}>;


export type ProReviewInvitationsFormCreateMutation = { __typename?: 'mutation_root', insertProReviewInvitation?: { __typename?: 'ProReviewInvitationMutationResponse', returning: Array<{ __typename: 'ProReviewInvitation', id: number }> } };

export type ProReviewInvitationsFormCreateQueryVariables = Exact<{
  proPresentationId: Scalars['Int'];
}>;


export type ProReviewInvitationsFormCreateQuery = { __typename?: 'query_root', proPresentationByPk?: { __typename?: 'ProPresentation', id: number, proReviews: Array<{ __typename?: 'ReviewPresentation', review: { __typename?: 'ProReview', id: number, dateCreated: any, givenName: string, familyName: string, email: string } }>, proReviewInvitations: Array<{ __typename?: 'ProReviewInvitation', id: number, dateCreated: any, givenName: string, familyName: string, email: string, proPresentation?: { __typename?: 'ProPresentation', id: number, slug: string, mainTrades: Array<{ __typename?: 'TradeProPresentation', trade: { __typename?: 'Trade', slug: string } }>, proViews: Array<{ __typename?: 'ProView', id: number }> } }>, company?: { __typename?: 'Company', proPresentations: Array<{ __typename?: 'ProPresentation', proReviews: Array<{ __typename?: 'ReviewPresentation', review: { __typename?: 'ProReview', id: number, dateCreated: any, givenName: string, familyName: string, email: string } }>, proReviewInvitations: Array<{ __typename?: 'ProReviewInvitation', id: number, dateCreated: any, givenName: string, familyName: string, email: string, proPresentation?: { __typename?: 'ProPresentation', id: number, slug: string, mainTrades: Array<{ __typename?: 'TradeProPresentation', trade: { __typename?: 'Trade', slug: string } }>, proViews: Array<{ __typename?: 'ProView', id: number }> } }> }> } } };

export type ProReviewFormUpdateMutationVariables = Exact<{
  proReviewId: Scalars['Int'];
  proReview: ProReviewSetInput;
}>;


export type ProReviewFormUpdateMutation = { __typename?: 'mutation_root', updateProReviewByPk?: { __typename?: 'ProReview', id: number, referenceView?: { __typename?: 'ReviewReferenceView', view?: { __typename?: 'ProView', proPresentation: { __typename?: 'ProPresentation', id: number, name: string, mainTradeNames?: string, proViews: Array<{ __typename?: 'ProView', id: number, bilikZone: { __typename?: 'BilikZone', id: number, mainCityCode: string } }> } } } } };

export type ProReviewFormUpdateQueryVariables = Exact<{
  proReviewId: Scalars['Int'];
}>;


export type ProReviewFormUpdateQuery = { __typename?: 'query_root', proReviewByPk?: { __typename?: 'ProReview', givenName: string, familyName: string, email: string, telephone: string, reviewAspect: string, reviewBody: string, comment?: string, privateComment?: string, dateOfWork?: any, reply?: string, replyStatus?: string, rating?: number, cityId?: number, source: string, referenceView?: { __typename?: 'ReviewReferenceView', view?: { __typename?: 'ProView', proPresentation: { __typename?: 'ProPresentation', name: string } } } } };

export type ProReviewFormCreateQueryVariables = Exact<{
  proPresentationId: Scalars['Int'];
}>;


export type ProReviewFormCreateQuery = { __typename?: 'query_root', proPresentationByPk?: { __typename?: 'ProPresentation', id: number } };

export type ProReviewInvitationCreatedUpdateMutationVariables = Exact<{
  proReviewId: Scalars['Int'];
  proPresentationId: Scalars['Int'];
  email: Scalars['String'];
  dateOfWork?: InputMaybe<Scalars['timestamptz']>;
}>;


export type ProReviewInvitationCreatedUpdateMutation = { __typename?: 'mutation_root', updateProReviewInvitation?: { __typename?: 'ProReviewInvitationMutationResponse', affectedRows: number } };

export type ProReviewCreatePageQueryVariables = Exact<{
  proPresentationId: Scalars['Int'];
}>;


export type ProReviewCreatePageQuery = { __typename?: 'query_root', proPresentationByPk?: { __typename?: 'ProPresentation', id: number, name: string, mainTradeNames?: string } };

export type ProReviewUpdatePageQueryVariables = Exact<{
  proReviewId: Scalars['Int'];
}>;


export type ProReviewUpdatePageQuery = { __typename?: 'query_root', proReviewByPk?: { __typename?: 'ProReview', givenName: string, familyName: string } };

export type ProReviewCertificateAddressesQueryVariables = Exact<{
  proPresentationId: Scalars['Int'];
}>;


export type ProReviewCertificateAddressesQuery = { __typename?: 'query_root', proPresentationByPk?: { __typename?: 'ProPresentation', id: number, company?: { __typename?: 'Company', streetAddress: string, postalCode: string, city: string }, proViews: Array<{ __typename?: 'ProView', id: number, proPostalAddress?: { __typename?: 'ProPostalAddress', street: string, postalCode: string, city: string } }> } };

export type ProContractFormQueryVariables = Exact<{
  proViewId: Scalars['Int'];
}>;


export type ProContractFormQuery = { __typename?: 'query_root', proViewByPk?: { __typename?: 'ProView', contractConfiguration?: any } };

export type ProContractQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProContractQuery = { __typename?: 'query_root', proView?: { __typename?: 'ProView', id: number, contractConfiguration?: any, contractEvents?: any, datePublished?: any, bilikZone: { __typename?: 'BilikZone', slug: string, mainCityCode: string }, proPresentation: { __typename?: 'ProPresentation', mainTrades: Array<{ __typename?: 'TradeProPresentation', trade: { __typename?: 'Trade', slug: string, label: string } }>, company?: { __typename?: 'Company', name: string, legalForm: string, registrationNumber: string, streetAddress: string, postalCode: string, city: string } } } };

export type ProFormUpdateMutationVariables = Exact<{
  proViewId: Scalars['Int'];
  proView: ProViewSetInput;
  proPresentationId: Scalars['Int'];
  insertProPostalAddressOne: ProPostalAddressInsertInput;
  insertProPrices: Array<ProPriceInsertInput> | ProPriceInsertInput;
  deleteProPrices?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  deleteGoogleReviewLinks?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  insertProMessages: Array<ProMessageInsertInput> | ProMessageInsertInput;
  deleteProMessages?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  insertProMediaObjects: Array<ProMediaObjectInsertInput> | ProMediaObjectInsertInput;
  deleteProMediaObjects?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  insertTrades: Array<TradeProViewInsertInput> | TradeProViewInsertInput;
  deleteTrades?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  insertMainTrades: Array<TradeProPresentationInsertInput> | TradeProPresentationInsertInput;
  deleteMainTrades?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  deleteColleagues?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  insertColleagues: Array<ProViewProViewInsertInput> | ProViewProViewInsertInput;
  deleteCities?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  insertCities: Array<CityProViewInsertInput> | CityProViewInsertInput;
  deleteCertifications?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  insertCertifications: Array<ProCertificationInsertInput> | ProCertificationInsertInput;
  deleteProPeople?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  deleteAccounts?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type ProFormUpdateMutation = { __typename?: 'mutation_root', updateProViewByPk?: { __typename?: 'ProView', id: number }, insertProPostalAddressOne?: { __typename?: 'ProPostalAddress', proViewId: number }, insertProPrice?: { __typename?: 'ProPriceMutationResponse', affectedRows: number }, deleteProPrice?: { __typename?: 'ProPriceMutationResponse', affectedRows: number }, deleteGoogleReviewLink?: { __typename?: 'GoogleReviewLinkMutationResponse', affectedRows: number }, insertProMessage?: { __typename?: 'ProMessageMutationResponse', affectedRows: number }, deleteProMessage?: { __typename?: 'ProMessageMutationResponse', affectedRows: number }, insertProMediaObject?: { __typename?: 'ProMediaObjectMutationResponse', affectedRows: number }, deleteProMediaObject?: { __typename?: 'ProMediaObjectMutationResponse', affectedRows: number }, deleteTradeProView?: { __typename?: 'TradeProViewMutationResponse', affectedRows: number }, insertTradeProView?: { __typename?: 'TradeProViewMutationResponse', affectedRows: number }, deleteTradeProPresentation?: { __typename?: 'TradeProPresentationMutationResponse', affectedRows: number }, insertTradeProPresentation?: { __typename?: 'TradeProPresentationMutationResponse', affectedRows: number }, deleteProViewProView?: { __typename?: 'ProViewProViewMutationResponse', affectedRows: number }, insertProViewProView?: { __typename?: 'ProViewProViewMutationResponse', affectedRows: number }, deleteCityProView?: { __typename?: 'CityProViewMutationResponse', affectedRows: number }, insertCityProView?: { __typename?: 'CityProViewMutationResponse', affectedRows: number }, deleteProCertification?: { __typename?: 'ProCertificationMutationResponse', affectedRows: number }, insertProCertification?: { __typename?: 'ProCertificationMutationResponse', affectedRows: number }, deleteProViewProPerson?: { __typename?: 'ProViewProPersonMutationResponse', affectedRows: number }, deleteAccountProView?: { __typename?: 'AccountProViewMutationResponse', affectedRows: number } };

export type UpdatePresentationMutationVariables = Exact<{
  id: Scalars['Int'];
  presentation: ProPresentationSetInput;
}>;


export type UpdatePresentationMutation = { __typename?: 'mutation_root', updateProPresentationByPk?: { __typename?: 'ProPresentation', id: number } };

export type ProFormCreateSlugRedirectMutationVariables = Exact<{
  input: SlugRedirectInsertInput;
}>;


export type ProFormCreateSlugRedirectMutation = { __typename?: 'mutation_root', insertSlugRedirectOne?: { __typename?: 'SlugRedirect', id: number } };

export type ProFormCreateGoogleReviewLinkMutationVariables = Exact<{
  input: GoogleReviewLinkInsertInput;
}>;


export type ProFormCreateGoogleReviewLinkMutation = { __typename?: 'mutation_root', insertGoogleReviewLinkOne?: { __typename?: 'GoogleReviewLink', id: number } };

export type ProFormUpdateProMessageMutationVariables = Exact<{
  proMessageId: Scalars['Int'];
  proMessage: ProMessageSetInput;
}>;


export type ProFormUpdateProMessageMutation = { __typename?: 'mutation_root', updateProMessageByPk?: { __typename?: 'ProMessage', id: number } };

export type ProFormUpdateProPriceMutationVariables = Exact<{
  proPriceId: Scalars['Int'];
  proPrice: ProPriceSetInput;
}>;


export type ProFormUpdateProPriceMutation = { __typename?: 'mutation_root', updateProPriceByPk?: { __typename?: 'ProPrice', id: number } };

export type ProFormUpdateGoogleReviewLinkMutationVariables = Exact<{
  googleReviewLinkId: Scalars['Int'];
  googleReviewLink: GoogleReviewLinkSetInput;
}>;


export type ProFormUpdateGoogleReviewLinkMutation = { __typename?: 'mutation_root', updateGoogleReviewLinkByPk?: { __typename?: 'GoogleReviewLink', id: number } };

export type ProFormUpdateProViewGoogleReviewLinkMutationVariables = Exact<{
  proViewId: Scalars['Int'];
  googleReviewLinkId: Scalars['Int'];
}>;


export type ProFormUpdateProViewGoogleReviewLinkMutation = { __typename?: 'mutation_root', updateProViewByPk?: { __typename?: 'ProView', id: number } };

export type ProFormUpdateProMediaObjectMutationVariables = Exact<{
  proMediaObjectId: Scalars['Int'];
  proMediaObject: ProMediaObjectSetInput;
}>;


export type ProFormUpdateProMediaObjectMutation = { __typename?: 'mutation_root', updateProMediaObjectByPk?: { __typename?: 'ProMediaObject', id: number } };

export type ProFormUpdateProViewProPersonMutationVariables = Exact<{
  proViewId: Scalars['Int'];
  proPersonId: Scalars['Int'];
  proViewProPerson?: InputMaybe<ProViewProPersonSetInput>;
}>;


export type ProFormUpdateProViewProPersonMutation = { __typename?: 'mutation_root', updateProViewProPersonByPk?: { __typename?: 'ProViewProPerson', proPersonId: number, proViewId: number } };

export type ProFormUpdateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProFormUpdateQuery = { __typename?: 'query_root', proViewByPk?: { __typename?: 'ProView', id: number, hasContact: boolean, hasQuotation: boolean, dateCreated: any, isLocalBusiness: boolean, isCallsDisabled: boolean, isSolicitationsDisabled: boolean, isEnglishSpeaker: boolean, isSmsDisabled: boolean, isCallAlertActivated: boolean, isCallRecordable: boolean, openingHours?: string, priceComment?: string, averageResponseDays: number, averageQuotationDays: number, averageProjectDays: number, status: string, callTrackingTarget: any, callTrackingForward?: any, avatarHash?: string, originalAvatarHash?: string, datePublished?: any, note?: string, isMainCityCenterExcluded: boolean, dateArchiveScheduled?: any, emailTarget: string, phoneNumbers: Array<{ __typename?: 'PhoneNumber', id: number, number: string, tag: string }>, trades: Array<{ __typename?: 'TradeProView', trade: { __typename?: 'Trade', id: number } }>, bilikZone: { __typename?: 'BilikZone', id: number, mainCityCode: string, slug: string }, cities: Array<{ __typename?: 'CityProView', type: string, city: { __typename?: 'City', id: number, parentId?: number } }>, proPrices: Array<{ __typename?: 'ProPrice', id: number, title: string, content: string, isRepair: boolean }>, proMessages: Array<{ __typename?: 'ProMessage', id: number, body: string, isPermanent: boolean, startDate?: any, endDate?: any }>, colleagues: Array<{ __typename?: 'ProViewProView', proView: { __typename?: 'ProView', id: number } }>, proPeople: Array<{ __typename?: 'ProViewProPerson', position: number, isVisible: boolean, proPerson: { __typename?: 'ProPerson', id: number } }>, accounts: Array<{ __typename?: 'AccountProView', authUserId: any }>, proPostalAddress?: { __typename?: 'ProPostalAddress', proViewId: number, street: string, city: string, postalCode: string, displayOption: string, geoCoordinates: Geometry, cityGeoCoordinates?: Geometry }, googleReviewLink?: { __typename?: 'GoogleReviewLink', id: number, url: string }, proPresentation: { __typename?: 'ProPresentation', id: number, name: string, slug: string, profile?: string, hobbies?: string, expertise1?: string, expertise11?: string, expertise12?: string, expertise13?: string, expertise14?: string, expertise15?: string, expertise16?: string, expertise2?: string, expertise21?: string, expertise22?: string, expertise23?: string, expertise24?: string, expertise25?: string, expertise26?: string, expertise3?: string, expertise31?: string, expertise32?: string, expertise33?: string, expertise34?: string, expertise35?: string, expertise36?: string, extra1?: string, extra2?: string, extra3?: string, extra4?: string, extra5?: string, isRge?: boolean, mainTradeNames?: string, companyId?: number, certifications: Array<{ __typename?: 'ProCertification', certification: { __typename?: 'Certification', id: number } }>, mainTrades: Array<{ __typename?: 'TradeProPresentation', trade: { __typename?: 'Trade', id: number, slug: string } }>, googleReviewLinks: Array<{ __typename?: 'GoogleReviewLink', id: number, url: string, proPresentationId: number, proViews: Array<{ __typename?: 'ProView', id: number }> }>, proMediaObjects: Array<{ __typename?: 'ProMediaObject', id: number, hash: string, position: number }>, proViews: Array<{ __typename?: 'ProView', id: number, bilikZone: { __typename?: 'BilikZone', id: number, mainCityCode: string }, trades: Array<{ __typename?: 'TradeProView', trade: { __typename?: 'Trade', id: number } }> }> } } };

export type ProFormUpdateFetchCompanyQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProFormUpdateFetchCompanyQuery = { __typename?: 'query_root', companyByPk?: { __typename?: 'Company', proPresentations: Array<{ __typename?: 'ProPresentation', id: number, mainTradeNames?: string, mainTrades: Array<{ __typename?: 'TradeProPresentation', trade: { __typename?: 'Trade', id: number } }> }> } };

export type ProInfosQueryVariables = Exact<{
  proViewId: Scalars['Int'];
}>;


export type ProInfosQuery = { __typename?: 'query_root', proViewByPk?: { __typename?: 'ProView', id: number, datePublished?: any, dateCreated: any, dateArchived?: any, dateArchiveScheduled?: any, archiveReason?: string, status: string, proPresentation: { __typename?: 'ProPresentation', id: number, mainTradeNames?: string, averageRating?: any, publishedReviewCount?: number, pendingReviewCount?: number, company?: { __typename?: 'Company', firstDatePublished?: { __typename?: 'ProOrganizationFirstDatePublished', date?: any } } } } };

export type InsertProCertificationRgeMutationVariables = Exact<{
  proPresentationId: Scalars['Int'];
}>;


export type InsertProCertificationRgeMutation = { __typename?: 'mutation_root', insertProCertificationOne?: { __typename?: 'ProCertification', certificationId: number, proPresentationId: number } };

export type DeleteProCertificationRgeMutationVariables = Exact<{
  proPresentationId: Scalars['Int'];
}>;


export type DeleteProCertificationRgeMutation = { __typename?: 'mutation_root', deleteProCertification?: { __typename?: 'ProCertificationMutationResponse', affectedRows: number } };

export type ProLabelsMutationVariables = Exact<{
  id: Scalars['Int'];
  isVisible: Scalars['Boolean'];
}>;


export type ProLabelsMutation = { __typename?: 'mutation_root', updateProLabelByPk?: { __typename?: 'ProLabel', id: number } };

export type ProLabelsQueryVariables = Exact<{
  proPresentationId: Scalars['Int'];
}>;


export type ProLabelsQuery = { __typename?: 'query_root', proLabels: Array<{ __typename?: 'ProLabel', id: number, certificateName: string, domain: string, qualificationUrl: string, dateChecked: any, isVisible: boolean, isCheckActive: boolean }>, certifications: Array<{ __typename?: 'Certification', id: number, name: string }> };

export type ProMandateUpdateByPkMutationVariables = Exact<{
  proMandateId: Scalars['Int'];
  proMandateInput: ProMandateSetInput;
}>;


export type ProMandateUpdateByPkMutation = { __typename?: 'mutation_root', updateProMandateByPk?: { __typename?: 'ProMandate', id: number } };

export type ProMandatesQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type ProMandatesQuery = { __typename?: 'query_root', proMandate: Array<{ __typename?: 'ProMandate', bic: string, dateArchived?: any, dateCreated: any, dateSigned?: any, iban: string, id: number, rum: string, status: string, fileName?: string, zohoOrganizationId: number, zohoOrganization: { __typename?: 'ZohoOrganization', name: string } }> };

export type ProPhoneNumbersQueryVariables = Exact<{
  proViewId: Scalars['Int'];
}>;


export type ProPhoneNumbersQuery = { __typename?: 'query_root', phoneNumber: Array<{ __typename?: 'PhoneNumber', id: number, number: string, tag: string }> };

export type ProPreviewGuideQueryVariables = Exact<{
  proViewId: Scalars['Int'];
}>;


export type ProPreviewGuideQuery = { __typename?: 'query_root', proViewByPk?: { __typename?: 'ProView', proPeople: Array<{ __typename?: 'ProViewProPerson', proPerson: { __typename?: 'ProPerson', givenName: string, familyName: string } }>, bilikZone: { __typename?: 'BilikZone', guideName: string } } };

export type ProPublishButtonGetValidDataQueryVariables = Exact<{
  proViewId: Scalars['Int'];
}>;


export type ProPublishButtonGetValidDataQuery = { __typename?: 'query_root', proViewByPk?: { __typename?: 'ProView', id: number, contractConfiguration?: any, contractEvents?: any, proPresentation: { __typename?: 'ProPresentation', company?: { __typename?: 'Company', proMandates: Array<{ __typename?: 'ProMandate', id: number }> } } } };

export type CompanyRouteQueryVariables = Exact<{
  proPeopleIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  bilikZoneId: Scalars['Int'];
}>;


export type CompanyRouteQuery = { __typename?: 'query_root', proPerson: Array<{ __typename?: 'ProPerson', id: number, email?: string, givenName: string, familyName: string, telephone?: string }>, zohoOrganization: Array<{ __typename?: 'ZohoOrganization', id: number }> };

export type ProSectorsRouteQueryVariables = Exact<{
  bilikZoneId: Scalars['Int'];
  proPresentationId: Scalars['Int'];
  proViewId: Scalars['Int'];
}>;


export type ProSectorsRouteQuery = { __typename?: 'query_root', bilikZoneByPk?: { __typename?: 'BilikZone', mainCity: { __typename?: 'City', name: string, area: Geometry } }, proPresentationByPk?: { __typename?: 'ProPresentation', proViews: Array<{ __typename?: 'ProView', interventionInclude?: Geometry, interventionExclude?: Geometry }> } };

export type ProViewRouteQueryVariables = Exact<{
  proViewId: Scalars['Int'];
}>;


export type ProViewRouteQuery = { __typename?: 'query_root', proViewByPk?: { __typename?: 'ProView', proPresentation: { __typename?: 'ProPresentation', mainTradeNames?: string, mainTrades: Array<{ __typename?: 'TradeProPresentation', trade: { __typename?: 'Trade', id: number, tradeGuides: Array<{ __typename?: 'TradeTradeGuide', tradeGuide: { __typename?: 'TradeGuide', name: string } }> } }>, proViews: Array<{ __typename?: 'ProView', id: number, bilikZone: { __typename?: 'BilikZone', id: number, mainCityCode: string }, trades: Array<{ __typename?: 'TradeProView', trade: { __typename?: 'Trade', id: number } }> }> } } };

export type ProReviewInvitationsCountByDateQueryVariables = Exact<{
  before: Scalars['timestamptz'];
  after: Scalars['timestamptz'];
  proPresentationId: Scalars['Int'];
}>;


export type ProReviewInvitationsCountByDateQuery = { __typename?: 'query_root', countProReviewInvitationsByMonthByProPresentation: Array<{ __typename?: 'CountProReviewInvitationsByMonthByProPresentation', count?: any, month?: any }> };

export type ProReviewsCountByDateQueryVariables = Exact<{
  before: Scalars['timestamptz'];
  after: Scalars['timestamptz'];
  proPresentationId: Scalars['Int'];
}>;


export type ProReviewsCountByDateQuery = { __typename?: 'query_root', countProReviewsWithStatusOkByMonthByProPresentation: Array<{ __typename?: 'CountProReviewsWithStatusOkByMonthByProPresentation', count?: any, month?: any }> };

export type ProSolicitationsByDateQueryVariables = Exact<{
  before: Scalars['timestamptz'];
  after: Scalars['timestamptz'];
  proViewId: Scalars['Int'];
}>;


export type ProSolicitationsByDateQuery = { __typename?: 'query_root', solicitationStat: Array<{ __typename?: 'SolicitationStat', dateCreated?: any, email?: string }> };

export type ProSubscriptionTableGetBilikPeopleQueryVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type ProSubscriptionTableGetBilikPeopleQuery = { __typename?: 'query_root', bilikPeople: Array<{ __typename?: 'BilikPerson', id: number, givenName: string, familyName: string }> };

export type ProSubscriptionsGetValidMandateQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type ProSubscriptionsGetValidMandateQuery = { __typename?: 'query_root', proMandates: Array<{ __typename?: 'ProMandate', id: number, status: string }> };

export type ProZonesQueryVariables = Exact<{
  proPresentationId: Scalars['Int'];
}>;


export type ProZonesQuery = { __typename?: 'query_root', proPresentations: Array<{ __typename?: 'ProPresentation', mainTrades: Array<{ __typename?: 'TradeProPresentation', trade: { __typename?: 'Trade', label: string } }>, proViews: Array<{ __typename?: 'ProView', id: number, status: string, bilikZone: { __typename?: 'BilikZone', mainCityCode: string } }> }> };

export type ProUpdatePageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProUpdatePageQuery = { __typename?: 'query_root', proViewByPk?: { __typename?: 'ProView', id: number, proPresentationId: number } };

export type ProsTableQueryVariables = Exact<{
  criteria?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProViewOrderBy> | ProViewOrderBy>;
  where?: InputMaybe<ProViewBoolExp>;
}>;


export type ProsTableQuery = { __typename?: 'query_root', searchProView: Array<{ __typename?: 'ProView', id: number, status: string, dateArchived?: any, dateCreated: any, datePublished?: any, activeHoliday?: { __typename?: 'ViewActiveHoliday', endDate?: string }, proPeople: Array<{ __typename?: 'ProViewProPerson', proPerson: { __typename?: 'ProPerson', id: number, givenName: string, familyName: string } }>, bilikZone: { __typename?: 'BilikZone', id: number, mainCityCode: string, mainCity: { __typename?: 'City', name: string } }, trades: Array<{ __typename?: 'TradeProView', trade: { __typename?: 'Trade', id: number, name: string } }>, proPresentation: { __typename?: 'ProPresentation', id: number, name: string, slug: string, averageRating?: any, proReviewInvitationsAggregate: { __typename?: 'ProReviewInvitationAggregate', aggregate?: { __typename?: 'ProReviewInvitationAggregateFields', count: number } }, mainTrades: Array<{ __typename?: 'TradeProPresentation', trade: { __typename?: 'Trade', name: string, id: number } }> } }> };

export type TradesGuideTableQueryVariables = Exact<{ [key: string]: never; }>;


export type TradesGuideTableQuery = { __typename?: 'query_root', tradeGuide: Array<{ __typename?: 'TradeGuide', name: string, trades: Array<{ __typename?: 'TradeTradeGuide', trade: { __typename?: 'Trade', name: string } }> }> };

export type TradeFormCreateMutationVariables = Exact<{
  trade: TradeInsertInput;
}>;


export type TradeFormCreateMutation = { __typename?: 'mutation_root', insertTradeOne?: { __typename: 'Trade', id: number } };

export type TradeFormUpdateMutationVariables = Exact<{
  tradeId: Scalars['Int'];
  trade?: InputMaybe<TradeSetInput>;
  deleteTradeGroupIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  insertTradeGroups: Array<TradeTradeGroupInsertInput> | TradeTradeGroupInsertInput;
  insertTradeQuestions: Array<TradeQuestionInsertInput> | TradeQuestionInsertInput;
  deleteTradeQuestions?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  insertTradeKeywords: Array<TradeKeywordInsertInput> | TradeKeywordInsertInput;
  deleteTradeKeyword?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type TradeFormUpdateMutation = { __typename?: 'mutation_root', updateTradeByPk?: { __typename: 'Trade', id: number }, deleteTradeTradeGroup?: { __typename?: 'TradeTradeGroupMutationResponse', returning: Array<{ __typename: 'TradeTradeGroup', tradeGroup: { __typename: 'TradeGroup', id: number } }> }, insertTradeTradeGroup?: { __typename?: 'TradeTradeGroupMutationResponse', returning: Array<{ __typename: 'TradeTradeGroup', tradeGroup: { __typename: 'TradeGroup', id: number } }> }, insertTradeQuestion?: { __typename?: 'TradeQuestionMutationResponse', affectedRows: number }, deleteTradeQuestion?: { __typename?: 'TradeQuestionMutationResponse', affectedRows: number }, insertTradeKeyword?: { __typename?: 'TradeKeywordMutationResponse', affectedRows: number }, deleteTradeKeyword?: { __typename?: 'TradeKeywordMutationResponse', affectedRows: number } };

export type TradeFormUpdateTradeKeywordMutationVariables = Exact<{
  tradeKeywordId: Scalars['Int'];
  tradeKeyword: TradeKeywordSetInput;
}>;


export type TradeFormUpdateTradeKeywordMutation = { __typename?: 'mutation_root', updateTradeKeywordByPk?: { __typename?: 'TradeKeyword', id: number } };

export type TradeFormUpdateTradeQuestionMutationVariables = Exact<{
  tradeQuestionId: Scalars['Int'];
  tradeQuestion: TradeQuestionSetInput;
}>;


export type TradeFormUpdateTradeQuestionMutation = { __typename?: 'mutation_root', updateTradeQuestionByPk?: { __typename?: 'TradeQuestion', id: number } };

export type TradeFormCreateSlugRedirectMutationVariables = Exact<{
  input: SlugRedirectInsertInput;
}>;


export type TradeFormCreateSlugRedirectMutation = { __typename?: 'mutation_root', insertSlugRedirectOne?: { __typename?: 'SlugRedirect', id: number } };

export type TradeFormUpdateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type TradeFormUpdateQuery = { __typename?: 'query_root', tradeByPk?: { __typename?: 'Trade', id: number, slug: string, name: string, pageTitle: string, anchor: string, pageTitleVariant: string, pageSubtitle: string, pageTitleDirectory: string, label: string, metaTitle: string, metaDescription: string, isCallRecordable: boolean, isAnonymised: boolean, isRgeFilterable: boolean, schemaType: string, schemaAdditionalType?: string, tradeGroups: Array<{ __typename?: 'TradeTradeGroup', tradeGroup: { __typename?: 'TradeGroup', id: number, iconName?: string } }>, tradeKeywords: Array<{ __typename?: 'TradeKeyword', id: number, name: string }>, tradeQuestions: Array<{ __typename?: 'TradeQuestion', id: number, question: string, answer: string }> } };

export type TradeUpdatePageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type TradeUpdatePageQuery = { __typename?: 'query_root', tradeByPk?: { __typename: 'Trade', id: number, slug: string, name: string, tradeGroups: Array<{ __typename?: 'TradeTradeGroup', trade: { __typename: 'Trade', id: number } }> } };

export type TradesTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TradeOrderBy> | TradeOrderBy>;
  where: TradeBoolExp;
  whereProView: ProViewBoolExp;
  whereProPresentation: TradeProPresentationBoolExp;
  whereTradeProView: TradeProViewBoolExp;
}>;


export type TradesTableQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'Trade', id: number, name: string, tradeGroups: Array<{ __typename?: 'TradeTradeGroup', tradeGroup: { __typename?: 'TradeGroup', id: number, name: string } }>, tradeProViewsAggregate: { __typename?: 'TradeProViewAggregate', aggregate?: { __typename?: 'TradeProViewAggregateFields', count: number } }, mainTradeProPresentations: Array<{ __typename?: 'TradeProPresentation', proPresentation: { __typename?: 'ProPresentation', name: string, proViews: Array<{ __typename?: 'ProView', id: number, avatarHash?: string }>, proViewsAggregate: { __typename?: 'ProViewAggregate', aggregate?: { __typename?: 'ProViewAggregateFields', count: number } } } }>, tradeKeywords: Array<{ __typename?: 'TradeKeyword', id: number, name: string }> }> };


export const AccountProViewDeleteConfirmModalQueryDocument = gql`
    query accountProViewDeleteConfirmModalQuery($authUserId: uuid!) {
  proView(
    where: {accounts: {authUserId: {_eq: $authUserId}}, status: {_nin: ["archived"]}}
  ) {
    id
    bilikZone {
      mainCityCode
    }
    proPresentation {
      name
      mainTradeNames
    }
  }
}
    `;

/**
 * __useAccountProViewDeleteConfirmModalQuery__
 *
 * To run a query within a React component, call `useAccountProViewDeleteConfirmModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountProViewDeleteConfirmModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountProViewDeleteConfirmModalQuery({
 *   variables: {
 *      authUserId: // value for 'authUserId'
 *   },
 * });
 */
export function useAccountProViewDeleteConfirmModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountProViewDeleteConfirmModalQuery, AccountProViewDeleteConfirmModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountProViewDeleteConfirmModalQuery, AccountProViewDeleteConfirmModalQueryVariables>(AccountProViewDeleteConfirmModalQueryDocument, options);
      }
export function useAccountProViewDeleteConfirmModalQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountProViewDeleteConfirmModalQuery, AccountProViewDeleteConfirmModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountProViewDeleteConfirmModalQuery, AccountProViewDeleteConfirmModalQueryVariables>(AccountProViewDeleteConfirmModalQueryDocument, options);
        }
export type AccountProViewDeleteConfirmModalQueryHookResult = ReturnType<typeof useAccountProViewDeleteConfirmModalQuery>;
export type AccountProViewDeleteConfirmModalQueryLazyQueryHookResult = ReturnType<typeof useAccountProViewDeleteConfirmModalQueryLazyQuery>;
export type AccountProViewDeleteConfirmModalQueryQueryResult = ApolloReactCommon.QueryResult<AccountProViewDeleteConfirmModalQuery, AccountProViewDeleteConfirmModalQueryVariables>;
export const AccountsFieldUnlinkAllAccountDocument = gql`
    mutation accountsFieldUnlinkAllAccount($authUserId: uuid!) {
  deleteAccountProView(where: {authUserId: {_eq: $authUserId}}) {
    affectedRows
  }
}
    `;
export type AccountsFieldUnlinkAllAccountMutationFn = ApolloReactCommon.MutationFunction<AccountsFieldUnlinkAllAccountMutation, AccountsFieldUnlinkAllAccountMutationVariables>;

/**
 * __useAccountsFieldUnlinkAllAccountMutation__
 *
 * To run a mutation, you first call `useAccountsFieldUnlinkAllAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountsFieldUnlinkAllAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountsFieldUnlinkAllAccountMutation, { data, loading, error }] = useAccountsFieldUnlinkAllAccountMutation({
 *   variables: {
 *      authUserId: // value for 'authUserId'
 *   },
 * });
 */
export function useAccountsFieldUnlinkAllAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AccountsFieldUnlinkAllAccountMutation, AccountsFieldUnlinkAllAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AccountsFieldUnlinkAllAccountMutation, AccountsFieldUnlinkAllAccountMutationVariables>(AccountsFieldUnlinkAllAccountDocument, options);
      }
export type AccountsFieldUnlinkAllAccountMutationHookResult = ReturnType<typeof useAccountsFieldUnlinkAllAccountMutation>;
export type AccountsFieldUnlinkAllAccountMutationResult = ApolloReactCommon.MutationResult<AccountsFieldUnlinkAllAccountMutation>;
export type AccountsFieldUnlinkAllAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<AccountsFieldUnlinkAllAccountMutation, AccountsFieldUnlinkAllAccountMutationVariables>;
export const AccountsFieldLinkAccountDocument = gql`
    mutation accountsFieldLinkAccount($objects: [AccountProViewInsertInput!]!) {
  insertAccountProView(objects: $objects) {
    affectedRows
  }
}
    `;
export type AccountsFieldLinkAccountMutationFn = ApolloReactCommon.MutationFunction<AccountsFieldLinkAccountMutation, AccountsFieldLinkAccountMutationVariables>;

/**
 * __useAccountsFieldLinkAccountMutation__
 *
 * To run a mutation, you first call `useAccountsFieldLinkAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountsFieldLinkAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountsFieldLinkAccountMutation, { data, loading, error }] = useAccountsFieldLinkAccountMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAccountsFieldLinkAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AccountsFieldLinkAccountMutation, AccountsFieldLinkAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AccountsFieldLinkAccountMutation, AccountsFieldLinkAccountMutationVariables>(AccountsFieldLinkAccountDocument, options);
      }
export type AccountsFieldLinkAccountMutationHookResult = ReturnType<typeof useAccountsFieldLinkAccountMutation>;
export type AccountsFieldLinkAccountMutationResult = ApolloReactCommon.MutationResult<AccountsFieldLinkAccountMutation>;
export type AccountsFieldLinkAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<AccountsFieldLinkAccountMutation, AccountsFieldLinkAccountMutationVariables>;
export const AccountsFieldGetLinkedAccountDocument = gql`
    query accountsFieldGetLinkedAccount($authUserId: uuid!) {
  accountProView(where: {authUserId: {_eq: $authUserId}}) {
    proViewId
  }
}
    `;

/**
 * __useAccountsFieldGetLinkedAccountQuery__
 *
 * To run a query within a React component, call `useAccountsFieldGetLinkedAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsFieldGetLinkedAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsFieldGetLinkedAccountQuery({
 *   variables: {
 *      authUserId: // value for 'authUserId'
 *   },
 * });
 */
export function useAccountsFieldGetLinkedAccountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountsFieldGetLinkedAccountQuery, AccountsFieldGetLinkedAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountsFieldGetLinkedAccountQuery, AccountsFieldGetLinkedAccountQueryVariables>(AccountsFieldGetLinkedAccountDocument, options);
      }
export function useAccountsFieldGetLinkedAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountsFieldGetLinkedAccountQuery, AccountsFieldGetLinkedAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountsFieldGetLinkedAccountQuery, AccountsFieldGetLinkedAccountQueryVariables>(AccountsFieldGetLinkedAccountDocument, options);
        }
export type AccountsFieldGetLinkedAccountQueryHookResult = ReturnType<typeof useAccountsFieldGetLinkedAccountQuery>;
export type AccountsFieldGetLinkedAccountLazyQueryHookResult = ReturnType<typeof useAccountsFieldGetLinkedAccountLazyQuery>;
export type AccountsFieldGetLinkedAccountQueryResult = ApolloReactCommon.QueryResult<AccountsFieldGetLinkedAccountQuery, AccountsFieldGetLinkedAccountQueryVariables>;
export const CallsTableGloballyBlockedDocument = gql`
    query callsTableGloballyBlocked {
  globallyBlockedIdentity(where: {identifier: {_like: "telephone:%"}}) {
    identifier
  }
}
    `;

/**
 * __useCallsTableGloballyBlockedQuery__
 *
 * To run a query within a React component, call `useCallsTableGloballyBlockedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallsTableGloballyBlockedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallsTableGloballyBlockedQuery({
 *   variables: {
 *   },
 * });
 */
export function useCallsTableGloballyBlockedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CallsTableGloballyBlockedQuery, CallsTableGloballyBlockedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CallsTableGloballyBlockedQuery, CallsTableGloballyBlockedQueryVariables>(CallsTableGloballyBlockedDocument, options);
      }
export function useCallsTableGloballyBlockedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CallsTableGloballyBlockedQuery, CallsTableGloballyBlockedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CallsTableGloballyBlockedQuery, CallsTableGloballyBlockedQueryVariables>(CallsTableGloballyBlockedDocument, options);
        }
export type CallsTableGloballyBlockedQueryHookResult = ReturnType<typeof useCallsTableGloballyBlockedQuery>;
export type CallsTableGloballyBlockedLazyQueryHookResult = ReturnType<typeof useCallsTableGloballyBlockedLazyQuery>;
export type CallsTableGloballyBlockedQueryResult = ApolloReactCommon.QueryResult<CallsTableGloballyBlockedQuery, CallsTableGloballyBlockedQueryVariables>;
export const CountPresentationReviewByStatusQueryDocument = gql`
    query countPresentationReviewByStatusQuery($where: CountProReviewByStatusBoolExp) {
  countProReviewByStatus(where: $where) {
    count
    status
  }
}
    `;

/**
 * __useCountPresentationReviewByStatusQuery__
 *
 * To run a query within a React component, call `useCountPresentationReviewByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPresentationReviewByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPresentationReviewByStatusQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPresentationReviewByStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CountPresentationReviewByStatusQuery, CountPresentationReviewByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CountPresentationReviewByStatusQuery, CountPresentationReviewByStatusQueryVariables>(CountPresentationReviewByStatusQueryDocument, options);
      }
export function useCountPresentationReviewByStatusQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CountPresentationReviewByStatusQuery, CountPresentationReviewByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CountPresentationReviewByStatusQuery, CountPresentationReviewByStatusQueryVariables>(CountPresentationReviewByStatusQueryDocument, options);
        }
export type CountPresentationReviewByStatusQueryHookResult = ReturnType<typeof useCountPresentationReviewByStatusQuery>;
export type CountPresentationReviewByStatusQueryLazyQueryHookResult = ReturnType<typeof useCountPresentationReviewByStatusQueryLazyQuery>;
export type CountPresentationReviewByStatusQueryQueryResult = ApolloReactCommon.QueryResult<CountPresentationReviewByStatusQuery, CountPresentationReviewByStatusQueryVariables>;
export const GloballyBlockedDocument = gql`
    query globallyBlocked($identifiers: [String!]) {
  globallyBlockedIdentity(where: {identifier: {_in: $identifiers}}) {
    id
    identifier
    reason
    dateCreated
  }
}
    `;

/**
 * __useGloballyBlockedQuery__
 *
 * To run a query within a React component, call `useGloballyBlockedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGloballyBlockedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGloballyBlockedQuery({
 *   variables: {
 *      identifiers: // value for 'identifiers'
 *   },
 * });
 */
export function useGloballyBlockedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GloballyBlockedQuery, GloballyBlockedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GloballyBlockedQuery, GloballyBlockedQueryVariables>(GloballyBlockedDocument, options);
      }
export function useGloballyBlockedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GloballyBlockedQuery, GloballyBlockedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GloballyBlockedQuery, GloballyBlockedQueryVariables>(GloballyBlockedDocument, options);
        }
export type GloballyBlockedQueryHookResult = ReturnType<typeof useGloballyBlockedQuery>;
export type GloballyBlockedLazyQueryHookResult = ReturnType<typeof useGloballyBlockedLazyQuery>;
export type GloballyBlockedQueryResult = ApolloReactCommon.QueryResult<GloballyBlockedQuery, GloballyBlockedQueryVariables>;
export const GoogleReviewLinkFieldQueryDocument = gql`
    query googleReviewLinkFieldQuery($id: Int!) {
  proPresentationByPk(id: $id) {
    proViewsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGoogleReviewLinkFieldQuery__
 *
 * To run a query within a React component, call `useGoogleReviewLinkFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleReviewLinkFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleReviewLinkFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGoogleReviewLinkFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GoogleReviewLinkFieldQuery, GoogleReviewLinkFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GoogleReviewLinkFieldQuery, GoogleReviewLinkFieldQueryVariables>(GoogleReviewLinkFieldQueryDocument, options);
      }
export function useGoogleReviewLinkFieldQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GoogleReviewLinkFieldQuery, GoogleReviewLinkFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GoogleReviewLinkFieldQuery, GoogleReviewLinkFieldQueryVariables>(GoogleReviewLinkFieldQueryDocument, options);
        }
export type GoogleReviewLinkFieldQueryHookResult = ReturnType<typeof useGoogleReviewLinkFieldQuery>;
export type GoogleReviewLinkFieldQueryLazyQueryHookResult = ReturnType<typeof useGoogleReviewLinkFieldQueryLazyQuery>;
export type GoogleReviewLinkFieldQueryQueryResult = ApolloReactCommon.QueryResult<GoogleReviewLinkFieldQuery, GoogleReviewLinkFieldQueryVariables>;
export const GetCitiesDocument = gql`
    query getCities($where: CityBoolExp!) {
  city(where: {_and: [$where, {slug: {_nin: ["paris", "lyon", "marseille"]}}]}) {
    id
    name
    area
    parentId
    departmentId
  }
}
    `;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
      }
export function useGetCitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
        }
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>;
export type GetCitiesLazyQueryHookResult = ReturnType<typeof useGetCitiesLazyQuery>;
export type GetCitiesQueryResult = ApolloReactCommon.QueryResult<GetCitiesQuery, GetCitiesQueryVariables>;
export const GetInterventionsFieldDepartmentsDocument = gql`
    query getInterventionsFieldDepartments {
  department(orderBy: [{code: ASC}]) {
    id
    name
    code
    area
    citiesAggregate(where: {slug: {_nin: ["paris", "lyon", "marseille"]}}) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetInterventionsFieldDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetInterventionsFieldDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterventionsFieldDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterventionsFieldDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterventionsFieldDepartmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInterventionsFieldDepartmentsQuery, GetInterventionsFieldDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInterventionsFieldDepartmentsQuery, GetInterventionsFieldDepartmentsQueryVariables>(GetInterventionsFieldDepartmentsDocument, options);
      }
export function useGetInterventionsFieldDepartmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInterventionsFieldDepartmentsQuery, GetInterventionsFieldDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInterventionsFieldDepartmentsQuery, GetInterventionsFieldDepartmentsQueryVariables>(GetInterventionsFieldDepartmentsDocument, options);
        }
export type GetInterventionsFieldDepartmentsQueryHookResult = ReturnType<typeof useGetInterventionsFieldDepartmentsQuery>;
export type GetInterventionsFieldDepartmentsLazyQueryHookResult = ReturnType<typeof useGetInterventionsFieldDepartmentsLazyQuery>;
export type GetInterventionsFieldDepartmentsQueryResult = ApolloReactCommon.QueryResult<GetInterventionsFieldDepartmentsQuery, GetInterventionsFieldDepartmentsQueryVariables>;
export const LastCheckedProReviewDocument = gql`
    query lastCheckedProReview($proPresentationId: Int!) {
  proReview(
    where: {presentations: {presentationId: {_eq: $proPresentationId}}, checkDate: {_isNull: false}}
    orderBy: {checkDate: DESC}
    limit: 1
  ) {
    checkDate
  }
}
    `;

/**
 * __useLastCheckedProReviewQuery__
 *
 * To run a query within a React component, call `useLastCheckedProReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastCheckedProReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastCheckedProReviewQuery({
 *   variables: {
 *      proPresentationId: // value for 'proPresentationId'
 *   },
 * });
 */
export function useLastCheckedProReviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LastCheckedProReviewQuery, LastCheckedProReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LastCheckedProReviewQuery, LastCheckedProReviewQueryVariables>(LastCheckedProReviewDocument, options);
      }
export function useLastCheckedProReviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LastCheckedProReviewQuery, LastCheckedProReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LastCheckedProReviewQuery, LastCheckedProReviewQueryVariables>(LastCheckedProReviewDocument, options);
        }
export type LastCheckedProReviewQueryHookResult = ReturnType<typeof useLastCheckedProReviewQuery>;
export type LastCheckedProReviewLazyQueryHookResult = ReturnType<typeof useLastCheckedProReviewLazyQuery>;
export type LastCheckedProReviewQueryResult = ApolloReactCommon.QueryResult<LastCheckedProReviewQuery, LastCheckedProReviewQueryVariables>;
export const BilikZonesLayerDocument = gql`
    query BilikZonesLayer {
  bilikZoneOutline(
    where: {outline: {_isNull: false}, bilikZone: {status: {_eq: "published"}}}
  ) {
    bilikZoneId
    outline
    bilikZone {
      name
    }
  }
}
    `;

/**
 * __useBilikZonesLayerQuery__
 *
 * To run a query within a React component, call `useBilikZonesLayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBilikZonesLayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBilikZonesLayerQuery({
 *   variables: {
 *   },
 * });
 */
export function useBilikZonesLayerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BilikZonesLayerQuery, BilikZonesLayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BilikZonesLayerQuery, BilikZonesLayerQueryVariables>(BilikZonesLayerDocument, options);
      }
export function useBilikZonesLayerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BilikZonesLayerQuery, BilikZonesLayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BilikZonesLayerQuery, BilikZonesLayerQueryVariables>(BilikZonesLayerDocument, options);
        }
export type BilikZonesLayerQueryHookResult = ReturnType<typeof useBilikZonesLayerQuery>;
export type BilikZonesLayerLazyQueryHookResult = ReturnType<typeof useBilikZonesLayerLazyQuery>;
export type BilikZonesLayerQueryResult = ApolloReactCommon.QueryResult<BilikZonesLayerQuery, BilikZonesLayerQueryVariables>;
export const NoteIdentityDeleteMutationDocument = gql`
    mutation noteIdentityDeleteMutation($noteIdentityId: Int!) {
  deleteNoteIdentityByPk(id: $noteIdentityId) {
    id
  }
}
    `;
export type NoteIdentityDeleteMutationMutationFn = ApolloReactCommon.MutationFunction<NoteIdentityDeleteMutation, NoteIdentityDeleteMutationVariables>;

/**
 * __useNoteIdentityDeleteMutation__
 *
 * To run a mutation, you first call `useNoteIdentityDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteIdentityDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteIdentityDeleteMutation, { data, loading, error }] = useNoteIdentityDeleteMutation({
 *   variables: {
 *      noteIdentityId: // value for 'noteIdentityId'
 *   },
 * });
 */
export function useNoteIdentityDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NoteIdentityDeleteMutation, NoteIdentityDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<NoteIdentityDeleteMutation, NoteIdentityDeleteMutationVariables>(NoteIdentityDeleteMutationDocument, options);
      }
export type NoteIdentityDeleteMutationHookResult = ReturnType<typeof useNoteIdentityDeleteMutation>;
export type NoteIdentityDeleteMutationMutationResult = ApolloReactCommon.MutationResult<NoteIdentityDeleteMutation>;
export type NoteIdentityDeleteMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<NoteIdentityDeleteMutation, NoteIdentityDeleteMutationVariables>;
export const NoteIdentityInsertMutationDocument = gql`
    mutation noteIdentityInsertMutation($noteIdentityInput: NoteIdentityInsertInput!) {
  insertNoteIdentityOne(
    object: $noteIdentityInput
    onConflict: {constraint: note_identity_pkey, updateColumns: [identifier, lastEditorId, lastUpdatedDate, message]}
  ) {
    id
  }
}
    `;
export type NoteIdentityInsertMutationMutationFn = ApolloReactCommon.MutationFunction<NoteIdentityInsertMutation, NoteIdentityInsertMutationVariables>;

/**
 * __useNoteIdentityInsertMutation__
 *
 * To run a mutation, you first call `useNoteIdentityInsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteIdentityInsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteIdentityInsertMutation, { data, loading, error }] = useNoteIdentityInsertMutation({
 *   variables: {
 *      noteIdentityInput: // value for 'noteIdentityInput'
 *   },
 * });
 */
export function useNoteIdentityInsertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NoteIdentityInsertMutation, NoteIdentityInsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<NoteIdentityInsertMutation, NoteIdentityInsertMutationVariables>(NoteIdentityInsertMutationDocument, options);
      }
export type NoteIdentityInsertMutationHookResult = ReturnType<typeof useNoteIdentityInsertMutation>;
export type NoteIdentityInsertMutationMutationResult = ApolloReactCommon.MutationResult<NoteIdentityInsertMutation>;
export type NoteIdentityInsertMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<NoteIdentityInsertMutation, NoteIdentityInsertMutationVariables>;
export const NotesIdentityByIdentifiersQueryDocument = gql`
    query notesIdentityByIdentifiersQuery($identifiers: [String!]) {
  noteIdentity(where: {identifier: {_in: $identifiers}}) {
    id
    identifier
    lastEditorId
    lastUpdatedDate
    message
    bilikPerson {
      id
      givenName
    }
  }
}
    `;

/**
 * __useNotesIdentityByIdentifiersQuery__
 *
 * To run a query within a React component, call `useNotesIdentityByIdentifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesIdentityByIdentifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesIdentityByIdentifiersQuery({
 *   variables: {
 *      identifiers: // value for 'identifiers'
 *   },
 * });
 */
export function useNotesIdentityByIdentifiersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NotesIdentityByIdentifiersQuery, NotesIdentityByIdentifiersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NotesIdentityByIdentifiersQuery, NotesIdentityByIdentifiersQueryVariables>(NotesIdentityByIdentifiersQueryDocument, options);
      }
export function useNotesIdentityByIdentifiersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NotesIdentityByIdentifiersQuery, NotesIdentityByIdentifiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NotesIdentityByIdentifiersQuery, NotesIdentityByIdentifiersQueryVariables>(NotesIdentityByIdentifiersQueryDocument, options);
        }
export type NotesIdentityByIdentifiersQueryHookResult = ReturnType<typeof useNotesIdentityByIdentifiersQuery>;
export type NotesIdentityByIdentifiersQueryLazyQueryHookResult = ReturnType<typeof useNotesIdentityByIdentifiersQueryLazyQuery>;
export type NotesIdentityByIdentifiersQueryQueryResult = ApolloReactCommon.QueryResult<NotesIdentityByIdentifiersQuery, NotesIdentityByIdentifiersQueryVariables>;
export const PrivateIndividualSearchSolicitationQueryDocument = gql`
    query privateIndividualSearchSolicitationQuery($criteria: String, $where: SolicitationBoolExp) {
  searchSolicitation(args: {search: $criteria}, limit: 15, where: $where) {
    email
    givenName
    familyName
  }
}
    `;

/**
 * __usePrivateIndividualSearchSolicitationQuery__
 *
 * To run a query within a React component, call `usePrivateIndividualSearchSolicitationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivateIndividualSearchSolicitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivateIndividualSearchSolicitationQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePrivateIndividualSearchSolicitationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PrivateIndividualSearchSolicitationQuery, PrivateIndividualSearchSolicitationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrivateIndividualSearchSolicitationQuery, PrivateIndividualSearchSolicitationQueryVariables>(PrivateIndividualSearchSolicitationQueryDocument, options);
      }
export function usePrivateIndividualSearchSolicitationQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrivateIndividualSearchSolicitationQuery, PrivateIndividualSearchSolicitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrivateIndividualSearchSolicitationQuery, PrivateIndividualSearchSolicitationQueryVariables>(PrivateIndividualSearchSolicitationQueryDocument, options);
        }
export type PrivateIndividualSearchSolicitationQueryHookResult = ReturnType<typeof usePrivateIndividualSearchSolicitationQuery>;
export type PrivateIndividualSearchSolicitationQueryLazyQueryHookResult = ReturnType<typeof usePrivateIndividualSearchSolicitationQueryLazyQuery>;
export type PrivateIndividualSearchSolicitationQueryQueryResult = ApolloReactCommon.QueryResult<PrivateIndividualSearchSolicitationQuery, PrivateIndividualSearchSolicitationQueryVariables>;
export const PrivateIndividualSearchProReviewQueryDocument = gql`
    query privateIndividualSearchProReviewQuery($criteria: String, $where: ProReviewBoolExp) {
  searchProReview(args: {search: $criteria}, limit: 15, where: $where) {
    email
    givenName
    familyName
  }
}
    `;

/**
 * __usePrivateIndividualSearchProReviewQuery__
 *
 * To run a query within a React component, call `usePrivateIndividualSearchProReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivateIndividualSearchProReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivateIndividualSearchProReviewQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePrivateIndividualSearchProReviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PrivateIndividualSearchProReviewQuery, PrivateIndividualSearchProReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrivateIndividualSearchProReviewQuery, PrivateIndividualSearchProReviewQueryVariables>(PrivateIndividualSearchProReviewQueryDocument, options);
      }
export function usePrivateIndividualSearchProReviewQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrivateIndividualSearchProReviewQuery, PrivateIndividualSearchProReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrivateIndividualSearchProReviewQuery, PrivateIndividualSearchProReviewQueryVariables>(PrivateIndividualSearchProReviewQueryDocument, options);
        }
export type PrivateIndividualSearchProReviewQueryHookResult = ReturnType<typeof usePrivateIndividualSearchProReviewQuery>;
export type PrivateIndividualSearchProReviewQueryLazyQueryHookResult = ReturnType<typeof usePrivateIndividualSearchProReviewQueryLazyQuery>;
export type PrivateIndividualSearchProReviewQueryQueryResult = ApolloReactCommon.QueryResult<PrivateIndividualSearchProReviewQuery, PrivateIndividualSearchProReviewQueryVariables>;
export const PrivateIndividualSearchProReviewInvitationQueryDocument = gql`
    query privateIndividualSearchProReviewInvitationQuery($criteria: String, $where: ProReviewInvitationBoolExp) {
  searchProReviewInvitation(args: {search: $criteria}, limit: 15, where: $where) {
    email
    givenName
    familyName
  }
}
    `;

/**
 * __usePrivateIndividualSearchProReviewInvitationQuery__
 *
 * To run a query within a React component, call `usePrivateIndividualSearchProReviewInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivateIndividualSearchProReviewInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivateIndividualSearchProReviewInvitationQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePrivateIndividualSearchProReviewInvitationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PrivateIndividualSearchProReviewInvitationQuery, PrivateIndividualSearchProReviewInvitationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrivateIndividualSearchProReviewInvitationQuery, PrivateIndividualSearchProReviewInvitationQueryVariables>(PrivateIndividualSearchProReviewInvitationQueryDocument, options);
      }
export function usePrivateIndividualSearchProReviewInvitationQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrivateIndividualSearchProReviewInvitationQuery, PrivateIndividualSearchProReviewInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrivateIndividualSearchProReviewInvitationQuery, PrivateIndividualSearchProReviewInvitationQueryVariables>(PrivateIndividualSearchProReviewInvitationQueryDocument, options);
        }
export type PrivateIndividualSearchProReviewInvitationQueryHookResult = ReturnType<typeof usePrivateIndividualSearchProReviewInvitationQuery>;
export type PrivateIndividualSearchProReviewInvitationQueryLazyQueryHookResult = ReturnType<typeof usePrivateIndividualSearchProReviewInvitationQueryLazyQuery>;
export type PrivateIndividualSearchProReviewInvitationQueryQueryResult = ApolloReactCommon.QueryResult<PrivateIndividualSearchProReviewInvitationQuery, PrivateIndividualSearchProReviewInvitationQueryVariables>;
export const ProPersonSearchFilterQueryDocument = gql`
    query proPersonSearchFilterQuery($criteria: String) {
  searchProPerson(args: {search: $criteria}) {
    id
    givenName
    familyName
    email
    telephone
  }
}
    `;

/**
 * __useProPersonSearchFilterQuery__
 *
 * To run a query within a React component, call `useProPersonSearchFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useProPersonSearchFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProPersonSearchFilterQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useProPersonSearchFilterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProPersonSearchFilterQuery, ProPersonSearchFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProPersonSearchFilterQuery, ProPersonSearchFilterQueryVariables>(ProPersonSearchFilterQueryDocument, options);
      }
export function useProPersonSearchFilterQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProPersonSearchFilterQuery, ProPersonSearchFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProPersonSearchFilterQuery, ProPersonSearchFilterQueryVariables>(ProPersonSearchFilterQueryDocument, options);
        }
export type ProPersonSearchFilterQueryHookResult = ReturnType<typeof useProPersonSearchFilterQuery>;
export type ProPersonSearchFilterQueryLazyQueryHookResult = ReturnType<typeof useProPersonSearchFilterQueryLazyQuery>;
export type ProPersonSearchFilterQueryQueryResult = ApolloReactCommon.QueryResult<ProPersonSearchFilterQuery, ProPersonSearchFilterQueryVariables>;
export const ProContactDeleteConfirmModalQueryDocument = gql`
    query proContactDeleteConfirmModalQuery($proPersonId: Int!, $authUserId: uuid!, $skipRelatedProViewAccounts: Boolean!) {
  relatedProViewProPeople: proView(
    where: {proPeople: {proPersonId: {_eq: $proPersonId}}, status: {_nin: ["archived"]}}
  ) {
    id
    bilikZone {
      mainCityCode
    }
    proPresentation {
      name
      mainTradeNames
    }
  }
  relatedProViewAccounts: proView(
    where: {accounts: {authUserId: {_eq: $authUserId}}, status: {_nin: ["archived"]}}
  ) @skip(if: $skipRelatedProViewAccounts) {
    id
    bilikZone {
      mainCityCode
    }
    proPresentation {
      name
      mainTradeNames
    }
  }
}
    `;

/**
 * __useProContactDeleteConfirmModalQuery__
 *
 * To run a query within a React component, call `useProContactDeleteConfirmModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useProContactDeleteConfirmModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProContactDeleteConfirmModalQuery({
 *   variables: {
 *      proPersonId: // value for 'proPersonId'
 *      authUserId: // value for 'authUserId'
 *      skipRelatedProViewAccounts: // value for 'skipRelatedProViewAccounts'
 *   },
 * });
 */
export function useProContactDeleteConfirmModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProContactDeleteConfirmModalQuery, ProContactDeleteConfirmModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProContactDeleteConfirmModalQuery, ProContactDeleteConfirmModalQueryVariables>(ProContactDeleteConfirmModalQueryDocument, options);
      }
export function useProContactDeleteConfirmModalQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProContactDeleteConfirmModalQuery, ProContactDeleteConfirmModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProContactDeleteConfirmModalQuery, ProContactDeleteConfirmModalQueryVariables>(ProContactDeleteConfirmModalQueryDocument, options);
        }
export type ProContactDeleteConfirmModalQueryHookResult = ReturnType<typeof useProContactDeleteConfirmModalQuery>;
export type ProContactDeleteConfirmModalQueryLazyQueryHookResult = ReturnType<typeof useProContactDeleteConfirmModalQueryLazyQuery>;
export type ProContactDeleteConfirmModalQueryQueryResult = ApolloReactCommon.QueryResult<ProContactDeleteConfirmModalQuery, ProContactDeleteConfirmModalQueryVariables>;
export const ProContactsFieldQueryDocument = gql`
    query proContactsFieldQuery($ids: [Int!]) {
  proPerson(where: {id: {_in: $ids}}) {
    id
    givenName
    familyName
    email
    telephone
  }
}
    `;

/**
 * __useProContactsFieldQuery__
 *
 * To run a query within a React component, call `useProContactsFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useProContactsFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProContactsFieldQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useProContactsFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProContactsFieldQuery, ProContactsFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProContactsFieldQuery, ProContactsFieldQueryVariables>(ProContactsFieldQueryDocument, options);
      }
export function useProContactsFieldQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProContactsFieldQuery, ProContactsFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProContactsFieldQuery, ProContactsFieldQueryVariables>(ProContactsFieldQueryDocument, options);
        }
export type ProContactsFieldQueryHookResult = ReturnType<typeof useProContactsFieldQuery>;
export type ProContactsFieldQueryLazyQueryHookResult = ReturnType<typeof useProContactsFieldQueryLazyQuery>;
export type ProContactsFieldQueryQueryResult = ApolloReactCommon.QueryResult<ProContactsFieldQuery, ProContactsFieldQueryVariables>;
export const ProFormArchiveModalUpdateDocument = gql`
    mutation proFormArchiveModalUpdate($proViewIds: [Int!]!, $set: ProViewSetInput!) {
  updateProView(where: {id: {_in: $proViewIds}}, _set: $set) {
    returning {
      id
    }
  }
}
    `;
export type ProFormArchiveModalUpdateMutationFn = ApolloReactCommon.MutationFunction<ProFormArchiveModalUpdateMutation, ProFormArchiveModalUpdateMutationVariables>;

/**
 * __useProFormArchiveModalUpdateMutation__
 *
 * To run a mutation, you first call `useProFormArchiveModalUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProFormArchiveModalUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proFormArchiveModalUpdateMutation, { data, loading, error }] = useProFormArchiveModalUpdateMutation({
 *   variables: {
 *      proViewIds: // value for 'proViewIds'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useProFormArchiveModalUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProFormArchiveModalUpdateMutation, ProFormArchiveModalUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProFormArchiveModalUpdateMutation, ProFormArchiveModalUpdateMutationVariables>(ProFormArchiveModalUpdateDocument, options);
      }
export type ProFormArchiveModalUpdateMutationHookResult = ReturnType<typeof useProFormArchiveModalUpdateMutation>;
export type ProFormArchiveModalUpdateMutationResult = ApolloReactCommon.MutationResult<ProFormArchiveModalUpdateMutation>;
export type ProFormArchiveModalUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<ProFormArchiveModalUpdateMutation, ProFormArchiveModalUpdateMutationVariables>;
export const ProFormArchiveModalQueryDocument = gql`
    query proFormArchiveModalQuery($companyId: Int!, $proViewId: Int!) {
  proView: proViewByPk(id: $proViewId) {
    id
    dateArchiveScheduled
    archiveReason
  }
  company: companyByPk(id: $companyId) {
    proPresentations {
      name
      proViews(where: {status: {_neq: "archived"}}) {
        id
        dateArchiveScheduled
        archiveReason
        bilikZone {
          name
        }
        proPresentation {
          mainTradeNames
        }
      }
    }
  }
}
    `;

/**
 * __useProFormArchiveModalQuery__
 *
 * To run a query within a React component, call `useProFormArchiveModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useProFormArchiveModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProFormArchiveModalQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      proViewId: // value for 'proViewId'
 *   },
 * });
 */
export function useProFormArchiveModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProFormArchiveModalQuery, ProFormArchiveModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProFormArchiveModalQuery, ProFormArchiveModalQueryVariables>(ProFormArchiveModalQueryDocument, options);
      }
export function useProFormArchiveModalQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProFormArchiveModalQuery, ProFormArchiveModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProFormArchiveModalQuery, ProFormArchiveModalQueryVariables>(ProFormArchiveModalQueryDocument, options);
        }
export type ProFormArchiveModalQueryHookResult = ReturnType<typeof useProFormArchiveModalQuery>;
export type ProFormArchiveModalQueryLazyQueryHookResult = ReturnType<typeof useProFormArchiveModalQueryLazyQuery>;
export type ProFormArchiveModalQueryQueryResult = ApolloReactCommon.QueryResult<ProFormArchiveModalQuery, ProFormArchiveModalQueryVariables>;
export const ProFormCreateProViewMutationDocument = gql`
    mutation proFormCreateProViewMutation($input: ProViewInsertInput!) {
  insertProViewOne(object: $input) {
    id
  }
}
    `;
export type ProFormCreateProViewMutationMutationFn = ApolloReactCommon.MutationFunction<ProFormCreateProViewMutation, ProFormCreateProViewMutationVariables>;

/**
 * __useProFormCreateProViewMutation__
 *
 * To run a mutation, you first call `useProFormCreateProViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProFormCreateProViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proFormCreateProViewMutation, { data, loading, error }] = useProFormCreateProViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProFormCreateProViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProFormCreateProViewMutation, ProFormCreateProViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProFormCreateProViewMutation, ProFormCreateProViewMutationVariables>(ProFormCreateProViewMutationDocument, options);
      }
export type ProFormCreateProViewMutationHookResult = ReturnType<typeof useProFormCreateProViewMutation>;
export type ProFormCreateProViewMutationMutationResult = ApolloReactCommon.MutationResult<ProFormCreateProViewMutation>;
export type ProFormCreateProViewMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ProFormCreateProViewMutation, ProFormCreateProViewMutationVariables>;
export const ProFormUpdateProPresentationMutationDocument = gql`
    mutation proFormUpdateProPresentationMutation($id: Int!, $input: ProPresentationSetInput!) {
  updateProPresentationByPk(pkColumns: {id: $id}, _set: $input) {
    id
    slug
    mainTrades {
      tradeId
    }
  }
}
    `;
export type ProFormUpdateProPresentationMutationMutationFn = ApolloReactCommon.MutationFunction<ProFormUpdateProPresentationMutation, ProFormUpdateProPresentationMutationVariables>;

/**
 * __useProFormUpdateProPresentationMutation__
 *
 * To run a mutation, you first call `useProFormUpdateProPresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProFormUpdateProPresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proFormUpdateProPresentationMutation, { data, loading, error }] = useProFormUpdateProPresentationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProFormUpdateProPresentationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProFormUpdateProPresentationMutation, ProFormUpdateProPresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProFormUpdateProPresentationMutation, ProFormUpdateProPresentationMutationVariables>(ProFormUpdateProPresentationMutationDocument, options);
      }
export type ProFormUpdateProPresentationMutationHookResult = ReturnType<typeof useProFormUpdateProPresentationMutation>;
export type ProFormUpdateProPresentationMutationMutationResult = ApolloReactCommon.MutationResult<ProFormUpdateProPresentationMutation>;
export type ProFormUpdateProPresentationMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ProFormUpdateProPresentationMutation, ProFormUpdateProPresentationMutationVariables>;
export const ProFormCreateModalQueryDocument = gql`
    query proFormCreateModalQuery($id: Int!) {
  proPresentationByPk(id: $id) {
    id
    name
    slug
    mainTrades {
      tradeId
    }
    proViews {
      bilikZoneId
      trades {
        trade {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useProFormCreateModalQuery__
 *
 * To run a query within a React component, call `useProFormCreateModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useProFormCreateModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProFormCreateModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProFormCreateModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProFormCreateModalQuery, ProFormCreateModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProFormCreateModalQuery, ProFormCreateModalQueryVariables>(ProFormCreateModalQueryDocument, options);
      }
export function useProFormCreateModalQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProFormCreateModalQuery, ProFormCreateModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProFormCreateModalQuery, ProFormCreateModalQueryVariables>(ProFormCreateModalQueryDocument, options);
        }
export type ProFormCreateModalQueryHookResult = ReturnType<typeof useProFormCreateModalQuery>;
export type ProFormCreateModalQueryLazyQueryHookResult = ReturnType<typeof useProFormCreateModalQueryLazyQuery>;
export type ProFormCreateModalQueryQueryResult = ApolloReactCommon.QueryResult<ProFormCreateModalQuery, ProFormCreateModalQueryVariables>;
export const ProMandateFormCreateMutationDocument = gql`
    mutation proMandateFormCreateMutation($proMandate: ProMandateInsertInput!) {
  insertProMandateOne(object: $proMandate) {
    id
    dateCreated
    rum
    zohoOrganizationId
    companyId
    iban
    bic
    status
  }
}
    `;
export type ProMandateFormCreateMutationMutationFn = ApolloReactCommon.MutationFunction<ProMandateFormCreateMutation, ProMandateFormCreateMutationVariables>;

/**
 * __useProMandateFormCreateMutation__
 *
 * To run a mutation, you first call `useProMandateFormCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProMandateFormCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proMandateFormCreateMutation, { data, loading, error }] = useProMandateFormCreateMutation({
 *   variables: {
 *      proMandate: // value for 'proMandate'
 *   },
 * });
 */
export function useProMandateFormCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProMandateFormCreateMutation, ProMandateFormCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProMandateFormCreateMutation, ProMandateFormCreateMutationVariables>(ProMandateFormCreateMutationDocument, options);
      }
export type ProMandateFormCreateMutationHookResult = ReturnType<typeof useProMandateFormCreateMutation>;
export type ProMandateFormCreateMutationMutationResult = ApolloReactCommon.MutationResult<ProMandateFormCreateMutation>;
export type ProMandateFormCreateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ProMandateFormCreateMutation, ProMandateFormCreateMutationVariables>;
export const ProPresentationSearchFilterProPresentationDocument = gql`
    query proPresentationSearchFilterProPresentation($id: Int!) {
  proPresentationByPk(id: $id) {
    name
  }
}
    `;

/**
 * __useProPresentationSearchFilterProPresentationQuery__
 *
 * To run a query within a React component, call `useProPresentationSearchFilterProPresentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProPresentationSearchFilterProPresentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProPresentationSearchFilterProPresentationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProPresentationSearchFilterProPresentationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProPresentationSearchFilterProPresentationQuery, ProPresentationSearchFilterProPresentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProPresentationSearchFilterProPresentationQuery, ProPresentationSearchFilterProPresentationQueryVariables>(ProPresentationSearchFilterProPresentationDocument, options);
      }
export function useProPresentationSearchFilterProPresentationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProPresentationSearchFilterProPresentationQuery, ProPresentationSearchFilterProPresentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProPresentationSearchFilterProPresentationQuery, ProPresentationSearchFilterProPresentationQueryVariables>(ProPresentationSearchFilterProPresentationDocument, options);
        }
export type ProPresentationSearchFilterProPresentationQueryHookResult = ReturnType<typeof useProPresentationSearchFilterProPresentationQuery>;
export type ProPresentationSearchFilterProPresentationLazyQueryHookResult = ReturnType<typeof useProPresentationSearchFilterProPresentationLazyQuery>;
export type ProPresentationSearchFilterProPresentationQueryResult = ApolloReactCommon.QueryResult<ProPresentationSearchFilterProPresentationQuery, ProPresentationSearchFilterProPresentationQueryVariables>;
export const ProPresentationSearchFilterQueryDocument = gql`
    query proPresentationSearchFilterQuery($criteria: String, $filters: ProPresentationBoolExp!) {
  searchProPresentation(
    args: {search: $criteria}
    distinctOn: [id]
    where: $filters
  ) {
    id
    name
    mainTradeNames
    proViews {
      id
      proPeople {
        proPerson {
          id
          givenName
          familyName
        }
      }
      bilikZone {
        mainCityCode
      }
      status
    }
  }
}
    `;

/**
 * __useProPresentationSearchFilterQuery__
 *
 * To run a query within a React component, call `useProPresentationSearchFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useProPresentationSearchFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProPresentationSearchFilterQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProPresentationSearchFilterQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProPresentationSearchFilterQuery, ProPresentationSearchFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProPresentationSearchFilterQuery, ProPresentationSearchFilterQueryVariables>(ProPresentationSearchFilterQueryDocument, options);
      }
export function useProPresentationSearchFilterQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProPresentationSearchFilterQuery, ProPresentationSearchFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProPresentationSearchFilterQuery, ProPresentationSearchFilterQueryVariables>(ProPresentationSearchFilterQueryDocument, options);
        }
export type ProPresentationSearchFilterQueryHookResult = ReturnType<typeof useProPresentationSearchFilterQuery>;
export type ProPresentationSearchFilterQueryLazyQueryHookResult = ReturnType<typeof useProPresentationSearchFilterQueryLazyQuery>;
export type ProPresentationSearchFilterQueryQueryResult = ApolloReactCommon.QueryResult<ProPresentationSearchFilterQuery, ProPresentationSearchFilterQueryVariables>;
export const ProReviewInvitationToggleMutationDocument = gql`
    mutation proReviewInvitationToggleMutation($isAutorespondActive: Boolean!, $id: Int!) {
  updateProReviewInvitationByPk(
    pkColumns: {id: $id}
    _set: {isAutorespondActive: $isAutorespondActive}
  ) {
    id
    email
    isAutorespondActive
    proPresentation {
      name
      mainTradeNames
    }
  }
}
    `;
export type ProReviewInvitationToggleMutationMutationFn = ApolloReactCommon.MutationFunction<ProReviewInvitationToggleMutation, ProReviewInvitationToggleMutationVariables>;

/**
 * __useProReviewInvitationToggleMutation__
 *
 * To run a mutation, you first call `useProReviewInvitationToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProReviewInvitationToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proReviewInvitationToggleMutation, { data, loading, error }] = useProReviewInvitationToggleMutation({
 *   variables: {
 *      isAutorespondActive: // value for 'isAutorespondActive'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProReviewInvitationToggleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProReviewInvitationToggleMutation, ProReviewInvitationToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProReviewInvitationToggleMutation, ProReviewInvitationToggleMutationVariables>(ProReviewInvitationToggleMutationDocument, options);
      }
export type ProReviewInvitationToggleMutationHookResult = ReturnType<typeof useProReviewInvitationToggleMutation>;
export type ProReviewInvitationToggleMutationMutationResult = ApolloReactCommon.MutationResult<ProReviewInvitationToggleMutation>;
export type ProReviewInvitationToggleMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ProReviewInvitationToggleMutation, ProReviewInvitationToggleMutationVariables>;
export const ProReviewInvitationToggleQueryDocument = gql`
    query proReviewInvitationToggleQuery($id: Int!) {
  proReviewInvitationByPk(id: $id) {
    id
    isAutorespondActive
    proReviewId
    isBounce
    proPresentation {
      proViews {
        status
      }
    }
  }
}
    `;

/**
 * __useProReviewInvitationToggleQuery__
 *
 * To run a query within a React component, call `useProReviewInvitationToggleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewInvitationToggleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewInvitationToggleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProReviewInvitationToggleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProReviewInvitationToggleQuery, ProReviewInvitationToggleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewInvitationToggleQuery, ProReviewInvitationToggleQueryVariables>(ProReviewInvitationToggleQueryDocument, options);
      }
export function useProReviewInvitationToggleQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewInvitationToggleQuery, ProReviewInvitationToggleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewInvitationToggleQuery, ProReviewInvitationToggleQueryVariables>(ProReviewInvitationToggleQueryDocument, options);
        }
export type ProReviewInvitationToggleQueryHookResult = ReturnType<typeof useProReviewInvitationToggleQuery>;
export type ProReviewInvitationToggleQueryLazyQueryHookResult = ReturnType<typeof useProReviewInvitationToggleQueryLazyQuery>;
export type ProReviewInvitationToggleQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewInvitationToggleQuery, ProReviewInvitationToggleQueryVariables>;
export const ProReviewInvitationMailsMutationDocument = gql`
    mutation proReviewInvitationMailsMutation($id: Int!, $proPresentation: ProPresentationSetInput!) {
  updateProPresentationByPk(pkColumns: {id: $id}, _set: $proPresentation) {
    id
  }
}
    `;
export type ProReviewInvitationMailsMutationMutationFn = ApolloReactCommon.MutationFunction<ProReviewInvitationMailsMutation, ProReviewInvitationMailsMutationVariables>;

/**
 * __useProReviewInvitationMailsMutation__
 *
 * To run a mutation, you first call `useProReviewInvitationMailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProReviewInvitationMailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proReviewInvitationMailsMutation, { data, loading, error }] = useProReviewInvitationMailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      proPresentation: // value for 'proPresentation'
 *   },
 * });
 */
export function useProReviewInvitationMailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProReviewInvitationMailsMutation, ProReviewInvitationMailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProReviewInvitationMailsMutation, ProReviewInvitationMailsMutationVariables>(ProReviewInvitationMailsMutationDocument, options);
      }
export type ProReviewInvitationMailsMutationHookResult = ReturnType<typeof useProReviewInvitationMailsMutation>;
export type ProReviewInvitationMailsMutationMutationResult = ApolloReactCommon.MutationResult<ProReviewInvitationMailsMutation>;
export type ProReviewInvitationMailsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ProReviewInvitationMailsMutation, ProReviewInvitationMailsMutationVariables>;
export const ProReviewInvitationsTableQueryDocument = gql`
    query proReviewInvitationsTableQuery($limit: Int, $offset: Int, $orderBy: [ProReviewInvitationOrderBy!], $where: ProReviewInvitationBoolExp) {
  proReviewInvitation(
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    where: $where
  ) {
    id
    givenName
    familyName
    email
    isBounce
    dateCreated
    dateOfWork
    uuid
    isAutorespondActive
    proReviewId
  }
}
    `;

/**
 * __useProReviewInvitationsTableQuery__
 *
 * To run a query within a React component, call `useProReviewInvitationsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewInvitationsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewInvitationsTableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProReviewInvitationsTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProReviewInvitationsTableQuery, ProReviewInvitationsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewInvitationsTableQuery, ProReviewInvitationsTableQueryVariables>(ProReviewInvitationsTableQueryDocument, options);
      }
export function useProReviewInvitationsTableQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewInvitationsTableQuery, ProReviewInvitationsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewInvitationsTableQuery, ProReviewInvitationsTableQueryVariables>(ProReviewInvitationsTableQueryDocument, options);
        }
export type ProReviewInvitationsTableQueryHookResult = ReturnType<typeof useProReviewInvitationsTableQuery>;
export type ProReviewInvitationsTableQueryLazyQueryHookResult = ReturnType<typeof useProReviewInvitationsTableQueryLazyQuery>;
export type ProReviewInvitationsTableQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewInvitationsTableQuery, ProReviewInvitationsTableQueryVariables>;
export const IpCheckerIndicatorQueryDocument = gql`
    query ipCheckerIndicatorQuery($where: ProReviewBoolExp) {
  proReviewAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useIpCheckerIndicatorQuery__
 *
 * To run a query within a React component, call `useIpCheckerIndicatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useIpCheckerIndicatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIpCheckerIndicatorQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useIpCheckerIndicatorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IpCheckerIndicatorQuery, IpCheckerIndicatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IpCheckerIndicatorQuery, IpCheckerIndicatorQueryVariables>(IpCheckerIndicatorQueryDocument, options);
      }
export function useIpCheckerIndicatorQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IpCheckerIndicatorQuery, IpCheckerIndicatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IpCheckerIndicatorQuery, IpCheckerIndicatorQueryVariables>(IpCheckerIndicatorQueryDocument, options);
        }
export type IpCheckerIndicatorQueryHookResult = ReturnType<typeof useIpCheckerIndicatorQuery>;
export type IpCheckerIndicatorQueryLazyQueryHookResult = ReturnType<typeof useIpCheckerIndicatorQueryLazyQuery>;
export type IpCheckerIndicatorQueryQueryResult = ApolloReactCommon.QueryResult<IpCheckerIndicatorQuery, IpCheckerIndicatorQueryVariables>;
export const ProReviewInvitationCheckerIndicatorQueryDocument = gql`
    query proReviewInvitationCheckerIndicatorQuery($email: String!) {
  proReviewInvitation(where: {email: {_eq: $email}}) {
    id
    proPresentation {
      id
    }
  }
}
    `;

/**
 * __useProReviewInvitationCheckerIndicatorQuery__
 *
 * To run a query within a React component, call `useProReviewInvitationCheckerIndicatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewInvitationCheckerIndicatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewInvitationCheckerIndicatorQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useProReviewInvitationCheckerIndicatorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProReviewInvitationCheckerIndicatorQuery, ProReviewInvitationCheckerIndicatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewInvitationCheckerIndicatorQuery, ProReviewInvitationCheckerIndicatorQueryVariables>(ProReviewInvitationCheckerIndicatorQueryDocument, options);
      }
export function useProReviewInvitationCheckerIndicatorQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewInvitationCheckerIndicatorQuery, ProReviewInvitationCheckerIndicatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewInvitationCheckerIndicatorQuery, ProReviewInvitationCheckerIndicatorQueryVariables>(ProReviewInvitationCheckerIndicatorQueryDocument, options);
        }
export type ProReviewInvitationCheckerIndicatorQueryHookResult = ReturnType<typeof useProReviewInvitationCheckerIndicatorQuery>;
export type ProReviewInvitationCheckerIndicatorQueryLazyQueryHookResult = ReturnType<typeof useProReviewInvitationCheckerIndicatorQueryLazyQuery>;
export type ProReviewInvitationCheckerIndicatorQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewInvitationCheckerIndicatorQuery, ProReviewInvitationCheckerIndicatorQueryVariables>;
export const SolicitationCheckerIndicatorQueryDocument = gql`
    query solicitationCheckerIndicatorQuery($email: String!) {
  solicitation(where: {email: {_eq: $email}}) {
    id
    givenName
    familyName
    email
    isAutorespondActive
    proView {
      id
      proPresentation {
        id
      }
    }
    proReview {
      id
    }
  }
}
    `;

/**
 * __useSolicitationCheckerIndicatorQuery__
 *
 * To run a query within a React component, call `useSolicitationCheckerIndicatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitationCheckerIndicatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitationCheckerIndicatorQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSolicitationCheckerIndicatorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SolicitationCheckerIndicatorQuery, SolicitationCheckerIndicatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SolicitationCheckerIndicatorQuery, SolicitationCheckerIndicatorQueryVariables>(SolicitationCheckerIndicatorQueryDocument, options);
      }
export function useSolicitationCheckerIndicatorQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SolicitationCheckerIndicatorQuery, SolicitationCheckerIndicatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SolicitationCheckerIndicatorQuery, SolicitationCheckerIndicatorQueryVariables>(SolicitationCheckerIndicatorQueryDocument, options);
        }
export type SolicitationCheckerIndicatorQueryHookResult = ReturnType<typeof useSolicitationCheckerIndicatorQuery>;
export type SolicitationCheckerIndicatorQueryLazyQueryHookResult = ReturnType<typeof useSolicitationCheckerIndicatorQueryLazyQuery>;
export type SolicitationCheckerIndicatorQueryQueryResult = ApolloReactCommon.QueryResult<SolicitationCheckerIndicatorQuery, SolicitationCheckerIndicatorQueryVariables>;
export const SearchCityFieldDocument = gql`
    query searchCityField($criteria: String, $where: CityBoolExp) {
  searchCity(args: {search: $criteria}, where: $where) {
    id
    name
    slug
    department {
      code
    }
  }
}
    `;

/**
 * __useSearchCityFieldQuery__
 *
 * To run a query within a React component, call `useSearchCityFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCityFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCityFieldQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSearchCityFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchCityFieldQuery, SearchCityFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchCityFieldQuery, SearchCityFieldQueryVariables>(SearchCityFieldDocument, options);
      }
export function useSearchCityFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchCityFieldQuery, SearchCityFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchCityFieldQuery, SearchCityFieldQueryVariables>(SearchCityFieldDocument, options);
        }
export type SearchCityFieldQueryHookResult = ReturnType<typeof useSearchCityFieldQuery>;
export type SearchCityFieldLazyQueryHookResult = ReturnType<typeof useSearchCityFieldLazyQuery>;
export type SearchCityFieldQueryResult = ApolloReactCommon.QueryResult<SearchCityFieldQuery, SearchCityFieldQueryVariables>;
export const SearchCityFieldDefaultQueryDocument = gql`
    query searchCityFieldDefaultQuery($id: Int!) {
  cityByPk(id: $id) {
    id
    name
    slug
    department {
      code
    }
  }
}
    `;

/**
 * __useSearchCityFieldDefaultQuery__
 *
 * To run a query within a React component, call `useSearchCityFieldDefaultQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCityFieldDefaultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCityFieldDefaultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSearchCityFieldDefaultQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchCityFieldDefaultQuery, SearchCityFieldDefaultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchCityFieldDefaultQuery, SearchCityFieldDefaultQueryVariables>(SearchCityFieldDefaultQueryDocument, options);
      }
export function useSearchCityFieldDefaultQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchCityFieldDefaultQuery, SearchCityFieldDefaultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchCityFieldDefaultQuery, SearchCityFieldDefaultQueryVariables>(SearchCityFieldDefaultQueryDocument, options);
        }
export type SearchCityFieldDefaultQueryHookResult = ReturnType<typeof useSearchCityFieldDefaultQuery>;
export type SearchCityFieldDefaultQueryLazyQueryHookResult = ReturnType<typeof useSearchCityFieldDefaultQueryLazyQuery>;
export type SearchCityFieldDefaultQueryQueryResult = ApolloReactCommon.QueryResult<SearchCityFieldDefaultQuery, SearchCityFieldDefaultQueryVariables>;
export const SelectBilikPersonFieldDocument = gql`
    query selectBilikPersonField($where: BilikPersonBoolExp) {
  bilikPerson(where: $where, orderBy: {familyName: ASC}) {
    id
    givenName
    familyName
    email
    telephone
  }
}
    `;

/**
 * __useSelectBilikPersonFieldQuery__
 *
 * To run a query within a React component, call `useSelectBilikPersonFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectBilikPersonFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectBilikPersonFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSelectBilikPersonFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelectBilikPersonFieldQuery, SelectBilikPersonFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectBilikPersonFieldQuery, SelectBilikPersonFieldQueryVariables>(SelectBilikPersonFieldDocument, options);
      }
export function useSelectBilikPersonFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectBilikPersonFieldQuery, SelectBilikPersonFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectBilikPersonFieldQuery, SelectBilikPersonFieldQueryVariables>(SelectBilikPersonFieldDocument, options);
        }
export type SelectBilikPersonFieldQueryHookResult = ReturnType<typeof useSelectBilikPersonFieldQuery>;
export type SelectBilikPersonFieldLazyQueryHookResult = ReturnType<typeof useSelectBilikPersonFieldLazyQuery>;
export type SelectBilikPersonFieldQueryResult = ApolloReactCommon.QueryResult<SelectBilikPersonFieldQuery, SelectBilikPersonFieldQueryVariables>;
export const SelectBilikZoneFieldDocument = gql`
    query selectBilikZoneField {
  bilikZone(where: {status: {_eq: "published"}}) {
    id
    name
  }
}
    `;

/**
 * __useSelectBilikZoneFieldQuery__
 *
 * To run a query within a React component, call `useSelectBilikZoneFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectBilikZoneFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectBilikZoneFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectBilikZoneFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelectBilikZoneFieldQuery, SelectBilikZoneFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectBilikZoneFieldQuery, SelectBilikZoneFieldQueryVariables>(SelectBilikZoneFieldDocument, options);
      }
export function useSelectBilikZoneFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectBilikZoneFieldQuery, SelectBilikZoneFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectBilikZoneFieldQuery, SelectBilikZoneFieldQueryVariables>(SelectBilikZoneFieldDocument, options);
        }
export type SelectBilikZoneFieldQueryHookResult = ReturnType<typeof useSelectBilikZoneFieldQuery>;
export type SelectBilikZoneFieldLazyQueryHookResult = ReturnType<typeof useSelectBilikZoneFieldLazyQuery>;
export type SelectBilikZoneFieldQueryResult = ApolloReactCommon.QueryResult<SelectBilikZoneFieldQuery, SelectBilikZoneFieldQueryVariables>;
export const SelectBilikZoneQueryDocument = gql`
    query selectBilikZoneQuery($orderBy: [BilikZoneOrderBy!]) {
  bilikZone(orderBy: $orderBy) {
    id
    name
  }
}
    `;

/**
 * __useSelectBilikZoneQuery__
 *
 * To run a query within a React component, call `useSelectBilikZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectBilikZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectBilikZoneQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSelectBilikZoneQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelectBilikZoneQuery, SelectBilikZoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectBilikZoneQuery, SelectBilikZoneQueryVariables>(SelectBilikZoneQueryDocument, options);
      }
export function useSelectBilikZoneQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectBilikZoneQuery, SelectBilikZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectBilikZoneQuery, SelectBilikZoneQueryVariables>(SelectBilikZoneQueryDocument, options);
        }
export type SelectBilikZoneQueryHookResult = ReturnType<typeof useSelectBilikZoneQuery>;
export type SelectBilikZoneQueryLazyQueryHookResult = ReturnType<typeof useSelectBilikZoneQueryLazyQuery>;
export type SelectBilikZoneQueryQueryResult = ApolloReactCommon.QueryResult<SelectBilikZoneQuery, SelectBilikZoneQueryVariables>;
export const SelectCityFieldDocument = gql`
    query selectCityField($where: CityBoolExp) {
  cities: city(where: $where) {
    id
    name
    slug
  }
}
    `;

/**
 * __useSelectCityFieldQuery__
 *
 * To run a query within a React component, call `useSelectCityFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectCityFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectCityFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSelectCityFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelectCityFieldQuery, SelectCityFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectCityFieldQuery, SelectCityFieldQueryVariables>(SelectCityFieldDocument, options);
      }
export function useSelectCityFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectCityFieldQuery, SelectCityFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectCityFieldQuery, SelectCityFieldQueryVariables>(SelectCityFieldDocument, options);
        }
export type SelectCityFieldQueryHookResult = ReturnType<typeof useSelectCityFieldQuery>;
export type SelectCityFieldLazyQueryHookResult = ReturnType<typeof useSelectCityFieldLazyQuery>;
export type SelectCityFieldQueryResult = ApolloReactCommon.QueryResult<SelectCityFieldQuery, SelectCityFieldQueryVariables>;
export const SelectCompanyFieldDocument = gql`
    query selectCompanyField {
  company {
    id
    name
  }
}
    `;

/**
 * __useSelectCompanyFieldQuery__
 *
 * To run a query within a React component, call `useSelectCompanyFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectCompanyFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectCompanyFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectCompanyFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelectCompanyFieldQuery, SelectCompanyFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectCompanyFieldQuery, SelectCompanyFieldQueryVariables>(SelectCompanyFieldDocument, options);
      }
export function useSelectCompanyFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectCompanyFieldQuery, SelectCompanyFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectCompanyFieldQuery, SelectCompanyFieldQueryVariables>(SelectCompanyFieldDocument, options);
        }
export type SelectCompanyFieldQueryHookResult = ReturnType<typeof useSelectCompanyFieldQuery>;
export type SelectCompanyFieldLazyQueryHookResult = ReturnType<typeof useSelectCompanyFieldLazyQuery>;
export type SelectCompanyFieldQueryResult = ApolloReactCommon.QueryResult<SelectCompanyFieldQuery, SelectCompanyFieldQueryVariables>;
export const SelectCurrentBilikZoneQueryDocument = gql`
    query selectCurrentBilikZoneQuery($orderBy: [BilikZoneOrderBy!]) {
  bilikZone(orderBy: $orderBy) {
    id
    name
    mainCityCode
  }
}
    `;

/**
 * __useSelectCurrentBilikZoneQuery__
 *
 * To run a query within a React component, call `useSelectCurrentBilikZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectCurrentBilikZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectCurrentBilikZoneQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSelectCurrentBilikZoneQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelectCurrentBilikZoneQuery, SelectCurrentBilikZoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectCurrentBilikZoneQuery, SelectCurrentBilikZoneQueryVariables>(SelectCurrentBilikZoneQueryDocument, options);
      }
export function useSelectCurrentBilikZoneQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectCurrentBilikZoneQuery, SelectCurrentBilikZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectCurrentBilikZoneQuery, SelectCurrentBilikZoneQueryVariables>(SelectCurrentBilikZoneQueryDocument, options);
        }
export type SelectCurrentBilikZoneQueryHookResult = ReturnType<typeof useSelectCurrentBilikZoneQuery>;
export type SelectCurrentBilikZoneQueryLazyQueryHookResult = ReturnType<typeof useSelectCurrentBilikZoneQueryLazyQuery>;
export type SelectCurrentBilikZoneQueryQueryResult = ApolloReactCommon.QueryResult<SelectCurrentBilikZoneQuery, SelectCurrentBilikZoneQueryVariables>;
export const SelectProPresentationFieldDocument = gql`
    query selectProPresentationField($where: ProPresentationBoolExp) {
  proPresentation(where: $where, orderBy: {id: ASC}) {
    id
    name
    mainTradeNames
  }
}
    `;

/**
 * __useSelectProPresentationFieldQuery__
 *
 * To run a query within a React component, call `useSelectProPresentationFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectProPresentationFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectProPresentationFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSelectProPresentationFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelectProPresentationFieldQuery, SelectProPresentationFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectProPresentationFieldQuery, SelectProPresentationFieldQueryVariables>(SelectProPresentationFieldDocument, options);
      }
export function useSelectProPresentationFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectProPresentationFieldQuery, SelectProPresentationFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectProPresentationFieldQuery, SelectProPresentationFieldQueryVariables>(SelectProPresentationFieldDocument, options);
        }
export type SelectProPresentationFieldQueryHookResult = ReturnType<typeof useSelectProPresentationFieldQuery>;
export type SelectProPresentationFieldLazyQueryHookResult = ReturnType<typeof useSelectProPresentationFieldLazyQuery>;
export type SelectProPresentationFieldQueryResult = ApolloReactCommon.QueryResult<SelectProPresentationFieldQuery, SelectProPresentationFieldQueryVariables>;
export const SelectProViewFieldDocument = gql`
    query selectProViewField($where: ProViewBoolExp) {
  proView(where: $where) {
    id
    proPresentation {
      id
      name
      mainTradeNames
    }
    bilikZone {
      id
      mainCityCode
    }
  }
}
    `;

/**
 * __useSelectProViewFieldQuery__
 *
 * To run a query within a React component, call `useSelectProViewFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectProViewFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectProViewFieldQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSelectProViewFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelectProViewFieldQuery, SelectProViewFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectProViewFieldQuery, SelectProViewFieldQueryVariables>(SelectProViewFieldDocument, options);
      }
export function useSelectProViewFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectProViewFieldQuery, SelectProViewFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectProViewFieldQuery, SelectProViewFieldQueryVariables>(SelectProViewFieldDocument, options);
        }
export type SelectProViewFieldQueryHookResult = ReturnType<typeof useSelectProViewFieldQuery>;
export type SelectProViewFieldLazyQueryHookResult = ReturnType<typeof useSelectProViewFieldLazyQuery>;
export type SelectProViewFieldQueryResult = ApolloReactCommon.QueryResult<SelectProViewFieldQuery, SelectProViewFieldQueryVariables>;
export const SelectTradeFieldDocument = gql`
    query selectTradeField($bilikZoneId: Int!) {
  trade {
    id
    name
    tradeProViewsAggregate(
      where: {proView: {bilikZoneId: {_eq: $bilikZoneId}, status: {_eq: "published"}}}
    ) {
      aggregate {
        count
      }
    }
    mainTradeProPresentationsAggregate(
      where: {proPresentation: {proViews: {bilikZoneId: {_eq: $bilikZoneId}, status: {_eq: "published"}}}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useSelectTradeFieldQuery__
 *
 * To run a query within a React component, call `useSelectTradeFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectTradeFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectTradeFieldQuery({
 *   variables: {
 *      bilikZoneId: // value for 'bilikZoneId'
 *   },
 * });
 */
export function useSelectTradeFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectTradeFieldQuery, SelectTradeFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectTradeFieldQuery, SelectTradeFieldQueryVariables>(SelectTradeFieldDocument, options);
      }
export function useSelectTradeFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectTradeFieldQuery, SelectTradeFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectTradeFieldQuery, SelectTradeFieldQueryVariables>(SelectTradeFieldDocument, options);
        }
export type SelectTradeFieldQueryHookResult = ReturnType<typeof useSelectTradeFieldQuery>;
export type SelectTradeFieldLazyQueryHookResult = ReturnType<typeof useSelectTradeFieldLazyQuery>;
export type SelectTradeFieldQueryResult = ApolloReactCommon.QueryResult<SelectTradeFieldQuery, SelectTradeFieldQueryVariables>;
export const SelectTradeGroupFieldDocument = gql`
    query selectTradeGroupField($order_by: [TradeGroupOrderBy!], $where: TradeGroupBoolExp) {
  tradeGroup(orderBy: $order_by, where: $where) {
    id
    name
  }
}
    `;

/**
 * __useSelectTradeGroupFieldQuery__
 *
 * To run a query within a React component, call `useSelectTradeGroupFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectTradeGroupFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectTradeGroupFieldQuery({
 *   variables: {
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSelectTradeGroupFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelectTradeGroupFieldQuery, SelectTradeGroupFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectTradeGroupFieldQuery, SelectTradeGroupFieldQueryVariables>(SelectTradeGroupFieldDocument, options);
      }
export function useSelectTradeGroupFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectTradeGroupFieldQuery, SelectTradeGroupFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectTradeGroupFieldQuery, SelectTradeGroupFieldQueryVariables>(SelectTradeGroupFieldDocument, options);
        }
export type SelectTradeGroupFieldQueryHookResult = ReturnType<typeof useSelectTradeGroupFieldQuery>;
export type SelectTradeGroupFieldLazyQueryHookResult = ReturnType<typeof useSelectTradeGroupFieldLazyQuery>;
export type SelectTradeGroupFieldQueryResult = ApolloReactCommon.QueryResult<SelectTradeGroupFieldQuery, SelectTradeGroupFieldQueryVariables>;
export const SelectZohoOrganizationFieldDocument = gql`
    query selectZohoOrganizationField {
  zohoOrganization {
    id
    organizationId
    name
  }
}
    `;

/**
 * __useSelectZohoOrganizationFieldQuery__
 *
 * To run a query within a React component, call `useSelectZohoOrganizationFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectZohoOrganizationFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectZohoOrganizationFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectZohoOrganizationFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelectZohoOrganizationFieldQuery, SelectZohoOrganizationFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectZohoOrganizationFieldQuery, SelectZohoOrganizationFieldQueryVariables>(SelectZohoOrganizationFieldDocument, options);
      }
export function useSelectZohoOrganizationFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectZohoOrganizationFieldQuery, SelectZohoOrganizationFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectZohoOrganizationFieldQuery, SelectZohoOrganizationFieldQueryVariables>(SelectZohoOrganizationFieldDocument, options);
        }
export type SelectZohoOrganizationFieldQueryHookResult = ReturnType<typeof useSelectZohoOrganizationFieldQuery>;
export type SelectZohoOrganizationFieldLazyQueryHookResult = ReturnType<typeof useSelectZohoOrganizationFieldLazyQuery>;
export type SelectZohoOrganizationFieldQueryResult = ApolloReactCommon.QueryResult<SelectZohoOrganizationFieldQuery, SelectZohoOrganizationFieldQueryVariables>;
export const DeleteSlugRedirectbyIdsDocument = gql`
    mutation deleteSlugRedirectbyIds($ids: [Int!]!) {
  deleteSlugRedirect(where: {id: {_in: $ids}}) {
    affectedRows
  }
}
    `;
export type DeleteSlugRedirectbyIdsMutationFn = ApolloReactCommon.MutationFunction<DeleteSlugRedirectbyIdsMutation, DeleteSlugRedirectbyIdsMutationVariables>;

/**
 * __useDeleteSlugRedirectbyIdsMutation__
 *
 * To run a mutation, you first call `useDeleteSlugRedirectbyIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSlugRedirectbyIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSlugRedirectbyIdsMutation, { data, loading, error }] = useDeleteSlugRedirectbyIdsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteSlugRedirectbyIdsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSlugRedirectbyIdsMutation, DeleteSlugRedirectbyIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSlugRedirectbyIdsMutation, DeleteSlugRedirectbyIdsMutationVariables>(DeleteSlugRedirectbyIdsDocument, options);
      }
export type DeleteSlugRedirectbyIdsMutationHookResult = ReturnType<typeof useDeleteSlugRedirectbyIdsMutation>;
export type DeleteSlugRedirectbyIdsMutationResult = ApolloReactCommon.MutationResult<DeleteSlugRedirectbyIdsMutation>;
export type DeleteSlugRedirectbyIdsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteSlugRedirectbyIdsMutation, DeleteSlugRedirectbyIdsMutationVariables>;
export const PiBouncedSolicitationUpdateMutationDocument = gql`
    mutation piBouncedSolicitationUpdateMutation($solicitationId: Int!, $solicitation: SolicitationSetInput!) {
  updateSolicitationByPk(pkColumns: {id: $solicitationId}, _set: $solicitation) {
    email
  }
}
    `;
export type PiBouncedSolicitationUpdateMutationMutationFn = ApolloReactCommon.MutationFunction<PiBouncedSolicitationUpdateMutation, PiBouncedSolicitationUpdateMutationVariables>;

/**
 * __usePiBouncedSolicitationUpdateMutation__
 *
 * To run a mutation, you first call `usePiBouncedSolicitationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePiBouncedSolicitationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [piBouncedSolicitationUpdateMutation, { data, loading, error }] = usePiBouncedSolicitationUpdateMutation({
 *   variables: {
 *      solicitationId: // value for 'solicitationId'
 *      solicitation: // value for 'solicitation'
 *   },
 * });
 */
export function usePiBouncedSolicitationUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PiBouncedSolicitationUpdateMutation, PiBouncedSolicitationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PiBouncedSolicitationUpdateMutation, PiBouncedSolicitationUpdateMutationVariables>(PiBouncedSolicitationUpdateMutationDocument, options);
      }
export type PiBouncedSolicitationUpdateMutationHookResult = ReturnType<typeof usePiBouncedSolicitationUpdateMutation>;
export type PiBouncedSolicitationUpdateMutationMutationResult = ApolloReactCommon.MutationResult<PiBouncedSolicitationUpdateMutation>;
export type PiBouncedSolicitationUpdateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<PiBouncedSolicitationUpdateMutation, PiBouncedSolicitationUpdateMutationVariables>;
export const SolicitationAutorespondToggleMutationDocument = gql`
    mutation solicitationAutorespondToggleMutation($isAutorespondActive: Boolean!, $id: Int!) {
  updateSolicitationByPk(
    _set: {isAutorespondActive: $isAutorespondActive}
    pkColumns: {id: $id}
  ) {
    id
    email
    telephone
    isAutorespondActive
    proView {
      proPresentation {
        name
        mainTradeNames
      }
      bilikZone {
        mainCityCode
      }
    }
  }
}
    `;
export type SolicitationAutorespondToggleMutationMutationFn = ApolloReactCommon.MutationFunction<SolicitationAutorespondToggleMutation, SolicitationAutorespondToggleMutationVariables>;

/**
 * __useSolicitationAutorespondToggleMutation__
 *
 * To run a mutation, you first call `useSolicitationAutorespondToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolicitationAutorespondToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solicitationAutorespondToggleMutation, { data, loading, error }] = useSolicitationAutorespondToggleMutation({
 *   variables: {
 *      isAutorespondActive: // value for 'isAutorespondActive'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSolicitationAutorespondToggleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SolicitationAutorespondToggleMutation, SolicitationAutorespondToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SolicitationAutorespondToggleMutation, SolicitationAutorespondToggleMutationVariables>(SolicitationAutorespondToggleMutationDocument, options);
      }
export type SolicitationAutorespondToggleMutationHookResult = ReturnType<typeof useSolicitationAutorespondToggleMutation>;
export type SolicitationAutorespondToggleMutationMutationResult = ApolloReactCommon.MutationResult<SolicitationAutorespondToggleMutation>;
export type SolicitationAutorespondToggleMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SolicitationAutorespondToggleMutation, SolicitationAutorespondToggleMutationVariables>;
export const SolicitationAutorespondToggleQueryDocument = gql`
    query solicitationAutorespondToggleQuery($id: Int!) {
  solicitationByPk(id: $id) {
    id
    isAutorespondActive
    proReviewId
    declinedBy
    proView {
      status
    }
  }
}
    `;

/**
 * __useSolicitationAutorespondToggleQuery__
 *
 * To run a query within a React component, call `useSolicitationAutorespondToggleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitationAutorespondToggleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitationAutorespondToggleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSolicitationAutorespondToggleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SolicitationAutorespondToggleQuery, SolicitationAutorespondToggleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SolicitationAutorespondToggleQuery, SolicitationAutorespondToggleQueryVariables>(SolicitationAutorespondToggleQueryDocument, options);
      }
export function useSolicitationAutorespondToggleQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SolicitationAutorespondToggleQuery, SolicitationAutorespondToggleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SolicitationAutorespondToggleQuery, SolicitationAutorespondToggleQueryVariables>(SolicitationAutorespondToggleQueryDocument, options);
        }
export type SolicitationAutorespondToggleQueryHookResult = ReturnType<typeof useSolicitationAutorespondToggleQuery>;
export type SolicitationAutorespondToggleQueryLazyQueryHookResult = ReturnType<typeof useSolicitationAutorespondToggleQueryLazyQuery>;
export type SolicitationAutorespondToggleQueryQueryResult = ApolloReactCommon.QueryResult<SolicitationAutorespondToggleQuery, SolicitationAutorespondToggleQueryVariables>;
export const SolicitationsTableGloballyBlockedByIdentifierDocument = gql`
    query solicitationsTableGloballyBlockedByIdentifier($identifier: String) {
  globallyBlockedIdentity(where: {identifier: {_eq: $identifier}}) {
    identifier
  }
}
    `;

/**
 * __useSolicitationsTableGloballyBlockedByIdentifierQuery__
 *
 * To run a query within a React component, call `useSolicitationsTableGloballyBlockedByIdentifierQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitationsTableGloballyBlockedByIdentifierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitationsTableGloballyBlockedByIdentifierQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useSolicitationsTableGloballyBlockedByIdentifierQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SolicitationsTableGloballyBlockedByIdentifierQuery, SolicitationsTableGloballyBlockedByIdentifierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SolicitationsTableGloballyBlockedByIdentifierQuery, SolicitationsTableGloballyBlockedByIdentifierQueryVariables>(SolicitationsTableGloballyBlockedByIdentifierDocument, options);
      }
export function useSolicitationsTableGloballyBlockedByIdentifierLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SolicitationsTableGloballyBlockedByIdentifierQuery, SolicitationsTableGloballyBlockedByIdentifierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SolicitationsTableGloballyBlockedByIdentifierQuery, SolicitationsTableGloballyBlockedByIdentifierQueryVariables>(SolicitationsTableGloballyBlockedByIdentifierDocument, options);
        }
export type SolicitationsTableGloballyBlockedByIdentifierQueryHookResult = ReturnType<typeof useSolicitationsTableGloballyBlockedByIdentifierQuery>;
export type SolicitationsTableGloballyBlockedByIdentifierLazyQueryHookResult = ReturnType<typeof useSolicitationsTableGloballyBlockedByIdentifierLazyQuery>;
export type SolicitationsTableGloballyBlockedByIdentifierQueryResult = ApolloReactCommon.QueryResult<SolicitationsTableGloballyBlockedByIdentifierQuery, SolicitationsTableGloballyBlockedByIdentifierQueryVariables>;
export const SolicitationsTableGloballyBlockedDocument = gql`
    query solicitationsTableGloballyBlocked {
  globallyBlockedIdentity {
    identifier
  }
}
    `;

/**
 * __useSolicitationsTableGloballyBlockedQuery__
 *
 * To run a query within a React component, call `useSolicitationsTableGloballyBlockedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitationsTableGloballyBlockedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitationsTableGloballyBlockedQuery({
 *   variables: {
 *   },
 * });
 */
export function useSolicitationsTableGloballyBlockedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SolicitationsTableGloballyBlockedQuery, SolicitationsTableGloballyBlockedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SolicitationsTableGloballyBlockedQuery, SolicitationsTableGloballyBlockedQueryVariables>(SolicitationsTableGloballyBlockedDocument, options);
      }
export function useSolicitationsTableGloballyBlockedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SolicitationsTableGloballyBlockedQuery, SolicitationsTableGloballyBlockedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SolicitationsTableGloballyBlockedQuery, SolicitationsTableGloballyBlockedQueryVariables>(SolicitationsTableGloballyBlockedDocument, options);
        }
export type SolicitationsTableGloballyBlockedQueryHookResult = ReturnType<typeof useSolicitationsTableGloballyBlockedQuery>;
export type SolicitationsTableGloballyBlockedLazyQueryHookResult = ReturnType<typeof useSolicitationsTableGloballyBlockedLazyQuery>;
export type SolicitationsTableGloballyBlockedQueryResult = ApolloReactCommon.QueryResult<SolicitationsTableGloballyBlockedQuery, SolicitationsTableGloballyBlockedQueryVariables>;
export const SolicitationsTableQueryDocument = gql`
    query solicitationsTableQuery($limit: Int, $offset: Int, $order_by: [SolicitationOrderBy!], $where: SolicitationBoolExp) {
  solicitation(limit: $limit, offset: $offset, orderBy: $order_by, where: $where) {
    id
    uuid
    ip
    givenName
    familyName
    telephone
    email
    subject
    message
    addressLocality
    isSpam
    dateCreated
    declinedBy
    declineReason
    bounceEntity
    delay
    configuration
    lastResponseDate
    source
    proReview {
      id
    }
    proView {
      id
      status
      emailTarget
      bilikZone {
        id
        mainCityCode
      }
      proPeople {
        proPerson {
          id
          givenName
          familyName
        }
      }
      proPresentation {
        id
        name
        slug
        mainTradeNames
      }
    }
  }
}
    `;

/**
 * __useSolicitationsTableQuery__
 *
 * To run a query within a React component, call `useSolicitationsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitationsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitationsTableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSolicitationsTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SolicitationsTableQuery, SolicitationsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SolicitationsTableQuery, SolicitationsTableQueryVariables>(SolicitationsTableQueryDocument, options);
      }
export function useSolicitationsTableQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SolicitationsTableQuery, SolicitationsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SolicitationsTableQuery, SolicitationsTableQueryVariables>(SolicitationsTableQueryDocument, options);
        }
export type SolicitationsTableQueryHookResult = ReturnType<typeof useSolicitationsTableQuery>;
export type SolicitationsTableQueryLazyQueryHookResult = ReturnType<typeof useSolicitationsTableQueryLazyQuery>;
export type SolicitationsTableQueryQueryResult = ApolloReactCommon.QueryResult<SolicitationsTableQuery, SolicitationsTableQueryVariables>;
export const StopSmsCreateMutationDocument = gql`
    mutation stopSmsCreateMutation($object: StopSmsInsertInput!) {
  insertStopSmsOne(object: $object) {
    id
    telephone
    dateCreated
  }
}
    `;
export type StopSmsCreateMutationMutationFn = ApolloReactCommon.MutationFunction<StopSmsCreateMutation, StopSmsCreateMutationVariables>;

/**
 * __useStopSmsCreateMutation__
 *
 * To run a mutation, you first call `useStopSmsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopSmsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopSmsCreateMutation, { data, loading, error }] = useStopSmsCreateMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useStopSmsCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StopSmsCreateMutation, StopSmsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopSmsCreateMutation, StopSmsCreateMutationVariables>(StopSmsCreateMutationDocument, options);
      }
export type StopSmsCreateMutationHookResult = ReturnType<typeof useStopSmsCreateMutation>;
export type StopSmsCreateMutationMutationResult = ApolloReactCommon.MutationResult<StopSmsCreateMutation>;
export type StopSmsCreateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<StopSmsCreateMutation, StopSmsCreateMutationVariables>;
export const StopSmsDeleteMutationDocument = gql`
    mutation StopSmsDeleteMutation($telephone: String!) {
  deleteStopSms(where: {telephone: {_eq: $telephone}}) {
    returning {
      id
      telephone
      dateCreated
    }
  }
}
    `;
export type StopSmsDeleteMutationMutationFn = ApolloReactCommon.MutationFunction<StopSmsDeleteMutation, StopSmsDeleteMutationVariables>;

/**
 * __useStopSmsDeleteMutation__
 *
 * To run a mutation, you first call `useStopSmsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopSmsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopSmsDeleteMutation, { data, loading, error }] = useStopSmsDeleteMutation({
 *   variables: {
 *      telephone: // value for 'telephone'
 *   },
 * });
 */
export function useStopSmsDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StopSmsDeleteMutation, StopSmsDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopSmsDeleteMutation, StopSmsDeleteMutationVariables>(StopSmsDeleteMutationDocument, options);
      }
export type StopSmsDeleteMutationHookResult = ReturnType<typeof useStopSmsDeleteMutation>;
export type StopSmsDeleteMutationMutationResult = ApolloReactCommon.MutationResult<StopSmsDeleteMutation>;
export type StopSmsDeleteMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<StopSmsDeleteMutation, StopSmsDeleteMutationVariables>;
export const StopSmsDocument = gql`
    query StopSms($telephones: [String!]) {
  stopSms(where: {telephone: {_in: $telephones}}) {
    id
    telephone
    dateCreated
  }
}
    `;

/**
 * __useStopSmsQuery__
 *
 * To run a query within a React component, call `useStopSmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStopSmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStopSmsQuery({
 *   variables: {
 *      telephones: // value for 'telephones'
 *   },
 * });
 */
export function useStopSmsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StopSmsQuery, StopSmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StopSmsQuery, StopSmsQueryVariables>(StopSmsDocument, options);
      }
export function useStopSmsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StopSmsQuery, StopSmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StopSmsQuery, StopSmsQueryVariables>(StopSmsDocument, options);
        }
export type StopSmsQueryHookResult = ReturnType<typeof useStopSmsQuery>;
export type StopSmsLazyQueryHookResult = ReturnType<typeof useStopSmsLazyQuery>;
export type StopSmsQueryResult = ApolloReactCommon.QueryResult<StopSmsQuery, StopSmsQueryVariables>;
export const TimelinePrivateIndividualQueryDocument = gql`
    query timelinePrivateIndividualQuery($value: String!) {
  timelinePrivateIndividual(
    where: {_or: [{email: {_eq: $value}}, {telephone: {_eq: $value}}]}
  ) {
    email
    telephone
    givenName
    familyName
    addressLocality
  }
}
    `;

/**
 * __useTimelinePrivateIndividualQuery__
 *
 * To run a query within a React component, call `useTimelinePrivateIndividualQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelinePrivateIndividualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelinePrivateIndividualQuery({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useTimelinePrivateIndividualQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimelinePrivateIndividualQuery, TimelinePrivateIndividualQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimelinePrivateIndividualQuery, TimelinePrivateIndividualQueryVariables>(TimelinePrivateIndividualQueryDocument, options);
      }
export function useTimelinePrivateIndividualQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimelinePrivateIndividualQuery, TimelinePrivateIndividualQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimelinePrivateIndividualQuery, TimelinePrivateIndividualQueryVariables>(TimelinePrivateIndividualQueryDocument, options);
        }
export type TimelinePrivateIndividualQueryHookResult = ReturnType<typeof useTimelinePrivateIndividualQuery>;
export type TimelinePrivateIndividualQueryLazyQueryHookResult = ReturnType<typeof useTimelinePrivateIndividualQueryLazyQuery>;
export type TimelinePrivateIndividualQueryQueryResult = ApolloReactCommon.QueryResult<TimelinePrivateIndividualQuery, TimelinePrivateIndividualQueryVariables>;
export const GetBilikPersonByContactInfoQueryDocument = gql`
    query getBilikPersonByContactInfoQuery($value: String!) {
  bilikPerson(
    where: {_or: [{telephone: {_eq: $value}}, {email: {_eq: $value}}, {managedBilikZones: {bilikZone: {telephone: {_eq: $value}}}}, {managedBilikZones: {bilikZone: {genericEmail: {_eq: $value}}}}]}
  ) {
    telephone
  }
}
    `;

/**
 * __useGetBilikPersonByContactInfoQuery__
 *
 * To run a query within a React component, call `useGetBilikPersonByContactInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBilikPersonByContactInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBilikPersonByContactInfoQuery({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useGetBilikPersonByContactInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBilikPersonByContactInfoQuery, GetBilikPersonByContactInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBilikPersonByContactInfoQuery, GetBilikPersonByContactInfoQueryVariables>(GetBilikPersonByContactInfoQueryDocument, options);
      }
export function useGetBilikPersonByContactInfoQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBilikPersonByContactInfoQuery, GetBilikPersonByContactInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBilikPersonByContactInfoQuery, GetBilikPersonByContactInfoQueryVariables>(GetBilikPersonByContactInfoQueryDocument, options);
        }
export type GetBilikPersonByContactInfoQueryHookResult = ReturnType<typeof useGetBilikPersonByContactInfoQuery>;
export type GetBilikPersonByContactInfoQueryLazyQueryHookResult = ReturnType<typeof useGetBilikPersonByContactInfoQueryLazyQuery>;
export type GetBilikPersonByContactInfoQueryQueryResult = ApolloReactCommon.QueryResult<GetBilikPersonByContactInfoQuery, GetBilikPersonByContactInfoQueryVariables>;
export const GloballyBlockedIdentityDocument = gql`
    query globallyBlockedIdentity($identifier: String!) {
  globallyBlockedIdentity(where: {identifier: {_eq: $identifier}}) {
    identifier
  }
}
    `;

/**
 * __useGloballyBlockedIdentityQuery__
 *
 * To run a query within a React component, call `useGloballyBlockedIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGloballyBlockedIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGloballyBlockedIdentityQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGloballyBlockedIdentityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GloballyBlockedIdentityQuery, GloballyBlockedIdentityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GloballyBlockedIdentityQuery, GloballyBlockedIdentityQueryVariables>(GloballyBlockedIdentityDocument, options);
      }
export function useGloballyBlockedIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GloballyBlockedIdentityQuery, GloballyBlockedIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GloballyBlockedIdentityQuery, GloballyBlockedIdentityQueryVariables>(GloballyBlockedIdentityDocument, options);
        }
export type GloballyBlockedIdentityQueryHookResult = ReturnType<typeof useGloballyBlockedIdentityQuery>;
export type GloballyBlockedIdentityLazyQueryHookResult = ReturnType<typeof useGloballyBlockedIdentityLazyQuery>;
export type GloballyBlockedIdentityQueryResult = ApolloReactCommon.QueryResult<GloballyBlockedIdentityQuery, GloballyBlockedIdentityQueryVariables>;
export const TradeFieldsSuggestionsDocument = gql`
    query tradeFieldsSuggestions($tradeIds: [Int!]!, $mainTradeIds: [Int!]!) {
  mainTrades: trade(where: {id: {_in: $mainTradeIds}}) {
    name
  }
  possibleTradeGuides: tradeGuide(where: {trades: {tradeId: {_in: $tradeIds}}}) {
    name
    trades {
      trade {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useTradeFieldsSuggestionsQuery__
 *
 * To run a query within a React component, call `useTradeFieldsSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeFieldsSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeFieldsSuggestionsQuery({
 *   variables: {
 *      tradeIds: // value for 'tradeIds'
 *      mainTradeIds: // value for 'mainTradeIds'
 *   },
 * });
 */
export function useTradeFieldsSuggestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradeFieldsSuggestionsQuery, TradeFieldsSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradeFieldsSuggestionsQuery, TradeFieldsSuggestionsQueryVariables>(TradeFieldsSuggestionsDocument, options);
      }
export function useTradeFieldsSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeFieldsSuggestionsQuery, TradeFieldsSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradeFieldsSuggestionsQuery, TradeFieldsSuggestionsQueryVariables>(TradeFieldsSuggestionsDocument, options);
        }
export type TradeFieldsSuggestionsQueryHookResult = ReturnType<typeof useTradeFieldsSuggestionsQuery>;
export type TradeFieldsSuggestionsLazyQueryHookResult = ReturnType<typeof useTradeFieldsSuggestionsLazyQuery>;
export type TradeFieldsSuggestionsQueryResult = ApolloReactCommon.QueryResult<TradeFieldsSuggestionsQuery, TradeFieldsSuggestionsQueryVariables>;
export const TradeGroupSearchFilterDefaultQueryDocument = gql`
    query tradeGroupSearchFilterDefaultQuery($id: Int!) {
  tradeGroupByPk(id: $id) {
    name
  }
}
    `;

/**
 * __useTradeGroupSearchFilterDefaultQuery__
 *
 * To run a query within a React component, call `useTradeGroupSearchFilterDefaultQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeGroupSearchFilterDefaultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeGroupSearchFilterDefaultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTradeGroupSearchFilterDefaultQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradeGroupSearchFilterDefaultQuery, TradeGroupSearchFilterDefaultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradeGroupSearchFilterDefaultQuery, TradeGroupSearchFilterDefaultQueryVariables>(TradeGroupSearchFilterDefaultQueryDocument, options);
      }
export function useTradeGroupSearchFilterDefaultQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeGroupSearchFilterDefaultQuery, TradeGroupSearchFilterDefaultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradeGroupSearchFilterDefaultQuery, TradeGroupSearchFilterDefaultQueryVariables>(TradeGroupSearchFilterDefaultQueryDocument, options);
        }
export type TradeGroupSearchFilterDefaultQueryHookResult = ReturnType<typeof useTradeGroupSearchFilterDefaultQuery>;
export type TradeGroupSearchFilterDefaultQueryLazyQueryHookResult = ReturnType<typeof useTradeGroupSearchFilterDefaultQueryLazyQuery>;
export type TradeGroupSearchFilterDefaultQueryQueryResult = ApolloReactCommon.QueryResult<TradeGroupSearchFilterDefaultQuery, TradeGroupSearchFilterDefaultQueryVariables>;
export const TradeGroupSearchFilterQueryDocument = gql`
    query tradeGroupSearchFilterQuery($criteria: String) {
  searchTradeGroup(args: {search: $criteria}) {
    id
    name
  }
}
    `;

/**
 * __useTradeGroupSearchFilterQuery__
 *
 * To run a query within a React component, call `useTradeGroupSearchFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeGroupSearchFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeGroupSearchFilterQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useTradeGroupSearchFilterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TradeGroupSearchFilterQuery, TradeGroupSearchFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradeGroupSearchFilterQuery, TradeGroupSearchFilterQueryVariables>(TradeGroupSearchFilterQueryDocument, options);
      }
export function useTradeGroupSearchFilterQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeGroupSearchFilterQuery, TradeGroupSearchFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradeGroupSearchFilterQuery, TradeGroupSearchFilterQueryVariables>(TradeGroupSearchFilterQueryDocument, options);
        }
export type TradeGroupSearchFilterQueryHookResult = ReturnType<typeof useTradeGroupSearchFilterQuery>;
export type TradeGroupSearchFilterQueryLazyQueryHookResult = ReturnType<typeof useTradeGroupSearchFilterQueryLazyQuery>;
export type TradeGroupSearchFilterQueryQueryResult = ApolloReactCommon.QueryResult<TradeGroupSearchFilterQuery, TradeGroupSearchFilterQueryVariables>;
export const TradeSearchFilterDefaultQueryDocument = gql`
    query tradeSearchFilterDefaultQuery($id: Int!) {
  tradeByPk(id: $id) {
    name
  }
}
    `;

/**
 * __useTradeSearchFilterDefaultQuery__
 *
 * To run a query within a React component, call `useTradeSearchFilterDefaultQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeSearchFilterDefaultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeSearchFilterDefaultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTradeSearchFilterDefaultQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradeSearchFilterDefaultQuery, TradeSearchFilterDefaultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradeSearchFilterDefaultQuery, TradeSearchFilterDefaultQueryVariables>(TradeSearchFilterDefaultQueryDocument, options);
      }
export function useTradeSearchFilterDefaultQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeSearchFilterDefaultQuery, TradeSearchFilterDefaultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradeSearchFilterDefaultQuery, TradeSearchFilterDefaultQueryVariables>(TradeSearchFilterDefaultQueryDocument, options);
        }
export type TradeSearchFilterDefaultQueryHookResult = ReturnType<typeof useTradeSearchFilterDefaultQuery>;
export type TradeSearchFilterDefaultQueryLazyQueryHookResult = ReturnType<typeof useTradeSearchFilterDefaultQueryLazyQuery>;
export type TradeSearchFilterDefaultQueryQueryResult = ApolloReactCommon.QueryResult<TradeSearchFilterDefaultQuery, TradeSearchFilterDefaultQueryVariables>;
export const TradeSearchFilterQueryDocument = gql`
    query tradeSearchFilterQuery($criteria: String) {
  searchTrade(args: {search: $criteria}) {
    id
    name
  }
}
    `;

/**
 * __useTradeSearchFilterQuery__
 *
 * To run a query within a React component, call `useTradeSearchFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeSearchFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeSearchFilterQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useTradeSearchFilterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TradeSearchFilterQuery, TradeSearchFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradeSearchFilterQuery, TradeSearchFilterQueryVariables>(TradeSearchFilterQueryDocument, options);
      }
export function useTradeSearchFilterQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeSearchFilterQuery, TradeSearchFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradeSearchFilterQuery, TradeSearchFilterQueryVariables>(TradeSearchFilterQueryDocument, options);
        }
export type TradeSearchFilterQueryHookResult = ReturnType<typeof useTradeSearchFilterQuery>;
export type TradeSearchFilterQueryLazyQueryHookResult = ReturnType<typeof useTradeSearchFilterQueryLazyQuery>;
export type TradeSearchFilterQueryQueryResult = ApolloReactCommon.QueryResult<TradeSearchFilterQuery, TradeSearchFilterQueryVariables>;
export const CurrentBilikZonesDocument = gql`
    query currentBilikZones($ids: [Int!]!) {
  bilikZone(where: {id: {_in: $ids}}) {
    id
    mainCityCode
    name
    slug
    telephone
    managers {
      bilikPerson {
        id
        givenName
        familyName
      }
    }
  }
}
    `;

/**
 * __useCurrentBilikZonesQuery__
 *
 * To run a query within a React component, call `useCurrentBilikZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBilikZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBilikZonesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCurrentBilikZonesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CurrentBilikZonesQuery, CurrentBilikZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentBilikZonesQuery, CurrentBilikZonesQueryVariables>(CurrentBilikZonesDocument, options);
      }
export function useCurrentBilikZonesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentBilikZonesQuery, CurrentBilikZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentBilikZonesQuery, CurrentBilikZonesQueryVariables>(CurrentBilikZonesDocument, options);
        }
export type CurrentBilikZonesQueryHookResult = ReturnType<typeof useCurrentBilikZonesQuery>;
export type CurrentBilikZonesLazyQueryHookResult = ReturnType<typeof useCurrentBilikZonesLazyQuery>;
export type CurrentBilikZonesQueryResult = ApolloReactCommon.QueryResult<CurrentBilikZonesQuery, CurrentBilikZonesQueryVariables>;
export const CurrentBilikPersonQueryDocument = gql`
    query currentBilikPersonQuery($authUserId: uuid!) {
  bilikPerson(where: {authUserId: {_eq: $authUserId}}, limit: 1) {
    id
    familyName
    givenName
    avatarHash
    roleName
    telephone
    email
  }
}
    `;

/**
 * __useCurrentBilikPersonQuery__
 *
 * To run a query within a React component, call `useCurrentBilikPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBilikPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBilikPersonQuery({
 *   variables: {
 *      authUserId: // value for 'authUserId'
 *   },
 * });
 */
export function useCurrentBilikPersonQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CurrentBilikPersonQuery, CurrentBilikPersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentBilikPersonQuery, CurrentBilikPersonQueryVariables>(CurrentBilikPersonQueryDocument, options);
      }
export function useCurrentBilikPersonQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentBilikPersonQuery, CurrentBilikPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentBilikPersonQuery, CurrentBilikPersonQueryVariables>(CurrentBilikPersonQueryDocument, options);
        }
export type CurrentBilikPersonQueryHookResult = ReturnType<typeof useCurrentBilikPersonQuery>;
export type CurrentBilikPersonQueryLazyQueryHookResult = ReturnType<typeof useCurrentBilikPersonQueryLazyQuery>;
export type CurrentBilikPersonQueryQueryResult = ApolloReactCommon.QueryResult<CurrentBilikPersonQuery, CurrentBilikPersonQueryVariables>;
export const ProReviewInvitationsCountDocument = gql`
    query proReviewInvitationsCount($where: ProReviewInvitationBoolExp) {
  proReviewInvitationAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useProReviewInvitationsCountQuery__
 *
 * To run a query within a React component, call `useProReviewInvitationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewInvitationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewInvitationsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProReviewInvitationsCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProReviewInvitationsCountQuery, ProReviewInvitationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewInvitationsCountQuery, ProReviewInvitationsCountQueryVariables>(ProReviewInvitationsCountDocument, options);
      }
export function useProReviewInvitationsCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewInvitationsCountQuery, ProReviewInvitationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewInvitationsCountQuery, ProReviewInvitationsCountQueryVariables>(ProReviewInvitationsCountDocument, options);
        }
export type ProReviewInvitationsCountQueryHookResult = ReturnType<typeof useProReviewInvitationsCountQuery>;
export type ProReviewInvitationsCountLazyQueryHookResult = ReturnType<typeof useProReviewInvitationsCountLazyQuery>;
export type ProReviewInvitationsCountQueryResult = ApolloReactCommon.QueryResult<ProReviewInvitationsCountQuery, ProReviewInvitationsCountQueryVariables>;
export const ProReviewsCountQueryDocument = gql`
    query proReviewsCountQuery($where: ProReviewBoolExp) {
  proReviewAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useProReviewsCountQuery__
 *
 * To run a query within a React component, call `useProReviewsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProReviewsCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProReviewsCountQuery, ProReviewsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewsCountQuery, ProReviewsCountQueryVariables>(ProReviewsCountQueryDocument, options);
      }
export function useProReviewsCountQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewsCountQuery, ProReviewsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewsCountQuery, ProReviewsCountQueryVariables>(ProReviewsCountQueryDocument, options);
        }
export type ProReviewsCountQueryHookResult = ReturnType<typeof useProReviewsCountQuery>;
export type ProReviewsCountQueryLazyQueryHookResult = ReturnType<typeof useProReviewsCountQueryLazyQuery>;
export type ProReviewsCountQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewsCountQuery, ProReviewsCountQueryVariables>;
export const ProViewPublishedCountByMonthQueryDocument = gql`
    query proViewPublishedCountByMonthQuery($where: ProViewBoolExp) {
  proView(where: $where) {
    datePublished
    dateArchived
  }
}
    `;

/**
 * __useProViewPublishedCountByMonthQuery__
 *
 * To run a query within a React component, call `useProViewPublishedCountByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useProViewPublishedCountByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProViewPublishedCountByMonthQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProViewPublishedCountByMonthQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProViewPublishedCountByMonthQuery, ProViewPublishedCountByMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProViewPublishedCountByMonthQuery, ProViewPublishedCountByMonthQueryVariables>(ProViewPublishedCountByMonthQueryDocument, options);
      }
export function useProViewPublishedCountByMonthQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProViewPublishedCountByMonthQuery, ProViewPublishedCountByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProViewPublishedCountByMonthQuery, ProViewPublishedCountByMonthQueryVariables>(ProViewPublishedCountByMonthQueryDocument, options);
        }
export type ProViewPublishedCountByMonthQueryHookResult = ReturnType<typeof useProViewPublishedCountByMonthQuery>;
export type ProViewPublishedCountByMonthQueryLazyQueryHookResult = ReturnType<typeof useProViewPublishedCountByMonthQueryLazyQuery>;
export type ProViewPublishedCountByMonthQueryQueryResult = ApolloReactCommon.QueryResult<ProViewPublishedCountByMonthQuery, ProViewPublishedCountByMonthQueryVariables>;
export const ProViewsCountQueryDocument = gql`
    query proViewsCountQuery($criteria: String, $where: ProViewBoolExp) {
  searchProViewAggregate(args: {search: $criteria}, where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useProViewsCountQuery__
 *
 * To run a query within a React component, call `useProViewsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProViewsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProViewsCountQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProViewsCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProViewsCountQuery, ProViewsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProViewsCountQuery, ProViewsCountQueryVariables>(ProViewsCountQueryDocument, options);
      }
export function useProViewsCountQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProViewsCountQuery, ProViewsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProViewsCountQuery, ProViewsCountQueryVariables>(ProViewsCountQueryDocument, options);
        }
export type ProViewsCountQueryHookResult = ReturnType<typeof useProViewsCountQuery>;
export type ProViewsCountQueryLazyQueryHookResult = ReturnType<typeof useProViewsCountQueryLazyQuery>;
export type ProViewsCountQueryQueryResult = ApolloReactCommon.QueryResult<ProViewsCountQuery, ProViewsCountQueryVariables>;
export const SlugRedirectQueryDocument = gql`
    query slugRedirectQuery($fromslug: String!) {
  slugRedirect(where: {fromslug: {_eq: $fromslug}}) {
    id
    fromslug
    toslug
  }
}
    `;

/**
 * __useSlugRedirectQuery__
 *
 * To run a query within a React component, call `useSlugRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlugRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlugRedirectQuery({
 *   variables: {
 *      fromslug: // value for 'fromslug'
 *   },
 * });
 */
export function useSlugRedirectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SlugRedirectQuery, SlugRedirectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SlugRedirectQuery, SlugRedirectQueryVariables>(SlugRedirectQueryDocument, options);
      }
export function useSlugRedirectQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SlugRedirectQuery, SlugRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SlugRedirectQuery, SlugRedirectQueryVariables>(SlugRedirectQueryDocument, options);
        }
export type SlugRedirectQueryHookResult = ReturnType<typeof useSlugRedirectQuery>;
export type SlugRedirectQueryLazyQueryHookResult = ReturnType<typeof useSlugRedirectQueryLazyQuery>;
export type SlugRedirectQueryQueryResult = ApolloReactCommon.QueryResult<SlugRedirectQuery, SlugRedirectQueryVariables>;
export const SolicitationStatsCountDocument = gql`
    query SolicitationStatsCount($where: SolicitationStatBoolExp, $distinct: [SolicitationStatSelectColumn!]) {
  solicitationStatAggregate(where: $where, distinctOn: $distinct) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useSolicitationStatsCountQuery__
 *
 * To run a query within a React component, call `useSolicitationStatsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitationStatsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitationStatsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *      distinct: // value for 'distinct'
 *   },
 * });
 */
export function useSolicitationStatsCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SolicitationStatsCountQuery, SolicitationStatsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SolicitationStatsCountQuery, SolicitationStatsCountQueryVariables>(SolicitationStatsCountDocument, options);
      }
export function useSolicitationStatsCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SolicitationStatsCountQuery, SolicitationStatsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SolicitationStatsCountQuery, SolicitationStatsCountQueryVariables>(SolicitationStatsCountDocument, options);
        }
export type SolicitationStatsCountQueryHookResult = ReturnType<typeof useSolicitationStatsCountQuery>;
export type SolicitationStatsCountLazyQueryHookResult = ReturnType<typeof useSolicitationStatsCountLazyQuery>;
export type SolicitationStatsCountQueryResult = ApolloReactCommon.QueryResult<SolicitationStatsCountQuery, SolicitationStatsCountQueryVariables>;
export const SolicitationsCountDocument = gql`
    query SolicitationsCount($where: SolicitationBoolExp) {
  solicitationAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useSolicitationsCountQuery__
 *
 * To run a query within a React component, call `useSolicitationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitationsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSolicitationsCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SolicitationsCountQuery, SolicitationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SolicitationsCountQuery, SolicitationsCountQueryVariables>(SolicitationsCountDocument, options);
      }
export function useSolicitationsCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SolicitationsCountQuery, SolicitationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SolicitationsCountQuery, SolicitationsCountQueryVariables>(SolicitationsCountDocument, options);
        }
export type SolicitationsCountQueryHookResult = ReturnType<typeof useSolicitationsCountQuery>;
export type SolicitationsCountLazyQueryHookResult = ReturnType<typeof useSolicitationsCountLazyQuery>;
export type SolicitationsCountQueryResult = ApolloReactCommon.QueryResult<SolicitationsCountQuery, SolicitationsCountQueryVariables>;
export const ReviewCompanyPresentationsDocument = gql`
    query reviewCompanyPresentations($companyId: Int!) {
  proPresentation(where: {companyId: {_eq: $companyId}}, orderBy: {id: ASC}) {
    id
    name
    mainTradeNames
    proViews {
      id
      status
      bilikZone {
        id
        mainCityCode
      }
    }
  }
}
    `;

/**
 * __useReviewCompanyPresentationsQuery__
 *
 * To run a query within a React component, call `useReviewCompanyPresentationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewCompanyPresentationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewCompanyPresentationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useReviewCompanyPresentationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewCompanyPresentationsQuery, ReviewCompanyPresentationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewCompanyPresentationsQuery, ReviewCompanyPresentationsQueryVariables>(ReviewCompanyPresentationsDocument, options);
      }
export function useReviewCompanyPresentationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewCompanyPresentationsQuery, ReviewCompanyPresentationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewCompanyPresentationsQuery, ReviewCompanyPresentationsQueryVariables>(ReviewCompanyPresentationsDocument, options);
        }
export type ReviewCompanyPresentationsQueryHookResult = ReturnType<typeof useReviewCompanyPresentationsQuery>;
export type ReviewCompanyPresentationsLazyQueryHookResult = ReturnType<typeof useReviewCompanyPresentationsLazyQuery>;
export type ReviewCompanyPresentationsQueryResult = ApolloReactCommon.QueryResult<ReviewCompanyPresentationsQuery, ReviewCompanyPresentationsQueryVariables>;
export const QueryProReviewIsSpamByIdDocument = gql`
    query queryProReviewIsSpamById($id: Int!) {
  proReviewByPk(id: $id) {
    id
    email
    telephone
    referenceView {
      view {
        proPresentation {
          id
          name
          mainTradeNames
        }
      }
    }
  }
}
    `;

/**
 * __useQueryProReviewIsSpamByIdQuery__
 *
 * To run a query within a React component, call `useQueryProReviewIsSpamByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryProReviewIsSpamByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryProReviewIsSpamByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQueryProReviewIsSpamByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QueryProReviewIsSpamByIdQuery, QueryProReviewIsSpamByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QueryProReviewIsSpamByIdQuery, QueryProReviewIsSpamByIdQueryVariables>(QueryProReviewIsSpamByIdDocument, options);
      }
export function useQueryProReviewIsSpamByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QueryProReviewIsSpamByIdQuery, QueryProReviewIsSpamByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QueryProReviewIsSpamByIdQuery, QueryProReviewIsSpamByIdQueryVariables>(QueryProReviewIsSpamByIdDocument, options);
        }
export type QueryProReviewIsSpamByIdQueryHookResult = ReturnType<typeof useQueryProReviewIsSpamByIdQuery>;
export type QueryProReviewIsSpamByIdLazyQueryHookResult = ReturnType<typeof useQueryProReviewIsSpamByIdLazyQuery>;
export type QueryProReviewIsSpamByIdQueryResult = ApolloReactCommon.QueryResult<QueryProReviewIsSpamByIdQuery, QueryProReviewIsSpamByIdQueryVariables>;
export const ProReviewUpdateByPkDocument = gql`
    mutation proReviewUpdateByPk($lockerId: Int, $lockerDate: timestamptz, $proReviewId: Int!) {
  updateProReviewByPk(
    _set: {lockerId: $lockerId, lockDate: $lockerDate}
    pkColumns: {id: $proReviewId}
  ) {
    id
  }
}
    `;
export type ProReviewUpdateByPkMutationFn = ApolloReactCommon.MutationFunction<ProReviewUpdateByPkMutation, ProReviewUpdateByPkMutationVariables>;

/**
 * __useProReviewUpdateByPkMutation__
 *
 * To run a mutation, you first call `useProReviewUpdateByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProReviewUpdateByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proReviewUpdateByPkMutation, { data, loading, error }] = useProReviewUpdateByPkMutation({
 *   variables: {
 *      lockerId: // value for 'lockerId'
 *      lockerDate: // value for 'lockerDate'
 *      proReviewId: // value for 'proReviewId'
 *   },
 * });
 */
export function useProReviewUpdateByPkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProReviewUpdateByPkMutation, ProReviewUpdateByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProReviewUpdateByPkMutation, ProReviewUpdateByPkMutationVariables>(ProReviewUpdateByPkDocument, options);
      }
export type ProReviewUpdateByPkMutationHookResult = ReturnType<typeof useProReviewUpdateByPkMutation>;
export type ProReviewUpdateByPkMutationResult = ApolloReactCommon.MutationResult<ProReviewUpdateByPkMutation>;
export type ProReviewUpdateByPkMutationOptions = ApolloReactCommon.BaseMutationOptions<ProReviewUpdateByPkMutation, ProReviewUpdateByPkMutationVariables>;
export const ReviewLockerQueryDocument = gql`
    query reviewLockerQuery($proReviewId: Int!) {
  proReviewByPk(id: $proReviewId) {
    id
    lockerId
    lockDate
    locker {
      id
      givenName
      familyName
    }
  }
}
    `;

/**
 * __useReviewLockerQuery__
 *
 * To run a query within a React component, call `useReviewLockerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewLockerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewLockerQuery({
 *   variables: {
 *      proReviewId: // value for 'proReviewId'
 *   },
 * });
 */
export function useReviewLockerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewLockerQuery, ReviewLockerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewLockerQuery, ReviewLockerQueryVariables>(ReviewLockerQueryDocument, options);
      }
export function useReviewLockerQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewLockerQuery, ReviewLockerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewLockerQuery, ReviewLockerQueryVariables>(ReviewLockerQueryDocument, options);
        }
export type ReviewLockerQueryHookResult = ReturnType<typeof useReviewLockerQuery>;
export type ReviewLockerQueryLazyQueryHookResult = ReturnType<typeof useReviewLockerQueryLazyQuery>;
export type ReviewLockerQueryQueryResult = ApolloReactCommon.QueryResult<ReviewLockerQuery, ReviewLockerQueryVariables>;
export const PresentationReviewStatsQueryDocument = gql`
    query presentationReviewStatsQuery($presentationId: Int!) {
  averageRating: proReviewAggregate(
    where: {presentations: {presentationId: {_eq: $presentationId}}, status: {_eq: "ok"}, isSpam: {_eq: false}}
  ) {
    aggregate {
      avg {
        rating
      }
    }
  }
  latestReview: proReviewAggregate(
    where: {presentations: {presentationId: {_eq: $presentationId}}, isSpam: {_eq: false}}
  ) {
    aggregate {
      max {
        dateCreated
      }
    }
  }
}
    `;

/**
 * __usePresentationReviewStatsQuery__
 *
 * To run a query within a React component, call `usePresentationReviewStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresentationReviewStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresentationReviewStatsQuery({
 *   variables: {
 *      presentationId: // value for 'presentationId'
 *   },
 * });
 */
export function usePresentationReviewStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PresentationReviewStatsQuery, PresentationReviewStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PresentationReviewStatsQuery, PresentationReviewStatsQueryVariables>(PresentationReviewStatsQueryDocument, options);
      }
export function usePresentationReviewStatsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PresentationReviewStatsQuery, PresentationReviewStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PresentationReviewStatsQuery, PresentationReviewStatsQueryVariables>(PresentationReviewStatsQueryDocument, options);
        }
export type PresentationReviewStatsQueryHookResult = ReturnType<typeof usePresentationReviewStatsQuery>;
export type PresentationReviewStatsQueryLazyQueryHookResult = ReturnType<typeof usePresentationReviewStatsQueryLazyQuery>;
export type PresentationReviewStatsQueryQueryResult = ApolloReactCommon.QueryResult<PresentationReviewStatsQuery, PresentationReviewStatsQueryVariables>;
export const ReviewsQueryDocument = gql`
    query reviewsQuery($limit: Int, $offset: Int, $order_by: [ProReviewOrderBy!], $where: ProReviewBoolExp) {
  proReview(limit: $limit, offset: $offset, orderBy: $order_by, where: $where) {
    id
    status
    trustLevel
    reviewAspect
    reviewBody
    source
    refuseReason
    rating
    ratingType
    privateComment
    comment
    reply
    givenName
    familyName
    telephone
    email
    dateCreated
    addressLocality
    isSpam
    lastModifiedAt
    dateOfWork
    checkDate
    lockDate
    proofStatus
    replyStatus
    replyDate
    checker {
      id
      givenName
      familyName
    }
    locker {
      id
      givenName
      familyName
      email
    }
    originalProReviewId
    referenceView {
      view {
        id
        status
        bilikZone {
          id
          slug
          mainCityCode
        }
        proPresentation {
          id
          name
          slug
          mainTradeNames
          proViews {
            id
            status
            bilikZone {
              id
              slug
              mainCityCode
            }
          }
        }
      }
    }
    presentations {
      presentationId
      presentation {
        id
        name
        mainTradeNames
        companyId
        company {
          name
          proPresentationsAggregate {
            aggregate {
              count
            }
          }
        }
        proViews {
          id
          status
          bilikZone {
            id
            mainCityCode
          }
        }
      }
    }
    ip
    cityId
    city {
      id
      name
      postalCodes
      bilikZoneId
    }
  }
}
    `;

/**
 * __useReviewsQuery__
 *
 * To run a query within a React component, call `useReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useReviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReviewsQuery, ReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewsQuery, ReviewsQueryVariables>(ReviewsQueryDocument, options);
      }
export function useReviewsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewsQuery, ReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewsQuery, ReviewsQueryVariables>(ReviewsQueryDocument, options);
        }
export type ReviewsQueryHookResult = ReturnType<typeof useReviewsQuery>;
export type ReviewsQueryLazyQueryHookResult = ReturnType<typeof useReviewsQueryLazyQuery>;
export type ReviewsQueryQueryResult = ApolloReactCommon.QueryResult<ReviewsQuery, ReviewsQueryVariables>;
export const BilikPeopleTableQueryDocument = gql`
    query bilikPeopleTableQuery($limit: Int, $offset: Int, $order_by: [BilikPersonOrderBy!]) {
  bilikPerson(limit: $limit, offset: $offset, orderBy: $order_by) {
    id
    givenName
    familyName
    telephone
    roleName
    employmentDate
    status
    email
  }
}
    `;

/**
 * __useBilikPeopleTableQuery__
 *
 * To run a query within a React component, call `useBilikPeopleTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useBilikPeopleTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBilikPeopleTableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useBilikPeopleTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BilikPeopleTableQuery, BilikPeopleTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BilikPeopleTableQuery, BilikPeopleTableQueryVariables>(BilikPeopleTableQueryDocument, options);
      }
export function useBilikPeopleTableQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BilikPeopleTableQuery, BilikPeopleTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BilikPeopleTableQuery, BilikPeopleTableQueryVariables>(BilikPeopleTableQueryDocument, options);
        }
export type BilikPeopleTableQueryHookResult = ReturnType<typeof useBilikPeopleTableQuery>;
export type BilikPeopleTableQueryLazyQueryHookResult = ReturnType<typeof useBilikPeopleTableQueryLazyQuery>;
export type BilikPeopleTableQueryQueryResult = ApolloReactCommon.QueryResult<BilikPeopleTableQuery, BilikPeopleTableQueryVariables>;
export const BilikPersonFormCreateMutationDocument = gql`
    mutation bilikPersonFormCreateMutation($object: BilikPersonInsertInput!) {
  insertBilikPersonOne(object: $object) {
    id
  }
}
    `;
export type BilikPersonFormCreateMutationMutationFn = ApolloReactCommon.MutationFunction<BilikPersonFormCreateMutation, BilikPersonFormCreateMutationVariables>;

/**
 * __useBilikPersonFormCreateMutation__
 *
 * To run a mutation, you first call `useBilikPersonFormCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBilikPersonFormCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bilikPersonFormCreateMutation, { data, loading, error }] = useBilikPersonFormCreateMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useBilikPersonFormCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BilikPersonFormCreateMutation, BilikPersonFormCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BilikPersonFormCreateMutation, BilikPersonFormCreateMutationVariables>(BilikPersonFormCreateMutationDocument, options);
      }
export type BilikPersonFormCreateMutationHookResult = ReturnType<typeof useBilikPersonFormCreateMutation>;
export type BilikPersonFormCreateMutationMutationResult = ApolloReactCommon.MutationResult<BilikPersonFormCreateMutation>;
export type BilikPersonFormCreateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<BilikPersonFormCreateMutation, BilikPersonFormCreateMutationVariables>;
export const UseBilikPersonFormUpdateMutationDocument = gql`
    mutation useBilikPersonFormUpdateMutation($bilikPersonId: Int!, $bilikPerson: BilikPersonSetInput) {
  updateBilikPersonByPk(pkColumns: {id: $bilikPersonId}, _set: $bilikPerson) {
    id
  }
}
    `;
export type UseBilikPersonFormUpdateMutationMutationFn = ApolloReactCommon.MutationFunction<UseBilikPersonFormUpdateMutation, UseBilikPersonFormUpdateMutationVariables>;

/**
 * __useUseBilikPersonFormUpdateMutation__
 *
 * To run a mutation, you first call `useUseBilikPersonFormUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseBilikPersonFormUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useBilikPersonFormUpdateMutation, { data, loading, error }] = useUseBilikPersonFormUpdateMutation({
 *   variables: {
 *      bilikPersonId: // value for 'bilikPersonId'
 *      bilikPerson: // value for 'bilikPerson'
 *   },
 * });
 */
export function useUseBilikPersonFormUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UseBilikPersonFormUpdateMutation, UseBilikPersonFormUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UseBilikPersonFormUpdateMutation, UseBilikPersonFormUpdateMutationVariables>(UseBilikPersonFormUpdateMutationDocument, options);
      }
export type UseBilikPersonFormUpdateMutationHookResult = ReturnType<typeof useUseBilikPersonFormUpdateMutation>;
export type UseBilikPersonFormUpdateMutationMutationResult = ApolloReactCommon.MutationResult<UseBilikPersonFormUpdateMutation>;
export type UseBilikPersonFormUpdateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UseBilikPersonFormUpdateMutation, UseBilikPersonFormUpdateMutationVariables>;
export const BilikPersonFormUpdateQueryDocument = gql`
    query bilikPersonFormUpdateQuery($id: Int!) {
  bilikPersonByPk(id: $id) {
    id
    roleName
    telephone
    givenName
    familyName
    avatarHash
    employmentDate
    status
    description
    email
    authUserId
  }
}
    `;

/**
 * __useBilikPersonFormUpdateQuery__
 *
 * To run a query within a React component, call `useBilikPersonFormUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useBilikPersonFormUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBilikPersonFormUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBilikPersonFormUpdateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BilikPersonFormUpdateQuery, BilikPersonFormUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BilikPersonFormUpdateQuery, BilikPersonFormUpdateQueryVariables>(BilikPersonFormUpdateQueryDocument, options);
      }
export function useBilikPersonFormUpdateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BilikPersonFormUpdateQuery, BilikPersonFormUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BilikPersonFormUpdateQuery, BilikPersonFormUpdateQueryVariables>(BilikPersonFormUpdateQueryDocument, options);
        }
export type BilikPersonFormUpdateQueryHookResult = ReturnType<typeof useBilikPersonFormUpdateQuery>;
export type BilikPersonFormUpdateQueryLazyQueryHookResult = ReturnType<typeof useBilikPersonFormUpdateQueryLazyQuery>;
export type BilikPersonFormUpdateQueryQueryResult = ApolloReactCommon.QueryResult<BilikPersonFormUpdateQuery, BilikPersonFormUpdateQueryVariables>;
export const BilikPersonUpdatePageQueryDocument = gql`
    query bilikPersonUpdatePageQuery($id: Int!) {
  bilikPersonByPk(id: $id) {
    givenName
    familyName
  }
}
    `;

/**
 * __useBilikPersonUpdatePageQuery__
 *
 * To run a query within a React component, call `useBilikPersonUpdatePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBilikPersonUpdatePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBilikPersonUpdatePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBilikPersonUpdatePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BilikPersonUpdatePageQuery, BilikPersonUpdatePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BilikPersonUpdatePageQuery, BilikPersonUpdatePageQueryVariables>(BilikPersonUpdatePageQueryDocument, options);
      }
export function useBilikPersonUpdatePageQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BilikPersonUpdatePageQuery, BilikPersonUpdatePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BilikPersonUpdatePageQuery, BilikPersonUpdatePageQueryVariables>(BilikPersonUpdatePageQueryDocument, options);
        }
export type BilikPersonUpdatePageQueryHookResult = ReturnType<typeof useBilikPersonUpdatePageQuery>;
export type BilikPersonUpdatePageQueryLazyQueryHookResult = ReturnType<typeof useBilikPersonUpdatePageQueryLazyQuery>;
export type BilikPersonUpdatePageQueryQueryResult = ApolloReactCommon.QueryResult<BilikPersonUpdatePageQuery, BilikPersonUpdatePageQueryVariables>;
export const BilikZoneFormCreateMutationDocument = gql`
    mutation bilikZoneFormCreateMutation($object: BilikZoneInsertInput!) {
  insertBilikZoneOne(object: $object) {
    __typename
    id
  }
}
    `;
export type BilikZoneFormCreateMutationMutationFn = ApolloReactCommon.MutationFunction<BilikZoneFormCreateMutation, BilikZoneFormCreateMutationVariables>;

/**
 * __useBilikZoneFormCreateMutation__
 *
 * To run a mutation, you first call `useBilikZoneFormCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBilikZoneFormCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bilikZoneFormCreateMutation, { data, loading, error }] = useBilikZoneFormCreateMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useBilikZoneFormCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BilikZoneFormCreateMutation, BilikZoneFormCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BilikZoneFormCreateMutation, BilikZoneFormCreateMutationVariables>(BilikZoneFormCreateMutationDocument, options);
      }
export type BilikZoneFormCreateMutationHookResult = ReturnType<typeof useBilikZoneFormCreateMutation>;
export type BilikZoneFormCreateMutationMutationResult = ApolloReactCommon.MutationResult<BilikZoneFormCreateMutation>;
export type BilikZoneFormCreateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<BilikZoneFormCreateMutation, BilikZoneFormCreateMutationVariables>;
export const UpdateCityMutationDocument = gql`
    mutation updateCityMutation($updateCities: [CityUpdates!]!) {
  updateCityMany(updates: $updateCities) {
    returning {
      id
    }
  }
}
    `;
export type UpdateCityMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateCityMutation, UpdateCityMutationVariables>;

/**
 * __useUpdateCityMutation__
 *
 * To run a mutation, you first call `useUpdateCityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCityMutation, { data, loading, error }] = useUpdateCityMutation({
 *   variables: {
 *      updateCities: // value for 'updateCities'
 *   },
 * });
 */
export function useUpdateCityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCityMutation, UpdateCityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCityMutation, UpdateCityMutationVariables>(UpdateCityMutationDocument, options);
      }
export type UpdateCityMutationHookResult = ReturnType<typeof useUpdateCityMutation>;
export type UpdateCityMutationMutationResult = ApolloReactCommon.MutationResult<UpdateCityMutation>;
export type UpdateCityMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCityMutation, UpdateCityMutationVariables>;
export const BilikZoneFormGetInterventionsFieldDataQueryDocument = gql`
    query bilikZoneFormGetInterventionsFieldDataQuery($currentBilikZoneId: Int!) {
  otherBilikZones: bilikZone(where: {id: {_neq: $currentBilikZoneId}}) {
    name
    area
  }
  currentBilikZones: bilikZoneByPk(id: $currentBilikZoneId) {
    area
  }
}
    `;

/**
 * __useBilikZoneFormGetInterventionsFieldDataQuery__
 *
 * To run a query within a React component, call `useBilikZoneFormGetInterventionsFieldDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBilikZoneFormGetInterventionsFieldDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBilikZoneFormGetInterventionsFieldDataQuery({
 *   variables: {
 *      currentBilikZoneId: // value for 'currentBilikZoneId'
 *   },
 * });
 */
export function useBilikZoneFormGetInterventionsFieldDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BilikZoneFormGetInterventionsFieldDataQuery, BilikZoneFormGetInterventionsFieldDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BilikZoneFormGetInterventionsFieldDataQuery, BilikZoneFormGetInterventionsFieldDataQueryVariables>(BilikZoneFormGetInterventionsFieldDataQueryDocument, options);
      }
export function useBilikZoneFormGetInterventionsFieldDataQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BilikZoneFormGetInterventionsFieldDataQuery, BilikZoneFormGetInterventionsFieldDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BilikZoneFormGetInterventionsFieldDataQuery, BilikZoneFormGetInterventionsFieldDataQueryVariables>(BilikZoneFormGetInterventionsFieldDataQueryDocument, options);
        }
export type BilikZoneFormGetInterventionsFieldDataQueryHookResult = ReturnType<typeof useBilikZoneFormGetInterventionsFieldDataQuery>;
export type BilikZoneFormGetInterventionsFieldDataQueryLazyQueryHookResult = ReturnType<typeof useBilikZoneFormGetInterventionsFieldDataQueryLazyQuery>;
export type BilikZoneFormGetInterventionsFieldDataQueryQueryResult = ApolloReactCommon.QueryResult<BilikZoneFormGetInterventionsFieldDataQuery, BilikZoneFormGetInterventionsFieldDataQueryVariables>;
export const BilikZoneFormUpdateMutationDocument = gql`
    mutation bilikZoneFormUpdateMutation($bilikZoneId: Int!, $bilikZone: BilikZoneSetInput, $removeManagerIds: [Int!], $addManagers: [ManagerBilikPersonBilikZoneInsertInput!]!, $removeMemberIds: [Int!], $addMembers: [MemberBilikPersonBilikZoneInsertInput!]!, $updateCities: [CityUpdates!]!) {
  updateBilikZoneByPk(pkColumns: {id: $bilikZoneId}, _set: $bilikZone) {
    __typename
    id
  }
  updateCityMany(updates: $updateCities) {
    returning {
      __typename
      id
    }
  }
  deleteManagerBilikPersonBilikZone(
    where: {bilikZoneId: {_eq: $bilikZoneId}, _and: {bilikPersonId: {_in: $removeManagerIds}}}
  ) {
    returning {
      __typename
      bilikPerson {
        __typename
        id
      }
    }
  }
  insertManagerBilikPersonBilikZone(objects: $addManagers) {
    returning {
      __typename
      bilikPerson {
        __typename
        id
      }
    }
  }
  deleteMemberBilikPersonBilikZone(
    where: {bilikZoneId: {_eq: $bilikZoneId}, _and: {bilikPersonId: {_in: $removeMemberIds}}}
  ) {
    returning {
      __typename
      bilikPerson {
        __typename
        id
      }
    }
  }
  insertMemberBilikPersonBilikZone(objects: $addMembers) {
    returning {
      __typename
      bilikPerson {
        __typename
        id
      }
    }
  }
}
    `;
export type BilikZoneFormUpdateMutationMutationFn = ApolloReactCommon.MutationFunction<BilikZoneFormUpdateMutation, BilikZoneFormUpdateMutationVariables>;

/**
 * __useBilikZoneFormUpdateMutation__
 *
 * To run a mutation, you first call `useBilikZoneFormUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBilikZoneFormUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bilikZoneFormUpdateMutation, { data, loading, error }] = useBilikZoneFormUpdateMutation({
 *   variables: {
 *      bilikZoneId: // value for 'bilikZoneId'
 *      bilikZone: // value for 'bilikZone'
 *      removeManagerIds: // value for 'removeManagerIds'
 *      addManagers: // value for 'addManagers'
 *      removeMemberIds: // value for 'removeMemberIds'
 *      addMembers: // value for 'addMembers'
 *      updateCities: // value for 'updateCities'
 *   },
 * });
 */
export function useBilikZoneFormUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BilikZoneFormUpdateMutation, BilikZoneFormUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BilikZoneFormUpdateMutation, BilikZoneFormUpdateMutationVariables>(BilikZoneFormUpdateMutationDocument, options);
      }
export type BilikZoneFormUpdateMutationHookResult = ReturnType<typeof useBilikZoneFormUpdateMutation>;
export type BilikZoneFormUpdateMutationMutationResult = ApolloReactCommon.MutationResult<BilikZoneFormUpdateMutation>;
export type BilikZoneFormUpdateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<BilikZoneFormUpdateMutation, BilikZoneFormUpdateMutationVariables>;
export const BilikZoneFormUpdateQueryDocument = gql`
    query bilikZoneFormUpdateQuery($id: Int!) {
  bilikZoneByPk(id: $id) {
    id
    status
    callTrackingTarget
    genericEmail
    defaultCallTrackingTarget
    telephone
    shouldDisplayContactInPiSms
    cities {
      id
      parentId
    }
    zohoOrganization {
      id
      organizationId
    }
    managers {
      bilikPerson {
        id
      }
    }
    members {
      bilikPerson {
        id
      }
    }
    addressLocality
    postOfficeBoxNumber
    regionPostalCode
    postalCode
    streetAddress
    name
    mainCityId
    guideName
    mainCityCode
    area
    slug
    hasMultiplePostalCode
    hasDistrict
    proViews {
      id
    }
  }
}
    `;

/**
 * __useBilikZoneFormUpdateQuery__
 *
 * To run a query within a React component, call `useBilikZoneFormUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useBilikZoneFormUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBilikZoneFormUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBilikZoneFormUpdateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BilikZoneFormUpdateQuery, BilikZoneFormUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BilikZoneFormUpdateQuery, BilikZoneFormUpdateQueryVariables>(BilikZoneFormUpdateQueryDocument, options);
      }
export function useBilikZoneFormUpdateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BilikZoneFormUpdateQuery, BilikZoneFormUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BilikZoneFormUpdateQuery, BilikZoneFormUpdateQueryVariables>(BilikZoneFormUpdateQueryDocument, options);
        }
export type BilikZoneFormUpdateQueryHookResult = ReturnType<typeof useBilikZoneFormUpdateQuery>;
export type BilikZoneFormUpdateQueryLazyQueryHookResult = ReturnType<typeof useBilikZoneFormUpdateQueryLazyQuery>;
export type BilikZoneFormUpdateQueryQueryResult = ApolloReactCommon.QueryResult<BilikZoneFormUpdateQuery, BilikZoneFormUpdateQueryVariables>;
export const BilikZonesTableQueryDocument = gql`
    query bilikZonesTableQuery($limit: Int, $offset: Int, $order_by: [BilikZoneOrderBy!], $where: BilikZoneBoolExp) {
  bilikZone(limit: $limit, offset: $offset, orderBy: $order_by, where: $where) {
    id
    name
    status
    managers {
      bilikPerson {
        id
        givenName
        familyName
      }
    }
    citiesAggregate {
      aggregate {
        count
        sum {
          population
        }
      }
    }
  }
}
    `;

/**
 * __useBilikZonesTableQuery__
 *
 * To run a query within a React component, call `useBilikZonesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useBilikZonesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBilikZonesTableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBilikZonesTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BilikZonesTableQuery, BilikZonesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BilikZonesTableQuery, BilikZonesTableQueryVariables>(BilikZonesTableQueryDocument, options);
      }
export function useBilikZonesTableQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BilikZonesTableQuery, BilikZonesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BilikZonesTableQuery, BilikZonesTableQueryVariables>(BilikZonesTableQueryDocument, options);
        }
export type BilikZonesTableQueryHookResult = ReturnType<typeof useBilikZonesTableQuery>;
export type BilikZonesTableQueryLazyQueryHookResult = ReturnType<typeof useBilikZonesTableQueryLazyQuery>;
export type BilikZonesTableQueryQueryResult = ApolloReactCommon.QueryResult<BilikZonesTableQuery, BilikZonesTableQueryVariables>;
export const DashboardPageProViewQueryDocument = gql`
    query dashboardPageProViewQuery($where: ProViewBoolExp!) {
  proView(where: $where) {
    id
    status
  }
}
    `;

/**
 * __useDashboardPageProViewQuery__
 *
 * To run a query within a React component, call `useDashboardPageProViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPageProViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardPageProViewQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDashboardPageProViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardPageProViewQuery, DashboardPageProViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardPageProViewQuery, DashboardPageProViewQueryVariables>(DashboardPageProViewQueryDocument, options);
      }
export function useDashboardPageProViewQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardPageProViewQuery, DashboardPageProViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardPageProViewQuery, DashboardPageProViewQueryVariables>(DashboardPageProViewQueryDocument, options);
        }
export type DashboardPageProViewQueryHookResult = ReturnType<typeof useDashboardPageProViewQuery>;
export type DashboardPageProViewQueryLazyQueryHookResult = ReturnType<typeof useDashboardPageProViewQueryLazyQuery>;
export type DashboardPageProViewQueryQueryResult = ApolloReactCommon.QueryResult<DashboardPageProViewQuery, DashboardPageProViewQueryVariables>;
export const FinancialStatsQueryDocument = gql`
    query financialStatsQuery($bilikPersonIds: [Int!]!, $bilikZoneIds: [Int!]!) {
  bilikPeople: bilikPerson(where: {id: {_in: $bilikPersonIds}}) {
    id
    givenName
    familyName
  }
  bilikZones: bilikZone(where: {id: {_in: $bilikZoneIds}}) {
    id
    name
  }
}
    `;

/**
 * __useFinancialStatsQuery__
 *
 * To run a query within a React component, call `useFinancialStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialStatsQuery({
 *   variables: {
 *      bilikPersonIds: // value for 'bilikPersonIds'
 *      bilikZoneIds: // value for 'bilikZoneIds'
 *   },
 * });
 */
export function useFinancialStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FinancialStatsQuery, FinancialStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinancialStatsQuery, FinancialStatsQueryVariables>(FinancialStatsQueryDocument, options);
      }
export function useFinancialStatsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinancialStatsQuery, FinancialStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinancialStatsQuery, FinancialStatsQueryVariables>(FinancialStatsQueryDocument, options);
        }
export type FinancialStatsQueryHookResult = ReturnType<typeof useFinancialStatsQuery>;
export type FinancialStatsQueryLazyQueryHookResult = ReturnType<typeof useFinancialStatsQueryLazyQuery>;
export type FinancialStatsQueryQueryResult = ApolloReactCommon.QueryResult<FinancialStatsQuery, FinancialStatsQueryVariables>;
export const ProReviewInvitationGraphQueryDocument = gql`
    query proReviewInvitationGraphQuery($where: ProReviewInvitationBoolExp) {
  proReviewInvitation(where: $where) {
    dateCreated
  }
}
    `;

/**
 * __useProReviewInvitationGraphQuery__
 *
 * To run a query within a React component, call `useProReviewInvitationGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewInvitationGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewInvitationGraphQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProReviewInvitationGraphQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProReviewInvitationGraphQuery, ProReviewInvitationGraphQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewInvitationGraphQuery, ProReviewInvitationGraphQueryVariables>(ProReviewInvitationGraphQueryDocument, options);
      }
export function useProReviewInvitationGraphQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewInvitationGraphQuery, ProReviewInvitationGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewInvitationGraphQuery, ProReviewInvitationGraphQueryVariables>(ProReviewInvitationGraphQueryDocument, options);
        }
export type ProReviewInvitationGraphQueryHookResult = ReturnType<typeof useProReviewInvitationGraphQuery>;
export type ProReviewInvitationGraphQueryLazyQueryHookResult = ReturnType<typeof useProReviewInvitationGraphQueryLazyQuery>;
export type ProReviewInvitationGraphQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewInvitationGraphQuery, ProReviewInvitationGraphQueryVariables>;
export const SolicitationGraphQueryDocument = gql`
    query solicitationGraphQuery($where: SolicitationStatBoolExp) {
  solicitationStat(where: $where) {
    dateCreated
  }
}
    `;

/**
 * __useSolicitationGraphQuery__
 *
 * To run a query within a React component, call `useSolicitationGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitationGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitationGraphQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSolicitationGraphQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SolicitationGraphQuery, SolicitationGraphQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SolicitationGraphQuery, SolicitationGraphQueryVariables>(SolicitationGraphQueryDocument, options);
      }
export function useSolicitationGraphQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SolicitationGraphQuery, SolicitationGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SolicitationGraphQuery, SolicitationGraphQueryVariables>(SolicitationGraphQueryDocument, options);
        }
export type SolicitationGraphQueryHookResult = ReturnType<typeof useSolicitationGraphQuery>;
export type SolicitationGraphQueryLazyQueryHookResult = ReturnType<typeof useSolicitationGraphQueryLazyQuery>;
export type SolicitationGraphQueryQueryResult = ApolloReactCommon.QueryResult<SolicitationGraphQuery, SolicitationGraphQueryVariables>;
export const ExportGuideProViewsTableQueryDocument = gql`
    query exportGuideProViewsTableQuery($where: ProViewBoolExp) {
  proView(where: $where) {
    id
    phoneNumbers(where: {tag: {_eq: "guide"}}) {
      id
      tag
    }
    proPresentation {
      id
      name
      profile
      mainTrades {
        trade {
          name
        }
      }
      matchingTradeGuides(orderBy: {tradesAggregate: {count: DESC}}) {
        name
      }
    }
    proPeople {
      proPerson {
        id
        givenName
        familyName
      }
    }
  }
}
    `;

/**
 * __useExportGuideProViewsTableQuery__
 *
 * To run a query within a React component, call `useExportGuideProViewsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportGuideProViewsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportGuideProViewsTableQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExportGuideProViewsTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExportGuideProViewsTableQuery, ExportGuideProViewsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExportGuideProViewsTableQuery, ExportGuideProViewsTableQueryVariables>(ExportGuideProViewsTableQueryDocument, options);
      }
export function useExportGuideProViewsTableQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExportGuideProViewsTableQuery, ExportGuideProViewsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExportGuideProViewsTableQuery, ExportGuideProViewsTableQueryVariables>(ExportGuideProViewsTableQueryDocument, options);
        }
export type ExportGuideProViewsTableQueryHookResult = ReturnType<typeof useExportGuideProViewsTableQuery>;
export type ExportGuideProViewsTableQueryLazyQueryHookResult = ReturnType<typeof useExportGuideProViewsTableQueryLazyQuery>;
export type ExportGuideProViewsTableQueryQueryResult = ApolloReactCommon.QueryResult<ExportGuideProViewsTableQuery, ExportGuideProViewsTableQueryVariables>;
export const ManageNetworkMapHeatmapDocument = gql`
    query manageNetworkMapHeatmap($where: CityProViewBoolExp!) {
  city(where: {proViews: $where, slug: {_nin: ["lyon", "marseille", "paris"]}}) {
    id
    name
    slug
    area
    proViewsAggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useManageNetworkMapHeatmapQuery__
 *
 * To run a query within a React component, call `useManageNetworkMapHeatmapQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageNetworkMapHeatmapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageNetworkMapHeatmapQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useManageNetworkMapHeatmapQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ManageNetworkMapHeatmapQuery, ManageNetworkMapHeatmapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ManageNetworkMapHeatmapQuery, ManageNetworkMapHeatmapQueryVariables>(ManageNetworkMapHeatmapDocument, options);
      }
export function useManageNetworkMapHeatmapLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ManageNetworkMapHeatmapQuery, ManageNetworkMapHeatmapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ManageNetworkMapHeatmapQuery, ManageNetworkMapHeatmapQueryVariables>(ManageNetworkMapHeatmapDocument, options);
        }
export type ManageNetworkMapHeatmapQueryHookResult = ReturnType<typeof useManageNetworkMapHeatmapQuery>;
export type ManageNetworkMapHeatmapLazyQueryHookResult = ReturnType<typeof useManageNetworkMapHeatmapLazyQuery>;
export type ManageNetworkMapHeatmapQueryResult = ApolloReactCommon.QueryResult<ManageNetworkMapHeatmapQuery, ManageNetworkMapHeatmapQueryVariables>;
export const ManageNetworkMapViewsDocument = gql`
    query manageNetworkMapViews($where: ProViewBoolExp!) {
  proView(where: $where) {
    id
    avatarHash
    proPostalAddress {
      geoCoordinates
    }
    proPresentation {
      name
      mainTradeNames
    }
    bilikZone {
      name
    }
  }
}
    `;

/**
 * __useManageNetworkMapViewsQuery__
 *
 * To run a query within a React component, call `useManageNetworkMapViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageNetworkMapViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageNetworkMapViewsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useManageNetworkMapViewsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ManageNetworkMapViewsQuery, ManageNetworkMapViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ManageNetworkMapViewsQuery, ManageNetworkMapViewsQueryVariables>(ManageNetworkMapViewsDocument, options);
      }
export function useManageNetworkMapViewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ManageNetworkMapViewsQuery, ManageNetworkMapViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ManageNetworkMapViewsQuery, ManageNetworkMapViewsQueryVariables>(ManageNetworkMapViewsDocument, options);
        }
export type ManageNetworkMapViewsQueryHookResult = ReturnType<typeof useManageNetworkMapViewsQuery>;
export type ManageNetworkMapViewsLazyQueryHookResult = ReturnType<typeof useManageNetworkMapViewsLazyQuery>;
export type ManageNetworkMapViewsQueryResult = ApolloReactCommon.QueryResult<ManageNetworkMapViewsQuery, ManageNetworkMapViewsQueryVariables>;
export const ProReviewInvitationsCreatePageQueryDocument = gql`
    query proReviewInvitationsCreatePageQuery($id: Int!) {
  proPresentationByPk(id: $id) {
    id
    name
    mainTradeNames
  }
}
    `;

/**
 * __useProReviewInvitationsCreatePageQuery__
 *
 * To run a query within a React component, call `useProReviewInvitationsCreatePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewInvitationsCreatePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewInvitationsCreatePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProReviewInvitationsCreatePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProReviewInvitationsCreatePageQuery, ProReviewInvitationsCreatePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewInvitationsCreatePageQuery, ProReviewInvitationsCreatePageQueryVariables>(ProReviewInvitationsCreatePageQueryDocument, options);
      }
export function useProReviewInvitationsCreatePageQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewInvitationsCreatePageQuery, ProReviewInvitationsCreatePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewInvitationsCreatePageQuery, ProReviewInvitationsCreatePageQueryVariables>(ProReviewInvitationsCreatePageQueryDocument, options);
        }
export type ProReviewInvitationsCreatePageQueryHookResult = ReturnType<typeof useProReviewInvitationsCreatePageQuery>;
export type ProReviewInvitationsCreatePageQueryLazyQueryHookResult = ReturnType<typeof useProReviewInvitationsCreatePageQueryLazyQuery>;
export type ProReviewInvitationsCreatePageQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewInvitationsCreatePageQuery, ProReviewInvitationsCreatePageQueryVariables>;
export const ProReviewInvitationsFormCreateMutationDocument = gql`
    mutation proReviewInvitationsFormCreateMutation($proReviewInvitations: [ProReviewInvitationInsertInput!]!) {
  insertProReviewInvitation(objects: $proReviewInvitations) {
    returning {
      id
      __typename
    }
  }
}
    `;
export type ProReviewInvitationsFormCreateMutationMutationFn = ApolloReactCommon.MutationFunction<ProReviewInvitationsFormCreateMutation, ProReviewInvitationsFormCreateMutationVariables>;

/**
 * __useProReviewInvitationsFormCreateMutation__
 *
 * To run a mutation, you first call `useProReviewInvitationsFormCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProReviewInvitationsFormCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proReviewInvitationsFormCreateMutation, { data, loading, error }] = useProReviewInvitationsFormCreateMutation({
 *   variables: {
 *      proReviewInvitations: // value for 'proReviewInvitations'
 *   },
 * });
 */
export function useProReviewInvitationsFormCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProReviewInvitationsFormCreateMutation, ProReviewInvitationsFormCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProReviewInvitationsFormCreateMutation, ProReviewInvitationsFormCreateMutationVariables>(ProReviewInvitationsFormCreateMutationDocument, options);
      }
export type ProReviewInvitationsFormCreateMutationHookResult = ReturnType<typeof useProReviewInvitationsFormCreateMutation>;
export type ProReviewInvitationsFormCreateMutationMutationResult = ApolloReactCommon.MutationResult<ProReviewInvitationsFormCreateMutation>;
export type ProReviewInvitationsFormCreateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ProReviewInvitationsFormCreateMutation, ProReviewInvitationsFormCreateMutationVariables>;
export const ProReviewInvitationsFormCreateQueryDocument = gql`
    query proReviewInvitationsFormCreateQuery($proPresentationId: Int!) {
  proPresentationByPk(id: $proPresentationId) {
    id
    proReviews: reviews(
      where: {review: {status: {_eq: "ok"}, isSpam: {_eq: false}}}
    ) {
      review {
        id
        dateCreated
        givenName
        familyName
        email
      }
    }
    proReviewInvitations(
      where: {proPresentation: {id: {_eq: $proPresentationId}}}
      orderBy: {dateCreated: DESC}
    ) {
      id
      dateCreated
      givenName
      familyName
      email
      proPresentation {
        id
        slug
        mainTrades {
          trade {
            slug
          }
        }
        proViews {
          id
        }
      }
    }
    company {
      proPresentations(where: {id: {_neq: $proPresentationId}}) {
        proReviews: reviews(
          where: {review: {status: {_eq: "ok"}, isSpam: {_eq: false}}}
        ) {
          review {
            id
            dateCreated
            givenName
            familyName
            email
          }
        }
        proReviewInvitations(
          where: {proPresentation: {id: {_neq: $proPresentationId}}}
          orderBy: {dateCreated: DESC}
        ) {
          id
          dateCreated
          givenName
          familyName
          email
          proPresentation {
            id
            slug
            mainTrades {
              trade {
                slug
              }
            }
            proViews {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProReviewInvitationsFormCreateQuery__
 *
 * To run a query within a React component, call `useProReviewInvitationsFormCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewInvitationsFormCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewInvitationsFormCreateQuery({
 *   variables: {
 *      proPresentationId: // value for 'proPresentationId'
 *   },
 * });
 */
export function useProReviewInvitationsFormCreateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProReviewInvitationsFormCreateQuery, ProReviewInvitationsFormCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewInvitationsFormCreateQuery, ProReviewInvitationsFormCreateQueryVariables>(ProReviewInvitationsFormCreateQueryDocument, options);
      }
export function useProReviewInvitationsFormCreateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewInvitationsFormCreateQuery, ProReviewInvitationsFormCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewInvitationsFormCreateQuery, ProReviewInvitationsFormCreateQueryVariables>(ProReviewInvitationsFormCreateQueryDocument, options);
        }
export type ProReviewInvitationsFormCreateQueryHookResult = ReturnType<typeof useProReviewInvitationsFormCreateQuery>;
export type ProReviewInvitationsFormCreateQueryLazyQueryHookResult = ReturnType<typeof useProReviewInvitationsFormCreateQueryLazyQuery>;
export type ProReviewInvitationsFormCreateQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewInvitationsFormCreateQuery, ProReviewInvitationsFormCreateQueryVariables>;
export const ProReviewFormUpdateMutationDocument = gql`
    mutation proReviewFormUpdateMutation($proReviewId: Int!, $proReview: ProReviewSetInput!) {
  updateProReviewByPk(pkColumns: {id: $proReviewId}, _set: $proReview) {
    id
    referenceView {
      view {
        proPresentation {
          id
          name
          mainTradeNames
          proViews {
            id
            bilikZone {
              id
              mainCityCode
            }
          }
        }
      }
    }
  }
}
    `;
export type ProReviewFormUpdateMutationMutationFn = ApolloReactCommon.MutationFunction<ProReviewFormUpdateMutation, ProReviewFormUpdateMutationVariables>;

/**
 * __useProReviewFormUpdateMutation__
 *
 * To run a mutation, you first call `useProReviewFormUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProReviewFormUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proReviewFormUpdateMutation, { data, loading, error }] = useProReviewFormUpdateMutation({
 *   variables: {
 *      proReviewId: // value for 'proReviewId'
 *      proReview: // value for 'proReview'
 *   },
 * });
 */
export function useProReviewFormUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProReviewFormUpdateMutation, ProReviewFormUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProReviewFormUpdateMutation, ProReviewFormUpdateMutationVariables>(ProReviewFormUpdateMutationDocument, options);
      }
export type ProReviewFormUpdateMutationHookResult = ReturnType<typeof useProReviewFormUpdateMutation>;
export type ProReviewFormUpdateMutationMutationResult = ApolloReactCommon.MutationResult<ProReviewFormUpdateMutation>;
export type ProReviewFormUpdateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ProReviewFormUpdateMutation, ProReviewFormUpdateMutationVariables>;
export const ProReviewFormUpdateQueryDocument = gql`
    query proReviewFormUpdateQuery($proReviewId: Int!) {
  proReviewByPk(id: $proReviewId) {
    givenName
    familyName
    email
    telephone
    reviewAspect
    reviewBody
    comment
    privateComment
    dateOfWork
    reply
    replyStatus
    rating
    cityId
    source
    referenceView {
      view {
        proPresentation {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useProReviewFormUpdateQuery__
 *
 * To run a query within a React component, call `useProReviewFormUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewFormUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewFormUpdateQuery({
 *   variables: {
 *      proReviewId: // value for 'proReviewId'
 *   },
 * });
 */
export function useProReviewFormUpdateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProReviewFormUpdateQuery, ProReviewFormUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewFormUpdateQuery, ProReviewFormUpdateQueryVariables>(ProReviewFormUpdateQueryDocument, options);
      }
export function useProReviewFormUpdateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewFormUpdateQuery, ProReviewFormUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewFormUpdateQuery, ProReviewFormUpdateQueryVariables>(ProReviewFormUpdateQueryDocument, options);
        }
export type ProReviewFormUpdateQueryHookResult = ReturnType<typeof useProReviewFormUpdateQuery>;
export type ProReviewFormUpdateQueryLazyQueryHookResult = ReturnType<typeof useProReviewFormUpdateQueryLazyQuery>;
export type ProReviewFormUpdateQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewFormUpdateQuery, ProReviewFormUpdateQueryVariables>;
export const ProReviewFormCreateQueryDocument = gql`
    query ProReviewFormCreateQuery($proPresentationId: Int!) {
  proPresentationByPk(id: $proPresentationId) {
    id
  }
}
    `;

/**
 * __useProReviewFormCreateQuery__
 *
 * To run a query within a React component, call `useProReviewFormCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewFormCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewFormCreateQuery({
 *   variables: {
 *      proPresentationId: // value for 'proPresentationId'
 *   },
 * });
 */
export function useProReviewFormCreateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProReviewFormCreateQuery, ProReviewFormCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewFormCreateQuery, ProReviewFormCreateQueryVariables>(ProReviewFormCreateQueryDocument, options);
      }
export function useProReviewFormCreateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewFormCreateQuery, ProReviewFormCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewFormCreateQuery, ProReviewFormCreateQueryVariables>(ProReviewFormCreateQueryDocument, options);
        }
export type ProReviewFormCreateQueryHookResult = ReturnType<typeof useProReviewFormCreateQuery>;
export type ProReviewFormCreateQueryLazyQueryHookResult = ReturnType<typeof useProReviewFormCreateQueryLazyQuery>;
export type ProReviewFormCreateQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewFormCreateQuery, ProReviewFormCreateQueryVariables>;
export const ProReviewInvitationCreatedUpdateMutationDocument = gql`
    mutation proReviewInvitationCreatedUpdateMutation($proReviewId: Int!, $proPresentationId: Int!, $email: String!, $dateOfWork: timestamptz) {
  updateProReviewInvitation(
    where: {proPresentationId: {_eq: $proPresentationId}, _and: {email: {_eq: $email}, proReviewId: {_isNull: true}}}
    _set: {proReviewId: $proReviewId, dateOfWork: $dateOfWork}
  ) {
    affectedRows
  }
}
    `;
export type ProReviewInvitationCreatedUpdateMutationMutationFn = ApolloReactCommon.MutationFunction<ProReviewInvitationCreatedUpdateMutation, ProReviewInvitationCreatedUpdateMutationVariables>;

/**
 * __useProReviewInvitationCreatedUpdateMutation__
 *
 * To run a mutation, you first call `useProReviewInvitationCreatedUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProReviewInvitationCreatedUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proReviewInvitationCreatedUpdateMutation, { data, loading, error }] = useProReviewInvitationCreatedUpdateMutation({
 *   variables: {
 *      proReviewId: // value for 'proReviewId'
 *      proPresentationId: // value for 'proPresentationId'
 *      email: // value for 'email'
 *      dateOfWork: // value for 'dateOfWork'
 *   },
 * });
 */
export function useProReviewInvitationCreatedUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProReviewInvitationCreatedUpdateMutation, ProReviewInvitationCreatedUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProReviewInvitationCreatedUpdateMutation, ProReviewInvitationCreatedUpdateMutationVariables>(ProReviewInvitationCreatedUpdateMutationDocument, options);
      }
export type ProReviewInvitationCreatedUpdateMutationHookResult = ReturnType<typeof useProReviewInvitationCreatedUpdateMutation>;
export type ProReviewInvitationCreatedUpdateMutationMutationResult = ApolloReactCommon.MutationResult<ProReviewInvitationCreatedUpdateMutation>;
export type ProReviewInvitationCreatedUpdateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ProReviewInvitationCreatedUpdateMutation, ProReviewInvitationCreatedUpdateMutationVariables>;
export const ProReviewCreatePageQueryDocument = gql`
    query proReviewCreatePageQuery($proPresentationId: Int!) {
  proPresentationByPk(id: $proPresentationId) {
    id
    name
    mainTradeNames
  }
}
    `;

/**
 * __useProReviewCreatePageQuery__
 *
 * To run a query within a React component, call `useProReviewCreatePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewCreatePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewCreatePageQuery({
 *   variables: {
 *      proPresentationId: // value for 'proPresentationId'
 *   },
 * });
 */
export function useProReviewCreatePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProReviewCreatePageQuery, ProReviewCreatePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewCreatePageQuery, ProReviewCreatePageQueryVariables>(ProReviewCreatePageQueryDocument, options);
      }
export function useProReviewCreatePageQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewCreatePageQuery, ProReviewCreatePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewCreatePageQuery, ProReviewCreatePageQueryVariables>(ProReviewCreatePageQueryDocument, options);
        }
export type ProReviewCreatePageQueryHookResult = ReturnType<typeof useProReviewCreatePageQuery>;
export type ProReviewCreatePageQueryLazyQueryHookResult = ReturnType<typeof useProReviewCreatePageQueryLazyQuery>;
export type ProReviewCreatePageQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewCreatePageQuery, ProReviewCreatePageQueryVariables>;
export const ProReviewUpdatePageQueryDocument = gql`
    query proReviewUpdatePageQuery($proReviewId: Int!) {
  proReviewByPk(id: $proReviewId) {
    givenName
    familyName
  }
}
    `;

/**
 * __useProReviewUpdatePageQuery__
 *
 * To run a query within a React component, call `useProReviewUpdatePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewUpdatePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewUpdatePageQuery({
 *   variables: {
 *      proReviewId: // value for 'proReviewId'
 *   },
 * });
 */
export function useProReviewUpdatePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProReviewUpdatePageQuery, ProReviewUpdatePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewUpdatePageQuery, ProReviewUpdatePageQueryVariables>(ProReviewUpdatePageQueryDocument, options);
      }
export function useProReviewUpdatePageQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewUpdatePageQuery, ProReviewUpdatePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewUpdatePageQuery, ProReviewUpdatePageQueryVariables>(ProReviewUpdatePageQueryDocument, options);
        }
export type ProReviewUpdatePageQueryHookResult = ReturnType<typeof useProReviewUpdatePageQuery>;
export type ProReviewUpdatePageQueryLazyQueryHookResult = ReturnType<typeof useProReviewUpdatePageQueryLazyQuery>;
export type ProReviewUpdatePageQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewUpdatePageQuery, ProReviewUpdatePageQueryVariables>;
export const ProReviewCertificateAddressesQueryDocument = gql`
    query proReviewCertificateAddressesQuery($proPresentationId: Int!) {
  proPresentationByPk(id: $proPresentationId) {
    id
    company {
      streetAddress
      postalCode
      city
    }
    proViews(where: {status: {_neq: "archived"}}) {
      id
      proPostalAddress {
        street
        postalCode
        city
      }
    }
  }
}
    `;

/**
 * __useProReviewCertificateAddressesQuery__
 *
 * To run a query within a React component, call `useProReviewCertificateAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewCertificateAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewCertificateAddressesQuery({
 *   variables: {
 *      proPresentationId: // value for 'proPresentationId'
 *   },
 * });
 */
export function useProReviewCertificateAddressesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProReviewCertificateAddressesQuery, ProReviewCertificateAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewCertificateAddressesQuery, ProReviewCertificateAddressesQueryVariables>(ProReviewCertificateAddressesQueryDocument, options);
      }
export function useProReviewCertificateAddressesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewCertificateAddressesQuery, ProReviewCertificateAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewCertificateAddressesQuery, ProReviewCertificateAddressesQueryVariables>(ProReviewCertificateAddressesQueryDocument, options);
        }
export type ProReviewCertificateAddressesQueryHookResult = ReturnType<typeof useProReviewCertificateAddressesQuery>;
export type ProReviewCertificateAddressesQueryLazyQueryHookResult = ReturnType<typeof useProReviewCertificateAddressesQueryLazyQuery>;
export type ProReviewCertificateAddressesQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewCertificateAddressesQuery, ProReviewCertificateAddressesQueryVariables>;
export const ProContractFormQueryDocument = gql`
    query proContractFormQuery($proViewId: Int!) {
  proViewByPk(id: $proViewId) {
    contractConfiguration
  }
}
    `;

/**
 * __useProContractFormQuery__
 *
 * To run a query within a React component, call `useProContractFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useProContractFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProContractFormQuery({
 *   variables: {
 *      proViewId: // value for 'proViewId'
 *   },
 * });
 */
export function useProContractFormQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProContractFormQuery, ProContractFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProContractFormQuery, ProContractFormQueryVariables>(ProContractFormQueryDocument, options);
      }
export function useProContractFormQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProContractFormQuery, ProContractFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProContractFormQuery, ProContractFormQueryVariables>(ProContractFormQueryDocument, options);
        }
export type ProContractFormQueryHookResult = ReturnType<typeof useProContractFormQuery>;
export type ProContractFormQueryLazyQueryHookResult = ReturnType<typeof useProContractFormQueryLazyQuery>;
export type ProContractFormQueryQueryResult = ApolloReactCommon.QueryResult<ProContractFormQuery, ProContractFormQueryVariables>;
export const ProContractQueryDocument = gql`
    query proContractQuery($id: Int!) {
  proView: proViewByPk(id: $id) {
    id
    contractConfiguration
    contractEvents
    datePublished
    bilikZone {
      slug
      mainCityCode
    }
    proPresentation {
      mainTrades {
        trade {
          slug
          label
        }
      }
      company {
        name
        legalForm
        registrationNumber
        streetAddress
        postalCode
        city
      }
    }
  }
}
    `;

/**
 * __useProContractQuery__
 *
 * To run a query within a React component, call `useProContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useProContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProContractQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProContractQuery, ProContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProContractQuery, ProContractQueryVariables>(ProContractQueryDocument, options);
      }
export function useProContractQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProContractQuery, ProContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProContractQuery, ProContractQueryVariables>(ProContractQueryDocument, options);
        }
export type ProContractQueryHookResult = ReturnType<typeof useProContractQuery>;
export type ProContractQueryLazyQueryHookResult = ReturnType<typeof useProContractQueryLazyQuery>;
export type ProContractQueryQueryResult = ApolloReactCommon.QueryResult<ProContractQuery, ProContractQueryVariables>;
export const ProFormUpdateDocument = gql`
    mutation proFormUpdate($proViewId: Int!, $proView: ProViewSetInput!, $proPresentationId: Int!, $insertProPostalAddressOne: ProPostalAddressInsertInput!, $insertProPrices: [ProPriceInsertInput!]!, $deleteProPrices: [Int!], $deleteGoogleReviewLinks: [Int!], $insertProMessages: [ProMessageInsertInput!]!, $deleteProMessages: [Int!], $insertProMediaObjects: [ProMediaObjectInsertInput!]!, $deleteProMediaObjects: [Int!], $insertTrades: [TradeProViewInsertInput!]!, $deleteTrades: [Int!], $insertMainTrades: [TradeProPresentationInsertInput!]!, $deleteMainTrades: [Int!], $deleteColleagues: [Int!], $insertColleagues: [ProViewProViewInsertInput!]!, $deleteCities: [Int!], $insertCities: [CityProViewInsertInput!]!, $deleteCertifications: [Int!], $insertCertifications: [ProCertificationInsertInput!]!, $deleteProPeople: [Int!], $deleteAccounts: [uuid!]) {
  updateProViewByPk(pkColumns: {id: $proViewId}, _set: $proView) {
    id
  }
  insertProPostalAddressOne(
    object: $insertProPostalAddressOne
    onConflict: {constraint: pro_postal_address_pkey, updateColumns: [city, geoCoordinates, displayOption, postalCode, street, cityGeoCoordinates]}
  ) {
    proViewId
  }
  insertProPrice(objects: $insertProPrices) {
    affectedRows
  }
  deleteProPrice(where: {id: {_in: $deleteProPrices}}) {
    affectedRows
  }
  deleteGoogleReviewLink(where: {id: {_in: $deleteGoogleReviewLinks}}) {
    affectedRows
  }
  insertProMessage(objects: $insertProMessages) {
    affectedRows
  }
  deleteProMessage(where: {id: {_in: $deleteProMessages}}) {
    affectedRows
  }
  insertProMediaObject(objects: $insertProMediaObjects) {
    affectedRows
  }
  deleteProMediaObject(where: {id: {_in: $deleteProMediaObjects}}) {
    affectedRows
  }
  deleteTradeProView(
    where: {proViewId: {_eq: $proViewId}, tradeId: {_in: $deleteTrades}}
  ) {
    affectedRows
  }
  insertTradeProView(objects: $insertTrades) {
    affectedRows
  }
  deleteTradeProPresentation(
    where: {proPresentationId: {_eq: $proPresentationId}, tradeId: {_in: $deleteMainTrades}}
  ) {
    affectedRows
  }
  insertTradeProPresentation(objects: $insertMainTrades) {
    affectedRows
  }
  deleteProViewProView(
    where: {proViewSource: {_eq: $proViewId}, proViewTarget: {_in: $deleteColleagues}}
  ) {
    affectedRows
  }
  insertProViewProView(objects: $insertColleagues) {
    affectedRows
  }
  deleteCityProView(
    where: {proViewId: {_eq: $proViewId}, cityId: {_in: $deleteCities}}
  ) {
    affectedRows
  }
  insertCityProView(
    objects: $insertCities
    onConflict: {constraint: city_pro_view_pkey, updateColumns: [type]}
  ) {
    affectedRows
  }
  deleteProCertification(
    where: {proPresentationId: {_eq: $proPresentationId}, certificationId: {_in: $deleteCertifications}}
  ) {
    affectedRows
  }
  insertProCertification(objects: $insertCertifications) {
    affectedRows
  }
  deleteProViewProPerson(
    where: {proViewId: {_eq: $proViewId}, proPersonId: {_in: $deleteProPeople}}
  ) {
    affectedRows
  }
  deleteAccountProView(
    where: {proViewId: {_eq: $proViewId}, authUserId: {_in: $deleteAccounts}}
  ) {
    affectedRows
  }
}
    `;
export type ProFormUpdateMutationFn = ApolloReactCommon.MutationFunction<ProFormUpdateMutation, ProFormUpdateMutationVariables>;

/**
 * __useProFormUpdateMutation__
 *
 * To run a mutation, you first call `useProFormUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProFormUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proFormUpdateMutation, { data, loading, error }] = useProFormUpdateMutation({
 *   variables: {
 *      proViewId: // value for 'proViewId'
 *      proView: // value for 'proView'
 *      proPresentationId: // value for 'proPresentationId'
 *      insertProPostalAddressOne: // value for 'insertProPostalAddressOne'
 *      insertProPrices: // value for 'insertProPrices'
 *      deleteProPrices: // value for 'deleteProPrices'
 *      deleteGoogleReviewLinks: // value for 'deleteGoogleReviewLinks'
 *      insertProMessages: // value for 'insertProMessages'
 *      deleteProMessages: // value for 'deleteProMessages'
 *      insertProMediaObjects: // value for 'insertProMediaObjects'
 *      deleteProMediaObjects: // value for 'deleteProMediaObjects'
 *      insertTrades: // value for 'insertTrades'
 *      deleteTrades: // value for 'deleteTrades'
 *      insertMainTrades: // value for 'insertMainTrades'
 *      deleteMainTrades: // value for 'deleteMainTrades'
 *      deleteColleagues: // value for 'deleteColleagues'
 *      insertColleagues: // value for 'insertColleagues'
 *      deleteCities: // value for 'deleteCities'
 *      insertCities: // value for 'insertCities'
 *      deleteCertifications: // value for 'deleteCertifications'
 *      insertCertifications: // value for 'insertCertifications'
 *      deleteProPeople: // value for 'deleteProPeople'
 *      deleteAccounts: // value for 'deleteAccounts'
 *   },
 * });
 */
export function useProFormUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProFormUpdateMutation, ProFormUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProFormUpdateMutation, ProFormUpdateMutationVariables>(ProFormUpdateDocument, options);
      }
export type ProFormUpdateMutationHookResult = ReturnType<typeof useProFormUpdateMutation>;
export type ProFormUpdateMutationResult = ApolloReactCommon.MutationResult<ProFormUpdateMutation>;
export type ProFormUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<ProFormUpdateMutation, ProFormUpdateMutationVariables>;
export const UpdatePresentationDocument = gql`
    mutation updatePresentation($id: Int!, $presentation: ProPresentationSetInput!) {
  updateProPresentationByPk(pkColumns: {id: $id}, _set: $presentation) {
    id
  }
}
    `;
export type UpdatePresentationMutationFn = ApolloReactCommon.MutationFunction<UpdatePresentationMutation, UpdatePresentationMutationVariables>;

/**
 * __useUpdatePresentationMutation__
 *
 * To run a mutation, you first call `useUpdatePresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePresentationMutation, { data, loading, error }] = useUpdatePresentationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      presentation: // value for 'presentation'
 *   },
 * });
 */
export function useUpdatePresentationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePresentationMutation, UpdatePresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePresentationMutation, UpdatePresentationMutationVariables>(UpdatePresentationDocument, options);
      }
export type UpdatePresentationMutationHookResult = ReturnType<typeof useUpdatePresentationMutation>;
export type UpdatePresentationMutationResult = ApolloReactCommon.MutationResult<UpdatePresentationMutation>;
export type UpdatePresentationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePresentationMutation, UpdatePresentationMutationVariables>;
export const ProFormCreateSlugRedirectDocument = gql`
    mutation proFormCreateSlugRedirect($input: SlugRedirectInsertInput!) {
  insertSlugRedirectOne(object: $input) {
    id
  }
}
    `;
export type ProFormCreateSlugRedirectMutationFn = ApolloReactCommon.MutationFunction<ProFormCreateSlugRedirectMutation, ProFormCreateSlugRedirectMutationVariables>;

/**
 * __useProFormCreateSlugRedirectMutation__
 *
 * To run a mutation, you first call `useProFormCreateSlugRedirectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProFormCreateSlugRedirectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proFormCreateSlugRedirectMutation, { data, loading, error }] = useProFormCreateSlugRedirectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProFormCreateSlugRedirectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProFormCreateSlugRedirectMutation, ProFormCreateSlugRedirectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProFormCreateSlugRedirectMutation, ProFormCreateSlugRedirectMutationVariables>(ProFormCreateSlugRedirectDocument, options);
      }
export type ProFormCreateSlugRedirectMutationHookResult = ReturnType<typeof useProFormCreateSlugRedirectMutation>;
export type ProFormCreateSlugRedirectMutationResult = ApolloReactCommon.MutationResult<ProFormCreateSlugRedirectMutation>;
export type ProFormCreateSlugRedirectMutationOptions = ApolloReactCommon.BaseMutationOptions<ProFormCreateSlugRedirectMutation, ProFormCreateSlugRedirectMutationVariables>;
export const ProFormCreateGoogleReviewLinkDocument = gql`
    mutation proFormCreateGoogleReviewLink($input: GoogleReviewLinkInsertInput!) {
  insertGoogleReviewLinkOne(object: $input) {
    id
  }
}
    `;
export type ProFormCreateGoogleReviewLinkMutationFn = ApolloReactCommon.MutationFunction<ProFormCreateGoogleReviewLinkMutation, ProFormCreateGoogleReviewLinkMutationVariables>;

/**
 * __useProFormCreateGoogleReviewLinkMutation__
 *
 * To run a mutation, you first call `useProFormCreateGoogleReviewLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProFormCreateGoogleReviewLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proFormCreateGoogleReviewLinkMutation, { data, loading, error }] = useProFormCreateGoogleReviewLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProFormCreateGoogleReviewLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProFormCreateGoogleReviewLinkMutation, ProFormCreateGoogleReviewLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProFormCreateGoogleReviewLinkMutation, ProFormCreateGoogleReviewLinkMutationVariables>(ProFormCreateGoogleReviewLinkDocument, options);
      }
export type ProFormCreateGoogleReviewLinkMutationHookResult = ReturnType<typeof useProFormCreateGoogleReviewLinkMutation>;
export type ProFormCreateGoogleReviewLinkMutationResult = ApolloReactCommon.MutationResult<ProFormCreateGoogleReviewLinkMutation>;
export type ProFormCreateGoogleReviewLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<ProFormCreateGoogleReviewLinkMutation, ProFormCreateGoogleReviewLinkMutationVariables>;
export const ProFormUpdateProMessageDocument = gql`
    mutation proFormUpdateProMessage($proMessageId: Int!, $proMessage: ProMessageSetInput!) {
  updateProMessageByPk(pkColumns: {id: $proMessageId}, _set: $proMessage) {
    id
  }
}
    `;
export type ProFormUpdateProMessageMutationFn = ApolloReactCommon.MutationFunction<ProFormUpdateProMessageMutation, ProFormUpdateProMessageMutationVariables>;

/**
 * __useProFormUpdateProMessageMutation__
 *
 * To run a mutation, you first call `useProFormUpdateProMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProFormUpdateProMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proFormUpdateProMessageMutation, { data, loading, error }] = useProFormUpdateProMessageMutation({
 *   variables: {
 *      proMessageId: // value for 'proMessageId'
 *      proMessage: // value for 'proMessage'
 *   },
 * });
 */
export function useProFormUpdateProMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProFormUpdateProMessageMutation, ProFormUpdateProMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProFormUpdateProMessageMutation, ProFormUpdateProMessageMutationVariables>(ProFormUpdateProMessageDocument, options);
      }
export type ProFormUpdateProMessageMutationHookResult = ReturnType<typeof useProFormUpdateProMessageMutation>;
export type ProFormUpdateProMessageMutationResult = ApolloReactCommon.MutationResult<ProFormUpdateProMessageMutation>;
export type ProFormUpdateProMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<ProFormUpdateProMessageMutation, ProFormUpdateProMessageMutationVariables>;
export const ProFormUpdateProPriceDocument = gql`
    mutation proFormUpdateProPrice($proPriceId: Int!, $proPrice: ProPriceSetInput!) {
  updateProPriceByPk(pkColumns: {id: $proPriceId}, _set: $proPrice) {
    id
  }
}
    `;
export type ProFormUpdateProPriceMutationFn = ApolloReactCommon.MutationFunction<ProFormUpdateProPriceMutation, ProFormUpdateProPriceMutationVariables>;

/**
 * __useProFormUpdateProPriceMutation__
 *
 * To run a mutation, you first call `useProFormUpdateProPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProFormUpdateProPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proFormUpdateProPriceMutation, { data, loading, error }] = useProFormUpdateProPriceMutation({
 *   variables: {
 *      proPriceId: // value for 'proPriceId'
 *      proPrice: // value for 'proPrice'
 *   },
 * });
 */
export function useProFormUpdateProPriceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProFormUpdateProPriceMutation, ProFormUpdateProPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProFormUpdateProPriceMutation, ProFormUpdateProPriceMutationVariables>(ProFormUpdateProPriceDocument, options);
      }
export type ProFormUpdateProPriceMutationHookResult = ReturnType<typeof useProFormUpdateProPriceMutation>;
export type ProFormUpdateProPriceMutationResult = ApolloReactCommon.MutationResult<ProFormUpdateProPriceMutation>;
export type ProFormUpdateProPriceMutationOptions = ApolloReactCommon.BaseMutationOptions<ProFormUpdateProPriceMutation, ProFormUpdateProPriceMutationVariables>;
export const ProFormUpdateGoogleReviewLinkDocument = gql`
    mutation proFormUpdateGoogleReviewLink($googleReviewLinkId: Int!, $googleReviewLink: GoogleReviewLinkSetInput!) {
  updateGoogleReviewLinkByPk(
    pkColumns: {id: $googleReviewLinkId}
    _set: $googleReviewLink
  ) {
    id
  }
}
    `;
export type ProFormUpdateGoogleReviewLinkMutationFn = ApolloReactCommon.MutationFunction<ProFormUpdateGoogleReviewLinkMutation, ProFormUpdateGoogleReviewLinkMutationVariables>;

/**
 * __useProFormUpdateGoogleReviewLinkMutation__
 *
 * To run a mutation, you first call `useProFormUpdateGoogleReviewLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProFormUpdateGoogleReviewLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proFormUpdateGoogleReviewLinkMutation, { data, loading, error }] = useProFormUpdateGoogleReviewLinkMutation({
 *   variables: {
 *      googleReviewLinkId: // value for 'googleReviewLinkId'
 *      googleReviewLink: // value for 'googleReviewLink'
 *   },
 * });
 */
export function useProFormUpdateGoogleReviewLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProFormUpdateGoogleReviewLinkMutation, ProFormUpdateGoogleReviewLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProFormUpdateGoogleReviewLinkMutation, ProFormUpdateGoogleReviewLinkMutationVariables>(ProFormUpdateGoogleReviewLinkDocument, options);
      }
export type ProFormUpdateGoogleReviewLinkMutationHookResult = ReturnType<typeof useProFormUpdateGoogleReviewLinkMutation>;
export type ProFormUpdateGoogleReviewLinkMutationResult = ApolloReactCommon.MutationResult<ProFormUpdateGoogleReviewLinkMutation>;
export type ProFormUpdateGoogleReviewLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<ProFormUpdateGoogleReviewLinkMutation, ProFormUpdateGoogleReviewLinkMutationVariables>;
export const ProFormUpdateProViewGoogleReviewLinkDocument = gql`
    mutation proFormUpdateProViewGoogleReviewLink($proViewId: Int!, $googleReviewLinkId: Int!) {
  updateProViewByPk(
    pkColumns: {id: $proViewId}
    _set: {googleReviewLinkId: $googleReviewLinkId}
  ) {
    id
  }
}
    `;
export type ProFormUpdateProViewGoogleReviewLinkMutationFn = ApolloReactCommon.MutationFunction<ProFormUpdateProViewGoogleReviewLinkMutation, ProFormUpdateProViewGoogleReviewLinkMutationVariables>;

/**
 * __useProFormUpdateProViewGoogleReviewLinkMutation__
 *
 * To run a mutation, you first call `useProFormUpdateProViewGoogleReviewLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProFormUpdateProViewGoogleReviewLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proFormUpdateProViewGoogleReviewLinkMutation, { data, loading, error }] = useProFormUpdateProViewGoogleReviewLinkMutation({
 *   variables: {
 *      proViewId: // value for 'proViewId'
 *      googleReviewLinkId: // value for 'googleReviewLinkId'
 *   },
 * });
 */
export function useProFormUpdateProViewGoogleReviewLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProFormUpdateProViewGoogleReviewLinkMutation, ProFormUpdateProViewGoogleReviewLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProFormUpdateProViewGoogleReviewLinkMutation, ProFormUpdateProViewGoogleReviewLinkMutationVariables>(ProFormUpdateProViewGoogleReviewLinkDocument, options);
      }
export type ProFormUpdateProViewGoogleReviewLinkMutationHookResult = ReturnType<typeof useProFormUpdateProViewGoogleReviewLinkMutation>;
export type ProFormUpdateProViewGoogleReviewLinkMutationResult = ApolloReactCommon.MutationResult<ProFormUpdateProViewGoogleReviewLinkMutation>;
export type ProFormUpdateProViewGoogleReviewLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<ProFormUpdateProViewGoogleReviewLinkMutation, ProFormUpdateProViewGoogleReviewLinkMutationVariables>;
export const ProFormUpdateProMediaObjectDocument = gql`
    mutation proFormUpdateProMediaObject($proMediaObjectId: Int!, $proMediaObject: ProMediaObjectSetInput!) {
  updateProMediaObjectByPk(
    pkColumns: {id: $proMediaObjectId}
    _set: $proMediaObject
  ) {
    id
  }
}
    `;
export type ProFormUpdateProMediaObjectMutationFn = ApolloReactCommon.MutationFunction<ProFormUpdateProMediaObjectMutation, ProFormUpdateProMediaObjectMutationVariables>;

/**
 * __useProFormUpdateProMediaObjectMutation__
 *
 * To run a mutation, you first call `useProFormUpdateProMediaObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProFormUpdateProMediaObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proFormUpdateProMediaObjectMutation, { data, loading, error }] = useProFormUpdateProMediaObjectMutation({
 *   variables: {
 *      proMediaObjectId: // value for 'proMediaObjectId'
 *      proMediaObject: // value for 'proMediaObject'
 *   },
 * });
 */
export function useProFormUpdateProMediaObjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProFormUpdateProMediaObjectMutation, ProFormUpdateProMediaObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProFormUpdateProMediaObjectMutation, ProFormUpdateProMediaObjectMutationVariables>(ProFormUpdateProMediaObjectDocument, options);
      }
export type ProFormUpdateProMediaObjectMutationHookResult = ReturnType<typeof useProFormUpdateProMediaObjectMutation>;
export type ProFormUpdateProMediaObjectMutationResult = ApolloReactCommon.MutationResult<ProFormUpdateProMediaObjectMutation>;
export type ProFormUpdateProMediaObjectMutationOptions = ApolloReactCommon.BaseMutationOptions<ProFormUpdateProMediaObjectMutation, ProFormUpdateProMediaObjectMutationVariables>;
export const ProFormUpdateProViewProPersonDocument = gql`
    mutation proFormUpdateProViewProPerson($proViewId: Int!, $proPersonId: Int!, $proViewProPerson: ProViewProPersonSetInput) {
  updateProViewProPersonByPk(
    pkColumns: {proPersonId: $proPersonId, proViewId: $proViewId}
    _set: $proViewProPerson
  ) {
    proPersonId
    proViewId
  }
}
    `;
export type ProFormUpdateProViewProPersonMutationFn = ApolloReactCommon.MutationFunction<ProFormUpdateProViewProPersonMutation, ProFormUpdateProViewProPersonMutationVariables>;

/**
 * __useProFormUpdateProViewProPersonMutation__
 *
 * To run a mutation, you first call `useProFormUpdateProViewProPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProFormUpdateProViewProPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proFormUpdateProViewProPersonMutation, { data, loading, error }] = useProFormUpdateProViewProPersonMutation({
 *   variables: {
 *      proViewId: // value for 'proViewId'
 *      proPersonId: // value for 'proPersonId'
 *      proViewProPerson: // value for 'proViewProPerson'
 *   },
 * });
 */
export function useProFormUpdateProViewProPersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProFormUpdateProViewProPersonMutation, ProFormUpdateProViewProPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProFormUpdateProViewProPersonMutation, ProFormUpdateProViewProPersonMutationVariables>(ProFormUpdateProViewProPersonDocument, options);
      }
export type ProFormUpdateProViewProPersonMutationHookResult = ReturnType<typeof useProFormUpdateProViewProPersonMutation>;
export type ProFormUpdateProViewProPersonMutationResult = ApolloReactCommon.MutationResult<ProFormUpdateProViewProPersonMutation>;
export type ProFormUpdateProViewProPersonMutationOptions = ApolloReactCommon.BaseMutationOptions<ProFormUpdateProViewProPersonMutation, ProFormUpdateProViewProPersonMutationVariables>;
export const ProFormUpdateQueryDocument = gql`
    query proFormUpdateQuery($id: Int!) {
  proViewByPk(id: $id) {
    id
    hasContact
    hasQuotation
    dateCreated
    isLocalBusiness
    isCallsDisabled
    isSolicitationsDisabled
    isEnglishSpeaker
    isSmsDisabled
    isCallAlertActivated
    isCallRecordable
    openingHours
    priceComment
    phoneNumbers {
      id
      number
      tag
    }
    averageResponseDays
    averageQuotationDays
    averageProjectDays
    status
    callTrackingTarget
    callTrackingForward
    avatarHash
    originalAvatarHash
    datePublished
    note
    isMainCityCenterExcluded
    dateArchiveScheduled
    emailTarget
    trades {
      trade {
        id
      }
    }
    bilikZone {
      id
      mainCityCode
      slug
    }
    cities {
      type
      city {
        id
        parentId
      }
    }
    proPrices(orderBy: {id: ASC}) {
      id
      title
      content
      isRepair
    }
    proMessages {
      id
      body
      isPermanent
      startDate
      endDate
    }
    colleagues {
      proView {
        id
      }
    }
    proPeople(orderBy: {position: ASC}) {
      position
      isVisible
      proPerson {
        id
      }
    }
    accounts {
      authUserId
    }
    proPostalAddress {
      proViewId
      street
      city
      postalCode
      displayOption
      geoCoordinates
      cityGeoCoordinates
    }
    googleReviewLink {
      id
      url
    }
    proPresentation {
      id
      name
      slug
      profile
      hobbies
      expertise1
      expertise11
      expertise12
      expertise13
      expertise14
      expertise15
      expertise16
      expertise2
      expertise21
      expertise22
      expertise23
      expertise24
      expertise25
      expertise26
      expertise3
      expertise31
      expertise32
      expertise33
      expertise34
      expertise35
      expertise36
      extra1
      extra2
      extra3
      extra4
      extra5
      isRge
      certifications {
        certification {
          id
        }
      }
      mainTradeNames
      mainTrades {
        trade {
          id
          slug
        }
      }
      companyId
      googleReviewLinks {
        id
        url
        proPresentationId
        proViews {
          id
        }
      }
      proMediaObjects {
        id
        hash
        position
      }
      proViews {
        id
        bilikZone {
          id
          mainCityCode
        }
        trades {
          trade {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProFormUpdateQuery__
 *
 * To run a query within a React component, call `useProFormUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProFormUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProFormUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProFormUpdateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProFormUpdateQuery, ProFormUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProFormUpdateQuery, ProFormUpdateQueryVariables>(ProFormUpdateQueryDocument, options);
      }
export function useProFormUpdateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProFormUpdateQuery, ProFormUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProFormUpdateQuery, ProFormUpdateQueryVariables>(ProFormUpdateQueryDocument, options);
        }
export type ProFormUpdateQueryHookResult = ReturnType<typeof useProFormUpdateQuery>;
export type ProFormUpdateQueryLazyQueryHookResult = ReturnType<typeof useProFormUpdateQueryLazyQuery>;
export type ProFormUpdateQueryQueryResult = ApolloReactCommon.QueryResult<ProFormUpdateQuery, ProFormUpdateQueryVariables>;
export const ProFormUpdateFetchCompanyDocument = gql`
    query proFormUpdateFetchCompany($id: Int!) {
  companyByPk(id: $id) {
    proPresentations {
      id
      mainTradeNames
      mainTrades {
        trade {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useProFormUpdateFetchCompanyQuery__
 *
 * To run a query within a React component, call `useProFormUpdateFetchCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProFormUpdateFetchCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProFormUpdateFetchCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProFormUpdateFetchCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProFormUpdateFetchCompanyQuery, ProFormUpdateFetchCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProFormUpdateFetchCompanyQuery, ProFormUpdateFetchCompanyQueryVariables>(ProFormUpdateFetchCompanyDocument, options);
      }
export function useProFormUpdateFetchCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProFormUpdateFetchCompanyQuery, ProFormUpdateFetchCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProFormUpdateFetchCompanyQuery, ProFormUpdateFetchCompanyQueryVariables>(ProFormUpdateFetchCompanyDocument, options);
        }
export type ProFormUpdateFetchCompanyQueryHookResult = ReturnType<typeof useProFormUpdateFetchCompanyQuery>;
export type ProFormUpdateFetchCompanyLazyQueryHookResult = ReturnType<typeof useProFormUpdateFetchCompanyLazyQuery>;
export type ProFormUpdateFetchCompanyQueryResult = ApolloReactCommon.QueryResult<ProFormUpdateFetchCompanyQuery, ProFormUpdateFetchCompanyQueryVariables>;
export const ProInfosQueryDocument = gql`
    query proInfosQuery($proViewId: Int!) {
  proViewByPk(id: $proViewId) {
    id
    datePublished
    dateCreated
    dateArchived
    dateArchiveScheduled
    archiveReason
    status
    proPresentation {
      id
      mainTradeNames
      company {
        firstDatePublished {
          date
        }
      }
      averageRating
      publishedReviewCount
      pendingReviewCount
    }
  }
}
    `;

/**
 * __useProInfosQuery__
 *
 * To run a query within a React component, call `useProInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useProInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProInfosQuery({
 *   variables: {
 *      proViewId: // value for 'proViewId'
 *   },
 * });
 */
export function useProInfosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProInfosQuery, ProInfosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProInfosQuery, ProInfosQueryVariables>(ProInfosQueryDocument, options);
      }
export function useProInfosQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProInfosQuery, ProInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProInfosQuery, ProInfosQueryVariables>(ProInfosQueryDocument, options);
        }
export type ProInfosQueryHookResult = ReturnType<typeof useProInfosQuery>;
export type ProInfosQueryLazyQueryHookResult = ReturnType<typeof useProInfosQueryLazyQuery>;
export type ProInfosQueryQueryResult = ApolloReactCommon.QueryResult<ProInfosQuery, ProInfosQueryVariables>;
export const InsertProCertificationRgeMutationDocument = gql`
    mutation insertProCertificationRgeMutation($proPresentationId: Int!) {
  insertProCertificationOne(
    object: {certificationId: 1, proPresentationId: $proPresentationId}
    onConflict: {constraint: pro_certification_pkey, updateColumns: [certificationId, proPresentationId]}
  ) {
    certificationId
    proPresentationId
  }
}
    `;
export type InsertProCertificationRgeMutationMutationFn = ApolloReactCommon.MutationFunction<InsertProCertificationRgeMutation, InsertProCertificationRgeMutationVariables>;

/**
 * __useInsertProCertificationRgeMutation__
 *
 * To run a mutation, you first call `useInsertProCertificationRgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertProCertificationRgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertProCertificationRgeMutation, { data, loading, error }] = useInsertProCertificationRgeMutation({
 *   variables: {
 *      proPresentationId: // value for 'proPresentationId'
 *   },
 * });
 */
export function useInsertProCertificationRgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertProCertificationRgeMutation, InsertProCertificationRgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertProCertificationRgeMutation, InsertProCertificationRgeMutationVariables>(InsertProCertificationRgeMutationDocument, options);
      }
export type InsertProCertificationRgeMutationHookResult = ReturnType<typeof useInsertProCertificationRgeMutation>;
export type InsertProCertificationRgeMutationMutationResult = ApolloReactCommon.MutationResult<InsertProCertificationRgeMutation>;
export type InsertProCertificationRgeMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertProCertificationRgeMutation, InsertProCertificationRgeMutationVariables>;
export const DeleteProCertificationRgeMutationDocument = gql`
    mutation deleteProCertificationRgeMutation($proPresentationId: Int!) {
  deleteProCertification(
    where: {proPresentationId: {_eq: $proPresentationId}, certificationId: {_eq: 1}}
  ) {
    affectedRows
  }
}
    `;
export type DeleteProCertificationRgeMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteProCertificationRgeMutation, DeleteProCertificationRgeMutationVariables>;

/**
 * __useDeleteProCertificationRgeMutation__
 *
 * To run a mutation, you first call `useDeleteProCertificationRgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProCertificationRgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProCertificationRgeMutation, { data, loading, error }] = useDeleteProCertificationRgeMutation({
 *   variables: {
 *      proPresentationId: // value for 'proPresentationId'
 *   },
 * });
 */
export function useDeleteProCertificationRgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProCertificationRgeMutation, DeleteProCertificationRgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProCertificationRgeMutation, DeleteProCertificationRgeMutationVariables>(DeleteProCertificationRgeMutationDocument, options);
      }
export type DeleteProCertificationRgeMutationHookResult = ReturnType<typeof useDeleteProCertificationRgeMutation>;
export type DeleteProCertificationRgeMutationMutationResult = ApolloReactCommon.MutationResult<DeleteProCertificationRgeMutation>;
export type DeleteProCertificationRgeMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProCertificationRgeMutation, DeleteProCertificationRgeMutationVariables>;
export const ProLabelsMutationDocument = gql`
    mutation proLabelsMutation($id: Int!, $isVisible: Boolean!) {
  updateProLabelByPk(pkColumns: {id: $id}, _set: {isVisible: $isVisible}) {
    id
  }
}
    `;
export type ProLabelsMutationMutationFn = ApolloReactCommon.MutationFunction<ProLabelsMutation, ProLabelsMutationVariables>;

/**
 * __useProLabelsMutation__
 *
 * To run a mutation, you first call `useProLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proLabelsMutation, { data, loading, error }] = useProLabelsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isVisible: // value for 'isVisible'
 *   },
 * });
 */
export function useProLabelsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProLabelsMutation, ProLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProLabelsMutation, ProLabelsMutationVariables>(ProLabelsMutationDocument, options);
      }
export type ProLabelsMutationHookResult = ReturnType<typeof useProLabelsMutation>;
export type ProLabelsMutationMutationResult = ApolloReactCommon.MutationResult<ProLabelsMutation>;
export type ProLabelsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ProLabelsMutation, ProLabelsMutationVariables>;
export const ProLabelsQueryDocument = gql`
    query proLabelsQuery($proPresentationId: Int!) {
  proLabels: proLabel(
    orderBy: {certificateName: ASC, domain: ASC}
    where: {proPresentationId: {_eq: $proPresentationId}}
  ) {
    id
    certificateName
    domain
    qualificationUrl
    dateChecked
    isVisible
    isCheckActive
  }
  certifications: certification(orderBy: {id: ASC}, where: {slug: {_neq: "rge"}}) {
    id
    name
  }
}
    `;

/**
 * __useProLabelsQuery__
 *
 * To run a query within a React component, call `useProLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProLabelsQuery({
 *   variables: {
 *      proPresentationId: // value for 'proPresentationId'
 *   },
 * });
 */
export function useProLabelsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProLabelsQuery, ProLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProLabelsQuery, ProLabelsQueryVariables>(ProLabelsQueryDocument, options);
      }
export function useProLabelsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProLabelsQuery, ProLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProLabelsQuery, ProLabelsQueryVariables>(ProLabelsQueryDocument, options);
        }
export type ProLabelsQueryHookResult = ReturnType<typeof useProLabelsQuery>;
export type ProLabelsQueryLazyQueryHookResult = ReturnType<typeof useProLabelsQueryLazyQuery>;
export type ProLabelsQueryQueryResult = ApolloReactCommon.QueryResult<ProLabelsQuery, ProLabelsQueryVariables>;
export const ProMandateUpdateByPkMutationDocument = gql`
    mutation proMandateUpdateByPkMutation($proMandateId: Int!, $proMandateInput: ProMandateSetInput!) {
  updateProMandateByPk(pkColumns: {id: $proMandateId}, _set: $proMandateInput) {
    id
  }
}
    `;
export type ProMandateUpdateByPkMutationMutationFn = ApolloReactCommon.MutationFunction<ProMandateUpdateByPkMutation, ProMandateUpdateByPkMutationVariables>;

/**
 * __useProMandateUpdateByPkMutation__
 *
 * To run a mutation, you first call `useProMandateUpdateByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProMandateUpdateByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proMandateUpdateByPkMutation, { data, loading, error }] = useProMandateUpdateByPkMutation({
 *   variables: {
 *      proMandateId: // value for 'proMandateId'
 *      proMandateInput: // value for 'proMandateInput'
 *   },
 * });
 */
export function useProMandateUpdateByPkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProMandateUpdateByPkMutation, ProMandateUpdateByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProMandateUpdateByPkMutation, ProMandateUpdateByPkMutationVariables>(ProMandateUpdateByPkMutationDocument, options);
      }
export type ProMandateUpdateByPkMutationHookResult = ReturnType<typeof useProMandateUpdateByPkMutation>;
export type ProMandateUpdateByPkMutationMutationResult = ApolloReactCommon.MutationResult<ProMandateUpdateByPkMutation>;
export type ProMandateUpdateByPkMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ProMandateUpdateByPkMutation, ProMandateUpdateByPkMutationVariables>;
export const ProMandatesQueryDocument = gql`
    query proMandatesQuery($companyId: Int!) {
  proMandate(orderBy: {dateCreated: DESC}, where: {companyId: {_eq: $companyId}}) {
    bic
    dateArchived
    dateCreated
    dateSigned
    iban
    id
    rum
    status
    fileName
    zohoOrganizationId
    zohoOrganization {
      name
    }
  }
}
    `;

/**
 * __useProMandatesQuery__
 *
 * To run a query within a React component, call `useProMandatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProMandatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProMandatesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useProMandatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProMandatesQuery, ProMandatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProMandatesQuery, ProMandatesQueryVariables>(ProMandatesQueryDocument, options);
      }
export function useProMandatesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProMandatesQuery, ProMandatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProMandatesQuery, ProMandatesQueryVariables>(ProMandatesQueryDocument, options);
        }
export type ProMandatesQueryHookResult = ReturnType<typeof useProMandatesQuery>;
export type ProMandatesQueryLazyQueryHookResult = ReturnType<typeof useProMandatesQueryLazyQuery>;
export type ProMandatesQueryQueryResult = ApolloReactCommon.QueryResult<ProMandatesQuery, ProMandatesQueryVariables>;
export const ProPhoneNumbersQueryDocument = gql`
    query proPhoneNumbersQuery($proViewId: Int!) {
  phoneNumber(where: {proViewId: {_eq: $proViewId}}) {
    id
    number
    tag
  }
}
    `;

/**
 * __useProPhoneNumbersQuery__
 *
 * To run a query within a React component, call `useProPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProPhoneNumbersQuery({
 *   variables: {
 *      proViewId: // value for 'proViewId'
 *   },
 * });
 */
export function useProPhoneNumbersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProPhoneNumbersQuery, ProPhoneNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProPhoneNumbersQuery, ProPhoneNumbersQueryVariables>(ProPhoneNumbersQueryDocument, options);
      }
export function useProPhoneNumbersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProPhoneNumbersQuery, ProPhoneNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProPhoneNumbersQuery, ProPhoneNumbersQueryVariables>(ProPhoneNumbersQueryDocument, options);
        }
export type ProPhoneNumbersQueryHookResult = ReturnType<typeof useProPhoneNumbersQuery>;
export type ProPhoneNumbersQueryLazyQueryHookResult = ReturnType<typeof useProPhoneNumbersQueryLazyQuery>;
export type ProPhoneNumbersQueryQueryResult = ApolloReactCommon.QueryResult<ProPhoneNumbersQuery, ProPhoneNumbersQueryVariables>;
export const ProPreviewGuideQueryDocument = gql`
    query proPreviewGuideQuery($proViewId: Int!) {
  proViewByPk(id: $proViewId) {
    proPeople(orderBy: {position: ASC}, where: {isVisible: {_eq: true}}) {
      proPerson {
        givenName
        familyName
      }
    }
    bilikZone {
      guideName
    }
  }
}
    `;

/**
 * __useProPreviewGuideQuery__
 *
 * To run a query within a React component, call `useProPreviewGuideQuery` and pass it any options that fit your needs.
 * When your component renders, `useProPreviewGuideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProPreviewGuideQuery({
 *   variables: {
 *      proViewId: // value for 'proViewId'
 *   },
 * });
 */
export function useProPreviewGuideQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProPreviewGuideQuery, ProPreviewGuideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProPreviewGuideQuery, ProPreviewGuideQueryVariables>(ProPreviewGuideQueryDocument, options);
      }
export function useProPreviewGuideQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProPreviewGuideQuery, ProPreviewGuideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProPreviewGuideQuery, ProPreviewGuideQueryVariables>(ProPreviewGuideQueryDocument, options);
        }
export type ProPreviewGuideQueryHookResult = ReturnType<typeof useProPreviewGuideQuery>;
export type ProPreviewGuideQueryLazyQueryHookResult = ReturnType<typeof useProPreviewGuideQueryLazyQuery>;
export type ProPreviewGuideQueryQueryResult = ApolloReactCommon.QueryResult<ProPreviewGuideQuery, ProPreviewGuideQueryVariables>;
export const ProPublishButtonGetValidDataQueryDocument = gql`
    query proPublishButtonGetValidDataQuery($proViewId: Int!) {
  proViewByPk(id: $proViewId) {
    id
    contractConfiguration
    contractEvents
    proPresentation {
      company {
        proMandates(where: {status: {_in: ["signed", "import"]}}) {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useProPublishButtonGetValidDataQuery__
 *
 * To run a query within a React component, call `useProPublishButtonGetValidDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProPublishButtonGetValidDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProPublishButtonGetValidDataQuery({
 *   variables: {
 *      proViewId: // value for 'proViewId'
 *   },
 * });
 */
export function useProPublishButtonGetValidDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProPublishButtonGetValidDataQuery, ProPublishButtonGetValidDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProPublishButtonGetValidDataQuery, ProPublishButtonGetValidDataQueryVariables>(ProPublishButtonGetValidDataQueryDocument, options);
      }
export function useProPublishButtonGetValidDataQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProPublishButtonGetValidDataQuery, ProPublishButtonGetValidDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProPublishButtonGetValidDataQuery, ProPublishButtonGetValidDataQueryVariables>(ProPublishButtonGetValidDataQueryDocument, options);
        }
export type ProPublishButtonGetValidDataQueryHookResult = ReturnType<typeof useProPublishButtonGetValidDataQuery>;
export type ProPublishButtonGetValidDataQueryLazyQueryHookResult = ReturnType<typeof useProPublishButtonGetValidDataQueryLazyQuery>;
export type ProPublishButtonGetValidDataQueryQueryResult = ApolloReactCommon.QueryResult<ProPublishButtonGetValidDataQuery, ProPublishButtonGetValidDataQueryVariables>;
export const CompanyRouteQueryDocument = gql`
    query companyRouteQuery($proPeopleIds: [Int!], $bilikZoneId: Int!) {
  proPerson(where: {id: {_in: $proPeopleIds}}) {
    id
    email
    givenName
    familyName
    telephone
  }
  zohoOrganization(where: {bilikZones: {id: {_eq: $bilikZoneId}}}) {
    id
  }
}
    `;

/**
 * __useCompanyRouteQuery__
 *
 * To run a query within a React component, call `useCompanyRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyRouteQuery({
 *   variables: {
 *      proPeopleIds: // value for 'proPeopleIds'
 *      bilikZoneId: // value for 'bilikZoneId'
 *   },
 * });
 */
export function useCompanyRouteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyRouteQuery, CompanyRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyRouteQuery, CompanyRouteQueryVariables>(CompanyRouteQueryDocument, options);
      }
export function useCompanyRouteQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyRouteQuery, CompanyRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyRouteQuery, CompanyRouteQueryVariables>(CompanyRouteQueryDocument, options);
        }
export type CompanyRouteQueryHookResult = ReturnType<typeof useCompanyRouteQuery>;
export type CompanyRouteQueryLazyQueryHookResult = ReturnType<typeof useCompanyRouteQueryLazyQuery>;
export type CompanyRouteQueryQueryResult = ApolloReactCommon.QueryResult<CompanyRouteQuery, CompanyRouteQueryVariables>;
export const ProSectorsRouteQueryDocument = gql`
    query proSectorsRouteQuery($bilikZoneId: Int!, $proPresentationId: Int!, $proViewId: Int!) {
  bilikZoneByPk(id: $bilikZoneId) {
    mainCity {
      name
      area
    }
  }
  proPresentationByPk(id: $proPresentationId) {
    proViews(where: {status: {_neq: "archived"}, id: {_neq: $proViewId}}) {
      interventionInclude
      interventionExclude
    }
  }
}
    `;

/**
 * __useProSectorsRouteQuery__
 *
 * To run a query within a React component, call `useProSectorsRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useProSectorsRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProSectorsRouteQuery({
 *   variables: {
 *      bilikZoneId: // value for 'bilikZoneId'
 *      proPresentationId: // value for 'proPresentationId'
 *      proViewId: // value for 'proViewId'
 *   },
 * });
 */
export function useProSectorsRouteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProSectorsRouteQuery, ProSectorsRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProSectorsRouteQuery, ProSectorsRouteQueryVariables>(ProSectorsRouteQueryDocument, options);
      }
export function useProSectorsRouteQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProSectorsRouteQuery, ProSectorsRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProSectorsRouteQuery, ProSectorsRouteQueryVariables>(ProSectorsRouteQueryDocument, options);
        }
export type ProSectorsRouteQueryHookResult = ReturnType<typeof useProSectorsRouteQuery>;
export type ProSectorsRouteQueryLazyQueryHookResult = ReturnType<typeof useProSectorsRouteQueryLazyQuery>;
export type ProSectorsRouteQueryQueryResult = ApolloReactCommon.QueryResult<ProSectorsRouteQuery, ProSectorsRouteQueryVariables>;
export const ProViewRouteQueryDocument = gql`
    query proViewRouteQuery($proViewId: Int!) {
  proViewByPk(id: $proViewId) {
    proPresentation {
      mainTradeNames
      mainTrades {
        trade {
          tradeGuides {
            tradeGuide {
              name
            }
          }
          id
        }
      }
      proViews {
        id
        bilikZone {
          id
          mainCityCode
        }
        trades {
          trade {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProViewRouteQuery__
 *
 * To run a query within a React component, call `useProViewRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useProViewRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProViewRouteQuery({
 *   variables: {
 *      proViewId: // value for 'proViewId'
 *   },
 * });
 */
export function useProViewRouteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProViewRouteQuery, ProViewRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProViewRouteQuery, ProViewRouteQueryVariables>(ProViewRouteQueryDocument, options);
      }
export function useProViewRouteQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProViewRouteQuery, ProViewRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProViewRouteQuery, ProViewRouteQueryVariables>(ProViewRouteQueryDocument, options);
        }
export type ProViewRouteQueryHookResult = ReturnType<typeof useProViewRouteQuery>;
export type ProViewRouteQueryLazyQueryHookResult = ReturnType<typeof useProViewRouteQueryLazyQuery>;
export type ProViewRouteQueryQueryResult = ApolloReactCommon.QueryResult<ProViewRouteQuery, ProViewRouteQueryVariables>;
export const ProReviewInvitationsCountByDateQueryDocument = gql`
    query proReviewInvitationsCountByDateQuery($before: timestamptz!, $after: timestamptz!, $proPresentationId: Int!) {
  countProReviewInvitationsByMonthByProPresentation(
    where: {month: {_gte: $before, _lte: $after}, proPresentationId: {_eq: $proPresentationId}}
  ) {
    count
    month
  }
}
    `;

/**
 * __useProReviewInvitationsCountByDateQuery__
 *
 * To run a query within a React component, call `useProReviewInvitationsCountByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewInvitationsCountByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewInvitationsCountByDateQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      proPresentationId: // value for 'proPresentationId'
 *   },
 * });
 */
export function useProReviewInvitationsCountByDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProReviewInvitationsCountByDateQuery, ProReviewInvitationsCountByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewInvitationsCountByDateQuery, ProReviewInvitationsCountByDateQueryVariables>(ProReviewInvitationsCountByDateQueryDocument, options);
      }
export function useProReviewInvitationsCountByDateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewInvitationsCountByDateQuery, ProReviewInvitationsCountByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewInvitationsCountByDateQuery, ProReviewInvitationsCountByDateQueryVariables>(ProReviewInvitationsCountByDateQueryDocument, options);
        }
export type ProReviewInvitationsCountByDateQueryHookResult = ReturnType<typeof useProReviewInvitationsCountByDateQuery>;
export type ProReviewInvitationsCountByDateQueryLazyQueryHookResult = ReturnType<typeof useProReviewInvitationsCountByDateQueryLazyQuery>;
export type ProReviewInvitationsCountByDateQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewInvitationsCountByDateQuery, ProReviewInvitationsCountByDateQueryVariables>;
export const ProReviewsCountByDateQueryDocument = gql`
    query proReviewsCountByDateQuery($before: timestamptz!, $after: timestamptz!, $proPresentationId: Int!) {
  countProReviewsWithStatusOkByMonthByProPresentation(
    where: {month: {_gte: $before, _lte: $after}, proPresentationId: {_eq: $proPresentationId}}
  ) {
    count
    month
  }
}
    `;

/**
 * __useProReviewsCountByDateQuery__
 *
 * To run a query within a React component, call `useProReviewsCountByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProReviewsCountByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProReviewsCountByDateQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      proPresentationId: // value for 'proPresentationId'
 *   },
 * });
 */
export function useProReviewsCountByDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProReviewsCountByDateQuery, ProReviewsCountByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProReviewsCountByDateQuery, ProReviewsCountByDateQueryVariables>(ProReviewsCountByDateQueryDocument, options);
      }
export function useProReviewsCountByDateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProReviewsCountByDateQuery, ProReviewsCountByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProReviewsCountByDateQuery, ProReviewsCountByDateQueryVariables>(ProReviewsCountByDateQueryDocument, options);
        }
export type ProReviewsCountByDateQueryHookResult = ReturnType<typeof useProReviewsCountByDateQuery>;
export type ProReviewsCountByDateQueryLazyQueryHookResult = ReturnType<typeof useProReviewsCountByDateQueryLazyQuery>;
export type ProReviewsCountByDateQueryQueryResult = ApolloReactCommon.QueryResult<ProReviewsCountByDateQuery, ProReviewsCountByDateQueryVariables>;
export const ProSolicitationsByDateQueryDocument = gql`
    query proSolicitationsByDateQuery($before: timestamptz!, $after: timestamptz!, $proViewId: Int!) {
  solicitationStat(
    where: {dateCreated: {_gte: $before, _lte: $after}, proViewId: {_eq: $proViewId}}
  ) {
    dateCreated
    email
  }
}
    `;

/**
 * __useProSolicitationsByDateQuery__
 *
 * To run a query within a React component, call `useProSolicitationsByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProSolicitationsByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProSolicitationsByDateQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      proViewId: // value for 'proViewId'
 *   },
 * });
 */
export function useProSolicitationsByDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProSolicitationsByDateQuery, ProSolicitationsByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProSolicitationsByDateQuery, ProSolicitationsByDateQueryVariables>(ProSolicitationsByDateQueryDocument, options);
      }
export function useProSolicitationsByDateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProSolicitationsByDateQuery, ProSolicitationsByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProSolicitationsByDateQuery, ProSolicitationsByDateQueryVariables>(ProSolicitationsByDateQueryDocument, options);
        }
export type ProSolicitationsByDateQueryHookResult = ReturnType<typeof useProSolicitationsByDateQuery>;
export type ProSolicitationsByDateQueryLazyQueryHookResult = ReturnType<typeof useProSolicitationsByDateQueryLazyQuery>;
export type ProSolicitationsByDateQueryQueryResult = ApolloReactCommon.QueryResult<ProSolicitationsByDateQuery, ProSolicitationsByDateQueryVariables>;
export const ProSubscriptionTableGetBilikPeopleDocument = gql`
    query proSubscriptionTableGetBilikPeople($ids: [Int!]!) {
  bilikPeople: bilikPerson(where: {id: {_in: $ids}}) {
    id
    givenName
    familyName
  }
}
    `;

/**
 * __useProSubscriptionTableGetBilikPeople__
 *
 * To run a query within a React component, call `useProSubscriptionTableGetBilikPeople` and pass it any options that fit your needs.
 * When your component renders, `useProSubscriptionTableGetBilikPeople` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProSubscriptionTableGetBilikPeople({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useProSubscriptionTableGetBilikPeople(baseOptions: ApolloReactHooks.QueryHookOptions<ProSubscriptionTableGetBilikPeopleQuery, ProSubscriptionTableGetBilikPeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProSubscriptionTableGetBilikPeopleQuery, ProSubscriptionTableGetBilikPeopleQueryVariables>(ProSubscriptionTableGetBilikPeopleDocument, options);
      }
export function useProSubscriptionTableGetBilikPeopleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProSubscriptionTableGetBilikPeopleQuery, ProSubscriptionTableGetBilikPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProSubscriptionTableGetBilikPeopleQuery, ProSubscriptionTableGetBilikPeopleQueryVariables>(ProSubscriptionTableGetBilikPeopleDocument, options);
        }
export type ProSubscriptionTableGetBilikPeopleHookResult = ReturnType<typeof useProSubscriptionTableGetBilikPeople>;
export type ProSubscriptionTableGetBilikPeopleLazyQueryHookResult = ReturnType<typeof useProSubscriptionTableGetBilikPeopleLazyQuery>;
export type ProSubscriptionTableGetBilikPeopleQueryResult = ApolloReactCommon.QueryResult<ProSubscriptionTableGetBilikPeopleQuery, ProSubscriptionTableGetBilikPeopleQueryVariables>;
export const ProSubscriptionsGetValidMandateDocument = gql`
    query proSubscriptionsGetValidMandate($companyId: Int!) {
  proMandates: proMandate(
    where: {companyId: {_eq: $companyId}, status: {_in: ["signed", "import"]}}
  ) {
    id
    status
  }
}
    `;

/**
 * __useProSubscriptionsGetValidMandate__
 *
 * To run a query within a React component, call `useProSubscriptionsGetValidMandate` and pass it any options that fit your needs.
 * When your component renders, `useProSubscriptionsGetValidMandate` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProSubscriptionsGetValidMandate({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useProSubscriptionsGetValidMandate(baseOptions: ApolloReactHooks.QueryHookOptions<ProSubscriptionsGetValidMandateQuery, ProSubscriptionsGetValidMandateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProSubscriptionsGetValidMandateQuery, ProSubscriptionsGetValidMandateQueryVariables>(ProSubscriptionsGetValidMandateDocument, options);
      }
export function useProSubscriptionsGetValidMandateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProSubscriptionsGetValidMandateQuery, ProSubscriptionsGetValidMandateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProSubscriptionsGetValidMandateQuery, ProSubscriptionsGetValidMandateQueryVariables>(ProSubscriptionsGetValidMandateDocument, options);
        }
export type ProSubscriptionsGetValidMandateHookResult = ReturnType<typeof useProSubscriptionsGetValidMandate>;
export type ProSubscriptionsGetValidMandateLazyQueryHookResult = ReturnType<typeof useProSubscriptionsGetValidMandateLazyQuery>;
export type ProSubscriptionsGetValidMandateQueryResult = ApolloReactCommon.QueryResult<ProSubscriptionsGetValidMandateQuery, ProSubscriptionsGetValidMandateQueryVariables>;
export const ProZonesQueryDocument = gql`
    query proZonesQuery($proPresentationId: Int!) {
  proPresentations: proPresentation(
    where: {_or: [{id: {_eq: $proPresentationId}}, {company: {proPresentations: {id: {_eq: $proPresentationId}}}}]}
  ) {
    mainTrades {
      trade {
        label
      }
    }
    proViews {
      id
      status
      bilikZone {
        mainCityCode
      }
    }
  }
}
    `;

/**
 * __useProZonesQuery__
 *
 * To run a query within a React component, call `useProZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProZonesQuery({
 *   variables: {
 *      proPresentationId: // value for 'proPresentationId'
 *   },
 * });
 */
export function useProZonesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProZonesQuery, ProZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProZonesQuery, ProZonesQueryVariables>(ProZonesQueryDocument, options);
      }
export function useProZonesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProZonesQuery, ProZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProZonesQuery, ProZonesQueryVariables>(ProZonesQueryDocument, options);
        }
export type ProZonesQueryHookResult = ReturnType<typeof useProZonesQuery>;
export type ProZonesQueryLazyQueryHookResult = ReturnType<typeof useProZonesQueryLazyQuery>;
export type ProZonesQueryQueryResult = ApolloReactCommon.QueryResult<ProZonesQuery, ProZonesQueryVariables>;
export const ProUpdatePageQueryDocument = gql`
    query proUpdatePageQuery($id: Int!) {
  proViewByPk(id: $id) {
    id
    proPresentationId
  }
}
    `;

/**
 * __useProUpdatePageQuery__
 *
 * To run a query within a React component, call `useProUpdatePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProUpdatePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProUpdatePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProUpdatePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProUpdatePageQuery, ProUpdatePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProUpdatePageQuery, ProUpdatePageQueryVariables>(ProUpdatePageQueryDocument, options);
      }
export function useProUpdatePageQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProUpdatePageQuery, ProUpdatePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProUpdatePageQuery, ProUpdatePageQueryVariables>(ProUpdatePageQueryDocument, options);
        }
export type ProUpdatePageQueryHookResult = ReturnType<typeof useProUpdatePageQuery>;
export type ProUpdatePageQueryLazyQueryHookResult = ReturnType<typeof useProUpdatePageQueryLazyQuery>;
export type ProUpdatePageQueryQueryResult = ApolloReactCommon.QueryResult<ProUpdatePageQuery, ProUpdatePageQueryVariables>;
export const ProsTableQueryDocument = gql`
    query prosTableQuery($criteria: String, $limit: Int, $offset: Int, $order_by: [ProViewOrderBy!], $where: ProViewBoolExp) {
  searchProView(
    args: {search: $criteria}
    limit: $limit
    offset: $offset
    orderBy: $order_by
    where: $where
  ) {
    id
    status
    dateArchived
    dateCreated
    datePublished
    activeHoliday {
      endDate
    }
    proPeople(orderBy: {position: ASC}) {
      proPerson {
        id
        givenName
        familyName
      }
    }
    bilikZone {
      id
      mainCity {
        name
      }
      mainCityCode
    }
    trades {
      trade {
        id
        name
      }
    }
    proPresentation {
      id
      name
      slug
      proReviewInvitationsAggregate {
        aggregate {
          count
        }
      }
      averageRating
      mainTrades {
        trade {
          name
          id
        }
      }
    }
  }
}
    `;

/**
 * __useProsTableQuery__
 *
 * To run a query within a React component, call `useProsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useProsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProsTableQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProsTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProsTableQuery, ProsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProsTableQuery, ProsTableQueryVariables>(ProsTableQueryDocument, options);
      }
export function useProsTableQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProsTableQuery, ProsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProsTableQuery, ProsTableQueryVariables>(ProsTableQueryDocument, options);
        }
export type ProsTableQueryHookResult = ReturnType<typeof useProsTableQuery>;
export type ProsTableQueryLazyQueryHookResult = ReturnType<typeof useProsTableQueryLazyQuery>;
export type ProsTableQueryQueryResult = ApolloReactCommon.QueryResult<ProsTableQuery, ProsTableQueryVariables>;
export const TradesGuideTableQueryDocument = gql`
    query tradesGuideTableQuery {
  tradeGuide {
    name
    trades {
      trade {
        name
      }
    }
  }
}
    `;

/**
 * __useTradesGuideTableQuery__
 *
 * To run a query within a React component, call `useTradesGuideTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradesGuideTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradesGuideTableQuery({
 *   variables: {
 *   },
 * });
 */
export function useTradesGuideTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TradesGuideTableQuery, TradesGuideTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradesGuideTableQuery, TradesGuideTableQueryVariables>(TradesGuideTableQueryDocument, options);
      }
export function useTradesGuideTableQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradesGuideTableQuery, TradesGuideTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradesGuideTableQuery, TradesGuideTableQueryVariables>(TradesGuideTableQueryDocument, options);
        }
export type TradesGuideTableQueryHookResult = ReturnType<typeof useTradesGuideTableQuery>;
export type TradesGuideTableQueryLazyQueryHookResult = ReturnType<typeof useTradesGuideTableQueryLazyQuery>;
export type TradesGuideTableQueryQueryResult = ApolloReactCommon.QueryResult<TradesGuideTableQuery, TradesGuideTableQueryVariables>;
export const TradeFormCreateMutationDocument = gql`
    mutation tradeFormCreateMutation($trade: TradeInsertInput!) {
  insertTradeOne(object: $trade) {
    __typename
    id
  }
}
    `;
export type TradeFormCreateMutationMutationFn = ApolloReactCommon.MutationFunction<TradeFormCreateMutation, TradeFormCreateMutationVariables>;

/**
 * __useTradeFormCreateMutation__
 *
 * To run a mutation, you first call `useTradeFormCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTradeFormCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tradeFormCreateMutation, { data, loading, error }] = useTradeFormCreateMutation({
 *   variables: {
 *      trade: // value for 'trade'
 *   },
 * });
 */
export function useTradeFormCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TradeFormCreateMutation, TradeFormCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TradeFormCreateMutation, TradeFormCreateMutationVariables>(TradeFormCreateMutationDocument, options);
      }
export type TradeFormCreateMutationHookResult = ReturnType<typeof useTradeFormCreateMutation>;
export type TradeFormCreateMutationMutationResult = ApolloReactCommon.MutationResult<TradeFormCreateMutation>;
export type TradeFormCreateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<TradeFormCreateMutation, TradeFormCreateMutationVariables>;
export const TradeFormUpdateMutationDocument = gql`
    mutation tradeFormUpdateMutation($tradeId: Int!, $trade: TradeSetInput, $deleteTradeGroupIds: [Int!], $insertTradeGroups: [TradeTradeGroupInsertInput!]!, $insertTradeQuestions: [TradeQuestionInsertInput!]!, $deleteTradeQuestions: [Int!], $insertTradeKeywords: [TradeKeywordInsertInput!]!, $deleteTradeKeyword: [Int!]) {
  updateTradeByPk(pkColumns: {id: $tradeId}, _set: $trade) {
    __typename
    id
  }
  deleteTradeTradeGroup(
    where: {tradeId: {_eq: $tradeId}, _and: {tradeGroupId: {_in: $deleteTradeGroupIds}}}
  ) {
    returning {
      __typename
      tradeGroup {
        __typename
        id
      }
    }
  }
  insertTradeTradeGroup(objects: $insertTradeGroups) {
    returning {
      __typename
      tradeGroup {
        __typename
        id
      }
    }
  }
  insertTradeQuestion(objects: $insertTradeQuestions) {
    affectedRows
  }
  deleteTradeQuestion(where: {id: {_in: $deleteTradeQuestions}}) {
    affectedRows
  }
  insertTradeKeyword(objects: $insertTradeKeywords) {
    affectedRows
  }
  deleteTradeKeyword(where: {id: {_in: $deleteTradeKeyword}}) {
    affectedRows
  }
}
    `;
export type TradeFormUpdateMutationMutationFn = ApolloReactCommon.MutationFunction<TradeFormUpdateMutation, TradeFormUpdateMutationVariables>;

/**
 * __useTradeFormUpdateMutation__
 *
 * To run a mutation, you first call `useTradeFormUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTradeFormUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tradeFormUpdateMutation, { data, loading, error }] = useTradeFormUpdateMutation({
 *   variables: {
 *      tradeId: // value for 'tradeId'
 *      trade: // value for 'trade'
 *      deleteTradeGroupIds: // value for 'deleteTradeGroupIds'
 *      insertTradeGroups: // value for 'insertTradeGroups'
 *      insertTradeQuestions: // value for 'insertTradeQuestions'
 *      deleteTradeQuestions: // value for 'deleteTradeQuestions'
 *      insertTradeKeywords: // value for 'insertTradeKeywords'
 *      deleteTradeKeyword: // value for 'deleteTradeKeyword'
 *   },
 * });
 */
export function useTradeFormUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TradeFormUpdateMutation, TradeFormUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TradeFormUpdateMutation, TradeFormUpdateMutationVariables>(TradeFormUpdateMutationDocument, options);
      }
export type TradeFormUpdateMutationHookResult = ReturnType<typeof useTradeFormUpdateMutation>;
export type TradeFormUpdateMutationMutationResult = ApolloReactCommon.MutationResult<TradeFormUpdateMutation>;
export type TradeFormUpdateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<TradeFormUpdateMutation, TradeFormUpdateMutationVariables>;
export const TradeFormUpdateTradeKeywordMutationDocument = gql`
    mutation tradeFormUpdateTradeKeywordMutation($tradeKeywordId: Int!, $tradeKeyword: TradeKeywordSetInput!) {
  updateTradeKeywordByPk(pkColumns: {id: $tradeKeywordId}, _set: $tradeKeyword) {
    id
  }
}
    `;
export type TradeFormUpdateTradeKeywordMutationMutationFn = ApolloReactCommon.MutationFunction<TradeFormUpdateTradeKeywordMutation, TradeFormUpdateTradeKeywordMutationVariables>;

/**
 * __useTradeFormUpdateTradeKeywordMutation__
 *
 * To run a mutation, you first call `useTradeFormUpdateTradeKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTradeFormUpdateTradeKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tradeFormUpdateTradeKeywordMutation, { data, loading, error }] = useTradeFormUpdateTradeKeywordMutation({
 *   variables: {
 *      tradeKeywordId: // value for 'tradeKeywordId'
 *      tradeKeyword: // value for 'tradeKeyword'
 *   },
 * });
 */
export function useTradeFormUpdateTradeKeywordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TradeFormUpdateTradeKeywordMutation, TradeFormUpdateTradeKeywordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TradeFormUpdateTradeKeywordMutation, TradeFormUpdateTradeKeywordMutationVariables>(TradeFormUpdateTradeKeywordMutationDocument, options);
      }
export type TradeFormUpdateTradeKeywordMutationHookResult = ReturnType<typeof useTradeFormUpdateTradeKeywordMutation>;
export type TradeFormUpdateTradeKeywordMutationMutationResult = ApolloReactCommon.MutationResult<TradeFormUpdateTradeKeywordMutation>;
export type TradeFormUpdateTradeKeywordMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<TradeFormUpdateTradeKeywordMutation, TradeFormUpdateTradeKeywordMutationVariables>;
export const TradeFormUpdateTradeQuestionMutationDocument = gql`
    mutation tradeFormUpdateTradeQuestionMutation($tradeQuestionId: Int!, $tradeQuestion: TradeQuestionSetInput!) {
  updateTradeQuestionByPk(pkColumns: {id: $tradeQuestionId}, _set: $tradeQuestion) {
    id
  }
}
    `;
export type TradeFormUpdateTradeQuestionMutationMutationFn = ApolloReactCommon.MutationFunction<TradeFormUpdateTradeQuestionMutation, TradeFormUpdateTradeQuestionMutationVariables>;

/**
 * __useTradeFormUpdateTradeQuestionMutation__
 *
 * To run a mutation, you first call `useTradeFormUpdateTradeQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTradeFormUpdateTradeQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tradeFormUpdateTradeQuestionMutation, { data, loading, error }] = useTradeFormUpdateTradeQuestionMutation({
 *   variables: {
 *      tradeQuestionId: // value for 'tradeQuestionId'
 *      tradeQuestion: // value for 'tradeQuestion'
 *   },
 * });
 */
export function useTradeFormUpdateTradeQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TradeFormUpdateTradeQuestionMutation, TradeFormUpdateTradeQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TradeFormUpdateTradeQuestionMutation, TradeFormUpdateTradeQuestionMutationVariables>(TradeFormUpdateTradeQuestionMutationDocument, options);
      }
export type TradeFormUpdateTradeQuestionMutationHookResult = ReturnType<typeof useTradeFormUpdateTradeQuestionMutation>;
export type TradeFormUpdateTradeQuestionMutationMutationResult = ApolloReactCommon.MutationResult<TradeFormUpdateTradeQuestionMutation>;
export type TradeFormUpdateTradeQuestionMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<TradeFormUpdateTradeQuestionMutation, TradeFormUpdateTradeQuestionMutationVariables>;
export const TradeFormCreateSlugRedirectMutationDocument = gql`
    mutation tradeFormCreateSlugRedirectMutation($input: SlugRedirectInsertInput!) {
  insertSlugRedirectOne(object: $input) {
    id
  }
}
    `;
export type TradeFormCreateSlugRedirectMutationMutationFn = ApolloReactCommon.MutationFunction<TradeFormCreateSlugRedirectMutation, TradeFormCreateSlugRedirectMutationVariables>;

/**
 * __useTradeFormCreateSlugRedirectMutation__
 *
 * To run a mutation, you first call `useTradeFormCreateSlugRedirectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTradeFormCreateSlugRedirectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tradeFormCreateSlugRedirectMutation, { data, loading, error }] = useTradeFormCreateSlugRedirectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTradeFormCreateSlugRedirectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TradeFormCreateSlugRedirectMutation, TradeFormCreateSlugRedirectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TradeFormCreateSlugRedirectMutation, TradeFormCreateSlugRedirectMutationVariables>(TradeFormCreateSlugRedirectMutationDocument, options);
      }
export type TradeFormCreateSlugRedirectMutationHookResult = ReturnType<typeof useTradeFormCreateSlugRedirectMutation>;
export type TradeFormCreateSlugRedirectMutationMutationResult = ApolloReactCommon.MutationResult<TradeFormCreateSlugRedirectMutation>;
export type TradeFormCreateSlugRedirectMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<TradeFormCreateSlugRedirectMutation, TradeFormCreateSlugRedirectMutationVariables>;
export const TradeFormUpdateQueryDocument = gql`
    query tradeFormUpdateQuery($id: Int!) {
  tradeByPk(id: $id) {
    id
    slug
    name
    pageTitle
    anchor
    pageTitleVariant
    pageSubtitle
    pageTitleDirectory
    label
    metaTitle
    metaDescription
    isCallRecordable
    isAnonymised
    isRgeFilterable
    schemaType
    schemaAdditionalType
    tradeGroups {
      tradeGroup {
        id
        iconName
      }
    }
    tradeKeywords {
      id
      name
    }
    tradeQuestions(orderBy: [{id: ASC}]) {
      id
      question
      answer
    }
  }
}
    `;

/**
 * __useTradeFormUpdateQuery__
 *
 * To run a query within a React component, call `useTradeFormUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeFormUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeFormUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTradeFormUpdateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradeFormUpdateQuery, TradeFormUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradeFormUpdateQuery, TradeFormUpdateQueryVariables>(TradeFormUpdateQueryDocument, options);
      }
export function useTradeFormUpdateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeFormUpdateQuery, TradeFormUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradeFormUpdateQuery, TradeFormUpdateQueryVariables>(TradeFormUpdateQueryDocument, options);
        }
export type TradeFormUpdateQueryHookResult = ReturnType<typeof useTradeFormUpdateQuery>;
export type TradeFormUpdateQueryLazyQueryHookResult = ReturnType<typeof useTradeFormUpdateQueryLazyQuery>;
export type TradeFormUpdateQueryQueryResult = ApolloReactCommon.QueryResult<TradeFormUpdateQuery, TradeFormUpdateQueryVariables>;
export const TradeUpdatePageQueryDocument = gql`
    query tradeUpdatePageQuery($id: Int!) {
  tradeByPk(id: $id) {
    __typename
    id
    slug
    name
    tradeGroups {
      trade {
        __typename
        id
      }
    }
  }
}
    `;

/**
 * __useTradeUpdatePageQuery__
 *
 * To run a query within a React component, call `useTradeUpdatePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeUpdatePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeUpdatePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTradeUpdatePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradeUpdatePageQuery, TradeUpdatePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradeUpdatePageQuery, TradeUpdatePageQueryVariables>(TradeUpdatePageQueryDocument, options);
      }
export function useTradeUpdatePageQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeUpdatePageQuery, TradeUpdatePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradeUpdatePageQuery, TradeUpdatePageQueryVariables>(TradeUpdatePageQueryDocument, options);
        }
export type TradeUpdatePageQueryHookResult = ReturnType<typeof useTradeUpdatePageQuery>;
export type TradeUpdatePageQueryLazyQueryHookResult = ReturnType<typeof useTradeUpdatePageQueryLazyQuery>;
export type TradeUpdatePageQueryQueryResult = ApolloReactCommon.QueryResult<TradeUpdatePageQuery, TradeUpdatePageQueryVariables>;
export const TradesTableQueryDocument = gql`
    query tradesTableQuery($limit: Int, $offset: Int, $order_by: [TradeOrderBy!], $where: TradeBoolExp!, $whereProView: ProViewBoolExp!, $whereProPresentation: TradeProPresentationBoolExp!, $whereTradeProView: TradeProViewBoolExp!) {
  trade(limit: $limit, offset: $offset, orderBy: $order_by, where: $where) {
    id
    name
    tradeGroups {
      tradeGroup {
        id
        name
      }
    }
    tradeProViewsAggregate(where: $whereTradeProView) {
      aggregate {
        count
      }
    }
    mainTradeProPresentations(where: $whereProPresentation) {
      proPresentation {
        name
        proViews(where: $whereProView) {
          id
          avatarHash
        }
        proViewsAggregate(where: $whereProView) {
          aggregate {
            count
          }
        }
      }
    }
    tradeKeywords {
      id
      name
    }
  }
}
    `;

/**
 * __useTradesTableQuery__
 *
 * To run a query within a React component, call `useTradesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradesTableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *      whereProView: // value for 'whereProView'
 *      whereProPresentation: // value for 'whereProPresentation'
 *      whereTradeProView: // value for 'whereTradeProView'
 *   },
 * });
 */
export function useTradesTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradesTableQuery, TradesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradesTableQuery, TradesTableQueryVariables>(TradesTableQueryDocument, options);
      }
export function useTradesTableQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradesTableQuery, TradesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradesTableQuery, TradesTableQueryVariables>(TradesTableQueryDocument, options);
        }
export type TradesTableQueryHookResult = ReturnType<typeof useTradesTableQuery>;
export type TradesTableQueryLazyQueryHookResult = ReturnType<typeof useTradesTableQueryLazyQuery>;
export type TradesTableQueryQueryResult = ApolloReactCommon.QueryResult<TradesTableQuery, TradesTableQueryVariables>;